import $e, { useState as be, useMemo as K, useEffect as Xe, useContext as wc, useRef as yc, useDebugValue as va, createElement as Lm, useCallback as ze, createContext as Om, Fragment as Um, useLayoutEffect as $t, cloneElement as Wm } from "react";
import { Scope as Gm } from "react-shadow-scope";
import { QueryClient as Jm, QueryClientProvider as Km, useMutation as Xm, useQuery as Ec } from "@tanstack/react-query";
import { atom as ee, useAtomValue as X, useAtom as ue, useSetAtom as Z } from "jotai";
import { SkipClient as Zm } from "@skip-go/client";
import { atomWithQuery as pi, atomWithMutation as Ym } from "jotai-tanstack-query";
import { getWallet as Ai, GrazProvider as Qm, WalletType as we, useAccount as Yr, useActiveWalletType as _m, useDisconnect as $m, connect as yo } from "graz";
import { createClient as ep, custom as np, walletActions as wa, defineChain as Qr, http as xe, isAddress as ip, createPublicClient as op } from "viem";
import { createConfig as tp, WagmiProvider as cp, useAccount as pt, useConnectors as _r, useConnect as ap } from "wagmi";
import { BackpackWalletAdapter as rp } from "@solana/wallet-adapter-backpack";
import { CoinbaseWalletAdapter as sp } from "@solana/wallet-adapter-coinbase";
import { LedgerWalletAdapter as lp } from "@solana/wallet-adapter-ledger";
import { PhantomWalletAdapter as mp } from "@solana/wallet-adapter-phantom";
import { SolflareWalletAdapter as pp } from "@solana/wallet-adapter-solflare";
import { TrustWalletAdapter as up } from "@solana/wallet-adapter-trust";
import $r, { useModal as hp } from "@ebay/nice-modal-react";
import * as Ko from "@radix-ui/react-dialog";
import { ErrorBoundary as Ro } from "react-error-boundary";
import ao from "pluralize";
import { atomEffect as es } from "jotai-effect";
import dp from "rc-virtual-list";
import { PublicKey as ya } from "@solana/web3.js";
import { createPenumbraClient as xp } from "@penumbra-zone/client";
import { ViewService as Dp } from "@penumbra-zone/protobuf";
import { matchSorter as ns } from "match-sorter";
function gp(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var is = { exports: {} }, Fe = is.exports = {}, bn, An;
function ec() {
  throw new Error("setTimeout has not been defined");
}
function nc() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? bn = setTimeout : bn = ec;
  } catch {
    bn = ec;
  }
  try {
    typeof clearTimeout == "function" ? An = clearTimeout : An = nc;
  } catch {
    An = nc;
  }
})();
function os(e) {
  if (bn === setTimeout)
    return setTimeout(e, 0);
  if ((bn === ec || !bn) && setTimeout)
    return bn = setTimeout, setTimeout(e, 0);
  try {
    return bn(e, 0);
  } catch {
    try {
      return bn.call(null, e, 0);
    } catch {
      return bn.call(this, e, 0);
    }
  }
}
function fp(e) {
  if (An === clearTimeout)
    return clearTimeout(e);
  if ((An === nc || !An) && clearTimeout)
    return An = clearTimeout, clearTimeout(e);
  try {
    return An(e);
  } catch {
    try {
      return An.call(null, e);
    } catch {
      return An.call(this, e);
    }
  }
}
var jn = [], ki = !1, ei, Lo = -1;
function bp() {
  !ki || !ei || (ki = !1, ei.length ? jn = ei.concat(jn) : Lo = -1, jn.length && ts());
}
function ts() {
  if (!ki) {
    var e = os(bp);
    ki = !0;
    for (var n = jn.length; n; ) {
      for (ei = jn, jn = []; ++Lo < n; )
        ei && ei[Lo].run();
      Lo = -1, n = jn.length;
    }
    ei = null, ki = !1, fp(e);
  }
}
Fe.nextTick = function(e) {
  var n = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var i = 1; i < arguments.length; i++)
      n[i - 1] = arguments[i];
  jn.push(new cs(e, n)), jn.length === 1 && !ki && os(ts);
};
function cs(e, n) {
  this.fun = e, this.array = n;
}
cs.prototype.run = function() {
  this.fun.apply(null, this.array);
};
Fe.title = "browser";
Fe.browser = !0;
Fe.env = {};
Fe.argv = [];
Fe.version = "";
Fe.versions = {};
function qn() {
}
Fe.on = qn;
Fe.addListener = qn;
Fe.once = qn;
Fe.off = qn;
Fe.removeListener = qn;
Fe.removeAllListeners = qn;
Fe.emit = qn;
Fe.prependListener = qn;
Fe.prependOnceListener = qn;
Fe.listeners = function(e) {
  return [];
};
Fe.binding = function(e) {
  throw new Error("process.binding is not supported");
};
Fe.cwd = function() {
  return "/";
};
Fe.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
Fe.umask = function() {
  return 0;
};
var Ap = is.exports;
const ie = /* @__PURE__ */ gp(Ap);
var ln = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Cp(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ic = { exports: {} }, Zi = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ea;
function kp() {
  if (Ea) return Zi;
  Ea = 1;
  var e = $e, n = Symbol.for("react.element"), i = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, m) {
    var h, u = {}, D = null, b = null;
    m !== void 0 && (D = "" + m), l.key !== void 0 && (D = "" + l.key), l.ref !== void 0 && (b = l.ref);
    for (h in l) o.call(l, h) && !c.hasOwnProperty(h) && (u[h] = l[h]);
    if (s && s.defaultProps) for (h in l = s.defaultProps, l) u[h] === void 0 && (u[h] = l[h]);
    return { $$typeof: n, type: s, key: D, ref: b, props: u, _owner: t.current };
  }
  return Zi.Fragment = i, Zi.jsx = a, Zi.jsxs = a, Zi;
}
var Yi = {}, Pa;
function vp() {
  return Pa || (Pa = 1, ie.env.NODE_ENV !== "production" && function() {
    var e = $e, n = Symbol.for("react.element"), i = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), t = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), u = Symbol.for("react.memo"), D = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), C = Symbol.iterator, k = "@@iterator";
    function q(A) {
      if (A === null || typeof A != "object")
        return null;
      var N = C && A[C] || A[k];
      return typeof N == "function" ? N : null;
    }
    var E = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function x(A) {
      {
        for (var N = arguments.length, R = new Array(N > 1 ? N - 1 : 0), Y = 1; Y < N; Y++)
          R[Y - 1] = arguments[Y];
        g("error", A, R);
      }
    }
    function g(A, N, R) {
      {
        var Y = E.ReactDebugCurrentFrame, le = Y.getStackAddendum();
        le !== "" && (N += "%s", R = R.concat([le]));
        var de = R.map(function(ae) {
          return String(ae);
        });
        de.unshift("Warning: " + N), Function.prototype.apply.call(console[A], console, de);
      }
    }
    var M = !1, H = !1, P = !1, S = !1, p = !1, d;
    d = Symbol.for("react.module.reference");
    function f(A) {
      return !!(typeof A == "string" || typeof A == "function" || A === o || A === c || p || A === t || A === m || A === h || S || A === b || M || H || P || typeof A == "object" && A !== null && (A.$$typeof === D || A.$$typeof === u || A.$$typeof === a || A.$$typeof === s || A.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      A.$$typeof === d || A.getModuleId !== void 0));
    }
    function w(A, N, R) {
      var Y = A.displayName;
      if (Y)
        return Y;
      var le = N.displayName || N.name || "";
      return le !== "" ? R + "(" + le + ")" : R;
    }
    function y(A) {
      return A.displayName || "Context";
    }
    function F(A) {
      if (A == null)
        return null;
      if (typeof A.tag == "number" && x("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof A == "function")
        return A.displayName || A.name || null;
      if (typeof A == "string")
        return A;
      switch (A) {
        case o:
          return "Fragment";
        case i:
          return "Portal";
        case c:
          return "Profiler";
        case t:
          return "StrictMode";
        case m:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof A == "object")
        switch (A.$$typeof) {
          case s:
            var N = A;
            return y(N) + ".Consumer";
          case a:
            var R = A;
            return y(R._context) + ".Provider";
          case l:
            return w(A, A.render, "ForwardRef");
          case u:
            var Y = A.displayName || null;
            return Y !== null ? Y : F(A.type) || "Memo";
          case D: {
            var le = A, de = le._payload, ae = le._init;
            try {
              return F(ae(de));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var I = Object.assign, v = 0, B, z, j, T, L, W, J;
    function se() {
    }
    se.__reactDisabledLog = !0;
    function pe() {
      {
        if (v === 0) {
          B = console.log, z = console.info, j = console.warn, T = console.error, L = console.group, W = console.groupCollapsed, J = console.groupEnd;
          var A = {
            configurable: !0,
            enumerable: !0,
            value: se,
            writable: !0
          };
          Object.defineProperties(console, {
            info: A,
            log: A,
            warn: A,
            error: A,
            group: A,
            groupCollapsed: A,
            groupEnd: A
          });
        }
        v++;
      }
    }
    function _() {
      {
        if (v--, v === 0) {
          var A = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: I({}, A, {
              value: B
            }),
            info: I({}, A, {
              value: z
            }),
            warn: I({}, A, {
              value: j
            }),
            error: I({}, A, {
              value: T
            }),
            group: I({}, A, {
              value: L
            }),
            groupCollapsed: I({}, A, {
              value: W
            }),
            groupEnd: I({}, A, {
              value: J
            })
          });
        }
        v < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var O = E.ReactCurrentDispatcher, ce;
    function ge(A, N, R) {
      {
        if (ce === void 0)
          try {
            throw Error();
          } catch (le) {
            var Y = le.stack.trim().match(/\n( *(at )?)/);
            ce = Y && Y[1] || "";
          }
        return `
` + ce + A;
      }
    }
    var ye = !1, Be;
    {
      var Ne = typeof WeakMap == "function" ? WeakMap : Map;
      Be = new Ne();
    }
    function Ve(A, N) {
      if (!A || ye)
        return "";
      {
        var R = Be.get(A);
        if (R !== void 0)
          return R;
      }
      var Y;
      ye = !0;
      var le = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var de;
      de = O.current, O.current = null, pe();
      try {
        if (N) {
          var ae = function() {
            throw Error();
          };
          if (Object.defineProperty(ae.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ae, []);
            } catch (Ye) {
              Y = Ye;
            }
            Reflect.construct(A, [], ae);
          } else {
            try {
              ae.call();
            } catch (Ye) {
              Y = Ye;
            }
            A.call(ae.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ye) {
            Y = Ye;
          }
          A();
        }
      } catch (Ye) {
        if (Ye && Y && typeof Ye.stack == "string") {
          for (var oe = Ye.stack.split(`
`), We = Y.stack.split(`
`), Ee = oe.length - 1, Me = We.length - 1; Ee >= 1 && Me >= 0 && oe[Ee] !== We[Me]; )
            Me--;
          for (; Ee >= 1 && Me >= 0; Ee--, Me--)
            if (oe[Ee] !== We[Me]) {
              if (Ee !== 1 || Me !== 1)
                do
                  if (Ee--, Me--, Me < 0 || oe[Ee] !== We[Me]) {
                    var nn = `
` + oe[Ee].replace(" at new ", " at ");
                    return A.displayName && nn.includes("<anonymous>") && (nn = nn.replace("<anonymous>", A.displayName)), typeof A == "function" && Be.set(A, nn), nn;
                  }
                while (Ee >= 1 && Me >= 0);
              break;
            }
        }
      } finally {
        ye = !1, O.current = de, _(), Error.prepareStackTrace = le;
      }
      var xi = A ? A.displayName || A.name : "", Yn = xi ? ge(xi) : "";
      return typeof A == "function" && Be.set(A, Yn), Yn;
    }
    function Ze(A, N, R) {
      return Ve(A, !1);
    }
    function Re(A) {
      var N = A.prototype;
      return !!(N && N.isReactComponent);
    }
    function he(A, N, R) {
      if (A == null)
        return "";
      if (typeof A == "function")
        return Ve(A, Re(A));
      if (typeof A == "string")
        return ge(A);
      switch (A) {
        case m:
          return ge("Suspense");
        case h:
          return ge("SuspenseList");
      }
      if (typeof A == "object")
        switch (A.$$typeof) {
          case l:
            return Ze(A.render);
          case u:
            return he(A.type, N, R);
          case D: {
            var Y = A, le = Y._payload, de = Y._init;
            try {
              return he(de(le), N, R);
            } catch {
            }
          }
        }
      return "";
    }
    var Ki = Object.prototype.hasOwnProperty, ma = {}, pa = E.ReactDebugCurrentFrame;
    function wo(A) {
      if (A) {
        var N = A._owner, R = he(A.type, A._source, N ? N.type : null);
        pa.setExtraStackFrame(R);
      } else
        pa.setExtraStackFrame(null);
    }
    function bm(A, N, R, Y, le) {
      {
        var de = Function.call.bind(Ki);
        for (var ae in A)
          if (de(A, ae)) {
            var oe = void 0;
            try {
              if (typeof A[ae] != "function") {
                var We = Error((Y || "React class") + ": " + R + " type `" + ae + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof A[ae] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw We.name = "Invariant Violation", We;
              }
              oe = A[ae](N, ae, Y, R, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ee) {
              oe = Ee;
            }
            oe && !(oe instanceof Error) && (wo(le), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Y || "React class", R, ae, typeof oe), wo(null)), oe instanceof Error && !(oe.message in ma) && (ma[oe.message] = !0, wo(le), x("Failed %s type: %s", R, oe.message), wo(null));
          }
      }
    }
    var Am = Array.isArray;
    function Bt(A) {
      return Am(A);
    }
    function Cm(A) {
      {
        var N = typeof Symbol == "function" && Symbol.toStringTag, R = N && A[Symbol.toStringTag] || A.constructor.name || "Object";
        return R;
      }
    }
    function km(A) {
      try {
        return ua(A), !1;
      } catch {
        return !0;
      }
    }
    function ua(A) {
      return "" + A;
    }
    function ha(A) {
      if (km(A))
        return x("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Cm(A)), ua(A);
    }
    var Xi = E.ReactCurrentOwner, vm = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, da, xa, Mt;
    Mt = {};
    function wm(A) {
      if (Ki.call(A, "ref")) {
        var N = Object.getOwnPropertyDescriptor(A, "ref").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return A.ref !== void 0;
    }
    function ym(A) {
      if (Ki.call(A, "key")) {
        var N = Object.getOwnPropertyDescriptor(A, "key").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return A.key !== void 0;
    }
    function Em(A, N) {
      if (typeof A.ref == "string" && Xi.current && N && Xi.current.stateNode !== N) {
        var R = F(Xi.current.type);
        Mt[R] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', F(Xi.current.type), A.ref), Mt[R] = !0);
      }
    }
    function Pm(A, N) {
      {
        var R = function() {
          da || (da = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        R.isReactWarning = !0, Object.defineProperty(A, "key", {
          get: R,
          configurable: !0
        });
      }
    }
    function Fm(A, N) {
      {
        var R = function() {
          xa || (xa = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        R.isReactWarning = !0, Object.defineProperty(A, "ref", {
          get: R,
          configurable: !0
        });
      }
    }
    var Bm = function(A, N, R, Y, le, de, ae) {
      var oe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: A,
        key: N,
        ref: R,
        props: ae,
        // Record the component responsible for creating this element.
        _owner: de
      };
      return oe._store = {}, Object.defineProperty(oe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(oe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Y
      }), Object.defineProperty(oe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: le
      }), Object.freeze && (Object.freeze(oe.props), Object.freeze(oe)), oe;
    };
    function Mm(A, N, R, Y, le) {
      {
        var de, ae = {}, oe = null, We = null;
        R !== void 0 && (ha(R), oe = "" + R), ym(N) && (ha(N.key), oe = "" + N.key), wm(N) && (We = N.ref, Em(N, le));
        for (de in N)
          Ki.call(N, de) && !vm.hasOwnProperty(de) && (ae[de] = N[de]);
        if (A && A.defaultProps) {
          var Ee = A.defaultProps;
          for (de in Ee)
            ae[de] === void 0 && (ae[de] = Ee[de]);
        }
        if (oe || We) {
          var Me = typeof A == "function" ? A.displayName || A.name || "Unknown" : A;
          oe && Pm(ae, Me), We && Fm(ae, Me);
        }
        return Bm(A, oe, We, le, Y, Xi.current, ae);
      }
    }
    var jt = E.ReactCurrentOwner, Da = E.ReactDebugCurrentFrame;
    function di(A) {
      if (A) {
        var N = A._owner, R = he(A.type, A._source, N ? N.type : null);
        Da.setExtraStackFrame(R);
      } else
        Da.setExtraStackFrame(null);
    }
    var zt;
    zt = !1;
    function qt(A) {
      return typeof A == "object" && A !== null && A.$$typeof === n;
    }
    function ga() {
      {
        if (jt.current) {
          var A = F(jt.current.type);
          if (A)
            return `

Check the render method of \`` + A + "`.";
        }
        return "";
      }
    }
    function jm(A) {
      return "";
    }
    var fa = {};
    function zm(A) {
      {
        var N = ga();
        if (!N) {
          var R = typeof A == "string" ? A : A.displayName || A.name;
          R && (N = `

Check the top-level render call using <` + R + ">.");
        }
        return N;
      }
    }
    function ba(A, N) {
      {
        if (!A._store || A._store.validated || A.key != null)
          return;
        A._store.validated = !0;
        var R = zm(N);
        if (fa[R])
          return;
        fa[R] = !0;
        var Y = "";
        A && A._owner && A._owner !== jt.current && (Y = " It was passed a child from " + F(A._owner.type) + "."), di(A), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', R, Y), di(null);
      }
    }
    function Aa(A, N) {
      {
        if (typeof A != "object")
          return;
        if (Bt(A))
          for (var R = 0; R < A.length; R++) {
            var Y = A[R];
            qt(Y) && ba(Y, N);
          }
        else if (qt(A))
          A._store && (A._store.validated = !0);
        else if (A) {
          var le = q(A);
          if (typeof le == "function" && le !== A.entries)
            for (var de = le.call(A), ae; !(ae = de.next()).done; )
              qt(ae.value) && ba(ae.value, N);
        }
      }
    }
    function qm(A) {
      {
        var N = A.type;
        if (N == null || typeof N == "string")
          return;
        var R;
        if (typeof N == "function")
          R = N.propTypes;
        else if (typeof N == "object" && (N.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        N.$$typeof === u))
          R = N.propTypes;
        else
          return;
        if (R) {
          var Y = F(N);
          bm(R, A.props, "prop", Y, A);
        } else if (N.PropTypes !== void 0 && !zt) {
          zt = !0;
          var le = F(N);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", le || "Unknown");
        }
        typeof N.getDefaultProps == "function" && !N.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Im(A) {
      {
        for (var N = Object.keys(A.props), R = 0; R < N.length; R++) {
          var Y = N[R];
          if (Y !== "children" && Y !== "key") {
            di(A), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Y), di(null);
            break;
          }
        }
        A.ref !== null && (di(A), x("Invalid attribute `ref` supplied to `React.Fragment`."), di(null));
      }
    }
    var Ca = {};
    function ka(A, N, R, Y, le, de) {
      {
        var ae = f(A);
        if (!ae) {
          var oe = "";
          (A === void 0 || typeof A == "object" && A !== null && Object.keys(A).length === 0) && (oe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var We = jm();
          We ? oe += We : oe += ga();
          var Ee;
          A === null ? Ee = "null" : Bt(A) ? Ee = "array" : A !== void 0 && A.$$typeof === n ? (Ee = "<" + (F(A.type) || "Unknown") + " />", oe = " Did you accidentally export a JSX literal instead of a component?") : Ee = typeof A, x("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ee, oe);
        }
        var Me = Mm(A, N, R, le, de);
        if (Me == null)
          return Me;
        if (ae) {
          var nn = N.children;
          if (nn !== void 0)
            if (Y)
              if (Bt(nn)) {
                for (var xi = 0; xi < nn.length; xi++)
                  Aa(nn[xi], A);
                Object.freeze && Object.freeze(nn);
              } else
                x("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Aa(nn, A);
        }
        if (Ki.call(N, "key")) {
          var Yn = F(A), Ye = Object.keys(N).filter(function(Rm) {
            return Rm !== "key";
          }), It = Ye.length > 0 ? "{key: someKey, " + Ye.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ca[Yn + It]) {
            var Vm = Ye.length > 0 ? "{" + Ye.join(": ..., ") + ": ...}" : "{}";
            x(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, It, Yn, Vm, Yn), Ca[Yn + It] = !0;
          }
        }
        return A === o ? Im(Me) : qm(Me), Me;
      }
    }
    function Sm(A, N, R) {
      return ka(A, N, R, !0);
    }
    function Hm(A, N, R) {
      return ka(A, N, R, !1);
    }
    var Tm = Hm, Nm = Sm;
    Yi.Fragment = o, Yi.jsx = Tm, Yi.jsxs = Nm;
  }()), Yi;
}
ie.env.NODE_ENV === "production" ? ic.exports = kp() : ic.exports = vp();
var r = ic.exports, Oe = function() {
  return Oe = Object.assign || function(n) {
    for (var i, o = 1, t = arguments.length; o < t; o++) {
      i = arguments[o];
      for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (n[c] = i[c]);
    }
    return n;
  }, Oe.apply(this, arguments);
};
function ti(e, n, i) {
  if (i || arguments.length === 2) for (var o = 0, t = n.length, c; o < t; o++)
    (c || !(o in n)) && (c || (c = Array.prototype.slice.call(n, 0, o)), c[o] = n[o]);
  return e.concat(c || Array.prototype.slice.call(n));
}
function wp(e) {
  var n = /* @__PURE__ */ Object.create(null);
  return function(i) {
    return n[i] === void 0 && (n[i] = e(i)), n[i];
  };
}
var yp = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, as = /* @__PURE__ */ wp(
  function(e) {
    return yp.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Ep = function(n, i, o, t) {
  var c = o ? o.call(t, n, i) : void 0;
  if (c !== void 0)
    return !!c;
  if (n === i)
    return !0;
  if (typeof n != "object" || !n || typeof i != "object" || !i)
    return !1;
  var a = Object.keys(n), s = Object.keys(i);
  if (a.length !== s.length)
    return !1;
  for (var l = Object.prototype.hasOwnProperty.bind(i), m = 0; m < a.length; m++) {
    var h = a[m];
    if (!l(h))
      return !1;
    var u = n[h], D = i[h];
    if (c = o ? o.call(t, u, D, h) : void 0, c === !1 || c === void 0 && u !== D)
      return !1;
  }
  return !0;
};
const Pp = /* @__PURE__ */ Cp(Ep);
var fe = "-ms-", ro = "-moz-", me = "-webkit-", rs = "comm", ut = "rule", Pc = "decl", Fp = "@import", ss = "@keyframes", Bp = "@layer", ls = Math.abs, Fc = String.fromCharCode, oc = Object.assign;
function Mp(e, n) {
  return Se(e, 0) ^ 45 ? (((n << 2 ^ Se(e, 0)) << 2 ^ Se(e, 1)) << 2 ^ Se(e, 2)) << 2 ^ Se(e, 3) : 0;
}
function ms(e) {
  return e.trim();
}
function Bn(e, n) {
  return (e = n.exec(e)) ? e[0] : e;
}
function ne(e, n, i) {
  return e.replace(n, i);
}
function Oo(e, n, i) {
  return e.indexOf(n, i);
}
function Se(e, n) {
  return e.charCodeAt(n) | 0;
}
function Ei(e, n, i) {
  return e.slice(n, i);
}
function Cn(e) {
  return e.length;
}
function ps(e) {
  return e.length;
}
function to(e, n) {
  return n.push(e), e;
}
function jp(e, n) {
  return e.map(n).join("");
}
function Fa(e, n) {
  return e.filter(function(i) {
    return !Bn(i, n);
  });
}
var ht = 1, Pi = 1, us = 0, mn = 0, je = 0, Vi = "";
function dt(e, n, i, o, t, c, a, s) {
  return { value: e, root: n, parent: i, type: o, props: t, children: c, line: ht, column: Pi, length: a, return: "", siblings: s };
}
function Ln(e, n) {
  return oc(dt("", null, null, "", null, null, 0, e.siblings), e, { length: -e.length }, n);
}
function Di(e) {
  for (; e.root; )
    e = Ln(e.root, { children: [e] });
  to(e, e.siblings);
}
function zp() {
  return je;
}
function qp() {
  return je = mn > 0 ? Se(Vi, --mn) : 0, Pi--, je === 10 && (Pi = 1, ht--), je;
}
function dn() {
  return je = mn < us ? Se(Vi, mn++) : 0, Pi++, je === 10 && (Pi = 1, ht++), je;
}
function ii() {
  return Se(Vi, mn);
}
function Uo() {
  return mn;
}
function xt(e, n) {
  return Ei(Vi, e, n);
}
function tc(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Ip(e) {
  return ht = Pi = 1, us = Cn(Vi = e), mn = 0, [];
}
function Sp(e) {
  return Vi = "", e;
}
function St(e) {
  return ms(xt(mn - 1, cc(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Hp(e) {
  for (; (je = ii()) && je < 33; )
    dn();
  return tc(e) > 2 || tc(je) > 3 ? "" : " ";
}
function Tp(e, n) {
  for (; --n && dn() && !(je < 48 || je > 102 || je > 57 && je < 65 || je > 70 && je < 97); )
    ;
  return xt(e, Uo() + (n < 6 && ii() == 32 && dn() == 32));
}
function cc(e) {
  for (; dn(); )
    switch (je) {
      case e:
        return mn;
      case 34:
      case 39:
        e !== 34 && e !== 39 && cc(je);
        break;
      case 40:
        e === 41 && cc(e);
        break;
      case 92:
        dn();
        break;
    }
  return mn;
}
function Np(e, n) {
  for (; dn() && e + je !== 57; )
    if (e + je === 84 && ii() === 47)
      break;
  return "/*" + xt(n, mn - 1) + "*" + Fc(e === 47 ? e : dn());
}
function Vp(e) {
  for (; !tc(ii()); )
    dn();
  return xt(e, mn);
}
function Rp(e) {
  return Sp(Wo("", null, null, null, [""], e = Ip(e), 0, [0], e));
}
function Wo(e, n, i, o, t, c, a, s, l) {
  for (var m = 0, h = 0, u = a, D = 0, b = 0, C = 0, k = 1, q = 1, E = 1, x = 0, g = "", M = t, H = c, P = o, S = g; q; )
    switch (C = x, x = dn()) {
      case 40:
        if (C != 108 && Se(S, u - 1) == 58) {
          Oo(S += ne(St(x), "&", "&\f"), "&\f", ls(m ? s[m - 1] : 0)) != -1 && (E = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        S += St(x);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        S += Hp(C);
        break;
      case 92:
        S += Tp(Uo() - 1, 7);
        continue;
      case 47:
        switch (ii()) {
          case 42:
          case 47:
            to(Lp(Np(dn(), Uo()), n, i, l), l);
            break;
          default:
            S += "/";
        }
        break;
      case 123 * k:
        s[m++] = Cn(S) * E;
      case 125 * k:
      case 59:
      case 0:
        switch (x) {
          case 0:
          case 125:
            q = 0;
          case 59 + h:
            E == -1 && (S = ne(S, /\f/g, "")), b > 0 && Cn(S) - u && to(b > 32 ? Ma(S + ";", o, i, u - 1, l) : Ma(ne(S, " ", "") + ";", o, i, u - 2, l), l);
            break;
          case 59:
            S += ";";
          default:
            if (to(P = Ba(S, n, i, m, h, t, s, g, M = [], H = [], u, c), c), x === 123)
              if (h === 0)
                Wo(S, n, P, P, M, c, u, s, H);
              else
                switch (D === 99 && Se(S, 3) === 110 ? 100 : D) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Wo(e, P, P, o && to(Ba(e, P, P, 0, 0, t, s, g, t, M = [], u, H), H), t, H, u, s, o ? M : H);
                    break;
                  default:
                    Wo(S, P, P, P, [""], H, 0, s, H);
                }
        }
        m = h = b = 0, k = E = 1, g = S = "", u = a;
        break;
      case 58:
        u = 1 + Cn(S), b = C;
      default:
        if (k < 1) {
          if (x == 123)
            --k;
          else if (x == 125 && k++ == 0 && qp() == 125)
            continue;
        }
        switch (S += Fc(x), x * k) {
          case 38:
            E = h > 0 ? 1 : (S += "\f", -1);
            break;
          case 44:
            s[m++] = (Cn(S) - 1) * E, E = 1;
            break;
          case 64:
            ii() === 45 && (S += St(dn())), D = ii(), h = u = Cn(g = S += Vp(Uo())), x++;
            break;
          case 45:
            C === 45 && Cn(S) == 2 && (k = 0);
        }
    }
  return c;
}
function Ba(e, n, i, o, t, c, a, s, l, m, h, u) {
  for (var D = t - 1, b = t === 0 ? c : [""], C = ps(b), k = 0, q = 0, E = 0; k < o; ++k)
    for (var x = 0, g = Ei(e, D + 1, D = ls(q = a[k])), M = e; x < C; ++x)
      (M = ms(q > 0 ? b[x] + " " + g : ne(g, /&\f/g, b[x]))) && (l[E++] = M);
  return dt(e, n, i, t === 0 ? ut : s, l, m, h, u);
}
function Lp(e, n, i, o) {
  return dt(e, n, i, rs, Fc(zp()), Ei(e, 2, -2), 0, o);
}
function Ma(e, n, i, o, t) {
  return dt(e, n, i, Pc, Ei(e, 0, o), Ei(e, o + 1, -1), o, t);
}
function hs(e, n, i) {
  switch (Mp(e, n)) {
    case 5103:
      return me + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return me + e + e;
    case 4789:
      return ro + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return me + e + ro + e + fe + e + e;
    case 5936:
      switch (Se(e, n + 11)) {
        case 114:
          return me + e + fe + ne(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return me + e + fe + ne(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return me + e + fe + ne(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
    case 6828:
    case 4268:
    case 2903:
      return me + e + fe + e + e;
    case 6165:
      return me + e + fe + "flex-" + e + e;
    case 5187:
      return me + e + ne(e, /(\w+).+(:[^]+)/, me + "box-$1$2" + fe + "flex-$1$2") + e;
    case 5443:
      return me + e + fe + "flex-item-" + ne(e, /flex-|-self/g, "") + (Bn(e, /flex-|baseline/) ? "" : fe + "grid-row-" + ne(e, /flex-|-self/g, "")) + e;
    case 4675:
      return me + e + fe + "flex-line-pack" + ne(e, /align-content|flex-|-self/g, "") + e;
    case 5548:
      return me + e + fe + ne(e, "shrink", "negative") + e;
    case 5292:
      return me + e + fe + ne(e, "basis", "preferred-size") + e;
    case 6060:
      return me + "box-" + ne(e, "-grow", "") + me + e + fe + ne(e, "grow", "positive") + e;
    case 4554:
      return me + ne(e, /([^-])(transform)/g, "$1" + me + "$2") + e;
    case 6187:
      return ne(ne(ne(e, /(zoom-|grab)/, me + "$1"), /(image-set)/, me + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return ne(e, /(image-set\([^]*)/, me + "$1$`$1");
    case 4968:
      return ne(ne(e, /(.+:)(flex-)?(.*)/, me + "box-pack:$3" + fe + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + me + e + e;
    case 4200:
      if (!Bn(e, /flex-|baseline/)) return fe + "grid-column-align" + Ei(e, n) + e;
      break;
    case 2592:
    case 3360:
      return fe + ne(e, "template-", "") + e;
    case 4384:
    case 3616:
      return i && i.some(function(o, t) {
        return n = t, Bn(o.props, /grid-\w+-end/);
      }) ? ~Oo(e + (i = i[n].value), "span", 0) ? e : fe + ne(e, "-start", "") + e + fe + "grid-row-span:" + (~Oo(i, "span", 0) ? Bn(i, /\d+/) : +Bn(i, /\d+/) - +Bn(e, /\d+/)) + ";" : fe + ne(e, "-start", "") + e;
    case 4896:
    case 4128:
      return i && i.some(function(o) {
        return Bn(o.props, /grid-\w+-start/);
      }) ? e : fe + ne(ne(e, "-end", "-span"), "span ", "") + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return ne(e, /(.+)-inline(.+)/, me + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Cn(e) - 1 - n > 6)
        switch (Se(e, n + 1)) {
          case 109:
            if (Se(e, n + 4) !== 45)
              break;
          case 102:
            return ne(e, /(.+:)(.+)-([^]+)/, "$1" + me + "$2-$3$1" + ro + (Se(e, n + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~Oo(e, "stretch", 0) ? hs(ne(e, "stretch", "fill-available"), n, i) + e : e;
        }
      break;
    case 5152:
    case 5920:
      return ne(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(o, t, c, a, s, l, m) {
        return fe + t + ":" + c + m + (a ? fe + t + "-span:" + (s ? l : +l - +c) + m : "") + e;
      });
    case 4949:
      if (Se(e, n + 6) === 121)
        return ne(e, ":", ":" + me) + e;
      break;
    case 6444:
      switch (Se(e, Se(e, 14) === 45 ? 18 : 11)) {
        case 120:
          return ne(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + me + (Se(e, 14) === 45 ? "inline-" : "") + "box$3$1" + me + "$2$3$1" + fe + "$2box$3") + e;
        case 100:
          return ne(e, ":", ":" + fe) + e;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return ne(e, "scroll-", "scroll-snap-") + e;
  }
  return e;
}
function Xo(e, n) {
  for (var i = "", o = 0; o < e.length; o++)
    i += n(e[o], o, e, n) || "";
  return i;
}
function Op(e, n, i, o) {
  switch (e.type) {
    case Bp:
      if (e.children.length) break;
    case Fp:
    case Pc:
      return e.return = e.return || e.value;
    case rs:
      return "";
    case ss:
      return e.return = e.value + "{" + Xo(e.children, o) + "}";
    case ut:
      if (!Cn(e.value = e.props.join(","))) return "";
  }
  return Cn(i = Xo(e.children, o)) ? e.return = e.value + "{" + i + "}" : "";
}
function Up(e) {
  var n = ps(e);
  return function(i, o, t, c) {
    for (var a = "", s = 0; s < n; s++)
      a += e[s](i, o, t, c) || "";
    return a;
  };
}
function Wp(e) {
  return function(n) {
    n.root || (n = n.return) && e(n);
  };
}
function Gp(e, n, i, o) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case Pc:
        e.return = hs(e.value, e.length, i);
        return;
      case ss:
        return Xo([Ln(e, { value: ne(e.value, "@", "@" + me) })], o);
      case ut:
        if (e.length)
          return jp(i = e.props, function(t) {
            switch (Bn(t, o = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                Di(Ln(e, { props: [ne(t, /:(read-\w+)/, ":" + ro + "$1")] })), Di(Ln(e, { props: [t] })), oc(e, { props: Fa(i, o) });
                break;
              case "::placeholder":
                Di(Ln(e, { props: [ne(t, /:(plac\w+)/, ":" + me + "input-$1")] })), Di(Ln(e, { props: [ne(t, /:(plac\w+)/, ":" + ro + "$1")] })), Di(Ln(e, { props: [ne(t, /:(plac\w+)/, fe + "input-$1")] })), Di(Ln(e, { props: [t] })), oc(e, { props: Fa(i, o) });
                break;
            }
            return "";
          });
    }
}
var Jp = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, ci = typeof ie < "u" && ie.env !== void 0 && (ie.env.REACT_APP_SC_ATTR || ie.env.SC_ATTR) || "data-styled", ds = "active", xs = "data-styled-version", Dt = "6.1.13", Bc = `/*!sc*/
`, Zo = typeof window < "u" && "HTMLElement" in window, Kp = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof ie < "u" && ie.env !== void 0 && ie.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && ie.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? ie.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && ie.env.REACT_APP_SC_DISABLE_SPEEDY : typeof ie < "u" && ie.env !== void 0 && ie.env.SC_DISABLE_SPEEDY !== void 0 && ie.env.SC_DISABLE_SPEEDY !== "" ? ie.env.SC_DISABLE_SPEEDY !== "false" && ie.env.SC_DISABLE_SPEEDY : ie.env.NODE_ENV !== "production"), ja = /invalid hook call/i, Eo = /* @__PURE__ */ new Set(), Xp = function(e, n) {
  if (ie.env.NODE_ENV !== "production") {
    var i = n ? ' with the id of "'.concat(n, '"') : "", o = "The component ".concat(e).concat(i, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, t = console.error;
    try {
      var c = !0;
      console.error = function(a) {
        for (var s = [], l = 1; l < arguments.length; l++) s[l - 1] = arguments[l];
        ja.test(a) ? (c = !1, Eo.delete(o)) : t.apply(void 0, ti([a], s, !1));
      }, yc(), c && !Eo.has(o) && (console.warn(o), Eo.add(o));
    } catch (a) {
      ja.test(a.message) && Eo.delete(o);
    } finally {
      console.error = t;
    }
  }
}, gt = Object.freeze([]), Fi = Object.freeze({});
function Zp(e, n, i) {
  return i === void 0 && (i = Fi), e.theme !== i.theme && e.theme || n || i.theme;
}
var ac = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), Yp = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, Qp = /(^-|-$)/g;
function za(e) {
  return e.replace(Yp, "-").replace(Qp, "");
}
var _p = /(a)(d)/gi, Po = 52, qa = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function rc(e) {
  var n, i = "";
  for (n = Math.abs(e); n > Po; n = n / Po | 0) i = qa(n % Po) + i;
  return (qa(n % Po) + i).replace(_p, "$1-$2");
}
var Ht, Ds = 5381, $n = function(e, n) {
  for (var i = n.length; i; ) e = 33 * e ^ n.charCodeAt(--i);
  return e;
}, gs = function(e) {
  return $n(Ds, e);
};
function fs(e) {
  return rc(gs(e) >>> 0);
}
function bs(e) {
  return ie.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function Tt(e) {
  return typeof e == "string" && (ie.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var As = typeof Symbol == "function" && Symbol.for, Cs = As ? Symbol.for("react.memo") : 60115, $p = As ? Symbol.for("react.forward_ref") : 60112, eu = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, nu = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, ks = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, iu = ((Ht = {})[$p] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, Ht[Cs] = ks, Ht);
function Ia(e) {
  return ("type" in (n = e) && n.type.$$typeof) === Cs ? ks : "$$typeof" in e ? iu[e.$$typeof] : eu;
  var n;
}
var ou = Object.defineProperty, tu = Object.getOwnPropertyNames, Sa = Object.getOwnPropertySymbols, cu = Object.getOwnPropertyDescriptor, au = Object.getPrototypeOf, Ha = Object.prototype;
function vs(e, n, i) {
  if (typeof n != "string") {
    if (Ha) {
      var o = au(n);
      o && o !== Ha && vs(e, o, i);
    }
    var t = tu(n);
    Sa && (t = t.concat(Sa(n)));
    for (var c = Ia(e), a = Ia(n), s = 0; s < t.length; ++s) {
      var l = t[s];
      if (!(l in nu || i && i[l] || a && l in a || c && l in c)) {
        var m = cu(n, l);
        try {
          ou(e, l, m);
        } catch {
        }
      }
    }
  }
  return e;
}
function ai(e) {
  return typeof e == "function";
}
function Mc(e) {
  return typeof e == "object" && "styledComponentId" in e;
}
function ni(e, n) {
  return e && n ? "".concat(e, " ").concat(n) : e || n || "";
}
function sc(e, n) {
  if (e.length === 0) return "";
  for (var i = e[0], o = 1; o < e.length; o++) i += e[o];
  return i;
}
function Bi(e) {
  return e !== null && typeof e == "object" && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function lc(e, n, i) {
  if (i === void 0 && (i = !1), !i && !Bi(e) && !Array.isArray(e)) return n;
  if (Array.isArray(n)) for (var o = 0; o < n.length; o++) e[o] = lc(e[o], n[o]);
  else if (Bi(n)) for (var o in n) e[o] = lc(e[o], n[o]);
  return e;
}
function jc(e, n) {
  Object.defineProperty(e, "toString", { value: n });
}
var ru = ie.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function su() {
  for (var e = [], n = 0; n < arguments.length; n++) e[n] = arguments[n];
  for (var i = e[0], o = [], t = 1, c = e.length; t < c; t += 1) o.push(e[t]);
  return o.forEach(function(a) {
    i = i.replace(/%[a-z]/, a);
  }), i;
}
function vn(e) {
  for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
  return ie.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(e, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : "")) : new Error(su.apply(void 0, ti([ru[e]], n, !1)).trim());
}
var lu = function() {
  function e(n) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = n;
  }
  return e.prototype.indexOfGroup = function(n) {
    for (var i = 0, o = 0; o < n; o++) i += this.groupSizes[o];
    return i;
  }, e.prototype.insertRules = function(n, i) {
    if (n >= this.groupSizes.length) {
      for (var o = this.groupSizes, t = o.length, c = t; n >= c; ) if ((c <<= 1) < 0) throw vn(16, "".concat(n));
      this.groupSizes = new Uint32Array(c), this.groupSizes.set(o), this.length = c;
      for (var a = t; a < c; a++) this.groupSizes[a] = 0;
    }
    for (var s = this.indexOfGroup(n + 1), l = (a = 0, i.length); a < l; a++) this.tag.insertRule(s, i[a]) && (this.groupSizes[n]++, s++);
  }, e.prototype.clearGroup = function(n) {
    if (n < this.length) {
      var i = this.groupSizes[n], o = this.indexOfGroup(n), t = o + i;
      this.groupSizes[n] = 0;
      for (var c = o; c < t; c++) this.tag.deleteRule(o);
    }
  }, e.prototype.getGroup = function(n) {
    var i = "";
    if (n >= this.length || this.groupSizes[n] === 0) return i;
    for (var o = this.groupSizes[n], t = this.indexOfGroup(n), c = t + o, a = t; a < c; a++) i += "".concat(this.tag.getRule(a)).concat(Bc);
    return i;
  }, e;
}(), mu = 1 << 30, Go = /* @__PURE__ */ new Map(), Yo = /* @__PURE__ */ new Map(), Jo = 1, Fo = function(e) {
  if (Go.has(e)) return Go.get(e);
  for (; Yo.has(Jo); ) Jo++;
  var n = Jo++;
  if (ie.env.NODE_ENV !== "production" && ((0 | n) < 0 || n > mu)) throw vn(16, "".concat(n));
  return Go.set(e, n), Yo.set(n, e), n;
}, pu = function(e, n) {
  Jo = n + 1, Go.set(e, n), Yo.set(n, e);
}, uu = "style[".concat(ci, "][").concat(xs, '="').concat(Dt, '"]'), hu = new RegExp("^".concat(ci, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), du = function(e, n, i) {
  for (var o, t = i.split(","), c = 0, a = t.length; c < a; c++) (o = t[c]) && e.registerName(n, o);
}, xu = function(e, n) {
  for (var i, o = ((i = n.textContent) !== null && i !== void 0 ? i : "").split(Bc), t = [], c = 0, a = o.length; c < a; c++) {
    var s = o[c].trim();
    if (s) {
      var l = s.match(hu);
      if (l) {
        var m = 0 | parseInt(l[1], 10), h = l[2];
        m !== 0 && (pu(h, m), du(e, h, l[3]), e.getTag().insertRules(m, t)), t.length = 0;
      } else t.push(s);
    }
  }
}, Ta = function(e) {
  for (var n = document.querySelectorAll(uu), i = 0, o = n.length; i < o; i++) {
    var t = n[i];
    t && t.getAttribute(ci) !== ds && (xu(e, t), t.parentNode && t.parentNode.removeChild(t));
  }
};
function Du() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var ws = function(e) {
  var n = document.head, i = e || n, o = document.createElement("style"), t = function(s) {
    var l = Array.from(s.querySelectorAll("style[".concat(ci, "]")));
    return l[l.length - 1];
  }(i), c = t !== void 0 ? t.nextSibling : null;
  o.setAttribute(ci, ds), o.setAttribute(xs, Dt);
  var a = Du();
  return a && o.setAttribute("nonce", a), i.insertBefore(o, c), o;
}, gu = function() {
  function e(n) {
    this.element = ws(n), this.element.appendChild(document.createTextNode("")), this.sheet = function(i) {
      if (i.sheet) return i.sheet;
      for (var o = document.styleSheets, t = 0, c = o.length; t < c; t++) {
        var a = o[t];
        if (a.ownerNode === i) return a;
      }
      throw vn(17);
    }(this.element), this.length = 0;
  }
  return e.prototype.insertRule = function(n, i) {
    try {
      return this.sheet.insertRule(i, n), this.length++, !0;
    } catch {
      return !1;
    }
  }, e.prototype.deleteRule = function(n) {
    this.sheet.deleteRule(n), this.length--;
  }, e.prototype.getRule = function(n) {
    var i = this.sheet.cssRules[n];
    return i && i.cssText ? i.cssText : "";
  }, e;
}(), fu = function() {
  function e(n) {
    this.element = ws(n), this.nodes = this.element.childNodes, this.length = 0;
  }
  return e.prototype.insertRule = function(n, i) {
    if (n <= this.length && n >= 0) {
      var o = document.createTextNode(i);
      return this.element.insertBefore(o, this.nodes[n] || null), this.length++, !0;
    }
    return !1;
  }, e.prototype.deleteRule = function(n) {
    this.element.removeChild(this.nodes[n]), this.length--;
  }, e.prototype.getRule = function(n) {
    return n < this.length ? this.nodes[n].textContent : "";
  }, e;
}(), bu = function() {
  function e(n) {
    this.rules = [], this.length = 0;
  }
  return e.prototype.insertRule = function(n, i) {
    return n <= this.length && (this.rules.splice(n, 0, i), this.length++, !0);
  }, e.prototype.deleteRule = function(n) {
    this.rules.splice(n, 1), this.length--;
  }, e.prototype.getRule = function(n) {
    return n < this.length ? this.rules[n] : "";
  }, e;
}(), Na = Zo, Au = { isServer: !Zo, useCSSOMInjection: !Kp }, ys = function() {
  function e(n, i, o) {
    n === void 0 && (n = Fi), i === void 0 && (i = {});
    var t = this;
    this.options = Oe(Oe({}, Au), n), this.gs = i, this.names = new Map(o), this.server = !!n.isServer, !this.server && Zo && Na && (Na = !1, Ta(this)), jc(this, function() {
      return function(c) {
        for (var a = c.getTag(), s = a.length, l = "", m = function(u) {
          var D = function(E) {
            return Yo.get(E);
          }(u);
          if (D === void 0) return "continue";
          var b = c.names.get(D), C = a.getGroup(u);
          if (b === void 0 || !b.size || C.length === 0) return "continue";
          var k = "".concat(ci, ".g").concat(u, '[id="').concat(D, '"]'), q = "";
          b !== void 0 && b.forEach(function(E) {
            E.length > 0 && (q += "".concat(E, ","));
          }), l += "".concat(C).concat(k, '{content:"').concat(q, '"}').concat(Bc);
        }, h = 0; h < s; h++) m(h);
        return l;
      }(t);
    });
  }
  return e.registerId = function(n) {
    return Fo(n);
  }, e.prototype.rehydrate = function() {
    !this.server && Zo && Ta(this);
  }, e.prototype.reconstructWithOptions = function(n, i) {
    return i === void 0 && (i = !0), new e(Oe(Oe({}, this.options), n), this.gs, i && this.names || void 0);
  }, e.prototype.allocateGSInstance = function(n) {
    return this.gs[n] = (this.gs[n] || 0) + 1;
  }, e.prototype.getTag = function() {
    return this.tag || (this.tag = (n = function(i) {
      var o = i.useCSSOMInjection, t = i.target;
      return i.isServer ? new bu(t) : o ? new gu(t) : new fu(t);
    }(this.options), new lu(n)));
    var n;
  }, e.prototype.hasNameForId = function(n, i) {
    return this.names.has(n) && this.names.get(n).has(i);
  }, e.prototype.registerName = function(n, i) {
    if (Fo(n), this.names.has(n)) this.names.get(n).add(i);
    else {
      var o = /* @__PURE__ */ new Set();
      o.add(i), this.names.set(n, o);
    }
  }, e.prototype.insertRules = function(n, i, o) {
    this.registerName(n, i), this.getTag().insertRules(Fo(n), o);
  }, e.prototype.clearNames = function(n) {
    this.names.has(n) && this.names.get(n).clear();
  }, e.prototype.clearRules = function(n) {
    this.getTag().clearGroup(Fo(n)), this.clearNames(n);
  }, e.prototype.clearTag = function() {
    this.tag = void 0;
  }, e;
}(), Cu = /&/g, ku = /^\s*\/\/.*$/gm;
function Es(e, n) {
  return e.map(function(i) {
    return i.type === "rule" && (i.value = "".concat(n, " ").concat(i.value), i.value = i.value.replaceAll(",", ",".concat(n, " ")), i.props = i.props.map(function(o) {
      return "".concat(n, " ").concat(o);
    })), Array.isArray(i.children) && i.type !== "@keyframes" && (i.children = Es(i.children, n)), i;
  });
}
function Ps(e) {
  var n, i, o, t = e === void 0 ? Fi : e, c = t.options, a = c === void 0 ? Fi : c, s = t.plugins, l = s === void 0 ? gt : s, m = function(D, b, C) {
    return C.startsWith(i) && C.endsWith(i) && C.replaceAll(i, "").length > 0 ? ".".concat(n) : D;
  }, h = l.slice();
  h.push(function(D) {
    D.type === ut && D.value.includes("&") && (D.props[0] = D.props[0].replace(Cu, i).replace(o, m));
  }), a.prefix && h.push(Gp), h.push(Op);
  var u = function(D, b, C, k) {
    b === void 0 && (b = ""), C === void 0 && (C = ""), k === void 0 && (k = "&"), n = k, i = b, o = new RegExp("\\".concat(i, "\\b"), "g");
    var q = D.replace(ku, ""), E = Rp(C || b ? "".concat(C, " ").concat(b, " { ").concat(q, " }") : q);
    a.namespace && (E = Es(E, a.namespace));
    var x = [];
    return Xo(E, Up(h.concat(Wp(function(g) {
      return x.push(g);
    })))), x;
  };
  return u.hash = l.length ? l.reduce(function(D, b) {
    return b.name || vn(15), $n(D, b.name);
  }, Ds).toString() : "", u;
}
var vu = new ys(), mc = Ps(), zc = $e.createContext({ shouldForwardProp: void 0, styleSheet: vu, stylis: mc });
zc.Consumer;
var wu = $e.createContext(void 0);
function pc() {
  return wc(zc);
}
function yu(e) {
  var n = be(e.stylisPlugins), i = n[0], o = n[1], t = pc().styleSheet, c = K(function() {
    var l = t;
    return e.sheet ? l = e.sheet : e.target && (l = l.reconstructWithOptions({ target: e.target }, !1)), e.disableCSSOMInjection && (l = l.reconstructWithOptions({ useCSSOMInjection: !1 })), l;
  }, [e.disableCSSOMInjection, e.sheet, e.target, t]), a = K(function() {
    return Ps({ options: { namespace: e.namespace, prefix: e.enableVendorPrefixes }, plugins: i });
  }, [e.enableVendorPrefixes, e.namespace, i]);
  Xe(function() {
    Pp(i, e.stylisPlugins) || o(e.stylisPlugins);
  }, [e.stylisPlugins]);
  var s = K(function() {
    return { shouldForwardProp: e.shouldForwardProp, styleSheet: c, stylis: a };
  }, [e.shouldForwardProp, c, a]);
  return $e.createElement(zc.Provider, { value: s }, $e.createElement(wu.Provider, { value: a }, e.children));
}
var uc = function() {
  function e(n, i) {
    var o = this;
    this.inject = function(t, c) {
      c === void 0 && (c = mc);
      var a = o.name + c.hash;
      t.hasNameForId(o.id, a) || t.insertRules(o.id, a, c(o.rules, a, "@keyframes"));
    }, this.name = n, this.id = "sc-keyframes-".concat(n), this.rules = i, jc(this, function() {
      throw vn(12, String(o.name));
    });
  }
  return e.prototype.getName = function(n) {
    return n === void 0 && (n = mc), this.name + n.hash;
  }, e;
}(), Eu = function(e) {
  return e >= "A" && e <= "Z";
};
function Va(e) {
  for (var n = "", i = 0; i < e.length; i++) {
    var o = e[i];
    if (i === 1 && o === "-" && e[0] === "-") return e;
    Eu(o) ? n += "-" + o.toLowerCase() : n += o;
  }
  return n.startsWith("ms-") ? "-" + n : n;
}
var Fs = function(e) {
  return e == null || e === !1 || e === "";
}, Bs = function(e) {
  var n, i, o = [];
  for (var t in e) {
    var c = e[t];
    e.hasOwnProperty(t) && !Fs(c) && (Array.isArray(c) && c.isCss || ai(c) ? o.push("".concat(Va(t), ":"), c, ";") : Bi(c) ? o.push.apply(o, ti(ti(["".concat(t, " {")], Bs(c), !1), ["}"], !1)) : o.push("".concat(Va(t), ": ").concat((n = t, (i = c) == null || typeof i == "boolean" || i === "" ? "" : typeof i != "number" || i === 0 || n in Jp || n.startsWith("--") ? String(i).trim() : "".concat(i, "px")), ";")));
  }
  return o;
};
function oi(e, n, i, o) {
  if (Fs(e)) return [];
  if (Mc(e)) return [".".concat(e.styledComponentId)];
  if (ai(e)) {
    if (!ai(c = e) || c.prototype && c.prototype.isReactComponent || !n) return [e];
    var t = e(n);
    return ie.env.NODE_ENV === "production" || typeof t != "object" || Array.isArray(t) || t instanceof uc || Bi(t) || t === null || console.error("".concat(bs(e), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), oi(t, n, i, o);
  }
  var c;
  return e instanceof uc ? i ? (e.inject(i, o), [e.getName(o)]) : [e] : Bi(e) ? Bs(e) : Array.isArray(e) ? Array.prototype.concat.apply(gt, e.map(function(a) {
    return oi(a, n, i, o);
  })) : [e.toString()];
}
function Pu(e) {
  for (var n = 0; n < e.length; n += 1) {
    var i = e[n];
    if (ai(i) && !Mc(i)) return !1;
  }
  return !0;
}
var Fu = gs(Dt), Bu = function() {
  function e(n, i, o) {
    this.rules = n, this.staticRulesId = "", this.isStatic = ie.env.NODE_ENV === "production" && (o === void 0 || o.isStatic) && Pu(n), this.componentId = i, this.baseHash = $n(Fu, i), this.baseStyle = o, ys.registerId(i);
  }
  return e.prototype.generateAndInjectStyles = function(n, i, o) {
    var t = this.baseStyle ? this.baseStyle.generateAndInjectStyles(n, i, o) : "";
    if (this.isStatic && !o.hash) if (this.staticRulesId && i.hasNameForId(this.componentId, this.staticRulesId)) t = ni(t, this.staticRulesId);
    else {
      var c = sc(oi(this.rules, n, i, o)), a = rc($n(this.baseHash, c) >>> 0);
      if (!i.hasNameForId(this.componentId, a)) {
        var s = o(c, ".".concat(a), void 0, this.componentId);
        i.insertRules(this.componentId, a, s);
      }
      t = ni(t, a), this.staticRulesId = a;
    }
    else {
      for (var l = $n(this.baseHash, o.hash), m = "", h = 0; h < this.rules.length; h++) {
        var u = this.rules[h];
        if (typeof u == "string") m += u, ie.env.NODE_ENV !== "production" && (l = $n(l, u));
        else if (u) {
          var D = sc(oi(u, n, i, o));
          l = $n(l, D + h), m += D;
        }
      }
      if (m) {
        var b = rc(l >>> 0);
        i.hasNameForId(this.componentId, b) || i.insertRules(this.componentId, b, o(m, ".".concat(b), void 0, this.componentId)), t = ni(t, b);
      }
    }
    return t;
  }, e;
}(), lo = $e.createContext(void 0);
lo.Consumer;
function ke() {
  var e = wc(lo);
  if (!e) throw vn(18);
  return e;
}
function Mu(e) {
  var n = $e.useContext(lo), i = K(function() {
    return function(o, t) {
      if (!o) throw vn(14);
      if (ai(o)) {
        var c = o(t);
        if (ie.env.NODE_ENV !== "production" && (c === null || Array.isArray(c) || typeof c != "object")) throw vn(7);
        return c;
      }
      if (Array.isArray(o) || typeof o != "object") throw vn(8);
      return t ? Oe(Oe({}, t), o) : o;
    }(e.theme, n);
  }, [e.theme, n]);
  return e.children ? $e.createElement(lo.Provider, { value: i }, e.children) : null;
}
var Nt = {}, Ra = /* @__PURE__ */ new Set();
function ju(e, n, i) {
  var o = Mc(e), t = e, c = !Tt(e), a = n.attrs, s = a === void 0 ? gt : a, l = n.componentId, m = l === void 0 ? function(M, H) {
    var P = typeof M != "string" ? "sc" : za(M);
    Nt[P] = (Nt[P] || 0) + 1;
    var S = "".concat(P, "-").concat(fs(Dt + P + Nt[P]));
    return H ? "".concat(H, "-").concat(S) : S;
  }(n.displayName, n.parentComponentId) : l, h = n.displayName, u = h === void 0 ? function(M) {
    return Tt(M) ? "styled.".concat(M) : "Styled(".concat(bs(M), ")");
  }(e) : h, D = n.displayName && n.componentId ? "".concat(za(n.displayName), "-").concat(n.componentId) : n.componentId || m, b = o && t.attrs ? t.attrs.concat(s).filter(Boolean) : s, C = n.shouldForwardProp;
  if (o && t.shouldForwardProp) {
    var k = t.shouldForwardProp;
    if (n.shouldForwardProp) {
      var q = n.shouldForwardProp;
      C = function(M, H) {
        return k(M, H) && q(M, H);
      };
    } else C = k;
  }
  var E = new Bu(i, D, o ? t.componentStyle : void 0);
  function x(M, H) {
    return function(P, S, p) {
      var d = P.attrs, f = P.componentStyle, w = P.defaultProps, y = P.foldedComponentIds, F = P.styledComponentId, I = P.target, v = $e.useContext(lo), B = pc(), z = P.shouldForwardProp || B.shouldForwardProp;
      ie.env.NODE_ENV !== "production" && va(F);
      var j = Zp(S, v, w) || Fi, T = function(_, O, ce) {
        for (var ge, ye = Oe(Oe({}, O), { className: void 0, theme: ce }), Be = 0; Be < _.length; Be += 1) {
          var Ne = ai(ge = _[Be]) ? ge(ye) : ge;
          for (var Ve in Ne) ye[Ve] = Ve === "className" ? ni(ye[Ve], Ne[Ve]) : Ve === "style" ? Oe(Oe({}, ye[Ve]), Ne[Ve]) : Ne[Ve];
        }
        return O.className && (ye.className = ni(ye.className, O.className)), ye;
      }(d, S, j), L = T.as || I, W = {};
      for (var J in T) T[J] === void 0 || J[0] === "$" || J === "as" || J === "theme" && T.theme === j || (J === "forwardedAs" ? W.as = T.forwardedAs : z && !z(J, L) || (W[J] = T[J], z || ie.env.NODE_ENV !== "development" || as(J) || Ra.has(J) || !ac.has(L) || (Ra.add(J), console.warn('styled-components: it looks like an unknown prop "'.concat(J, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var se = function(_, O) {
        var ce = pc(), ge = _.generateAndInjectStyles(O, ce.styleSheet, ce.stylis);
        return ie.env.NODE_ENV !== "production" && va(ge), ge;
      }(f, T);
      ie.env.NODE_ENV !== "production" && P.warnTooManyClasses && P.warnTooManyClasses(se);
      var pe = ni(y, F);
      return se && (pe += " " + se), T.className && (pe += " " + T.className), W[Tt(L) && !ac.has(L) ? "class" : "className"] = pe, W.ref = p, Lm(L, W);
    }(g, M, H);
  }
  x.displayName = u;
  var g = $e.forwardRef(x);
  return g.attrs = b, g.componentStyle = E, g.displayName = u, g.shouldForwardProp = C, g.foldedComponentIds = o ? ni(t.foldedComponentIds, t.styledComponentId) : "", g.styledComponentId = D, g.target = o ? t.target : e, Object.defineProperty(g, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(M) {
    this._foldedDefaultProps = o ? function(H) {
      for (var P = [], S = 1; S < arguments.length; S++) P[S - 1] = arguments[S];
      for (var p = 0, d = P; p < d.length; p++) lc(H, d[p], !0);
      return H;
    }({}, t.defaultProps, M) : M;
  } }), ie.env.NODE_ENV !== "production" && (Xp(u, D), g.warnTooManyClasses = /* @__PURE__ */ function(M, H) {
    var P = {}, S = !1;
    return function(p) {
      if (!S && (P[p] = !0, Object.keys(P).length >= 200)) {
        var d = H ? ' with the id of "'.concat(H, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(M).concat(d, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), S = !0, P = {};
      }
    };
  }(u, D)), jc(g, function() {
    return ".".concat(g.styledComponentId);
  }), c && vs(g, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), g;
}
function La(e, n) {
  for (var i = [e[0]], o = 0, t = n.length; o < t; o += 1) i.push(n[o], e[o + 1]);
  return i;
}
var Oa = function(e) {
  return Object.assign(e, { isCss: !0 });
};
function He(e) {
  for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
  if (ai(e) || Bi(e)) return Oa(oi(La(gt, ti([e], n, !0))));
  var o = e;
  return n.length === 0 && o.length === 1 && typeof o[0] == "string" ? oi(o) : Oa(oi(La(o, n)));
}
function hc(e, n, i) {
  if (i === void 0 && (i = Fi), !n) throw vn(1, n);
  var o = function(t) {
    for (var c = [], a = 1; a < arguments.length; a++) c[a - 1] = arguments[a];
    return e(n, i, He.apply(void 0, ti([t], c, !1)));
  };
  return o.attrs = function(t) {
    return hc(e, n, Oe(Oe({}, i), { attrs: Array.prototype.concat(i.attrs, t).filter(Boolean) }));
  }, o.withConfig = function(t) {
    return hc(e, n, Oe(Oe({}, i), t));
  }, o;
}
var Ms = function(e) {
  return hc(ju, e);
}, V = Ms;
ac.forEach(function(e) {
  V[e] = Ms(e);
});
function Ri(e) {
  for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
  ie.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  var o = sc(He.apply(void 0, ti([e], n, !1))), t = fs(o);
  return new uc(t, o);
}
ie.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var Bo = "__sc-".concat(ci, "__");
ie.env.NODE_ENV !== "production" && ie.env.NODE_ENV !== "test" && typeof window < "u" && (window[Bo] || (window[Bo] = 0), window[Bo] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[Bo] += 1);
const sn = (e) => {
  const n = Math.max(0, Math.min(100, e));
  return Math.round(n / 100 * 255).toString(16).padStart(2, "0").toUpperCase();
}, qc = (e) => {
  const n = document.createElement("canvas").getContext("2d");
  return n ? (n.fillStyle = e, n.fillStyle) : e;
}, xo = (e) => {
  e = qc(e);
  const n = parseInt(e.slice(1, 3), 16), i = parseInt(e.slice(3, 5), 16), o = parseInt(e.slice(5, 7), 16);
  return (Math.sqrt(0.299 * (n * n) + 0.587 * (i * i) + 0.114 * (o * o)) > 127.5 ? "light" : "dark") === "light" ? "black" : "white";
}, Qo = {
  brandColor: "#ff66ff",
  primary: {
    background: {
      normal: "#000",
      transparent: "#000000" + sn(90)
    },
    text: {
      normal: "#fff",
      lowContrast: "#ffffff" + sn(50),
      ultraLowContrast: "#ffffff" + sn(20)
    },
    ghostButtonHover: "#000000" + sn(40)
  },
  secondary: {
    background: {
      normal: "#141414",
      transparent: "#252525" + sn(70),
      hover: "#4A4A4A"
    }
  },
  success: {
    text: "#6fde00"
  },
  warning: {
    background: "#411f00",
    text: "#ff7a00"
  },
  error: {
    background: "#430000",
    text: "#ff1616"
  }
}, zu = {
  brandColor: "#ff66ff",
  primary: {
    background: {
      normal: "#ffffff",
      transparent: "#ffffff" + sn(95)
    },
    text: {
      normal: "#000000",
      lowContrast: "#000000" + sn(45),
      ultraLowContrast: "#000000" + sn(10)
    },
    ghostButtonHover: "#ffffff" + sn(90)
  },
  secondary: {
    background: {
      normal: "#f1f1f1",
      transparent: "#eeeeee" + sn(90),
      hover: "#e0e0e0"
    }
  },
  success: {
    text: "#6bcf07"
  },
  warning: {
    background: "#ffe2c8",
    text: "#ef7404"
  },
  error: {
    background: "#ffcbcb",
    text: "#ef1e1e"
  }
}, qu = [
  {
    chainId: "eightball-1",
    currencies: [
      {
        coinDenom: "ebl",
        coinMinimalDenom: "uebl",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.8ball.info",
    rpc: "https://rpc.8ball.info/",
    bech32Config: {
      bech32PrefixAccAddr: "8ball",
      bech32PrefixAccPub: "8ballpub",
      bech32PrefixValAddr: "8ballvaloper",
      bech32PrefixValPub: "8ballvaloperpub",
      bech32PrefixConsAddr: "8ballvalcons",
      bech32PrefixConsPub: "8ballvalconspub"
    },
    chainName: "8ball",
    feeCurrencies: [
      {
        coinDenom: "ebl",
        coinMinimalDenom: "uebl",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "ebl",
      coinMinimalDenom: "uebl",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "acre_9052-1",
    currencies: [
      {
        coinDenom: "acre",
        coinMinimalDenom: "aacre",
        coinDecimals: 18
      },
      {
        coinDenom: "arusd",
        coinMinimalDenom: "erc20/0x2Cbea61fdfDFA520Ee99700F104D5b75ADf50B0c",
        coinDecimals: 18
      },
      {
        coinDenom: "cnto",
        coinMinimalDenom: "erc20/0xAE6D3334989a22A65228732446731438672418F2",
        coinDecimals: 18
      }
    ],
    rest: "https://lcd-acre.synergynodes.com",
    rpc: "https://rpc.acre.nodestake.top",
    bech32Config: {
      bech32PrefixAccAddr: "acre",
      bech32PrefixAccPub: "acrepub",
      bech32PrefixValAddr: "acrevaloper",
      bech32PrefixValPub: "acrevaloperpub",
      bech32PrefixConsAddr: "acrevalcons",
      bech32PrefixConsPub: "acrevalconspub"
    },
    chainName: "acrechain",
    feeCurrencies: [
      {
        coinDenom: "acre",
        coinMinimalDenom: "aacre",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e10,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "acre",
      coinMinimalDenom: "aacre",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "agoric-3",
    currencies: [
      {
        coinDenom: "bld",
        coinMinimalDenom: "ubld",
        coinDecimals: 6
      },
      {
        coinDenom: "ist",
        coinMinimalDenom: "uist",
        coinDecimals: 6
      }
    ],
    rest: "https://main.api.agoric.net:443",
    rpc: "https://main.rpc.agoric.net:443",
    bech32Config: {
      bech32PrefixAccAddr: "agoric",
      bech32PrefixAccPub: "agoricpub",
      bech32PrefixValAddr: "agoricvaloper",
      bech32PrefixValPub: "agoricvaloperpub",
      bech32PrefixConsAddr: "agoricvalcons",
      bech32PrefixConsPub: "agoricvalconspub"
    },
    chainName: "agoric",
    feeCurrencies: [
      {
        coinDenom: "bld",
        coinMinimalDenom: "ubld",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.03,
          average: 0.05,
          high: 0.07
        }
      },
      {
        coinDenom: "ist",
        coinMinimalDenom: "uist",
        coinDecimals: 6,
        gasPriceStep: {
          low: 34e-4,
          average: 7e-3,
          high: 0.02
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "bld",
      coinMinimalDenom: "ubld",
      coinDecimals: 6
    },
    bip44: {
      coinType: 564
    }
  },
  {
    chainId: "aioz_168-1",
    currencies: [
      {
        coinDenom: "aioz",
        coinMinimalDenom: "attoaioz",
        coinDecimals: 18
      }
    ],
    rest: "https://lcd-dataseed.aioz.network",
    rpc: "https://rpc-dataseed.aioz.network:443",
    bech32Config: {
      bech32PrefixAccAddr: "aioz",
      bech32PrefixAccPub: "aiozpub",
      bech32PrefixValAddr: "aiozvaloper",
      bech32PrefixValPub: "aiozvaloperpub",
      bech32PrefixConsAddr: "aiozvalcons",
      bech32PrefixConsPub: "aiozvalconspub"
    },
    chainName: "aioz",
    feeCurrencies: [
      {
        coinDenom: "aioz",
        coinMinimalDenom: "attoaioz",
        coinDecimals: 18,
        gasPriceStep: {
          low: 7e9,
          average: 7e9,
          high: 1e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "aioz",
      coinMinimalDenom: "attoaioz",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "akashnet-2",
    currencies: [
      {
        coinDenom: "akt",
        coinMinimalDenom: "uakt",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/05DB6975261B805B6F6A157A4386C627F8A70BF8118D411655EFEDCA82BFABA5",
        coinDecimals: 6
      }
    ],
    rest: "https://api.akash.forbole.com:443",
    rpc: "https://rpc.akash.forbole.com:443",
    bech32Config: {
      bech32PrefixAccAddr: "akash",
      bech32PrefixAccPub: "akashpub",
      bech32PrefixValAddr: "akashvaloper",
      bech32PrefixValPub: "akashvaloperpub",
      bech32PrefixConsAddr: "akashvalcons",
      bech32PrefixConsPub: "akashvalconspub"
    },
    chainName: "akash",
    feeCurrencies: [
      {
        coinDenom: "akt",
        coinMinimalDenom: "uakt",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-5,
          average: 25e-4,
          high: 0.025
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "akt",
      coinMinimalDenom: "uakt",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "akiro-1",
    currencies: [
      {
        coinDenom: "akiro",
        coinMinimalDenom: "uakiro",
        coinDecimals: 6
      }
    ],
    rest: "http://213.199.36.82:1317",
    rpc: "http://213.199.36.82:26657",
    bech32Config: {
      bech32PrefixAccAddr: "akiro",
      bech32PrefixAccPub: "akiropub",
      bech32PrefixValAddr: "akirovaloper",
      bech32PrefixValPub: "akirovaloperpub",
      bech32PrefixConsAddr: "akirovalcons",
      bech32PrefixConsPub: "akirovalconspub"
    },
    chainName: "akiro",
    feeCurrencies: [
      {
        coinDenom: "akiro",
        coinMinimalDenom: "uakiro",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.035,
          high: 0.045
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "akiro",
      coinMinimalDenom: "uakiro",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "althea_258432-1",
    currencies: [
      {
        coinDenom: "althea",
        coinMinimalDenom: "aalthea",
        coinDecimals: 18
      }
    ],
    rest: "https://nodes.chandrastation.com/api/althea/",
    rpc: "https://nodes.chandrastation.com/rpc/althea/",
    bech32Config: {
      bech32PrefixAccAddr: "althea",
      bech32PrefixAccPub: "altheapub",
      bech32PrefixValAddr: "altheavaloper",
      bech32PrefixValPub: "altheavaloperpub",
      bech32PrefixConsAddr: "altheavalcons",
      bech32PrefixConsPub: "altheavalconspub"
    },
    chainName: "althea",
    feeCurrencies: [
      {
        coinDenom: "althea",
        coinMinimalDenom: "aalthea",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e11,
          average: 1e11,
          high: 3e11
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "althea",
      coinMinimalDenom: "aalthea",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "andromeda-1",
    currencies: [
      {
        coinDenom: "andr",
        coinMinimalDenom: "uandr",
        coinDecimals: 6
      }
    ],
    rest: "https://api.andromeda-1.andromeda.aviaone.com",
    rpc: "https://rpc.andromeda-1.andromeda.aviaone.com",
    bech32Config: {
      bech32PrefixAccAddr: "andr",
      bech32PrefixAccPub: "andrpub",
      bech32PrefixValAddr: "andrvaloper",
      bech32PrefixValPub: "andrvaloperpub",
      bech32PrefixConsAddr: "andrvalcons",
      bech32PrefixConsPub: "andrvalconspub"
    },
    chainName: "andromeda",
    feeCurrencies: [
      {
        coinDenom: "andr",
        coinMinimalDenom: "uandr",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.03,
          average: 0.05,
          high: 0.075
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "andr",
      coinMinimalDenom: "uandr",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "archway-1",
    currencies: [
      {
        coinDenom: "arch",
        coinMinimalDenom: "aarch",
        coinDecimals: 18
      },
      {
        coinDenom: "bARCH",
        coinMinimalDenom: "archway12yurzx8zynv3ck7uh4tucre48tqsm4fac4hfk9p3l24qs2cn08dqr684cg",
        coinDecimals: 18
      },
      {
        coinDenom: "TOKN",
        coinMinimalDenom: "archway16kxu278xtwa9ql20yhgk9smk2k6ke74hsxeesf36c9dhxqc5zyksh8ykwu",
        coinDecimals: 18
      },
      {
        coinDenom: "ampARCH",
        coinMinimalDenom: "cw20:archway1fwurjg7ah4v7hhs6xsc3wutqpvmahrfhns285s0lt34tgfdhplxq6m8xg5",
        coinDecimals: 6
      },
      {
        coinDenom: "WOSMO",
        coinMinimalDenom: "ibc/D2BCFE34F35AF2968C8E1F84557D8A2058BB56F739EB553206EFC2AD8C6EDAF0",
        coinDecimals: 6
      },
      {
        coinDenom: "vdl",
        coinMinimalDenom: "ibc/1BCF1FCAFE3568E234787EDFDA12460BD8931B17FE6A729DCD60FAD845558DA1",
        coinDecimals: 6
      },
      {
        coinDenom: "AXV",
        coinMinimalDenom: "cw20:archway1ecjefhcf8r60wtfnhwefrxhj9caeqa90fj58cqsaafqveawn6cjs5znd2n",
        coinDecimals: 6
      },
      {
        coinDenom: "wARCH",
        coinMinimalDenom: "cw20:archway1msc3fa4e2mh73y760qmjd3wfkzr98nl26f36xgt2xnhuw6ay3scs42zeue",
        coinDecimals: 18
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/43897B9739BD63E3A08A88191999C632E052724AB96BD4C74AE31375C991F48D",
        coinDecimals: 6
      },
      {
        coinDenom: "wUSDC",
        coinMinimalDenom: "cw20:archway1gaf9nw7n8v5lpjz9caxjpps006kxfcrzcuc8y5qp4clslhven2ns2g0ule",
        coinDecimals: 6
      }
    ],
    rest: "https://api.mainnet.archway.io",
    rpc: "https://rpc.mainnet.archway.io",
    bech32Config: {
      bech32PrefixAccAddr: "archway",
      bech32PrefixAccPub: "archwaypub",
      bech32PrefixValAddr: "archwayvaloper",
      bech32PrefixValPub: "archwayvaloperpub",
      bech32PrefixConsAddr: "archwayvalcons",
      bech32PrefixConsPub: "archwayvalconspub"
    },
    chainName: "archway",
    feeCurrencies: [
      {
        coinDenom: "arch",
        coinMinimalDenom: "aarch",
        coinDecimals: 18,
        gasPriceStep: {
          low: 196e9,
          average: 2254e8,
          high: 2548e8
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "arch",
      coinMinimalDenom: "aarch",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "arkh",
    currencies: [
      {
        coinDenom: "ARKH",
        coinMinimalDenom: "arkh",
        coinDecimals: 6
      }
    ],
    rest: "https://asc-blockchain-api.arkhadian.com/",
    rpc: "https://asc-dataseed.arkhadian.com/",
    bech32Config: {
      bech32PrefixAccAddr: "arkh",
      bech32PrefixAccPub: "arkhpub",
      bech32PrefixValAddr: "arkhvaloper",
      bech32PrefixValPub: "arkhvaloperpub",
      bech32PrefixConsAddr: "arkhvalcons",
      bech32PrefixConsPub: "arkhvalconspub"
    },
    chainName: "arkh",
    feeCurrencies: [
      {
        coinDenom: "ARKH",
        coinMinimalDenom: "arkh",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ARKH",
      coinMinimalDenom: "arkh",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "mantle-1",
    currencies: [
      {
        coinDenom: "mntl",
        coinMinimalDenom: "umntl",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.assetmantle.one",
    rpc: "https://rpc.assetmantle.one",
    bech32Config: {
      bech32PrefixAccAddr: "mantle",
      bech32PrefixAccPub: "mantlepub",
      bech32PrefixValAddr: "mantlevaloper",
      bech32PrefixValPub: "mantlevaloperpub",
      bech32PrefixConsAddr: "mantlevalcons",
      bech32PrefixConsPub: "mantlevalconspub"
    },
    chainName: "assetmantle",
    feeCurrencies: [
      {
        coinDenom: "mntl",
        coinMinimalDenom: "umntl",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "mntl",
      coinMinimalDenom: "umntl",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "atomone-1",
    currencies: [
      {
        coinDenom: "atone",
        coinMinimalDenom: "uatone",
        coinDecimals: 6
      }
    ],
    rest: "https://atomone-api.allinbits.com",
    rpc: "https://atomone-rpc.allinbits.com:443",
    bech32Config: {
      bech32PrefixAccAddr: "atone",
      bech32PrefixAccPub: "atonepub",
      bech32PrefixValAddr: "atonevaloper",
      bech32PrefixValPub: "atonevaloperpub",
      bech32PrefixConsAddr: "atonevalcons",
      bech32PrefixConsPub: "atonevalconspub"
    },
    chainName: "atomone",
    feeCurrencies: [
      {
        coinDenom: "atone",
        coinMinimalDenom: "uatone",
        coinDecimals: 6,
        gasPriceStep: {
          low: 6e-3,
          average: 6e-3,
          high: 9e-3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "atone",
      coinMinimalDenom: "uatone",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "aura_6322-2",
    currencies: [
      {
        coinDenom: "aura",
        coinMinimalDenom: "uaura",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.aura.network/",
    rpc: "https://rpc.aura.network/",
    bech32Config: {
      bech32PrefixAccAddr: "aura",
      bech32PrefixAccPub: "aurapub",
      bech32PrefixValAddr: "auravaloper",
      bech32PrefixValPub: "auravaloperpub",
      bech32PrefixConsAddr: "auravalcons",
      bech32PrefixConsPub: "auravalconspub"
    },
    chainName: "aura",
    feeCurrencies: [
      {
        coinDenom: "aura",
        coinMinimalDenom: "uaura",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-3,
          average: 2e-3,
          high: 25e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "aura",
      coinMinimalDenom: "uaura",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "xstaxy-1",
    currencies: [
      {
        coinDenom: "aura",
        coinMinimalDenom: "uaura",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.aura.network/",
    rpc: "https://rpc.aura.network/",
    bech32Config: {
      bech32PrefixAccAddr: "aura",
      bech32PrefixAccPub: "aurapub",
      bech32PrefixValAddr: "auravaloper",
      bech32PrefixValPub: "auravaloperpub",
      bech32PrefixConsAddr: "auravalcons",
      bech32PrefixConsPub: "auravalconspub"
    },
    chainName: "aura1",
    feeCurrencies: [
      {
        coinDenom: "aura",
        coinMinimalDenom: "uaura",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-3,
          average: 2e-3,
          high: 25e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "aura",
      coinMinimalDenom: "uaura",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "axelar-dojo-1",
    currencies: [
      {
        coinDenom: "axl",
        coinMinimalDenom: "uaxl",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "uusdc",
        coinDecimals: 6
      },
      {
        coinDenom: "frax",
        coinMinimalDenom: "frax-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "dai",
        coinMinimalDenom: "dai-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "uusdt",
        coinDecimals: 6
      },
      {
        coinDenom: "weth",
        coinMinimalDenom: "weth-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "wbtc",
        coinMinimalDenom: "wbtc-satoshi",
        coinDecimals: 8
      },
      {
        coinDenom: "aave",
        coinMinimalDenom: "aave-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "ape",
        coinMinimalDenom: "ape-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "axs",
        coinMinimalDenom: "axs-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "link",
        coinMinimalDenom: "link-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "mkr",
        coinMinimalDenom: "mkr-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "rai",
        coinMinimalDenom: "rai-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "shib",
        coinMinimalDenom: "shib-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "steth",
        coinMinimalDenom: "steth-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "uni",
        coinMinimalDenom: "uni-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "xcn",
        coinMinimalDenom: "xcn-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "dot",
        coinMinimalDenom: "dot-planck",
        coinDecimals: 10
      },
      {
        coinDenom: "wglmr",
        coinMinimalDenom: "wglmr-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "wmatic",
        coinMinimalDenom: "wmatic-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "wbnb",
        coinMinimalDenom: "wbnb-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "busd",
        coinMinimalDenom: "busd-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "avax",
        coinMinimalDenom: "wavax-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "ftm",
        coinMinimalDenom: "wftm-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "polygon-usdc",
        coinMinimalDenom: "polygon-uusdc",
        coinDecimals: 6
      },
      {
        coinDenom: "avalanche-usdc",
        coinMinimalDenom: "avalanche-uusdc",
        coinDecimals: 6
      },
      {
        coinDenom: "fil",
        coinMinimalDenom: "wfil-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "arb",
        coinMinimalDenom: "arb-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "pepe",
        coinMinimalDenom: "pepe-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "cbeth",
        coinMinimalDenom: "cbeth-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "reth",
        coinMinimalDenom: "reth-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "sfrxeth",
        coinMinimalDenom: "sfrxeth-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "wsteth",
        coinMinimalDenom: "wsteth-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "YieldETH",
        coinMinimalDenom: "yieldeth-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "ox",
        coinMinimalDenom: "ox-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "yum",
        coinMinimalDenom: "yum-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "arbitrum-weth",
        coinMinimalDenom: "arbitrum-weth-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "base-weth",
        coinMinimalDenom: "base-weth-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "polygon-weth",
        coinMinimalDenom: "polygon-weth-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "op",
        coinMinimalDenom: "op-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "arbitrum-uusdt",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "optimism-uusdt",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "polygon-uusdt",
        coinDecimals: 6
      },
      {
        coinDenom: "cbbtc",
        coinMinimalDenom: "cbbtc-satoshi",
        coinDecimals: 8
      },
      {
        coinDenom: "fbtc",
        coinMinimalDenom: "fbtc-satoshi",
        coinDecimals: 8
      },
      {
        coinDenom: "lbtc",
        coinMinimalDenom: "lbtc-satoshi",
        coinDecimals: 8
      }
    ],
    rest: "https://lcd-axelar.imperator.co:443",
    rpc: "https://rpc-axelar.imperator.co:443",
    bech32Config: {
      bech32PrefixAccAddr: "axelar",
      bech32PrefixAccPub: "axelarpub",
      bech32PrefixValAddr: "axelarvaloper",
      bech32PrefixValPub: "axelarvaloperpub",
      bech32PrefixConsAddr: "axelarvalcons",
      bech32PrefixConsPub: "axelarvalconspub"
    },
    chainName: "axelar",
    feeCurrencies: [
      {
        coinDenom: "axl",
        coinMinimalDenom: "uaxl",
        coinDecimals: 6,
        gasPriceStep: {
          low: 7e-3,
          average: 7e-3,
          high: 0.01
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "axl",
      coinMinimalDenom: "uaxl",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "laozi-mainnet",
    currencies: [
      {
        coinDenom: "band",
        coinMinimalDenom: "uband",
        coinDecimals: 6
      }
    ],
    rest: "https://laozi1.bandchain.org/api",
    rpc: "http://rpc.laozi1.bandchain.org:80",
    bech32Config: {
      bech32PrefixAccAddr: "band",
      bech32PrefixAccPub: "bandpub",
      bech32PrefixValAddr: "bandvaloper",
      bech32PrefixValPub: "bandvaloperpub",
      bech32PrefixConsAddr: "bandvalcons",
      bech32PrefixConsPub: "bandvalconspub"
    },
    chainName: "bandchain",
    feeCurrencies: [
      {
        coinDenom: "band",
        coinMinimalDenom: "uband",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 3e-3,
          high: 5e-3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "band",
      coinMinimalDenom: "uband",
      coinDecimals: 6
    },
    bip44: {
      coinType: 494
    }
  },
  {
    chainId: "beezee-1",
    currencies: [
      {
        coinDenom: "bze",
        coinMinimalDenom: "ubze",
        coinDecimals: 6
      },
      {
        coinDenom: "vdl",
        coinMinimalDenom: "factory/bze13gzq40che93tgfm9kzmkpjamah5nj0j73pyhqk/uvdl",
        coinDecimals: 6
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
        coinDecimals: 6
      },
      {
        coinDenom: "C2M",
        coinMinimalDenom: "factory/bze15pqjgk4la0mfphwddce00d05n3th3u66n3ptcv/2MARS",
        coinDecimals: 6
      },
      {
        coinDenom: "arch",
        coinMinimalDenom: "ibc/C00D101A3572A5374E23F11944463D1325319E255D7C824B33AF2F927F532348",
        coinDecimals: 18
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/6490A7EAB61059BFC1CDDEB05917DD70BDF3A611654162A1A47DB930D40D8AF4",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.getbze.com",
    rpc: "https://rpc.getbze.com",
    bech32Config: {
      bech32PrefixAccAddr: "bze",
      bech32PrefixAccPub: "bzepub",
      bech32PrefixValAddr: "bzevaloper",
      bech32PrefixValPub: "bzevaloperpub",
      bech32PrefixConsAddr: "bzevalcons",
      bech32PrefixConsPub: "bzevalconspub"
    },
    chainName: "beezee",
    feeCurrencies: [
      {
        coinDenom: "bze",
        coinMinimalDenom: "ubze",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "bze",
      coinMinimalDenom: "ubze",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "bitbadges-1",
    currencies: [
      {
        coinDenom: "badge",
        coinMinimalDenom: "ubadge",
        coinDecimals: 9
      },
      {
        coinDenom: "stake",
        coinMinimalDenom: "ustake",
        coinDecimals: 9
      }
    ],
    rest: "http://134.122.12.165:1317",
    rpc: "http://134.122.12.165:26657",
    bech32Config: {
      bech32PrefixAccAddr: "bb",
      bech32PrefixAccPub: "bbpub",
      bech32PrefixValAddr: "bbvaloper",
      bech32PrefixValPub: "bbvaloperpub",
      bech32PrefixConsAddr: "bbvalcons",
      bech32PrefixConsPub: "bbvalconspub"
    },
    chainName: "bitbadges",
    feeCurrencies: [
      {
        coinDenom: "badge",
        coinMinimalDenom: "ubadge",
        coinDecimals: 9,
        gasPriceStep: {
          low: 25e-5,
          average: 25e-4,
          high: 0.025
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "badge",
      coinMinimalDenom: "ubadge",
      coinDecimals: 9
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "bitcanna-1",
    currencies: [
      {
        coinDenom: "bcna",
        coinMinimalDenom: "ubcna",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.bitcanna.io",
    rpc: "https://rpc.bitcanna.io/",
    bech32Config: {
      bech32PrefixAccAddr: "bcna",
      bech32PrefixAccPub: "bcnapub",
      bech32PrefixValAddr: "bcnavaloper",
      bech32PrefixValPub: "bcnavaloperpub",
      bech32PrefixConsAddr: "bcnavalcons",
      bech32PrefixConsPub: "bcnavalconspub"
    },
    chainName: "bitcanna",
    feeCurrencies: [
      {
        coinDenom: "bcna",
        coinMinimalDenom: "ubcna",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-3,
          average: 25e-4,
          high: 0.01
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "bcna",
      coinMinimalDenom: "ubcna",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "bitsong-2b",
    currencies: [
      {
        coinDenom: "btsg",
        coinMinimalDenom: "ubtsg",
        coinDecimals: 6
      },
      {
        coinDenom: "clay",
        coinMinimalDenom: "ft2D8E7041556CE93E1EFD66C07C45D551A6AAAE09",
        coinDecimals: 6
      },
      {
        coinDenom: "fasano",
        coinMinimalDenom: "ft25B30C386CDDEBD1413D5AE1180956AE9EB3B9F7",
        coinDecimals: 6
      },
      {
        coinDenom: "d9x",
        coinMinimalDenom: "ft575B10B0CEE2C164D9ED6A96313496F164A9607C",
        coinDecimals: 6
      },
      {
        coinDenom: "fonti",
        coinMinimalDenom: "ft56664FC98A2CF5F4FBAC3566D1A11D891AD88305",
        coinDecimals: 6
      },
      {
        coinDenom: "bjks",
        coinMinimalDenom: "ft52EEB0EE509AC546ED92EAC8591F731F213DDD16",
        coinDecimals: 6
      },
      {
        coinDenom: "rwne",
        coinMinimalDenom: "ftE4903ECC861CA45F2C2BC7EAB8255D2E6E87A33A",
        coinDecimals: 6
      },
      {
        coinDenom: "enmoda",
        coinMinimalDenom: "ft85AE1716C5E39EA6D64BBD7898C3899A7B500626",
        coinDecimals: 6
      },
      {
        coinDenom: "404dr",
        coinMinimalDenom: "ft99091610CCC66F4277C66D14AF2BC4C5EE52E27A",
        coinDecimals: 6
      },
      {
        coinDenom: "n43",
        coinMinimalDenom: "ft387C1C279D962ED80C09C1D592A92C4275FD7C5D",
        coinDecimals: 6
      },
      {
        coinDenom: "lobo",
        coinMinimalDenom: "ft24C9FA4F10B0F235F4A815B15FC774E046A2B2EB",
        coinDecimals: 6
      },
      {
        coinDenom: "vibra",
        coinMinimalDenom: "ft7020C2A8E984EEBCBB383E91CD6FBB067BB2272B",
        coinDecimals: 6
      },
      {
        coinDenom: "karina",
        coinMinimalDenom: "ft2DD67F5D99E9A141142B48474FA7B6B3FF00A3FE",
        coinDecimals: 6
      },
      {
        coinDenom: "testa",
        coinMinimalDenom: "ft4B030260D99E3ABE2B604EA2B33BAF3C085CDA12",
        coinDecimals: 6
      },
      {
        coinDenom: "cmqz",
        coinMinimalDenom: "ftD4B6290EDEE1EC7B97AB5A1DC6C177EFD08ADCC3",
        coinDecimals: 6
      },
      {
        coinDenom: "ft347B1612A2B7659913679CF6CD45B8B130C50A00/6",
        coinMinimalDenom: "ft347B1612A2B7659913679CF6CD45B8B130C50A00",
        coinDecimals: 6
      }
    ],
    rest: "https://api-bitsong-ia.cosmosia.notional.ventures/",
    rpc: "https://rpc-bitsong-ia.cosmosia.notional.ventures/",
    bech32Config: {
      bech32PrefixAccAddr: "bitsong",
      bech32PrefixAccPub: "bitsongpub",
      bech32PrefixValAddr: "bitsongvaloper",
      bech32PrefixValPub: "bitsongvaloperpub",
      bech32PrefixConsAddr: "bitsongvalcons",
      bech32PrefixConsPub: "bitsongvalconspub"
    },
    chainName: "bitsong",
    feeCurrencies: [
      {
        coinDenom: "btsg",
        coinMinimalDenom: "ubtsg",
        coinDecimals: 6,
        gasPriceStep: {
          low: 3,
          average: 10,
          high: 20
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "btsg",
      coinMinimalDenom: "ubtsg",
      coinDecimals: 6
    },
    bip44: {
      coinType: 639
    }
  },
  {
    chainId: "bluzelle-9",
    currencies: [
      {
        coinDenom: "bnt",
        coinMinimalDenom: "ubnt",
        coinDecimals: 6
      },
      {
        coinDenom: "elt",
        coinMinimalDenom: "uelt",
        coinDecimals: 6
      },
      {
        coinDenom: "g4",
        coinMinimalDenom: "ug4",
        coinDecimals: 6
      }
    ],
    rest: "https://a.client.sentry.net.bluzelle.com:1317",
    rpc: "https://a.client.sentry.net.bluzelle.com:26657",
    bech32Config: {
      bech32PrefixAccAddr: "bluzelle",
      bech32PrefixAccPub: "bluzellepub",
      bech32PrefixValAddr: "bluzellevaloper",
      bech32PrefixValPub: "bluzellevaloperpub",
      bech32PrefixConsAddr: "bluzellevalcons",
      bech32PrefixConsPub: "bluzellevalconspub"
    },
    chainName: "bluzelle",
    feeCurrencies: [
      {
        coinDenom: "bnt",
        coinMinimalDenom: "ubnt",
        coinDecimals: 6,
        gasPriceStep: {
          low: 2e-3,
          average: 2e-3,
          high: 0.025
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "bnt",
      coinMinimalDenom: "ubnt",
      coinDecimals: 6
    },
    bip44: {
      coinType: 483
    }
  },
  {
    chainId: "bostrom",
    currencies: [
      {
        coinDenom: "boot",
        coinMinimalDenom: "boot",
        coinDecimals: 0
      },
      {
        coinDenom: "hydrogen",
        coinMinimalDenom: "hydrogen",
        coinDecimals: 0
      },
      {
        coinDenom: "ampere",
        coinMinimalDenom: "milliampere",
        coinDecimals: 3
      },
      {
        coinDenom: "volt",
        coinMinimalDenom: "millivolt",
        coinDecimals: 3
      },
      {
        coinDenom: "tocyb",
        coinMinimalDenom: "tocyb",
        coinDecimals: 0
      }
    ],
    rest: "https://lcd.bostrom.cybernode.ai",
    rpc: "https://rpc.bostrom.cybernode.ai",
    bech32Config: {
      bech32PrefixAccAddr: "bostrom",
      bech32PrefixAccPub: "bostrompub",
      bech32PrefixValAddr: "bostromvaloper",
      bech32PrefixValPub: "bostromvaloperpub",
      bech32PrefixConsAddr: "bostromvalcons",
      bech32PrefixConsPub: "bostromvalconspub"
    },
    chainName: "bostrom",
    feeCurrencies: [
      {
        coinDenom: "boot",
        coinMinimalDenom: "boot",
        coinDecimals: 0
      }
    ],
    stakeCurrency: {
      coinDenom: "boot",
      coinMinimalDenom: "boot",
      coinDecimals: 0
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "bouachain",
    currencies: [
      {
        coinDenom: "bouacoin",
        coinMinimalDenom: "ubouacoin",
        coinDecimals: 8
      }
    ],
    rest: "https://lcd.bouachain.com",
    rpc: "https://rpc.bouachain.com",
    bech32Config: {
      bech32PrefixAccAddr: "boua",
      bech32PrefixAccPub: "bouapub",
      bech32PrefixValAddr: "bouavaloper",
      bech32PrefixValPub: "bouavaloperpub",
      bech32PrefixConsAddr: "bouavalcons",
      bech32PrefixConsPub: "bouavalconspub"
    },
    chainName: "bouachain",
    feeCurrencies: [
      {
        coinDenom: "bouacoin",
        coinMinimalDenom: "ubouacoin",
        coinDecimals: 8,
        gasPriceStep: {
          low: 6e-4,
          average: 0.012,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "bouacoin",
      coinMinimalDenom: "ubouacoin",
      coinDecimals: 8
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "canto_7700-1",
    currencies: [
      {
        coinDenom: "canto",
        coinMinimalDenom: "acanto",
        coinDecimals: 18
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/FAFF3F7B2FE30447544A27910DF77069763CF25472BFCF63A9E7C81F0AD545AC",
        coinDecimals: 6
      }
    ],
    rest: "https://api.canto.nodestake.top",
    rpc: "https://rpc.canto.nodestake.top",
    bech32Config: {
      bech32PrefixAccAddr: "canto",
      bech32PrefixAccPub: "cantopub",
      bech32PrefixValAddr: "cantovaloper",
      bech32PrefixValPub: "cantovaloperpub",
      bech32PrefixConsAddr: "cantovalcons",
      bech32PrefixConsPub: "cantovalconspub"
    },
    chainName: "canto",
    feeCurrencies: [
      {
        coinDenom: "canto",
        coinMinimalDenom: "acanto",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e12,
          average: 2e12,
          high: 3e12
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "canto",
      coinMinimalDenom: "acanto",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "carbon-1",
    currencies: [
      {
        coinDenom: "dswth",
        coinMinimalDenom: "swth",
        coinDecimals: 8
      },
      {
        coinDenom: "dusc",
        coinMinimalDenom: "usc",
        coinDecimals: 8
      },
      {
        coinDenom: "bnb",
        coinMinimalDenom: "bnb.1.6.773edb",
        coinDecimals: 18
      },
      {
        coinDenom: "bneo",
        coinMinimalDenom: "bneo.1.14.e2e5f6",
        coinDecimals: 8
      },
      {
        coinDenom: "busd",
        coinMinimalDenom: "busd.1.6.754a80",
        coinDecimals: 18
      },
      {
        coinDenom: "cglp",
        coinMinimalDenom: "cglp.1.19.1698d3",
        coinDecimals: 18
      },
      {
        coinDenom: "usd",
        coinMinimalDenom: "cgt/1",
        coinDecimals: 18
      },
      {
        coinDenom: "eth",
        coinMinimalDenom: "eth.1.19.c3b805",
        coinDecimals: 18
      },
      {
        coinDenom: "eth",
        coinMinimalDenom: "eth.1.2.942d87",
        coinDecimals: 18
      },
      {
        coinDenom: "stars",
        coinMinimalDenom: "ibc/07FA7831E1920D0C87C9388F86B0108677F6ED0C9DE7E4063F05ED675192405C",
        coinDecimals: 6
      },
      {
        coinDenom: "luna",
        coinMinimalDenom: "ibc/2B58B8C147E8718EECCB3713271DF46DEE8A3A00A27242628604E31C2F370EF5",
        coinDecimals: 6
      },
      {
        coinDenom: "tia",
        coinMinimalDenom: "ibc/6C349F0EB135C5FA99301758F35B87DB88403D690E5E314AB080401FEE4066E5",
        coinDecimals: 6
      },
      {
        coinDenom: "milkTIA",
        coinMinimalDenom: "ibc/16065EE5282C5217685C8F084FC44864C25C706AC37356B0D62811D50B96920F",
        coinDecimals: 6
      },
      {
        coinDenom: "strd",
        coinMinimalDenom: "ibc/3552CECB7BCE1891DB6070D37EC6E954C972B1400141308FCD85FD148BD06DE5",
        coinDecimals: 6
      },
      {
        coinDenom: "evmos",
        coinMinimalDenom: "ibc/35E771B8682D828173F4B795F6C307780F96DC64D6F914FAE4CC9B4666F66364",
        coinDecimals: 18
      },
      {
        coinDenom: "iris",
        coinMinimalDenom: "ibc/4E06CF24FEBFB3F5AF645377DCC0B70AA6183BAF6B918B8B6243FCDEB7D38118",
        coinDecimals: 6
      },
      {
        coinDenom: "kuji",
        coinMinimalDenom: "ibc/662914D0C1CEBCB070C68F061D035E8B10A07C79AB286E7342C85F3BE74612C5",
        coinDecimals: 6
      },
      {
        coinDenom: "stosmo",
        coinMinimalDenom: "ibc/75249A18DEFBEFE55F83B1C70CAD234DF164F174C6BC51682EE92C2C81C18C93",
        coinDecimals: 6
      },
      {
        coinDenom: "canto",
        coinMinimalDenom: "ibc/92E974290AF9E2BC3AEEEC35305C8FD76AC5A22A74CF8D91270FDF5A1C41E861",
        coinDecimals: 18
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/A4DB47A9D3CF9A068D454513891B526702455D3EF08FB9EB558C561F9DC2B701",
        coinDecimals: 6
      },
      {
        coinDenom: "statom",
        coinMinimalDenom: "ibc/B7864B03E1B9FD4F049243E92ABD691586F682137037A9F3FCA5222815620B3C",
        coinDecimals: 6
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "usdc.1.2.343151",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "usdc.1.6.53ff75",
        coinDecimals: 18
      },
      {
        coinDenom: "zil",
        coinMinimalDenom: "zil.1.18.1a4a06",
        coinDecimals: 12
      }
    ],
    rest: "https://api.carbon.network",
    rpc: "https://tm-api.carbon.network",
    bech32Config: {
      bech32PrefixAccAddr: "swth",
      bech32PrefixAccPub: "swthpub",
      bech32PrefixValAddr: "swthvaloper",
      bech32PrefixValPub: "swthvaloperpub",
      bech32PrefixConsAddr: "swthvalcons",
      bech32PrefixConsPub: "swthvalconspub"
    },
    chainName: "carbon",
    feeCurrencies: [
      {
        coinDenom: "dswth",
        coinMinimalDenom: "swth",
        coinDecimals: 8,
        gasPriceStep: {
          low: 1,
          average: 1,
          high: 1
        }
      },
      {
        coinDenom: "dusc",
        coinMinimalDenom: "usc",
        coinDecimals: 8,
        gasPriceStep: {
          low: 1e-4,
          average: 1e-4,
          high: 1e-4
        }
      },
      {
        coinDenom: "bnb",
        coinMinimalDenom: "bnb.1.6.773edb",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e6,
          average: 1e6,
          high: 1e6
        }
      },
      {
        coinDenom: "bneo",
        coinMinimalDenom: "bneo.1.14.e2e5f6",
        coinDecimals: 8,
        gasPriceStep: {
          low: 15e-4,
          average: 15e-4,
          high: 15e-4
        }
      },
      {
        coinDenom: "busd",
        coinMinimalDenom: "busd.1.6.754a80",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e8,
          average: 1e8,
          high: 1e8
        }
      },
      {
        coinDenom: "cglp",
        coinMinimalDenom: "cglp.1.19.1698d3",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e8,
          average: 1e8,
          high: 1e8
        }
      },
      {
        coinDenom: "usd",
        coinMinimalDenom: "cgt/1",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e8,
          average: 1e8,
          high: 1e8
        }
      },
      {
        coinDenom: "eth",
        coinMinimalDenom: "eth.1.19.c3b805",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e5,
          average: 1e5,
          high: 1e5
        }
      },
      {
        coinDenom: "eth",
        coinMinimalDenom: "eth.1.2.942d87",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e5,
          average: 1e5,
          high: 1e5
        }
      },
      {
        coinDenom: "stars",
        coinMinimalDenom: "ibc/07FA7831E1920D0C87C9388F86B0108677F6ED0C9DE7E4063F05ED675192405C",
        coinDecimals: 6,
        gasPriceStep: {
          low: 35e-4,
          average: 35e-4,
          high: 35e-4
        }
      },
      {
        coinDenom: "milkTIA",
        coinMinimalDenom: "ibc/16065EE5282C5217685C8F084FC44864C25C706AC37356B0D62811D50B96920F",
        coinDecimals: 6,
        gasPriceStep: {
          low: 75e-7,
          average: 75e-7,
          high: 75e-7
        }
      },
      {
        coinDenom: "luna",
        coinMinimalDenom: "ibc/2B58B8C147E8718EECCB3713271DF46DEE8A3A00A27242628604E31C2F370EF5",
        coinDecimals: 6,
        gasPriceStep: {
          low: 5e-5,
          average: 5e-5,
          high: 5e-5
        }
      },
      {
        coinDenom: "strd",
        coinMinimalDenom: "ibc/3552CECB7BCE1891DB6070D37EC6E954C972B1400141308FCD85FD148BD06DE5",
        coinDecimals: 6,
        gasPriceStep: {
          low: 32e-5,
          average: 32e-5,
          high: 32e-5
        }
      },
      {
        coinDenom: "evmos",
        coinMinimalDenom: "ibc/35E771B8682D828173F4B795F6C307780F96DC64D6F914FAE4CC9B4666F66364",
        coinDecimals: 18,
        gasPriceStep: {
          low: 3e8,
          average: 3e8,
          high: 3e8
        }
      },
      {
        coinDenom: "iris",
        coinMinimalDenom: "ibc/4E06CF24FEBFB3F5AF645377DCC0B70AA6183BAF6B918B8B6243FCDEB7D38118",
        coinDecimals: 6,
        gasPriceStep: {
          low: 6e-4,
          average: 6e-4,
          high: 6e-4
        }
      },
      {
        coinDenom: "kuji",
        coinMinimalDenom: "ibc/662914D0C1CEBCB070C68F061D035E8B10A07C79AB286E7342C85F3BE74612C5",
        coinDecimals: 6,
        gasPriceStep: {
          low: 15e-5,
          average: 15e-5,
          high: 15e-5
        }
      },
      {
        coinDenom: "tia",
        coinMinimalDenom: "ibc/6C349F0EB135C5FA99301758F35B87DB88403D690E5E314AB080401FEE4066E5",
        coinDecimals: 6,
        gasPriceStep: {
          low: 75e-7,
          average: 75e-7,
          high: 75e-7
        }
      },
      {
        coinDenom: "stosmo",
        coinMinimalDenom: "ibc/75249A18DEFBEFE55F83B1C70CAD234DF164F174C6BC51682EE92C2C81C18C93",
        coinDecimals: 6,
        gasPriceStep: {
          low: 15e-5,
          average: 15e-5,
          high: 15e-5
        }
      },
      {
        coinDenom: "canto",
        coinMinimalDenom: "ibc/92E974290AF9E2BC3AEEEC35305C8FD76AC5A22A74CF8D91270FDF5A1C41E861",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e8,
          average: 2e8,
          high: 2e8
        }
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/A4DB47A9D3CF9A068D454513891B526702455D3EF08FB9EB558C561F9DC2B701",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-5,
          average: 1e-5,
          high: 1e-5
        }
      },
      {
        coinDenom: "statom",
        coinMinimalDenom: "ibc/B7864B03E1B9FD4F049243E92ABD691586F682137037A9F3FCA5222815620B3C",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-5,
          average: 1e-5,
          high: 1e-5
        }
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
        coinDecimals: 6,
        gasPriceStep: {
          low: 15e-5,
          average: 15e-5,
          high: 15e-5
        }
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "usdc.1.2.343151",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-4,
          average: 1e-4,
          high: 1e-4
        }
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "usdc.1.6.53ff75",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e8,
          average: 1e8,
          high: 1e8
        }
      },
      {
        coinDenom: "zil",
        coinMinimalDenom: "zil.1.18.1a4a06",
        coinDecimals: 12,
        gasPriceStep: {
          low: 6e3,
          average: 6e3,
          high: 6e3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "dswth",
      coinMinimalDenom: "swth",
      coinDecimals: 8
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "celestia",
    currencies: [
      {
        coinDenom: "tia",
        coinMinimalDenom: "utia",
        coinDecimals: 6
      }
    ],
    rest: "https://public-celestia-lcd.numia.xyz",
    rpc: "https://public-celestia-rpc.numia.xyz",
    bech32Config: {
      bech32PrefixAccAddr: "celestia",
      bech32PrefixAccPub: "celestiapub",
      bech32PrefixValAddr: "celestiavaloper",
      bech32PrefixValPub: "celestiavaloperpub",
      bech32PrefixConsAddr: "celestiavalcons",
      bech32PrefixConsPub: "celestiavalconspub"
    },
    chainName: "celestia",
    feeCurrencies: [
      {
        coinDenom: "tia",
        coinMinimalDenom: "utia",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.02,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tia",
      coinMinimalDenom: "utia",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "perun-1",
    currencies: [
      {
        coinDenom: "c4e",
        coinMinimalDenom: "uc4e",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.c4e.io/",
    rpc: "https://rpc.c4e.io/",
    bech32Config: {
      bech32PrefixAccAddr: "c4e",
      bech32PrefixAccPub: "c4epub",
      bech32PrefixValAddr: "c4evaloper",
      bech32PrefixValPub: "c4evaloperpub",
      bech32PrefixConsAddr: "c4evalcons",
      bech32PrefixConsPub: "c4evalconspub"
    },
    chainName: "chain4energy",
    feeCurrencies: [
      {
        coinDenom: "c4e",
        coinMinimalDenom: "uc4e",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "c4e",
      coinMinimalDenom: "uc4e",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "cheqd-mainnet-1",
    currencies: [
      {
        coinDenom: "cheq",
        coinMinimalDenom: "ncheq",
        coinDecimals: 9
      }
    ],
    rest: "https://api.cheqd.net",
    rpc: "https://rpc.cheqd.net",
    bech32Config: {
      bech32PrefixAccAddr: "cheqd",
      bech32PrefixAccPub: "cheqdpub",
      bech32PrefixValAddr: "cheqdvaloper",
      bech32PrefixValPub: "cheqdvaloperpub",
      bech32PrefixConsAddr: "cheqdvalcons",
      bech32PrefixConsPub: "cheqdvalconspub"
    },
    chainName: "cheqd",
    feeCurrencies: [
      {
        coinDenom: "cheq",
        coinMinimalDenom: "ncheq",
        coinDecimals: 9,
        gasPriceStep: {
          low: 50,
          average: 75,
          high: 100
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "cheq",
      coinMinimalDenom: "ncheq",
      coinDecimals: 9
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "chihuahua-1",
    currencies: [
      {
        coinDenom: "huahua",
        coinMinimalDenom: "uhuahua",
        coinDecimals: 6
      },
      {
        coinDenom: "puppy",
        coinMinimalDenom: "cw20:chihuahua1yl8z39ugle8s02fpwkhh293509q5xcpalmdzc4amvchz8nkexrmsy95gef",
        coinDecimals: 6
      },
      {
        coinDenom: "achihuahuawifhat",
        coinMinimalDenom: "factory/chihuahua1x4q2vkrz4dfgd9hcw0p5m2f2nuv2uqmt9xr8k2/achihuahuawifhat",
        coinDecimals: 6
      },
      {
        coinDenom: "WOOF",
        coinMinimalDenom: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/uwoof",
        coinDecimals: 6
      },
      {
        coinDenom: "TACOS",
        coinMinimalDenom: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/utacos",
        coinDecimals: 6
      },
      {
        coinDenom: "WEED",
        coinMinimalDenom: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/uweed",
        coinDecimals: 6
      },
      {
        coinDenom: "BDOG",
        coinMinimalDenom: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/ubdog",
        coinDecimals: 6
      },
      {
        coinDenom: "CORSO",
        coinMinimalDenom: "factory/chihuahua13jawsn574rf3f0u5rhu7e8n6sayx5gkw3eddhp/ucorso",
        coinDecimals: 6
      },
      {
        coinDenom: "bHUAHUA",
        coinMinimalDenom: "cw20:chihuahua1jz5n4aynhpxx7clf2m8hrv9dp5nz83k67fgaxhy4p9dfwl6zssrq3ymr6w",
        coinDecimals: 6
      },
      {
        coinDenom: "ashHUAHUA",
        coinMinimalDenom: "factory/chihuahua1hplyuj2hzxd75q8686g9vm3uzrrny9ggvt8aza2csupgdp98vg2sp0e3h0/uhuahua.ash",
        coinDecimals: 6
      },
      {
        coinDenom: "ampGASH",
        coinMinimalDenom: "ibc/7D01429FF7542DBC41C261793B480B63FE7A83260C751989CC268BC7E852EB99",
        coinDecimals: 6
      },
      {
        coinDenom: "GUPPY",
        coinMinimalDenom: "ibc/DBBDE1753EFA93F09C468DB5E384861BB741D4AA73E9C7032D139BB2C99FDD65",
        coinDecimals: 6
      }
    ],
    rest: "https://api.chihuahua.wtf",
    rpc: "https://rpc.chihuahua.wtf",
    bech32Config: {
      bech32PrefixAccAddr: "chihuahua",
      bech32PrefixAccPub: "chihuahuapub",
      bech32PrefixValAddr: "chihuahuavaloper",
      bech32PrefixValPub: "chihuahuavaloperpub",
      bech32PrefixConsAddr: "chihuahuavalcons",
      bech32PrefixConsPub: "chihuahuavalconspub"
    },
    chainName: "chihuahua",
    feeCurrencies: [
      {
        coinDenom: "huahua",
        coinMinimalDenom: "uhuahua",
        coinDecimals: 6,
        gasPriceStep: {
          low: 500,
          average: 1250,
          high: 2e3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "huahua",
      coinMinimalDenom: "uhuahua",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "chimba",
    currencies: [
      {
        coinDenom: "chimba",
        coinMinimalDenom: "ucmba",
        coinDecimals: 6
      }
    ],
    rest: "https://mainnet.chimba.ooo",
    rpc: "https://rpc.mainnet.chimba.ooo",
    bech32Config: {
      bech32PrefixAccAddr: "chimba",
      bech32PrefixAccPub: "chimbapub",
      bech32PrefixValAddr: "chimbavaloper",
      bech32PrefixValPub: "chimbavaloperpub",
      bech32PrefixConsAddr: "chimbavalcons",
      bech32PrefixConsPub: "chimbavalconspub"
    },
    chainName: "chimba",
    feeCurrencies: [
      {
        coinDenom: "chimba",
        coinMinimalDenom: "ucmba",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 5,
          high: 10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "chimba",
      coinMinimalDenom: "ucmba",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "morocco-1",
    currencies: [
      {
        coinDenom: "cht",
        coinMinimalDenom: "ucht",
        coinDecimals: 6
      },
      {
        coinDenom: "cgas",
        coinMinimalDenom: "ucgas",
        coinDecimals: 6
      }
    ],
    rest: "https://api-chronic.zenchainlabs.io/",
    rpc: "https://rpc-chronic.zenchainlabs.io/",
    bech32Config: {
      bech32PrefixAccAddr: "chronic",
      bech32PrefixAccPub: "chronicpub",
      bech32PrefixValAddr: "chronicvaloper",
      bech32PrefixValPub: "chronicvaloperpub",
      bech32PrefixConsAddr: "chronicvalcons",
      bech32PrefixConsPub: "chronicvalconspub"
    },
    chainName: "chronicnetwork",
    feeCurrencies: [
      {
        coinDenom: "cgas",
        coinMinimalDenom: "ucgas",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "cht",
      coinMinimalDenom: "ucht",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "cifer-2",
    currencies: [
      {
        coinDenom: "cif",
        coinMinimalDenom: "ucif",
        coinDecimals: 6
      }
    ],
    rest: "https://api.cifer.ai",
    rpc: "http://34.128.114.243:26657",
    bech32Config: {
      bech32PrefixAccAddr: "cife",
      bech32PrefixAccPub: "cifepub",
      bech32PrefixValAddr: "cifevaloper",
      bech32PrefixValPub: "cifevaloperpub",
      bech32PrefixConsAddr: "cifevalcons",
      bech32PrefixConsPub: "cifevalconspub"
    },
    chainName: "cifer",
    feeCurrencies: [
      {
        coinDenom: "cif",
        coinMinimalDenom: "ucif",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 5,
          high: 10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "cif",
      coinMinimalDenom: "ucif",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "cifer-1",
    currencies: [
      {
        coinDenom: "cif",
        coinMinimalDenom: "ucif",
        coinDecimals: 6
      }
    ],
    rest: "https://api.cifer.ai",
    rpc: "https://cif_node.cifer.ai/",
    bech32Config: {
      bech32PrefixAccAddr: "cife",
      bech32PrefixAccPub: "cifepub",
      bech32PrefixValAddr: "cifevaloper",
      bech32PrefixValPub: "cifevaloperpub",
      bech32PrefixConsAddr: "cifevalcons",
      bech32PrefixConsPub: "cifevalconspub"
    },
    chainName: "cifer1",
    feeCurrencies: [
      {
        coinDenom: "cif",
        coinMinimalDenom: "ucif",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 5,
          high: 10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "cif",
      coinMinimalDenom: "ucif",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "cnho_stables-1",
    currencies: [
      {
        coinDenom: "CNHO",
        coinMinimalDenom: "ucnho",
        coinDecimals: 6
      }
    ],
    rest: "https://api.cnho.io",
    rpc: "https://rpc.cnho.io",
    bech32Config: {
      bech32PrefixAccAddr: "cnho",
      bech32PrefixAccPub: "cnhopub",
      bech32PrefixValAddr: "cnhovaloper",
      bech32PrefixValPub: "cnhovaloperpub",
      bech32PrefixConsAddr: "cnhovalcons",
      bech32PrefixConsPub: "cnhovalconspub"
    },
    chainName: "cnhostables",
    feeCurrencies: [
      {
        coinDenom: "CNHO",
        coinMinimalDenom: "ucnho",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-6,
          average: 1e-5,
          high: 0.025
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "CNHO",
      coinMinimalDenom: "ucnho",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "comdex-1",
    currencies: [
      {
        coinDenom: "cmdx",
        coinMinimalDenom: "ucmdx",
        coinDecimals: 6
      },
      {
        coinDenom: "harbor",
        coinMinimalDenom: "uharbor",
        coinDecimals: 6
      },
      {
        coinDenom: "cmst",
        coinMinimalDenom: "ucmst",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.comdex.one",
    rpc: "https://rpc.comdex.one",
    bech32Config: {
      bech32PrefixAccAddr: "comdex",
      bech32PrefixAccPub: "comdexpub",
      bech32PrefixValAddr: "comdexvaloper",
      bech32PrefixValPub: "comdexvaloperpub",
      bech32PrefixConsAddr: "comdexvalcons",
      bech32PrefixConsPub: "comdexvalconspub"
    },
    chainName: "comdex",
    feeCurrencies: [
      {
        coinDenom: "cmdx",
        coinMinimalDenom: "ucmdx",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "cmdx",
      coinMinimalDenom: "ucmdx",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "commercio-3",
    currencies: [
      {
        coinDenom: "commercio",
        coinMinimalDenom: "ucommercio",
        coinDecimals: 6
      },
      {
        coinDenom: "ccc",
        coinMinimalDenom: "uccc",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd-mainnet.commercio.network",
    rpc: "https://rpc-mainnet.commercio.network",
    bech32Config: {
      bech32PrefixAccAddr: "did:com:",
      bech32PrefixAccPub: "did:com:pub",
      bech32PrefixValAddr: "did:com:valoper",
      bech32PrefixValPub: "did:com:valoperpub",
      bech32PrefixConsAddr: "did:com:valcons",
      bech32PrefixConsPub: "did:com:valconspub"
    },
    chainName: "commercionetwork",
    feeCurrencies: [
      {
        coinDenom: "commercio",
        coinMinimalDenom: "ucommercio",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "commercio",
      coinMinimalDenom: "ucommercio",
      coinDecimals: 6
    },
    bip44: {
      coinType: 701
    }
  },
  {
    chainId: "centauri-1",
    currencies: [
      {
        coinDenom: "pica",
        coinMinimalDenom: "ppica",
        coinDecimals: 12
      },
      {
        coinDenom: "ksm",
        coinMinimalDenom: "ibc/EE9046745AEC0E8302CB7ED9D5AD67F528FB3B7AE044B247FB0FB293DBDA35E9",
        coinDecimals: 12
      },
      {
        coinDenom: "dot",
        coinMinimalDenom: "ibc/3CC19CEC7E5A3E90E78A5A9ECC5A0E2F8F826A375CF1E096F4515CF09DA3E366",
        coinDecimals: 10
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/F3EC9F834E57DF704FA3AEAF14E8391C2E58397FE56960AD70E67562990D8265",
        coinDecimals: 6
      },
      {
        coinDenom: "tnkr",
        coinMinimalDenom: "ibc/C58E5D2571042137CB68B1B9851C4E7211C05F7C2C79E21E0966AF0F063961F8",
        coinDecimals: 12
      },
      {
        coinDenom: "eth",
        coinMinimalDenom: "ibc/F9D075D4079FC56A9C49B601E54A45292C319D8B0E8CC0F8439041130AA7166C",
        coinDecimals: 18
      },
      {
        coinDenom: "dai",
        coinMinimalDenom: "ibc/A342F6F8D1CDE1D934C50E8EAFF91E813D971E1BFEED7E557F1674E01004A533",
        coinDecimals: 18
      },
      {
        coinDenom: "fxs",
        coinMinimalDenom: "ibc/5F9BE030FC355733EC79307409FA98398BBFC747C9430B326C144A74F6808B29",
        coinDecimals: 18
      },
      {
        coinDenom: "frax",
        coinMinimalDenom: "ibc/4F20D68B51ED559F99C3CD658383E91F45486D884BF546E7B25337A058562CDB",
        coinDecimals: 18
      },
      {
        coinDenom: "frxeth",
        coinMinimalDenom: "ibc/458032E654E41DB91EF98F13E2CE4F9E0FE86BA3E0CDBEC074A854E9F5229A90",
        coinDecimals: 18
      },
      {
        coinDenom: "sfrxeth",
        coinMinimalDenom: "ibc/4E0ECE7819D77B0F2B49F5C34B5E594A02D2BA8B1B0F103208F847B53EBFB69A",
        coinDecimals: 18
      },
      {
        coinDenom: "sfrax",
        coinMinimalDenom: "ibc/5BD7F23FE150D9CF3BCC944DB829380BCC51A4022A131151C4D13B3AFAC2D1D9",
        coinDecimals: 18
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/37CC704EA53E96AB09A9C31D79142DE7DB252420F3AB18015F9870AE219947BD",
        coinDecimals: 6
      },
      {
        coinDenom: "crv",
        coinMinimalDenom: "ibc/52C8C6197989684F891076F228F20CD1659AB6E1776E3B85E65CBBEC67DA5DED",
        coinDecimals: 18
      },
      {
        coinDenom: "wbtc",
        coinMinimalDenom: "ibc/1507315B0C337368B85A7EC67C3956C508E1106EBD96336B1B092F7B2815B3E5",
        coinDecimals: 18
      },
      {
        coinDenom: "steth",
        coinMinimalDenom: "ibc/74F65FE91F672BC2524C039B3CD0211F6D370071209552533DF26D57743D5FFD",
        coinDecimals: 18
      },
      {
        coinDenom: "reth",
        coinMinimalDenom: "ibc/207E7F34DFEBF714CED4900C1FD85BAF200230BF431EE8133EB26B98CB535EDC",
        coinDecimals: 18
      },
      {
        coinDenom: "crvusd",
        coinMinimalDenom: "ibc/C9D79BE8E3E75CA2DFDC722C77D7B179C39A4802D59019C790A825FDE34B724A",
        coinDecimals: 18
      },
      {
        coinDenom: "pxeth",
        coinMinimalDenom: "ibc/36EF1EA47A09689C81D848B08E5240FA9FF13B17DB7DCF48B77D4D0D9B152821",
        coinDecimals: 18
      },
      {
        coinDenom: "eeth",
        coinMinimalDenom: "ibc/34C23BA6BAA2EAE0199D85AD1E2E214F76B0BFAD42BF75542D15F71264EEB05B",
        coinDecimals: 18
      },
      {
        coinDenom: "ena",
        coinMinimalDenom: "ibc/B089810D5A6316AD5E9C7808733DC4AB11C7BA3033221D28711FC7206BACB929",
        coinDecimals: 18
      },
      {
        coinDenom: "usde",
        coinMinimalDenom: "ibc/FFD9EB71B4480ED4D73F7370A2AEBDB48447A0AAE27265F8060A957F0FF71983",
        coinDecimals: 18
      },
      {
        coinDenom: "ezeth",
        coinMinimalDenom: "ibc/E317539F148285AAC77E7614101CBE94E20EDF169B233A5E0C867112972F9041",
        coinDecimals: 18
      },
      {
        coinDenom: "pepe",
        coinMinimalDenom: "ibc/6367C5AF2E2477FB13DD0C8CB0027FEDDF5AE947EE84C69FB75003E604E29D05",
        coinDecimals: 18
      },
      {
        coinDenom: "wsol",
        coinMinimalDenom: "ibc/2CC39C8141F257EBBA250F65B9D0F31DC8D153C225E51EC192DE6E3F65D43F0C",
        coinDecimals: 9
      },
      {
        coinDenom: "msol",
        coinMinimalDenom: "ibc/C280CB39B97E7CD33A0BF149CFD392C2A3F95FF896AFF89CFF2FA181479BED8D",
        coinDecimals: 9
      },
      {
        coinDenom: "jitosol",
        coinMinimalDenom: "ibc/91A2FE07F8BDFC0552B1C9972FCCBF2CFD067DDE5F496D81E5132CE57762B0F2",
        coinDecimals: 9
      },
      {
        coinDenom: "bsol",
        coinMinimalDenom: "ibc/F52A71607B3AA7BBA8A222A9176E9939E92AB3656A094289CD218907D45DB716",
        coinDecimals: 9
      },
      {
        coinDenom: "lst",
        coinMinimalDenom: "ibc/55F5B582483FEFA5422794292B079B4D49A5BAB9881E7C801F9F271F1D234F1D",
        coinDecimals: 9
      },
      {
        coinDenom: "edgesol",
        coinMinimalDenom: "ibc/BADB5950C4A81AC201696EBCB33CD295137FA86F0AA620CDDE946D3700E0208C",
        coinDecimals: 9
      },
      {
        coinDenom: "hsol",
        coinMinimalDenom: "ibc/531C52D572698BCBA29F44D959E73CD2148EE6542A3118F9E56621A28E1FF4C6",
        coinDecimals: 9
      },
      {
        coinDenom: "jupsol",
        coinMinimalDenom: "ibc/6976998E24F1CFC373A9F799C9CE901F5EC32C3E33B2B09384A05774D9339626",
        coinDecimals: 9
      },
      {
        coinDenom: "wif",
        coinMinimalDenom: "ibc/BA34EAA22BBDA46C228DC70E4ED7E42A0867D5B051D625F953CC7B1CEF58C071",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/D105950618E47CA2AEC314282BC401625025F80A4F812808DEEBB1941C685575",
        coinDecimals: 6
      },
      {
        coinDenom: "whine",
        coinMinimalDenom: "ibc/9D5DA3720001F91DD76B8F609A93F96688EC8185B54BF9A1A1450EB34FF2D912",
        coinDecimals: 6
      },
      {
        coinDenom: "unicorn",
        coinMinimalDenom: "ibc/586C150919550F6106711C7557DAAAEAB765DDF05648BAC0D96487AE90394BA1",
        coinDecimals: 6
      }
    ],
    rest: "https://api-composable-ia.cosmosia.notional.ventures",
    rpc: "https://rpc-composable-ia.cosmosia.notional.ventures",
    bech32Config: {
      bech32PrefixAccAddr: "pica",
      bech32PrefixAccPub: "picapub",
      bech32PrefixValAddr: "picavaloper",
      bech32PrefixValPub: "picavaloperpub",
      bech32PrefixConsAddr: "picavalcons",
      bech32PrefixConsPub: "picavalconspub"
    },
    chainName: "composable",
    feeCurrencies: [
      {
        coinDenom: "pica",
        coinMinimalDenom: "ppica",
        coinDecimals: 12
      }
    ],
    stakeCurrency: {
      coinDenom: "pica",
      coinMinimalDenom: "ppica",
      coinDecimals: 12
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "cvn_2032-1",
    currencies: [
      {
        coinDenom: "cvnt",
        coinMinimalDenom: "acvnt",
        coinDecimals: 18
      }
    ],
    rest: "https://api.cvn.io",
    rpc: "https://rpc.cvn.io/",
    bech32Config: {
      bech32PrefixAccAddr: "cvn",
      bech32PrefixAccPub: "cvnpub",
      bech32PrefixValAddr: "cvnvaloper",
      bech32PrefixValPub: "cvnvaloperpub",
      bech32PrefixConsAddr: "cvnvalcons",
      bech32PrefixConsPub: "cvnvalconspub"
    },
    chainName: "conscious",
    feeCurrencies: [
      {
        coinDenom: "cvnt",
        coinMinimalDenom: "acvnt",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e8,
          average: 2e8,
          high: 3e8
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "cvnt",
      coinMinimalDenom: "acvnt",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "coreum-mainnet-1",
    currencies: [
      {
        coinDenom: "core",
        coinMinimalDenom: "ucore",
        coinDecimals: 6
      },
      {
        coinDenom: "xrp",
        coinMinimalDenom: "drop-core1zhs909jp9yktml6qqx9f0ptcq2xnhhj99cja03j3lfcsp2pgm86studdrz",
        coinDecimals: 6
      }
    ],
    rest: "https://rest-coreum.ecostake.com",
    rpc: "https://full-node.mainnet-1.coreum.dev:26657",
    bech32Config: {
      bech32PrefixAccAddr: "core",
      bech32PrefixAccPub: "corepub",
      bech32PrefixValAddr: "corevaloper",
      bech32PrefixValPub: "corevaloperpub",
      bech32PrefixConsAddr: "corevalcons",
      bech32PrefixConsPub: "corevalconspub"
    },
    chainName: "coreum",
    feeCurrencies: [
      {
        coinDenom: "core",
        coinMinimalDenom: "ucore",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.0625,
          average: 0.0625,
          high: 62.5
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "core",
      coinMinimalDenom: "ucore",
      coinDecimals: 6
    },
    bip44: {
      coinType: 990
    }
  },
  {
    chainId: "cosmoshub-4",
    currencies: [
      {
        coinDenom: "atom",
        coinMinimalDenom: "uatom",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/F04D72CF9B5D9C849BB278B691CDFA2241813327430EC9CDC83F8F4CA4CDC2B0",
        coinDecimals: 6
      },
      {
        coinDenom: "ibc/4925E6ABA571A44D2BE0286D2D29AF42A294D0FF2BB16490149A1B26EAD33729",
        coinMinimalDenom: "ibc/4925E6ABA571A44D2BE0286D2D29AF42A294D0FF2BB16490149A1B26EAD33729",
        coinDecimals: 0
      }
    ],
    rest: "https://cosmoshub.lava.build:443",
    rpc: "https://cosmoshub.tendermintrpc.lava.build:443",
    bech32Config: {
      bech32PrefixAccAddr: "cosmos",
      bech32PrefixAccPub: "cosmospub",
      bech32PrefixValAddr: "cosmosvaloper",
      bech32PrefixValPub: "cosmosvaloperpub",
      bech32PrefixConsAddr: "cosmosvalcons",
      bech32PrefixConsPub: "cosmosvalconspub"
    },
    chainName: "cosmoshub",
    feeCurrencies: [
      {
        coinDenom: "atom",
        coinMinimalDenom: "uatom",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "atom",
      coinMinimalDenom: "uatom",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "coss-1",
    currencies: [
      {
        coinDenom: "cgas",
        coinMinimalDenom: "ucgas",
        coinDecimals: 6
      },
      {
        coinDenom: "coss",
        coinMinimalDenom: "ucoss",
        coinDecimals: 6
      },
      {
        coinDenom: "cias",
        coinMinimalDenom: "ucias",
        coinDecimals: 6
      }
    ],
    rest: "https://coss-rest.coss.ink",
    rpc: "https://coss-rpc.coss.ink",
    bech32Config: {
      bech32PrefixAccAddr: "coss",
      bech32PrefixAccPub: "cosspub",
      bech32PrefixValAddr: "cossvaloper",
      bech32PrefixValPub: "cossvaloperpub",
      bech32PrefixConsAddr: "cossvalcons",
      bech32PrefixConsPub: "cossvalconspub"
    },
    chainName: "coss",
    feeCurrencies: [
      {
        coinDenom: "coss",
        coinMinimalDenom: "ucoss",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.03,
          high: 0.04
        }
      },
      {
        coinDenom: "cgas",
        coinMinimalDenom: "ucgas",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.03,
          high: 0.04
        }
      },
      {
        coinDenom: "cias",
        coinMinimalDenom: "ucias",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.03,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "cgas",
      coinMinimalDenom: "ucgas",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "crescent-1",
    currencies: [
      {
        coinDenom: "cre",
        coinMinimalDenom: "ucre",
        coinDecimals: 6
      },
      {
        coinDenom: "bcre",
        coinMinimalDenom: "ubcre",
        coinDecimals: 6
      }
    ],
    rest: "https://mainnet.crescent.network:1317",
    rpc: "https://mainnet.crescent.network:26657",
    bech32Config: {
      bech32PrefixAccAddr: "cre",
      bech32PrefixAccPub: "crepub",
      bech32PrefixValAddr: "crevaloper",
      bech32PrefixValPub: "crevaloperpub",
      bech32PrefixConsAddr: "crevalcons",
      bech32PrefixConsPub: "crevalconspub"
    },
    chainName: "crescent",
    feeCurrencies: [
      {
        coinDenom: "cre",
        coinMinimalDenom: "ucre",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "cre",
      coinMinimalDenom: "ucre",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "cronosmainnet_25-1",
    currencies: [
      {
        coinDenom: "cro",
        coinMinimalDenom: "basecro",
        coinDecimals: 18
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/9106F2626880DF7FAD30621F355423B2A7523D8E2274475F009644D708A90682",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.cronos.org/",
    rpc: "https://rpc.cronos.org/",
    bech32Config: {
      bech32PrefixAccAddr: "crc",
      bech32PrefixAccPub: "crcpub",
      bech32PrefixValAddr: "crcvaloper",
      bech32PrefixValPub: "crcvaloperpub",
      bech32PrefixConsAddr: "crcvalcons",
      bech32PrefixConsPub: "crcvalconspub"
    },
    chainName: "cronos",
    feeCurrencies: [
      {
        coinDenom: "cro",
        coinMinimalDenom: "basecro",
        coinDecimals: 18
      }
    ],
    stakeCurrency: {
      coinDenom: "cro",
      coinMinimalDenom: "basecro",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "crypto-org-chain-mainnet-1",
    currencies: [
      {
        coinDenom: "cro",
        coinMinimalDenom: "basecro",
        coinDecimals: 8
      },
      {
        coinDenom: "lumen",
        coinMinimalDenom: "baseXLM",
        coinDecimals: 7
      },
      {
        coinDenom: "lumen",
        coinMinimalDenom: "ibc/34A1D4BF5FFCDB912F64FE71D54426D56970F873F1279983B69C713B3A62D10D",
        coinDecimals: 7
      }
    ],
    rest: "https://rest.mainnet.crypto.org/",
    rpc: "https://rpc.mainnet.crypto.org/",
    bech32Config: {
      bech32PrefixAccAddr: "cro",
      bech32PrefixAccPub: "cropub",
      bech32PrefixValAddr: "crovaloper",
      bech32PrefixValPub: "crovaloperpub",
      bech32PrefixConsAddr: "crovalcons",
      bech32PrefixConsPub: "crovalconspub"
    },
    chainName: "cryptoorgchain",
    feeCurrencies: [
      {
        coinDenom: "cro",
        coinMinimalDenom: "basecro",
        coinDecimals: 8,
        gasPriceStep: {
          low: 0.025,
          average: 0.03,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "cro",
      coinMinimalDenom: "basecro",
      coinDecimals: 8
    },
    bip44: {
      coinType: 394
    }
  },
  {
    chainId: "cudos-1",
    currencies: [
      {
        coinDenom: "cudos",
        coinMinimalDenom: "acudos",
        coinDecimals: 18
      }
    ],
    rest: "http://mainnet-full-node-01.hosts.cudos.org:1317",
    rpc: "http://mainnet-full-node-01.hosts.cudos.org:26657",
    bech32Config: {
      bech32PrefixAccAddr: "cudos",
      bech32PrefixAccPub: "cudospub",
      bech32PrefixValAddr: "cudosvaloper",
      bech32PrefixValPub: "cudosvaloperpub",
      bech32PrefixConsAddr: "cudosvalcons",
      bech32PrefixConsPub: "cudosvalconspub"
    },
    chainName: "cudos",
    feeCurrencies: [
      {
        coinDenom: "cudos",
        coinMinimalDenom: "acudos",
        coinDecimals: 18,
        gasPriceStep: {
          low: 5e12,
          average: 1e13,
          high: 2e13
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "cudos",
      coinMinimalDenom: "acudos",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "mainnet-3",
    currencies: [
      {
        coinDenom: "dec",
        coinMinimalDenom: "udec",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.mainnet.decentr.xyz",
    rpc: "https://poseidon.mainnet.decentr.xyz",
    bech32Config: {
      bech32PrefixAccAddr: "decentr",
      bech32PrefixAccPub: "decentrpub",
      bech32PrefixValAddr: "decentrvaloper",
      bech32PrefixValPub: "decentrvaloperpub",
      bech32PrefixConsAddr: "decentrvalcons",
      bech32PrefixConsPub: "decentrvalconspub"
    },
    chainName: "decentr",
    feeCurrencies: [
      {
        coinDenom: "dec",
        coinMinimalDenom: "udec",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.025
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "dec",
      coinMinimalDenom: "udec",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "desmos-mainnet",
    currencies: [
      {
        coinDenom: "dsm",
        coinMinimalDenom: "udsm",
        coinDecimals: 6
      }
    ],
    rest: "https://api.mainnet.desmos.network",
    rpc: "https://rpc.mainnet.desmos.network",
    bech32Config: {
      bech32PrefixAccAddr: "desmos",
      bech32PrefixAccPub: "desmospub",
      bech32PrefixValAddr: "desmosvaloper",
      bech32PrefixValPub: "desmosvaloperpub",
      bech32PrefixConsAddr: "desmosvalcons",
      bech32PrefixConsPub: "desmosvalconspub"
    },
    chainName: "desmos",
    feeCurrencies: [
      {
        coinDenom: "dsm",
        coinMinimalDenom: "udsm",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.03,
          high: 0.05
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "dsm",
      coinMinimalDenom: "udsm",
      coinDecimals: 6
    },
    bip44: {
      coinType: 852
    }
  },
  {
    chainId: "dhealth",
    currencies: [
      {
        coinDenom: "dhp",
        coinMinimalDenom: "udhp",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.dhealth.com",
    rpc: "https://rpc.dhealth.com",
    bech32Config: {
      bech32PrefixAccAddr: "dh",
      bech32PrefixAccPub: "dhpub",
      bech32PrefixValAddr: "dhvaloper",
      bech32PrefixValPub: "dhvaloperpub",
      bech32PrefixConsAddr: "dhvalcons",
      bech32PrefixConsPub: "dhvalconspub"
    },
    chainName: "dhealth",
    feeCurrencies: [
      {
        coinDenom: "dhp",
        coinMinimalDenom: "udhp",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.03,
          high: 0.035
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "dhp",
      coinMinimalDenom: "udhp",
      coinDecimals: 6
    },
    bip44: {
      coinType: 10111
    }
  },
  {
    chainId: "dig-1",
    currencies: [
      {
        coinDenom: "dig",
        coinMinimalDenom: "udig",
        coinDecimals: 6
      }
    ],
    rest: "https://api-1-dig.notional.ventures",
    rpc: "https://rpc-1-dig.notional.ventures",
    bech32Config: {
      bech32PrefixAccAddr: "dig",
      bech32PrefixAccPub: "digpub",
      bech32PrefixValAddr: "digvaloper",
      bech32PrefixValPub: "digvaloperpub",
      bech32PrefixConsAddr: "digvalcons",
      bech32PrefixConsPub: "digvalconspub"
    },
    chainName: "dig",
    feeCurrencies: [
      {
        coinDenom: "dig",
        coinMinimalDenom: "udig",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.03,
          high: 0.035
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "dig",
      coinMinimalDenom: "udig",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "vota-ash",
    currencies: [
      {
        coinDenom: "DORA",
        coinMinimalDenom: "peaka",
        coinDecimals: 18
      }
    ],
    rest: "https://vota-rest.dorafactory.org",
    rpc: "https://vota-rpc.dorafactory.org/",
    bech32Config: {
      bech32PrefixAccAddr: "dora",
      bech32PrefixAccPub: "dorapub",
      bech32PrefixValAddr: "doravaloper",
      bech32PrefixValPub: "doravaloperpub",
      bech32PrefixConsAddr: "doravalcons",
      bech32PrefixConsPub: "doravalconspub"
    },
    chainName: "doravota",
    feeCurrencies: [
      {
        coinDenom: "DORA",
        coinMinimalDenom: "peaka",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e11,
          average: 1e11,
          high: 1e11
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "DORA",
      coinMinimalDenom: "peaka",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "dydx-mainnet-1",
    currencies: [
      {
        coinDenom: "dydx",
        coinMinimalDenom: "adydx",
        coinDecimals: 18
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5",
        coinDecimals: 6
      }
    ],
    rest: "https://community.nuxian-node.ch:6797/dydx/crpc",
    rpc: "https://dydx-rpc.kingnodes.com:443",
    bech32Config: {
      bech32PrefixAccAddr: "dydx",
      bech32PrefixAccPub: "dydxpub",
      bech32PrefixValAddr: "dydxvaloper",
      bech32PrefixValPub: "dydxvaloperpub",
      bech32PrefixConsAddr: "dydxvalcons",
      bech32PrefixConsPub: "dydxvalconspub"
    },
    chainName: "dydx",
    feeCurrencies: [
      {
        coinDenom: "dydx",
        coinMinimalDenom: "adydx",
        coinDecimals: 18,
        gasPriceStep: {
          low: 125e8,
          average: 125e8,
          high: 2e10
        }
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "dydx",
      coinMinimalDenom: "adydx",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "dymension_1100-1",
    currencies: [
      {
        coinDenom: "dym",
        coinMinimalDenom: "adym",
        coinDecimals: 18
      },
      {
        coinDenom: "nim",
        coinMinimalDenom: "ibc/FB53D1684F155CBB86D9CE917807E42B59209EBE3AD3A92E15EF66586C073942",
        coinDecimals: 18
      },
      {
        coinDenom: "mand",
        coinMinimalDenom: "ibc/5A26C8DC8DA66F4DD94326E67F94510188F5F7AFE2DB3933A0C823670E56EABF",
        coinDecimals: 18
      }
    ],
    rest: "https://dym-m-api.agoranodes.com",
    rpc: "https://dym-m-rpc.agoranodes.com",
    bech32Config: {
      bech32PrefixAccAddr: "dym",
      bech32PrefixAccPub: "dympub",
      bech32PrefixValAddr: "dymvaloper",
      bech32PrefixValPub: "dymvaloperpub",
      bech32PrefixConsAddr: "dymvalcons",
      bech32PrefixConsPub: "dymvalconspub"
    },
    chainName: "dymension",
    feeCurrencies: [
      {
        coinDenom: "dym",
        coinMinimalDenom: "adym",
        coinDecimals: 18,
        gasPriceStep: {
          low: 5e9,
          average: 5e9,
          high: 2e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "dym",
      coinMinimalDenom: "adym",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "dyson-mainnet-01",
    currencies: [
      {
        coinDenom: "dys",
        coinMinimalDenom: "dys",
        coinDecimals: 0
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/13B2C536BB057AC79D5616B8EA1B9540EC1F2170718CAFF6F0083C966FFFED0B",
        coinDecimals: 6
      },
      {
        coinDenom: "wbtc",
        coinMinimalDenom: "ibc/9BF31153F7E37F687C75A2F310E7A4DB6E0512B065F709B5EB69FE828133AFAC",
        coinDecimals: 8
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/13DF61376C08483555C6D4C9203612086A1B23218EB5EBDBE609EEC7EFF2D82D",
        coinDecimals: 6
      }
    ],
    rest: "https://dys-api.dysonprotocol.com:443",
    rpc: "https://dys-tm.dysonprotocol.com:443",
    bech32Config: {
      bech32PrefixAccAddr: "dys",
      bech32PrefixAccPub: "dyspub",
      bech32PrefixValAddr: "dysvaloper",
      bech32PrefixValPub: "dysvaloperpub",
      bech32PrefixConsAddr: "dysvalcons",
      bech32PrefixConsPub: "dysvalconspub"
    },
    chainName: "dyson",
    feeCurrencies: [
      {
        coinDenom: "dys",
        coinMinimalDenom: "dys",
        coinDecimals: 0,
        gasPriceStep: {
          low: 1e-4,
          average: 2e-4,
          high: 3e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "dys",
      coinMinimalDenom: "dys",
      coinDecimals: 0
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "echelon_3000-3",
    currencies: [
      {
        coinDenom: "echelon",
        coinMinimalDenom: "aechelon",
        coinDecimals: 18
      }
    ],
    rest: "https://ech01api.mindheartsoul.org",
    rpc: "https://ech01trpc.mindheartsoul.org",
    bech32Config: {
      bech32PrefixAccAddr: "echelon",
      bech32PrefixAccPub: "echelonpub",
      bech32PrefixValAddr: "echelonvaloper",
      bech32PrefixValPub: "echelonvaloperpub",
      bech32PrefixConsAddr: "echelonvalcons",
      bech32PrefixConsPub: "echelonvalconspub"
    },
    chainName: "echelon",
    feeCurrencies: [
      {
        coinDenom: "echelon",
        coinMinimalDenom: "aechelon",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e10,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "echelon",
      coinMinimalDenom: "aechelon",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "emoney-3",
    currencies: [
      {
        coinDenom: "ngm",
        coinMinimalDenom: "ungm",
        coinDecimals: 6
      },
      {
        coinDenom: "eur",
        coinMinimalDenom: "eeur",
        coinDecimals: 6
      },
      {
        coinDenom: "chf",
        coinMinimalDenom: "echf",
        coinDecimals: 6
      },
      {
        coinDenom: "nok",
        coinMinimalDenom: "enok",
        coinDecimals: 6
      },
      {
        coinDenom: "dkk",
        coinMinimalDenom: "edkk",
        coinDecimals: 6
      },
      {
        coinDenom: "sek",
        coinMinimalDenom: "esek",
        coinDecimals: 6
      }
    ],
    rest: "https://emoney.validator.network/api/",
    rpc: "https://emoney.validator.network",
    bech32Config: {
      bech32PrefixAccAddr: "emoney",
      bech32PrefixAccPub: "emoneypub",
      bech32PrefixValAddr: "emoneyvaloper",
      bech32PrefixValPub: "emoneyvaloperpub",
      bech32PrefixConsAddr: "emoneyvalcons",
      bech32PrefixConsPub: "emoneyvalconspub"
    },
    chainName: "emoney",
    feeCurrencies: [
      {
        coinDenom: "ngm",
        coinMinimalDenom: "ungm",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 1,
          high: 1
        }
      },
      {
        coinDenom: "eur",
        coinMinimalDenom: "eeur",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 1,
          high: 1
        }
      },
      {
        coinDenom: "chf",
        coinMinimalDenom: "echf",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 1,
          high: 1
        }
      },
      {
        coinDenom: "nok",
        coinMinimalDenom: "enok",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 1,
          high: 1
        }
      },
      {
        coinDenom: "sek",
        coinMinimalDenom: "esek",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 1,
          high: 1
        }
      },
      {
        coinDenom: "dkk",
        coinMinimalDenom: "edkk",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 1,
          high: 1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ngm",
      coinMinimalDenom: "ungm",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "empowerchain-1",
    currencies: [
      {
        coinDenom: "mpwr",
        coinMinimalDenom: "umpwr",
        coinDecimals: 6
      }
    ],
    rest: "https://rest-empowerchain.ecostake.com:443",
    rpc: "https://rpc-empowerchain.ecostake.com:443",
    bech32Config: {
      bech32PrefixAccAddr: "empower",
      bech32PrefixAccPub: "empowerpub",
      bech32PrefixValAddr: "empowervaloper",
      bech32PrefixValPub: "empowervaloperpub",
      bech32PrefixConsAddr: "empowervalcons",
      bech32PrefixConsPub: "empowervalconspub"
    },
    chainName: "empowerchain",
    feeCurrencies: [
      {
        coinDenom: "mpwr",
        coinMinimalDenom: "umpwr",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "mpwr",
      coinMinimalDenom: "umpwr",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "epix_4242-1",
    currencies: [
      {
        coinDenom: "epix",
        coinMinimalDenom: "aepix",
        coinDecimals: 18
      }
    ],
    rest: "https://epix.api.silknodes.io",
    rpc: "https://epix.rpc.silknodes.io/",
    bech32Config: {
      bech32PrefixAccAddr: "epix",
      bech32PrefixAccPub: "epixpub",
      bech32PrefixValAddr: "epixvaloper",
      bech32PrefixValPub: "epixvaloperpub",
      bech32PrefixConsAddr: "epixvalcons",
      bech32PrefixConsPub: "epixvalconspub"
    },
    chainName: "epix",
    feeCurrencies: [
      {
        coinDenom: "epix",
        coinMinimalDenom: "aepix",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e12,
          average: 2e12,
          high: 3e12
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "epix",
      coinMinimalDenom: "aepix",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "ethos_7003-1",
    currencies: [
      {
        coinDenom: "RYT",
        coinMinimalDenom: "aRYT",
        coinDecimals: 18
      }
    ],
    rest: "https://ethos.provable.dev/rest/",
    rpc: "https://ethos-rpc.provable.dev:443/",
    bech32Config: {
      bech32PrefixAccAddr: "ethos",
      bech32PrefixAccPub: "ethospub",
      bech32PrefixValAddr: "ethosvaloper",
      bech32PrefixValPub: "ethosvaloperpub",
      bech32PrefixConsAddr: "ethosvalcons",
      bech32PrefixConsPub: "ethosvalconspub"
    },
    chainName: "ethos",
    feeCurrencies: [
      {
        coinDenom: "RYT",
        coinMinimalDenom: "aRYT",
        coinDecimals: 18
      }
    ],
    stakeCurrency: {
      coinDenom: "RYT",
      coinMinimalDenom: "aRYT",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "evmos_9001-2",
    currencies: [
      {
        coinDenom: "evmos",
        coinMinimalDenom: "aevmos",
        coinDecimals: 18
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/95F4898F70B1E3765715808C57E955034419200A7BB6DDECBEAA5FD3AA3DF7D5",
        coinDecimals: 6
      },
      {
        coinDenom: "neok",
        coinMinimalDenom: "erc20/0x655ecB57432CC1370f65e5dc2309588b71b473A9",
        coinDecimals: 18
      },
      {
        coinDenom: "berlin-legacy",
        coinMinimalDenom: "erc20/0x1cFc8f1FE8D5668BAFF2724547EcDbd6f013a280",
        coinDecimals: 18
      },
      {
        coinDenom: "crowdp",
        coinMinimalDenom: "erc20/0xfbf4318d24a93753f11d365a6dcf8b830e98ab0f",
        coinDecimals: 18
      }
    ],
    rest: "https://rest.bd.evmos.org:1317",
    rpc: "https://rpc.lavenderfive.com:443/evmos",
    bech32Config: {
      bech32PrefixAccAddr: "evmos",
      bech32PrefixAccPub: "evmospub",
      bech32PrefixValAddr: "evmosvaloper",
      bech32PrefixValPub: "evmosvaloperpub",
      bech32PrefixConsAddr: "evmosvalcons",
      bech32PrefixConsPub: "evmosvalconspub"
    },
    chainName: "evmos",
    feeCurrencies: [
      {
        coinDenom: "evmos",
        coinMinimalDenom: "aevmos",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e10,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "evmos",
      coinMinimalDenom: "aevmos",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "fetchhub-4",
    currencies: [
      {
        coinDenom: "fet",
        coinMinimalDenom: "afet",
        coinDecimals: 18
      },
      {
        coinDenom: "mobx",
        coinMinimalDenom: "nanomobx",
        coinDecimals: 9
      }
    ],
    rest: "https://rest-fetchhub.fetch.ai",
    rpc: "https://rpc-fetchhub.fetch.ai:443",
    bech32Config: {
      bech32PrefixAccAddr: "fetch",
      bech32PrefixAccPub: "fetchpub",
      bech32PrefixValAddr: "fetchvaloper",
      bech32PrefixValPub: "fetchvaloperpub",
      bech32PrefixConsAddr: "fetchvalcons",
      bech32PrefixConsPub: "fetchvalconspub"
    },
    chainName: "fetchhub",
    feeCurrencies: [
      {
        coinDenom: "fet",
        coinMinimalDenom: "afet",
        coinDecimals: 18,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.035
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "fet",
      coinMinimalDenom: "afet",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "finschia-2",
    currencies: [
      {
        coinDenom: "fnsa",
        coinMinimalDenom: "cony",
        coinDecimals: 6
      }
    ],
    rest: "https://finschia-api.finschia.io",
    rpc: "https://finschia-rpc.finschia.io",
    bech32Config: {
      bech32PrefixAccAddr: "link",
      bech32PrefixAccPub: "linkpub",
      bech32PrefixValAddr: "linkvaloper",
      bech32PrefixValPub: "linkvaloperpub",
      bech32PrefixConsAddr: "linkvalcons",
      bech32PrefixConsPub: "linkvalconspub"
    },
    chainName: "finschia",
    feeCurrencies: [
      {
        coinDenom: "fnsa",
        coinMinimalDenom: "cony",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.015,
          average: 0.015,
          high: 0.015
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "fnsa",
      coinMinimalDenom: "cony",
      coinDecimals: 6
    },
    bip44: {
      coinType: 438
    }
  },
  {
    chainId: "colosseum-1",
    currencies: [
      {
        coinDenom: "fct",
        coinMinimalDenom: "ufct",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd-mainnet.firmachain.dev:1317",
    rpc: "https://lcd-mainnet.firmachain.dev:26657",
    bech32Config: {
      bech32PrefixAccAddr: "firma",
      bech32PrefixAccPub: "firmapub",
      bech32PrefixValAddr: "firmavaloper",
      bech32PrefixValPub: "firmavaloperpub",
      bech32PrefixConsAddr: "firmavalcons",
      bech32PrefixConsPub: "firmavalconspub"
    },
    chainName: "firmachain",
    feeCurrencies: [
      {
        coinDenom: "fct",
        coinMinimalDenom: "ufct",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.1,
          average: 0.15,
          high: 0.2
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "fct",
      coinMinimalDenom: "ufct",
      coinDecimals: 6
    },
    bip44: {
      coinType: 7777777
    }
  },
  {
    chainId: "furya-1",
    currencies: [
      {
        coinDenom: "fury",
        coinMinimalDenom: "ufury",
        coinDecimals: 6
      }
    ],
    rest: "https://furya.api.nodeshub.online",
    rpc: "https://furya-rpc.synergynodes.com",
    bech32Config: {
      bech32PrefixAccAddr: "furya",
      bech32PrefixAccPub: "furyapub",
      bech32PrefixValAddr: "furyavaloper",
      bech32PrefixValPub: "furyavaloperpub",
      bech32PrefixConsAddr: "furyavalcons",
      bech32PrefixConsPub: "furyavalconspub"
    },
    chainName: "furya",
    feeCurrencies: [
      {
        coinDenom: "fury",
        coinMinimalDenom: "ufury",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.1,
          average: 0.25,
          high: 0.5
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "fury",
      coinMinimalDenom: "ufury",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "fxcore",
    currencies: [
      {
        coinDenom: "WFX",
        coinMinimalDenom: "FX",
        coinDecimals: 18
      },
      {
        coinDenom: "PUNDIX",
        coinMinimalDenom: "eth0x0FD10b9899882a6f2fcb5c371E17e70FdEe00C38",
        coinDecimals: 18
      }
    ],
    rest: "https://fx-rest.functionx.io",
    rpc: "https://fx-json.functionx.io",
    bech32Config: {
      bech32PrefixAccAddr: "fx",
      bech32PrefixAccPub: "fxpub",
      bech32PrefixValAddr: "fxvaloper",
      bech32PrefixValPub: "fxvaloperpub",
      bech32PrefixConsAddr: "fxvalcons",
      bech32PrefixConsPub: "fxvalconspub"
    },
    chainName: "fxcore",
    feeCurrencies: [
      {
        coinDenom: "WFX",
        coinMinimalDenom: "FX",
        coinDecimals: 18,
        gasPriceStep: {
          low: 4e12,
          average: 42e11,
          high: 5e12
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "WFX",
      coinMinimalDenom: "FX",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "wormchain",
    currencies: [
      {
        coinDenom: "test",
        coinMinimalDenom: "utest",
        coinDecimals: 6
      },
      {
        coinDenom: "worm",
        coinMinimalDenom: "uworm",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/46YEtoSN1AcwgGSRoWruoS6bnVh8XpMp5aQTpKohCJYh/8",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/46YEtoSN1AcwgGSRoWruoS6bnVh8XpMp5aQTpKohCJYh",
        coinDecimals: 8
      },
      {
        coinDenom: "wormhole/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp/8",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp",
        coinDecimals: 8
      },
      {
        coinDenom: "wormhole/5TSQTEhJ5Q6r1YqCmCxTRSPiV2pGx5rZUQf6g2XH4e1b/8",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5TSQTEhJ5Q6r1YqCmCxTRSPiV2pGx5rZUQf6g2XH4e1b",
        coinDecimals: 8
      },
      {
        coinDenom: "wormhole/5wS2fGojbL9RhGEAeQBdkHPUAciYDxjDTMYvdf9aDn2r/8",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5wS2fGojbL9RhGEAeQBdkHPUAciYDxjDTMYvdf9aDn2r",
        coinDecimals: 8
      },
      {
        coinDenom: "wormhole/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi/6",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA/8",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA",
        coinDecimals: 8
      },
      {
        coinDenom: "wormhole/95mnwzvJZJ3fKz77xfGN2nR5to9pZmH8YNvaxgLgw5AR/5",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/95mnwzvJZJ3fKz77xfGN2nR5to9pZmH8YNvaxgLgw5AR",
        coinDecimals: 5
      },
      {
        coinDenom: "wormhole/BGkuAcga2WArUghF8L6kt6uCAhAzrxmn1QcbQqi5r5bd/8",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/BGkuAcga2WArUghF8L6kt6uCAhAzrxmn1QcbQqi5r5bd",
        coinDecimals: 8
      },
      {
        coinDenom: "wormhole/BhqTYfQogyt7jX7cx7x8uHEQP1x9fdtdBZtK4Swghgpw/8",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/BhqTYfQogyt7jX7cx7x8uHEQP1x9fdtdBZtK4Swghgpw",
        coinDecimals: 8
      },
      {
        coinDenom: "wormhole/EKiMEqDnPKokFGcSXDvGMk6Gt1BJ6BC7BDZzTmEpWLH1/8",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/EKiMEqDnPKokFGcSXDvGMk6Gt1BJ6BC7BDZzTmEpWLH1",
        coinDecimals: 8
      },
      {
        coinDenom: "wormhole/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt/6",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/5ZLmAZpcbaP4EGyihSmpfwryzDr84h51tboV392BCjW4/6",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/5ZLmAZpcbaP4EGyihSmpfwryzDr84h51tboV392BCjW4",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/B8ohBnfisop27exk2gtNABJyYjLwQA7ogrp5uNzvZCoy/6",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/B8ohBnfisop27exk2gtNABJyYjLwQA7ogrp5uNzvZCoy",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3/6",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst/5",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst",
        coinDecimals: 5
      },
      {
        coinDenom: "w",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/2Wb6ueMFc9WLc2eyYVha6qnwHKbwzUXdooXsg6XXVvos",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP/6",
        coinMinimalDenom: "factory/wormhole14ejqjyq8um4p3xfqj74yld5waqljf88fz25yxnma0cngspxe3les00fpjx/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP",
        coinDecimals: 6
      }
    ],
    rest: "https://tncnt-eu-wormchain-main-01.rpc.p2p.world/lcd/",
    rpc: "https://tncnt-eu-wormchain-main-01.rpc.p2p.world/",
    bech32Config: {
      bech32PrefixAccAddr: "wormhole",
      bech32PrefixAccPub: "wormholepub",
      bech32PrefixValAddr: "wormholevaloper",
      bech32PrefixValPub: "wormholevaloperpub",
      bech32PrefixConsAddr: "wormholevalcons",
      bech32PrefixConsPub: "wormholevalconspub"
    },
    chainName: "gateway",
    feeCurrencies: [
      {
        coinDenom: "test",
        coinMinimalDenom: "utest",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "test",
      coinMinimalDenom: "utest",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "genesis_29-2",
    currencies: [
      {
        coinDenom: "l1",
        coinMinimalDenom: "el1",
        coinDecimals: 18
      }
    ],
    rest: "https://api.genesisl1.org",
    rpc: "https://26657.genesisl1.org",
    bech32Config: {
      bech32PrefixAccAddr: "genesis",
      bech32PrefixAccPub: "genesispub",
      bech32PrefixValAddr: "genesisvaloper",
      bech32PrefixValPub: "genesisvaloperpub",
      bech32PrefixConsAddr: "genesisvalcons",
      bech32PrefixConsPub: "genesisvalconspub"
    },
    chainName: "genesisl1",
    feeCurrencies: [
      {
        coinDenom: "l1",
        coinMinimalDenom: "el1",
        coinDecimals: 18,
        gasPriceStep: {
          low: 51e9,
          average: 52e9,
          high: 53e9
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "l1",
      coinMinimalDenom: "el1",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "gitopia",
    currencies: [
      {
        coinDenom: "LORE",
        coinMinimalDenom: "ulore",
        coinDecimals: 6
      }
    ],
    rest: "https://gitopia-api.polkachu.com:443",
    rpc: "https://gitopia-rpc.polkachu.com:443",
    bech32Config: {
      bech32PrefixAccAddr: "gitopia",
      bech32PrefixAccPub: "gitopiapub",
      bech32PrefixValAddr: "gitopiavaloper",
      bech32PrefixValPub: "gitopiavaloperpub",
      bech32PrefixConsAddr: "gitopiavalcons",
      bech32PrefixConsPub: "gitopiavalconspub"
    },
    chainName: "gitopia",
    feeCurrencies: [
      {
        coinDenom: "LORE",
        coinMinimalDenom: "ulore",
        coinDecimals: 6,
        gasPriceStep: {
          low: 12e-4,
          average: 16e-4,
          high: 24e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "LORE",
      coinMinimalDenom: "ulore",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "govgen-1",
    currencies: [
      {
        coinDenom: "govgen",
        coinMinimalDenom: "ugovgen",
        coinDecimals: 6
      }
    ],
    rest: "https://api.govgen.io/",
    rpc: "https://rpc.govgen.io:443",
    bech32Config: {
      bech32PrefixAccAddr: "govgen",
      bech32PrefixAccPub: "govgenpub",
      bech32PrefixValAddr: "govgenvaloper",
      bech32PrefixValPub: "govgenvaloperpub",
      bech32PrefixConsAddr: "govgenvalcons",
      bech32PrefixConsPub: "govgenvalconspub"
    },
    chainName: "govgen",
    feeCurrencies: [
      {
        coinDenom: "govgen",
        coinMinimalDenom: "ugovgen",
        coinDecimals: 6,
        gasPriceStep: {
          low: 6e-3,
          average: 6e-3,
          high: 9e-3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "govgen",
      coinMinimalDenom: "ugovgen",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "gravity-bridge-3",
    currencies: [
      {
        coinDenom: "graviton",
        coinMinimalDenom: "ugraviton",
        coinDecimals: 6
      },
      {
        coinDenom: "pstake",
        coinMinimalDenom: "gravity0xfB5c6815cA3AC72Ce9F5006869AE67f18bF77006",
        coinDecimals: 18
      },
      {
        coinDenom: "gweth",
        coinMinimalDenom: "gravity0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        coinDecimals: 18
      },
      {
        coinDenom: "gusdc",
        coinMinimalDenom: "gravity0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        coinDecimals: 6
      },
      {
        coinDenom: "gusdt",
        coinMinimalDenom: "gravity0xdAC17F958D2ee523a2206206994597C13D831ec7",
        coinDecimals: 6
      },
      {
        coinDenom: "gwbtc",
        coinMinimalDenom: "gravity0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
        coinDecimals: 8
      },
      {
        coinDenom: "gdai",
        coinMinimalDenom: "gravity0x6B175474E89094C44Da98b954EedeAC495271d0F",
        coinDecimals: 18
      },
      {
        coinDenom: "gsdai",
        coinMinimalDenom: "gravity0x83F20F44975D03b1b09e64809B757c47f942BEeA",
        coinDecimals: 18
      },
      {
        coinDenom: "gocc",
        coinMinimalDenom: "gravity0x2F109021aFe75B949429fe30523Ee7C0D5B27207",
        coinDecimals: 18
      },
      {
        coinDenom: "page",
        coinMinimalDenom: "gravity0x60e683C6514Edd5F758A55b6f393BeBBAfaA8d5e",
        coinDecimals: 8
      },
      {
        coinDenom: "gpaxg",
        coinMinimalDenom: "gravity0x45804880De22913dAFE09f4980848ECE6EcbAf78",
        coinDecimals: 18
      }
    ],
    rest: "https://gravitychain.io:1317",
    rpc: "https://gravitychain.io:26657",
    bech32Config: {
      bech32PrefixAccAddr: "gravity",
      bech32PrefixAccPub: "gravitypub",
      bech32PrefixValAddr: "gravityvaloper",
      bech32PrefixValPub: "gravityvaloperpub",
      bech32PrefixConsAddr: "gravityvalcons",
      bech32PrefixConsPub: "gravityvalconspub"
    },
    chainName: "gravitybridge",
    feeCurrencies: [
      {
        coinDenom: "graviton",
        coinMinimalDenom: "ugraviton",
        coinDecimals: 6
      },
      {
        coinDenom: "gusdc",
        coinMinimalDenom: "gravity0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
        coinDecimals: 6,
        gasPriceStep: {
          low: 2e-4,
          average: 5e-4,
          high: 8e-4
        }
      },
      {
        coinDenom: "gusdt",
        coinMinimalDenom: "gravity0xdAC17F958D2ee523a2206206994597C13D831ec7",
        coinDecimals: 6,
        gasPriceStep: {
          low: 2e-4,
          average: 5e-4,
          high: 8e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "graviton",
      coinMinimalDenom: "ugraviton",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "haqq_11235-1",
    currencies: [
      {
        coinDenom: "ISLM",
        coinMinimalDenom: "aISLM",
        coinDecimals: 18
      },
      {
        coinDenom: "DEEN",
        coinMinimalDenom: "erc20/0x4FEBDDe47Ab9a76200e57eFcC80b212a07b3e6cE",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.cosmos.haqq.network",
    rpc: "https://rpc.tm.haqq.network",
    bech32Config: {
      bech32PrefixAccAddr: "haqq",
      bech32PrefixAccPub: "haqqpub",
      bech32PrefixValAddr: "haqqvaloper",
      bech32PrefixValPub: "haqqvaloperpub",
      bech32PrefixConsAddr: "haqqvalcons",
      bech32PrefixConsPub: "haqqvalconspub"
    },
    chainName: "haqq",
    feeCurrencies: [
      {
        coinDenom: "ISLM",
        coinMinimalDenom: "aISLM",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e10,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ISLM",
      coinMinimalDenom: "aISLM",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "helichain",
    currencies: [
      {
        coinDenom: "heli",
        coinMinimalDenom: "uheli",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.helichain.com/",
    rpc: "https://rpc.helichain.com/",
    bech32Config: {
      bech32PrefixAccAddr: "heli",
      bech32PrefixAccPub: "helipub",
      bech32PrefixValAddr: "helivaloper",
      bech32PrefixValPub: "helivaloperpub",
      bech32PrefixConsAddr: "helivalcons",
      bech32PrefixConsPub: "helivalconspub"
    },
    chainName: "heli",
    feeCurrencies: [
      {
        coinDenom: "heli",
        coinMinimalDenom: "uheli",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-3,
          average: 2e-3,
          high: 25e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "heli",
      coinMinimalDenom: "uheli",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "highbury_710-1",
    currencies: [
      {
        coinDenom: "fury",
        coinMinimalDenom: "ufury",
        coinDecimals: 6
      },
      {
        coinDenom: "JINX",
        coinMinimalDenom: "jinx",
        coinDecimals: 6
      },
      {
        coinDenom: "JINXY",
        coinMinimalDenom: "jinxy",
        coinDecimals: 6
      }
    ],
    rest: "https://api-mainnet.furya.io/",
    rpc: "https://gridiron.furya.io",
    bech32Config: {
      bech32PrefixAccAddr: "fury",
      bech32PrefixAccPub: "furypub",
      bech32PrefixValAddr: "furyvaloper",
      bech32PrefixValPub: "furyvaloperpub",
      bech32PrefixConsAddr: "furyvalcons",
      bech32PrefixConsPub: "furyvalconspub"
    },
    chainName: "highbury",
    feeCurrencies: [
      {
        coinDenom: "fury",
        coinMinimalDenom: "ufury",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.05,
          average: 0.1,
          high: 0.25
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "fury",
      coinMinimalDenom: "ufury",
      coinDecimals: 6
    },
    bip44: {
      coinType: 459
    }
  },
  {
    chainId: "humans_1089-1",
    currencies: [
      {
        coinDenom: "heart",
        coinMinimalDenom: "aheart",
        coinDecimals: 18
      }
    ],
    rest: "https://api.humans.nodestake.top",
    rpc: "https://rpc.humans.nodestake.top",
    bech32Config: {
      bech32PrefixAccAddr: "human",
      bech32PrefixAccPub: "humanpub",
      bech32PrefixValAddr: "humanvaloper",
      bech32PrefixValPub: "humanvaloperpub",
      bech32PrefixConsAddr: "humanvalcons",
      bech32PrefixConsPub: "humanvalconspub"
    },
    chainName: "humans",
    feeCurrencies: [
      {
        coinDenom: "heart",
        coinMinimalDenom: "aheart",
        coinDecimals: 18,
        gasPriceStep: {
          low: 8e10,
          average: 1e11,
          high: 16e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "heart",
      coinMinimalDenom: "aheart",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "ixo-5",
    currencies: [
      {
        coinDenom: "ixo",
        coinMinimalDenom: "uixo",
        coinDecimals: 6
      }
    ],
    rest: "https://proxies.sifchain.finance/api/impacthub-3/rest",
    rpc: "https://proxies.sifchain.finance/api/impacthub-3/rpc",
    bech32Config: {
      bech32PrefixAccAddr: "ixo",
      bech32PrefixAccPub: "ixopub",
      bech32PrefixValAddr: "ixovaloper",
      bech32PrefixValPub: "ixovaloperpub",
      bech32PrefixConsAddr: "ixovalcons",
      bech32PrefixConsPub: "ixovalconspub"
    },
    chainName: "impacthub",
    feeCurrencies: [
      {
        coinDenom: "ixo",
        coinMinimalDenom: "uixo",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ixo",
      coinMinimalDenom: "uixo",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "injective-1",
    currencies: [
      {
        coinDenom: "INJ",
        coinMinimalDenom: "inj",
        coinDecimals: 18
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/4ABBEF4C8926DDDB320AE5188CFD63267ABBCEFC0583E4AE05D6E5AA2401DDAB",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "peggy0xdAC17F958D2ee523a2206206994597C13D831ec7",
        coinDecimals: 6
      },
      {
        coinDenom: "ampINJ",
        coinMinimalDenom: "factory/inj1cdwt8g7nxgtg2k4fn8sj363mh9ahkw2qt0vrnc/ampINJ",
        coinDecimals: 6
      },
      {
        coinDenom: "autism",
        coinMinimalDenom: "factory/inj14lf8xm6fcvlggpa7guxzjqwjmtr24gnvf56hvz/autism",
        coinDecimals: 6
      },
      {
        coinDenom: "bINJ",
        coinMinimalDenom: "factory/inj1dxp690rd86xltejgfq2fa7f2nxtgmm5cer3hvu/bINJ",
        coinDecimals: 18
      },
      {
        coinDenom: "NINJA",
        coinMinimalDenom: "factory/inj1xtel2knkt8hmc9dnzpjz6kdmacgcfmlv5f308w/ninja",
        coinDecimals: 6
      },
      {
        coinDenom: "WGMI",
        coinMinimalDenom: "factory/inj1rmjzj9fn47kdmfk4f3z39qr6czexxe0yjyc546/WGMI",
        coinDecimals: 6
      },
      {
        coinDenom: "WOSMO",
        coinMinimalDenom: "ibc/DD648F5D3CDA56D0D8D8820CF703D246B9FC4007725D8B38D23A21FF1A1477E3",
        coinDecimals: 6
      },
      {
        coinDenom: "glto",
        coinMinimalDenom: "peggy0xd73175f9eb15eee81745d367ae59309Ca2ceb5e2",
        coinDecimals: 6
      },
      {
        coinDenom: "hava",
        coinMinimalDenom: "factory/inj1h0ypsdtjfcjynqu3m75z2zwwz5mmrj8rtk2g52/uhava",
        coinDecimals: 6
      },
      {
        coinDenom: "BADKID",
        coinMinimalDenom: "ibc/A0C5AD197FECAF6636F589071338DC7ECD6B0809CD3A5AB131EAAA5395E7E5E8",
        coinDecimals: 6
      },
      {
        coinDenom: "NINPO",
        coinMinimalDenom: "inj1sudjgsyhufqu95yp7rqad3g78ws8g6htf32h88",
        coinDecimals: 6
      },
      {
        coinDenom: "JUDO",
        coinMinimalDenom: "inj16ukv8g2jcmml7gykxn5ws8ykhxjkugl4zhft5h",
        coinDecimals: 6
      },
      {
        coinDenom: "beast",
        coinMinimalDenom: "peggy0xA4426666addBE8c4985377d36683D17FB40c31Be",
        coinDecimals: 6
      },
      {
        coinDenom: "astro",
        coinMinimalDenom: "ibc/063F4461F7317CFF10F50AB044E44932D22AAD84FA7107082744946E6DB7B7A8",
        coinDecimals: 6
      },
      {
        coinDenom: "nINJ",
        coinMinimalDenom: "inj1rmzufd7h09sqfrre5dtvu5d09ta7c0t4jzkr2f",
        coinDecimals: 18
      },
      {
        coinDenom: "nATOM",
        coinMinimalDenom: "inj16jf4qkcarp3lan4wl2qkrelf4kduvvujwg0780",
        coinDecimals: 6
      },
      {
        coinDenom: "nWETH",
        coinMinimalDenom: "inj1kehk5nvreklhylx22p3x0yjydfsz9fv3fvg5xt",
        coinDecimals: 18
      },
      {
        coinDenom: "nUSDT",
        coinMinimalDenom: "inj1cy9hes20vww2yr6crvs75gxy5hpycya2hmjg9s",
        coinDecimals: 6
      },
      {
        coinDenom: "nTIA",
        coinMinimalDenom: "inj1fzquxxxam59z6fzewy2hvvreeh3m04x83zg4vv",
        coinDecimals: 6
      },
      {
        coinDenom: "NBZ",
        coinMinimalDenom: "ibc/1011E4D6D4800DA9B8F21D7C207C0B0C18E54E614A8576037F066B775210709D",
        coinDecimals: 6
      },
      {
        coinDenom: "Talis",
        coinMinimalDenom: "factory/inj1maeyvxfamtn8lfyxpjca8kuvauuf2qeu6gtxm3/Talis",
        coinDecimals: 6
      },
      {
        coinDenom: "xTalis",
        coinMinimalDenom: "factory/inj1maeyvxfamtn8lfyxpjca8kuvauuf2qeu6gtxm3/xTalis",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/2CBC2EA121AE42563B08028466F37B600F2D7D4282342DE938283CC3FB2BC00E",
        coinDecimals: 6
      },
      {
        coinDenom: "SYN",
        coinMinimalDenom: "factory/inj1a6xdezq7a94qwamec6n6cnup02nvewvjtz6h6e/SYN",
        coinDecimals: 6
      },
      {
        coinDenom: "ashSYN",
        coinMinimalDenom: "factory/inj1ej2f3lmpxj4djsmmuxvnfuvplrut7zmwrq7zj8/syn.ash",
        coinDecimals: 6
      },
      {
        coinDenom: "COSMO",
        coinMinimalDenom: "factory/inj1je6n5sr4qtx2lhpldfxndntmgls9hf38ncmcez/COSMO",
        coinDecimals: 6
      },
      {
        coinDenom: "XTRUMP",
        coinMinimalDenom: "ibc/5339B0D20986A7C20C2548ED9D6B8DE47BB64E03ABFD051B7792E713036EA20C",
        coinDecimals: 6
      },
      {
        coinDenom: "DRUGS",
        coinMinimalDenom: "cw20:inj19vy83ne9tzta2yqynj8yg7dq9ghca6yqn9hyej",
        coinDecimals: 18
      },
      {
        coinDenom: "DRUGS",
        coinMinimalDenom: "factory/inj178zy7myyxewek7ka7v9hru8ycpvfnen6xeps89/DRUGS",
        coinDecimals: 6
      }
    ],
    rest: "https://6d0ff611-9009-4bd1-a7a7-acec7c70d454.injective-1.mesa-rest.newmetric.xyz",
    rpc: "https://6d0ff611-9009-4bd1-a7a7-acec7c70d454.injective-1.mesa-rpc.newmetric.xyz",
    bech32Config: {
      bech32PrefixAccAddr: "inj",
      bech32PrefixAccPub: "injpub",
      bech32PrefixValAddr: "injvaloper",
      bech32PrefixValPub: "injvaloperpub",
      bech32PrefixConsAddr: "injvalcons",
      bech32PrefixConsPub: "injvalconspub"
    },
    chainName: "injective",
    feeCurrencies: [
      {
        coinDenom: "INJ",
        coinMinimalDenom: "inj",
        coinDecimals: 18,
        gasPriceStep: {
          low: 5e8,
          average: 7e8,
          high: 9e8
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "INJ",
      coinMinimalDenom: "inj",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "int3face-1",
    currencies: [
      {
        coinDenom: "int3",
        coinMinimalDenom: "uint3",
        coinDecimals: 6
      },
      {
        coinDenom: "btc",
        coinMinimalDenom: "factory/int31zlefkpe3g0vvm9a4h0jf9000lmqutlh99h7fsd/bitcoin-btc",
        coinDecimals: 8
      },
      {
        coinDenom: "bch",
        coinMinimalDenom: "factory/int31zlefkpe3g0vvm9a4h0jf9000lmqutlh99h7fsd/bitcoin-cash-bch",
        coinDecimals: 8
      },
      {
        coinDenom: "doge",
        coinMinimalDenom: "factory/int31zlefkpe3g0vvm9a4h0jf9000lmqutlh99h7fsd/dogecoin-doge",
        coinDecimals: 8
      },
      {
        coinDenom: "ltc",
        coinMinimalDenom: "factory/int31zlefkpe3g0vvm9a4h0jf9000lmqutlh99h7fsd/litecoin-ltc",
        coinDecimals: 8
      }
    ],
    rest: "https://api.mainnet.int3face.zone",
    rpc: "https://rpc.mainnet.int3face.zone",
    bech32Config: {
      bech32PrefixAccAddr: "int3",
      bech32PrefixAccPub: "int3pub",
      bech32PrefixValAddr: "int3valoper",
      bech32PrefixValPub: "int3valoperpub",
      bech32PrefixConsAddr: "int3valcons",
      bech32PrefixConsPub: "int3valconspub"
    },
    chainName: "int3face",
    feeCurrencies: [
      {
        coinDenom: "int3",
        coinMinimalDenom: "uint3",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "int3",
      coinMinimalDenom: "uint3",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "irishub-1",
    currencies: [
      {
        coinDenom: "iris",
        coinMinimalDenom: "uiris",
        coinDecimals: 6
      }
    ],
    rest: "https://api-irisnet-ia.cosmosia.notional.ventures/",
    rpc: "https://rpc-irisnet-ia.cosmosia.notional.ventures/",
    bech32Config: {
      bech32PrefixAccAddr: "iaa",
      bech32PrefixAccPub: "iaapub",
      bech32PrefixValAddr: "iaavaloper",
      bech32PrefixValPub: "iaavaloperpub",
      bech32PrefixConsAddr: "iaavalcons",
      bech32PrefixConsPub: "iaavalconspub"
    },
    chainName: "irisnet",
    feeCurrencies: [
      {
        coinDenom: "iris",
        coinMinimalDenom: "uiris",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.2,
          average: 0.3,
          high: 0.4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "iris",
      coinMinimalDenom: "uiris",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "jackal-1",
    currencies: [
      {
        coinDenom: "jkl",
        coinMinimalDenom: "ujkl",
        coinDecimals: 6
      }
    ],
    rest: "https://api.jackalprotocol.com",
    rpc: "https://rpc.jackalprotocol.com",
    bech32Config: {
      bech32PrefixAccAddr: "jkl",
      bech32PrefixAccPub: "jklpub",
      bech32PrefixValAddr: "jklvaloper",
      bech32PrefixValPub: "jklvaloperpub",
      bech32PrefixConsAddr: "jklvalcons",
      bech32PrefixConsPub: "jklvalconspub"
    },
    chainName: "jackal",
    feeCurrencies: [
      {
        coinDenom: "jkl",
        coinMinimalDenom: "ujkl",
        coinDecimals: 6,
        gasPriceStep: {
          low: 2e-3,
          average: 2e-3,
          high: 0.02
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "jkl",
      coinMinimalDenom: "ujkl",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "joltify_1729-1",
    currencies: [
      {
        coinDenom: "jolt",
        coinMinimalDenom: "ujolt",
        coinDecimals: 6
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/9117A26BA81E29FA4F78F57DC2BD90CD3D26848101BA880445F119B22A1E254E",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/65D0BEC6DAD96C7F5043D1E54E54B6BB5D5B3AEC3FF6CEBB75B9E059F3580EA3",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.joltify.io/",
    rpc: "https://rpc.joltify.io",
    bech32Config: {
      bech32PrefixAccAddr: "jolt",
      bech32PrefixAccPub: "joltpub",
      bech32PrefixValAddr: "joltvaloper",
      bech32PrefixValPub: "joltvaloperpub",
      bech32PrefixConsAddr: "joltvalcons",
      bech32PrefixConsPub: "joltvalconspub"
    },
    chainName: "joltify",
    feeCurrencies: [
      {
        coinDenom: "jolt",
        coinMinimalDenom: "ujolt",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "jolt",
      coinMinimalDenom: "ujolt",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "juno-1",
    currencies: [
      {
        coinDenom: "juno",
        coinMinimalDenom: "ujuno",
        coinDecimals: 6
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/C4CFF46FD6DE35CA4CF4CE031E643C8FDC9BA4B99AE598E9B0ED98FE3A2319F9",
        coinDecimals: 6
      },
      {
        coinDenom: "neta",
        coinMinimalDenom: "cw20:juno168ctmpyppk90d34p3jjy658zf5a5l3w8wk35wht6ccqj4mr0yv8s4j5awr",
        coinDecimals: 6
      },
      {
        coinDenom: "marble",
        coinMinimalDenom: "cw20:juno1g2g7ucurum66d42g8k5twk34yegdq8c82858gz0tq2fc75zy7khssgnhjl",
        coinDecimals: 3
      },
      {
        coinDenom: "hope",
        coinMinimalDenom: "cw20:juno1re3x67ppxap48ygndmrc7har2cnc7tcxtm9nplcas4v0gc3wnmvs3s807z",
        coinDecimals: 6
      },
      {
        coinDenom: "rac",
        coinMinimalDenom: "cw20:juno1r4pzw8f9z0sypct5l9j906d47z998ulwvhvqe5xdwgy8wf84583sxwh0pa",
        coinDecimals: 6
      },
      {
        coinDenom: "block",
        coinMinimalDenom: "cw20:juno1y9rf7ql6ffwkv02hsgd4yruz23pn4w97p75e2slsnkm0mnamhzysvqnxaq",
        coinDecimals: 6
      },
      {
        coinDenom: "cw20:juno1tdjwrqmnztn2j3sj2ln9xnyps5hs48q3ddwjrz7jpv6mskappjys5czd49",
        coinMinimalDenom: "cw20:juno1tdjwrqmnztn2j3sj2ln9xnyps5hs48q3ddwjrz7jpv6mskappjys5czd49",
        coinDecimals: 0
      },
      {
        coinDenom: "raw",
        coinMinimalDenom: "cw20:juno15u3dt79t6sxxa3x3kpkhzsy56edaa5a66wvt3kxmukqjz2sx0hes5sn38g",
        coinDecimals: 6
      },
      {
        coinDenom: "asvt",
        coinMinimalDenom: "cw20:juno17wzaxtfdw5em7lc94yed4ylgjme63eh73lm3lutp2rhcxttyvpwsypjm4w",
        coinDecimals: 6
      },
      {
        coinDenom: "hns",
        coinMinimalDenom: "cw20:juno1ur4jx0sxchdevahep7fwq28yk4tqsrhshdtylz46yka3uf6kky5qllqp4k",
        coinDecimals: 6
      },
      {
        coinDenom: "joe",
        coinMinimalDenom: "cw20:juno1n7n7d5088qlzlj37e9mgmkhx6dfgtvt02hqxq66lcap4dxnzdhwqfmgng3",
        coinDecimals: 6
      },
      {
        coinDenom: "dla",
        coinMinimalDenom: "cw20:juno1sfwye65qxcfsc837gu5qcprcz7w49gkv3wnat04764ld76hy3arqs779tr",
        coinDecimals: 6
      },
      {
        coinDenom: "glto",
        coinMinimalDenom: "cw20:juno1j0a9ymgngasfn3l5me8qpd53l5zlm9wurfdk7r65s5mg6tkxal3qpgf5se",
        coinDecimals: 6
      },
      {
        coinDenom: "gkey",
        coinMinimalDenom: "cw20:juno1gz8cf86zr4vw9cjcyyv432vgdaecvr9n254d3uwwkx9rermekddsxzageh",
        coinDecimals: 6
      },
      {
        coinDenom: "hole",
        coinMinimalDenom: "cw20:juno1t46z6hg8vvsena7sue0vg6w85ljar3cundplkre9sz0skeqkap9sxyyy6m",
        coinDecimals: 6
      },
      {
        coinDenom: "sejuno",
        coinMinimalDenom: "cw20:juno1dd0k0um5rqncfueza62w9sentdfh3ec4nw4aq4lk5hkjl63vljqscth9gv",
        coinDecimals: 6
      },
      {
        coinDenom: "bjuno",
        coinMinimalDenom: "cw20:juno1wwnhkagvcd3tjz6f8vsdsw5plqnw8qy2aj3rrhqr2axvktzv9q2qz8jxn3",
        coinDecimals: 6
      },
      {
        coinDenom: "solar",
        coinMinimalDenom: "cw20:juno159q8t5g02744lxq8lfmcn6f78qqulq9wn3y9w7lxjgkz4e0a6kvsfvapse",
        coinDecimals: 6
      },
      {
        coinDenom: "seasy",
        coinMinimalDenom: "cw20:juno19rqljkh95gh40s7qdx40ksx3zq5tm4qsmsrdz9smw668x9zdr3lqtg33mf",
        coinDecimals: 6
      },
      {
        coinDenom: "muse",
        coinMinimalDenom: "cw20:juno1p8x807f6h222ur0vssqy3qk6mcpa40gw2pchquz5atl935t7kvyq894ne3",
        coinDecimals: 6
      },
      {
        coinDenom: "loop",
        coinMinimalDenom: "cw20:juno1qsrercqegvs4ye0yqg93knv73ye5dc3prqwd6jcdcuj8ggp6w0us66deup",
        coinDecimals: 6
      },
      {
        coinDenom: "fury",
        coinMinimalDenom: "cw20:juno1cltgm8v842gu54srmejewghnd6uqa26lzkpa635wzra9m9xuudkqa2gtcz",
        coinDecimals: 6
      },
      {
        coinDenom: "phmn",
        coinMinimalDenom: "cw20:juno1rws84uz7969aaa7pej303udhlkt3j9ca0l3egpcae98jwak9quzq8szn2l",
        coinDecimals: 6
      },
      {
        coinDenom: "hopers",
        coinMinimalDenom: "cw20:juno1u45shlp0q4gcckvsj06ss4xuvsu0z24a0d0vr9ce6r24pht4e5xq7q995n",
        coinDecimals: 6
      },
      {
        coinDenom: "red",
        coinMinimalDenom: "cw20:juno1g647t78y2ulqlm3lss8rs3d0spzd0teuwhdvnqn92tr79yltk9dq2h24za",
        coinDecimals: 6
      },
      {
        coinDenom: "blue",
        coinMinimalDenom: "cw20:juno14q8kk464fafql2fwmlsgvgcdl6h2csqpzv4hr025fmcvgjahpess32k0j7",
        coinDecimals: 6
      },
      {
        coinDenom: "wynd",
        coinMinimalDenom: "cw20:juno1mkw83sv6c7sjdvsaplrzc8yaes9l42p4mhy0ssuxjnyzl87c9eps7ce3m9",
        coinDecimals: 6
      },
      {
        coinDenom: "banana",
        coinMinimalDenom: "cw20:juno1s2dp05rspeuzzpzyzdchk262szehrtfpz847uvf98cnwh53ulx4qg20qwj",
        coinDecimals: 6
      },
      {
        coinDenom: "nride",
        coinMinimalDenom: "cw20:juno1qmlchtmjpvu0cr7u0tad2pq8838h6farrrjzp39eqa9xswg7teussrswlq",
        coinDecimals: 6
      },
      {
        coinDenom: "sgnl",
        coinMinimalDenom: "cw20:juno14lycavan8gvpjn97aapzvwmsj8kyrvf644p05r0hu79namyj3ens87650k",
        coinDecimals: 6
      },
      {
        coinDenom: "jape",
        coinMinimalDenom: "cw20:juno1zkwveux7y6fmsr88atf3cyffx96p0c96qr8tgcsj7vfnhx7sal3s3zu3ps",
        coinDecimals: 6
      },
      {
        coinDenom: "catom",
        coinMinimalDenom: "cw20:juno12wxyvtqe76x2a5jj6ckp2hfq8v32m6rvyyxwwufl2tksqvkt7whqczv6pa",
        coinDecimals: 6
      },
      {
        coinDenom: "howl",
        coinMinimalDenom: "cw20:juno1g0wuyu2f49ncf94r65278puxzclf5arse9f3kvffxyv4se4vgdmsk4dvqz",
        coinDecimals: 6
      },
      {
        coinDenom: "fox",
        coinMinimalDenom: "cw20:juno1u8cr3hcjvfkzxcaacv9q75uw9hwjmn8pucc93pmy6yvkzz79kh3qncca8x",
        coinDecimals: 6
      },
      {
        coinDenom: "grdn",
        coinMinimalDenom: "cw20:juno1xekkh27punj0uxruv3gvuydyt856fax0nu750xns99t2qcxp7xmsqwhfma",
        coinDecimals: 6
      },
      {
        coinDenom: "mnpu",
        coinMinimalDenom: "cw20:juno166heaxlyntd33a5euh4rrz26svhean4klzw594esmd02l4atan6sazy2my",
        coinDecimals: 6
      },
      {
        coinDenom: "kleo",
        coinMinimalDenom: "cw20:juno10gthz5ufgrpuk5cscve2f0hjp56wgp90psqxcrqlg4m9mcu9dh8q4864xy",
        coinDecimals: 6
      },
      {
        coinDenom: "sikoba",
        coinMinimalDenom: "cw20:juno1qqwf3lkfjhp77yja7gmg3y95pda0e5xctqrdhf3wvwdd79flagvqfgrgxp",
        coinDecimals: 6
      },
      {
        coinDenom: "shibac",
        coinMinimalDenom: "cw20:juno1x5qt47rw84c4k6xvvywtrd40p8gxjt8wnmlahlqg07qevah3f8lqwxfs7z",
        coinDecimals: 6
      },
      {
        coinDenom: "clst",
        coinMinimalDenom: "cw20:juno1ngww7zxak55fql42wmyqrr4rhzpne24hhs4p3w4cwhcdgqgr3hxsmzl9zg",
        coinDecimals: 6
      },
      {
        coinDenom: "watr",
        coinMinimalDenom: "cw20:juno1m4h8q4p305wgy7vkux0w6e5ylhqll3s6pmadhxkhqtuwd5wlxhxs8xklsw",
        coinDecimals: 6
      },
      {
        coinDenom: "casa",
        coinMinimalDenom: "cw20:juno1ju8k8sqwsqu5k6umrypmtyqu2wqcpnrkf4w4mntvl0javt4nma7s8lzgss",
        coinDecimals: 6
      },
      {
        coinDenom: "summit",
        coinMinimalDenom: "cw20:juno1j4ux0f6gt7e82z7jdpm25v4g2gts880ap64rdwa49989wzhd0dfqed6vqm",
        coinDecimals: 6
      },
      {
        coinDenom: "manna",
        coinMinimalDenom: "cw20:juno13ca2g36ng6etcfhr9qxx352uw2n5e92np54thfkm3w3nzlhsgvwsjaqlyq",
        coinDecimals: 6
      },
      {
        coinDenom: "empwr",
        coinMinimalDenom: "cw20:juno12etxwkxvms0uy9ak8g3pyq6a53myukufdnx82pakzmjmpm77a0ksr9gs5v",
        coinDecimals: 6
      },
      {
        coinDenom: "middle",
        coinMinimalDenom: "cw20:juno1525fuspletvzykpgr2atxpymu9le4mghd7qq4a4u23uwqzc2f3fq7fmafd",
        coinDecimals: 6
      },
      {
        coinDenom: "sunset",
        coinMinimalDenom: "cw20:juno17703kcxtsg37hryxnestejyyycuv5yyvnghp2e7w0kqvafnnyetsgzq62w",
        coinDecimals: 6
      },
      {
        coinDenom: "tree",
        coinMinimalDenom: "cw20:juno1uu3rxu7w7fpfj4sl4xpxppgymk57mzdzn6kg7492jdxh5dwk7d2qq9429e",
        coinDecimals: 6
      },
      {
        coinDenom: "invdrs",
        coinMinimalDenom: "cw20:juno1jwdy7v4egw36pd84aeks3ww6n8k7zhsumd4ac8q5lts83ppxueus4626e8",
        coinDecimals: 6
      },
      {
        coinDenom: "apemos",
        coinMinimalDenom: "cw20:juno1jrr0tuuzxrrwcg6hgeqhw5wqpck2y55734e7zcrp745aardlp0qqg8jz06",
        coinDecimals: 6
      },
      {
        coinDenom: "osdoge",
        coinMinimalDenom: "cw20:juno1ytymtllllsp3hfmndvcp802p2xmy5s8m59ufel8xv9ahyxyfs4hs4kd4je",
        coinDecimals: 6
      },
      {
        coinDenom: "doga",
        coinMinimalDenom: "cw20:juno1k2ruzzvvwwtwny6gq6kcwyfhkzahaunp685wmz4hafplduekj98q9hgs6d",
        coinDecimals: 6
      },
      {
        coinDenom: "pepe",
        coinMinimalDenom: "cw20:juno1zqrj3ta4u7ylv0wqzd8t8q3jrr9rdmn43zuzp9zemeunecnhy8fss778g7",
        coinDecimals: 6
      },
      {
        coinDenom: "catmos",
        coinMinimalDenom: "cw20:juno1f5datjdse3mdgrapwuzs3prl7pvxxht48ns6calnn0t77v2s9l8s0qu488",
        coinDecimals: 6
      },
      {
        coinDenom: "spacer",
        coinMinimalDenom: "cw20:juno1dyyf7pxeassxvftf570krv7fdf5r8e4r04mp99h0mllsqzp3rs4q7y8yqg",
        coinDecimals: 6
      },
      {
        coinDenom: "light",
        coinMinimalDenom: "cw20:juno1dpany8c0lj526lsa02sldv7shzvnw5dt5ues72rk35hd69rrydxqeraz8l",
        coinDecimals: 9
      },
      {
        coinDenom: "mile",
        coinMinimalDenom: "cw20:juno1llg7q2d5dqlrqzh5dxv8c7kzzjszld34s5vktqmlmaaxqjssz43sxyhq0d",
        coinDecimals: 6
      },
      {
        coinDenom: "void",
        coinMinimalDenom: "cw20:juno1lpvx3mv2a6ddzfjc7zzz2v2cm5gqgqf0hx67hc5p5qwn7hz4cdjsnznhu8",
        coinDecimals: 6
      },
      {
        coinDenom: "silica",
        coinMinimalDenom: "cw20:juno10vgf2u03ufcf25tspgn05l7j3tfg0j63ljgpffy98t697m5r5hmqaw95ux",
        coinDecimals: 6
      },
      {
        coinDenom: "pepec",
        coinMinimalDenom: "cw20:juno1epxnvge53c4hkcmqzlxryw5fp7eae2utyk6ehjcfpwajwp48km3sgxsh9k",
        coinDecimals: 6
      },
      {
        coinDenom: "pltn",
        coinMinimalDenom: "cw20:juno15au4k2jgwd0jnchy0fkg3lm00fpt7jt0j2duuzradn2q7sega2dszyn5pp",
        coinDecimals: 6
      },
      {
        coinDenom: "yfd",
        coinMinimalDenom: "cw20:juno12mcwmd6wqhledkjsurlfqtc8j0pedvxlcxw3gs4kh2qf808ehehsen8nmw",
        coinDecimals: 6
      },
      {
        coinDenom: "nexx",
        coinMinimalDenom: "factory/juno1qly4zcmzr2gyxtze5yt9chv2srczwwunppxjfh/NEXX",
        coinDecimals: 6
      },
      {
        coinDenom: "dgl",
        coinMinimalDenom: "factory/juno1u805lv20qc6jy7c3ttre7nct6uyl20pfky5r7e/DGL",
        coinDecimals: 6
      },
      {
        coinDenom: "ampJUNO",
        coinMinimalDenom: "cw20:juno1a0khag6cfzu5lrwazmyndjgvlsuk7g4vn9jd8ceym8f4jf6v2l9q6d348a",
        coinDecimals: 6
      },
      {
        coinDenom: "bits",
        coinMinimalDenom: "cw20:juno14fz92ehqt37e096xr95kmy8nc0kz803uezxtg4fwx7agjjma86sqm8mg3h",
        coinDecimals: 8
      },
      {
        coinDenom: "poil",
        coinMinimalDenom: "cw20:juno13epyeat7ef0k7q6kllmyvc8zpfd9xm7cqjrgtk0qkgrk7n5mjfmq8979jw",
        coinDecimals: 6
      },
      {
        coinDenom: "minerva",
        coinMinimalDenom: "cw20:juno1h86ut5aevlxuuxrra6wy3dfq6e39zkzzv9eelz678jr6amxlc4gsx46j82",
        coinDecimals: 6
      },
      {
        coinDenom: "luno",
        coinMinimalDenom: "cw20:juno13c57ssxvlzefsj4v5spdz4m9r6c6s2far5npvmc9en7nz02xqjyqne40gk",
        coinDecimals: 6
      },
      {
        coinDenom: "aten",
        coinMinimalDenom: "cw20:juno1elpg96tju8a32vzn25u6asvscajjm4000589z0zthhvks28ajypqzurl7r",
        coinDecimals: 6
      },
      {
        coinDenom: "hera",
        coinMinimalDenom: "cw20:juno1dtd45vxvv080v9x7hffysnmvrqm6ysecjdnvafqul28646hm04xs9gheh0",
        coinDecimals: 6
      },
      {
        coinDenom: "bJUNO",
        coinMinimalDenom: "cw20:juno1mvkgcr5uce2rnpzr4qrzf50hx4qreuwzlt7fzsjrhjud3xnjmttq5mkh2m",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/4A482FA914A4B9B05801ED81C33713899F322B24F76A06F4B8FE872485EA22FF",
        coinDecimals: 6
      },
      {
        coinDenom: "rstk",
        coinMinimalDenom: "ibc/F0C440C8040E2FCCAC621D32D3A00D9B347C989D52CE869A91CB34D07B0021D2",
        coinDecimals: 6
      },
      {
        coinDenom: "wind",
        coinMinimalDenom: "factory/juno1h6y8tkceau4d8zyv5aa0fwdj2pa2y0gz2hx0tq/uwind",
        coinDecimals: 6
      },
      {
        coinDenom: "cw20:juno1spjes0smg5yp40dl7gqyw0h8rn03tnmve06dd2m5acwgh6tlx86swha3xg",
        coinMinimalDenom: "cw20:juno1spjes0smg5yp40dl7gqyw0h8rn03tnmve06dd2m5acwgh6tlx86swha3xg",
        coinDecimals: 0
      },
      {
        coinDenom: "arena",
        coinMinimalDenom: "factory/juno1vwmnqk0vyxc96qgffrure4nqxupjrql0zut8s02hadgp0n79r8xq5xdsxy/ARENA",
        coinDecimals: 6
      },
      {
        coinDenom: "ashWIND",
        coinMinimalDenom: "factory/juno16uprl38e4ljj5ctuha9ehpvp2l93z3d5jmwj2cttt6jkhlrhscpqgglalk/wind.ash",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd-juno.itastakers.com",
    rpc: "https://rpc-juno.itastakers.com",
    bech32Config: {
      bech32PrefixAccAddr: "juno",
      bech32PrefixAccPub: "junopub",
      bech32PrefixValAddr: "junovaloper",
      bech32PrefixValPub: "junovaloperpub",
      bech32PrefixConsAddr: "junovalcons",
      bech32PrefixConsPub: "junovalconspub"
    },
    chainName: "juno",
    feeCurrencies: [
      {
        coinDenom: "juno",
        coinMinimalDenom: "ujuno",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.075,
          average: 0.1,
          high: 0.125
        }
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/C4CFF46FD6DE35CA4CF4CE031E643C8FDC9BA4B99AE598E9B0ED98FE3A2319F9",
        coinDecimals: 6,
        gasPriceStep: {
          low: 3e-3,
          average: 35e-4,
          high: 4e-3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "juno",
      coinMinimalDenom: "ujuno",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "kava_2222-10",
    currencies: [
      {
        coinDenom: "kava",
        coinMinimalDenom: "ukava",
        coinDecimals: 6
      },
      {
        coinDenom: "HARD",
        coinMinimalDenom: "hard",
        coinDecimals: 6
      },
      {
        coinDenom: "SWP",
        coinMinimalDenom: "swp",
        coinDecimals: 6
      },
      {
        coinDenom: "USDX",
        coinMinimalDenom: "usdx",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "erc20/tether/usdt",
        coinDecimals: 6
      }
    ],
    rest: "https://api.data.kava.io/",
    rpc: "https://rpc.data.kava.io",
    bech32Config: {
      bech32PrefixAccAddr: "kava",
      bech32PrefixAccPub: "kavapub",
      bech32PrefixValAddr: "kavavaloper",
      bech32PrefixValPub: "kavavaloperpub",
      bech32PrefixConsAddr: "kavavalcons",
      bech32PrefixConsPub: "kavavalconspub"
    },
    chainName: "kava",
    feeCurrencies: [
      {
        coinDenom: "kava",
        coinMinimalDenom: "ukava",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.05,
          average: 0.1,
          high: 0.25
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "kava",
      coinMinimalDenom: "ukava",
      coinDecimals: 6
    },
    bip44: {
      coinType: 459
    }
  },
  {
    chainId: "kichain-2",
    currencies: [
      {
        coinDenom: "xki",
        coinMinimalDenom: "uxki",
        coinDecimals: 6
      },
      {
        coinDenom: "lvn",
        coinMinimalDenom: "cw20:ki1dt3lk455ed360pna38fkhqn0p8y44qndsr77qu73ghyaz2zv4whq83mwdy",
        coinDecimals: 6
      }
    ],
    rest: "https://api-mainnet.blockchain.ki",
    rpc: "https://rpc-mainnet.blockchain.ki",
    bech32Config: {
      bech32PrefixAccAddr: "ki",
      bech32PrefixAccPub: "kipub",
      bech32PrefixValAddr: "kivaloper",
      bech32PrefixValPub: "kivaloperpub",
      bech32PrefixConsAddr: "kivalcons",
      bech32PrefixConsPub: "kivalconspub"
    },
    chainName: "kichain",
    feeCurrencies: [
      {
        coinDenom: "xki",
        coinMinimalDenom: "uxki",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.03,
          high: 0.05
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "xki",
      coinMinimalDenom: "uxki",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "kima_network",
    currencies: [
      {
        coinDenom: "KIMA",
        coinMinimalDenom: "uKIMA",
        coinDecimals: 6
      }
    ],
    rest: "https://api.kima.network",
    rpc: "https://rpc.kima.network/",
    bech32Config: {
      bech32PrefixAccAddr: "kima",
      bech32PrefixAccPub: "kimapub",
      bech32PrefixValAddr: "kimavaloper",
      bech32PrefixValPub: "kimavaloperpub",
      bech32PrefixConsAddr: "kimavalcons",
      bech32PrefixConsPub: "kimavalconspub"
    },
    chainName: "kimanetwork",
    feeCurrencies: [
      {
        coinDenom: "KIMA",
        coinMinimalDenom: "uKIMA",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "KIMA",
      coinMinimalDenom: "uKIMA",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "darchub",
    currencies: [
      {
        coinDenom: "darc",
        coinMinimalDenom: "udarc",
        coinDecimals: 6
      }
    ],
    rest: "https://api-konstellation-ia.cosmosia.notional.ventures/",
    rpc: "https://rpc-konstellation-ia.cosmosia.notional.ventures/",
    bech32Config: {
      bech32PrefixAccAddr: "darc",
      bech32PrefixAccPub: "darcpub",
      bech32PrefixValAddr: "darcvaloper",
      bech32PrefixValPub: "darcvaloperpub",
      bech32PrefixConsAddr: "darcvalcons",
      bech32PrefixConsPub: "darcvalconspub"
    },
    chainName: "konstellation",
    feeCurrencies: [
      {
        coinDenom: "darc",
        coinMinimalDenom: "udarc",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-4,
          average: 1e-3,
          high: 0.01
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "darc",
      coinMinimalDenom: "udarc",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "kaiyo-1",
    currencies: [
      {
        coinDenom: "kuji",
        coinMinimalDenom: "ukuji",
        coinDecimals: 6
      },
      {
        coinDenom: "usk",
        coinMinimalDenom: "factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk",
        coinDecimals: 6
      },
      {
        coinDenom: "qcKUJI",
        coinMinimalDenom: "factory/kujira1m96ucsfpt2yy72w09z2rxjdj38y5qd8lqx5jtggnejmdua2ynpnsxyvjex/urcpt",
        coinDecimals: 6
      },
      {
        coinDenom: "ampKUJI",
        coinMinimalDenom: "factory/kujira1n3fr5f56r2ce0s37wdvwrk98yhhq3unnxgcqus8nzsfxvllk0yxquurqty/ampKUJI",
        coinDecimals: 6
      },
      {
        coinDenom: "mnta",
        coinMinimalDenom: "factory/kujira1643jxg8wasy5cfcn7xm8rd742yeazcksqlg4d7/umnta",
        coinDecimals: 6
      },
      {
        coinDenom: "qcMNTA",
        coinMinimalDenom: "factory/kujira1qzu3up50auxhqyzfq56znuj8n38q2ra7daaf9ef7vg8gu66jh4fqd2wd2y/urcpt",
        coinDecimals: 6
      },
      {
        coinDenom: "ampMNTA",
        coinMinimalDenom: "factory/kujira175yatpvkpgw07w0chhzuks3zrrae9z9g2y6r7u5pzqesyau4x9eqqyv0rr/ampMNTA",
        coinDecimals: 6
      },
      {
        coinDenom: "wink",
        coinMinimalDenom: "factory/kujira12cjjeytrqcj25uv349thltcygnp9k0kukpct0e/uwink",
        coinDecimals: 6
      },
      {
        coinDenom: "blend",
        coinMinimalDenom: "factory/kujira1slueerjz7mx9jp45u3y0rjwtvhcf8a68wf2mjt/ublend",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/20014F963CC9E6488B299622F87B60C6DE71632864859EC08B4753478DAB2BB8",
        coinDecimals: 6
      },
      {
        coinDenom: "fuzn",
        coinMinimalDenom: "factory/kujira1sc6a0347cc5q3k890jj0pf3ylx2s38rh4sza4t/ufuzn",
        coinDecimals: 6
      },
      {
        coinDenom: "rfuzn",
        coinMinimalDenom: "factory/kujira1sc6a0347cc5q3k890jj0pf3ylx2s38rh4sza4t/urfuzn",
        coinDecimals: 6
      },
      {
        coinDenom: "yfuzn",
        coinMinimalDenom: "factory/kujira1sc6a0347cc5q3k890jj0pf3ylx2s38rh4sza4t/uyfuzn",
        coinDecimals: 6
      },
      {
        coinDenom: "qcFUZN",
        coinMinimalDenom: "factory/kujira1l04ged98c7a7s9tllu62ld09ztylwf442qgm4thfgmadrvngeumsz4zrh2/urcpt",
        coinDecimals: 6
      },
      {
        coinDenom: "qcAQLA",
        coinMinimalDenom: "factory/kujira1d9fmsgvu3yvvppvqech2s3dhrqdm5ukngcf82ghcl70edfpwcrlsu6yr0u/urcpt",
        coinDecimals: 6
      },
      {
        coinDenom: "AQLA",
        coinMinimalDenom: "factory/kujira1xe0awk5planmtsmjel5xtx2hzhqdw5p8z66yqd/uaqla",
        coinDecimals: 6
      },
      {
        coinDenom: "nstk",
        coinMinimalDenom: "factory/kujira1aaudpfr9y23lt9d45hrmskphpdfaq9ajxd3ukh/unstk",
        coinDecimals: 6
      },
      {
        coinDenom: "local",
        coinMinimalDenom: "factory/kujira1swkuyt08z74n5jl7zr6hx0ru5sa2yev5v896p6/local",
        coinDecimals: 6
      },
      {
        coinDenom: "PLNK",
        coinMinimalDenom: "factory/kujira166ysf07ze5suazfzj0r05tv8amk2yn8zvsfuu7/uplnk",
        coinDecimals: 6
      },
      {
        coinDenom: "sol",
        coinMinimalDenom: "ibc/E5CA126979E2FFB4C70C072F8094D07ECF27773B37623AD2BF7582AD0726F0F3",
        coinDecimals: 8
      },
      {
        coinDenom: "evmos",
        coinMinimalDenom: "ibc/F3AA7EF362EC5E791FE78A0F4CCC69FEE1F9A7485EB1A8CAB3F6601C00522F10",
        coinDecimals: 18
      },
      {
        coinDenom: "avax",
        coinMinimalDenom: "ibc/004EBF085BBED1029326D56BE8A2E67C08CECE670A94AC1947DF413EF5130EB2",
        coinDecimals: 18
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/FE98AAD68F02F03565E9FA39A5E627946699B2B07115889ED812D8BA639576A9",
        coinDecimals: 6
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/47BD209179859CDE4A2806763D7189B6E6FE13A17880FE2B42DE1E6C1E329E23",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/295548A78785A1007F232DE286149A6FF512F180AF5657780FC89C009E2C348F",
        coinDecimals: 6
      },
      {
        coinDenom: "cmdx",
        coinMinimalDenom: "ibc/3607EB5B5E64DD1C0E12E07F077FF470D5BC4706AFCBC98FE1BA960E5AE4CE07",
        coinDecimals: 6
      },
      {
        coinDenom: "juno",
        coinMinimalDenom: "ibc/EFF323CC632EC4F747C61BCE238A758EFDB7699C3226565F7C20DA06509D59A5",
        coinDecimals: 6
      },
      {
        coinDenom: "weth",
        coinMinimalDenom: "ibc/1B38805B1C75352B28169284F96DF56BDEBD9E8FAC005BDCC8CF0378C82AA8E7",
        coinDecimals: 18
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
        coinDecimals: 6
      },
      {
        coinDenom: "luna",
        coinMinimalDenom: "ibc/DA59C009A0B3B95E0549E6BF7B075C8239285989FF457A8EDDBB56F10B2A6986",
        coinDecimals: 6
      },
      {
        coinDenom: "stars",
        coinMinimalDenom: "ibc/4F393C3FCA4190C0A6756CE7F6D897D5D1BE57D6CCB80D0BC87393566A7B6602",
        coinDecimals: 6
      },
      {
        coinDenom: "scrt",
        coinMinimalDenom: "ibc/A358D7F19237777AF6D8AD0E0F53268F8B18AE8A53ED318095C14D6D7F3B2DB5",
        coinDecimals: 6
      },
      {
        coinDenom: "stkatom",
        coinMinimalDenom: "ibc/086C1B2E9E611F23D3C9159C858D3F4C6A911D348DFB916A11AE306A865A77A8",
        coinDecimals: 6
      },
      {
        coinDenom: "bKUJI",
        coinMinimalDenom: "factory/kujira15e8q5wzlk5k38gjxlhse3vu6vqnafysncx2ltexd6y9gx50vuj2qpt7dgv/boneKuji",
        coinDecimals: 6
      },
      {
        coinDenom: "rstk",
        coinMinimalDenom: "ibc/82B298F9E74A9A211C55C67C7AB0C790836BD43672D5DD830F7AE2C5D010AD7D",
        coinDecimals: 6
      },
      {
        coinDenom: "xusk",
        coinMinimalDenom: "factory/kujira1w4yaama77v53fp0f9343t9w2f932z526vj970n2jv5055a7gt92sxgwypf/urcpt",
        coinDecimals: 6
      },
      {
        coinDenom: "xmnta",
        coinMinimalDenom: "factory/kujira1ya42knfcsvy6eztegsn3hz7zpjvhzn05ge85xa2dy2zrjeul9hnspp3c06/urcpt",
        coinDecimals: 6
      },
      {
        coinDenom: "statom",
        coinMinimalDenom: "ibc/0306D6B66EAA2EDBB7EAD23C0EC9DDFC69BB43E80B398035E90FBCFEF3FD1A87",
        coinDecimals: 6
      },
      {
        coinDenom: "wbtc.axl",
        coinMinimalDenom: "ibc/301DAF9CB0A9E247CD478533EF0E21F48FF8118C4A51F77C8BC3EB70E5566DBC",
        coinDecimals: 6
      },
      {
        coinDenom: "stosmo",
        coinMinimalDenom: "ibc/F97BDCE220CCB52139C73066E36C45EC7EDCEEF1DAFF891A34F4FBA195A2E6E8",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-dot-mnta",
        coinMinimalDenom: "factory/kujira10qyzrqaza0f593cmnl4sc3p3nhqqakn9j56d899u723pznxpn8us6cypuw/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-shd-mnta",
        coinMinimalDenom: "factory/kujira12tpc335t72qtrjh64ccdydzsr9qtswkqn72cyvfj4d5hmtgynphsv4xjtu/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-dydx-mnta",
        coinMinimalDenom: "factory/kujira13g2eelkf9q4md4xx52ylqvlgpccn50f2vyu05eazufd2g4jatmhq2425pq/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-wavax-mnta",
        coinMinimalDenom: "factory/kujira15pk8c09vcsgsdq4xlh2qfqxtu2r8pgdy7nggkqj8p3h2phke80pqwnvtzk/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-cheq-mnta",
        coinMinimalDenom: "factory/kujira15w6jhxsv924mn9cfr0qg9z36hltmw4rzd68x40d9re6hzyhslumqjw9zqd/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-fuzn-mnta",
        coinMinimalDenom: "factory/kujira1622xuv8unv22xzazljvqh8uukcdz3yzmrp6axgerh7vxg4kum5tqcwcqmv/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-somm-mnta",
        coinMinimalDenom: "factory/kujira17djzq5x5e5zm9q9zlp6dtxdt9p8q2zvj0qtmjs0wrxm5g9e2vf5q9d6y2t/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-weth-mnta",
        coinMinimalDenom: "factory/kujira17x2v39aut0paj5d6wc5jxvqqxrdhy9kvca4y5xn6vsfpsxkgc6gq7n4tg0/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-ntrn-mnta",
        coinMinimalDenom: "factory/kujira18lhugzap20ndlqr5j2p86yk4pxpe9jjuac05z0ypxuwn3mm5vjhsjh4etr/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-wftm-mnta",
        coinMinimalDenom: "factory/kujira18mveas6xseaqu3fmukwv2ac6mp4hszk08lvyamedytjs0kxm42yqs9v89x/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-stars-mnta",
        coinMinimalDenom: "factory/kujira1av284rnqh6s0l2lwdqgpgz8wuva3wh9lkmlsupjd9escn5v4fels6kwc7v/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-tia-mnta",
        coinMinimalDenom: "factory/kujira1cpdyhrkwdnz38u45el3zq7007at9dm6h05tc36zpxvs6vrdwzrrskt0tgg/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-sol-mnta",
        coinMinimalDenom: "factory/kujira1eqd96322ec258w7k9n9cfqkusrlvzwv38jkph3qs720egdv0epmq70j2zl/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-dym-mnta",
        coinMinimalDenom: "factory/kujira1fg7wmsde7ygw3pm6hqmd29cdvp947anajmunsvk0guvjta3md25qdqk4fw/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-akt-mnta",
        coinMinimalDenom: "factory/kujira1gnftck9586x0nhsqsj99k9zednl6tx4kezu9hpph0u6jtqnafpyqxha3me/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-link-mnta",
        coinMinimalDenom: "factory/kujira1gnvja05kkmpeh9dnxl0c2p4sde7fpsy2r44njzyqgpsf72nqs78q3gzpzc/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-wtao-mnta",
        coinMinimalDenom: "factory/kujira1gz2kvfw7hpds9fvygwkj64znl3a9pw697g77cspcq5y4vj3ru45s7qc0rd/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-mnta-kuji",
        coinMinimalDenom: "factory/kujira1h75predtjdm2e7u8cuvqs3usc6xs2mxlkcr20zsshvw3qap25frsr4z949/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-axl-mnta",
        coinMinimalDenom: "factory/kujira1h929g9e9vxhc5y8v7uexdrncacxdatjupr67velewafwepfyfaaq6s7l3v/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-atom-mnta",
        coinMinimalDenom: "factory/kujira1h9f3k54j060pzlnea8ep8qfymsmwl5yhwc5hqept5p2esqzve7tq2ghnm4/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-arb-mnta",
        coinMinimalDenom: "factory/kujira1kc90tgn4ucvdv4c9xycktanwz2lna0nfel6244ylqjvhaetfntusnmyu3d/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-whale-mnta",
        coinMinimalDenom: "factory/kujira1jsjygyj8hwa4f0p9wwgct4yzmzzexe5x5u6l40l7ty2qzwwwsemqavhk3x/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-scrt-mnta",
        coinMinimalDenom: "factory/kujira1p7w9ncnnme9yzzhrvzv0hnsa5u5ga06v0ckt7lq9yfap04hc5k9sn2vf6w/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-wsteth-mnta",
        coinMinimalDenom: "factory/kujira1qx3hcr297qmgjt5f6u9peldf4phxqufvmew8d3eey3ns29e8qp3snj6jfu/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-wmatic-mnta",
        coinMinimalDenom: "factory/kujira1smfdnww47xav4nn849xphku3gk3xp7a24fk533dce8masnsz4v8quklajx/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-uni-mnta",
        coinMinimalDenom: "factory/kujira1t4mr2xt4ky4mfwcy752chzlquam3hzs44mt8vwyec8mvypmzxu5s90vamt/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-yieldeth-mnta",
        coinMinimalDenom: "factory/kujira1u8dluwa4a83q7anz0cgpmma605r07a06f0789ajcl8l0xjrplqss005cgn/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-wbtc-mnta",
        coinMinimalDenom: "factory/kujira1vj39mdwekxznxxa97fv5gt957cghfdqhwju8fdv5ysu0x6vsyhps4zmqjl/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-paxg-mnta",
        coinMinimalDenom: "factory/kujira1vqdyup9zxxl9gqy5hwh593vvuc84lstldj7qzt7fylf3q3e3uemqlwpg9y/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-wbnb-mnta",
        coinMinimalDenom: "factory/kujira1y24jwsv84lnuv5j78qeqz5ujjpd058qsft7wfc0nk9jvycugm32sqnq53d/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-osmo-mnta",
        coinMinimalDenom: "factory/kujira1ygperwf0dc9ng2jffj0pwnnray3rscn9el6d78qjtt25qwgqukqszmdwtv/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-inj-mnta",
        coinMinimalDenom: "factory/kujira1znx048dcc6arqfw6kpckl0k4ts2h7cdx20nk22wz2cxh5vle3wxqknk238/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-stosmo-osmo",
        coinMinimalDenom: "factory/kujira18sek950cg92gd0kvpj67dfg6p7kee6hzw92etcf2jgufr3mttvaslt5sal/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-wsteth-weth",
        coinMinimalDenom: "factory/kujira1lyyeyuw4qgan6nz45thw2m0nmxa457uz7cp9dqw5d9a0h7ccek7qavkm6g/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-qcmnta-mnta",
        coinMinimalDenom: "factory/kujira1ul00h0a2kgcg9x2yfa86wj9qguhyv7jmpjpw6ztt24j9mn9xjw3slawyc8/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-ampmnta-mnta",
        coinMinimalDenom: "factory/kujira1vj36ntsqd3msc69lxldcv9dd50jngknmael9e07rz4fpn5kyq0jsglvz2m/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-weth-usk",
        coinMinimalDenom: "factory/kujira1n648rfqqvjxm6c7zgfnfqay85rkapgg0z7da9pnmjazz5m5d7l0qxdtq90/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "nami",
        coinMinimalDenom: "factory/kujira13x2l25mpkhwnwcwdzzd34cr8fyht9jlj7xu9g4uffe36g3fmln8qkvm3qn/unami",
        coinDecimals: 6
      },
      {
        coinDenom: "nausd",
        coinMinimalDenom: "factory/kujira18thffdpuz8tm3mwwun4uhks8a2v7ye0jmw3fllqhklma82lqkpms20gh9c/unausd",
        coinDecimals: 6
      },
      {
        coinDenom: "mctest",
        coinMinimalDenom: "factory/kujira1mn2pgkggquqm2m44zqlaq29jxwtad53qkv4xy4/MCTest",
        coinDecimals: 6
      },
      {
        coinDenom: "auto",
        coinMinimalDenom: "factory/kujira13x2l25mpkhwnwcwdzzd34cr8fyht9jlj7xu9g4uffe36g3fmln8qkvm3qn/uauto",
        coinDecimals: 6
      },
      {
        coinDenom: "qcDYDX",
        coinMinimalDenom: "factory/kujira1seqq2ekz47uqayshqkg5wqx5vcyrmtwcl9vscnwy2gjh7mz5aapsdfxsd5/urcpt",
        coinDecimals: 18
      },
      {
        coinDenom: "rkuji",
        coinMinimalDenom: "factory/kujira1tsekaqv9vmem0zwskmf90gpf0twl6k57e8vdnq/urkuji",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-atom-usk",
        coinMinimalDenom: "factory/kujira1yncutssgh2vj9scaymtteg949hwcft07c6qmgarxnaf04yesq3jsn6g2uv/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-weth-usk",
        coinMinimalDenom: "factory/kujira1xwvvjq5w0887v2vz4e83kcu38s0jq8q8lqa3z5hxm295q7y4uejqp24la7/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-sol-usk",
        coinMinimalDenom: "factory/kujira1vcmh95lje5dln782pxckma65eujs4sv960w22whgsp7a2ajsc6lsvnlhgd/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-weth-usdc",
        coinMinimalDenom: "factory/kujira1n4jfv39hzv2dtshzv6gj4hp8rkdy5rrsr7l84lc3x9cahz4v0umq24q3lu/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-dydx-usk",
        coinMinimalDenom: "factory/kujira1lctu7hy65466fxw3tcqf8w45zwrpwgd9chvjqpgyfgcr73k774nsv4ya6t/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-akt-usdc",
        coinMinimalDenom: "factory/kujira1g5st8p6qdyf23zzerjcxgpr2r7a9wzdyaymu79ngg6ve3m9v3n4sdetv4e/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-wbtc-usk",
        coinMinimalDenom: "factory/kujira1d7jt9zwlnpvf7sskfm57c77pm9mtwczqre75t9k80ees0v523kasss9htj/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-wbtc-wbtc",
        coinMinimalDenom: "factory/kujira1c4e2zk4z0anrufjh64gxtse6e4s5g52fe2ja8ke3r9e0pvpd0z0qws8zsp/ulp",
        coinDecimals: 8
      },
      {
        coinDenom: "lp-inj-usdc",
        coinMinimalDenom: "factory/kujira14jwhlsg3az20f7keav2axxj205fyv5j8mp6rv5svqwwll3ls9slq6zwleg/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-atom-usdc",
        coinMinimalDenom: "factory/kujira13my0qtm2a8jp0wg8uzg49tyn4zcea8scy3dc7ghn8z9eys08yzls49ymdm/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-mnta-usdc",
        coinMinimalDenom: "factory/kujira1742pe93mxm0cwqjxgxh6th9sspdrluqvw9pha9q69eeatue4x5xs0wdq2d/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "lp-mnta-usk",
        coinMinimalDenom: "factory/kujira1xtaadmh06s8u3z5mypp8qayhrnxgga5wr88s7raram4rz8zu37hquf82wk/ulp",
        coinDecimals: 6
      },
      {
        coinDenom: "boon",
        coinMinimalDenom: "factory/kujira1gewwffxhaygxe8tacd3z9h4uyvpd2h7v9qtfmaw8jjhwalxxpd7qlqld4m/boon",
        coinDecimals: 6
      },
      {
        coinDenom: "yum",
        coinMinimalDenom: "ibc/507BE7E33F06026652F519AD4D36716251F2D34DF04514A905D3B19A7D8130F7",
        coinDecimals: 18
      }
    ],
    rest: "https://lcd.kaiyo.kujira.setten.io",
    rpc: "https://rpc.kaiyo.kujira.setten.io",
    bech32Config: {
      bech32PrefixAccAddr: "kujira",
      bech32PrefixAccPub: "kujirapub",
      bech32PrefixValAddr: "kujiravaloper",
      bech32PrefixValPub: "kujiravaloperpub",
      bech32PrefixConsAddr: "kujiravalcons",
      bech32PrefixConsPub: "kujiravalconspub"
    },
    chainName: "kujira",
    feeCurrencies: [
      {
        coinDenom: "kuji",
        coinMinimalDenom: "ukuji",
        coinDecimals: 6,
        gasPriceStep: {
          low: 34e-4,
          average: 51e-4,
          high: 681e-5
        }
      },
      {
        coinDenom: "usk",
        coinMinimalDenom: "factory/kujira1qk00h5atutpsv900x202pxx42npjr9thg58dnqpa72f2p7m2luase444a7/uusk",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01186,
          average: 0.01779,
          high: 0.02372
        }
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/295548A78785A1007F232DE286149A6FF512F180AF5657780FC89C009E2C348F",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.0119,
          average: 0.01785,
          high: 0.02379
        }
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
        coinDecimals: 6,
        gasPriceStep: {
          low: 129e-5,
          average: 193e-5,
          high: 258e-5
        }
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/47BD209179859CDE4A2806763D7189B6E6FE13A17880FE2B42DE1E6C1E329E23",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01795,
          average: 0.02692,
          high: 0.0359
        }
      },
      {
        coinDenom: "cmdx",
        coinMinimalDenom: "ibc/3607EB5B5E64DD1C0E12E07F077FF470D5BC4706AFCBC98FE1BA960E5AE4CE07",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.65943,
          average: 0.98915,
          high: 1.31887
        }
      },
      {
        coinDenom: "evmos",
        coinMinimalDenom: "ibc/F3AA7EF362EC5E791FE78A0F4CCC69FEE1F9A7485EB1A8CAB3F6601C00522F10",
        coinDecimals: 18,
        gasPriceStep: {
          low: 160416396197,
          average: 240624594296,
          high: 320832792394
        }
      },
      {
        coinDenom: "juno",
        coinMinimalDenom: "ibc/EFF323CC632EC4F747C61BCE238A758EFDB7699C3226565F7C20DA06509D59A5",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.02689,
          average: 0.04034,
          high: 0.05379
        }
      },
      {
        coinDenom: "luna",
        coinMinimalDenom: "ibc/DA59C009A0B3B95E0549E6BF7B075C8239285989FF457A8EDDBB56F10B2A6986",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01495,
          average: 0.02243,
          high: 0.02991
        }
      },
      {
        coinDenom: "scrt",
        coinMinimalDenom: "ibc/A358D7F19237777AF6D8AD0E0F53268F8B18AE8A53ED318095C14D6D7F3B2DB5",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.03139,
          average: 0.04709,
          high: 0.06278
        }
      },
      {
        coinDenom: "stars",
        coinMinimalDenom: "ibc/4F393C3FCA4190C0A6756CE7F6D897D5D1BE57D6CCB80D0BC87393566A7B6602",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.90403,
          average: 1.35605,
          high: 1.80806
        }
      },
      {
        coinDenom: "avax",
        coinMinimalDenom: "ibc/004EBF085BBED1029326D56BE8A2E67C08CECE670A94AC1947DF413EF5130EB2",
        coinDecimals: 18,
        gasPriceStep: {
          low: 559196837,
          average: 838795256,
          high: 1118393675
        }
      },
      {
        coinDenom: "weth",
        coinMinimalDenom: "ibc/1B38805B1C75352B28169284F96DF56BDEBD9E8FAC005BDCC8CF0378C82AA8E7",
        coinDecimals: 18,
        gasPriceStep: {
          low: 5772801,
          average: 8659201,
          high: 11545602
        }
      },
      {
        coinDenom: "mnta",
        coinMinimalDenom: "factory/kujira1643jxg8wasy5cfcn7xm8rd742yeazcksqlg4d7/umnta",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01807,
          average: 0.02711,
          high: 0.03615
        }
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/FE98AAD68F02F03565E9FA39A5E627946699B2B07115889ED812D8BA639576A9",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01194,
          average: 0.01792,
          high: 0.02389
        }
      },
      {
        coinDenom: "sol",
        coinMinimalDenom: "ibc/E5CA126979E2FFB4C70C072F8094D07ECF27773B37623AD2BF7582AD0726F0F3",
        coinDecimals: 8,
        gasPriceStep: {
          low: 19e-5,
          average: 29e-5,
          high: 39e-5
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "kuji",
      coinMinimalDenom: "ukuji",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "kyve-1",
    currencies: [
      {
        coinDenom: "kyve",
        coinMinimalDenom: "ukyve",
        coinDecimals: 6
      }
    ],
    rest: "https://api-eu-1.kyve.network",
    rpc: "https://rpc-eu-1.kyve.network",
    bech32Config: {
      bech32PrefixAccAddr: "kyve",
      bech32PrefixAccPub: "kyvepub",
      bech32PrefixValAddr: "kyvevaloper",
      bech32PrefixValPub: "kyvevaloperpub",
      bech32PrefixConsAddr: "kyvevalcons",
      bech32PrefixConsPub: "kyvevalconspub"
    },
    chainName: "kyve",
    feeCurrencies: [
      {
        coinDenom: "kyve",
        coinMinimalDenom: "ukyve",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.02,
          average: 0.03,
          high: 0.06
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "kyve",
      coinMinimalDenom: "ukyve",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "lambda_92000-1",
    currencies: [
      {
        coinDenom: "lamb",
        coinMinimalDenom: "ulamb",
        coinDecimals: 18
      }
    ],
    rest: "https://rest.lambda.im",
    rpc: "https://rpc.lambda.im",
    bech32Config: {
      bech32PrefixAccAddr: "lamb",
      bech32PrefixAccPub: "lambpub",
      bech32PrefixValAddr: "lambvaloper",
      bech32PrefixValPub: "lambvaloperpub",
      bech32PrefixConsAddr: "lambvalcons",
      bech32PrefixConsPub: "lambvalconspub"
    },
    chainName: "lambda",
    feeCurrencies: [
      {
        coinDenom: "lamb",
        coinMinimalDenom: "ulamb",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e10,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "lamb",
      coinMinimalDenom: "ulamb",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "lava-mainnet-1",
    currencies: [
      {
        coinDenom: "lava",
        coinMinimalDenom: "ulava",
        coinDecimals: 6
      }
    ],
    rest: "https://lava-api.finteh.org:443",
    rpc: "https://lava.tendermintrpc.lava.build",
    bech32Config: {
      bech32PrefixAccAddr: "lava@",
      bech32PrefixAccPub: "lava@pub",
      bech32PrefixValAddr: "lava@valoper",
      bech32PrefixValPub: "lava@valoperpub",
      bech32PrefixConsAddr: "lava@valcons",
      bech32PrefixConsPub: "lava@valconspub"
    },
    chainName: "lava",
    feeCurrencies: [
      {
        coinDenom: "lava",
        coinMinimalDenom: "ulava",
        coinDecimals: 6,
        gasPriceStep: {
          low: 2e-5,
          average: 0.025,
          high: 0.05
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "lava",
      coinMinimalDenom: "ulava",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "likecoin-mainnet-2",
    currencies: [
      {
        coinDenom: "like",
        coinMinimalDenom: "nanolike",
        coinDecimals: 9
      }
    ],
    rest: "https://mainnet-node.like.co",
    rpc: "https://mainnet-node.like.co/rpc/",
    bech32Config: {
      bech32PrefixAccAddr: "like",
      bech32PrefixAccPub: "likepub",
      bech32PrefixValAddr: "likevaloper",
      bech32PrefixValPub: "likevaloperpub",
      bech32PrefixConsAddr: "likevalcons",
      bech32PrefixConsPub: "likevalconspub"
    },
    chainName: "likecoin",
    feeCurrencies: [
      {
        coinDenom: "like",
        coinMinimalDenom: "nanolike",
        coinDecimals: 9,
        gasPriceStep: {
          low: 1e3,
          average: 1e4,
          high: 1e6
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "like",
      coinMinimalDenom: "nanolike",
      coinDecimals: 9
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "logos_7002-1",
    currencies: [
      {
        coinDenom: "LYT",
        coinMinimalDenom: "aLYT",
        coinDecimals: 18
      }
    ],
    rest: "https://logos.provable.dev/rest/",
    rpc: "https://logos-rpc.provable.dev:443/",
    bech32Config: {
      bech32PrefixAccAddr: "logos",
      bech32PrefixAccPub: "logospub",
      bech32PrefixValAddr: "logosvaloper",
      bech32PrefixValPub: "logosvaloperpub",
      bech32PrefixConsAddr: "logosvalcons",
      bech32PrefixConsPub: "logosvalconspub"
    },
    chainName: "logos",
    feeCurrencies: [
      {
        coinDenom: "LYT",
        coinMinimalDenom: "aLYT",
        coinDecimals: 18
      }
    ],
    stakeCurrency: {
      coinDenom: "LYT",
      coinMinimalDenom: "aLYT",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "loop-1",
    currencies: [
      {
        coinDenom: "token",
        coinMinimalDenom: "token",
        coinDecimals: 0
      },
      {
        coinDenom: "poa",
        coinMinimalDenom: "upoa",
        coinDecimals: 6
      }
    ],
    rest: "https://api.loop.pfc.zone/",
    rpc: "https://rpc.loop.pfc.zone/",
    bech32Config: {
      bech32PrefixAccAddr: "loop",
      bech32PrefixAccPub: "looppub",
      bech32PrefixValAddr: "loopvaloper",
      bech32PrefixValPub: "loopvaloperpub",
      bech32PrefixConsAddr: "loopvalcons",
      bech32PrefixConsPub: "loopvalconspub"
    },
    chainName: "loop",
    feeCurrencies: [
      {
        coinDenom: "token",
        coinMinimalDenom: "token",
        coinDecimals: 0
      }
    ],
    stakeCurrency: {
      coinDenom: "token",
      coinMinimalDenom: "token",
      coinDecimals: 0
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "loyal-main-02",
    currencies: [
      {
        coinDenom: "lyl",
        coinMinimalDenom: "ulyl",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd-main.joinloyal.io/",
    rpc: "https://rpc-main.joinloyal.io/",
    bech32Config: {
      bech32PrefixAccAddr: "loyal",
      bech32PrefixAccPub: "loyalpub",
      bech32PrefixValAddr: "loyalvaloper",
      bech32PrefixValPub: "loyalvaloperpub",
      bech32PrefixConsAddr: "loyalvalcons",
      bech32PrefixConsPub: "loyalvalconspub"
    },
    chainName: "loyal",
    feeCurrencies: [
      {
        coinDenom: "lyl",
        coinMinimalDenom: "ulyl",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "lyl",
      coinMinimalDenom: "ulyl",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "LumenX",
    currencies: [
      {
        coinDenom: "lumen",
        coinMinimalDenom: "ulumen",
        coinDecimals: 6
      }
    ],
    rest: "https://api-lumenx.cryptonet.pl/",
    rpc: "https://rpc-lumenx.cryptonet.pl/",
    bech32Config: {
      bech32PrefixAccAddr: "lumen",
      bech32PrefixAccPub: "lumenpub",
      bech32PrefixValAddr: "lumenvaloper",
      bech32PrefixValPub: "lumenvaloperpub",
      bech32PrefixConsAddr: "lumenvalcons",
      bech32PrefixConsPub: "lumenvalconspub"
    },
    chainName: "lumenx",
    feeCurrencies: [
      {
        coinDenom: "lumen",
        coinMinimalDenom: "ulumen",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "lumen",
      coinMinimalDenom: "ulumen",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "lum-network-1",
    currencies: [
      {
        coinDenom: "lum",
        coinMinimalDenom: "ulum",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.node0.mainnet.lum.network",
    rpc: "https://rpc.node0.mainnet.lum.network",
    bech32Config: {
      bech32PrefixAccAddr: "lum",
      bech32PrefixAccPub: "lumpub",
      bech32PrefixValAddr: "lumvaloper",
      bech32PrefixValPub: "lumvaloperpub",
      bech32PrefixConsAddr: "lumvalcons",
      bech32PrefixConsPub: "lumvalconspub"
    },
    chainName: "lumnetwork",
    feeCurrencies: [
      {
        coinDenom: "lum",
        coinMinimalDenom: "ulum",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "lum",
      coinMinimalDenom: "ulum",
      coinDecimals: 6
    },
    bip44: {
      coinType: 880
    }
  },
  {
    chainId: "mande_18071918-1",
    currencies: [
      {
        coinDenom: "mand",
        coinMinimalDenom: "amand",
        coinDecimals: 18
      }
    ],
    rest: "https://mande-mainnet-rest.public.blastapi.io",
    rpc: "https://mande-mainnet-tendermint.public.blastapi.io",
    bech32Config: {
      bech32PrefixAccAddr: "mande",
      bech32PrefixAccPub: "mandepub",
      bech32PrefixValAddr: "mandevaloper",
      bech32PrefixValPub: "mandevaloperpub",
      bech32PrefixConsAddr: "mandevalcons",
      bech32PrefixConsPub: "mandevalconspub"
    },
    chainName: "mande",
    feeCurrencies: [
      {
        coinDenom: "mand",
        coinMinimalDenom: "amand",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e10,
          average: 2e10,
          high: 2e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "mand",
      coinMinimalDenom: "amand",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "mantra-1",
    currencies: [
      {
        coinDenom: "om",
        coinMinimalDenom: "uom",
        coinDecimals: 6
      }
    ],
    rest: "https://api.mantrachain.io",
    rpc: "https://rpc.mantrachain.io",
    bech32Config: {
      bech32PrefixAccAddr: "mantra",
      bech32PrefixAccPub: "mantrapub",
      bech32PrefixValAddr: "mantravaloper",
      bech32PrefixValPub: "mantravaloperpub",
      bech32PrefixConsAddr: "mantravalcons",
      bech32PrefixConsPub: "mantravalconspub"
    },
    chainName: "mantrachain",
    feeCurrencies: [
      {
        coinDenom: "om",
        coinMinimalDenom: "uom",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.02,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "om",
      coinMinimalDenom: "uom",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "mars-1",
    currencies: [
      {
        coinDenom: "mars",
        coinMinimalDenom: "umars",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.marsprotocol.io:443",
    rpc: "https://rpc.marsprotocol.io:443",
    bech32Config: {
      bech32PrefixAccAddr: "mars",
      bech32PrefixAccPub: "marspub",
      bech32PrefixValAddr: "marsvaloper",
      bech32PrefixValPub: "marsvaloperpub",
      bech32PrefixConsAddr: "marsvalcons",
      bech32PrefixConsPub: "marsvalconspub"
    },
    chainName: "mars",
    feeCurrencies: [
      {
        coinDenom: "mars",
        coinMinimalDenom: "umars",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "mars",
      coinMinimalDenom: "umars",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "medasdigital-1",
    currencies: [
      {
        coinDenom: "medas",
        coinMinimalDenom: "umedas",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.medas-digital.io:1317/",
    rpc: "https://rpc.medas-digital.io:26657/",
    bech32Config: {
      bech32PrefixAccAddr: "medas",
      bech32PrefixAccPub: "medaspub",
      bech32PrefixValAddr: "medasvaloper",
      bech32PrefixValPub: "medasvaloperpub",
      bech32PrefixConsAddr: "medasvalcons",
      bech32PrefixConsPub: "medasvalconspub"
    },
    chainName: "medasdigital",
    feeCurrencies: [
      {
        coinDenom: "medas",
        coinMinimalDenom: "umedas",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.1,
          average: 0.25,
          high: 0.4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "medas",
      coinMinimalDenom: "umedas",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "meme-1",
    currencies: [
      {
        coinDenom: "meme",
        coinMinimalDenom: "umeme",
        coinDecimals: 6
      },
      {
        coinDenom: "planq",
        coinMinimalDenom: "ibc/FACC1CE598366EA01D86CF1CBE05F1A6C7511F673E91DEFF04342ED8DEFE3A60",
        coinDecimals: 18
      }
    ],
    rest: "https://api-meme-1.meme.sx/",
    rpc: "https://rpc-meme-1.meme.sx/",
    bech32Config: {
      bech32PrefixAccAddr: "meme",
      bech32PrefixAccPub: "memepub",
      bech32PrefixValAddr: "memevaloper",
      bech32PrefixValPub: "memevaloperpub",
      bech32PrefixConsAddr: "memevalcons",
      bech32PrefixConsPub: "memevalconspub"
    },
    chainName: "meme",
    feeCurrencies: [
      {
        coinDenom: "meme",
        coinMinimalDenom: "umeme",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.035,
          high: 0.045
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "meme",
      coinMinimalDenom: "umeme",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "migaloo-1",
    currencies: [
      {
        coinDenom: "whale",
        coinMinimalDenom: "uwhale",
        coinDecimals: 6
      },
      {
        coinDenom: "ampWHALE",
        coinMinimalDenom: "factory/migaloo1436kxs0w2es6xlqpp9rd35e3d0cjnw4sv8j3a7483sgks29jqwgshqdky4/ampWHALE",
        coinDecimals: 6
      },
      {
        coinDenom: "bWHALE",
        coinMinimalDenom: "factory/migaloo1mf6ptkssddfmxvhdx0ech0k03ktp6kf9yk59renau2gvht3nq2gqdhts4u/boneWhale",
        coinDecimals: 6
      },
      {
        coinDenom: "fable",
        coinMinimalDenom: "factory/migaloo18a9m9stu3dyvewwcq9qmp85euxqcvln5mefync/fable",
        coinDecimals: 6
      },
      {
        coinDenom: "bluna",
        coinMinimalDenom: "ibc/40C29143BF4153B365089E40E437B7AA819672646C45BB0A5F1E10915A0B6708",
        coinDecimals: 6
      },
      {
        coinDenom: "RAC",
        coinMinimalDenom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/urac",
        coinDecimals: 6
      },
      {
        coinDenom: "ASH",
        coinMinimalDenom: "factory/migaloo1erul6xyq0gk6ws98ncj7lnq9l4jn4gnnu9we73gdz78yyl2lr7qqrvcgup/ash",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/86A25A8A327164AE7C68A29B6ED745C7EEDC36E260A6666F33A6407BECEC4737",
        coinDecimals: 6
      },
      {
        coinDenom: "mUSDC",
        coinMinimalDenom: "cw20:migaloo10nucfm2zqgzqmy7y7ls398t58pjt9cwjsvpy88y2nvamtl34rgmqt5em2v",
        coinDecimals: 6
      },
      {
        coinDenom: "GUPPY",
        coinMinimalDenom: "factory/migaloo1etlu2h30tjvv8rfa4fwdc43c92f6ul5w9acxzk/uguppy",
        coinDecimals: 6
      },
      {
        coinDenom: "OPHIR",
        coinMinimalDenom: "factory/migaloo1t862qdu9mj5hr3j727247acypym3ej47axu22rrapm4tqlcpuseqltxwq5/ophir",
        coinDecimals: 6
      },
      {
        coinDenom: "SHARK",
        coinMinimalDenom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/shark",
        coinDecimals: 6
      },
      {
        coinDenom: "lsdSHARK",
        coinMinimalDenom: "factory/migaloo1p3aj9f09d7c4jxhgue0hpdpw370j6gzc59nxxx6l8d0gc9f9rfwsdwetus/lsdSHARK",
        coinDecimals: 6
      },
      {
        coinDenom: "luna",
        coinMinimalDenom: "ibc/4627AD2524E3E0523047E35BB76CC90E37D9D57ACF14F0FCBCEB2480705F3CB8",
        coinDecimals: 6
      },
      {
        coinDenom: "Rakoff",
        coinMinimalDenom: "ibc/44C29C91F202E20C8E28DFB1FA89B725C54171CD77B8948836C72E7A97E4A018",
        coinDecimals: 6
      },
      {
        coinDenom: "gash",
        coinMinimalDenom: "factory/migaloo1r9x8fz4alekzr78k42rpmr9unpa7egsldpqeynmwl2nfvzexue9sn8l5rg/gash",
        coinDecimals: 6
      },
      {
        coinDenom: "rstk",
        coinMinimalDenom: "factory/migaloo1d0uma9qzcts4fzt7ml39xp44aut5k6qyjfzz4asalnecppppr3rsl52vvv/rstk",
        coinDecimals: 6
      },
      {
        coinDenom: "frog",
        coinMinimalDenom: "ibc/B1BD4EF49A2E051EFC85E8C6A932B559CE62F9519E0E83BE29A8F0BDF89BD1D3",
        coinDecimals: 6
      },
      {
        coinDenom: "GRAC",
        coinMinimalDenom: "factory/migaloo1eqntnl6tzcj9h86psg4y4h6hh05g2h9nj8e09l/ugrac",
        coinDecimals: 6
      },
      {
        coinDenom: "wind",
        coinMinimalDenom: "ibc/721B42229246EEDA7A656DB17E494127F91E84AD63E21852737628321892A928",
        coinDecimals: 6
      },
      {
        coinDenom: "shitmos",
        coinMinimalDenom: "ibc/0E1B883A15D5FCA533332CBAB1A672934C3936920399F2A3EB4F438E3EBAD0E9",
        coinDecimals: 6
      },
      {
        coinDenom: "ampGASH",
        coinMinimalDenom: "factory/migaloo1nsskhvvh0msm7d5ke2kfg24a8d4jecsnxd28s27h0uz5kf9ap60shlqmcl/ampGASH",
        coinDecimals: 6
      },
      {
        coinDenom: "SYN",
        coinMinimalDenom: "ibc/33E97105B5C1F48CB7D6400F4673F9B3699AC59EDB621CCCD57D5D480E0C83B6",
        coinDecimals: 6
      }
    ],
    rest: "https://migaloo-api.polkachu.com:443",
    rpc: "https://migaloo-rpc.polkachu.com:443",
    bech32Config: {
      bech32PrefixAccAddr: "migaloo",
      bech32PrefixAccPub: "migaloopub",
      bech32PrefixValAddr: "migaloovaloper",
      bech32PrefixValPub: "migaloovaloperpub",
      bech32PrefixConsAddr: "migaloovalcons",
      bech32PrefixConsPub: "migaloovalconspub"
    },
    chainName: "migaloo",
    feeCurrencies: [
      {
        coinDenom: "whale",
        coinMinimalDenom: "uwhale",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 2,
          high: 3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "whale",
      coinMinimalDenom: "uwhale",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "mtgbp-1",
    currencies: [
      {
        coinDenom: "mtgbp",
        coinMinimalDenom: "mtgbp",
        coinDecimals: 0
      }
    ],
    rest: "https://lcd.mtgbp.com",
    rpc: "https://rcp.mtgbp.com",
    bech32Config: {
      bech32PrefixAccAddr: "mtgbp",
      bech32PrefixAccPub: "mtgbppub",
      bech32PrefixValAddr: "mtgbpvaloper",
      bech32PrefixValPub: "mtgbpvaloperpub",
      bech32PrefixConsAddr: "mtgbpvalcons",
      bech32PrefixConsPub: "mtgbpvalconspub"
    },
    chainName: "mtgbp",
    feeCurrencies: [
      {
        coinDenom: "mtgbp",
        coinMinimalDenom: "mtgbp",
        coinDecimals: 0,
        gasPriceStep: {
          low: 1e-6,
          average: 5e-6,
          high: 1e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "mtgbp",
      coinMinimalDenom: "mtgbp",
      coinDecimals: 0
    },
    bip44: {
      coinType: 1179993441
    }
  },
  {
    chainId: "mun-1",
    currencies: [
      {
        coinDenom: "mun",
        coinMinimalDenom: "umun",
        coinDecimals: 6
      }
    ],
    rest: "https://mainnet1.mun.money",
    rpc: "https://mainnet1rpc.mun.money",
    bech32Config: {
      bech32PrefixAccAddr: "mun",
      bech32PrefixAccPub: "munpub",
      bech32PrefixValAddr: "munvaloper",
      bech32PrefixValPub: "munvaloperpub",
      bech32PrefixConsAddr: "munvalcons",
      bech32PrefixConsPub: "munvalconspub"
    },
    chainName: "mun",
    feeCurrencies: [
      {
        coinDenom: "mun",
        coinMinimalDenom: "umun",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "mun",
      coinMinimalDenom: "umun",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "mythos_7001-1",
    currencies: [
      {
        coinDenom: "MYT",
        coinMinimalDenom: "aMYT",
        coinDecimals: 18
      }
    ],
    rest: "https://mythos.provable.dev/rest/",
    rpc: "https://mythos-rpc.provable.dev:443/",
    bech32Config: {
      bech32PrefixAccAddr: "mythos",
      bech32PrefixAccPub: "mythospub",
      bech32PrefixValAddr: "mythosvaloper",
      bech32PrefixValPub: "mythosvaloperpub",
      bech32PrefixConsAddr: "mythosvalcons",
      bech32PrefixConsPub: "mythosvalconspub"
    },
    chainName: "mythos",
    feeCurrencies: [
      {
        coinDenom: "MYT",
        coinMinimalDenom: "aMYT",
        coinDecimals: 18
      }
    ],
    stakeCurrency: {
      coinDenom: "MYT",
      coinMinimalDenom: "aMYT",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "Neutaro-1",
    currencies: [
      {
        coinDenom: "neutaro",
        coinMinimalDenom: "uneutaro",
        coinDecimals: 6
      }
    ],
    rest: "https://api2.neutaro.tech:443",
    rpc: "https://rpc2.neutaro.tech:443",
    bech32Config: {
      bech32PrefixAccAddr: "neutaro",
      bech32PrefixAccPub: "neutaropub",
      bech32PrefixValAddr: "neutarovaloper",
      bech32PrefixValPub: "neutarovaloperpub",
      bech32PrefixConsAddr: "neutarovalcons",
      bech32PrefixConsPub: "neutarovalconspub"
    },
    chainName: "neutaro",
    feeCurrencies: [
      {
        coinDenom: "neutaro",
        coinMinimalDenom: "uneutaro",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "neutaro",
      coinMinimalDenom: "uneutaro",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "neutron-1",
    currencies: [
      {
        coinDenom: "ntrn",
        coinMinimalDenom: "untrn",
        coinDecimals: 6
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/C4CFF46FD6DE35CA4CF4CE031E643C8FDC9BA4B99AE598E9B0ED98FE3A2319F9",
        coinDecimals: 6
      },
      {
        coinDenom: "axlusdc",
        coinMinimalDenom: "ibc/F082B65C88E4B6D5EF1DB243CDA1D331D002759E938A0F5CD3FFDC5D53B3E349",
        coinDecimals: 6
      },
      {
        coinDenom: "tia",
        coinMinimalDenom: "ibc/773B4D0A3CD667B2275D5A4A7A2F0909C0BA0F4059C0B9181E680DDF4965DCC7",
        coinDecimals: 6
      },
      {
        coinDenom: "ASTROPEPE",
        coinMinimalDenom: "factory/neutron14henrqx9y328fjrdvz6l6d92r0t7g5hk86q5nd/uastropepe",
        coinDecimals: 6
      },
      {
        coinDenom: "wstETH",
        coinMinimalDenom: "factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH",
        coinDecimals: 18
      },
      {
        coinDenom: "sat",
        coinMinimalDenom: "ibc/DDC3C60EE82BF544F1A0C6A983FF500EF1C14DE20071A5E1E7C0FB470E36E920",
        coinDecimals: 6
      },
      {
        coinDenom: "dydx",
        coinMinimalDenom: "ibc/2CB87BCE0937B1D1DFCEE79BE4501AAF3C265E923509AEAC410AD85D27F35130",
        coinDecimals: 18
      },
      {
        coinDenom: "newt",
        coinMinimalDenom: "factory/neutron1p8d89wvxyjcnawmgw72klknr3lg9gwwl6ypxda/newt",
        coinDecimals: 6
      },
      {
        coinDenom: "astro",
        coinMinimalDenom: "factory/neutron1ffus553eet978k024lmssw0czsxwr97mggyv85lpcsdkft8v9ufsz3sa07/astro",
        coinDecimals: 6
      },
      {
        coinDenom: "xASTRO",
        coinMinimalDenom: "factory/neutron1zlf3hutsa4qnmue53lz2tfxrutp8y2e3rj4nkghg3rupgl4mqy8s5jgxsn/xASTRO",
        coinDecimals: 6
      },
      {
        coinDenom: "astro.cw20",
        coinMinimalDenom: "ibc/5751B8BCDA688FD0A8EC0B292EEF1CDEAB4B766B63EC632778B196D317C40C3A",
        coinDecimals: 6
      },
      {
        coinDenom: "corgi",
        coinMinimalDenom: "factory/neutron1tklm6cvr2wxg8k65t8gh5ewslnzdfd5fsk0w3f/corgi",
        coinDecimals: 6
      },
      {
        coinDenom: "circus",
        coinMinimalDenom: "factory/neutron170v88vrtnedesyfytuku257cggxc79rd7lwt7q/ucircus",
        coinDecimals: 6
      },
      {
        coinDenom: "jimmy",
        coinMinimalDenom: "factory/neutron108x7vp9zv22d6wxrs9as8dshd3pd5vsga463yd/JIMMY",
        coinDecimals: 6
      },
      {
        coinDenom: "bad",
        coinMinimalDenom: "factory/neutron143wp6g8paqasnuuey6zyapucknwy9rhnld8hkr/bad",
        coinDecimals: 6
      },
      {
        coinDenom: "bitcosmos",
        coinMinimalDenom: "neutron1fjzg7fmv770hsvahqm0nwnu6grs3rjnd2wa6fvm9unv6vedkzekqpw44qj",
        coinDecimals: 6
      },
      {
        coinDenom: "wtf",
        coinMinimalDenom: "neutron12h09p8hq5y4xpsmcuxxzsn9juef4f6jvekp8yefc6xnlwm6uumnsdk29wf",
        coinDecimals: 6
      },
      {
        coinDenom: "nls",
        coinMinimalDenom: "ibc/6C9E6701AC217C0FC7D74B0F7A6265B9B4E3C3CDA6E80AADE5F950A8F52F9972",
        coinDecimals: 6
      },
      {
        coinDenom: "goddard",
        coinMinimalDenom: "factory/neutron1t5qrjtyryh8gzt800qr5vylhh2f8cmx4wmz9mc/ugoddard",
        coinDecimals: 6
      },
      {
        coinDenom: "apollo",
        coinMinimalDenom: "factory/neutron154gg0wtm2v4h9ur8xg32ep64e8ef0g5twlsgvfeajqwghdryvyqsqhgk8e/APOLLO",
        coinDecimals: 6
      },
      {
        coinDenom: "newtroll",
        coinMinimalDenom: "factory/neutron1ume2n42r5j0660gegrr28fzdze7aqf7r5cd9y6/newtroll",
        coinDecimals: 6
      },
      {
        coinDenom: "retro",
        coinMinimalDenom: "factory/neutron1t24nc7whl77relnu3taxyg3p66pjyuk82png2y/uretro",
        coinDecimals: 6
      },
      {
        coinDenom: "goddard",
        coinMinimalDenom: "factory/neutron1yqj9vcc0y73xfxjzegaj4v8q0zefevnlpuh4rj/GODDARD",
        coinDecimals: 6
      },
      {
        coinDenom: "WOSMO",
        coinMinimalDenom: "ibc/7DA39F5140741177846FCF3CFAB14450EE7F57B7794E5A94BEF73825D3741958",
        coinDecimals: 6
      },
      {
        coinDenom: "boy",
        coinMinimalDenom: "neutron1uqvse8fdrd9tam47f2jhy9m6al6xxtqpc83f9pdnz5gdle4swc0spfnctv",
        coinDecimals: 6
      },
      {
        coinDenom: "BADKID",
        coinMinimalDenom: "ibc/9F8417FBA11E5E01F7F85DDD48C400EB746E95084C11706041663845B4A700A8",
        coinDecimals: 6
      },
      {
        coinDenom: "cartel",
        coinMinimalDenom: "factory/neutron1w0pz4mjw7n96kkragj8etgfgakg5vw9lzg77wq/cartel",
        coinDecimals: 6
      },
      {
        coinDenom: "ATOM1KLFG",
        coinMinimalDenom: "factory/neutron13lkh47msw28yynspc5rnmty3yktk43wc3dsv0l/ATOM1KLFG",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/B559A80D62249C8AA07A380E2A2BEA6E5CA9A6F079C912C3A9E9B494105E4F81",
        coinDecimals: 6
      },
      {
        coinDenom: "WEIRD",
        coinMinimalDenom: "factory/neutron133xakkrfksq39wxy575unve2nyehg5npx75nph/WEIRD",
        coinDecimals: 6
      },
      {
        coinDenom: "takumi",
        coinMinimalDenom: "factory/neutron19tynwawkm2rgefqxy7weupu4hdamyhg890zep2/TAKUMI",
        coinDecimals: 6
      },
      {
        coinDenom: "NBZ",
        coinMinimalDenom: "factory/neutron1a6ydq8urdj0gkvjw9e9e5y9r5ce2qegm9m4xufpt96kcm60kmuass0mqq4/nbz",
        coinDecimals: 6
      },
      {
        coinDenom: "MARS",
        coinMinimalDenom: "factory/neutron1ndu2wvkrxtane8se2tr48gv7nsm46y5gcqjhux/MARS",
        coinDecimals: 6
      },
      {
        coinDenom: "dATOM",
        coinMinimalDenom: "factory/neutron1k6hr0f83e7un2wjf29cspk7j69jrnskk65k3ek2nj9dztrlzpj6q00rtsa/udatom",
        coinDecimals: 6
      },
      {
        coinDenom: "SIN",
        coinMinimalDenom: "factory/neutron133xakkrfksq39wxy575unve2nyehg5npx75nph/sin",
        coinDecimals: 6
      },
      {
        coinDenom: "GOP",
        coinMinimalDenom: "factory/neutron133xakkrfksq39wxy575unve2nyehg5npx75nph/GOP",
        coinDecimals: 6
      },
      {
        coinDenom: "arena",
        coinMinimalDenom: "factory/neutron129ukd5cwahcjkccujz87rjemjukff7jf6sau72qrhva677xgz9gs4m4jeq/uarena",
        coinDecimals: 6
      }
    ],
    rest: "https://api.novel.remedy.tm.p2p.org",
    rpc: "https://rpc-voidara.neutron-1.neutron.org",
    bech32Config: {
      bech32PrefixAccAddr: "neutron",
      bech32PrefixAccPub: "neutronpub",
      bech32PrefixValAddr: "neutronvaloper",
      bech32PrefixValPub: "neutronvaloperpub",
      bech32PrefixConsAddr: "neutronvalcons",
      bech32PrefixConsPub: "neutronvalconspub"
    },
    chainName: "neutron",
    feeCurrencies: [
      {
        coinDenom: "ntrn",
        coinMinimalDenom: "untrn",
        coinDecimals: 6,
        gasPriceStep: {
          low: 53e-4,
          average: 53e-4,
          high: 53e-4
        }
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/C4CFF46FD6DE35CA4CF4CE031E643C8FDC9BA4B99AE598E9B0ED98FE3A2319F9",
        coinDecimals: 6,
        gasPriceStep: {
          low: 8e-4,
          average: 8e-4,
          high: 8e-4
        }
      },
      {
        coinDenom: "axlusdc",
        coinMinimalDenom: "ibc/F082B65C88E4B6D5EF1DB243CDA1D331D002759E938A0F5CD3FFDC5D53B3E349",
        coinDecimals: 6,
        gasPriceStep: {
          low: 8e-3,
          average: 8e-3,
          high: 8e-3
        }
      },
      {
        coinDenom: "wstETH",
        coinMinimalDenom: "factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH",
        coinDecimals: 18,
        gasPriceStep: {
          low: 29032316597e-4,
          average: 29032316597e-4,
          high: 29032316597e-4
        }
      },
      {
        coinDenom: "dydx",
        coinMinimalDenom: "ibc/2CB87BCE0937B1D1DFCEE79BE4501AAF3C265E923509AEAC410AD85D27F35130",
        coinDecimals: 18,
        gasPriceStep: {
          low: 25641025641026e-4,
          average: 25641025641026e-4,
          high: 25641025641026e-4
        }
      },
      {
        coinDenom: "tia",
        coinMinimalDenom: "ibc/773B4D0A3CD667B2275D5A4A7A2F0909C0BA0F4059C0B9181E680DDF4965DCC7",
        coinDecimals: 6,
        gasPriceStep: {
          low: 4e-4,
          average: 4e-4,
          high: 4e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ntrn",
      coinMinimalDenom: "untrn",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "cataclysm-1",
    currencies: [
      {
        coinDenom: "attonibi",
        coinMinimalDenom: "unibi",
        coinDecimals: 18
      },
      {
        coinDenom: "stNIBI",
        coinMinimalDenom: "tf/nibi1udqqx30cw8nwjxtl4l28ym9hhrp933zlq8dqxfjzcdhvl8y24zcqpzmh8m/ampNIBI",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/F082B65C88E4B6D5EF1DB243CDA1D331D002759E938A0F5CD3FFDC5D53B3E349",
        coinDecimals: 6
      },
      {
        coinDenom: "tf/nibi149m52kn7nvsg5nftvv4fh85scsavpdfxp5nr7zasz97dum89dp5qkyhy0t/uoprek",
        coinMinimalDenom: "tf/nibi149m52kn7nvsg5nftvv4fh85scsavpdfxp5nr7zasz97dum89dp5qkyhy0t/uoprek",
        coinDecimals: 0
      },
      {
        coinDenom: "tf/nibi1lp28kx3gz0prsztl024z730ufkg3alahaq3e7a6gae22nk0dqdvsyrrgqw/utestate",
        coinMinimalDenom: "tf/nibi1lp28kx3gz0prsztl024z730ufkg3alahaq3e7a6gae22nk0dqdvsyrrgqw/utestate",
        coinDecimals: 0
      },
      {
        coinDenom: "tf/nibi1xpp7yn0tce62ffattws3gpd6v0tah0mlevef3ej3r4pnfvsehcgqk3jvxq/NPP",
        coinMinimalDenom: "tf/nibi1xpp7yn0tce62ffattws3gpd6v0tah0mlevef3ej3r4pnfvsehcgqk3jvxq/NPP",
        coinDecimals: 0
      }
    ],
    rest: "https://lcd.nibiru.fi",
    rpc: "https://rpc.nibiru.fi",
    bech32Config: {
      bech32PrefixAccAddr: "nibi",
      bech32PrefixAccPub: "nibipub",
      bech32PrefixValAddr: "nibivaloper",
      bech32PrefixValPub: "nibivaloperpub",
      bech32PrefixConsAddr: "nibivalcons",
      bech32PrefixConsPub: "nibivalconspub"
    },
    chainName: "nibiru",
    feeCurrencies: [
      {
        coinDenom: "attonibi",
        coinMinimalDenom: "unibi",
        coinDecimals: 18,
        gasPriceStep: {
          low: 0.025,
          average: 0.05,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "attonibi",
      coinMinimalDenom: "unibi",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "nim_1122-1",
    currencies: [
      {
        coinDenom: "nim",
        coinMinimalDenom: "anim",
        coinDecimals: 18
      }
    ],
    rest: "https://nim-mainnet-rest.public.blastapi.io",
    rpc: "https://nim-mainnet-tendermint.public.blastapi.io",
    bech32Config: {
      bech32PrefixAccAddr: "nim",
      bech32PrefixAccPub: "nimpub",
      bech32PrefixValAddr: "nimvaloper",
      bech32PrefixValPub: "nimvaloperpub",
      bech32PrefixConsAddr: "nimvalcons",
      bech32PrefixConsPub: "nimvalconspub"
    },
    chainName: "nim",
    feeCurrencies: [
      {
        coinDenom: "nim",
        coinMinimalDenom: "anim",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e10,
          average: 2e10,
          high: 2e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "nim",
      coinMinimalDenom: "anim",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "noble-1",
    currencies: [
      {
        coinDenom: "stake",
        coinMinimalDenom: "ustake",
        coinDecimals: 6
      },
      {
        coinDenom: "frienzies",
        coinMinimalDenom: "ufrienzies",
        coinDecimals: 6
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/EF48E6B1A1A19F47ECAEA62F5670C37C0580E86A9E88498B7E393EB6F49F33C0",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "uusdc",
        coinDecimals: 6
      },
      {
        coinDenom: "usdy",
        coinMinimalDenom: "ausdy",
        coinDecimals: 18
      },
      {
        coinDenom: "eure",
        coinMinimalDenom: "ueure",
        coinDecimals: 6
      }
    ],
    rest: "https://noble-api.polkachu.com",
    rpc: "https://noble-rpc.polkachu.com",
    bech32Config: {
      bech32PrefixAccAddr: "noble",
      bech32PrefixAccPub: "noblepub",
      bech32PrefixValAddr: "noblevaloper",
      bech32PrefixValPub: "noblevaloperpub",
      bech32PrefixConsAddr: "noblevalcons",
      bech32PrefixConsPub: "noblevalconspub"
    },
    chainName: "noble",
    feeCurrencies: [
      {
        coinDenom: "usdc",
        coinMinimalDenom: "uusdc",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.1,
          average: 0.1,
          high: 0.2
        }
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/EF48E6B1A1A19F47ECAEA62F5670C37C0580E86A9E88498B7E393EB6F49F33C0",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.01,
          high: 0.02
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "stake",
      coinMinimalDenom: "ustake",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "nois-1",
    currencies: [
      {
        coinDenom: "nois",
        coinMinimalDenom: "unois",
        coinDecimals: 6
      }
    ],
    rest: "https://m-nois.api.utsa.tech",
    rpc: "https://nois-rpc.nysa.network",
    bech32Config: {
      bech32PrefixAccAddr: "nois",
      bech32PrefixAccPub: "noispub",
      bech32PrefixValAddr: "noisvaloper",
      bech32PrefixValPub: "noisvaloperpub",
      bech32PrefixConsAddr: "noisvalcons",
      bech32PrefixConsPub: "noisvalconspub"
    },
    chainName: "nois",
    feeCurrencies: [
      {
        coinDenom: "nois",
        coinMinimalDenom: "unois",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.05,
          average: 0.05,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "nois",
      coinMinimalDenom: "unois",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "pirin-1",
    currencies: [
      {
        coinDenom: "nls",
        coinMinimalDenom: "unls",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/7FBDBEEEBA9C50C4BCDF7BF438EAB99E64360833D240B32655C96E319559E911",
        coinDecimals: 6
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
        coinDecimals: 6
      },
      {
        coinDenom: "stosmo",
        coinMinimalDenom: "ibc/AF5559D128329B6C753F15481BEC26E533B847A471074703FA4903E7E6F61BA1",
        coinDecimals: 6
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/6CDD4663F2F09CD62285E2D45891FC149A3568E316CE3EBBE201A71A78A69388",
        coinDecimals: 6
      },
      {
        coinDenom: "statom",
        coinMinimalDenom: "ibc/FCFF8B19C61677F3B78E2A5AE3B4A34A8D23858D16905F253B8438B3AFD07FF8",
        coinDecimals: 6
      },
      {
        coinDenom: "weth",
        coinMinimalDenom: "ibc/A7C4A3FB19E88ABE60416125F9189DA680800F4CDD14E3C10C874E022BEFF04C",
        coinDecimals: 18
      },
      {
        coinDenom: "wbtc",
        coinMinimalDenom: "ibc/84E70F4A34FB2DE135FD3A04FDDF53B7DA4206080AA785C8BAB7F8B26299A221",
        coinDecimals: 8
      },
      {
        coinDenom: "akt",
        coinMinimalDenom: "ibc/ADC63C00000CA75F909D2BE3ACB5A9980BED3A73B92746E0FCE6C67414055459",
        coinDecimals: 6
      },
      {
        coinDenom: "axl",
        coinMinimalDenom: "ibc/1B03A71B8E6F6EF424411DC9326A8E0D25D096E4D2616425CFAF2AF06F0FE717",
        coinDecimals: 6
      },
      {
        coinDenom: "juno",
        coinMinimalDenom: "ibc/4F3E83AB35529435E4BFEA001F5D935E7250133347C4E1010A9C77149EF0394C",
        coinDecimals: 6
      },
      {
        coinDenom: "evmos",
        coinMinimalDenom: "ibc/A59A9C955F1AB8B76671B00C1A0482C64A6590352944BB5880E5122358F7E1CE",
        coinDecimals: 18
      },
      {
        coinDenom: "stk/atom",
        coinMinimalDenom: "ibc/DAAD372DB7DD45BBCFA4DDD40CA9793E9D265D1530083AB41A8A0C53C3EBE865",
        coinDecimals: 6
      },
      {
        coinDenom: "scrt",
        coinMinimalDenom: "ibc/EA00FFF0335B07B5CD1530B7EB3D2C710620AE5B168C71AFF7B50532D690E107",
        coinDecimals: 6
      },
      {
        coinDenom: "cro",
        coinMinimalDenom: "ibc/E1BCC0F7B932E654B1A930F72B76C0678D55095387E2A4D8F00E941A8F82EE48",
        coinDecimals: 8
      },
      {
        coinDenom: "stars",
        coinMinimalDenom: "ibc/11E3CF372E065ACB1A39C531A3C7E7E03F60B5D0653AD2139D31128ACD2772B5",
        coinDecimals: 6
      },
      {
        coinDenom: "tia",
        coinMinimalDenom: "ibc/6C349F0EB135C5FA99301758F35B87DB88403D690E5E314AB080401FEE4066E5",
        coinDecimals: 6
      },
      {
        coinDenom: "strd",
        coinMinimalDenom: "ibc/04CA9067228BB51F1C39A506DA00DF07E1496D8308DD21E8EF66AD6169FA722B",
        coinDecimals: 6
      },
      {
        coinDenom: "cudos",
        coinMinimalDenom: "ibc/BB9810E7FE8836311126F15BE0B20E7463189751840F8C3FEF3AC8F87D8AB7C8",
        coinDecimals: 18
      },
      {
        coinDenom: "allBTC",
        coinMinimalDenom: "ibc/E45CFCB959F4F6D1065B7033EE49A88E606E6AD82E75725219B3D68B0FA89987",
        coinDecimals: 8
      },
      {
        coinDenom: "allSOL",
        coinMinimalDenom: "ibc/762E1E45658845A12E214A91C3C05FDFC5951D60404FAADA225A369A96DCD9A9",
        coinDecimals: 9
      },
      {
        coinDenom: "ntrn",
        coinMinimalDenom: "ibc/3D6BC6E049CAEB905AC97031A42800588C58FB471EBDC7A3530FFCD0C3DC9E09",
        coinDecimals: 6
      },
      {
        coinDenom: "dydx",
        coinMinimalDenom: "ibc/6DF8CF5C976851D152E2C7270B0AB25C4F9D64C0A46513A68D6CBB2662A98DF4",
        coinDecimals: 18
      },
      {
        coinDenom: "dATOM",
        coinMinimalDenom: "ibc/EB08474FFC49B6BB2F03F7D9B08697138F4DA53347CA1AB718C8BCFBB58C1B2B",
        coinDecimals: 6
      }
    ],
    rest: "lcd.nolus.network",
    rpc: "rpc.nolus.network",
    bech32Config: {
      bech32PrefixAccAddr: "nolus",
      bech32PrefixAccPub: "noluspub",
      bech32PrefixValAddr: "nolusvaloper",
      bech32PrefixValPub: "nolusvaloperpub",
      bech32PrefixConsAddr: "nolusvalcons",
      bech32PrefixConsPub: "nolusvalconspub"
    },
    chainName: "nolus",
    feeCurrencies: [
      {
        coinDenom: "nls",
        coinMinimalDenom: "unls",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.05
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "nls",
      coinMinimalDenom: "unls",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "nomic-stakenet-3",
    currencies: [
      {
        coinDenom: "nom",
        coinMinimalDenom: "unom",
        coinDecimals: 6
      },
      {
        coinDenom: "nbtc",
        coinMinimalDenom: "usat",
        coinDecimals: 14
      }
    ],
    rest: "https://app.nomic.io:8443",
    rpc: "https://stakenet-rpc.nomic.io:2096",
    bech32Config: {
      bech32PrefixAccAddr: "nomic",
      bech32PrefixAccPub: "nomicpub",
      bech32PrefixValAddr: "nomicvaloper",
      bech32PrefixValPub: "nomicvaloperpub",
      bech32PrefixConsAddr: "nomicvalcons",
      bech32PrefixConsPub: "nomicvalconspub"
    },
    chainName: "nomic",
    feeCurrencies: [
      {
        coinDenom: "nom",
        coinMinimalDenom: "unom",
        coinDecimals: 6
      },
      {
        coinDenom: "nbtc",
        coinMinimalDenom: "usat",
        coinDecimals: 14
      }
    ],
    stakeCurrency: {
      coinDenom: "nom",
      coinMinimalDenom: "unom",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "nyx",
    currencies: [
      {
        coinDenom: "nyx",
        coinMinimalDenom: "unyx",
        coinDecimals: 6
      },
      {
        coinDenom: "nym",
        coinMinimalDenom: "unym",
        coinDecimals: 6
      }
    ],
    rest: "https://nym-api.polkachu.com/",
    rpc: "https://rpc.nymtech.net/",
    bech32Config: {
      bech32PrefixAccAddr: "n",
      bech32PrefixAccPub: "npub",
      bech32PrefixValAddr: "nvaloper",
      bech32PrefixValPub: "nvaloperpub",
      bech32PrefixConsAddr: "nvalcons",
      bech32PrefixConsPub: "nvalconspub"
    },
    chainName: "nyx",
    feeCurrencies: [
      {
        coinDenom: "nym",
        coinMinimalDenom: "unym",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.04
        }
      },
      {
        coinDenom: "nyx",
        coinMinimalDenom: "unyx",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "nyx",
      coinMinimalDenom: "unyx",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "odin-mainnet-freya",
    currencies: [
      {
        coinDenom: "odin",
        coinMinimalDenom: "loki",
        coinDecimals: 6
      },
      {
        coinDenom: "geo",
        coinMinimalDenom: "mGeo",
        coinDecimals: 6
      },
      {
        coinDenom: "O9W",
        coinMinimalDenom: "mO9W",
        coinDecimals: 6
      }
    ],
    rest: "http://34.79.179.216:1317/",
    rpc: "http://34.79.179.216:26657",
    bech32Config: {
      bech32PrefixAccAddr: "odin",
      bech32PrefixAccPub: "odinpub",
      bech32PrefixValAddr: "odinvaloper",
      bech32PrefixValPub: "odinvaloperpub",
      bech32PrefixConsAddr: "odinvalcons",
      bech32PrefixConsPub: "odinvalconspub"
    },
    chainName: "odin",
    feeCurrencies: [
      {
        coinDenom: "odin",
        coinMinimalDenom: "loki",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.05,
          high: 0.06
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "odin",
      coinMinimalDenom: "loki",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "omniflixhub-1",
    currencies: [
      {
        coinDenom: "flix",
        coinMinimalDenom: "uflix",
        coinDecimals: 6
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/A8C2D23A1E6F95DA4E48BA349667E322BD7A6C996D8A4AAE8BA72E190F3D1477",
        coinDecimals: 6
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/0471F1C4E7AFD3F07702BEF6DC365268D64570F7C1FDC98EA6098DD6DE59817B",
        coinDecimals: 6
      },
      {
        coinDenom: "ist",
        coinMinimalDenom: "ibc/43D3010F4CA111744AC8B68E460BC95E565C32928A267FA2B30609C04C10B274",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/AC4C84DD7D3732CFA95A420247FAD5179BE4F42E5635E2BF0A62C67E2E2FA4A9",
        coinDecimals: 6
      },
      {
        coinDenom: "akt",
        coinMinimalDenom: "ibc/6901B45BC2C5418ED8B3C3C9F9A641A3DAF2D234230AFA9DF32D8F9F9434721C",
        coinDecimals: 6
      },
      {
        coinDenom: "baddog",
        coinMinimalDenom: "ibc/9F28238BDB687A86681B30764BA1437E079C3565D04FDD7862055A83F7E5C630",
        coinDecimals: 6
      },
      {
        coinDenom: "ygata",
        coinMinimalDenom: "factory/omniflix1fwphj5p6qd8gtkehkzfgac38eur4uqzgz97uwvf6hsc0vjl004gqfj0xnv/ygata",
        coinDecimals: 6
      }
    ],
    rest: "https://api.omniflix.nodestake.top",
    rpc: "https://omniflix-rpc.kingnodes.com",
    bech32Config: {
      bech32PrefixAccAddr: "omniflix",
      bech32PrefixAccPub: "omniflixpub",
      bech32PrefixValAddr: "omniflixvaloper",
      bech32PrefixValPub: "omniflixvaloperpub",
      bech32PrefixConsAddr: "omniflixvalcons",
      bech32PrefixConsPub: "omniflixvalconspub"
    },
    chainName: "omniflixhub",
    feeCurrencies: [
      {
        coinDenom: "flix",
        coinMinimalDenom: "uflix",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-3,
          average: 25e-4,
          high: 0.025
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "flix",
      coinMinimalDenom: "uflix",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "onex-mainnet-1",
    currencies: [
      {
        coinDenom: "onex",
        coinMinimalDenom: "aonex",
        coinDecimals: 18
      }
    ],
    rest: "https://rest.mainnet.onex.onomy.io",
    rpc: "https://rpc.mainnet.onex.onomy.io",
    bech32Config: {
      bech32PrefixAccAddr: "onomy",
      bech32PrefixAccPub: "onomypub",
      bech32PrefixValAddr: "onomyvaloper",
      bech32PrefixValPub: "onomyvaloperpub",
      bech32PrefixConsAddr: "onomyvalcons",
      bech32PrefixConsPub: "onomyvalconspub"
    },
    chainName: "onex",
    feeCurrencies: [
      {
        coinDenom: "onex",
        coinMinimalDenom: "aonex",
        coinDecimals: 18
      }
    ],
    stakeCurrency: {
      coinDenom: "onex",
      coinMinimalDenom: "aonex",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "onomy-mainnet-1",
    currencies: [
      {
        coinDenom: "nom",
        coinMinimalDenom: "anom",
        coinDecimals: 18
      }
    ],
    rest: "https://rest-mainnet.onomy.io",
    rpc: "https://rpc-mainnet.onomy.io",
    bech32Config: {
      bech32PrefixAccAddr: "onomy",
      bech32PrefixAccPub: "onomypub",
      bech32PrefixValAddr: "onomyvaloper",
      bech32PrefixValPub: "onomyvaloperpub",
      bech32PrefixConsAddr: "onomyvalcons",
      bech32PrefixConsPub: "onomyvalconspub"
    },
    chainName: "onomy",
    feeCurrencies: [
      {
        coinDenom: "nom",
        coinMinimalDenom: "anom",
        coinDecimals: 18
      }
    ],
    stakeCurrency: {
      coinDenom: "nom",
      coinMinimalDenom: "anom",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "Oraichain",
    currencies: [
      {
        coinDenom: "ORAI",
        coinMinimalDenom: "orai",
        coinDecimals: 6
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/A2E2EEC9057A4A1C2C0A6A4C78B0239118DF5F278830F50B4A6BDD7A66506B78",
        coinDecimals: 6
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/9C4DCD21B48231D0BC2AC3D1B74A864746B37E4292694C93C617324250D002FC",
        coinDecimals: 6
      },
      {
        coinDenom: "inj",
        coinMinimalDenom: "ibc/49D820DFDE9F885D7081725A58202ABA2F465CAEE4AFBC683DFB79A8E013E83E",
        coinDecimals: 6
      },
      {
        coinDenom: "inj",
        coinMinimalDenom: "cw20:orai19rtmkk6sn4tppvjmp5d5zj6gfsdykrl5rw2euu5gwur3luheuuusesqn49",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "cw20:orai12hzjxfh77wl572gdzct2fxv2arxcwh6gykc7qh",
        coinDecimals: 6
      },
      {
        coinDenom: "airi",
        coinMinimalDenom: "cw20:orai10ldgzued6zjp0mkqwsv2mux3ml50l97c74x8sg",
        coinDecimals: 6
      },
      {
        coinDenom: "oraix",
        coinMinimalDenom: "cw20:orai1lus0f0rhx8s03gdllx2n6vhkmf0536dv57wfge",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "cw20:orai15un8msx3n5zf9ahlxmfeqd2kwa5wm0nrpxer304m9nd5q6qq0g6sku5pdd",
        coinDecimals: 6
      },
      {
        coinDenom: "kwt",
        coinMinimalDenom: "cw20:orai1nd4r053e3kgedgld2ymen8l9yrw8xpjyaal7j5",
        coinDecimals: 6
      },
      {
        coinDenom: "milky",
        coinMinimalDenom: "cw20:orai1gzvndtzceqwfymu2kqhta2jn6gmzxvzqwdgvjw",
        coinDecimals: 6
      },
      {
        coinDenom: "scorai",
        coinMinimalDenom: "cw20:orai1065qe48g7aemju045aeyprflytemx7kecxkf5m7u5h5mphd0qlcs47pclp",
        coinDecimals: 6
      },
      {
        coinDenom: "wtrx",
        coinMinimalDenom: "cw20:orai1c7tpjenafvgjtgm9aqwm7afnke6c56hpdms8jc6md40xs3ugd0es5encn0",
        coinDecimals: 6
      },
      {
        coinDenom: "scatom",
        coinMinimalDenom: "cw20:orai19q4qak2g3cj2xc2y3060t0quzn3gfhzx08rjlrdd3vqxhjtat0cq668phq",
        coinDecimals: 6
      },
      {
        coinDenom: "xoch",
        coinMinimalDenom: "cw20:orai1lplapmgqnelqn253stz6kmvm3ulgdaytn89a8mz9y85xq8wd684s6xl3lt",
        coinDecimals: 6
      },
      {
        coinDenom: "weth",
        coinMinimalDenom: "cw20:orai1dqa52a7hxxuv8ghe7q5v0s36ra0cthea960q2cukznleqhk0wpnshfegez",
        coinDecimals: 6
      },
      {
        coinDenom: "btc",
        coinMinimalDenom: "cw20:orai10g6frpysmdgw5tdqke47als6f97aqmr8s3cljsvjce4n5enjftcqtamzsd",
        coinDecimals: 6
      },
      {
        coinDenom: "och",
        coinMinimalDenom: "cw20:orai1hn8w33cqvysun2aujk5sv33tku4pgcxhhnsxmvnkfvdxagcx0p8qa4l98q",
        coinDecimals: 6
      },
      {
        coinDenom: "ton",
        coinMinimalDenom: "factory/orai1wuvhex9xqs3r539mvc6mtm7n20fcj3qr2m0y9khx6n5vtlngfzes3k0rq9/ton",
        coinDecimals: 9
      },
      {
        coinDenom: "pepe",
        coinMinimalDenom: "factory/orai1wuvhex9xqs3r539mvc6mtm7n20fcj3qr2m0y9khx6n5vtlngfzes3k0rq9/extPEPE",
        coinDecimals: 6
      },
      {
        coinDenom: "hmstr",
        coinMinimalDenom: "factory/orai1wuvhex9xqs3r539mvc6mtm7n20fcj3qr2m0y9khx6n5vtlngfzes3k0rq9/HMSTR",
        coinDecimals: 9
      }
    ],
    rest: "http://lcd.orai.io",
    rpc: "https://rpc.orai.io",
    bech32Config: {
      bech32PrefixAccAddr: "orai",
      bech32PrefixAccPub: "oraipub",
      bech32PrefixValAddr: "oraivaloper",
      bech32PrefixValPub: "oraivaloperpub",
      bech32PrefixConsAddr: "oraivalcons",
      bech32PrefixConsPub: "oraivalconspub"
    },
    chainName: "oraichain",
    feeCurrencies: [
      {
        coinDenom: "ORAI",
        coinMinimalDenom: "orai",
        coinDecimals: 6,
        gasPriceStep: {
          low: 3e-3,
          average: 5e-3,
          high: 7e-3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ORAI",
      coinMinimalDenom: "orai",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "osmosis-1",
    currencies: [
      {
        coinDenom: "osmo",
        coinMinimalDenom: "uosmo",
        coinDecimals: 6
      },
      {
        coinDenom: "ion",
        coinMinimalDenom: "uion",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/D189335C6E4A68B513C10AB227BF1C1D38C746766278BA3EEB4FB14124F1D858",
        coinDecimals: 6
      },
      {
        coinDenom: "weth",
        coinMinimalDenom: "ibc/EA1D43981D5C9A1C4AAEA9C23BB1D4FA126BA9BC7020A25E0AE4AA841EA25DC5",
        coinDecimals: 18
      },
      {
        coinDenom: "wbtc",
        coinMinimalDenom: "ibc/D1542AA8762DB13087D8364F3EA6509FD6F009A34F00426AF9E4F9FA85CBBF1F",
        coinDecimals: 8
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/8242AD24008032E457D2E12D46588FD39FB54FB29680C6C7663D296B383C37C4",
        coinDecimals: 6
      },
      {
        coinDenom: "dai",
        coinMinimalDenom: "ibc/0CD3A0285E1341859B5E86B6AB7682F023D03E97607CCC1DC95706411D866DF7",
        coinDecimals: 18
      },
      {
        coinDenom: "busd",
        coinMinimalDenom: "ibc/6329DD8CF31A334DD5BE3F68C846C9FE313281362B37686A62343BAC1EB1546D",
        coinDecimals: 18
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
        coinDecimals: 6
      },
      {
        coinDenom: "cro",
        coinMinimalDenom: "ibc/E6931F78057F7CC5DA0FD6CEF82FF39373A6E0452BF1FD76910B93292CF356C1",
        coinDecimals: 8
      },
      {
        coinDenom: "wbnb",
        coinMinimalDenom: "ibc/F4A070A6D78496D53127EA85C094A9EC87DFC1F36071B8CCDDBD020F933D213D",
        coinDecimals: 18
      },
      {
        coinDenom: "wmatic",
        coinMinimalDenom: "ibc/AB589511ED0DD5FA56171A39978AFBF1371DB986EC1C3526CE138A16377E39BB",
        coinDecimals: 18
      },
      {
        coinDenom: "avax",
        coinMinimalDenom: "ibc/6F62F01D913E3FFE472A38C78235B8F021B511BC6596ADFF02615C8F83D3B373",
        coinDecimals: 18
      },
      {
        coinDenom: "luna",
        coinMinimalDenom: "ibc/0EF15DF2F02480ADE0BB6E85D9EBB5DAEA2836D3860E9F97F9AADE4F57A31AA0",
        coinDecimals: 6
      },
      {
        coinDenom: "juno",
        coinMinimalDenom: "ibc/46B44899322F3CD854D2D46DEEF881958467CDD4B3B10086DA49296BBED94BED",
        coinDecimals: 6
      },
      {
        coinDenom: "dot",
        coinMinimalDenom: "ibc/3FF92D26B407FD61AE95D975712A7C319CDE28DE4D80BDC9978D935932B991D7",
        coinDecimals: 10
      },
      {
        coinDenom: "evmos",
        coinMinimalDenom: "ibc/6AE98883D4D5D5FF9E50D7130F1305DA2FFA0C652D1DD9C123657C6B4EB2DF8A",
        coinDecimals: 18
      },
      {
        coinDenom: "kava",
        coinMinimalDenom: "ibc/57AA1A70A4BC9769C525EBF6386F7A21536E04A79D62E1981EFCEF9428EBB205",
        coinDecimals: 6
      },
      {
        coinDenom: "scrt",
        coinMinimalDenom: "ibc/0954E1C28EB7AF5B72D24F3BC2B47BBB2FDF91BDDFD57B74B99E133AED40972A",
        coinDecimals: 6
      },
      {
        coinDenom: "ust",
        coinMinimalDenom: "ibc/BE1BB42D4BE3C30D50B68D7C41DB4DFCE9678E8EF8C539F6E6A9345048894FCC",
        coinDecimals: 6
      },
      {
        coinDenom: "stars",
        coinMinimalDenom: "ibc/987C17B11ABC2B20019178ACE62929FE9840202CE79498E29FE8E5CB02B7C0A4",
        coinDecimals: 6
      },
      {
        coinDenom: "huahua",
        coinMinimalDenom: "ibc/B9E0A1A524E98BB407D3CED8720EFEFD186002F90C1B1B7964811DD0CCC12228",
        coinDecimals: 6
      },
      {
        coinDenom: "xprt",
        coinMinimalDenom: "ibc/A0CC0CF735BFB30E730C70019D4218A1244FF383503FF7579C9201AB93CA9293",
        coinDecimals: 6
      },
      {
        coinDenom: "pstake",
        coinMinimalDenom: "ibc/8061A06D3BD4D52C4A28FFECF7150D370393AF0BA661C3776C54FF32836C3961",
        coinDecimals: 18
      },
      {
        coinDenom: "akt",
        coinMinimalDenom: "ibc/1480B8FD20AD5FCAE81EA87584D269547DD4D436843C1D20F15E00EB64743EF4",
        coinDecimals: 6
      },
      {
        coinDenom: "regen",
        coinMinimalDenom: "ibc/1DCC8A6CB5689018431323953344A9F6CC4D0BFB261E88C9F7777372C10CD076",
        coinDecimals: 6
      },
      {
        coinDenom: "dvpn",
        coinMinimalDenom: "ibc/9712DBB13B9631EDFA9BF61B55F1B2D290B2ADB67E3A4EB3A875F3B6081B3B84",
        coinDecimals: 6
      },
      {
        coinDenom: "iris",
        coinMinimalDenom: "ibc/7C4D60AA95E5A7558B0A364860979CA34B7FF8AAF255B87AF9E879374470CEC0",
        coinDecimals: 6
      },
      {
        coinDenom: "iov",
        coinMinimalDenom: "ibc/52B1AA623B34EB78FD767CEA69E8D7FA6C9CFE1FBF49C5406268FD325E2CC2AC",
        coinDecimals: 6
      },
      {
        coinDenom: "ngm",
        coinMinimalDenom: "ibc/1DC495FCEFDA068A3820F903EDBD78B942FBD204D7E93D3BA2B432E9669D1A59",
        coinDecimals: 6
      },
      {
        coinDenom: "eur",
        coinMinimalDenom: "ibc/5973C068568365FFF40DEDCF1A1CB7582B6116B731CD31A12231AE25E20B871F",
        coinDecimals: 6
      },
      {
        coinDenom: "like",
        coinMinimalDenom: "ibc/9989AD6CCA39D1131523DB0617B50F6442081162294B4795E26746292467B525",
        coinDecimals: 9
      },
      {
        coinDenom: "ixo",
        coinMinimalDenom: "ibc/F3FF7A84A73B62921538642F9797C423D2B4C4ACB3C7FCFFCE7F12AA69909C4B",
        coinDecimals: 6
      },
      {
        coinDenom: "bcna",
        coinMinimalDenom: "ibc/D805F1DA50D31B96E4282C1D4181EDDFB1A44A598BFF5666F4B43E4B8BEA95A5",
        coinDecimals: 6
      },
      {
        coinDenom: "btsg",
        coinMinimalDenom: "ibc/4E5444C35610CC76FC94E7F7886B93121175C28262DDFDDE6F84E82BF2425452",
        coinDecimals: 6
      },
      {
        coinDenom: "xki",
        coinMinimalDenom: "ibc/B547DC9B897E7C3AA5B824696110B8E3D2C31E3ED3F02FF363DCBAD82457E07E",
        coinDecimals: 6
      },
      {
        coinDenom: "med",
        coinMinimalDenom: "ibc/3BCCC93AD5DF58D11A6F8A05FA8BC801CBA0BA61A981F57E91B8B598BF8061CB",
        coinDecimals: 6
      },
      {
        coinDenom: "ibc/FE2CD1E6828EC0FAB8AF39BAC45BC25B965BA67CCBC50C13A14BD610B0D1E2C4",
        coinMinimalDenom: "ibc/FE2CD1E6828EC0FAB8AF39BAC45BC25B965BA67CCBC50C13A14BD610B0D1E2C4",
        coinDecimals: 0
      },
      {
        coinDenom: "cmdx",
        coinMinimalDenom: "ibc/EA3E1640F9B1532AB129A571203A0B9F789A7F14BB66E350DCBFA18E1A1931F0",
        coinDecimals: 6
      },
      {
        coinDenom: "cheq",
        coinMinimalDenom: "ibc/7A08C6F11EF0F59EB841B9F788A87EC9F2361C7D9703157EC13D940DC53031FA",
        coinDecimals: 9
      },
      {
        coinDenom: "lum",
        coinMinimalDenom: "ibc/8A34AF0C1943FD0DFCDE9ADBF0B2C9959C45E87E6088EA2FC6ADACD59261B8A2",
        coinDecimals: 6
      },
      {
        coinDenom: "vdl",
        coinMinimalDenom: "ibc/E7B35499CFBEB0FF5778127ABA4FB2C4B79A6B8D3D831D4379C4048C238796BD",
        coinDecimals: 6
      },
      {
        coinDenom: "dsm",
        coinMinimalDenom: "ibc/EA4C0A9F72E2CEDF10D0E7A9A6A22954DB3444910DB5BE980DF59B05A46DAD1C",
        coinDecimals: 6
      },
      {
        coinDenom: "dig",
        coinMinimalDenom: "ibc/307E5C96C8F60D1CBEE269A9A86C0834E1DB06F2B3788AE4F716EDB97A48B97D",
        coinDecimals: 6
      },
      {
        coinDenom: "somm",
        coinMinimalDenom: "ibc/9BBA9A1C257E971E38C1422780CE6F0B0686F0A3085E2D61118D904BFE0F5F5E",
        coinDecimals: 6
      },
      {
        coinDenom: "band",
        coinMinimalDenom: "ibc/F867AE2112EFE646EC71A25CD2DFABB8927126AC1E19F1BBF0FF693A4ECA05DE",
        coinDecimals: 6
      },
      {
        coinDenom: "darc",
        coinMinimalDenom: "ibc/346786EA82F41FE55FAD14BF69AD8BA9B36985406E43F3CB23E6C45A285A9593",
        coinDecimals: 6
      },
      {
        coinDenom: "umee",
        coinMinimalDenom: "ibc/67795E528DF67C5606FC20F824EA39A6EF55BA133F4DC79C90A8C47A0901E17C",
        coinDecimals: 6
      },
      {
        coinDenom: "graviton",
        coinMinimalDenom: "ibc/E97634A40119F1898989C2A23224ED83FDD0A57EA46B3A094E287288D1672B44",
        coinDecimals: 6
      },
      {
        coinDenom: "dec",
        coinMinimalDenom: "ibc/9BCB27203424535B6230D594553F1659C77EC173E36D9CF4759E7186EE747E84",
        coinDecimals: 6
      },
      {
        coinDenom: "marble",
        coinMinimalDenom: "ibc/F6B691D5F7126579DDC87357B09D653B47FDCE0A3383FF33C8D8B544FE29A8A6",
        coinDecimals: 3
      },
      {
        coinDenom: "dswth",
        coinMinimalDenom: "ibc/8FEFAE6AECF6E2A255585617F781F35A8D5709A545A804482A261C0C9548A9D3",
        coinDecimals: 8
      },
      {
        coinDenom: "crbrus",
        coinMinimalDenom: "ibc/41999DF04D9441DAC0DF5D8291DF4333FBCBA810FFD63FDCE34FDF41EF37B6F7",
        coinDecimals: 6
      },
      {
        coinDenom: "fet",
        coinMinimalDenom: "ibc/5D1F516200EE8C6B2354102143B78A2DEDA25EDE771AC0F8DC3C1837C8FD4447",
        coinDecimals: 18
      },
      {
        coinDenom: "mntl",
        coinMinimalDenom: "ibc/CBA34207E969623D95D057D9B11B0C8B32B89A71F170577D982FDDE623813FFC",
        coinDecimals: 6
      },
      {
        coinDenom: "neta",
        coinMinimalDenom: "ibc/297C64CC42B5A8D8F82FE2EBE208A6FE8F94B86037FA28C4529A23701C228F7A",
        coinDecimals: 6
      },
      {
        coinDenom: "INJ",
        coinMinimalDenom: "ibc/64BA6E31FE887D66C6F8F31C7B1A80C7CA179239677B4088BB55F5EA07DBE273",
        coinDecimals: 18
      },
      {
        coinDenom: "krt",
        coinMinimalDenom: "ibc/204A582244FC241613DBB50B04D1D454116C58C4AF7866C186AA0D6EEAD42780",
        coinDecimals: 6
      },
      {
        coinDenom: "tick",
        coinMinimalDenom: "ibc/655BCEF3CDEBE32863FF281DBBE3B06160339E9897DC9C9C9821932A5F8BA6F8",
        coinDecimals: 6
      },
      {
        coinDenom: "ROWAN",
        coinMinimalDenom: "ibc/8318FD63C42203D16DDCAF49FE10E8590669B3219A3E87676AC9DA50722687FB",
        coinDecimals: 18
      },
      {
        coinDenom: "ctk",
        coinMinimalDenom: "ibc/7ED954CFFFC06EE8419387F3FC688837FF64EF264DE14219935F724EEEDBF8D3",
        coinDecimals: 6
      },
      {
        coinDenom: "hope",
        coinMinimalDenom: "ibc/C2A2E9CA95DDD4828B75124B5E27B8401C7D8493BC48353D418CBFC04565899B",
        coinDecimals: 6
      },
      {
        coinDenom: "rac",
        coinMinimalDenom: "ibc/6BDB4C8CCD45033F9604E4B93ED395008A753E01EECD6992E7D1EA23D9D3B788",
        coinDecimals: 6
      },
      {
        coinDenom: "frax",
        coinMinimalDenom: "ibc/0E43EDE2E2A3AFA36D0CD38BDDC0B49FECA64FA426A82E102F304E430ECF46EE",
        coinDecimals: 18
      },
      {
        coinDenom: "gwbtc",
        coinMinimalDenom: "ibc/C9B0D48FD2C5B91135F118FF2484551888966590D7BDC20F6A87308DBA670796",
        coinDecimals: 8
      },
      {
        coinDenom: "gweth",
        coinMinimalDenom: "ibc/65381C5F3FD21442283D56925E62EA524DED8B6927F0FF94E21E0020954C40B5",
        coinDecimals: 18
      },
      {
        coinDenom: "gusdc",
        coinMinimalDenom: "ibc/9F9B07EF9AD291167CF5700628145DE1DEB777C2CFC7907553B24446515F6D0E",
        coinDecimals: 6
      },
      {
        coinDenom: "gdai",
        coinMinimalDenom: "ibc/F292A17CF920E3462C816CBE6B042E779F676CAB59096904C4C1C966413E3DF5",
        coinDecimals: 18
      },
      {
        coinDenom: "gusdt",
        coinMinimalDenom: "ibc/71B441E27F1BBB44DD0891BCD370C2794D404D60A4FFE5AECCD9B1E28BC89805",
        coinDecimals: 6
      },
      {
        coinDenom: "block",
        coinMinimalDenom: "ibc/DB9755CB6FE55192948AE074D18FA815E1429D3D374D5BDA8D89623C6CF235C3",
        coinDecimals: 6
      },
      {
        coinDenom: "hash",
        coinMinimalDenom: "ibc/CE5BFF1D9BADA03BB5CCA5F56939392A761B53A10FBD03B37506669C3218D3B2",
        coinDecimals: 9
      },
      {
        coinDenom: "glx",
        coinMinimalDenom: "ibc/F49DE040EBA5AB2FAD5F660C2A1DDF98A68470FAE82229818BE775EBF3EE79F2",
        coinDecimals: 6
      },
      {
        coinDenom: "ibc/52E12CF5CA2BB903D84F5298B4BFD725D66CAB95E09AA4FC75B2904CA5485FEB",
        coinMinimalDenom: "ibc/52E12CF5CA2BB903D84F5298B4BFD725D66CAB95E09AA4FC75B2904CA5485FEB",
        coinDecimals: 0
      },
      {
        coinDenom: "raw",
        coinMinimalDenom: "ibc/00B6E60AD3D65CBEF5579AC8AF609527C0B57535B6E32D96C80A735344FD9DCC",
        coinDecimals: 6
      },
      {
        coinDenom: "meme",
        coinMinimalDenom: "ibc/67C89B8B0A70C08F093C909A4DD996DD10E0494C87E28FD9A551697BF173D4CA",
        coinDecimals: 6
      },
      {
        coinDenom: "asvt",
        coinMinimalDenom: "ibc/AA1C80225BCA7B32ED1FC6ABF8B8E899BEB48ECDB4B417FD69873C6D715F97E7",
        coinDecimals: 6
      },
      {
        coinDenom: "joe",
        coinMinimalDenom: "ibc/0CB9DB3441D0D50F35699DEE22B9C965487E83FB2D9F483D1CC5CA34E856C484",
        coinDecimals: 6
      },
      {
        coinDenom: "luna",
        coinMinimalDenom: "ibc/785AFEC6B3741100D15E7AF01374E3C4C36F24888E96479B1C33F5C71F364EF9",
        coinDecimals: 6
      },
      {
        coinDenom: "atolo",
        coinMinimalDenom: "ibc/2716E3F2E146664BEFA9217F1A03BFCEDBCD5178B3C71CACB1A0D7584451D219",
        coinDecimals: 6
      },
      {
        coinDenom: "HARD",
        coinMinimalDenom: "ibc/D6C28E07F7343360AC41E15DDD44D79701DDCA2E0C2C41279739C8D4AE5264BC",
        coinDecimals: 6
      },
      {
        coinDenom: "SWP",
        coinMinimalDenom: "ibc/70CF1A54E23EA4E480DEDA9E12082D3FD5684C3483CBDCE190C5C807227688C5",
        coinDecimals: 6
      },
      {
        coinDenom: "link",
        coinMinimalDenom: "ibc/D3327A763C23F01EC43D1F0DB3CEFEC390C362569B6FD191F40A5192F8960049",
        coinDecimals: 18
      },
      {
        coinDenom: "l1",
        coinMinimalDenom: "ibc/F16FDC11A7662B86BC0B9CE61871CBACF7C20606F95E86260FD38915184B75B4",
        coinDecimals: 18
      },
      {
        coinDenom: "aave",
        coinMinimalDenom: "ibc/384E5DD50BDE042E1AAF51F312B55F08F95BC985C503880189258B4D9374CBBE",
        coinDecimals: 18
      },
      {
        coinDenom: "ape",
        coinMinimalDenom: "ibc/F83CC6471DA4D4B508F437244F10B9E4C68975344E551A2DEB6B8617AB08F0D4",
        coinDecimals: 18
      },
      {
        coinDenom: "mkr",
        coinMinimalDenom: "ibc/D27DDDF34BB47E5D5A570742CC667DE53277867116CCCA341F27785E899A70F3",
        coinDecimals: 18
      },
      {
        coinDenom: "rai",
        coinMinimalDenom: "ibc/BD796662F8825327D41C96355DF62045A5BA225BAE31C0A86289B9D88ED3F44E",
        coinDecimals: 18
      },
      {
        coinDenom: "shib",
        coinMinimalDenom: "ibc/19305E20681911F14D1FB275E538CDE524C3BF88CF9AE5D5F78F4D4DA05E85B2",
        coinDecimals: 18
      },
      {
        coinDenom: "kuji",
        coinMinimalDenom: "ibc/BB6BCDB515050BAE97516111873CCD7BCF1FD0CCB723CC12F3C4F704D6C646CE",
        coinDecimals: 6
      },
      {
        coinDenom: "tgd",
        coinMinimalDenom: "ibc/1E09CB0F506ACF12FDE4683FB6B34DA62FB4BE122641E0D93AAF98A87675676C",
        coinDecimals: 6
      },
      {
        coinDenom: "echelon",
        coinMinimalDenom: "ibc/47EE224A9B33CF0ABEAC82106E52F0F6E8D8CEC5BA80B9D9A6F55172CBB0177D",
        coinDecimals: 18
      },
      {
        coinDenom: "odin",
        coinMinimalDenom: "ibc/C360EF34A86D334F625E4CBB7DA3223AEA97174B61F35BB3758081A8160F7D9B",
        coinDecimals: 6
      },
      {
        coinDenom: "geo",
        coinMinimalDenom: "ibc/9B6FBABA36BB4A3BF127AE5E96B572A5197FD9F3111D895D8919B07BC290764A",
        coinDecimals: 6
      },
      {
        coinDenom: "O9W",
        coinMinimalDenom: "ibc/0CD46223FEABD2AEAAAF1F057D01E63BCA79B7D4BD6B68F1EB973A987344695D",
        coinDecimals: 6
      },
      {
        coinDenom: "lvn",
        coinMinimalDenom: "ibc/AD185F62399F770CCCE8A36A180A77879FF6C26A0398BD3D2A74E087B0BFA121",
        coinDecimals: 6
      },
      {
        coinDenom: "wglmr",
        coinMinimalDenom: "ibc/1E26DB0E5122AED464D98462BD384FCCB595732A66B3970AE6CE0B58BAE0FC49",
        coinDecimals: 18
      },
      {
        coinDenom: "glto",
        coinMinimalDenom: "ibc/52C57FCA7D6854AA178E7A183DDBE4EF322B904B1D719FC485F6FFBC1F72A19E",
        coinDecimals: 6
      },
      {
        coinDenom: "gkey",
        coinMinimalDenom: "ibc/7C781B4C2082CD62129A972D47486D78EC17155C299270E3C89348EA026BEAF8",
        coinDecimals: 6
      },
      {
        coinDenom: "cre",
        coinMinimalDenom: "ibc/5A7C219BA5F7582B99629BA3B2A01A61BFDA0F6FD1FE95B5366F7334C4BC0580",
        coinDecimals: 6
      },
      {
        coinDenom: "lumen",
        coinMinimalDenom: "ibc/FFA652599C77E853F017193E36B5AB2D4D9AFC4B54721A74904F80C9236BF3B7",
        coinDecimals: 6
      },
      {
        coinDenom: "ORAI",
        coinMinimalDenom: "ibc/161D7D62BAB3B9C39003334F1671208F43C06B643CC9EDBBE82B64793C857F1D",
        coinDecimals: 6
      },
      {
        coinDenom: "cudos",
        coinMinimalDenom: "ibc/E09ED39F390EC51FA9F3F69BEA08B5BBE6A48B3057B2B1C3467FAAE9E58B021B",
        coinDecimals: 18
      },
      {
        coinDenom: "USDX",
        coinMinimalDenom: "ibc/C78F65E1648A3DFE0BAEB6C4CDA69CC2A75437F1793C0E6386DFDA26393790AE",
        coinDecimals: 6
      },
      {
        coinDenom: "bld",
        coinMinimalDenom: "ibc/2DA9C149E9AD2BD27FEFA635458FB37093C256C1A940392634A16BEA45262604",
        coinDecimals: 6
      },
      {
        coinDenom: "ist",
        coinMinimalDenom: "ibc/92BE0717F4678905E53F4E45B2DED18BC0CB97BF1F8B6A25AFEDF3D5A879B4D5",
        coinDecimals: 6
      },
      {
        coinDenom: "sejuno",
        coinMinimalDenom: "ibc/C6B6BFCB6EE49A7CAB1A7E7B021DE35B99D525AC660844952F0F6C78DCB2A57B",
        coinDecimals: 6
      },
      {
        coinDenom: "bjuno",
        coinMinimalDenom: "ibc/C2DF5C3949CA835B221C575625991F09BAB4E48FB9C11A4EE357194F736111E3",
        coinDecimals: 6
      },
      {
        coinDenom: "strd",
        coinMinimalDenom: "ibc/A8CA5EE328FA10C9519DF6057DA1F69682D28F7D0F5CCC7ECB72E3DCA2D157A4",
        coinDecimals: 6
      },
      {
        coinDenom: "statom",
        coinMinimalDenom: "ibc/C140AFD542AE77BD7DCC83F13FDD8C5E5BB8C4929785E6EC2F4C636F98F17901",
        coinDecimals: 6
      },
      {
        coinDenom: "ststars",
        coinMinimalDenom: "ibc/5DD1F95ED336014D00CE2520977EC71566D282F9749170ADC83A392E0EA7426A",
        coinDecimals: 6
      },
      {
        coinDenom: "solar",
        coinMinimalDenom: "ibc/C3FC4DED273E7D1DD2E7BAA3317EC9A53CD3252B577AA33DC00D9DF2BDF3ED5C",
        coinDecimals: 6
      },
      {
        coinDenom: "seasy",
        coinMinimalDenom: "ibc/18A676A074F73B9B42DA4F9DFC8E5AEF334C9A6636DDEC8D34682F52F1DECDF6",
        coinDecimals: 6
      },
      {
        coinDenom: "axl",
        coinMinimalDenom: "ibc/903A61A498756EA560B85A85132D3AEE21B5DEDD41213725D22ABF276EA6945E",
        coinDecimals: 6
      },
      {
        coinDenom: "rebus",
        coinMinimalDenom: "ibc/A1AC7F9EE2F643A68E3A35BCEB22040120BEA4059773BB56985C76BDFEBC71D9",
        coinDecimals: 18
      },
      {
        coinDenom: "tori",
        coinMinimalDenom: "ibc/EB7FB9C8B425F289B63703413327C2051030E848CE4EAAEA2E51199D6D39D3EC",
        coinDecimals: 6
      },
      {
        coinDenom: "stjuno",
        coinMinimalDenom: "ibc/84502A75BCA4A5F68D464C00B3F610CE2585847D59B52E5FFB7C3C9D2DDCD3FE",
        coinDecimals: 6
      },
      {
        coinDenom: "stosmo",
        coinMinimalDenom: "ibc/D176154B0C63D1F9C6DCFB4F70349EBF2E2B5A87A05902F57A6AE92B863E9AEC",
        coinDecimals: 6
      },
      {
        coinDenom: "muse",
        coinMinimalDenom: "ibc/6B982170CE024689E8DD0E7555B129B488005130D4EDA426733D552D10B36D8F",
        coinDecimals: 6
      },
      {
        coinDenom: "lamb",
        coinMinimalDenom: "ibc/80825E8F04B12D914ABEADB1F4D39C04755B12C8402F6876EE3168450C0A90BB",
        coinDecimals: 18
      },
      {
        coinDenom: "usk",
        coinMinimalDenom: "ibc/44492EAB24B72E3FB59B9FA619A22337FB74F95D8808FE6BC78CC0E6C18DC2EC",
        coinDecimals: 6
      },
      {
        coinDenom: "FUND",
        coinMinimalDenom: "ibc/608EF5C0CE64FEA097500DB39657BDD36CA708CC5DCC2E250A024B6981DD36BC",
        coinDecimals: 9
      },
      {
        coinDenom: "jkl",
        coinMinimalDenom: "ibc/8E697BDABE97ACE8773C6DF7402B2D1D5104DD1EEABE12608E3469B7F64C15BA",
        coinDecimals: 6
      },
      {
        coinDenom: "alter",
        coinMinimalDenom: "ibc/A6383B6CF5EA23E067666C06BC34E2A96869927BD9744DC0C1643E589C710AA3",
        coinDecimals: 6
      },
      {
        coinDenom: "butt",
        coinMinimalDenom: "ibc/1FBA9E763B8679BEF7BAAAF2D16BCA78C3B297D226C3F31312C769D7B8F992D8",
        coinDecimals: 6
      },
      {
        coinDenom: "shd",
        coinMinimalDenom: "ibc/71055835C7639739EAE03AACD1324FE162DBA41D09F197CB72D966D014225B1C",
        coinDecimals: 8
      },
      {
        coinDenom: "sienna",
        coinMinimalDenom: "ibc/9A8A93D04917A149C8AC7C16D3DA8F470D59E8D867499C4DA97450E1D7363213",
        coinDecimals: 18
      },
      {
        coinDenom: "stkd-scrt",
        coinMinimalDenom: "ibc/D0E5BF2940FB58D9B283A339032DE88111407AAD7D94A7F1F3EB78874F8616D4",
        coinDecimals: 6
      },
      {
        coinDenom: "bze",
        coinMinimalDenom: "ibc/C822645522FC3EECF817609AA38C24B64D04F5C267A23BCCF8F2E3BC5755FA88",
        coinDecimals: 6
      },
      {
        coinDenom: "fury",
        coinMinimalDenom: "ibc/7CE5F388D661D82A0774E47B5129DA51CC7129BD1A70B5FA6BCEBB5B0A2FAEAF",
        coinDecimals: 6
      },
      {
        coinDenom: "acre",
        coinMinimalDenom: "ibc/BB936517F7E5D77A63E0ADB05217A6608B0C4CF8FBA7EA2F4BAE4107A7238F06",
        coinDecimals: 18
      },
      {
        coinDenom: "cmst",
        coinMinimalDenom: "ibc/23CA6C8D1AB2145DD13EB1E089A2E3F960DC298B468CCE034E19E5A78B61136E",
        coinDecimals: 6
      },
      {
        coinDenom: "imv",
        coinMinimalDenom: "ibc/92B223EBFA74DB99BEA92B23DEAA6050734FEEAABB84689CB8E1AE8F9C9F9AF4",
        coinDecimals: 18
      },
      {
        coinDenom: "medas",
        coinMinimalDenom: "ibc/01E94A5FF29B8DDEFC86F412CC3927F7330E9B523CC63A6194B1108F5276025C",
        coinDecimals: 6
      },
      {
        coinDenom: "phmn",
        coinMinimalDenom: "ibc/D3B574938631B0A1BA704879020C696E514CFADAA7643CDE4BD5EB010BDE327B",
        coinDecimals: 6
      },
      {
        coinDenom: "amber",
        coinMinimalDenom: "ibc/18A1B70E3205A48DE8590C0D11030E7146CDBF1048789261D53FFFD7527F8B55",
        coinDecimals: 6
      },
      {
        coinDenom: "nom",
        coinMinimalDenom: "ibc/B9606D347599F0F2FDF82BA3EE339000673B7D274EA50F59494DC51EFCD42163",
        coinDecimals: 18
      },
      {
        coinDenom: "stkatom",
        coinMinimalDenom: "ibc/CAA179E40F0266B0B29FB5EAA288FB9212E628822265D4141EBD1C47C3CBFCBC",
        coinDecimals: 6
      },
      {
        coinDenom: "ibc/E27CD305D33F150369AB526AEB6646A76EC3FFB1A6CA58A663B5DE657A89D55D",
        coinMinimalDenom: "ibc/E27CD305D33F150369AB526AEB6646A76EC3FFB1A6CA58A663B5DE657A89D55D",
        coinDecimals: 0
      },
      {
        coinDenom: "hopers",
        coinMinimalDenom: "ibc/D3ADAF73F84CDF205BCB72C142FDAEEA2C612AB853CEE6D6C06F184FA38B1099",
        coinDecimals: 6
      },
      {
        coinDenom: "arusd",
        coinMinimalDenom: "ibc/5D270A584B1078FBE07D14570ED5E88EC1FEDA8518B76C322606291E6FD8286F",
        coinDecimals: 18
      },
      {
        coinDenom: "planq",
        coinMinimalDenom: "ibc/B1E0166EA0D759FDF4B207D1F5F12210D8BFE36F2345CEFC76948CE2B36DFBAF",
        coinDecimals: 18
      },
      {
        coinDenom: "ftm",
        coinMinimalDenom: "ibc/5E2DFDF1734137302129EA1C1BA21A580F96F778D4F021815EA4F6DB378DA1A4",
        coinDecimals: 18
      },
      {
        coinDenom: "canto",
        coinMinimalDenom: "ibc/47CAF2DB8C016FAC960F33BC492FD8E454593B65CC59D70FA9D9F30424F9C32F",
        coinDecimals: 18
      },
      {
        coinDenom: "qstars",
        coinMinimalDenom: "ibc/46C83BB054E12E189882B5284542DB605D94C99827E367C9192CF0579CD5BC83",
        coinDecimals: 6
      },
      {
        coinDenom: "wynd",
        coinMinimalDenom: "ibc/2FBAC4BF296D7844796844B35978E5899984BA5A6314B2DD8F83C215550010B3",
        coinDecimals: 6
      },
      {
        coinDenom: "polygon-usdc",
        coinMinimalDenom: "ibc/231FD77ECCB2DB916D314019DA30FE013202833386B1908A191D16989AD80B5A",
        coinDecimals: 6
      },
      {
        coinDenom: "avalanche-usdc",
        coinMinimalDenom: "ibc/F17C9CA112815613C5B6771047A093054F837C3020CBA59DFFD9D780A8B2984C",
        coinDecimals: 6
      },
      {
        coinDenom: "MARS.old",
        coinMinimalDenom: "ibc/573FCD90FACEE750F55A8864EF7D38265F07E5A9273FA0E8DAFD39951332B580",
        coinDecimals: 6
      },
      {
        coinDenom: "cnto",
        coinMinimalDenom: "ibc/D38BB3DD46864694F009AF01DA5A815B3A875F8CC52FF5679BFFCC35DC7451D5",
        coinDecimals: 18
      },
      {
        coinDenom: "stluna",
        coinMinimalDenom: "ibc/C491E7582E94AE921F6A029790083CDE1106C28F3F6C4AD7F1340544C13EC372",
        coinDecimals: 6
      },
      {
        coinDenom: "stevmos",
        coinMinimalDenom: "ibc/C5579A9595790017C600DD726276D978B9BF314CF82406CE342720A9C7911A01",
        coinDecimals: 18
      },
      {
        coinDenom: "nride",
        coinMinimalDenom: "ibc/E750D31033DC1CF4A044C3AA0A8117401316DC918FBEBC4E3D34F91B09D5F54C",
        coinDecimals: 6
      },
      {
        coinDenom: "ebl",
        coinMinimalDenom: "ibc/8BE73A810E22F80E5E850531A688600D63AE7392E7C2770AE758CAA4FD921B7F",
        coinDecimals: 6
      },
      {
        coinDenom: "qatom",
        coinMinimalDenom: "ibc/FA602364BEC305A696CBDF987058E99D8B479F0318E47314C49173E8838C5BAC",
        coinDecimals: 6
      },
      {
        coinDenom: "harbor",
        coinMinimalDenom: "ibc/AD4DEA52408EA07C0C9E19444EC8DA84A274A70AD2687A710EFDDEB28BB2986A",
        coinDecimals: 6
      },
      {
        coinDenom: "qregen",
        coinMinimalDenom: "ibc/79A676508A2ECA1021EDDC7BB9CF70CEEC9514C478DA526A5A8B3E78506C2206",
        coinDecimals: 6
      },
      {
        coinDenom: "fox",
        coinMinimalDenom: "ibc/4F24D904BAB5FFBD3524F2DE3EC3C7A9E687A2408D9A985E57B356D9FA9201C6",
        coinDecimals: 6
      },
      {
        coinDenom: "qck",
        coinMinimalDenom: "ibc/635CB83EF1DFE598B10A3E90485306FD0D47D34217A4BE5FD9977FA010A5367D",
        coinDecimals: 6
      },
      {
        coinDenom: "ARKH",
        coinMinimalDenom: "ibc/0F91EE8B98AAE3CF393D94CD7F89A10F8D7758C5EC707E721899DFE65C164C28",
        coinDecimals: 6
      },
      {
        coinDenom: "qosmo",
        coinMinimalDenom: "ibc/42D24879D4569CE6477B7E88206ADBFE47C222C6CAD51A54083E4A72594269FC",
        coinDecimals: 6
      },
      {
        coinDenom: "frienzies",
        coinMinimalDenom: "ibc/7FA7EC64490E3BDE5A1A28CBE73CC0AD22522794957BC891C46321E3A6074DB9",
        coinDecimals: 6
      },
      {
        coinDenom: "whale",
        coinMinimalDenom: "ibc/EDD6F0D66BCD49C1084FB2C35353B4ACD7B9191117CE63671B61320548F7C89D",
        coinDecimals: 6
      },
      {
        coinDenom: "grdn",
        coinMinimalDenom: "ibc/BAC9C6998F1F5C316D3353622EAEDAF8BD00FAABEB374FECDF8C9BC475172CFA",
        coinDecimals: 6
      },
      {
        coinDenom: "mnpu",
        coinMinimalDenom: "ibc/DC0D3303BBE739E073224D0314385B88B247F56D71D726A91414CCA244FFFE7E",
        coinDecimals: 6
      },
      {
        coinDenom: "shibac",
        coinMinimalDenom: "ibc/447A0DCE83691056289503DDAB8EB08E52E167A73629F2ACC59F056B92F51CE8",
        coinDecimals: 6
      },
      {
        coinDenom: "sikoba",
        coinMinimalDenom: "ibc/71066B030D8FC6479E638580E1BA9C44925E8C1F6E45036669D22017CFDC8C5E",
        coinDecimals: 6
      },
      {
        coinDenom: "nct",
        coinMinimalDenom: "ibc/A76EB6ECF4E3E2D4A23C526FD1B48FDD42F171B206C9D2758EF778A7826ADD68",
        coinDecimals: 6
      },
      {
        coinDenom: "clst",
        coinMinimalDenom: "ibc/0E4FA664327BD40B32803EE84A77F145834C0281B7F82B65521333B3669FA0BA",
        coinDecimals: 6
      },
      {
        coinDenom: "osdoge",
        coinMinimalDenom: "ibc/8AEEA9B9304392070F72611076C0E328CE3F2DECA1E18557E36F9DB4F09C0156",
        coinDecimals: 6
      },
      {
        coinDenom: "apemos",
        coinMinimalDenom: "ibc/1EB03F13F29FEA73444586FC4E88A8C14ACE9291501E9658E3BEF951EA4AC85D",
        coinDecimals: 6
      },
      {
        coinDenom: "invdrs",
        coinMinimalDenom: "ibc/3DB1721541C94AD19D7735FECED74C227E13F925BDB814392980B40A19C1ED54",
        coinDecimals: 6
      },
      {
        coinDenom: "doga",
        coinMinimalDenom: "ibc/04BE4E9C825ED781F9684A1226114BB49607500CAD855F1E3FEEC18532297250",
        coinDecimals: 6
      },
      {
        coinDenom: "catmos",
        coinMinimalDenom: "ibc/F4A07138CAEF0BFB4889E03C44C57956A48631061F1C8AB80421C1F229C1B835",
        coinDecimals: 6
      },
      {
        coinDenom: "summit",
        coinMinimalDenom: "ibc/56B988C4D934FB7503F5EA9B440C75D489C8AD5D193715B477BEC4F84B8BBA2A",
        coinDecimals: 6
      },
      {
        coinDenom: "flix",
        coinMinimalDenom: "ibc/CEE970BB3D26F4B907097B6B660489F13F3B0DA765B83CC7D9A0BC0CE220FA6F",
        coinDecimals: 6
      },
      {
        coinDenom: "spacer",
        coinMinimalDenom: "ibc/7A496DB7C2277D4B74EC4428DDB5AC8A62816FBD0DEBE1CFE094935D746BE19C",
        coinDecimals: 6
      },
      {
        coinDenom: "light",
        coinMinimalDenom: "ibc/3DC08BDF2689978DBCEE28C7ADC2932AA658B2F64B372760FBC5A0058669AD29",
        coinDecimals: 9
      },
      {
        coinDenom: "silk",
        coinMinimalDenom: "ibc/8A025A1E70101E39DE0C0F153E582A30806D3DA16795F6D868A3AA247D2DEDF7",
        coinDecimals: 6
      },
      {
        coinDenom: "mile",
        coinMinimalDenom: "ibc/912275A63A565BFD80734AEDFFB540132C51E446EAC41483B26EDE8A557C71CF",
        coinDecimals: 6
      },
      {
        coinDenom: "manna",
        coinMinimalDenom: "ibc/980A2748F37C938AD129B92A51E2ABA8CFFC6862ADD61EC1B291125535DBE30B",
        coinDecimals: 6
      },
      {
        coinDenom: "fil",
        coinMinimalDenom: "ibc/18FB5C09D9D2371F659D4846A956FA56225E377EE3C3652A2BF3542BF809159D",
        coinDecimals: 18
      },
      {
        coinDenom: "void",
        coinMinimalDenom: "ibc/593F820ECE676A3E0890C734EC4F3A8DE16EC10A54EEDFA8BDFEB40EEA903960",
        coinDecimals: 6
      },
      {
        coinDenom: "shd",
        coinMinimalDenom: "ibc/0B3D528E74E3DEAADF8A68F393887AC7E06028904D02173561B0D27F6E751D0A",
        coinDecimals: 8
      },
      {
        coinDenom: "bnt",
        coinMinimalDenom: "ibc/63CDD51098FD99E04E5F5610A3882CBE7614C441607BA6FCD7F3A3C1CD5325F8",
        coinDecimals: 6
      },
      {
        coinDenom: "arb",
        coinMinimalDenom: "ibc/10E5E5B06D78FFBB61FD9F89209DEE5FD4446ED0550CBB8E3747DA79E10D9DC6",
        coinDecimals: 18
      },
      {
        coinDenom: "silica",
        coinMinimalDenom: "ibc/5164ECF584AD7DC27DA9E6A89E75DAB0F7C4FCB0A624B69215B8BC6A2C40CD07",
        coinDecimals: 6
      },
      {
        coinDenom: "pepec",
        coinMinimalDenom: "ibc/C00B17F74C94449A62935B4C886E6F0F643249A270DEF269D53CE6741ECCDB93",
        coinDecimals: 6
      },
      {
        coinDenom: "pepe",
        coinMinimalDenom: "ibc/E47F4E97C534C95B942729E1B25DBDE111EA791411CFF100515050BEA0AC0C6B",
        coinDecimals: 18
      },
      {
        coinDenom: "ibcx",
        coinMinimalDenom: "factory/osmo14klwqgkmackvx2tqa0trtg69dmy0nrg4ntq4gjgw2za4734r5seqjqm4gm/uibcx",
        coinDecimals: 6
      },
      {
        coinDenom: "cbeth",
        coinMinimalDenom: "ibc/4D7A6F2A7744B1534C984A21F9EDFFF8809FC71A9E9243FFB702073E7FCA513A",
        coinDecimals: 18
      },
      {
        coinDenom: "reth",
        coinMinimalDenom: "ibc/E610B83FD5544E00A8A1967A2EB3BEF25F1A8CFE8650FE247A8BD4ECA9DC9222",
        coinDecimals: 18
      },
      {
        coinDenom: "sfrxeth",
        coinMinimalDenom: "ibc/81F578C39006EB4B27FFFA9460954527910D73390991B379C03B18934D272F46",
        coinDecimals: 18
      },
      {
        coinDenom: "wsteth",
        coinMinimalDenom: "ibc/B2BD584CD2A0A9CE53D4449667E26160C7D44A9C41AF50F602C201E5B3CCA46C",
        coinDecimals: 18
      },
      {
        coinDenom: "LORE",
        coinMinimalDenom: "ibc/B1C1806A540B3E165A2D42222C59946FB85BA325596FC85662D7047649F419F3",
        coinDecimals: 6
      },
      {
        coinDenom: "roar",
        coinMinimalDenom: "ibc/98BCD43F190C6960D0005BC46BB765C827403A361C9C03C2FF694150A30284B0",
        coinDecimals: 6
      },
      {
        coinDenom: "stumee",
        coinMinimalDenom: "ibc/02F196DA6FD0917DD5FEA249EE61880F4D941EE9059E7964C5C9B50AF103800F",
        coinDecimals: 6
      },
      {
        coinDenom: "stibcx",
        coinMinimalDenom: "factory/osmo1xqw2sl9zk8a6pch0csaw78n4swg5ws8t62wc5qta4gnjxfqg6v2qcs243k/stuibcx",
        coinDecimals: 6
      },
      {
        coinDenom: "nls",
        coinMinimalDenom: "ibc/D9AFCECDD361D38302AA66EB3BAC23B95234832C51D12489DC451FA2B7C72782",
        coinDecimals: 6
      },
      {
        coinDenom: "cub",
        coinMinimalDenom: "ibc/6F18EFEBF1688AA77F7EAC17065609494DC1BA12AFC78E9AEC832AF70A11BEF3",
        coinDecimals: 6
      },
      {
        coinDenom: "blue",
        coinMinimalDenom: "ibc/DA961FE314B009C38595FFE3AF41225D8894D663B8C3F6650DCB5B6F8435592E",
        coinDecimals: 6
      },
      {
        coinDenom: "ntrn",
        coinMinimalDenom: "ibc/126DA09104B71B164883842B769C0E9EC1486C0887D27A9999E395C2C8FB5682",
        coinDecimals: 6
      },
      {
        coinDenom: "casa",
        coinMinimalDenom: "ibc/2F5C084037D951B24D100F15CC013A131DF786DCE1B1DBDC48F018A9B9A138DE",
        coinDecimals: 6
      },
      {
        coinDenom: "pica",
        coinMinimalDenom: "ibc/56D7C03B8F6A07AD322EEE1BEF3AE996E09D1C1E34C27CF37E0D4A0AC5972516",
        coinDecimals: 12
      },
      {
        coinDenom: "ksm",
        coinMinimalDenom: "ibc/6727B2F071643B3841BD535ECDD4ED9CAE52ABDD0DCD07C3630811A7A37B215C",
        coinDecimals: 12
      },
      {
        coinDenom: "dot",
        coinMinimalDenom: "ibc/6B2B19D874851F631FF0AF82C38A20D4B82F438C7A22F41EDA33568345397244",
        coinDecimals: 10
      },
      {
        coinDenom: "qsr",
        coinMinimalDenom: "ibc/1B708808D372E959CD4839C594960309283424C775F4A038AAEBE7F83A988477",
        coinDecimals: 6
      },
      {
        coinDenom: "arch",
        coinMinimalDenom: "ibc/23AB778D694C1ECFC59B91D8C399C115CC53B0BD1C61020D8E19519F002BDD85",
        coinDecimals: 18
      },
      {
        coinDenom: "mpwr",
        coinMinimalDenom: "ibc/DD3938D8131F41994C1F01F4EB5233DEE9A0A5B787545B9A07A321925655BF38",
        coinDecimals: 6
      },
      {
        coinDenom: "watr",
        coinMinimalDenom: "ibc/AABCB14ACAFD53A5C455BAC01EA0CA5AE18714895846681A52BFF1E3B960B44E",
        coinDecimals: 6
      },
      {
        coinDenom: "kyve",
        coinMinimalDenom: "ibc/613BF0BF2F2146AE9941E923725745E931676B2C14E9768CD609FA0849B2AE13",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/4ABBEF4C8926DDDB320AE5188CFD63267ABBCEFC0583E4AE05D6E5AA2401DDAB",
        coinDecimals: 6
      },
      {
        coinDenom: "ampOSMO",
        coinMinimalDenom: "factory/osmo1dv8wz09tckslr2wy5z86r46dxvegylhpt97r9yd6qc3kyc6tv42qa89dr9/ampOSMO",
        coinDecimals: 6
      },
      {
        coinDenom: "sei",
        coinMinimalDenom: "ibc/71F11BC0AF8E526B80E44172EBA9D3F0A8E03950BB882325435691EBC9450B1D",
        coinDecimals: 6
      },
      {
        coinDenom: "qsomm",
        coinMinimalDenom: "ibc/EAF76AD1EEF7B16D167D87711FB26ABE881AC7D9F7E6D0CF313D5FA530417208",
        coinDecimals: 6
      },
      {
        coinDenom: "pasg",
        coinMinimalDenom: "ibc/208B2F137CDE510B44C41947C045CFDC27F996A9D990EA64460BDD5B3DBEB2ED",
        coinDecimals: 6
      },
      {
        coinDenom: "stsomm",
        coinMinimalDenom: "ibc/5A0060579D24FBE5268BEA74C3281E7FE533D361C41A99307B4998FEC611E46B",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/8sYgCzLRJC3J7qPn2bNbx6PiGcarhyx8rBhVaNnfvHCA/8",
        coinMinimalDenom: "ibc/1E43D59E565D41FB4E54CA639B838FFD5BCFC20003D330A56CB1396231AA1CBA",
        coinDecimals: 8
      },
      {
        coinDenom: "wormhole/95mnwzvJZJ3fKz77xfGN2nR5to9pZmH8YNvaxgLgw5AR/5",
        coinMinimalDenom: "ibc/CA3733CB0071F480FAE8EF0D9C3D47A49C6589144620A642BBE0D59A293D110E",
        coinDecimals: 5
      },
      {
        coinDenom: "wormhole/8iuAc6DSeLvi2JDUtwJxLytsZT8R19itXebZsNReLLNi/6",
        coinMinimalDenom: "ibc/2108F2D81CBE328F371AD0CEF56691B18A86E08C3651504E42487D9EE92DDE9C",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/46YEtoSN1AcwgGSRoWruoS6bnVh8XpMp5aQTpKohCJYh/8",
        coinMinimalDenom: "ibc/B1C287C2701774522570010EEBCD864BCB7AB714711B3AA218699FDD75E832F5",
        coinDecimals: 8
      },
      {
        coinDenom: "wormhole/5wS2fGojbL9RhGEAeQBdkHPUAciYDxjDTMYvdf9aDn2r/8",
        coinMinimalDenom: "ibc/A4D176906C1646949574B48C1928D475F2DF56DE0AC04E1C99B08F90BC21ABDE",
        coinDecimals: 8
      },
      {
        coinDenom: "mnta",
        coinMinimalDenom: "ibc/51D893F870B7675E507E91DA8DB0B22EA66333207E4F5C0708757F08EE059B0B",
        coinDecimals: 6
      },
      {
        coinDenom: "dgl",
        coinMinimalDenom: "ibc/D69F6D787EC649F4E998161A9F0646F4C2DCC64748A2AB982F14CAFBA7CC0EC9",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/GGh9Ufn1SeDGrhzEkMyRKt5568VbbxZK2yvWNsd6PbXt/6",
        coinMinimalDenom: "ibc/6B99DB46AA9FF47162148C1726866919E44A6A5E0274B90912FD17E19A337695",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/5BWqpR48Lubd55szM5i62zK7TFkddckhbT48yy6mNbDp/8",
        coinMinimalDenom: "ibc/62F82550D0B96522361C89B0DA1119DE262FBDFB25E5502BC5101B5C0D0DBAAC",
        coinDecimals: 8
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/498A0751C798A0D9A389AA3691123DADA57DAA4FE165D5C75894505B876BA6E4",
        coinDecimals: 6
      },
      {
        coinDenom: "YieldETH",
        coinMinimalDenom: "ibc/FBB3FEF80ED2344D821D4F95C31DBFD33E4E31D5324CAD94EF756E67B749F668",
        coinDecimals: 18
      },
      {
        coinDenom: "xpla",
        coinMinimalDenom: "ibc/95C9B5870F95E21A242E6AF9ADCB1F212EE4A8855087226C36FBE43FC41A77B8",
        coinDecimals: 18
      },
      {
        coinDenom: "oin",
        coinMinimalDenom: "ibc/98B3DBF1FA79C4C14CC5F08F62ACD5498560FCB515F677526FD200D54EA048B6",
        coinDecimals: 6
      },
      {
        coinDenom: "neok",
        coinMinimalDenom: "ibc/DEE262653B9DE39BCEF0493D47E0DFC4FE62F7F046CF38B9FDEFEBE98D149A71",
        coinDecimals: 18
      },
      {
        coinDenom: "rio",
        coinMinimalDenom: "ibc/1CDF9C7D073DD59ED06F15DB08CC0901F2A24759BE70463570E8896F9A444ADF",
        coinDecimals: 18
      },
      {
        coinDenom: "cdt",
        coinMinimalDenom: "factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/ucdt",
        coinDecimals: 6
      },
      {
        coinDenom: "mbrn",
        coinMinimalDenom: "factory/osmo1s794h9rxggytja3a4pmwul53u98k06zy2qtrdvjnfuxruh7s8yjs6cyxgd/umbrn",
        coinDecimals: 6
      },
      {
        coinDenom: "sge",
        coinMinimalDenom: "ibc/A1830DECC0B742F0B2044FF74BE727B5CF92C9A28A9235C3BACE4D24A23504FA",
        coinDecimals: 6
      },
      {
        coinDenom: "fis",
        coinMinimalDenom: "ibc/01D2F0C4739C871BFBEE7E786709E6904A55559DC1483DD92ED392EF12247862",
        coinDecimals: 6
      },
      {
        coinDenom: "ratom",
        coinMinimalDenom: "ibc/B66CE615C600ED0A8B5AF425ECFE0D57BE2377587F66C45934A76886F34DC9B7",
        coinDecimals: 6
      },
      {
        coinDenom: "strdst",
        coinMinimalDenom: "ibc/CFF40564FDA3E958D9904B8B479124987901168494655D9CC6B7C0EC0416020B",
        coinDecimals: 6
      },
      {
        coinDenom: "DORA",
        coinMinimalDenom: "ibc/672406ADE4EDFD8C5EA7A0D0DD0C37E431DA7BD8393A15CD2CFDE3364917EB2A",
        coinDecimals: 18
      },
      {
        coinDenom: "core",
        coinMinimalDenom: "ibc/F3166F4D31D6BA1EC6C9F5536F5DDDD4CC93DBA430F7419E7CDC41C497944A65",
        coinDecimals: 6
      },
      {
        coinDenom: "tia",
        coinMinimalDenom: "ibc/D79E7D83AB399BFFF93433E54FAA480C191248FC556924A2A8351AE2638B3877",
        coinDecimals: 6
      },
      {
        coinDenom: "dydx",
        coinMinimalDenom: "ibc/831F0B1BBB1D08A2B75311892876D71565478C532967545476DF4C2D7492E48C",
        coinDecimals: 18
      },
      {
        coinDenom: "WFX",
        coinMinimalDenom: "ibc/2B30802A0B03F91E4E16D6175C9B70F2911377C1CAE9E50FF011C821465463F9",
        coinDecimals: 18
      },
      {
        coinDenom: "nbtc",
        coinMinimalDenom: "ibc/75345531D87BD90BF108BE7240BD721CB2CB0A1F16D4EBA71B09EC3C43E15C8F",
        coinDecimals: 14
      },
      {
        coinDenom: "nois",
        coinMinimalDenom: "ibc/6928AFA9EA721938FED13B051F9DBF1272B16393D20C49EA5E4901BB76D94A90",
        coinDecimals: 6
      },
      {
        coinDenom: "sqosmo",
        coinMinimalDenom: "factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/squosmo",
        coinDecimals: 6
      },
      {
        coinDenom: "nstk",
        coinMinimalDenom: "ibc/F74225B0AFD2F675AF56E9BE3F235486BCDE5C5E09AA88A97AFD2E052ABFE04C",
        coinDecimals: 6
      },
      {
        coinDenom: "BRNCH",
        coinMinimalDenom: "ibc/71DAA4CAFA4FE2F9803ABA0696BA5FC0EFC14305A2EA8B4E01880DB851B1EC02",
        coinDecimals: 6
      },
      {
        coinDenom: "wstETH",
        coinMinimalDenom: "ibc/2F21E6D4271DE3F561F20A02CD541DAF7405B1E9CB3B9B07E3C2AC7D8A4338A5",
        coinDecimals: 18
      },
      {
        coinDenom: "sqatom",
        coinMinimalDenom: "factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqatom",
        coinDecimals: 6
      },
      {
        coinDenom: "sqbtc",
        coinMinimalDenom: "factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqbtc",
        coinDecimals: 6
      },
      {
        coinDenom: "qwoyn",
        coinMinimalDenom: "ibc/09FAF1E04435E14C68DE7AB0D03C521C92975C792DB12B2EA390BAA2E06B3F3D",
        coinDecimals: 6
      },
      {
        coinDenom: "ibc/4F3B0EC2FE2D370D10C3671A1B7B06D2A964C721470C305CBB846ED60E6CAA20",
        coinMinimalDenom: "ibc/4F3B0EC2FE2D370D10C3671A1B7B06D2A964C721470C305CBB846ED60E6CAA20",
        coinDecimals: 0
      },
      {
        coinDenom: "ibc/BCDB35B7390806F35E716D275E1E017999F8281A81B6F128F087EF34D1DFA761",
        coinMinimalDenom: "ibc/BCDB35B7390806F35E716D275E1E017999F8281A81B6F128F087EF34D1DFA761",
        coinDecimals: 0
      },
      {
        coinDenom: "volt",
        coinMinimalDenom: "ibc/D3A1900B2B520E45608B5671ADA461E1109628E89B4289099557C6D3996F7DAA",
        coinDecimals: 3
      },
      {
        coinDenom: "ampere",
        coinMinimalDenom: "ibc/020F5162B7BC40656FC5432622647091F00D53E82EE8D21757B43D3282F25424",
        coinDecimals: 3
      },
      {
        coinDenom: "source",
        coinMinimalDenom: "ibc/E7905742CE2EA4EA5D592527DC89220C59B617DE803939FE7293805A64B484D7",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/B8ohBnfisop27exk2gtNABJyYjLwQA7ogrp5uNzvZCoy/6",
        coinMinimalDenom: "ibc/E42006ED917C769EDE1B474650EEA6BFE3F97958912B9206DD7010A28D01D9D5",
        coinDecimals: 6
      },
      {
        coinDenom: "stkosmo",
        coinMinimalDenom: "ibc/ECBE78BF7677320A93E7BA1761D144BCBF0CBC247C290C049655E106FE5DC68E",
        coinDecimals: 6
      },
      {
        coinDenom: "lvn",
        coinMinimalDenom: "factory/osmo1mlng7pz4pnyxtpq0akfwall37czyk9lukaucsrn30ameplhhshtqdvfm5c/ulvn",
        coinDecimals: 6
      },
      {
        coinDenom: "puppy",
        coinMinimalDenom: "ibc/46AC07DBFF1352EC94AF5BD4D23740D92D9803A6B41F6E213E77F3A1143FB963",
        coinDecimals: 6
      },
      {
        coinDenom: "newt",
        coinMinimalDenom: "ibc/BF685448E564B5A4AC8F6E0493A0B979D0E0BF5EC11F7E15D25A0A2160C944DD",
        coinDecimals: 6
      },
      {
        coinDenom: "milkTIA",
        coinMinimalDenom: "factory/osmo1f5vfcph2dvfeqcqkhetwv75fda69z7e5c2dldm3kvgj23crkv6wqcn47a0/umilkTIA",
        coinDecimals: 6
      },
      {
        coinDenom: "ASH",
        coinMinimalDenom: "ibc/4976049456D261659D0EC499CC9C2391D3C7D1128A0B9FB0BBF2842D1B2BC7BC",
        coinDecimals: 6
      },
      {
        coinDenom: "RAC",
        coinMinimalDenom: "ibc/DDF1CD4CDC14AE2D6A3060193624605FF12DEE71CF1F8C19EEF35E9447653493",
        coinDecimals: 6
      },
      {
        coinDenom: "GUPPY",
        coinMinimalDenom: "ibc/42A9553A7770F3D7B62F3A82AF04E7719B4FD6EAF31BE5645092AAC4A6C2201D",
        coinDecimals: 6
      },
      {
        coinDenom: "ISLM",
        coinMinimalDenom: "ibc/69110FF673D70B39904FF056CFDFD58A90BEC3194303F45C32CB91B8B0A738EA",
        coinDecimals: 18
      },
      {
        coinDenom: "autism",
        coinMinimalDenom: "ibc/9DDF52A334F92BC57A9E0D59DFF9984EAC61D2A14E5162605DF601AA58FDFC6D",
        coinDecimals: 6
      },
      {
        coinDenom: "page",
        coinMinimalDenom: "ibc/23A62409E4AD8133116C249B1FA38EED30E500A115D7B153109462CD82C1CD99",
        coinDecimals: 8
      },
      {
        coinDenom: "PURSE",
        coinMinimalDenom: "ibc/6FD2938076A4C1BB3A324A676E76B0150A4443DAE0E002FB62AC0E6B604B1519",
        coinDecimals: 18
      },
      {
        coinDenom: "NINJA",
        coinMinimalDenom: "ibc/183C0BB962D2F57C957E0B134CFA0AC9D6F755C02DE9DC2A59089BA23009DEC3",
        coinDecimals: 6
      },
      {
        coinDenom: "kleo",
        coinMinimalDenom: "ibc/5F5B7DA5ECC80F6C7A8702D525BB0B74279B1F7B8EFAE36E423D68788F7F39FF",
        coinDecimals: 6
      },
      {
        coinDenom: "nyx",
        coinMinimalDenom: "ibc/1A611E8A3E4248106A1A5A80A64BFA812739435E8B9888EB3F652A21F029F317",
        coinDecimals: 6
      },
      {
        coinDenom: "nym",
        coinMinimalDenom: "ibc/37CB3078432510EE57B9AFA8DBE028B33AE3280A144826FEAC5F2334CF2C5539",
        coinDecimals: 6
      },
      {
        coinDenom: "achihuahuawifhat",
        coinMinimalDenom: "ibc/2FFE07C4B4EFC0DDA099A16C6AF3C9CCA653CC56077E87217A585D48794B0BC7",
        coinDecimals: 6
      },
      {
        coinDenom: "circus",
        coinMinimalDenom: "ibc/8C8F6349F656C943543C6B040377BE44123D01F712277815C3C13098BB98818C",
        coinDecimals: 6
      },
      {
        coinDenom: "jape",
        coinMinimalDenom: "ibc/176DD560277BB0BD676260BE02EBAB697725CA85144D8A2BF286C6B5323DB5FE",
        coinDecimals: 6
      },
      {
        coinDenom: "WOOF",
        coinMinimalDenom: "ibc/9B8EC667B6DF55387DC0F3ACC4F187DA6921B0806ED35DE6B04DE96F5AB81F53",
        coinDecimals: 6
      },
      {
        coinDenom: "sneaky",
        coinMinimalDenom: "ibc/94ED1F172BC633DFC56D7E26551D8B101ADCCC69052AC44FED89F97FF658138F",
        coinDecimals: 6
      },
      {
        coinDenom: "wbtc",
        coinMinimalDenom: "factory/osmo1z0qrq605sjgcqpylfl4aa6s90x738j7m58wyatt0tdzflg2ha26q67k743/wbtc",
        coinDecimals: 8
      },
      {
        coinDenom: "bad",
        coinMinimalDenom: "ibc/442A08C33AE9875DF90792FFA73B5728E1CAECE87AB4F26AE9B422F1E682ED23",
        coinDecimals: 6
      },
      {
        coinDenom: "sgnl",
        coinMinimalDenom: "ibc/4BDADBEDA31899036AB286E9901116496A9D85FB87B35A408C9D67C0DCAC660A",
        coinDecimals: 6
      },
      {
        coinDenom: "WOSMO",
        coinMinimalDenom: "factory/osmo1pfyxruwvtwk00y8z06dh2lqjdj82ldvy74wzm3/WOSMO",
        coinDecimals: 6
      },
      {
        coinDenom: "sqtia",
        coinMinimalDenom: "factory/osmo1g8qypve6l95xmhgc0fddaecerffymsl7kn9muw/sqtia",
        coinDecimals: 6
      },
      {
        coinDenom: "apollo",
        coinMinimalDenom: "ibc/73BB20AF857D1FE6E061D01CA13870872AD0C979497CAF71BEA25B1CBF6879F1",
        coinDecimals: 6
      },
      {
        coinDenom: "stDYDX",
        coinMinimalDenom: "ibc/980E82A9F8E7CA8CD480F4577E73682A6D3855A267D1831485D7EBEF0E7A6C2C",
        coinDecimals: 18
      },
      {
        coinDenom: "stTIA",
        coinMinimalDenom: "ibc/698350B8A61D575025F3ED13E9AC9C0F45C89DEFE92F76D5838F1D3C1A7FF7C9",
        coinDecimals: 6
      },
      {
        coinDenom: "stSAGA",
        coinMinimalDenom: "ibc/2CD9F8161C3FC332E78EF0C25F6E684D09379FB2F56EF9267E7EC139642EC57B",
        coinDecimals: 6
      },
      {
        coinDenom: "stINJ",
        coinMinimalDenom: "ibc/C04DFC9BCD893E57F2BEFE40F63EFD18D2768514DBD5F63ABD2FF7F48FC01D36",
        coinDecimals: 18
      },
      {
        coinDenom: "glto",
        coinMinimalDenom: "ibc/072E5B3D6F278B3E6A9C51D7EAD1A737148609512C5EBE8CBCB5663264A0DDB7",
        coinDecimals: 6
      },
      {
        coinDenom: "dym",
        coinMinimalDenom: "ibc/9A76CDF0CBCEF37923F32518FA15E5DC92B9F56128292BC4D63C4AEA76CBB110",
        coinDecimals: 18
      },
      {
        coinDenom: "RAPTR",
        coinMinimalDenom: "factory/osmo1279xudevmf5cw83vkhglct7jededp86k90k2le/RAPTR",
        coinDecimals: 6
      },
      {
        coinDenom: "astro.cw20",
        coinMinimalDenom: "ibc/C25A2303FE24B922DAFFDCE377AC5A42E5EF746806D32E2ED4B610DE85C203F7",
        coinDecimals: 6
      },
      {
        coinDenom: "BADKID",
        coinMinimalDenom: "factory/osmo10n8rv8npx870l69248hnp6djy6pll2yuzzn9x8/BADKID",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/HJk1XMDRNUbRrpKkNZYui7SwWDMjXZAsySzqgyNcQoU3/6",
        coinMinimalDenom: "ibc/F08DE332018E8070CC4C68FE06E04E254F527556A614F5F8F9A68AF38D367E45",
        coinDecimals: 6
      },
      {
        coinDenom: "heart",
        coinMinimalDenom: "ibc/35CECC330D11DD00FACB555D07687631E0BC7D226260CC5F015F6D7980819533",
        coinDecimals: 18
      },
      {
        coinDenom: "berlin",
        coinMinimalDenom: "ibc/2BF9656CAB0384A31167DB9B0254F0FB1CB4346A229BD7E5CBDCBB911C3740F7",
        coinDecimals: 18
      },
      {
        coinDenom: "scr",
        coinMinimalDenom: "ibc/178248C262DE2E141EE6287EE7AB0854F05F25B0A3F40C4B912FA1C7E51F466E",
        coinDecimals: 9
      },
      {
        coinDenom: "c4e",
        coinMinimalDenom: "ibc/62118FB4D5FEDD5D2B18DC93648A745CD5E5B01D420E9B7A5FED5381CB13A7E8",
        coinDecimals: 6
      },
      {
        coinDenom: "bitmos",
        coinMinimalDenom: "ibc/7D389F0ABF1E4D45BE6D7BBE36A2C50EA0559C01E076B02F8E381E685EC1F942",
        coinDecimals: 6
      },
      {
        coinDenom: "srcx",
        coinMinimalDenom: "ibc/C97473CD237EBA2F94FDFA6ABA5EC0E22FA140655D73D2A2754F03A347BBA40B",
        coinDecimals: 9
      },
      {
        coinDenom: "rock",
        coinMinimalDenom: "ibc/0835781EF3F3ADD053874323AB660C75B50B18B16733CAB783CA6BBD78244EDF",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/bqqqpqsxzelp2hdfd4cgmxr6ekpatlj8yt2eghk52vst/5",
        coinMinimalDenom: "ibc/CDD1E59BD5034C1B2597DD199782204EB397DB93200AA2E99C0AF3A66B2915FA",
        coinDecimals: 5
      },
      {
        coinDenom: "aioz",
        coinMinimalDenom: "ibc/BB0AFE2AFBD6E883690DAE4B9168EAC2B306BCC9C9292DACBB4152BBB08DB25F",
        coinDecimals: 18
      },
      {
        coinDenom: "stDYM",
        coinMinimalDenom: "ibc/D53E785DC9C5C2CA50CADB1EFE4DE5D0C30418BE0E9C6F2AF9F092A247E8BC22",
        coinDecimals: 18
      },
      {
        coinDenom: "doki",
        coinMinimalDenom: "ibc/C12C353A83CD1005FC38943410B894DBEC5F2ABC97FC12908F0FB03B970E8E1B",
        coinDecimals: 6
      },
      {
        coinDenom: "sail",
        coinMinimalDenom: "factory/osmo1rckme96ptawr4zwexxj5g5gej9s2dmud8r2t9j0k0prn5mch5g4snzzwjv/sail",
        coinDecimals: 6
      },
      {
        coinDenom: "SHARK",
        coinMinimalDenom: "ibc/64D56DF9EC69BE554F49EBCE0199611062FF1137EF105E2F645C1997344F3834",
        coinDecimals: 6
      },
      {
        coinDenom: "xrp",
        coinMinimalDenom: "ibc/63A7CA0B6838AD8CAD6B5103998FF9B9B6A6F06FBB9638BFF51E63E0142339F3",
        coinDecimals: 6
      },
      {
        coinDenom: "SEIYAN",
        coinMinimalDenom: "ibc/86074B8DF625A75C25D52FA6112E3FD5446BA41FE418880C168CA99D10E22F05",
        coinDecimals: 6
      },
      {
        coinDenom: "nibi",
        coinMinimalDenom: "ibc/4017C65CEA338196ECCEC3FE3FE8258F23D1DE88F1D95750CC912C7A1C1016FF",
        coinDecimals: 6
      },
      {
        coinDenom: "beast",
        coinMinimalDenom: "ibc/B84F8CC583A54DA8173711C0B66B22FDC1954FEB1CA8DBC66C89919DAFE02000",
        coinDecimals: 6
      },
      {
        coinDenom: "cvnt",
        coinMinimalDenom: "ibc/044B7B28AFE93CEC769CF529ADC626DA09EA0EFA3E0E3284D540E9E00E01E24A",
        coinDecimals: 18
      },
      {
        coinDenom: "toro",
        coinMinimalDenom: "factory/osmo1nr8zfakf6jauye3uqa9lrmr5xumee5n42lv92z/toro",
        coinDecimals: 6
      },
      {
        coinDenom: "sayve",
        coinMinimalDenom: "ibc/06EF575844982382F4D1BC3830D294557A30EDB3CD223153AFC8DFEF06349C56",
        coinDecimals: 6
      },
      {
        coinDenom: "LAB",
        coinMinimalDenom: "factory/osmo17fel472lgzs87ekt9dvk0zqyh5gl80sqp4sk4n/LAB",
        coinDecimals: 6
      },
      {
        coinDenom: "bOSMO",
        coinMinimalDenom: "factory/osmo1s3l0lcqc7tu0vpj6wdjz9wqpxv8nk6eraevje4fuwkyjnwuy82qsx3lduv/boneOsmo",
        coinDecimals: 6
      },
      {
        coinDenom: "PUNDIX",
        coinMinimalDenom: "ibc/46D8D1A6E2A80ECCB7CA6663086A2E749C508B68DA56A077CD26E6F4F9691EEE",
        coinDecimals: 18
      },
      {
        coinDenom: "tnkr",
        coinMinimalDenom: "ibc/3A0A392E610A8D477851ABFEA74F3D828F36C015AB8E93B0FBB7566A6D13C4D6",
        coinDecimals: 12
      },
      {
        coinDenom: "w",
        coinMinimalDenom: "ibc/AC6EE43E608B5A7EEE460C960480BC1C3708010E32B2071C429DA259836E10C3",
        coinDecimals: 6
      },
      {
        coinDenom: "dhp",
        coinMinimalDenom: "ibc/FD506CCA1FC574F2A8175FB574C981E9F6351E194AA48AC219BD67FF934E2F33",
        coinDecimals: 6
      },
      {
        coinDenom: "fury",
        coinMinimalDenom: "ibc/E4C60B9F95BF54CC085A5E39F6057ABD4DF92793D330EB884A36530F7E6804DE",
        coinDecimals: 6
      },
      {
        coinDenom: "saga",
        coinMinimalDenom: "ibc/094FB70C3006906F67F5D674073D2DAFAFB41537E7033098F5C752F211E7B6C2",
        coinDecimals: 6
      },
      {
        coinDenom: "ATOM1KLFG",
        coinMinimalDenom: "ibc/0E77E090EC04C476DE2BC0A7056580AC47660DAEB7B0D4701C085E3A046AC7B7",
        coinDecimals: 6
      },
      {
        coinDenom: "SHIDO",
        coinMinimalDenom: "ibc/62B50BB1DAEAD2A92D6C6ACAC118F4ED8CBE54265DCF5688E8D0A0A978AA46E7",
        coinDecimals: 18
      },
      {
        coinDenom: "cif",
        coinMinimalDenom: "ibc/EFC1776BEFB7842F2DC7BABD9A3050E188145C99007ECC5F3526FED45A68D5F5",
        coinDecimals: 6
      },
      {
        coinDenom: "hava",
        coinMinimalDenom: "ibc/884EBC228DFCE8F1304D917A712AA9611427A6C1ECC3179B2E91D7468FB091A2",
        coinDecimals: 6
      },
      {
        coinDenom: "IBC",
        coinMinimalDenom: "factory/osmo1kqdw6pvn0xww6tyfv2sqvkkencdz0qw406x54r/IBC",
        coinDecimals: 6
      },
      {
        coinDenom: "crowdp",
        coinMinimalDenom: "ibc/B87F0F5255CC658408F167C2F7B987A8D914622E1F73BCC267406360588F2B1E",
        coinDecimals: 18
      },
      {
        coinDenom: "astro",
        coinMinimalDenom: "ibc/B8C608CEE08C4F30A15A7955306F2EDAF4A02BB191CABC4185C1A57FD978DA1B",
        coinDecimals: 6
      },
      {
        coinDenom: "xASTRO",
        coinMinimalDenom: "ibc/2ED09B03AA396BC2F35B741F4CA4A82D33A24A1007BFC1973299842DD626F564",
        coinDecimals: 6
      },
      {
        coinDenom: "gpaxg",
        coinMinimalDenom: "ibc/A5CCD24BA902843B1003A7EEE5F937C632808B9CF4925601241B15C5A0A51A53",
        coinDecimals: 18
      },
      {
        coinDenom: "rstk",
        coinMinimalDenom: "ibc/04FAC73DFF7F1DD59395948F2F043B0BBF978AD4533EE37E811340F501A08FFB",
        coinDecimals: 6
      },
      {
        coinDenom: "BERNESE",
        coinMinimalDenom: "factory/osmo1s6ht8qrm8x0eg8xag5x3ckx9mse9g4se248yss/BERNESE",
        coinDecimals: 6
      },
      {
        coinDenom: "eth",
        coinMinimalDenom: "ibc/A23E590BA7E0D808706FB5085A449B3B9D6864AE4DDE7DAF936243CEBB2A3D43",
        coinDecimals: 18
      },
      {
        coinDenom: "dai",
        coinMinimalDenom: "ibc/37DFAFDA529FF7D513B0DB23E9728DF9BF73122D38D46824C78BB7F91E6A736B",
        coinDecimals: 18
      },
      {
        coinDenom: "fxs",
        coinMinimalDenom: "ibc/5435437A8C9416B650DDA49C338B63CCFC6465123B715F6BAA9B1B2071E27913",
        coinDecimals: 18
      },
      {
        coinDenom: "frax",
        coinMinimalDenom: "ibc/9A8CBC029002DC5170E715F93FBF35011FFC9796371F59B1F3C3094AE1B453A9",
        coinDecimals: 18
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/078AD6F581E8115CDFBD8FFA29D8C71AFE250CE952AFF80040CBC64868D44AD3",
        coinDecimals: 6
      },
      {
        coinDenom: "sfrax",
        coinMinimalDenom: "ibc/0EFA07F312E05258A56AE1DD600E39B9151CF7A91C8A94EEBCF4F03ECFE5DD98",
        coinDecimals: 18
      },
      {
        coinDenom: "frxeth",
        coinMinimalDenom: "ibc/688E70EF567E5D4BA1CF4C54BAD758C288BC1A6C8B0B12979F911A2AE95E27EC",
        coinDecimals: 18
      },
      {
        coinDenom: "sfrxeth",
        coinMinimalDenom: "ibc/F17CCB4F07948CC2D8B72952C2D0A84F2B763962F698774BB121B872AE4611B5",
        coinDecimals: 18
      },
      {
        coinDenom: "clay",
        coinMinimalDenom: "ibc/7ABF696369EFB3387DF22B6A24204459FE5EFD010220E8E5618DC49DB877047B",
        coinDecimals: 6
      },
      {
        coinDenom: "404dr",
        coinMinimalDenom: "ibc/B797E4F42CD33C50511B341E50C5CC0E8EF0D93B1E1247ABAA071583B8619202",
        coinDecimals: 6
      },
      {
        coinDenom: "wLIBRA",
        coinMinimalDenom: "factory/osmo19hdqma2mj0vnmgcxag6ytswjnr8a3y07q7e70p/wLIBRA",
        coinDecimals: 6
      },
      {
        coinDenom: "nim",
        coinMinimalDenom: "ibc/279D69A6EF8E37456C8D2DC7A7C1C50F7A566EC4758F6DE17472A9FDE36C4426",
        coinDecimals: 18
      },
      {
        coinDenom: "seda",
        coinMinimalDenom: "ibc/956AEF1DA92F70584266E87978C3F30A43B91EE6ABC62F03D097E79F6B99C4D8",
        coinDecimals: 18
      },
      {
        coinDenom: "CAC",
        coinMinimalDenom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/cac",
        coinDecimals: 6
      },
      {
        coinDenom: "WEIRD",
        coinMinimalDenom: "ibc/38ADC6FFDDDB7D70B72AD0322CEA8844CB18FAA0A23400DBA8A99D43E18B3748",
        coinDecimals: 6
      },
      {
        coinDenom: "PBB",
        coinMinimalDenom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/pbb",
        coinDecimals: 6
      },
      {
        coinDenom: "bwh",
        coinMinimalDenom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/bwh",
        coinDecimals: 6
      },
      {
        coinDenom: "ibc/0D62E47FDEBBC199D4E1853C0708F0F9337AC62D95B719585C9700E466060995",
        coinMinimalDenom: "ibc/0D62E47FDEBBC199D4E1853C0708F0F9337AC62D95B719585C9700E466060995",
        coinDecimals: 0
      },
      {
        coinDenom: "SHITMOS",
        coinMinimalDenom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/shitmos",
        coinDecimals: 6
      },
      {
        coinDenom: "qjuno",
        coinMinimalDenom: "ibc/B4E18E61E1505C2F371B621E49B09E983F6A138F251A7B5286A6BDF739FD0D54",
        coinDecimals: 6
      },
      {
        coinDenom: "qsaga",
        coinMinimalDenom: "ibc/F2D400F2728E9DA06EAE2AFAB289931A69EDDA5A661578C66A3177EDFE3C0D13",
        coinDecimals: 6
      },
      {
        coinDenom: "qdydx",
        coinMinimalDenom: "ibc/273C593E51ACE56F1F2BDB3E03A5CB81BB208B894BCAA642676A32C3454E8C27",
        coinDecimals: 18
      },
      {
        coinDenom: "qbld",
        coinMinimalDenom: "ibc/C1C106D915C8E8C59E5DC69BF30FEF64729A6F788060B184C86A315DBB762EF7",
        coinDecimals: 6
      },
      {
        coinDenom: "pepe",
        coinMinimalDenom: "ibc/5B5BFCC8A9F0D554A4245117F7798E85BE25B6C73DBFA2D6F369BD9DD6CACC6D",
        coinDecimals: 18
      },
      {
        coinDenom: "crv",
        coinMinimalDenom: "ibc/080CE38C1E49595F2199E88BE7281F93FAEEF3FE354EECED0640625E8311C9CF",
        coinDecimals: 18
      },
      {
        coinDenom: "ezeth",
        coinMinimalDenom: "ibc/39AAE0F5F918B731BEF1E02E9BAED33C242805F668B0A941AC509FB569FE51CB",
        coinDecimals: 18
      },
      {
        coinDenom: "usde",
        coinMinimalDenom: "ibc/BFFE212A23384C4EB055CF6F95A1F5EC1BE0F9BD286FAA66C3748F0444E67D63",
        coinDecimals: 18
      },
      {
        coinDenom: "ena",
        coinMinimalDenom: "ibc/257FF64F160106F6EE43CEE7C761DA64C1346221895373CC810FFA1BFAC5A7CD",
        coinDecimals: 18
      },
      {
        coinDenom: "eeth",
        coinMinimalDenom: "ibc/8D0FFEA4EDB04E3C1738C9599B66AE49683E0540FC4C1214AC84534C200D818B",
        coinDecimals: 18
      },
      {
        coinDenom: "pxeth",
        coinMinimalDenom: "ibc/D09BB89B2187EF13EF006B44510749B0F02FD0B34F8BB55C70D812A1FF6148C7",
        coinDecimals: 18
      },
      {
        coinDenom: "crvusd",
        coinMinimalDenom: "ibc/63551E7BB24008F0AFC1CB051A423A5104F781F035F8B1A191264B7086A0A0F6",
        coinDecimals: 18
      },
      {
        coinDenom: "WIHA",
        coinMinimalDenom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/wiha",
        coinDecimals: 6
      },
      {
        coinDenom: "CRAZYHORSE",
        coinMinimalDenom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/crazyhorse",
        coinDecimals: 6
      },
      {
        coinDenom: "COCA",
        coinMinimalDenom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/coca",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/0233A3F2541FD43DBCA569B27AF886E97F5C03FC0305E4A8A3FAC6AC26249C7A",
        coinDecimals: 6
      },
      {
        coinDenom: "edgesol",
        coinMinimalDenom: "ibc/B83F9E20B4A07FA8846880000BD9D8985D89567A090F5E9390C64E81C39B4607",
        coinDecimals: 9
      },
      {
        coinDenom: "lst",
        coinMinimalDenom: "ibc/F618D130A2B8203D169811658BD0361F18DC2453085965FA0E5AEB8018DD54EE",
        coinDecimals: 9
      },
      {
        coinDenom: "jitosol",
        coinMinimalDenom: "ibc/9A83BDF4C8C5FFDDE735533BC8CD4363714A6474AED1C2C492FB003BB77C7982",
        coinDecimals: 9
      },
      {
        coinDenom: "wsol",
        coinMinimalDenom: "ibc/0F9E9277B61A78CB31014D541ACA5BF6AB06DFC4524C4C836490B131DAAECD78",
        coinDecimals: 9
      },
      {
        coinDenom: "allUSDT",
        coinMinimalDenom: "factory/osmo1em6xs47hd82806f5cxgyufguxrrc7l0aqx7nzzptjuqgswczk8csavdxek/alloyed/allUSDT",
        coinDecimals: 6
      },
      {
        coinDenom: "whine",
        coinMinimalDenom: "ibc/A8C568580D613F16F7E9075EA9FAD69FEBE0CC1F4AF46C60255FEC4459C166F1",
        coinDecimals: 6
      },
      {
        coinDenom: "BAG",
        coinMinimalDenom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/bag",
        coinDecimals: 6
      },
      {
        coinDenom: "allBTC",
        coinMinimalDenom: "factory/osmo1z6r6qdknhgsc0zeracktgpcxf43j6sekq07nw8sxduc9lg0qjjlqfu25e3/alloyed/allBTC",
        coinDecimals: 8
      },
      {
        coinDenom: "n43",
        coinMinimalDenom: "ibc/E4FFAACCDB7D55CE2D257DF637C00158CB841F11D0013B2D03E31FF7800A2C58",
        coinDecimals: 6
      },
      {
        coinDenom: "rakoff",
        coinMinimalDenom: "ibc/46579C587A0B8CF8B0A1FF6B0EFA2082F11876578E47FC81A9CAAD31F424AF98",
        coinDecimals: 6
      },
      {
        coinDenom: "arbitrum-weth",
        coinMinimalDenom: "ibc/64E62451C9A5682FF3047429C6E4714A02CDC0C35DE35CAB01E18D1188004CEB",
        coinDecimals: 18
      },
      {
        coinDenom: "base-weth",
        coinMinimalDenom: "ibc/D7D6DEF2A4F7ED0A6F5F0E266C1B2C9726E82F67EBBE49BBB47B3DEC289F8D7B",
        coinDecimals: 18
      },
      {
        coinDenom: "polygon-weth",
        coinMinimalDenom: "ibc/F9EB60AC212DBF05F4C5ED0FDE03BB9F08309B0EE9899A406AD4B904CF84968E",
        coinDecimals: 18
      },
      {
        coinDenom: "stISLM",
        coinMinimalDenom: "ibc/245C3CA604AAB4BB9EEA5E86F23F52D59253D8722C8FC9C4E3E69F77C5CD3D2F",
        coinDecimals: 18
      },
      {
        coinDenom: "mand",
        coinMinimalDenom: "ibc/739D70CB432FE1C6D94AF306B68C14F4CFB0B9EDD1238D3A8718B1B0E84E8547",
        coinDecimals: 18
      },
      {
        coinDenom: "neutaro",
        coinMinimalDenom: "ibc/DAED51CBD967A3BE0C467687970AFD97B202AFE4A1718B36936F49178AFE0133",
        coinDecimals: 6
      },
      {
        coinDenom: "wormhole/AbYYFgqSQEhe7NyXfo6w75GT7fCanVd9wNg4E9Df2puP/6",
        coinMinimalDenom: "ibc/E0D6A7FFAE26FA90C8F1AA3461A5A21E74DB154F183EAE56C96769F48F81FCA2",
        coinDecimals: 6
      },
      {
        coinDenom: "usdy",
        coinMinimalDenom: "ibc/23104D411A6EB6031FA92FB75F227422B84989969E91DCAD56A535DD7FF0A373",
        coinDecimals: 18
      },
      {
        coinDenom: "TURD",
        coinMinimalDenom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/turd",
        coinDecimals: 6
      },
      {
        coinDenom: "fct",
        coinMinimalDenom: "ibc/E43ABCC7E80E99E4E6E1226AE5695DDE0F83CB5C257CD04D47C36B8B90C1C839",
        coinDecimals: 6
      },
      {
        coinDenom: "allETH",
        coinMinimalDenom: "factory/osmo1k6c8jln7ejuqwtqmay3yvzrg3kueaczl96pk067ldg8u835w0yhsw27twm/alloyed/allETH",
        coinDecimals: 18
      },
      {
        coinDenom: "allSOL",
        coinMinimalDenom: "factory/osmo1n3n75av8awcnw4jl62n3l48e6e4sxqmaf97w5ua6ddu4s475q5qq9udvx4/alloyed/allSOL",
        coinDecimals: 9
      },
      {
        coinDenom: "lava",
        coinMinimalDenom: "ibc/1AEF145C549D4F9847C79E49710B198C294C7F4A107F4610DEE8E725FFC4B378",
        coinDecimals: 6
      },
      {
        coinDenom: "penumbra",
        coinMinimalDenom: "ibc/0FA9232B262B89E77D1335D54FB1E1F506A92A7E4B51524B400DC69C68D28372",
        coinDecimals: 6
      },
      {
        coinDenom: "trx",
        coinMinimalDenom: "factory/osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9/TRX.rt",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "factory/osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9/USDT.rt",
        coinDecimals: 6
      },
      {
        coinDenom: "COSMO",
        coinMinimalDenom: "ibc/4925733868E7999F5822C961ADE9470A7FC5FA4A560BAE1DE102783C3F64C201",
        coinDecimals: 6
      },
      {
        coinDenom: "stBAND",
        coinMinimalDenom: "ibc/603140E681973C7A3A33B06B1D377AAD0F6AC376119735CECC04C9184A1AB080",
        coinDecimals: 6
      },
      {
        coinDenom: "COOK",
        coinMinimalDenom: "factory/osmo1q77cw0mmlluxu0wr29fcdd0tdnh78gzhkvhe4n6ulal9qvrtu43qtd0nh8/COOK",
        coinDecimals: 6
      },
      {
        coinDenom: "trx",
        coinMinimalDenom: "factory/osmo14mafhhp337yjj2aujplawz0tks6jd2lel4hkwz4agyzhvvztzaqsqzjq8x/alloyed/allTRX",
        coinDecimals: 6
      },
      {
        coinDenom: "ROUTE",
        coinMinimalDenom: "ibc/3F8F00094F0F79D17750FF69C5F09B078084018570AAF4F1C92C86D3F73E6488",
        coinDecimals: 18
      },
      {
        coinDenom: "op",
        coinMinimalDenom: "factory/osmo1nufyzqlm8qhu2w7lm0l4rrax0ec8rsk69mga4tel8eare7c7ljaqpk2lyg/alloyed/allOP",
        coinDecimals: 12
      },
      {
        coinDenom: "op",
        coinMinimalDenom: "ibc/14A291DD362798D6805B7ABCB8D09AEEE02176108F89FA09AA43EA2EE096A2A9",
        coinDecimals: 18
      },
      {
        coinDenom: "shib",
        coinMinimalDenom: "factory/osmo1f588gk9dazpsueevdl2w6wfkmfmhg5gdvg2uerdlzl0atkasqhsq59qc6a/alloyed/allSHIB",
        coinDecimals: 12
      },
      {
        coinDenom: "arb",
        coinMinimalDenom: "factory/osmo1p7x454ex08s4f9ztmm7wfv7lvtgdkfztj2u7v7fezfcauy85q35qmqrdpk/alloyed/allARB",
        coinDecimals: 12
      },
      {
        coinDenom: "link",
        coinMinimalDenom: "factory/osmo18zdw5yvs6gfp95rp74qqwug9yduw2fyr8kplk2xgs726s9axc5usa2vpgw/alloyed/allLINK",
        coinDecimals: 12
      },
      {
        coinDenom: "pepe",
        coinMinimalDenom: "factory/osmo1nnlxegt0scm9qkzys9c874t0ntapv4epfjy2w49c0xdrp3dr0v4ssmelzx/alloyed/allPEPE",
        coinDecimals: 12
      },
      {
        coinDenom: "dot",
        coinMinimalDenom: "factory/osmo1r53fx9fvcdzncrs7zkn4gw5vfelx5gk8k5wc6wqha2jpkh992rusr5tk02/alloyed/allDOT",
        coinDecimals: 10
      },
      {
        coinDenom: "unicorn",
        coinMinimalDenom: "ibc/C91210281CEB708DC6E41A47FC9EC298F45712273DD58C682BEBAD00DCB59DC2",
        coinDecimals: 6
      },
      {
        coinDenom: "DEEN",
        coinMinimalDenom: "ibc/108604FDBE97DAEF128FD4ECFEB2A8AFC2D04A7162C97EAA2FD5BCB0869D0BBC",
        coinDecimals: 6
      },
      {
        coinDenom: "CosmoUSD",
        coinMinimalDenom: "factory/osmo104jtrwcljnxfljhml8mxrw7qetcsdmqvy3sprw/ucosmousd",
        coinDecimals: 6
      },
      {
        coinDenom: "XTRUMP",
        coinMinimalDenom: "factory/osmo1hg0zf0c9can4tvtulh5gmmxe4jpflre3yewxjl/XTRUMP",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/2AD3C64D19ADFBB522CD738B58F421102143F827C1CAFF574A8BF0B81017D53D",
        coinDecimals: 6
      },
      {
        coinDenom: "fBAD",
        coinMinimalDenom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fBAD",
        coinDecimals: 9
      },
      {
        coinDenom: "fMAD",
        coinMinimalDenom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fMAD",
        coinDecimals: 9
      },
      {
        coinDenom: "fSLOTH",
        coinMinimalDenom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fSLOTH",
        coinDecimals: 9
      },
      {
        coinDenom: "fNUT",
        coinMinimalDenom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fNUT",
        coinDecimals: 9
      },
      {
        coinDenom: "MARS",
        coinMinimalDenom: "ibc/B67DF59507B3755EEDE0866C449445BD54B4DA82CCEBA89D775E53DC35664255",
        coinDecimals: 6
      },
      {
        coinDenom: "ton",
        coinMinimalDenom: "ibc/905889A7F0B94F1CE1506D9BADF13AE9141E4CBDBCD565E1DFC7AE418B3E3E98",
        coinDecimals: 9
      },
      {
        coinDenom: "ton",
        coinMinimalDenom: "factory/osmo12lnwf54yd30p6amzaged2atln8k0l32n7ncxf04ctg7u7ymnsy7qkqgsw4/alloyed/allTON",
        coinDecimals: 9
      },
      {
        coinDenom: "display_stBTC",
        coinMinimalDenom: "ibc/453B5B25834A5D4B8FE1E894E69D73F46424F28E8ED3D8E8CA654AEFF1EC5D3B",
        coinDecimals: 18
      },
      {
        coinDenom: "BVT0",
        coinMinimalDenom: "factory/osmo1xu0gk9aggv79597xwazyfzaggv2pze9z7cq3p9p72tkkux9a7xaqufa792/BVT",
        coinDecimals: 18
      },
      {
        coinDenom: "BVT1",
        coinMinimalDenom: "factory/osmo16nxtnrnl7lctvnhhpcxqmmpv63n93zgg0ukaveyc0jl4dtad79cs53c3an/BVT",
        coinDecimals: 18
      },
      {
        coinDenom: "AVAIL",
        coinMinimalDenom: "factory/osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9/AVAIL.rt",
        coinDecimals: 18
      },
      {
        coinDenom: "eure",
        coinMinimalDenom: "ibc/92AE2F53284505223A1BB80D132F859A00E190C6A738772F0B3EF65E20BA484F",
        coinDecimals: 6
      },
      {
        coinDenom: "andr",
        coinMinimalDenom: "ibc/631DB9935E8523BDCF76B55129F5238A14C809CCB3B43AECC157DC19702F3F9E",
        coinDecimals: 6
      },
      {
        coinDenom: "ckBTC",
        coinMinimalDenom: "factory/osmo10c4y9csfs8q7mtvfg4p9gd8d0acx0hpc2mte9xqzthd7rd3348tsfhaesm/sICP-icrc-ckBTC",
        coinDecimals: 8
      },
      {
        coinDenom: "fWIZ",
        coinMinimalDenom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fWIZ",
        coinDecimals: 9
      },
      {
        coinDenom: "fWITCH",
        coinMinimalDenom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fWITCH",
        coinDecimals: 9
      },
      {
        coinDenom: "fCRYPTONIUM",
        coinMinimalDenom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fCRYPTONIUM",
        coinDecimals: 9
      },
      {
        coinDenom: "fATLAS",
        coinMinimalDenom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fATLAS",
        coinDecimals: 9
      },
      {
        coinDenom: "fGECK",
        coinMinimalDenom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fGECK",
        coinDecimals: 9
      },
      {
        coinDenom: "fBULLS",
        coinMinimalDenom: "factory/osmo1dywfmhyc8y0wga7qpzej0x0mgwqg25fj4eccp494w8yafzdpgamsx9ryyv/fBULLS",
        coinDecimals: 9
      },
      {
        coinDenom: "SIN",
        coinMinimalDenom: "ibc/2BF7FB3908B469FA9672767DC74AF8A18E2F47F8B623B0685DE290B828FCBD23",
        coinDecimals: 6
      },
      {
        coinDenom: "KIMA",
        coinMinimalDenom: "ibc/A6712952E566B8A9F29D0A533F043C3CE3CF9870B01A2180E390133119C14A71",
        coinDecimals: 6
      },
      {
        coinDenom: "stos",
        coinMinimalDenom: "ibc/ABD49F44559CB3E557CC458459CB6A67CEBD66E23C7674A0B2B445230BDA1F6C",
        coinDecimals: 18
      },
      {
        coinDenom: "uni",
        coinMinimalDenom: "ibc/AE2719773D6FCDD05AC17B1ED63F672F5F9D84144A61965F348C86C2A83AD161",
        coinDecimals: 18
      },
      {
        coinDenom: "allUNI",
        coinMinimalDenom: "factory/osmo1eqjda4pc6e09jtxzxggf6jl3jye2yn453ja58we5gxwzmf5ah28qvlnaz8/alloyed/allUNI",
        coinDecimals: 12
      },
      {
        coinDenom: "lp:8:osmo",
        coinMinimalDenom: "ibc/54B2D9DC9602A1CE2A0329D51C6A1C7C4ADE71477186AEAAA549318C4513A453",
        coinDecimals: 6
      },
      {
        coinDenom: "int3",
        coinMinimalDenom: "ibc/7D29C888219883C47C623578ACACFC89CC29AA70FBF09C895A1EED911BF90F32",
        coinDecimals: 6
      },
      {
        coinDenom: "doge",
        coinMinimalDenom: "ibc/B3DFDC2958A2BE482532DA3B6B5729B469BE7475598F7487D98B1B3E085245DE",
        coinDecimals: 8
      },
      {
        coinDenom: "btc",
        coinMinimalDenom: "ibc/2F4258D6E1E01B203D6CA83F2C7E4959615053A21EC2C2FC196F7911CAC832EF",
        coinDecimals: 8
      },
      {
        coinDenom: "bch",
        coinMinimalDenom: "ibc/869E01805EBBDDCAEA588666CD5149728B7DC7D69F30D92F77AD67F77CEB3FDA",
        coinDecimals: 8
      },
      {
        coinDenom: "ltc",
        coinMinimalDenom: "ibc/905326586AE1C86AC8B1CDB20BE957DE5FB23963EDD2C9ADD3E835CC22115A46",
        coinDecimals: 8
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/57B63A0795B6BC0AC4EFD0D4DEE9FE71FCC1D0FFA87F6280C9CDEF4F6727A173",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/EEA21E12A250B7FBBCBBBD1F7AA78984F5C12D684B32EBEEFC585FF596A7BCDA",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/2F6003A92088B989A159C593C551DF7B04FA0A0419CA3ED087E45E0006ECFF6E",
        coinDecimals: 6
      },
      {
        coinDenom: "cbbtc",
        coinMinimalDenom: "ibc/616C2EA69BC328F245CE449785CB0B526B462C48F19DCF9B3D30699579B4308A",
        coinDecimals: 8
      },
      {
        coinDenom: "fbtc",
        coinMinimalDenom: "ibc/22C342A34DD0189AC2B2697EE76C360A9FBA53748ABA76E12C3A9E9F5F1E130F",
        coinDecimals: 8
      },
      {
        coinDenom: "lbtc",
        coinMinimalDenom: "ibc/4AC81C97BBB5482536F6401328E0E10BCCD98F0F471DCF64319A811E25E53CAB",
        coinDecimals: 8
      },
      {
        coinDenom: "rbtc",
        coinMinimalDenom: "factory/osmo1myv2g72h8dan7n4hx7stt3mmust6ws03zh6gxc7vz4hpmgp5z3lq9aunm9/BTC.rt",
        coinDecimals: 18
      },
      {
        coinDenom: "allDOGE",
        coinMinimalDenom: "factory/osmo10pk4crey8fpdyqd62rsau0y02e3rk055w5u005ah6ly7k849k5tsf72x40/alloyed/allDOGE",
        coinDecimals: 8
      },
      {
        coinDenom: "allLTC",
        coinMinimalDenom: "factory/osmo1csp8fk353hnq2tmulklecxpex43qmjvrkxjcsh4c3eqcw2vjcslq5jls9v/alloyed/allLTC",
        coinDecimals: 8
      },
      {
        coinDenom: "allBCH",
        coinMinimalDenom: "factory/osmo1cranx3twqxfrgeqvgsu262gy54vafpc9xap6scye99v244zl970s7kw2sz/alloyed/allBCH",
        coinDecimals: 8
      },
      {
        coinDenom: "om",
        coinMinimalDenom: "ibc/164807F6226F91990F358C6467EEE8B162E437BDCD3DADEC3F0CE20693720795",
        coinDecimals: 6
      },
      {
        coinDenom: "fury",
        coinMinimalDenom: "ibc/42D0FBF9DDC72D7359D309A93A6DF9F6FDEE3987EA1C5B3CDE95C06FCE183F12",
        coinDecimals: 6
      },
      {
        coinDenom: "PUNDIX",
        coinMinimalDenom: "ibc/2EB516F83C9FF44AB6826F269CA98A5622608C6C955E12112E58F23A324FEE07",
        coinDecimals: 18
      },
      {
        coinDenom: "dhp",
        coinMinimalDenom: "ibc/320F8D6EC17E14436D19C6D844BB9A5AE9B9A209F6D18364A2191FF08E8732A9",
        coinDecimals: 6
      },
      {
        coinDenom: "SHIDO",
        coinMinimalDenom: "ibc/BBE825F7D1673E1EBF05AB02000E23E6077967B79547A3733B60AE4ED62C4D32",
        coinDecimals: 18
      },
      {
        coinDenom: "avalanche-usdc",
        coinMinimalDenom: "ibc/0B3C3D06228578334B66B57FBFBA4033216CEB8119B27ACDEE18D92DA5B28D43",
        coinDecimals: 6
      },
      {
        coinDenom: "nom",
        coinMinimalDenom: "ibc/F49DFB3BC8105C57EE7F17EC2402438825B31212CFDD81681EB87911E934F32C",
        coinDecimals: 6
      },
      {
        coinDenom: "ymos",
        coinMinimalDenom: "factory/osmo1vdvnznwg597qngrq9mnfcfk0am9jdc9y446jewhcqdreqz4r75xq5j5zvy/ymos",
        coinDecimals: 6
      },
      {
        coinDenom: "factory/osmo13gu58hzw3e9aqpj25h67m7snwcjuccd7v4p55w/brnz",
        coinMinimalDenom: "factory/osmo13gu58hzw3e9aqpj25h67m7snwcjuccd7v4p55w/brnz",
        coinDecimals: 0
      },
      {
        coinDenom: "ashLAB",
        coinMinimalDenom: "factory/osmo1svj5kd8kzj7xxtrd6ftjk0856ffpyj4egz7f9pd9dge5wr4kwansmefq07/lab.ash",
        coinDecimals: 6
      },
      {
        coinDenom: "grac",
        coinMinimalDenom: "ibc/58E4261D2E21FE3A459C290A9F97F3DCD257B28F48AAE828298B38E048804829",
        coinDecimals: 6
      },
      {
        coinDenom: "earnUSDC",
        coinMinimalDenom: "factory/osmo1vf6e300hv2qe7r5rln8deft45ewgyytjnwfrdfcv5rgzrfy0s6cswjqf9r/mars-usdc-looped",
        coinDecimals: 6
      },
      {
        coinDenom: "earnCDT",
        coinMinimalDenom: "factory/osmo1jw6r68y0uhfmqagc7uhtdddctc7wq95pncvrqnvtd47w4hx46p7se9nju5/earn-cdt",
        coinDecimals: 6
      },
      {
        coinDenom: "Spice",
        coinMinimalDenom: "factory/osmo1n6asrjy9754q8y9jsxqf557zmsv3s3xa5m9eg5/uspice",
        coinDecimals: 6
      },
      {
        coinDenom: "yum",
        coinMinimalDenom: "ibc/21D8071EF5B02A86D945430D859A594CBF28287D38104A264BB9FD3B22BBF5DE",
        coinDecimals: 18
      }
    ],
    rest: "https://lcd.osmosis.zone/",
    rpc: "https://rpc.osmosis.zone/",
    bech32Config: {
      bech32PrefixAccAddr: "osmo",
      bech32PrefixAccPub: "osmopub",
      bech32PrefixValAddr: "osmovaloper",
      bech32PrefixValPub: "osmovaloperpub",
      bech32PrefixConsAddr: "osmovalcons",
      bech32PrefixConsPub: "osmovalconspub"
    },
    chainName: "osmosis",
    feeCurrencies: [
      {
        coinDenom: "osmo",
        coinMinimalDenom: "uosmo",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "osmo",
      coinMinimalDenom: "uosmo",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "panacea-3",
    currencies: [
      {
        coinDenom: "med",
        coinMinimalDenom: "umed",
        coinDecimals: 6
      }
    ],
    rest: "https://api.gopanacea.org",
    rpc: "https://rpc.gopanacea.org",
    bech32Config: {
      bech32PrefixAccAddr: "panacea",
      bech32PrefixAccPub: "panaceapub",
      bech32PrefixValAddr: "panaceavaloper",
      bech32PrefixValPub: "panaceavaloperpub",
      bech32PrefixConsAddr: "panaceavalcons",
      bech32PrefixConsPub: "panaceavalconspub"
    },
    chainName: "panacea",
    feeCurrencies: [
      {
        coinDenom: "med",
        coinMinimalDenom: "umed",
        coinDecimals: 6,
        gasPriceStep: {
          low: 5,
          average: 7,
          high: 9
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "med",
      coinMinimalDenom: "umed",
      coinDecimals: 6
    },
    bip44: {
      coinType: 371
    }
  },
  {
    chainId: "passage-2",
    currencies: [
      {
        coinDenom: "pasg",
        coinMinimalDenom: "upasg",
        coinDecimals: 6
      }
    ],
    rest: "https://api.passage.vitwit.com",
    rpc: "https://rpc.passage.vitwit.com",
    bech32Config: {
      bech32PrefixAccAddr: "pasg",
      bech32PrefixAccPub: "pasgpub",
      bech32PrefixValAddr: "pasgvaloper",
      bech32PrefixValPub: "pasgvaloperpub",
      bech32PrefixConsAddr: "pasgvalcons",
      bech32PrefixConsPub: "pasgvalconspub"
    },
    chainName: "passage",
    feeCurrencies: [
      {
        coinDenom: "pasg",
        coinMinimalDenom: "upasg",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-3,
          average: 25e-4,
          high: 0.01
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "pasg",
      coinMinimalDenom: "upasg",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "core-1",
    currencies: [
      {
        coinDenom: "xprt",
        coinMinimalDenom: "uxprt",
        coinDecimals: 6
      },
      {
        coinDenom: "stkatom",
        coinMinimalDenom: "stk/uatom",
        coinDecimals: 6
      },
      {
        coinDenom: "pstake",
        coinMinimalDenom: "ibc/A6E3AF63B3C906416A9AF7A556C59EA4BD50E617EFFE6299B99700CCB780E444",
        coinDecimals: 18
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/C8A74ABBE2AF892E15680D916A7C22130585CE5704F9B17A10F184A90D53BECA",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/C559977F5797BDC1D74C0836A10C379C991D664166CB60D776A83029852431B4",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/B3792E4A62DF4A934EF2DF5968556DB56F5776ED25BDE11188A4F58A7DD406F0",
        coinDecimals: 6
      },
      {
        coinDenom: "dydx",
        coinMinimalDenom: "ibc/23DC3FF0E4CBB53A1915E4C62507CB7796956E84C68CA49707787CB8BDE90A1E",
        coinDecimals: 18
      },
      {
        coinDenom: "stkosmo",
        coinMinimalDenom: "stk/uosmo",
        coinDecimals: 6
      },
      {
        coinDenom: "stkdydx",
        coinMinimalDenom: "stk/adydx",
        coinDecimals: 18
      },
      {
        coinDenom: "stkstars",
        coinMinimalDenom: "stk/ustars",
        coinDecimals: 6
      },
      {
        coinDenom: "stars",
        coinMinimalDenom: "ibc/AD8E1D4AC4EA8FC79CC46E33319A3791477D4DEBFC30D5D874074B993422B41B",
        coinDecimals: 6
      },
      {
        coinDenom: "shd",
        coinMinimalDenom: "ibc/5D3B6445EA1D7064C4B1CCB588638589529556E1BCBADF13475021B42EA8C73B",
        coinDecimals: 8
      },
      {
        coinDenom: "stkhuahua",
        coinMinimalDenom: "stk/uhuahua",
        coinDecimals: 6
      },
      {
        coinDenom: "huahua",
        coinMinimalDenom: "ibc/B597D779FCDD9021263C98A48F1AFA9D2BCCCE980F397CDE5681CCEDE7DEE1A4",
        coinDecimals: 6
      },
      {
        coinDenom: "stkxprt",
        coinMinimalDenom: "stk/uxprt",
        coinDecimals: 6
      },
      {
        coinDenom: "wbtc",
        coinMinimalDenom: "ibc/CCA9F9B22D39884C09975D45E1869B73A12B87080EE53CB44905CE2C422CA228",
        coinDecimals: 8
      }
    ],
    rest: "https://rest.core.persistence.one",
    rpc: "https://rpc.core.persistence.one",
    bech32Config: {
      bech32PrefixAccAddr: "persistence",
      bech32PrefixAccPub: "persistencepub",
      bech32PrefixValAddr: "persistencevaloper",
      bech32PrefixValPub: "persistencevaloperpub",
      bech32PrefixConsAddr: "persistencevalcons",
      bech32PrefixConsPub: "persistencevalconspub"
    },
    chainName: "persistence",
    feeCurrencies: [
      {
        coinDenom: "xprt",
        coinMinimalDenom: "uxprt",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "xprt",
      coinMinimalDenom: "uxprt",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "planq_7070-2",
    currencies: [
      {
        coinDenom: "planq",
        coinMinimalDenom: "aplanq",
        coinDecimals: 18
      },
      {
        coinDenom: "srcx",
        coinMinimalDenom: "erc20/0x091F9A57A3F58d758b6572E9d41675918EAC7F09",
        coinDecimals: 9
      },
      {
        coinDenom: "meme",
        coinMinimalDenom: "ibc/747FF58D3F211497581252CEBE11D7E785FC1E53AC5C29497A361E3830F1AF4A",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.planq.network",
    rpc: "https://rpc.planq.network",
    bech32Config: {
      bech32PrefixAccAddr: "plq",
      bech32PrefixAccPub: "plqpub",
      bech32PrefixValAddr: "plqvaloper",
      bech32PrefixValPub: "plqvaloperpub",
      bech32PrefixConsAddr: "plqvalcons",
      bech32PrefixConsPub: "plqvalconspub"
    },
    chainName: "planq",
    feeCurrencies: [
      {
        coinDenom: "planq",
        coinMinimalDenom: "aplanq",
        coinDecimals: 18,
        gasPriceStep: {
          low: 3e10,
          average: 35e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "planq",
      coinMinimalDenom: "aplanq",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "point_10687-1",
    currencies: [
      {
        coinDenom: "point",
        coinMinimalDenom: "apoint",
        coinDecimals: 18
      }
    ],
    rest: "https://rpc-mainnet-1.point.space:1317",
    rpc: "https://rpc-mainnet-1.point.space:26657",
    bech32Config: {
      bech32PrefixAccAddr: "point",
      bech32PrefixAccPub: "pointpub",
      bech32PrefixValAddr: "pointvaloper",
      bech32PrefixValPub: "pointvaloperpub",
      bech32PrefixConsAddr: "pointvalcons",
      bech32PrefixConsPub: "pointvalconspub"
    },
    chainName: "point",
    feeCurrencies: [
      {
        coinDenom: "point",
        coinMinimalDenom: "apoint",
        coinDecimals: 18,
        gasPriceStep: {
          low: 5e9,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "point",
      coinMinimalDenom: "apoint",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "pio-mainnet-1",
    currencies: [
      {
        coinDenom: "hash",
        coinMinimalDenom: "nhash",
        coinDecimals: 9
      }
    ],
    rest: "https://api-provenance.takeshi.team",
    rpc: "https://rpc-provenance.takeshi.team/",
    bech32Config: {
      bech32PrefixAccAddr: "pb",
      bech32PrefixAccPub: "pbpub",
      bech32PrefixValAddr: "pbvaloper",
      bech32PrefixValPub: "pbvaloperpub",
      bech32PrefixConsAddr: "pbvalcons",
      bech32PrefixConsPub: "pbvalconspub"
    },
    chainName: "provenance",
    feeCurrencies: [
      {
        coinDenom: "hash",
        coinMinimalDenom: "nhash",
        coinDecimals: 9,
        gasPriceStep: {
          low: 1905,
          average: 2100,
          high: 2500
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "hash",
      coinMinimalDenom: "nhash",
      coinDecimals: 9
    },
    bip44: {
      coinType: 505
    }
  },
  {
    chainId: "pryzm-1",
    currencies: [
      {
        coinDenom: "pryzm",
        coinMinimalDenom: "upryzm",
        coinDecimals: 6
      },
      {
        coinDenom: "auuu",
        coinMinimalDenom: "factory/pryzm1jnhcsa5ddjsjq2t97v6a82z542rduxvtw6wd9h/uauuu",
        coinDecimals: 6
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
        coinDecimals: 6
      },
      {
        coinDenom: "INJ",
        coinMinimalDenom: "ibc/DE63D8AC34B752FB7D4CAA7594145EDE1C9FC256AC6D4043D0F12310EB8FC255",
        coinDecimals: 18
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/13B2C536BB057AC79D5616B8EA1B9540EC1F2170718CAFF6F0083C966FFFED0B",
        coinDecimals: 6
      },
      {
        coinDenom: "tia",
        coinMinimalDenom: "ibc/BF28D9C17E0306B194D50F51C3B2590BEAD15E04E03ADD34C3A26E62D85C9676",
        coinDecimals: 6
      },
      {
        coinDenom: "luna",
        coinMinimalDenom: "ibc/B8AF5D92165F35AB31F3FC7C7B444B9D240760FA5D406C49D24862BD0284E395",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/BFAAB7870A9AAABF64A7366DAAA0B8E5065EAA1FCE762F45677DC24BE796EF65",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/B9E4FD154C92D3A23BEA029906C4C5FF2FE74CB7E3A058290B77197A263CF88B",
        coinDecimals: 6
      },
      {
        coinDenom: "dydx",
        coinMinimalDenom: "ibc/F8CA5236869F819BC006EEF088E67889A26E4140339757878F0F4E229CDDA858",
        coinDecimals: 18
      },
      {
        coinDenom: "stTIA",
        coinMinimalDenom: "ibc/FA78980867B7E87F382CDA00275C55DDC248CABC7DEE27AC6868CCF97DD5E02F",
        coinDecimals: 6
      },
      {
        coinDenom: "stDYDX",
        coinMinimalDenom: "ibc/120DC39B61CC121E91525C1D51624E41BBE74C537D7B0BE50BBFF9A00E37B6EE",
        coinDecimals: 18
      },
      {
        coinDenom: "dATOM",
        coinMinimalDenom: "ibc/EA6E1E8BA2EB9F681C4BD12C8C81A46530A62934F2BD561B120A00F46946CE87",
        coinDecimals: 6
      },
      {
        coinDenom: "catom",
        coinMinimalDenom: "c:uatom",
        coinDecimals: 6
      },
      {
        coinDenom: "cINJ",
        coinMinimalDenom: "c:inj",
        coinDecimals: 18
      },
      {
        coinDenom: "cosmo",
        coinMinimalDenom: "c:uosmo",
        coinDecimals: 6
      },
      {
        coinDenom: "cluna",
        coinMinimalDenom: "c:uluna",
        coinDecimals: 6
      },
      {
        coinDenom: "cauuu",
        coinMinimalDenom: "factory/pryzm1qg5ega6dykkxc307y25pecuufrjkxkaggkkxh7nad0vhyhtuhw3sk0s70x/cuauuu",
        coinDecimals: 6
      },
      {
        coinDenom: "ctia",
        coinMinimalDenom: "c:utia",
        coinDecimals: 6
      },
      {
        coinDenom: "pATOM30Sep2024",
        coinMinimalDenom: "p:uatom:30Sep2024",
        coinDecimals: 6
      },
      {
        coinDenom: "pATOM31Dec2024",
        coinMinimalDenom: "p:uatom:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "pATOM31Dec2025",
        coinMinimalDenom: "p:uatom:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "pOSMO30Sep2024",
        coinMinimalDenom: "p:uosmo:30Sep2024",
        coinDecimals: 6
      },
      {
        coinDenom: "pOSMO31Dec2024",
        coinMinimalDenom: "p:uosmo:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "pOSMO31Dec2025",
        coinMinimalDenom: "p:uosmo:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "pINJ30Sep2024",
        coinMinimalDenom: "p:inj:30Sep2024",
        coinDecimals: 18
      },
      {
        coinDenom: "pINJ31Dec2024",
        coinMinimalDenom: "p:inj:31Dec2024",
        coinDecimals: 18
      },
      {
        coinDenom: "pINJ31Dec2025",
        coinMinimalDenom: "p:inj:31Dec2025",
        coinDecimals: 18
      },
      {
        coinDenom: "pLUNA30Sep2024",
        coinMinimalDenom: "p:uluna:30Sep2024",
        coinDecimals: 6
      },
      {
        coinDenom: "pLUNA31Dec2024",
        coinMinimalDenom: "p:uluna:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "pLUNA31Dec2025",
        coinMinimalDenom: "p:uluna:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "pAUUU30Sep2024",
        coinMinimalDenom: "p:uauuu:30Sep2024",
        coinDecimals: 6
      },
      {
        coinDenom: "pAUUU31Dec2024",
        coinMinimalDenom: "p:uauuu:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "pAUUU31Dec2025",
        coinMinimalDenom: "p:uauuu:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "pstTIA30Sep2024",
        coinMinimalDenom: "p:stutia:30Sep2024",
        coinDecimals: 6
      },
      {
        coinDenom: "pstTIA31Dec2024",
        coinMinimalDenom: "p:stutia:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "pstTIA31Dec2025",
        coinMinimalDenom: "p:stutia:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "pstDYDX30Sep2024",
        coinMinimalDenom: "p:stadydx:30Sep2024",
        coinDecimals: 18
      },
      {
        coinDenom: "pstDYDX31Dec2024",
        coinMinimalDenom: "p:stadydx:31Dec2024",
        coinDecimals: 18
      },
      {
        coinDenom: "pstDYDX31Dec2025",
        coinMinimalDenom: "p:stadydx:31Dec2025",
        coinDecimals: 18
      },
      {
        coinDenom: "pdATOM31Dec2024",
        coinMinimalDenom: "p:udatom:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "pdATOM30Jun2025",
        coinMinimalDenom: "p:udatom:30Jun2025",
        coinDecimals: 6
      },
      {
        coinDenom: "pdATOM31Dec2025",
        coinMinimalDenom: "p:udatom:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "pTIA31Dec2024",
        coinMinimalDenom: "p:utia:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "pTIA31Dec2025",
        coinMinimalDenom: "p:utia:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "yATOM30Sep2024",
        coinMinimalDenom: "y:uatom:30Sep2024",
        coinDecimals: 6
      },
      {
        coinDenom: "yATOM31Dec2024",
        coinMinimalDenom: "y:uatom:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "yATOM31Dec2025",
        coinMinimalDenom: "y:uatom:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "yOSMO30Sep2024",
        coinMinimalDenom: "y:uosmo:30Sep2024",
        coinDecimals: 6
      },
      {
        coinDenom: "yOSMO31Dec2024",
        coinMinimalDenom: "y:uosmo:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "yOSMO31Dec2025",
        coinMinimalDenom: "y:uosmo:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "yINJ30Sep2024",
        coinMinimalDenom: "y:inj:30Sep2024",
        coinDecimals: 18
      },
      {
        coinDenom: "yINJ31Dec2024",
        coinMinimalDenom: "y:inj:31Dec2024",
        coinDecimals: 18
      },
      {
        coinDenom: "yINJ31Dec2025",
        coinMinimalDenom: "y:inj:31Dec2025",
        coinDecimals: 18
      },
      {
        coinDenom: "yLUNA30Sep2024",
        coinMinimalDenom: "y:uluna:30Sep2024",
        coinDecimals: 6
      },
      {
        coinDenom: "yLUNA31Dec2024",
        coinMinimalDenom: "y:uluna:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "yLUNA31Dec2025",
        coinMinimalDenom: "y:uluna:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "yAUUU30Sep2024",
        coinMinimalDenom: "y:uauuu:30Sep2024",
        coinDecimals: 6
      },
      {
        coinDenom: "yAUUU31Dec2024",
        coinMinimalDenom: "y:uauuu:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "yAUUU31Dec2025",
        coinMinimalDenom: "y:uauuu:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "ystTIA30Sep2024",
        coinMinimalDenom: "y:stutia:30Sep2024",
        coinDecimals: 6
      },
      {
        coinDenom: "ystTIA31Dec2024",
        coinMinimalDenom: "y:stutia:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "ystTIA31Dec2025",
        coinMinimalDenom: "y:stutia:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "ystDYDX30Sep2024",
        coinMinimalDenom: "y:stadydx:30Sep2024",
        coinDecimals: 6
      },
      {
        coinDenom: "ystDYDX31Dec2024",
        coinMinimalDenom: "y:stadydx:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "ystDYDX31Dec2025",
        coinMinimalDenom: "y:stadydx:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "ydATOM31Dec2024",
        coinMinimalDenom: "y:udatom:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "ydATOM30Jun2025",
        coinMinimalDenom: "y:udatom:30Jun2025",
        coinDecimals: 6
      },
      {
        coinDenom: "ydATOM31Dec2025",
        coinMinimalDenom: "y:udatom:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "yTIA31Dec2024",
        coinMinimalDenom: "y:utia:31Dec2024",
        coinDecimals: 6
      },
      {
        coinDenom: "yTIA31Dec2025",
        coinMinimalDenom: "y:utia:31Dec2025",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:6:usdc.axl-usdc",
        coinMinimalDenom: "lp:6:uusdc.axl-uusdc",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:0:atom",
        coinMinimalDenom: "lp:0:uatom",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:2:atomypt-atom",
        coinMinimalDenom: "lp:2:uatomypt-uatom",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:3:atom-usdc",
        coinMinimalDenom: "lp:3:uatom-uusdc",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:1:INJ",
        coinMinimalDenom: "lp:1:inj",
        coinDecimals: 18
      },
      {
        coinDenom: "lp:4:INJypt-INJ",
        coinMinimalDenom: "lp:4:injypt-inj",
        coinDecimals: 18
      },
      {
        coinDenom: "lp:5:INJ-usdc",
        coinMinimalDenom: "lp:5:inj-uusdc",
        coinDecimals: 18
      },
      {
        coinDenom: "lp:8:osmo",
        coinMinimalDenom: "lp:8:uosmo",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:10:osmoypt-osmo",
        coinMinimalDenom: "lp:10:uosmoypt-uosmo",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:11:osmo-usdc",
        coinMinimalDenom: "lp:11:uosmo-uusdc",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:9:luna",
        coinMinimalDenom: "lp:9:uluna",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:12:lunaypt-luna",
        coinMinimalDenom: "lp:12:ulunaypt-uluna",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:13:luna-usdc",
        coinMinimalDenom: "lp:13:uluna-uusdc",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:14:auuu",
        coinMinimalDenom: "lp:14:uauuu",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:17:auuuypt-auuu",
        coinMinimalDenom: "lp:17:uauuuypt-uauuu",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:7:auuu-usdc",
        coinMinimalDenom: "lp:7:uauuu-uusdc",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:15:stdydx",
        coinMinimalDenom: "lp:15:stadydx",
        coinDecimals: 18
      },
      {
        coinDenom: "lp:18:stdydxypt-dydx",
        coinMinimalDenom: "lp:18:stadydxypt-adydx",
        coinDecimals: 18
      },
      {
        coinDenom: "lp:19:dydx-usdc",
        coinMinimalDenom: "lp:19:adydx-uusdc",
        coinDecimals: 18
      },
      {
        coinDenom: "lp:16:sttia",
        coinMinimalDenom: "lp:16:stutia",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:20:sttiaypt-tia",
        coinMinimalDenom: "lp:20:stutiaypt-utia",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:24:tia",
        coinMinimalDenom: "lp:24:utia",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:25:tiaypt-tia",
        coinMinimalDenom: "lp:25:utiaypt-utia",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:21:tia-usdc",
        coinMinimalDenom: "lp:21:utia-uusdc",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:22:datom",
        coinMinimalDenom: "lp:22:udatom",
        coinDecimals: 6
      },
      {
        coinDenom: "lp:23:datomypt-atom",
        coinMinimalDenom: "lp:23:udatomypt-uatom",
        coinDecimals: 6
      }
    ],
    rest: "https://api.pryzm.zone",
    rpc: "https://rpc.pryzm.zone",
    bech32Config: {
      bech32PrefixAccAddr: "pryzm",
      bech32PrefixAccPub: "pryzmpub",
      bech32PrefixValAddr: "pryzmvaloper",
      bech32PrefixValPub: "pryzmvaloperpub",
      bech32PrefixConsAddr: "pryzmvalcons",
      bech32PrefixConsPub: "pryzmvalconspub"
    },
    chainName: "pryzm",
    feeCurrencies: [
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 3e-3,
          high: 4e-3
        }
      },
      {
        coinDenom: "INJ",
        coinMinimalDenom: "ibc/DE63D8AC34B752FB7D4CAA7594145EDE1C9FC256AC6D4043D0F12310EB8FC255",
        coinDecimals: 18,
        gasPriceStep: {
          low: 5e8,
          average: 6e8,
          high: 7e8
        }
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/13B2C536BB057AC79D5616B8EA1B9540EC1F2170718CAFF6F0083C966FFFED0B",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.03,
          high: 0.04
        }
      },
      {
        coinDenom: "tia",
        coinMinimalDenom: "ibc/BF28D9C17E0306B194D50F51C3B2590BEAD15E04E03ADD34C3A26E62D85C9676",
        coinDecimals: 6,
        gasPriceStep: {
          low: 2e-3,
          average: 3e-3,
          high: 4e-3
        }
      },
      {
        coinDenom: "luna",
        coinMinimalDenom: "ibc/B8AF5D92165F35AB31F3FC7C7B444B9D240760FA5D406C49D24862BD0284E395",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.015,
          average: 0.02,
          high: 0.03
        }
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/BFAAB7870A9AAABF64A7366DAAA0B8E5065EAA1FCE762F45677DC24BE796EF65",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.02,
          average: 0.03,
          high: 0.04
        }
      },
      {
        coinDenom: "auuu",
        coinMinimalDenom: "factory/pryzm1jnhcsa5ddjsjq2t97v6a82z542rduxvtw6wd9h/uauuu",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.015,
          high: 0.02
        }
      },
      {
        coinDenom: "dydx",
        coinMinimalDenom: "ibc/F8CA5236869F819BC006EEF088E67889A26E4140339757878F0F4E229CDDA858",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e10,
          average: 12e9,
          high: 14e9
        }
      },
      {
        coinDenom: "stTIA",
        coinMinimalDenom: "ibc/FA78980867B7E87F382CDA00275C55DDC248CABC7DEE27AC6868CCF97DD5E02F",
        coinDecimals: 6,
        gasPriceStep: {
          low: 2e-3,
          average: 3e-3,
          high: 4e-3
        }
      },
      {
        coinDenom: "stDYDX",
        coinMinimalDenom: "ibc/120DC39B61CC121E91525C1D51624E41BBE74C537D7B0BE50BBFF9A00E37B6EE",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e10,
          average: 12e9,
          high: 14e9
        }
      },
      {
        coinDenom: "dATOM",
        coinMinimalDenom: "ibc/EA6E1E8BA2EB9F681C4BD12C8C81A46530A62934F2BD561B120A00F46946CE87",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 3e-3,
          high: 4e-3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "pryzm",
      coinMinimalDenom: "upryzm",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "PUNDIX",
    currencies: [
      {
        coinDenom: "PUNDIX",
        coinMinimalDenom: "ibc/55367B7B6572631B78A93C66EF9FDFCE87CDE372CC4ED7848DA78C1EB1DCDD78",
        coinDecimals: 18
      },
      {
        coinDenom: "PURSE",
        coinMinimalDenom: "bsc0x29a63F4B209C29B4DC47f06FFA896F32667DAD2C",
        coinDecimals: 18
      }
    ],
    rest: "https://px-rest.pundix.com",
    rpc: "https://px-json.pundix.com",
    bech32Config: {
      bech32PrefixAccAddr: "px",
      bech32PrefixAccPub: "pxpub",
      bech32PrefixValAddr: "pxvaloper",
      bech32PrefixValPub: "pxvaloperpub",
      bech32PrefixConsAddr: "pxvalcons",
      bech32PrefixConsPub: "pxvalconspub"
    },
    chainName: "pundix",
    feeCurrencies: [
      {
        coinDenom: "PUNDIX",
        coinMinimalDenom: "ibc/55367B7B6572631B78A93C66EF9FDFCE87CDE372CC4ED7848DA78C1EB1DCDD78",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e12,
          average: 25e11,
          high: 3e12
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "PUNDIX",
      coinMinimalDenom: "ibc/55367B7B6572631B78A93C66EF9FDFCE87CDE372CC4ED7848DA78C1EB1DCDD78",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "pylons-mainnet-1",
    currencies: [
      {
        coinDenom: "rock",
        coinMinimalDenom: "ubedrock",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.nodejumper.io/pylons",
    rpc: "https://rpc.nodejumper.io:443/pylons",
    bech32Config: {
      bech32PrefixAccAddr: "pylo",
      bech32PrefixAccPub: "pylopub",
      bech32PrefixValAddr: "pylovaloper",
      bech32PrefixValPub: "pylovaloperpub",
      bech32PrefixConsAddr: "pylovalcons",
      bech32PrefixConsPub: "pylovalconspub"
    },
    chainName: "pylons",
    feeCurrencies: [
      {
        coinDenom: "rock",
        coinMinimalDenom: "ubedrock",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "rock",
      coinMinimalDenom: "ubedrock",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "qfs-1",
    currencies: [
      {
        coinDenom: "qfs",
        coinMinimalDenom: "qfs",
        coinDecimals: 0
      }
    ],
    rest: "https://lcd.qfsone.com",
    rpc: "https://rcp.qfsone.com",
    bech32Config: {
      bech32PrefixAccAddr: "qfs",
      bech32PrefixAccPub: "qfspub",
      bech32PrefixValAddr: "qfsvaloper",
      bech32PrefixValPub: "qfsvaloperpub",
      bech32PrefixConsAddr: "qfsvalcons",
      bech32PrefixConsPub: "qfsvalconspub"
    },
    chainName: "qfs",
    feeCurrencies: [
      {
        coinDenom: "qfs",
        coinMinimalDenom: "qfs",
        coinDecimals: 0,
        gasPriceStep: {
          low: 1e-6,
          average: 5e-6,
          high: 1e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "qfs",
      coinMinimalDenom: "qfs",
      coinDecimals: 0
    },
    bip44: {
      coinType: 1179993431
    }
  },
  {
    chainId: "quasar-1",
    currencies: [
      {
        coinDenom: "qsr",
        coinMinimalDenom: "uqsr",
        coinDecimals: 6
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/0471F1C4E7AFD3F07702BEF6DC365268D64570F7C1FDC98EA6098DD6DE59817B",
        coinDecimals: 6
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/FA0006F056DB6719B8C16C551FC392B62F5729978FC0B125AC9A432DBB2AA1A5",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/FA7775734CC73176B7425910DE001A1D2AD9B6D9E93129A5D0750EAD13E4E63A",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.lavenderfive.com:443/quasar",
    rpc: "https://rpc.lavenderfive.com:443/quasar",
    bech32Config: {
      bech32PrefixAccAddr: "quasar",
      bech32PrefixAccPub: "quasarpub",
      bech32PrefixValAddr: "quasarvaloper",
      bech32PrefixValPub: "quasarvaloperpub",
      bech32PrefixConsAddr: "quasarvalcons",
      bech32PrefixConsPub: "quasarvalconspub"
    },
    chainName: "quasar",
    feeCurrencies: [
      {
        coinDenom: "qsr",
        coinMinimalDenom: "uqsr",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.1,
          average: 0.25,
          high: 0.3
        }
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/0471F1C4E7AFD3F07702BEF6DC365268D64570F7C1FDC98EA6098DD6DE59817B",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/FA0006F056DB6719B8C16C551FC392B62F5729978FC0B125AC9A432DBB2AA1A5",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/FA7775734CC73176B7425910DE001A1D2AD9B6D9E93129A5D0750EAD13E4E63A",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "qsr",
      coinMinimalDenom: "uqsr",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "quicksilver-2",
    currencies: [
      {
        coinDenom: "qck",
        coinMinimalDenom: "uqck",
        coinDecimals: 6
      },
      {
        coinDenom: "qstars",
        coinMinimalDenom: "uqstars",
        coinDecimals: 6
      },
      {
        coinDenom: "qatom",
        coinMinimalDenom: "uqatom",
        coinDecimals: 6
      },
      {
        coinDenom: "qregen",
        coinMinimalDenom: "uqregen",
        coinDecimals: 6
      },
      {
        coinDenom: "qosmo",
        coinMinimalDenom: "uqosmo",
        coinDecimals: 6
      },
      {
        coinDenom: "qsomm",
        coinMinimalDenom: "uqsomm",
        coinDecimals: 6
      },
      {
        coinDenom: "qjuno",
        coinMinimalDenom: "uqjuno",
        coinDecimals: 6
      },
      {
        coinDenom: "qdydx",
        coinMinimalDenom: "aqdydx",
        coinDecimals: 18
      },
      {
        coinDenom: "qsaga",
        coinMinimalDenom: "uqsaga",
        coinDecimals: 6
      },
      {
        coinDenom: "qbld",
        coinMinimalDenom: "uqbld",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/5666A86DCC869C75F69A7938AD6DCFECAC4A09C73522599E7A85B10143E5FBD2",
        coinDecimals: 6
      }
    ],
    rest: "https://api-quicksilver.takeshi.team:443",
    rpc: "https://rpc-quicksilver.takeshi.team:443",
    bech32Config: {
      bech32PrefixAccAddr: "quick",
      bech32PrefixAccPub: "quickpub",
      bech32PrefixValAddr: "quickvaloper",
      bech32PrefixValPub: "quickvaloperpub",
      bech32PrefixConsAddr: "quickvalcons",
      bech32PrefixConsPub: "quickvalconspub"
    },
    chainName: "quicksilver",
    feeCurrencies: [
      {
        coinDenom: "qck",
        coinMinimalDenom: "uqck",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-4,
          average: 1e-4,
          high: 25e-5
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "qck",
      coinMinimalDenom: "uqck",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "qwoyn-1",
    currencies: [
      {
        coinDenom: "qwoyn",
        coinMinimalDenom: "uqwoyn",
        coinDecimals: 6
      }
    ],
    rest: "https://rest-qwoyn.theamsolutions.info:443",
    rpc: "https://rpc.qwoyn.studio:443",
    bech32Config: {
      bech32PrefixAccAddr: "qwoyn",
      bech32PrefixAccPub: "qwoynpub",
      bech32PrefixValAddr: "qwoynvaloper",
      bech32PrefixValPub: "qwoynvaloperpub",
      bech32PrefixConsAddr: "qwoynvalcons",
      bech32PrefixConsPub: "qwoynvalconspub"
    },
    chainName: "qwoyn",
    feeCurrencies: [
      {
        coinDenom: "qwoyn",
        coinMinimalDenom: "uqwoyn",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.03,
          average: 0.05,
          high: 0.075
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "qwoyn",
      coinMinimalDenom: "uqwoyn",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "realionetwork_3301-1",
    currencies: [
      {
        coinDenom: "rio",
        coinMinimalDenom: "ario",
        coinDecimals: 18
      },
      {
        coinDenom: "rst",
        coinMinimalDenom: "arst",
        coinDecimals: 18
      }
    ],
    rest: "https://realio-api.genznodes.dev",
    rpc: "https://realio-rpc.genznodes.dev",
    bech32Config: {
      bech32PrefixAccAddr: "realio",
      bech32PrefixAccPub: "realiopub",
      bech32PrefixValAddr: "realiovaloper",
      bech32PrefixValPub: "realiovaloperpub",
      bech32PrefixConsAddr: "realiovalcons",
      bech32PrefixConsPub: "realiovalconspub"
    },
    chainName: "realio",
    feeCurrencies: [
      {
        coinDenom: "rio",
        coinMinimalDenom: "ario",
        coinDecimals: 18,
        gasPriceStep: {
          low: 4e9,
          average: 5e9,
          high: 8e9
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "rio",
      coinMinimalDenom: "ario",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "reb_1111-1",
    currencies: [
      {
        coinDenom: "rebus",
        coinMinimalDenom: "arebus",
        coinDecimals: 18
      }
    ],
    rest: "https://api.rebuschain.com:1317/",
    rpc: "https://api.rebuschain.com:26657/",
    bech32Config: {
      bech32PrefixAccAddr: "rebus",
      bech32PrefixAccPub: "rebuspub",
      bech32PrefixValAddr: "rebusvaloper",
      bech32PrefixValPub: "rebusvaloperpub",
      bech32PrefixConsAddr: "rebusvalcons",
      bech32PrefixConsPub: "rebusvalconspub"
    },
    chainName: "rebus",
    feeCurrencies: [
      {
        coinDenom: "rebus",
        coinMinimalDenom: "arebus",
        coinDecimals: 18,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "rebus",
      coinMinimalDenom: "arebus",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "regen-1",
    currencies: [
      {
        coinDenom: "regen",
        coinMinimalDenom: "uregen",
        coinDecimals: 6
      },
      {
        coinDenom: "nct",
        coinMinimalDenom: "eco.uC.NCT",
        coinDecimals: 6
      }
    ],
    rest: "http://public-rpc.regen.vitwit.com:1317",
    rpc: "https://rpc-regen.ecostake.com",
    bech32Config: {
      bech32PrefixAccAddr: "regen",
      bech32PrefixAccPub: "regenpub",
      bech32PrefixValAddr: "regenvaloper",
      bech32PrefixValPub: "regenvaloperpub",
      bech32PrefixConsAddr: "regenvalcons",
      bech32PrefixConsPub: "regenvalconspub"
    },
    chainName: "regen",
    feeCurrencies: [
      {
        coinDenom: "regen",
        coinMinimalDenom: "uregen",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.015,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "regen",
      coinMinimalDenom: "uregen",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "titan-1",
    currencies: [
      {
        coinDenom: "atolo",
        coinMinimalDenom: "uatolo",
        coinDecimals: 6
      }
    ],
    rest: "https://restapi.rizon.world/",
    rpc: "https://rpcapi.rizon.world/",
    bech32Config: {
      bech32PrefixAccAddr: "rizon",
      bech32PrefixAccPub: "rizonpub",
      bech32PrefixValAddr: "rizonvaloper",
      bech32PrefixValPub: "rizonvaloperpub",
      bech32PrefixConsAddr: "rizonvalcons",
      bech32PrefixConsPub: "rizonvalconspub"
    },
    chainName: "rizon",
    feeCurrencies: [
      {
        coinDenom: "atolo",
        coinMinimalDenom: "uatolo",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.035
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "atolo",
      coinMinimalDenom: "uatolo",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "router_9600-1",
    currencies: [
      {
        coinDenom: "ROUTE",
        coinMinimalDenom: "route",
        coinDecimals: 18
      }
    ],
    rest: "https://sentry.lcd.routerprotocol.com/",
    rpc: "https://sentry.tm.rpc.routerprotocol.com/",
    bech32Config: {
      bech32PrefixAccAddr: "router",
      bech32PrefixAccPub: "routerpub",
      bech32PrefixValAddr: "routervaloper",
      bech32PrefixValPub: "routervaloperpub",
      bech32PrefixConsAddr: "routervalcons",
      bech32PrefixConsPub: "routervalconspub"
    },
    chainName: "routerchain",
    feeCurrencies: [
      {
        coinDenom: "ROUTE",
        coinMinimalDenom: "route",
        coinDecimals: 18,
        gasPriceStep: {
          low: 7,
          average: 7,
          high: 10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ROUTE",
      coinMinimalDenom: "route",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "ssc-1",
    currencies: [
      {
        coinDenom: "saga",
        coinMinimalDenom: "usaga",
        coinDecimals: 6
      }
    ],
    rest: "https://saga-mainnet-lcd.autostake.com:443",
    rpc: "https://rpc-saga.keplr.app",
    bech32Config: {
      bech32PrefixAccAddr: "saga",
      bech32PrefixAccPub: "sagapub",
      bech32PrefixValAddr: "sagavaloper",
      bech32PrefixValPub: "sagavaloperpub",
      bech32PrefixConsAddr: "sagavalcons",
      bech32PrefixConsPub: "sagavalconspub"
    },
    chainName: "saga",
    feeCurrencies: [
      {
        coinDenom: "saga",
        coinMinimalDenom: "usaga",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "saga",
      coinMinimalDenom: "usaga",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "scorum-1",
    currencies: [
      {
        coinDenom: "scr",
        coinMinimalDenom: "nscr",
        coinDecimals: 9
      },
      {
        coinDenom: "gas",
        coinMinimalDenom: "gas",
        coinDecimals: 0
      }
    ],
    rest: "https://scorum-blockchain-mainnet-api.scorum.com",
    rpc: "https://scorum-blockchain-mainnet-rpc.scorum.com",
    bech32Config: {
      bech32PrefixAccAddr: "scorum",
      bech32PrefixAccPub: "scorumpub",
      bech32PrefixValAddr: "scorumvaloper",
      bech32PrefixValPub: "scorumvaloperpub",
      bech32PrefixConsAddr: "scorumvalcons",
      bech32PrefixConsPub: "scorumvalconspub"
    },
    chainName: "scorum",
    feeCurrencies: [
      {
        coinDenom: "gas",
        coinMinimalDenom: "gas",
        coinDecimals: 0,
        gasPriceStep: {
          low: 1,
          average: 1,
          high: 1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "scr",
      coinMinimalDenom: "nscr",
      coinDecimals: 9
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "secret-4",
    currencies: [
      {
        coinDenom: "scrt",
        coinMinimalDenom: "uscrt",
        coinDecimals: 6
      },
      {
        coinDenom: "sienna",
        coinMinimalDenom: "cw20:secret1rgm2m5t530tdzyd99775n6vzumxa5luxcllml4",
        coinDecimals: 18
      },
      {
        coinDenom: "shd",
        coinMinimalDenom: "cw20:secret1qfql357amn448duf5gvp9gr48sxx9tsnhupu3d",
        coinDecimals: 8
      },
      {
        coinDenom: "shd",
        coinMinimalDenom: "cw20:secret153wu605vvp934xhd4k9dtd640zsep5jkesstdm",
        coinDecimals: 8
      },
      {
        coinDenom: "silk",
        coinMinimalDenom: "cw20:secret1fl449muk5yq8dlad7a22nje4p5d2pnsgymhjfd",
        coinDecimals: 6
      },
      {
        coinDenom: "stkd-scrt",
        coinMinimalDenom: "cw20:secret1k6u0cy4feepm6pehnz804zmwakuwdapm69tuc4",
        coinDecimals: 6
      },
      {
        coinDenom: "butt",
        coinMinimalDenom: "cw20:secret1yxcexylwyxlq58umhgsjgstgcg2a0ytfy4d9lt",
        coinDecimals: 6
      },
      {
        coinDenom: "alter",
        coinMinimalDenom: "cw20:secret12rcvz0umvk875kd6a803txhtlu7y0pnd73kcej",
        coinDecimals: 6
      },
      {
        coinDenom: "amber",
        coinMinimalDenom: "cw20:secret1s09x2xvfd2lp2skgzm29w2xtena7s8fq98v852",
        coinDecimals: 6
      },
      {
        coinDenom: "shill",
        coinMinimalDenom: "cw20:secret197dvnt9yjxwn8sjdlx05f7zuk27lsdxtfnwxse",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.lavenderfive.com:443/secretnetwork",
    rpc: "https://scrt.public-rpc.com",
    bech32Config: {
      bech32PrefixAccAddr: "secret",
      bech32PrefixAccPub: "secretpub",
      bech32PrefixValAddr: "secretvaloper",
      bech32PrefixValPub: "secretvaloperpub",
      bech32PrefixConsAddr: "secretvalcons",
      bech32PrefixConsPub: "secretvalconspub"
    },
    chainName: "secretnetwork",
    feeCurrencies: [
      {
        coinDenom: "scrt",
        coinMinimalDenom: "uscrt",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.05,
          average: 0.1,
          high: 0.25
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "scrt",
      coinMinimalDenom: "uscrt",
      coinDecimals: 6
    },
    bip44: {
      coinType: 529
    }
  },
  {
    chainId: "seda-1",
    currencies: [
      {
        coinDenom: "seda",
        coinMinimalDenom: "aseda",
        coinDecimals: 18
      }
    ],
    rest: "https://lcd.mainnet.seda.xyz/",
    rpc: "https://rpc.mainnet.seda.xyz/",
    bech32Config: {
      bech32PrefixAccAddr: "seda",
      bech32PrefixAccPub: "sedapub",
      bech32PrefixValAddr: "sedavaloper",
      bech32PrefixValPub: "sedavaloperpub",
      bech32PrefixConsAddr: "sedavalcons",
      bech32PrefixConsPub: "sedavalconspub"
    },
    chainName: "seda",
    feeCurrencies: [
      {
        coinDenom: "seda",
        coinMinimalDenom: "aseda",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e10,
          average: 1e10,
          high: 14e9
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "seda",
      coinMinimalDenom: "aseda",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "pacific-1",
    currencies: [
      {
        coinDenom: "sei",
        coinMinimalDenom: "usei",
        coinDecimals: 6
      },
      {
        coinDenom: "oin",
        coinMinimalDenom: "factory/sei1thgp6wamxwqt7rthfkeehktmq0ujh5kspluw6w/OIN",
        coinDecimals: 6
      },
      {
        coinDenom: "ampSEI",
        coinMinimalDenom: "factory/sei1x2fgaaqecvk8kwuqkjqcj27clw5p5g99uawdzy9sc4rku8avumcq3cky4k/ampSEI",
        coinDecimals: 6
      },
      {
        coinDenom: "popeye",
        coinMinimalDenom: "factory/sei1fl8pg59wfsgw2wp4aruk38zqccfnc2g8ptrm24/popeye",
        coinDecimals: 6
      },
      {
        coinDenom: "sensei",
        coinMinimalDenom: "factory/sei1ta5rkr6y2qlkj7px8w2cvear7m2822q4f4ea0m/sensei",
        coinDecimals: 6
      },
      {
        coinDenom: "WOSMO",
        coinMinimalDenom: "ibc/B023C57727A38A9CF87238F9008477C3761AD4774D528BFA458DD707D90B553A",
        coinDecimals: 6
      },
      {
        coinDenom: "oozaru",
        coinMinimalDenom: "sei1wlf9j5uv50rcg0u5j6xk00px5tflptzprj39keck27eg8g7qd7hqq6kvda",
        coinDecimals: 6
      },
      {
        coinDenom: "SEIYAN",
        coinMinimalDenom: "cw20:sei1hrndqntlvtmx2kepr0zsfgr7nzjptcc72cr4ppk4yav58vvy7v3s4er8ed",
        coinDecimals: 6
      },
      {
        coinDenom: "astro",
        coinMinimalDenom: "ibc/063F4461F7317CFF10F50AB044E44932D22AAD84FA7107082744946E6DB7B7A8",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.sei-apis.com",
    rpc: "https://rpc.sei-apis.com",
    bech32Config: {
      bech32PrefixAccAddr: "sei",
      bech32PrefixAccPub: "seipub",
      bech32PrefixValAddr: "seivaloper",
      bech32PrefixValPub: "seivaloperpub",
      bech32PrefixConsAddr: "seivalcons",
      bech32PrefixConsPub: "seivalconspub"
    },
    chainName: "sei",
    feeCurrencies: [
      {
        coinDenom: "sei",
        coinMinimalDenom: "usei",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.02,
          average: 0.02,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "sei",
      coinMinimalDenom: "usei",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "self-1",
    currencies: [
      {
        coinDenom: "slf",
        coinMinimalDenom: "uslf",
        coinDecimals: 6
      }
    ],
    rest: "https://api.selfchain.io",
    rpc: "https://rpc.selfchain.io:26657",
    bech32Config: {
      bech32PrefixAccAddr: "self",
      bech32PrefixAccPub: "selfpub",
      bech32PrefixValAddr: "selfvaloper",
      bech32PrefixValPub: "selfvaloperpub",
      bech32PrefixConsAddr: "selfvalcons",
      bech32PrefixConsPub: "selfvalconspub"
    },
    chainName: "self",
    feeCurrencies: [
      {
        coinDenom: "slf",
        coinMinimalDenom: "uslf",
        coinDecimals: 6,
        gasPriceStep: {
          low: 5e-3,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "slf",
      coinMinimalDenom: "uslf",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "sentinelhub-2",
    currencies: [
      {
        coinDenom: "dvpn",
        coinMinimalDenom: "udvpn",
        coinDecimals: 6
      }
    ],
    rest: "https://api-sentinel.busurnode.com",
    rpc: "https://rpc-sentinel.busurnode.com",
    bech32Config: {
      bech32PrefixAccAddr: "sent",
      bech32PrefixAccPub: "sentpub",
      bech32PrefixValAddr: "sentvaloper",
      bech32PrefixValPub: "sentvaloperpub",
      bech32PrefixConsAddr: "sentvalcons",
      bech32PrefixConsPub: "sentvalconspub"
    },
    chainName: "sentinel",
    feeCurrencies: [
      {
        coinDenom: "dvpn",
        coinMinimalDenom: "udvpn",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.1,
          average: 0.25,
          high: 0.4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "dvpn",
      coinMinimalDenom: "udvpn",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "sgenet-1",
    currencies: [
      {
        coinDenom: "sge",
        coinMinimalDenom: "usge",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.lavenderfive.com:443/sge",
    rpc: "https://rpc.lavenderfive.com:443/sge",
    bech32Config: {
      bech32PrefixAccAddr: "sge",
      bech32PrefixAccPub: "sgepub",
      bech32PrefixValAddr: "sgevaloper",
      bech32PrefixValPub: "sgevaloperpub",
      bech32PrefixConsAddr: "sgevalcons",
      bech32PrefixConsPub: "sgevalconspub"
    },
    chainName: "sge",
    feeCurrencies: [
      {
        coinDenom: "sge",
        coinMinimalDenom: "usge",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.1,
          average: 0.25,
          high: 0.5
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "sge",
      coinMinimalDenom: "usge",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "ShareRing-VoyagerNet",
    currencies: [
      {
        coinDenom: "shr",
        coinMinimalDenom: "nshr",
        coinDecimals: 9
      }
    ],
    rest: "https://lcd.explorer.shareri.ng/",
    rpc: "https://rpc.explorer.shareri.ng",
    bech32Config: {
      bech32PrefixAccAddr: "shareledger",
      bech32PrefixAccPub: "shareledgerpub",
      bech32PrefixValAddr: "shareledgervaloper",
      bech32PrefixValPub: "shareledgervaloperpub",
      bech32PrefixConsAddr: "shareledgervalcons",
      bech32PrefixConsPub: "shareledgervalconspub"
    },
    chainName: "shareledger",
    feeCurrencies: [
      {
        coinDenom: "shr",
        coinMinimalDenom: "nshr",
        coinDecimals: 9,
        gasPriceStep: {
          low: 2e3,
          average: 3e3,
          high: 4e3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "shr",
      coinMinimalDenom: "nshr",
      coinDecimals: 9
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "shentu-2.2",
    currencies: [
      {
        coinDenom: "ctk",
        coinMinimalDenom: "uctk",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.shentu.org/",
    rpc: "https://rpc.shentu.org:443",
    bech32Config: {
      bech32PrefixAccAddr: "shentu",
      bech32PrefixAccPub: "shentupub",
      bech32PrefixValAddr: "shentuvaloper",
      bech32PrefixValPub: "shentuvaloperpub",
      bech32PrefixConsAddr: "shentuvalcons",
      bech32PrefixConsPub: "shentuvalconspub"
    },
    chainName: "shentu",
    feeCurrencies: [
      {
        coinDenom: "ctk",
        coinMinimalDenom: "uctk",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ctk",
      coinMinimalDenom: "uctk",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "shido_9008-1",
    currencies: [
      {
        coinDenom: "SHIDO",
        coinMinimalDenom: "shido",
        coinDecimals: 18
      }
    ],
    rest: "https://swagger.shidoscan.com",
    rpc: "https://tendermint.shidoscan.com",
    bech32Config: {
      bech32PrefixAccAddr: "shido",
      bech32PrefixAccPub: "shidopub",
      bech32PrefixValAddr: "shidovaloper",
      bech32PrefixValPub: "shidovaloperpub",
      bech32PrefixConsAddr: "shidovalcons",
      bech32PrefixConsPub: "shidovalconspub"
    },
    chainName: "shido",
    feeCurrencies: [
      {
        coinDenom: "SHIDO",
        coinMinimalDenom: "shido",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e10,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "SHIDO",
      coinMinimalDenom: "shido",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "sifchain-1",
    currencies: [
      {
        coinDenom: "ROWAN",
        coinMinimalDenom: "rowan",
        coinDecimals: 18
      }
    ],
    rest: "https://api-sifchain-ia.cosmosia.notional.ventures/",
    rpc: "https://sifchain-rpc.polkachu.com",
    bech32Config: {
      bech32PrefixAccAddr: "sif",
      bech32PrefixAccPub: "sifpub",
      bech32PrefixValAddr: "sifvaloper",
      bech32PrefixValPub: "sifvaloperpub",
      bech32PrefixConsAddr: "sifvalcons",
      bech32PrefixConsPub: "sifvalconspub"
    },
    chainName: "sifchain",
    feeCurrencies: [
      {
        coinDenom: "ROWAN",
        coinMinimalDenom: "rowan",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e12,
          average: 15e11,
          high: 2e12
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ROWAN",
      coinMinimalDenom: "rowan",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "sixnet",
    currencies: [
      {
        coinDenom: "six",
        coinMinimalDenom: "usix",
        coinDecimals: 6
      }
    ],
    rest: "https://sixnet-api.sixprotocol.net:443",
    rpc: "https://sixnet-rpc.sixprotocol.net:443",
    bech32Config: {
      bech32PrefixAccAddr: "6x",
      bech32PrefixAccPub: "6xpub",
      bech32PrefixValAddr: "6xvaloper",
      bech32PrefixValPub: "6xvaloperpub",
      bech32PrefixConsAddr: "6xvalcons",
      bech32PrefixConsPub: "6xvalconspub"
    },
    chainName: "six",
    feeCurrencies: [
      {
        coinDenom: "six",
        coinMinimalDenom: "usix",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1.25,
          average: 1.5,
          high: 1.75
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "six",
      coinMinimalDenom: "usix",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "sommelier-3",
    currencies: [
      {
        coinDenom: "somm",
        coinMinimalDenom: "usomm",
        coinDecimals: 6
      }
    ],
    rest: "https://api-sommelier.pupmos.network",
    rpc: "https://sommelier-rpc.polkachu.com",
    bech32Config: {
      bech32PrefixAccAddr: "somm",
      bech32PrefixAccPub: "sommpub",
      bech32PrefixValAddr: "sommvaloper",
      bech32PrefixValPub: "sommvaloperpub",
      bech32PrefixConsAddr: "sommvalcons",
      bech32PrefixConsPub: "sommvalconspub"
    },
    chainName: "sommelier",
    feeCurrencies: [
      {
        coinDenom: "somm",
        coinMinimalDenom: "usomm",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "somm",
      coinMinimalDenom: "usomm",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "source-1",
    currencies: [
      {
        coinDenom: "source",
        coinMinimalDenom: "usource",
        coinDecimals: 6
      },
      {
        coinDenom: "srcx",
        coinMinimalDenom: "ibc/FC5A7360EEED0713AE3E83E9D55A69AF873056A172AC495890ACE4582FF9685A",
        coinDecimals: 9
      }
    ],
    rest: "https://api.source.nodestake.top",
    rpc: "https://rpc.source.nodestake.top",
    bech32Config: {
      bech32PrefixAccAddr: "source",
      bech32PrefixAccPub: "sourcepub",
      bech32PrefixValAddr: "sourcevaloper",
      bech32PrefixValPub: "sourcevaloperpub",
      bech32PrefixConsAddr: "sourcevalcons",
      bech32PrefixConsPub: "sourcevalconspub"
    },
    chainName: "source",
    feeCurrencies: [
      {
        coinDenom: "source",
        coinMinimalDenom: "usource",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.05,
          average: 0.075,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "source",
      coinMinimalDenom: "usource",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "stafihub-1",
    currencies: [
      {
        coinDenom: "fis",
        coinMinimalDenom: "ufis",
        coinDecimals: 6
      },
      {
        coinDenom: "ratom",
        coinMinimalDenom: "uratom",
        coinDecimals: 6
      },
      {
        coinDenom: "riris",
        coinMinimalDenom: "uriris",
        coinDecimals: 6
      },
      {
        coinDenom: "rhuahua",
        coinMinimalDenom: "urhuahua",
        coinDecimals: 6
      },
      {
        coinDenom: "rswth",
        coinMinimalDenom: "urswth",
        coinDecimals: 8
      }
    ],
    rest: "https://public-rest-rpc1.stafihub.io",
    rpc: "https://public-rpc1.stafihub.io:443",
    bech32Config: {
      bech32PrefixAccAddr: "stafi",
      bech32PrefixAccPub: "stafipub",
      bech32PrefixValAddr: "stafivaloper",
      bech32PrefixValPub: "stafivaloperpub",
      bech32PrefixConsAddr: "stafivalcons",
      bech32PrefixConsPub: "stafivalconspub"
    },
    chainName: "stafihub",
    feeCurrencies: [
      {
        coinDenom: "fis",
        coinMinimalDenom: "ufis",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "fis",
      coinMinimalDenom: "ufis",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "stargaze-1",
    currencies: [
      {
        coinDenom: "stars",
        coinMinimalDenom: "ustars",
        coinDecimals: 6
      },
      {
        coinDenom: "strdst",
        coinMinimalDenom: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/dust",
        coinDecimals: 6
      },
      {
        coinDenom: "GAZE",
        coinMinimalDenom: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/mGAZE",
        coinDecimals: 6
      },
      {
        coinDenom: "BRNCH",
        coinMinimalDenom: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uBRNCH",
        coinDecimals: 6
      },
      {
        coinDenom: "OHH",
        coinMinimalDenom: "factory/stars16da2uus9zrsy83h23ur42v3lglg5rmyrpqnju4/uOHH",
        coinDecimals: 6
      },
      {
        coinDenom: "sneaky",
        coinMinimalDenom: "factory/stars1xx5976njvxpl9n4v8huvff6cudhx7yuu8e7rt4/usneaky",
        coinDecimals: 6
      },
      {
        coinDenom: "LAB",
        coinMinimalDenom: "ibc/93B1AE0AD5E88242745B245064A2A51DDA1319C18176A966D5F8F9E02ED5373E",
        coinDecimals: 6
      },
      {
        coinDenom: "CDT",
        coinMinimalDenom: "ibc/B0263C28B6F44651F4596413B41FDB749EA010BD1220816DAC0ABF9947C1E806",
        coinDecimals: 6
      },
      {
        coinDenom: "MBRN",
        coinMinimalDenom: "ibc/E94BB144B818CB8061F43E202BEA1E9273B87D6326C8C6F4E6AE71C62FD37854",
        coinDecimals: 6
      },
      {
        coinDenom: "astro",
        coinMinimalDenom: "ibc/C9C8D88917374F27F03CBCEAF4F1B85F45A62F9F2316CBAADAAC5FDB3675DD3F",
        coinDecimals: 6
      },
      {
        coinDenom: "PLEB",
        coinMinimalDenom: "factory/stars1k7qsxdxh8calmt4txk75e6hdntefslegwddqnlwjjqgjkmcfqy0qa97sn8/pleb",
        coinDecimals: 6
      },
      {
        coinDenom: "KINGSHIT",
        coinMinimalDenom: "factory/stars133a6mnkp9d3pkt48y699hy0tvq5xngpz7cwak0qr4suq0cj9zpfslvt0em/kingshit",
        coinDecimals: 6
      },
      {
        coinDenom: "BOTZ",
        coinMinimalDenom: "factory/stars132jrwxjps93usq3ejy7cq6qqc7j3gtx3mu8jhaj5nnk3p0ste2ssqsndvj/botz",
        coinDecimals: 6
      },
      {
        coinDenom: "COCKS",
        coinMinimalDenom: "factory/stars14mfk0sd6rlajkvgpgrvfk9lfhjwmkrzvednekvcn32jzy3drjy5sfem9p7/cocks",
        coinDecimals: 6
      },
      {
        coinDenom: "XTRUMP",
        coinMinimalDenom: "ibc/4982C47384F003FCCB02490F92CE2F23DBEC9A7A0C1F440BDB12D24357E6703D",
        coinDecimals: 6
      },
      {
        coinDenom: "WOLFSHIT",
        coinMinimalDenom: "factory/stars167y92c2fe690l0lrqyk9tahpqvu97au0cmpayh3j9455r2f6f06s78emw4/wolfshit",
        coinDecimals: 6
      },
      {
        coinDenom: "VLT",
        coinMinimalDenom: "factory/stars1t6fyr84hn6lyjdvk3e3c697cptfn5cwat2jxqyzuvuesaypznslshy6x9v/vlt",
        coinDecimals: 6
      },
      {
        coinDenom: "bglSTARS",
        coinMinimalDenom: "factory/stars1ur79p98rmpn456esgzjernaxy7v25mlwqsv8uhymzxahfw77427syk2h9j/bglSTARS",
        coinDecimals: 6
      },
      {
        coinDenom: "bglUSDC",
        coinMinimalDenom: "factory/stars1ur79p98rmpn456esgzjernaxy7v25mlwqsv8uhymzxahfw77427syk2h9j/bglUSDC",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.stargaze-apis.com/",
    rpc: "https://rpc.stargaze-apis.com/",
    bech32Config: {
      bech32PrefixAccAddr: "stars",
      bech32PrefixAccPub: "starspub",
      bech32PrefixValAddr: "starsvaloper",
      bech32PrefixValPub: "starsvaloperpub",
      bech32PrefixConsAddr: "starsvalcons",
      bech32PrefixConsPub: "starsvalconspub"
    },
    chainName: "stargaze",
    feeCurrencies: [
      {
        coinDenom: "stars",
        coinMinimalDenom: "ustars",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 1.1,
          high: 1.2
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "stars",
      coinMinimalDenom: "ustars",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "iov-mainnet-ibc",
    currencies: [
      {
        coinDenom: "iov",
        coinMinimalDenom: "uiov",
        coinDecimals: 6
      }
    ],
    rest: "https://api-starname-ia.cosmosia.notional.ventures/",
    rpc: "https://rpc-starname-ia.cosmosia.notional.ventures/",
    bech32Config: {
      bech32PrefixAccAddr: "star",
      bech32PrefixAccPub: "starpub",
      bech32PrefixValAddr: "starvaloper",
      bech32PrefixValPub: "starvaloperpub",
      bech32PrefixConsAddr: "starvalcons",
      bech32PrefixConsPub: "starvalconspub"
    },
    chainName: "starname",
    feeCurrencies: [
      {
        coinDenom: "iov",
        coinMinimalDenom: "uiov",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 2,
          high: 3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "iov",
      coinMinimalDenom: "uiov",
      coinDecimals: 6
    },
    bip44: {
      coinType: 234
    }
  },
  {
    chainId: "stratos-1",
    currencies: [
      {
        coinDenom: "stos",
        coinMinimalDenom: "wei",
        coinDecimals: 18
      }
    ],
    rest: "https://rest.thestratos.org",
    rpc: "https://rpc.thestratos.org",
    bech32Config: {
      bech32PrefixAccAddr: "st",
      bech32PrefixAccPub: "stpub",
      bech32PrefixValAddr: "stvaloper",
      bech32PrefixValPub: "stvaloperpub",
      bech32PrefixConsAddr: "stvalcons",
      bech32PrefixConsPub: "stvalconspub"
    },
    chainName: "stratos",
    feeCurrencies: [
      {
        coinDenom: "stos",
        coinMinimalDenom: "wei",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e9,
          average: 12e8,
          high: 16e8
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "stos",
      coinMinimalDenom: "wei",
      coinDecimals: 18
    },
    bip44: {
      coinType: 606
    }
  },
  {
    chainId: "stride-1",
    currencies: [
      {
        coinDenom: "strd",
        coinMinimalDenom: "ustrd",
        coinDecimals: 6
      },
      {
        coinDenom: "statom",
        coinMinimalDenom: "stuatom",
        coinDecimals: 6
      },
      {
        coinDenom: "ststars",
        coinMinimalDenom: "stustars",
        coinDecimals: 6
      },
      {
        coinDenom: "stosmo",
        coinMinimalDenom: "stuosmo",
        coinDecimals: 6
      },
      {
        coinDenom: "stjuno",
        coinMinimalDenom: "stujuno",
        coinDecimals: 6
      },
      {
        coinDenom: "stluna",
        coinMinimalDenom: "stuluna",
        coinDecimals: 6
      },
      {
        coinDenom: "stINJ",
        coinMinimalDenom: "stinj",
        coinDecimals: 18
      },
      {
        coinDenom: "stevmos",
        coinMinimalDenom: "staevmos",
        coinDecimals: 18
      },
      {
        coinDenom: "stDYDX",
        coinMinimalDenom: "stadydx",
        coinDecimals: 18
      },
      {
        coinDenom: "stTIA",
        coinMinimalDenom: "stutia",
        coinDecimals: 6
      },
      {
        coinDenom: "stDYM",
        coinMinimalDenom: "stadym",
        coinDecimals: 18
      },
      {
        coinDenom: "stumee",
        coinMinimalDenom: "stuumee",
        coinDecimals: 6
      },
      {
        coinDenom: "stcmdx",
        coinMinimalDenom: "stucmdx",
        coinDecimals: 6
      },
      {
        coinDenom: "stsomm",
        coinMinimalDenom: "stusomm",
        coinDecimals: 6
      },
      {
        coinDenom: "stSAGA",
        coinMinimalDenom: "stusaga",
        coinDecimals: 6
      },
      {
        coinDenom: "TIA",
        coinMinimalDenom: "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
        coinDecimals: 6
      },
      {
        coinDenom: "stISLM",
        coinMinimalDenom: "staISLM",
        coinDecimals: 18
      },
      {
        coinDenom: "stBAND",
        coinMinimalDenom: "stuband",
        coinDecimals: 6
      }
    ],
    rest: "https://stride-api.polkachu.com/",
    rpc: "https://stride-rpc.polkachu.com/",
    bech32Config: {
      bech32PrefixAccAddr: "stride",
      bech32PrefixAccPub: "stridepub",
      bech32PrefixValAddr: "stridevaloper",
      bech32PrefixValPub: "stridevaloperpub",
      bech32PrefixConsAddr: "stridevalcons",
      bech32PrefixConsPub: "stridevalconspub"
    },
    chainName: "stride",
    feeCurrencies: [
      {
        coinDenom: "strd",
        coinMinimalDenom: "ustrd",
        coinDecimals: 6,
        gasPriceStep: {
          low: 5e-3,
          average: 5e-3,
          high: 0.05
        }
      },
      {
        coinDenom: "statom",
        coinMinimalDenom: "stuatom",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-4,
          average: 2e-4,
          high: 5e-4
        }
      },
      {
        coinDenom: "stosmo",
        coinMinimalDenom: "stuosmo",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-3,
          average: 2e-3,
          high: 4e-3
        }
      },
      {
        coinDenom: "ststars",
        coinMinimalDenom: "stustars",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 1.1,
          high: 1.2
        }
      },
      {
        coinDenom: "stjuno",
        coinMinimalDenom: "stujuno",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.075,
          average: 0.1,
          high: 0.125
        }
      },
      {
        coinDenom: "stluna",
        coinMinimalDenom: "stuluna",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.0125,
          average: 0.015,
          high: 0.04
        }
      },
      {
        coinDenom: "stevmos",
        coinMinimalDenom: "staevmos",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e10,
          average: 25e9,
          high: 4e10
        }
      },
      {
        coinDenom: "stINJ",
        coinMinimalDenom: "stinj",
        coinDecimals: 18,
        gasPriceStep: {
          low: 5e8,
          average: 7e8,
          high: 9e8
        }
      },
      {
        coinDenom: "stcmdx",
        coinMinimalDenom: "stucmdx",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.02,
          average: 0.025,
          high: 0.04
        }
      },
      {
        coinDenom: "stumee",
        coinMinimalDenom: "stuumee",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.1,
          average: 0.12,
          high: 0.2
        }
      },
      {
        coinDenom: "stTIA",
        coinMinimalDenom: "stutia",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.02,
          high: 0.1
        }
      },
      {
        coinDenom: "stDYDX",
        coinMinimalDenom: "stadydx",
        coinDecimals: 18,
        gasPriceStep: {
          low: 15e9,
          average: 15e9,
          high: 2e10
        }
      },
      {
        coinDenom: "stDYM",
        coinMinimalDenom: "stadym",
        coinDecimals: 18,
        gasPriceStep: {
          low: 15e9,
          average: 15e9,
          high: 2e10
        }
      },
      {
        coinDenom: "stSAGA",
        coinMinimalDenom: "stusaga",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.015,
          high: 0.03
        }
      },
      {
        coinDenom: "TIA",
        coinMinimalDenom: "ibc/BF3B4F53F3694B66E13C23107C84B6485BD2B96296BB7EC680EA77BBA75B4801",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.02,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "strd",
      coinMinimalDenom: "ustrd",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "synternet-1",
    currencies: [
      {
        coinDenom: "SYNT",
        coinMinimalDenom: "usynt",
        coinDecimals: 6
      }
    ],
    rest: "https://api.synternet.com/",
    rpc: "https://rpc.synternet.com/",
    bech32Config: {
      bech32PrefixAccAddr: "synt",
      bech32PrefixAccPub: "syntpub",
      bech32PrefixValAddr: "syntvaloper",
      bech32PrefixValPub: "syntvaloperpub",
      bech32PrefixConsAddr: "syntvalcons",
      bech32PrefixConsPub: "syntvalconspub"
    },
    chainName: "synternet",
    feeCurrencies: [
      {
        coinDenom: "SYNT",
        coinMinimalDenom: "usynt",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "SYNT",
      coinMinimalDenom: "usynt",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "taketitan-12",
    currencies: [
      {
        coinDenom: "ttnc",
        coinMinimalDenom: "ttnc",
        coinDecimals: 0
      }
    ],
    rest: "https://lcdttnc.taketitan.com",
    rpc: "https://rcpttnc.taketitan.com",
    bech32Config: {
      bech32PrefixAccAddr: "taketitan",
      bech32PrefixAccPub: "taketitanpub",
      bech32PrefixValAddr: "taketitanvaloper",
      bech32PrefixValPub: "taketitanvaloperpub",
      bech32PrefixConsAddr: "taketitanvalcons",
      bech32PrefixConsPub: "taketitanvalconspub"
    },
    chainName: "taketitan",
    feeCurrencies: [
      {
        coinDenom: "ttnc",
        coinMinimalDenom: "ttnc",
        coinDecimals: 0,
        gasPriceStep: {
          low: 1e-6,
          average: 5e-6,
          high: 1e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ttnc",
      coinMinimalDenom: "ttnc",
      coinDecimals: 0
    },
    bip44: {
      coinType: 1179993421
    }
  },
  {
    chainId: "tenet_1559-1",
    currencies: [
      {
        coinDenom: "tenet",
        coinMinimalDenom: "atenet",
        coinDecimals: 18
      }
    ],
    rest: "https://app.rpc.tenet.org",
    rpc: "https://tendermint-1.rpc.tenet.org",
    bech32Config: {
      bech32PrefixAccAddr: "tenet",
      bech32PrefixAccPub: "tenetpub",
      bech32PrefixValAddr: "tenetvaloper",
      bech32PrefixValPub: "tenetvaloperpub",
      bech32PrefixConsAddr: "tenetvalcons",
      bech32PrefixConsPub: "tenetvalconspub"
    },
    chainName: "tenet",
    feeCurrencies: [
      {
        coinDenom: "tenet",
        coinMinimalDenom: "atenet",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e10,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tenet",
      coinMinimalDenom: "atenet",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "teritori-1",
    currencies: [
      {
        coinDenom: "tori",
        coinMinimalDenom: "utori",
        coinDecimals: 6
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/ED07A3391A112B175915CD8FAF43A2DA8E4790EDE12566649D0C2F97716B8518",
        coinDecimals: 6
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/A670D9568B3E399316EEDE40C1181B7AA4BD0695F0B37513CE9B95B977DFC12E",
        coinDecimals: 6
      },
      {
        coinDenom: "kuji",
        coinMinimalDenom: "ibc/1FECA3491D88F4AD24DE0948ED96718CA6D93F6730CEE7708E621B953594BB5E",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/FE98AAD68F02F03565E9FA39A5E627946699B2B07115889ED812D8BA639576A9",
        coinDecimals: 6
      },
      {
        coinDenom: "scrt",
        coinMinimalDenom: "ibc/F3F6BDEE1A79664B169D742651107BF4E03FA67E931452E27380B75F5917B7E9",
        coinDecimals: 6
      }
    ],
    rest: "https://teritori-api.polkachu.com",
    rpc: "https://teritori-rpc.polkachu.com",
    bech32Config: {
      bech32PrefixAccAddr: "tori",
      bech32PrefixAccPub: "toripub",
      bech32PrefixValAddr: "torivaloper",
      bech32PrefixValPub: "torivaloperpub",
      bech32PrefixConsAddr: "torivalcons",
      bech32PrefixConsPub: "torivalconspub"
    },
    chainName: "teritori",
    feeCurrencies: [
      {
        coinDenom: "tori",
        coinMinimalDenom: "utori",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "tori",
      coinMinimalDenom: "utori",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "morocco-1",
    currencies: [
      {
        coinDenom: "terp",
        coinMinimalDenom: "uterp",
        coinDecimals: 6
      },
      {
        coinDenom: "thiol",
        coinMinimalDenom: "uthiol",
        coinDecimals: 6
      }
    ],
    rest: "https://api-terp.zenchainlabs.io:443",
    rpc: "https://rpc-terp.zenchainlabs.io/",
    bech32Config: {
      bech32PrefixAccAddr: "terp",
      bech32PrefixAccPub: "terppub",
      bech32PrefixValAddr: "terpvaloper",
      bech32PrefixValPub: "terpvaloperpub",
      bech32PrefixConsAddr: "terpvalcons",
      bech32PrefixConsPub: "terpvalconspub"
    },
    chainName: "terpnetwork",
    feeCurrencies: [
      {
        coinDenom: "thiol",
        coinMinimalDenom: "uthiol",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "terp",
      coinMinimalDenom: "uterp",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "columbus-5",
    currencies: [
      {
        coinDenom: "luna",
        coinMinimalDenom: "uluna",
        coinDecimals: 6
      },
      {
        coinDenom: "ust",
        coinMinimalDenom: "uusd",
        coinDecimals: 6
      },
      {
        coinDenom: "krt",
        coinMinimalDenom: "ukrw",
        coinDecimals: 6
      },
      {
        coinDenom: "whale",
        coinMinimalDenom: "cw20:terra1php5m8a6qd68z02t3zpw4jv2pj4vgw4wz0t8mz",
        coinDecimals: 6
      },
      {
        coinDenom: "bluna",
        coinMinimalDenom: "cw20:terra1kc87mu460fwkqte29rquh4hc20m54fxwtsx7gp",
        coinDecimals: 6
      },
      {
        coinDenom: "beth",
        coinMinimalDenom: "cw20:terra1dzhzukyezv0etz22ud940z7adyv7xgcjkahuun",
        coinDecimals: 6
      },
      {
        coinDenom: "aust",
        coinMinimalDenom: "cw20:terra1hzh9vpxhsk8253se0vv5jj6etdvxu3nv8z07zu",
        coinDecimals: 6
      },
      {
        coinDenom: "anc",
        coinMinimalDenom: "cw20:terra14z56l0fp2lsf86zy3hty2z47ezkhnthtr9yq76",
        coinDecimals: 6
      },
      {
        coinDenom: "mir",
        coinMinimalDenom: "cw20:terra15gwkyepfc6xgca5t5zefzwy42uts8l2m4g40k6",
        coinDecimals: 6
      },
      {
        coinDenom: "maapl",
        coinMinimalDenom: "cw20:terra1vxtwu4ehgzz77mnfwrntyrmgl64qjs75mpwqaz",
        coinDecimals: 6
      },
      {
        coinDenom: "mabnb",
        coinMinimalDenom: "cw20:terra1g4x2pzmkc9z3mseewxf758rllg08z3797xly0n",
        coinDecimals: 6
      },
      {
        coinDenom: "mamc",
        coinMinimalDenom: "cw20:terra1qelfthdanju7wavc5tq0k5r0rhsyzyyrsn09qy",
        coinDecimals: 6
      },
      {
        coinDenom: "mamd",
        coinMinimalDenom: "cw20:terra18ej5nsuu867fkx4tuy2aglpvqjrkcrjjslap3z",
        coinDecimals: 6
      },
      {
        coinDenom: "mamzn",
        coinMinimalDenom: "cw20:terra165nd2qmrtszehcfrntlplzern7zl4ahtlhd5t2",
        coinDecimals: 6
      },
      {
        coinDenom: "markk",
        coinMinimalDenom: "cw20:terra1qqfx5jph0rsmkur2zgzyqnfucra45rtjae5vh6",
        coinDecimals: 6
      },
      {
        coinDenom: "mbaba",
        coinMinimalDenom: "cw20:terra1w7zgkcyt7y4zpct9dw8mw362ywvdlydnum2awa",
        coinDecimals: 6
      },
      {
        coinDenom: "mbtc",
        coinMinimalDenom: "cw20:terra1rhhvx8nzfrx5fufkuft06q5marfkucdqwq5sjw",
        coinDecimals: 6
      },
      {
        coinDenom: "mcoin",
        coinMinimalDenom: "cw20:terra18wayjpyq28gd970qzgjfmsjj7dmgdk039duhph",
        coinDecimals: 6
      },
      {
        coinDenom: "mdis",
        coinMinimalDenom: "cw20:terra149755r3y0rve30e209awkhn5cxgkn5c8ju9pm5",
        coinDecimals: 6
      },
      {
        coinDenom: "mdot",
        coinMinimalDenom: "cw20:terra19ya4jpvjvvtggepvmmj6ftmwly3p7way0tt08r",
        coinDecimals: 6
      },
      {
        coinDenom: "meth",
        coinMinimalDenom: "cw20:terra1dk3g53js3034x4v5c3vavhj2738une880yu6kx",
        coinDecimals: 6
      },
      {
        coinDenom: "mfb",
        coinMinimalDenom: "cw20:terra1mqsjugsugfprn3cvgxsrr8akkvdxv2pzc74us7",
        coinDecimals: 6
      },
      {
        coinDenom: "mglxy",
        coinMinimalDenom: "cw20:terra1l5lrxtwd98ylfy09fn866au6dp76gu8ywnudls",
        coinDecimals: 6
      },
      {
        coinDenom: "mgme",
        coinMinimalDenom: "cw20:terra1m6j6j9gw728n82k78s0j9kq8l5p6ne0xcc820p",
        coinDecimals: 6
      },
      {
        coinDenom: "mgoogl",
        coinMinimalDenom: "cw20:terra1h8arz2k547uvmpxctuwush3jzc8fun4s96qgwt",
        coinDecimals: 6
      },
      {
        coinDenom: "mgs",
        coinMinimalDenom: "cw20:terra137drsu8gce5thf6jr5mxlfghw36rpljt3zj73v",
        coinDecimals: 6
      },
      {
        coinDenom: "mhood",
        coinMinimalDenom: "cw20:terra18yqdfzfhnguerz9du5mnvxsh5kxlknqhcxzjfr",
        coinDecimals: 6
      },
      {
        coinDenom: "miau",
        coinMinimalDenom: "cw20:terra10h7ry7apm55h4ez502dqdv9gr53juu85nkd4aq",
        coinDecimals: 6
      },
      {
        coinDenom: "miau",
        coinMinimalDenom: "cw20:terra15hp9pr8y4qsvqvxf3m4xeptlk7l8h60634gqec",
        coinDecimals: 6
      },
      {
        coinDenom: "mjnj",
        coinMinimalDenom: "cw20:terra1ptdxmj3xmmljzx02nr4auwfuelmj0cnkh8egs2",
        coinDecimals: 6
      },
      {
        coinDenom: "mko",
        coinMinimalDenom: "cw20:terra1qsnj5gvq8rgs7yws8x5u02gwd5wvtu4tks0hjm",
        coinDecimals: 6
      },
      {
        coinDenom: "mmsft",
        coinMinimalDenom: "cw20:terra1227ppwxxj3jxz8cfgq00jgnxqcny7ryenvkwj6",
        coinDecimals: 6
      },
      {
        coinDenom: "mnflx",
        coinMinimalDenom: "cw20:terra1jsxngqasf2zynj5kyh0tgq9mj3zksa5gk35j4k",
        coinDecimals: 6
      },
      {
        coinDenom: "mnio",
        coinMinimalDenom: "cw20:terra1dj2cj02zak0nvwy3uj9r9dhhxhdwxnw6psse6p",
        coinDecimals: 6
      },
      {
        coinDenom: "mnke",
        coinMinimalDenom: "cw20:terra17ana8hvzea0q7w367dm0dw48sxwql39qekpt7g",
        coinDecimals: 6
      },
      {
        coinDenom: "mnvda",
        coinMinimalDenom: "cw20:terra1drsjzvzej4h4qlehcfwclxg4w5l3h5tuvd3jd8",
        coinDecimals: 6
      },
      {
        coinDenom: "mpypl",
        coinMinimalDenom: "cw20:terra1rh2907984nudl7vh56qjdtvv7947z4dujj92sx",
        coinDecimals: 6
      },
      {
        coinDenom: "mqqq",
        coinMinimalDenom: "cw20:terra1csk6tc7pdmpr782w527hwhez6gfv632tyf72cp",
        coinDecimals: 6
      },
      {
        coinDenom: "msbux",
        coinMinimalDenom: "cw20:terra1246zy658dfgtausf0c4a6ly8sc2e285q4kxqga",
        coinDecimals: 6
      },
      {
        coinDenom: "mslv",
        coinMinimalDenom: "cw20:terra1kscs6uhrqwy6rx5kuw5lwpuqvm3t6j2d6uf2lp",
        coinDecimals: 6
      },
      {
        coinDenom: "mspy",
        coinMinimalDenom: "cw20:terra1aa00lpfexyycedfg5k2p60l9djcmw0ue5l8fhc",
        coinDecimals: 6
      },
      {
        coinDenom: "msq",
        coinMinimalDenom: "cw20:terra1u43zu5amjlsgty5j64445fr9yglhm53m576ugh",
        coinDecimals: 6
      },
      {
        coinDenom: "mtsla",
        coinMinimalDenom: "cw20:terra14y5affaarufk3uscy2vr6pe6w6zqf2wpjzn5sh",
        coinDecimals: 6
      },
      {
        coinDenom: "mtwtr",
        coinMinimalDenom: "cw20:terra1cc3enj9qgchlrj34cnzhwuclc4vl2z3jl7tkqg",
        coinDecimals: 6
      },
      {
        coinDenom: "muso",
        coinMinimalDenom: "cw20:terra1lvmx8fsagy70tv0fhmfzdw9h6s3sy4prz38ugf",
        coinDecimals: 6
      },
      {
        coinDenom: "mvixy",
        coinMinimalDenom: "cw20:terra19cmt6vzvhnnnfsmccaaxzy2uaj06zjktu6yzjx",
        coinDecimals: 6
      },
      {
        coinDenom: "mvixy",
        coinMinimalDenom: "cw20:terra1zp3a6q6q4953cz376906g5qfmxnlg77hx3te45",
        coinDecimals: 6
      },
      {
        coinDenom: "lota",
        coinMinimalDenom: "cw20:terra1ez46kxtulsdv07538fh5ra5xj8l68mu8eg24vr",
        coinDecimals: 6
      },
      {
        coinDenom: "dph",
        coinMinimalDenom: "cw20:terra17jnhankdfl8vyzj6vejt7ag8uz0cjc9crkl2h7",
        coinDecimals: 6
      },
      {
        coinDenom: "mine",
        coinMinimalDenom: "cw20:terra1kcthelkax4j9x8d3ny6sdag0qmxxynl3qtcrpy",
        coinDecimals: 6
      },
      {
        coinDenom: "bpsidp-24m",
        coinMinimalDenom: "cw20:terra1zsaswh926ey8qa5x4vj93kzzlfnef0pstuca0y",
        coinDecimals: 6
      },
      {
        coinDenom: "spec",
        coinMinimalDenom: "cw20:terra1s5eczhe0h0jutf46re52x5z4r03c8hupacxmdr",
        coinDecimals: 6
      },
      {
        coinDenom: "loop",
        coinMinimalDenom: "cw20:terra1nef5jf6c7js9x6gkntlehgywvjlpytm7pcgkn4",
        coinDecimals: 6
      },
      {
        coinDenom: "loopr",
        coinMinimalDenom: "cw20:terra1jx4lmmke2srcvpjeereetc9hgegp4g5j0p9r2q",
        coinDecimals: 6
      },
      {
        coinDenom: "stt",
        coinMinimalDenom: "cw20:terra13xujxcrc9dqft4p9a8ls0w3j0xnzm6y2uvve8n",
        coinDecimals: 6
      },
      {
        coinDenom: "twd",
        coinMinimalDenom: "cw20:terra19djkaepjjswucys4npd5ltaxgsntl7jf0xz7w6",
        coinDecimals: 6
      },
      {
        coinDenom: "xtra",
        coinMinimalDenom: "cw20:terra1kvjscdgwuvwc6uzm4rqfjl6nlmuhj28tequlnc",
        coinDecimals: 6
      },
      {
        coinDenom: "miaw",
        coinMinimalDenom: "cw20:terra1vtr50tw0pgqpes34zqu60n554p9x4950wk8f63",
        coinDecimals: 6
      },
      {
        coinDenom: "psi",
        coinMinimalDenom: "cw20:terra12897djskt9rge8dtmm86w654g7kzckkd698608",
        coinDecimals: 6
      },
      {
        coinDenom: "nluna",
        coinMinimalDenom: "cw20:terra10f2mt82kjnkxqj2gepgwl637u2w4ue2z5nhz5j",
        coinDecimals: 6
      },
      {
        coinDenom: "neth",
        coinMinimalDenom: "cw20:terra178v546c407pdnx5rer3hu8s2c0fc924k74ymnn",
        coinDecimals: 6
      },
      {
        coinDenom: "cnluna",
        coinMinimalDenom: "cw20:terra1u553zk43jd4rwzc53qrdrq4jc2p8rextyq09dj",
        coinDecimals: 6
      },
      {
        coinDenom: "cneth",
        coinMinimalDenom: "cw20:terra1nagqpmyw55yjphea4rhntlfv87ugmeaj8ym756",
        coinDecimals: 6
      },
      {
        coinDenom: "navax",
        coinMinimalDenom: "cw20:terra13k62n0285wj8ug0ngcgpf7dgnkzqeu279tz636",
        coinDecimals: 6
      },
      {
        coinDenom: "natom",
        coinMinimalDenom: "cw20:terra1jtdc6zpf95tvh9peuaxwp3v0yqszcnwl8j5ade",
        coinDecimals: 6
      },
      {
        coinDenom: "vkr",
        coinMinimalDenom: "cw20:terra1dy9kmlm4anr92e42mrkjwzyvfqwz66un00rwr5",
        coinDecimals: 6
      },
      {
        coinDenom: "orion",
        coinMinimalDenom: "cw20:terra1mddcdx0ujx89f38gu7zspk2r2ffdl5enyz2u03",
        coinDecimals: 8
      },
      {
        coinDenom: "tland",
        coinMinimalDenom: "cw20:terra1r5506ckw5tfr3z52jwlek8vg9sn3yflrqrzfsc",
        coinDecimals: 6
      },
      {
        coinDenom: "vust",
        coinMinimalDenom: "cw20:terra1w0p5zre38ecdy3ez8efd5h9fvgum5s206xknrg",
        coinDecimals: 6
      },
      {
        coinDenom: "eth",
        coinMinimalDenom: "cw20:terra14tl83xcwqjy0ken9peu4pjjuu755lrry2uy25r",
        coinDecimals: 8
      },
      {
        coinDenom: "wbtc",
        coinMinimalDenom: "cw20:terra1aa7upykmmqqc63l924l5qfap8mrmx5rfdm0v55",
        coinDecimals: 8
      },
      {
        coinDenom: "sol",
        coinMinimalDenom: "cw20:terra190tqwgqx7s8qrknz6kckct7v607cu068gfujpk",
        coinDecimals: 8
      },
      {
        coinDenom: "maticet",
        coinMinimalDenom: "cw20:terra1dfasranqm4uyaz72r960umxy0w8t6zewqlnkuq",
        coinDecimals: 8
      },
      {
        coinDenom: "bnb",
        coinMinimalDenom: "cw20:terra1cetg5wruw2wsdjp7j46rj44xdel00z006e9yg8",
        coinDecimals: 8
      },
      {
        coinDenom: "cake",
        coinMinimalDenom: "cw20:terra1xvqlpjl2dxyel9qrp6qvtrg04xe3jh9cyxc6av",
        coinDecimals: 8
      },
      {
        coinDenom: "link",
        coinMinimalDenom: "cw20:terra12dfv3f0e6m22z6cnhfn3nxk2en3z3zeqy6ctym",
        coinDecimals: 8
      },
      {
        coinDenom: "sushi",
        coinMinimalDenom: "cw20:terra1csvuzlf92nyemu6tv25h0l79etpe8hz3h5vn4a",
        coinDecimals: 8
      },
      {
        coinDenom: "uni",
        coinMinimalDenom: "cw20:terra1wyxkuy5jq545fn7xfn3enpvs5zg9f9dghf6gxf",
        coinDecimals: 8
      },
      {
        coinDenom: "usdtet",
        coinMinimalDenom: "cw20:terra1ce06wkrdm4vl6t0hvc0g86rsy27pu8yadg3dva",
        coinDecimals: 6
      },
      {
        coinDenom: "usdcet",
        coinMinimalDenom: "cw20:terra1pepwcav40nvj3kh60qqgrk8k07ydmc00xyat06",
        coinDecimals: 6
      },
      {
        coinDenom: "kuji",
        coinMinimalDenom: "cw20:terra1xfsdgcemqwxp4hhnyk4rle6wr22sseq7j07dnn",
        coinDecimals: 6
      },
      {
        coinDenom: "skuji",
        coinMinimalDenom: "cw20:terra188w26t95tf4dz77raftme8p75rggatxjxfeknw",
        coinDecimals: 6
      },
      {
        coinDenom: "wsteth",
        coinMinimalDenom: "cw20:terra133chr09wu8sakfte5v7vd8qzq9vghtkv4tn0ur",
        coinDecimals: 8
      },
      {
        coinDenom: "wstsol",
        coinMinimalDenom: "cw20:terra1t9ul45l7m6jw6sxgvnp8e5hj8xzkjsg82g84ap",
        coinDecimals: 8
      },
      {
        coinDenom: "wsbsol",
        coinMinimalDenom: "cw20:terra1c3xd5s2j3ejx2d94tvcjfkrdeu6rmz48ghzznj",
        coinDecimals: 8
      },
      {
        coinDenom: "ldo",
        coinMinimalDenom: "cw20:terra1jxypgnfa07j6w92wazzyskhreq2ey2a5crgt6z",
        coinDecimals: 8
      },
      {
        coinDenom: "webeth",
        coinMinimalDenom: "cw20:terra1u5szg038ur9kzuular3cae8hq6q5rk5u27tuvz",
        coinDecimals: 8
      },
      {
        coinDenom: "stluna",
        coinMinimalDenom: "cw20:terra1yg3j2s986nyp5z7r2lvt0hx3r0lnd7kwvwwtsc",
        coinDecimals: 6
      },
      {
        coinDenom: "xdefi",
        coinMinimalDenom: "cw20:terra169edevav3pdrtjcx35j6pvzuv54aevewar4nlh",
        coinDecimals: 8
      },
      {
        coinDenom: "btl",
        coinMinimalDenom: "cw20:terra193c42lfwmlkasvcw22l9qqzc5q2dx208tkd7wl",
        coinDecimals: 6
      },
      {
        coinDenom: "lunax",
        coinMinimalDenom: "cw20:terra17y9qkl8dfkeg4py7n0g5407emqnemc3yqk5rup",
        coinDecimals: 6
      },
      {
        coinDenom: "luni",
        coinMinimalDenom: "cw20:terra1m3tdguf59xq3pa2twk5fjte5g6szj5y9x5npy7",
        coinDecimals: 6
      },
      {
        coinDenom: "ply",
        coinMinimalDenom: "cw20:terra13awdgcx40tz5uygkgm79dytez3x87rpg4uhnvu",
        coinDecimals: 6
      },
      {
        coinDenom: "tfloki",
        coinMinimalDenom: "cw20:terra1u2k0nkenw0p25ljsr4ksh7rxm65y466vkdewwj",
        coinDecimals: 6
      },
      {
        coinDenom: "tftic",
        coinMinimalDenom: "cw20:terra1a8k3jyv3wf6k3zngza5h6srrxcckdf7zv90p6u",
        coinDecimals: 6
      },
      {
        coinDenom: "tfticii",
        coinMinimalDenom: "cw20:terra1xt9fgu7965kgvunnjts9zkprd8986kcc444q86",
        coinDecimals: 6
      },
      {
        coinDenom: "tfticiii",
        coinMinimalDenom: "cw20:terra1vte2xv7dr8sfnrnwdf9arcyprqgr0hty5ads28",
        coinDecimals: 6
      },
      {
        coinDenom: "moon",
        coinMinimalDenom: "cw20:terra1hmxxq0y8h79f3228vs0czc4uz5jdgjt0appp26",
        coinDecimals: 6
      },
      {
        coinDenom: "astro",
        coinMinimalDenom: "cw20:terra1xj49zyqrwpv5k928jwfpfy2ha668nwdgkwlrg3",
        coinDecimals: 6
      },
      {
        coinDenom: "xastro.cw20",
        coinMinimalDenom: "cw20:terra14lpnyzc9z4g3ugr4lhm8s4nle0tq8vcltkhzh7",
        coinDecimals: 6
      },
      {
        coinDenom: "halo",
        coinMinimalDenom: "cw20:terra1w8kvd6cqpsthupsk4l0clwnmek4l3zr7c84kwq",
        coinDecimals: 6
      },
      {
        coinDenom: "pug",
        coinMinimalDenom: "cw20:terra1kdfsdm3c4reun9j3m4mk3nmyw4a4ns7mj24q3j",
        coinDecimals: 6
      },
      {
        coinDenom: "orne",
        coinMinimalDenom: "cw20:terra1hnezwjqlhzawcrfysczcxs6xqxu2jawn729kkf",
        coinDecimals: 6
      },
      {
        coinDenom: "tns",
        coinMinimalDenom: "cw20:terra14vz4v8adanzph278xyeggll4tfww7teh0xtw2y",
        coinDecimals: 6
      },
      {
        coinDenom: "xrune",
        coinMinimalDenom: "cw20:terra1td743l5k5cmfy7tqq202g7vkmdvq35q48u2jfm",
        coinDecimals: 6
      },
      {
        coinDenom: "alot",
        coinMinimalDenom: "cw20:terra1366wmr8t8rrkh6mag8fagqxntmf2qe4kyte784",
        coinDecimals: 6
      },
      {
        coinDenom: "sity",
        coinMinimalDenom: "cw20:terra1z09gnzufuflz6ckd9k0u456l9dnpgsynu0yyhe",
        coinDecimals: 6
      },
      {
        coinDenom: "glow",
        coinMinimalDenom: "cw20:terra13zx49nk8wjavedjzu8xkk95r3t0ta43c9ptul7",
        coinDecimals: 6
      },
      {
        coinDenom: "apollo",
        coinMinimalDenom: "cw20:terra100yeqvww74h4yaejj6h733thgcafdaukjtw397",
        coinDecimals: 6
      },
      {
        coinDenom: "abr",
        coinMinimalDenom: "cw20:terra1a7ye2splpfzyenu0yrdu8t83uzgusx2malkc7u",
        coinDecimals: 6
      },
      {
        coinDenom: "whgtps",
        coinMinimalDenom: "cw20:terra1y3d5qexmyac0fg53pfglh2pjk0664ymfvcq9mc",
        coinDecimals: 8
      },
      {
        coinDenom: "prism",
        coinMinimalDenom: "cw20:terra1dh9478k2qvqhqeajhn75a2a7dsnf74y5ukregw",
        coinDecimals: 6
      },
      {
        coinDenom: "sdollar",
        coinMinimalDenom: "cw20:terra1l0y8yg0s86x299nqw0p6fhh7ngex3r4phtjeuq",
        coinDecimals: 2
      },
      {
        coinDenom: "whsail",
        coinMinimalDenom: "cw20:terra1ku5e0dhutxhuxudsmsn5647wwcz6ndr3rsh90k",
        coinDecimals: 6
      },
      {
        coinDenom: "whgsail",
        coinMinimalDenom: "cw20:terra1rl0cpwgtwl4utnaynugevdje37fnmsea7rv4uu",
        coinDecimals: 8
      },
      {
        coinDenom: "xprism",
        coinMinimalDenom: "cw20:terra1042wzrwg2uk6jqxjm34ysqquyr9esdgm5qyswz",
        coinDecimals: 6
      },
      {
        coinDenom: "cde",
        coinMinimalDenom: "cw20:terra13fs83g5atgjwuh7c5ydzh6n7gecel6xyhhy2t5",
        coinDecimals: 9
      },
      {
        coinDenom: "ctx",
        coinMinimalDenom: "cw20:terra1rl20t79ffsrqfa29rke48tj05gj9jxumm92vg8",
        coinDecimals: 6
      },
      {
        coinDenom: "cluna",
        coinMinimalDenom: "cw20:terra13zaagrrrxj47qjwczsczujlvnnntde7fdt0mau",
        coinDecimals: 6
      },
      {
        coinDenom: "pluna",
        coinMinimalDenom: "cw20:terra1tlgelulz9pdkhls6uglfn5lmxarx7f2gxtdzh2",
        coinDecimals: 6
      },
      {
        coinDenom: "yluna",
        coinMinimalDenom: "cw20:terra17wkadg0tah554r35x6wvff0y5s7ve8npcjfuhz",
        coinDecimals: 6
      },
      {
        coinDenom: "atlo",
        coinMinimalDenom: "cw20:terra1cl7whtrqmz5ldr553q69qahck8xvk80fm33qjx",
        coinDecimals: 6
      },
      {
        coinDenom: "local",
        coinMinimalDenom: "cw20:terra1vchw83qt25j89zqwdpmdzj722sqxthnckqzxxp",
        coinDecimals: 6
      },
      {
        coinDenom: "luv",
        coinMinimalDenom: "cw20:terra15k5r9r8dl8r7xlr29pry8a9w7sghehcnv5mgp6",
        coinDecimals: 6
      },
      {
        coinDenom: "robo",
        coinMinimalDenom: "cw20:terra1f62tqesptvmhtzr8sudru00gsdtdz24srgm7wp",
        coinDecimals: 6
      },
      {
        coinDenom: "luart",
        coinMinimalDenom: "cw20:terra1vwz7t30q76s7xx6qgtxdqnu6vpr3ak3vw62ygk",
        coinDecimals: 6
      },
      {
        coinDenom: "mars",
        coinMinimalDenom: "cw20:terra12hgwnpupflfpuual532wgrxu2gjp0tcagzgx4n",
        coinDecimals: 6
      },
      {
        coinDenom: "xmars",
        coinMinimalDenom: "cw20:terra1a04v570f9cxp49mk06vjsm8axsswndpwwt67k4",
        coinDecimals: 6
      },
      {
        coinDenom: "dfiat",
        coinMinimalDenom: "cw20:terra1vpws4hmpmpsqwnz3gljn8zj42rv7rkpc5atgt4",
        coinDecimals: 8
      },
      {
        coinDenom: "ceres",
        coinMinimalDenom: "cw20:terra1hppnw4jppmrzzga4yvd8s87y3dwkhe27xwwl5d",
        coinDecimals: 6
      },
      {
        coinDenom: "wasavax",
        coinMinimalDenom: "cw20:terra1z3e2e4jpk4n0xzzwlkgcfvc95pc5ldq0xcny58",
        coinDecimals: 8
      },
      {
        coinDenom: "mint",
        coinMinimalDenom: "cw20:terra1zd6let0zg0xjn2sestagxv4ax24a4ml6j40qdr",
        coinDecimals: 6
      },
      {
        coinDenom: "sd",
        coinMinimalDenom: "cw20:terra1ustvnmngueq0p4jd7gfnutgvdc6ujpsjhsjd02",
        coinDecimals: 8
      },
      {
        coinDenom: "xsd",
        coinMinimalDenom: "cw20:terra1ln2z938phz0nc2wepxpzfkwp6ezn9yrz9zv9ep",
        coinDecimals: 8
      },
      {
        coinDenom: "paxg",
        coinMinimalDenom: "cw20:terra1uux6gwd6pzr0gfzrru5kne55cxex9d0700c72r",
        coinDecimals: 8
      },
      {
        coinDenom: "whdao",
        coinMinimalDenom: "cw20:terra1efjugpjc50d8sha7lr8s48cr7wmsthz94eevcl",
        coinDecimals: 8
      },
      {
        coinDenom: "link",
        coinMinimalDenom: "cw20:terra1su6g4t4vwx7y0uh3ksancyaurj4l6w9pfs40qt",
        coinDecimals: 18
      },
      {
        coinDenom: "sayve",
        coinMinimalDenom: "cw20:terra14v9wrjs55qsn9lkvylsqela3w2ytwxzkycqzcr",
        coinDecimals: 6
      },
      {
        coinDenom: "guides",
        coinMinimalDenom: "cw20:terra1z55rhw0ut70jxdmpvge98mvj0rkwcz74q77z0u",
        coinDecimals: 6
      },
      {
        coinDenom: "bro",
        coinMinimalDenom: "cw20:terra1mt2ytlrxhvd5c4d4fshxxs3zcus3fkdmuv4mk2",
        coinDecimals: 6
      },
      {
        coinDenom: "bbro",
        coinMinimalDenom: "cw20:terra1qryq5wreecx2wd3cdtzz94syr4z0a92l60asds",
        coinDecimals: 6
      },
      {
        coinDenom: "gtps",
        coinMinimalDenom: "cw20:terra15zvyhmv6gwddht7kt4q6w5nasn4tcpgzcdfmgr",
        coinDecimals: 18
      },
      {
        coinDenom: "gfi",
        coinMinimalDenom: "cw20:terra15pkdjxv2ewjzn9x665y26pfz2h6ymak4d4e8se",
        coinDecimals: 18
      },
      {
        coinDenom: "ulc",
        coinMinimalDenom: "cw20:terra1fyjsxx73jrufw8ufgtuswa773dvdkny92k70wa",
        coinDecimals: 18
      },
      {
        coinDenom: "sst",
        coinMinimalDenom: "cw20:terra1689ys6p6gfu0q6xrjqkzfn80sdyhurjqn0jfdl",
        coinDecimals: 6
      },
      {
        coinDenom: "atlas",
        coinMinimalDenom: "cw20:terra1rg8f993m9834afwazersesgx7jjxv4p87q9wvc",
        coinDecimals: 8
      },
      {
        coinDenom: "audio",
        coinMinimalDenom: "cw20:terra1nc6flp57m5hsr6y5y8aexzszy43ksr0drdr8rp",
        coinDecimals: 8
      },
      {
        coinDenom: "avax",
        coinMinimalDenom: "cw20:terra1hj8de24c3yqvcsv9r8chr03fzwsak3hgd8gv3m",
        coinDecimals: 8
      },
      {
        coinDenom: "bat",
        coinMinimalDenom: "cw20:terra1apxgj5agkkfdm2tprwvykug0qtahxvfmugnhx2",
        coinDecimals: 8
      },
      {
        coinDenom: "busdbs",
        coinMinimalDenom: "cw20:terra1skjr69exm6v8zellgjpaa2emhwutrk5a6dz7dd",
        coinDecimals: 8
      },
      {
        coinDenom: "dai",
        coinMinimalDenom: "cw20:terra1zmclyfepfmqvfqflu8r3lv6f75trmg05z7xq95",
        coinDecimals: 8
      },
      {
        coinDenom: "maticpo",
        coinMinimalDenom: "cw20:terra1dtqlfecglk47yplfrtwjzyagkgcqqngd5lgjp8",
        coinDecimals: 8
      },
      {
        coinDenom: "mimet",
        coinMinimalDenom: "cw20:terra15a9dr3a2a2lj5fclrw35xxg9yuxg0d908wpf2y",
        coinDecimals: 8
      },
      {
        coinDenom: "ray",
        coinMinimalDenom: "cw20:terra1ht5sepn28z999jx33sdduuxm9acthad507jg9q",
        coinDecimals: 6
      },
      {
        coinDenom: "sbr",
        coinMinimalDenom: "cw20:terra17h82zsq6q8x5tsgm5ugcx4gytw3axguvzt4pkc",
        coinDecimals: 6
      },
      {
        coinDenom: "shib",
        coinMinimalDenom: "cw20:terra1huku2lecfjhq9d00k5a8dh73gw7dwe6vvuf2dd",
        coinDecimals: 8
      },
      {
        coinDenom: "srmso",
        coinMinimalDenom: "cw20:terra1dkam9wd5yvaswv4yq3n2aqd4wm5j8n82qc0c7c",
        coinDecimals: 6
      },
      {
        coinDenom: "usdcav",
        coinMinimalDenom: "cw20:terra1pvel56a2hs93yd429pzv9zp5aptcjg5ulhkz7w",
        coinDecimals: 6
      },
      {
        coinDenom: "usdcbs",
        coinMinimalDenom: "cw20:terra1yljlrxvkar0c6ujpvf8g57m5rpcwl7r032zyvu",
        coinDecimals: 8
      },
      {
        coinDenom: "usdcpo",
        coinMinimalDenom: "cw20:terra1kkyyh7vganlpkj0gkc2rfmhy858ma4rtwywe3x",
        coinDecimals: 6
      },
      {
        coinDenom: "usdcso",
        coinMinimalDenom: "cw20:terra1e6mq63y64zcxz8xyu5van4tgkhemj3r86yvgu4",
        coinDecimals: 6
      },
      {
        coinDenom: "usdtav",
        coinMinimalDenom: "cw20:terra1eqvq3thjhye7anv6f6mhxpjhyvww8zjvqcdgjx",
        coinDecimals: 6
      },
      {
        coinDenom: "usdtbs",
        coinMinimalDenom: "cw20:terra1vlqeghv5mt5udh96kt5zxlh2wkh8q4kewkr0dd",
        coinDecimals: 8
      },
      {
        coinDenom: "usdtso",
        coinMinimalDenom: "cw20:terra1hd9n65snaluvf7en0p4hqzse9eqecejz2k8rl5",
        coinDecimals: 6
      },
      {
        coinDenom: "gohm",
        coinMinimalDenom: "cw20:terra1fpfn2kkr8mv390wx4dtpfk3vkjx9ch3thvykl3",
        coinDecimals: 8
      },
      {
        coinDenom: "msol",
        coinMinimalDenom: "cw20:terra1qvlpf2v0zmru3gtex40sqq02wxp39x3cjh359y",
        coinDecimals: 8
      },
      {
        coinDenom: "steth",
        coinMinimalDenom: "cw20:terra1w7ywr6waxtjuvn5svk5wqydqpjj0q9ps7qct4d",
        coinDecimals: 8
      },
      {
        coinDenom: "lct",
        coinMinimalDenom: "cw20:terra1srp2u95kxps35nvan88gn96nfqhukqya2d0ffc",
        coinDecimals: 6
      },
      {
        coinDenom: "batom",
        coinMinimalDenom: "cw20:terra18zqcnl83z98tf6lly37gghm7238k7lh79u4z9a",
        coinDecimals: 6
      },
      {
        coinDenom: "webatom",
        coinMinimalDenom: "cw20:terra128pe5jpempxu0nws5lw28se9zknhsr78626cpn",
        coinDecimals: 6
      },
      {
        coinDenom: "wcoin",
        coinMinimalDenom: "cw20:terra1laczhlpxlgmrwr9un9ds74qxd2fj4754nf82dn",
        coinDecimals: 6
      },
      {
        coinDenom: "lctfancard",
        coinMinimalDenom: "cw20:terra1thhm2u93m2stytzynhsxh5h3jrtg540x4punqy",
        coinDecimals: 6
      },
      {
        coinDenom: "kntc",
        coinMinimalDenom: "cw20:terra1yeyr6taynkwdl85ppaggr3zr8txhf66cny2ang",
        coinDecimals: 6
      },
      {
        coinDenom: "kust",
        coinMinimalDenom: "cw20:terra1g53pyke8jtmt4lwvk4yl0xaqc4u0qlsl8dz3ex",
        coinDecimals: 6
      },
      {
        coinDenom: "steak",
        coinMinimalDenom: "cw20:terra1rl4zyexjphwgx6v3ytyljkkc4mrje2pyznaclv",
        coinDecimals: 6
      },
      {
        coinDenom: "cst",
        coinMinimalDenom: "cw20:terra1jkkt5638cd5pur0u5jnr2juw0v6hz5d6z8xu8m",
        coinDecimals: 6
      },
      {
        coinDenom: "cstfancard",
        coinMinimalDenom: "cw20:terra1kz7qszu7p4dg9lts7m9m7lpuarsnan47jh3fam",
        coinDecimals: 6
      },
      {
        coinDenom: "nwld",
        coinMinimalDenom: "cw20:terra1amz5c45l34n7w8m5a3z7rd7u0k037x4nnsemwj",
        coinDecimals: 9
      },
      {
        coinDenom: "fury",
        coinMinimalDenom: "cw20:terra1cdc6nlsx0l6jmt3nnx7gxjggf902wge3n2z76k",
        coinDecimals: 6
      },
      {
        coinDenom: "rct",
        coinMinimalDenom: "cw20:terra17n223dxpkypc5c48la7aqjvverczg82ga3cr93",
        coinDecimals: 6
      },
      {
        coinDenom: "vitc",
        coinMinimalDenom: "cw20:terra14vw4sfqwe7jw8ppcc7u44vq7hy9qa2nlstnxmu",
        coinDecimals: 6
      },
      {
        coinDenom: "sb",
        coinMinimalDenom: "cw20:terra1948uvsah8aw40dhsa9mhl3htq8lraj0smlh77g",
        coinDecimals: 6
      },
      {
        coinDenom: "toad",
        coinMinimalDenom: "cw20:terra1rz964297kvt86rteajhtp4hsffhcum0ye8eljh",
        coinDecimals: 6
      },
      {
        coinDenom: "orionastro",
        coinMinimalDenom: "cw20:terra1yhlhrea3rgyx2xdnsswsfakn28qa8z7yp5gmhd",
        coinDecimals: 6
      },
      {
        coinDenom: "retro",
        coinMinimalDenom: "cw20:terra1j4hwavavmtsafa6zr0npalfz3tk9gf3p4787mp",
        coinDecimals: 6
      },
      {
        coinDenom: "tnd",
        coinMinimalDenom: "cw20:terra16wggm67a34msdxasg2vergm2pt289y7930wv7d",
        coinDecimals: 6
      },
      {
        coinDenom: "stnd",
        coinMinimalDenom: "cw20:terra1n9k2he20h5vpyn4mgv7pg4pzvw2n3wc4a86v3g",
        coinDecimals: 6
      },
      {
        coinDenom: "nwt",
        coinMinimalDenom: "cw20:terra1ezz5xply2v3xdyv32gy5tcd7zq4k235q4xtzwe",
        coinDecimals: 9
      },
      {
        coinDenom: "aut",
        coinMinimalDenom: "uaud",
        coinDecimals: 6
      },
      {
        coinDenom: "cat",
        coinMinimalDenom: "ucad",
        coinDecimals: 6
      },
      {
        coinDenom: "cht",
        coinMinimalDenom: "uchf",
        coinDecimals: 6
      },
      {
        coinDenom: "cnt",
        coinMinimalDenom: "ucny",
        coinDecimals: 6
      },
      {
        coinDenom: "dkt",
        coinMinimalDenom: "udkk",
        coinDecimals: 6
      },
      {
        coinDenom: "eut",
        coinMinimalDenom: "ueur",
        coinDecimals: 6
      },
      {
        coinDenom: "gbt",
        coinMinimalDenom: "ugbp",
        coinDecimals: 6
      },
      {
        coinDenom: "hkt",
        coinMinimalDenom: "uhkd",
        coinDecimals: 6
      },
      {
        coinDenom: "idt",
        coinMinimalDenom: "uidr",
        coinDecimals: 6
      },
      {
        coinDenom: "int",
        coinMinimalDenom: "uinr",
        coinDecimals: 6
      },
      {
        coinDenom: "jpt",
        coinMinimalDenom: "ujpy",
        coinDecimals: 6
      },
      {
        coinDenom: "mnt",
        coinMinimalDenom: "umnt",
        coinDecimals: 6
      },
      {
        coinDenom: "myt",
        coinMinimalDenom: "umyr",
        coinDecimals: 6
      },
      {
        coinDenom: "not",
        coinMinimalDenom: "unok",
        coinDecimals: 6
      },
      {
        coinDenom: "pht",
        coinMinimalDenom: "uphp",
        coinDecimals: 6
      },
      {
        coinDenom: "sdt",
        coinMinimalDenom: "usdr",
        coinDecimals: 6
      },
      {
        coinDenom: "set",
        coinMinimalDenom: "usek",
        coinDecimals: 6
      },
      {
        coinDenom: "sgt",
        coinMinimalDenom: "usgd",
        coinDecimals: 6
      },
      {
        coinDenom: "tht",
        coinMinimalDenom: "uthb",
        coinDecimals: 6
      },
      {
        coinDenom: "twt",
        coinMinimalDenom: "utwd",
        coinDecimals: 6
      },
      {
        coinDenom: "neb",
        coinMinimalDenom: "cw20:terra1mpq5zkkm39nmjrjg9raknpfrfmcfwv0nh0whvn",
        coinDecimals: 6
      },
      {
        coinDenom: "trit",
        coinMinimalDenom: "cw20:terra1g6fm3yu79gv0rc8067n2nnfpf0vks6n0wpzaf4u7w48tdrmj98zsy7uu00",
        coinDecimals: 6
      },
      {
        coinDenom: "juris",
        coinMinimalDenom: "cw20:terra1vhgq25vwuhdhn9xjll0rhl2s67jzw78a4g2t78y5kz89q9lsdskq2pxcj2",
        coinDecimals: 6
      },
      {
        coinDenom: "tadf",
        coinMinimalDenom: "cw20:terra19gzvkw5hft3ulp8n6ws3p9yradhc802axqal59lzxau6rqxktj9q0dwf9c",
        coinDecimals: 6
      },
      {
        coinDenom: "frog",
        coinMinimalDenom: "cw20:terra1wez9puj43v4s25vrex7cv3ut3w75w4h6j5e537sujyuxj0r5ne2qp9uwl9",
        coinDecimals: 6
      }
    ],
    rest: "https://terra-classic-lcd.publicnode.com",
    rpc: "https://terra-classic-rpc.publicnode.com:443",
    bech32Config: {
      bech32PrefixAccAddr: "terra",
      bech32PrefixAccPub: "terrapub",
      bech32PrefixValAddr: "terravaloper",
      bech32PrefixValPub: "terravaloperpub",
      bech32PrefixConsAddr: "terravalcons",
      bech32PrefixConsPub: "terravalconspub"
    },
    chainName: "terra",
    feeCurrencies: [
      {
        coinDenom: "luna",
        coinMinimalDenom: "uluna",
        coinDecimals: 6,
        gasPriceStep: {
          low: 28.325,
          average: 28.325,
          high: 50
        }
      },
      {
        coinDenom: "sdt",
        coinMinimalDenom: "usdr",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.52469,
          average: 0.52469,
          high: 0.52469
        }
      },
      {
        coinDenom: "ust",
        coinMinimalDenom: "uusd",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.75,
          average: 0.75,
          high: 0.75
        }
      },
      {
        coinDenom: "krt",
        coinMinimalDenom: "ukrw",
        coinDecimals: 6,
        gasPriceStep: {
          low: 850,
          average: 850,
          high: 850
        }
      },
      {
        coinDenom: "mnt",
        coinMinimalDenom: "umnt",
        coinDecimals: 6,
        gasPriceStep: {
          low: 2142.855,
          average: 2142.855,
          high: 2142.855
        }
      },
      {
        coinDenom: "eut",
        coinMinimalDenom: "ueur",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.625,
          average: 0.625,
          high: 0.625
        }
      },
      {
        coinDenom: "cnt",
        coinMinimalDenom: "ucny",
        coinDecimals: 6,
        gasPriceStep: {
          low: 4.9,
          average: 4.9,
          high: 4.9
        }
      },
      {
        coinDenom: "jpt",
        coinMinimalDenom: "ujpy",
        coinDecimals: 6,
        gasPriceStep: {
          low: 81.85,
          average: 81.85,
          high: 81.85
        }
      },
      {
        coinDenom: "gbt",
        coinMinimalDenom: "ugbp",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.55,
          average: 0.55,
          high: 0.55
        }
      },
      {
        coinDenom: "int",
        coinMinimalDenom: "uinr",
        coinDecimals: 6,
        gasPriceStep: {
          low: 54.4,
          average: 54.4,
          high: 54.4
        }
      },
      {
        coinDenom: "cat",
        coinMinimalDenom: "ucad",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.95,
          average: 0.95,
          high: 0.95
        }
      },
      {
        coinDenom: "cht",
        coinMinimalDenom: "uchf",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.7,
          average: 0.7,
          high: 0.7
        }
      },
      {
        coinDenom: "aut",
        coinMinimalDenom: "uaud",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.95,
          average: 0.95,
          high: 0.95
        }
      },
      {
        coinDenom: "sgt",
        coinMinimalDenom: "usgd",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 1,
          high: 1
        }
      },
      {
        coinDenom: "tht",
        coinMinimalDenom: "uthb",
        coinDecimals: 6,
        gasPriceStep: {
          low: 23.1,
          average: 23.1,
          high: 23.1
        }
      },
      {
        coinDenom: "set",
        coinMinimalDenom: "usek",
        coinDecimals: 6,
        gasPriceStep: {
          low: 6.25,
          average: 6.25,
          high: 6.25
        }
      },
      {
        coinDenom: "not",
        coinMinimalDenom: "unok",
        coinDecimals: 6,
        gasPriceStep: {
          low: 6.25,
          average: 6.25,
          high: 6.25
        }
      },
      {
        coinDenom: "dkt",
        coinMinimalDenom: "udkk",
        coinDecimals: 6,
        gasPriceStep: {
          low: 4.5,
          average: 4.5,
          high: 4.5
        }
      },
      {
        coinDenom: "idt",
        coinMinimalDenom: "uidr",
        coinDecimals: 6,
        gasPriceStep: {
          low: 10900,
          average: 10900,
          high: 10900
        }
      },
      {
        coinDenom: "pht",
        coinMinimalDenom: "uphp",
        coinDecimals: 6,
        gasPriceStep: {
          low: 38,
          average: 38,
          high: 38
        }
      },
      {
        coinDenom: "hkt",
        coinMinimalDenom: "uhkd",
        coinDecimals: 6,
        gasPriceStep: {
          low: 5.85,
          average: 5.85,
          high: 5.85
        }
      },
      {
        coinDenom: "myt",
        coinMinimalDenom: "umyr",
        coinDecimals: 6,
        gasPriceStep: {
          low: 3,
          average: 3,
          high: 3
        }
      },
      {
        coinDenom: "twt",
        coinMinimalDenom: "utwd",
        coinDecimals: 6,
        gasPriceStep: {
          low: 20,
          average: 20,
          high: 20
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "luna",
      coinMinimalDenom: "uluna",
      coinDecimals: 6
    },
    bip44: {
      coinType: 330
    }
  },
  {
    chainId: "phoenix-1",
    currencies: [
      {
        coinDenom: "luna",
        coinMinimalDenom: "uluna",
        coinDecimals: 6
      },
      {
        coinDenom: "astro.cw20",
        coinMinimalDenom: "cw20:terra1nsuqsk6kh58ulczatwev87ttq2z6r3pusulg9r24mfj2fvtzd4uq3exn26",
        coinDecimals: 6
      },
      {
        coinDenom: "astro",
        coinMinimalDenom: "ibc/8D8A7F7253615E5F76CB6252A1E1BD921D5EDB7BBAAF8913FB1C77FF125D9995",
        coinDecimals: 6
      },
      {
        coinDenom: "cw20:terra1spkm49wd9dqkranhrks4cupecl3rtgeqqljq3qrvrrts2ev2gw6sy5vz3k",
        coinMinimalDenom: "cw20:terra1spkm49wd9dqkranhrks4cupecl3rtgeqqljq3qrvrrts2ev2gw6sy5vz3k",
        coinDecimals: 0
      },
      {
        coinDenom: "Reis",
        coinMinimalDenom: "cw20:terra1sdglum2dt4f3fmq7jrt2phf2tegmnudc7qqqqujkpqcm9ujuxxkqakv5u8",
        coinDecimals: 6
      },
      {
        coinDenom: "Escudos",
        coinMinimalDenom: "cw20:terra1qj5hs3e86qn4vm9dvtgtlkdp550r0rayk9wpay44mfw3gn3tr8nq5jw3dg",
        coinDecimals: 6
      },
      {
        coinDenom: "Alem",
        coinMinimalDenom: "cw20:terra1cmf8ytutcwrjrv08zskj9phuh46a3w3nkjax7en4hxezsrdr58lqvzy05q",
        coinDecimals: 6
      },
      {
        coinDenom: "AMG",
        coinMinimalDenom: "cw20:terra1en42e2vsvtdsvrcqg5s5e5e4djejjaed6fxmvtpweg3tu33h6k5qkg9c40",
        coinDecimals: 6
      },
      {
        coinDenom: "ARK",
        coinMinimalDenom: "cw20:terra1ysd87nayjuelxj4wvp4wnp9as0mwszzkje6a9z6f3xx2903ghnsq4hm50y",
        coinDecimals: 6
      },
      {
        coinDenom: "DANU",
        coinMinimalDenom: "cw20:terra1vj68f2ntauaj5dfvy5z4tq4we3hsyg363k63js5sae2t7th9aacqan89sr",
        coinDecimals: 6
      },
      {
        coinDenom: "TRS",
        coinMinimalDenom: "cw20:terra1swzpenwh39f8aa7qht34r05f8ew6k2vehvqt2aw4fjy0fgghhheqs9l6h7",
        coinDecimals: 6
      },
      {
        coinDenom: "PLASMA",
        coinMinimalDenom: "cw20:terra1mqs6mdx0ak7qvjzs6efhg65g4j5pzwpdkcgdsv5tpekln3qhggrq3qzvdp",
        coinDecimals: 6
      },
      {
        coinDenom: "DMT",
        coinMinimalDenom: "cw20:terra1xfkkgwxychgrnq0vcp82u32mecrzj8s64s03cxtmf46k6j2n2wssc7rzjf",
        coinDecimals: 6
      },
      {
        coinDenom: "ampluna",
        coinMinimalDenom: "cw20:terra1ecgazyd0waaj3g7l9cmy5gulhxkps2gmxu9ghducvuypjq68mq2s5lvsct",
        coinDecimals: 6
      },
      {
        coinDenom: "roar",
        coinMinimalDenom: "cw20:terra1lxx40s29qvkrcj8fsa3yzyehy7w50umdvvnls2r830rys6lu2zns63eelv",
        coinDecimals: 6
      },
      {
        coinDenom: "gem",
        coinMinimalDenom: "cw20:terra1ynvsz80w9xmhdxucv96gkwpxlwvjgsq75xh2f3pf825c4wfmkfxskq6pqv",
        coinDecimals: 6
      },
      {
        coinDenom: "cub",
        coinMinimalDenom: "cw20:terra1lalvk0r6nhruel7fvzdppk3tup3mh5j4d4eadrqzfhle4zrf52as58hh9t",
        coinDecimals: 6
      },
      {
        coinDenom: "blue",
        coinMinimalDenom: "cw20:terra1gwrz9xzhqsygyr5asrgyq3pu0ewpn00mv2zenu86yvx2nlwpe8lqppv584",
        coinDecimals: 6
      },
      {
        coinDenom: "xxx",
        coinMinimalDenom: "cw20:terra10se906awphtccf4vd83m0ulpmpt9v4msuakmpy0pwvmtxmup3kdq25rayn",
        coinDecimals: 10
      },
      {
        coinDenom: "GUGU",
        coinMinimalDenom: "cw20:terra19nu4q2y0xe3vza6ve5ymup33uzm049pnrqq5ddeuulmrg279t57qstcces",
        coinDecimals: 6
      },
      {
        coinDenom: "bLUNA",
        coinMinimalDenom: "cw20:terra17aj4ty4sz4yhgm08na8drc0v03v2jwr3waxcqrwhajj729zhl7zqnpc0ml",
        coinDecimals: 6
      },
      {
        coinDenom: "sayve",
        coinMinimalDenom: "cw20:terra1xp9hrhthzddnl7j5du83gqqr4wmdjm5t0guzg9jp6jwrtpukwfjsjgy4f3",
        coinDecimals: 6
      },
      {
        coinDenom: "ampWHALEt",
        coinMinimalDenom: "factory/terra1j35ta0llaxcf55auv2cjqau5a7aee6g8fz7md7my7005cvh23jfsaw83dy/ampWHALEt",
        coinDecimals: 6
      },
      {
        coinDenom: "boneWHALEt",
        coinMinimalDenom: "factory/terra10j3zrymfrkta2pxe0gklc79gu06tqyuy8c3kh6tqdsrrprsjqkrqzfl4df/boneWHALEt",
        coinDecimals: 6
      },
      {
        coinDenom: "ampROAR",
        coinMinimalDenom: "factory/terra1vklefn7n6cchn0u962w3gaszr4vf52wjvd4y95t2sydwpmpdtszsqvk9wy/ampROAR",
        coinDecimals: 6
      },
      {
        coinDenom: "nico",
        coinMinimalDenom: "cw20:terra1e0efrrrj8d55pflme3dmtyuj7klzcef5cfmz6r2jyqz77kk2jz3qa6drg3",
        coinDecimals: 18
      },
      {
        coinDenom: "seas",
        coinMinimalDenom: "cw20:terra1rc6ssp5rym7a0hg29xpj4cc9e67tl56kg5jyzgl9qrhfxxc2ugvsnrkala",
        coinDecimals: 6
      },
      {
        coinDenom: "bitz",
        coinMinimalDenom: "cw20:terra18vp5s0r7keezm35hdxsgw8zgfnyn8wejdkk893ag2kqncgpqxhjqwjpc0v",
        coinDecimals: 6
      },
      {
        coinDenom: "factory/neutron1ug740qrkquxzrk2hh29qrlx3sktkfml3je7juusc2te7xmvsscns0n2wry/wstETH",
        coinMinimalDenom: "ibc/A356EC90DC3AE43D485514DA7260EDC7ABB5CFAA0654CE2524C739392975AD3C",
        coinDecimals: 18
      },
      {
        coinDenom: "seul",
        coinMinimalDenom: "cw20:terra13s5pxw5j2p4ssvzwvxd8l7h30vke8vjgtng75vqgv6p9vddfk3hskfka0l",
        coinDecimals: 6
      },
      {
        coinDenom: "xseul",
        coinMinimalDenom: "cw20:terra1q328gl40az3cf9x67cgudn8e8w2az9vsmhtkwsgdu7a43rhy5caqc82yr5",
        coinDecimals: 6
      },
      {
        coinDenom: "ito",
        coinMinimalDenom: "cw20:terra1c77xqv746m7ghxayrge79dxr4kcezev8g6cnrfled4f3n4ufj0vs5gz28s",
        coinDecimals: 6
      },
      {
        coinDenom: "ARMANI",
        coinMinimalDenom: "cw20:terra1aa7stl3fytvave9xtcexgv0kne4k7ks068dcljkrfj37hy8q270sjadav8",
        coinDecimals: 6
      },
      {
        coinDenom: "DROGO",
        coinMinimalDenom: "cw20:terra1cl273523kmr2uwjhhznq54je69mted2u3ljffm8kp2ap4z3drdksftwqun",
        coinDecimals: 6
      },
      {
        coinDenom: "ADO",
        coinMinimalDenom: "cw20:terra1w8xk6rtu40st6lvl3yv7ynw5urm2n686u9cchvrzltmnktzwdesqcwy0nu",
        coinDecimals: 6
      },
      {
        coinDenom: "WOSMO",
        coinMinimalDenom: "ibc/E18C0D303957867A164DE2863D1C3F83135936E6F17CADF4D241FBC12B0F23B2",
        coinDecimals: 6
      },
      {
        coinDenom: "DNA",
        coinMinimalDenom: "cw20:terra1epka8wevu90rxlvt6g5x9veevd800a760vtuftc5kqdfmrh47qds9f0m8h",
        coinDecimals: 6
      },
      {
        coinDenom: "bitmos",
        coinMinimalDenom: "cw20:terra1sxe8u2hjczlekwfkcq0rs28egt38pg3wqzfx4zcrese4fnvzzupsk9gjkq",
        coinDecimals: 6
      },
      {
        coinDenom: "lads",
        coinMinimalDenom: "cw20:terra1eh8eq60cjy997w5dc3a6exfzanlaurupav8klx7m9u9ddfgh25mqjwl5vj",
        coinDecimals: 6
      },
      {
        coinDenom: "rstk",
        coinMinimalDenom: "ibc/F709DF4969CD26174C1A53AA95F3D98BE643C1A52C9981487766F96A1811F6A4",
        coinDecimals: 6
      },
      {
        coinDenom: "CLON",
        coinMinimalDenom: "cw20:terra164ssz60yvsxey0ku9mtcaegdeyxwzuwwqyrp238nvflwqve0pvxsra7fa2",
        coinDecimals: 6
      },
      {
        coinDenom: "MOAR",
        coinMinimalDenom: "factory/terra1dndhtdr2v7ca8rrn67chlqw3cl3xhm3m2uxls62vghcg3fsh5tpss5xmcu/MOAR",
        coinDecimals: 6
      },
      {
        coinDenom: "usdt",
        coinMinimalDenom: "ibc/9B19062D46CAB50361CE9B0A3E6D0A7A53AC9E7CB361F32A73CC733144A9A9E5",
        coinDecimals: 6
      },
      {
        coinDenom: "atom-luna-lp",
        coinMinimalDenom: "factory/terra1djk2zl83dspt696ex5crhfacu8vm6934576t4zdd2592fzyahr2qma6guq/ULUN-IBC/-LP",
        coinDecimals: 6
      },
      {
        coinDenom: "luna-usdc-lp",
        coinMinimalDenom: "factory/terra12jxfw2vg4cu6mxlgf39dp5ccxtuwm468w8eh9cnh2qsxc9t0sffs7ekhft/ULUN-IBC/-LP",
        coinDecimals: 6
      },
      {
        coinDenom: "luna-usdt-lp",
        coinMinimalDenom: "factory/terra1w9spejtuac5dt0gympq576uhwde39exhh7hdxwl99rjvaphfukkq6y4cv7/ULUN-IBC/-LP",
        coinDecimals: 6
      },
      {
        coinDenom: "ashLUNA",
        coinMinimalDenom: "factory/terra1f5cfm48gcezl3cx25l64ngc4yktnmx7rcpj3kggu6v273742sqqs5yn5ks/luna.ash",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/2C962DAB9F57FE0921435426AE75196009FAA1981BF86991203C8411F8980FDB",
        coinDecimals: 6
      },
      {
        coinDenom: "COSMO",
        coinMinimalDenom: "ibc/4925733868E7999F5822C961ADE9470A7FC5FA4A560BAE1DE102783C3F64C201",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd-terra.wildsage.io",
    rpc: "https://rpc.lavenderfive.com:443/terra2",
    bech32Config: {
      bech32PrefixAccAddr: "terra",
      bech32PrefixAccPub: "terrapub",
      bech32PrefixValAddr: "terravaloper",
      bech32PrefixValPub: "terravaloperpub",
      bech32PrefixConsAddr: "terravalcons",
      bech32PrefixConsPub: "terravalconspub"
    },
    chainName: "terra2",
    feeCurrencies: [
      {
        coinDenom: "luna",
        coinMinimalDenom: "uluna",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.015,
          average: 0.015,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "luna",
      coinMinimalDenom: "uluna",
      coinDecimals: 6
    },
    bip44: {
      coinType: 330
    }
  },
  {
    chainId: "tgrade-mainnet-1",
    currencies: [
      {
        coinDenom: "tgd",
        coinMinimalDenom: "utgd",
        coinDecimals: 6
      }
    ],
    rest: "https://api.mainnet-1.tgrade.confio.run",
    rpc: "https://rpc.mainnet-1.tgrade.confio.run",
    bech32Config: {
      bech32PrefixAccAddr: "tgrade",
      bech32PrefixAccPub: "tgradepub",
      bech32PrefixValAddr: "tgradevaloper",
      bech32PrefixValPub: "tgradevaloperpub",
      bech32PrefixConsAddr: "tgradevalcons",
      bech32PrefixConsPub: "tgradevalconspub"
    },
    chainName: "tgrade",
    feeCurrencies: [
      {
        coinDenom: "tgd",
        coinMinimalDenom: "utgd",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.05,
          average: 0.075,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tgd",
      coinMinimalDenom: "utgd",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "titan_18888-1",
    currencies: [
      {
        coinDenom: "tkx",
        coinMinimalDenom: "atkx",
        coinDecimals: 18
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5",
        coinDecimals: 6
      }
    ],
    rest: "https://titan-lcd.titanlab.io:443",
    rpc: "https://titan-rpc.titanlab.io:443",
    bech32Config: {
      bech32PrefixAccAddr: "titan",
      bech32PrefixAccPub: "titanpub",
      bech32PrefixValAddr: "titanvaloper",
      bech32PrefixValPub: "titanvaloperpub",
      bech32PrefixConsAddr: "titanvalcons",
      bech32PrefixConsPub: "titanvalconspub"
    },
    chainName: "titan",
    feeCurrencies: [
      {
        coinDenom: "tkx",
        coinMinimalDenom: "atkx",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e11,
          average: 11e10,
          high: 2e11
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tkx",
      coinMinimalDenom: "atkx",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "umee-1",
    currencies: [
      {
        coinDenom: "umee",
        coinMinimalDenom: "uumee",
        coinDecimals: 6
      }
    ],
    rest: "https://api-umee-ia.cosmosia.notional.ventures/",
    rpc: "https://umee-rpc.polkachu.com",
    bech32Config: {
      bech32PrefixAccAddr: "umee",
      bech32PrefixAccPub: "umeepub",
      bech32PrefixValAddr: "umeevaloper",
      bech32PrefixValPub: "umeevaloperpub",
      bech32PrefixConsAddr: "umeevalcons",
      bech32PrefixConsPub: "umeevalconspub"
    },
    chainName: "umee",
    feeCurrencies: [
      {
        coinDenom: "umee",
        coinMinimalDenom: "uumee",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.1,
          average: 0.12,
          high: 0.2
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "umee",
      coinMinimalDenom: "uumee",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "FUND-MainNet-2",
    currencies: [
      {
        coinDenom: "FUND",
        coinMinimalDenom: "nund",
        coinDecimals: 9
      }
    ],
    rest: "https://rest.unification.io",
    rpc: "https://rpc.unification.io:443",
    bech32Config: {
      bech32PrefixAccAddr: "und",
      bech32PrefixAccPub: "undpub",
      bech32PrefixValAddr: "undvaloper",
      bech32PrefixValPub: "undvaloperpub",
      bech32PrefixConsAddr: "undvalcons",
      bech32PrefixConsPub: "undvalconspub"
    },
    chainName: "unification",
    feeCurrencies: [
      {
        coinDenom: "FUND",
        coinMinimalDenom: "nund",
        coinDecimals: 9,
        gasPriceStep: {
          low: 100,
          average: 200,
          high: 300
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "FUND",
      coinMinimalDenom: "nund",
      coinDecimals: 9
    },
    bip44: {
      coinType: 5555
    }
  },
  {
    chainId: "ununifi-beta-v1",
    currencies: [
      {
        coinDenom: "guu",
        coinMinimalDenom: "uguu",
        coinDecimals: 6
      }
    ],
    rest: "https://a.lcd.ununifi.cauchye.net:1318",
    rpc: "http://a.lcd.ununifi.cauchye.net:26657",
    bech32Config: {
      bech32PrefixAccAddr: "ununifi",
      bech32PrefixAccPub: "ununifipub",
      bech32PrefixValAddr: "ununifivaloper",
      bech32PrefixValPub: "ununifivaloperpub",
      bech32PrefixConsAddr: "ununifivalcons",
      bech32PrefixConsPub: "ununifivalconspub"
    },
    chainName: "ununifi",
    feeCurrencies: [
      {
        coinDenom: "guu",
        coinMinimalDenom: "uguu",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "guu",
      coinMinimalDenom: "uguu",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "uptick_117-1",
    currencies: [
      {
        coinDenom: "uptick",
        coinMinimalDenom: "auptick",
        coinDecimals: 18
      }
    ],
    rest: "https://uptick-rest.brocha.in:443",
    rpc: "https://uptick-rpc.brocha.in:443",
    bech32Config: {
      bech32PrefixAccAddr: "uptick",
      bech32PrefixAccPub: "uptickpub",
      bech32PrefixValAddr: "uptickvaloper",
      bech32PrefixValPub: "uptickvaloperpub",
      bech32PrefixConsAddr: "uptickvalcons",
      bech32PrefixConsPub: "uptickvalconspub"
    },
    chainName: "uptick",
    feeCurrencies: [
      {
        coinDenom: "uptick",
        coinMinimalDenom: "auptick",
        coinDecimals: 18,
        gasPriceStep: {
          low: 13e9,
          average: 16e9,
          high: 2e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "uptick",
      coinMinimalDenom: "auptick",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "vidulum-1",
    currencies: [
      {
        coinDenom: "vdl",
        coinMinimalDenom: "uvdl",
        coinDecimals: 6
      }
    ],
    rest: "https://mainnet-lcd.vidulum.app",
    rpc: "https://mainnet-rpc.vidulum.app/",
    bech32Config: {
      bech32PrefixAccAddr: "vdl",
      bech32PrefixAccPub: "vdlpub",
      bech32PrefixValAddr: "vdlvaloper",
      bech32PrefixValPub: "vdlvaloperpub",
      bech32PrefixConsAddr: "vdlvalcons",
      bech32PrefixConsPub: "vdlvalconspub"
    },
    chainName: "vidulum",
    feeCurrencies: [
      {
        coinDenom: "vdl",
        coinMinimalDenom: "uvdl",
        coinDecimals: 6,
        gasPriceStep: {
          low: 2e-3,
          average: 5e-3,
          high: 7e-3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "vdl",
      coinMinimalDenom: "uvdl",
      coinDecimals: 6
    },
    bip44: {
      coinType: 370
    }
  },
  {
    chainId: "dimension_37-1",
    currencies: [
      {
        coinDenom: "xpla",
        coinMinimalDenom: "axpla",
        coinDecimals: 18
      }
    ],
    rest: "https://dimension-lcd.xpla.io",
    rpc: "https://dimension-rpc.xpla.dev",
    bech32Config: {
      bech32PrefixAccAddr: "xpla",
      bech32PrefixAccPub: "xplapub",
      bech32PrefixValAddr: "xplavaloper",
      bech32PrefixValPub: "xplavaloperpub",
      bech32PrefixConsAddr: "xplavalcons",
      bech32PrefixConsPub: "xplavalconspub"
    },
    chainName: "xpla",
    feeCurrencies: [
      {
        coinDenom: "xpla",
        coinMinimalDenom: "axpla",
        coinDecimals: 18,
        gasPriceStep: {
          low: 85e10,
          average: 11475e8,
          high: 14875e8
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "xpla",
      coinMinimalDenom: "axpla",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "zetachain_7000-1",
    currencies: [
      {
        coinDenom: "zeta",
        coinMinimalDenom: "azeta",
        coinDecimals: 18
      }
    ],
    rest: "https://zetachain.blockpi.network/lcd/v1/public",
    rpc: "https://zetachain.blockpi.network/rpc/v1/public",
    bech32Config: {
      bech32PrefixAccAddr: "zeta",
      bech32PrefixAccPub: "zetapub",
      bech32PrefixValAddr: "zetavaloper",
      bech32PrefixValPub: "zetavaloperpub",
      bech32PrefixConsAddr: "zetavalcons",
      bech32PrefixConsPub: "zetavalconspub"
    },
    chainName: "zetachain",
    feeCurrencies: [
      {
        coinDenom: "zeta",
        coinMinimalDenom: "azeta",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e10,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "zeta",
      coinMinimalDenom: "azeta",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  }
], Iu = [
  {
    chainId: "junction",
    currencies: [
      {
        coinDenom: "AMF",
        coinMinimalDenom: "amf",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.nodejumper.io/airchainstestnet",
    rpc: "https://junction-rpc.validatorvn.com/",
    bech32Config: {
      bech32PrefixAccAddr: "air",
      bech32PrefixAccPub: "airpub",
      bech32PrefixValAddr: "airvaloper",
      bech32PrefixValPub: "airvaloperpub",
      bech32PrefixConsAddr: "airvalcons",
      bech32PrefixConsPub: "airvalconspub"
    },
    chainName: "airchainstestnet",
    feeCurrencies: [
      {
        coinDenom: "AMF",
        coinMinimalDenom: "amf",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-5,
          average: 5e-3,
          high: 0.01
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "AMF",
      coinMinimalDenom: "amf",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "sandbox-01",
    currencies: [
      {
        coinDenom: "akt",
        coinMinimalDenom: "uakt",
        coinDecimals: 6
      }
    ],
    rest: "https://api.sandbox-01.aksh.pw:443",
    rpc: "https://rpc.sandbox-01.aksh.pw:443",
    bech32Config: {
      bech32PrefixAccAddr: "akash",
      bech32PrefixAccPub: "akashpub",
      bech32PrefixValAddr: "akashvaloper",
      bech32PrefixValPub: "akashvaloperpub",
      bech32PrefixConsAddr: "akashvalcons",
      bech32PrefixConsPub: "akashvalconspub"
    },
    chainName: "akashtestnet",
    feeCurrencies: [
      {
        coinDenom: "akt",
        coinMinimalDenom: "uakt",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "akt",
      coinMinimalDenom: "uakt",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "constantine-3",
    currencies: [
      {
        coinDenom: "const",
        coinMinimalDenom: "aconst",
        coinDecimals: 18
      },
      {
        coinDenom: "wARCH",
        coinMinimalDenom: "cw20:archway1dz6h2smr432gvzruklk3lps7ak2ca7cngdge4vym93wehkkypwpqgwr2q2",
        coinDecimals: 18
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/34F8D3402273FFA5278AE5757D81CE151ACFD4B19C494C0EE372A7229714824F",
        coinDecimals: 6
      },
      {
        coinDenom: "wUSDC",
        coinMinimalDenom: "cw20:archway172vetupqnkgdc7dp3gwqpvk5ljmgzyj2gs4ag2fdmp0s2rucxxsqh0nqeu",
        coinDecimals: 6
      }
    ],
    rest: "https://api.constantine.archway.io",
    rpc: "https://rpc.constantine.archway.io",
    bech32Config: {
      bech32PrefixAccAddr: "archway",
      bech32PrefixAccPub: "archwaypub",
      bech32PrefixValAddr: "archwayvaloper",
      bech32PrefixValPub: "archwayvaloperpub",
      bech32PrefixConsAddr: "archwayvalcons",
      bech32PrefixConsPub: "archwayvalconspub"
    },
    chainName: "archwaytestnet",
    feeCurrencies: [
      {
        coinDenom: "const",
        coinMinimalDenom: "aconst",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e12,
          average: 15e11,
          high: 2e12
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "const",
      coinMinimalDenom: "aconst",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "arkeo",
    currencies: [
      {
        coinDenom: "arkeo",
        coinMinimalDenom: "uarkeo",
        coinDecimals: 6
      }
    ],
    rest: "https://arkeonetwork-testnet.nodejumper.io:1317",
    rpc: "https://arkeonetwork-testnet.nodejumper.io:26657",
    bech32Config: {
      bech32PrefixAccAddr: "tarkeo",
      bech32PrefixAccPub: "tarkeopub",
      bech32PrefixValAddr: "tarkeovaloper",
      bech32PrefixValPub: "tarkeovaloperpub",
      bech32PrefixConsAddr: "tarkeovalcons",
      bech32PrefixConsPub: "tarkeovalconspub"
    },
    chainName: "arkeonetworktestnet",
    feeCurrencies: [
      {
        coinDenom: "arkeo",
        coinMinimalDenom: "uarkeo",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "arkeo",
      coinMinimalDenom: "uarkeo",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "artela_11820-1",
    currencies: [
      {
        coinDenom: "art",
        coinMinimalDenom: "uart",
        coinDecimals: 18
      }
    ],
    rest: "https://testnet-rpc1.artela.network",
    rpc: "https://testnet-rpc1.artela.network",
    bech32Config: {
      bech32PrefixAccAddr: "art",
      bech32PrefixAccPub: "artpub",
      bech32PrefixValAddr: "artvaloper",
      bech32PrefixValPub: "artvaloperpub",
      bech32PrefixConsAddr: "artvalcons",
      bech32PrefixConsPub: "artvalconspub"
    },
    chainName: "artelatestnet",
    feeCurrencies: [
      {
        coinDenom: "art",
        coinMinimalDenom: "uart",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e10,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "art",
      coinMinimalDenom: "uart",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "aura_6321-3",
    currencies: [
      {
        coinDenom: "eaura",
        coinMinimalDenom: "ueaura",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.euphoria.aura.network/",
    rpc: "https://rpc.euphoria.aura.network/",
    bech32Config: {
      bech32PrefixAccAddr: "aura",
      bech32PrefixAccPub: "aurapub",
      bech32PrefixValAddr: "auravaloper",
      bech32PrefixValPub: "auravaloperpub",
      bech32PrefixConsAddr: "auravalcons",
      bech32PrefixConsPub: "auravalconspub"
    },
    chainName: "auratestnet",
    feeCurrencies: [
      {
        coinDenom: "eaura",
        coinMinimalDenom: "ueaura",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-3,
          average: 2e-3,
          high: 25e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "eaura",
      coinMinimalDenom: "ueaura",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "axelar-testnet-lisbon-3",
    currencies: [
      {
        coinDenom: "axl",
        coinMinimalDenom: "uaxl",
        coinDecimals: 6
      },
      {
        coinDenom: "ausdc",
        coinMinimalDenom: "uausdc",
        coinDecimals: 6
      },
      {
        coinDenom: "weth",
        coinMinimalDenom: "eth-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "wglmr",
        coinMinimalDenom: "wglmr-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "wmatic",
        coinMinimalDenom: "wmatic-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "wbnb",
        coinMinimalDenom: "wbnb-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "avax",
        coinMinimalDenom: "wavax-wei",
        coinDecimals: 18
      },
      {
        coinDenom: "ftm",
        coinMinimalDenom: "wftm-wei",
        coinDecimals: 18
      }
    ],
    rest: "https://lcd-axelar-testnet.imperator.co:443",
    rpc: "https://rpc-axelar-testnet.imperator.co:443",
    bech32Config: {
      bech32PrefixAccAddr: "axelar",
      bech32PrefixAccPub: "axelarpub",
      bech32PrefixValAddr: "axelarvaloper",
      bech32PrefixValPub: "axelarvaloperpub",
      bech32PrefixConsAddr: "axelarvalcons",
      bech32PrefixConsPub: "axelarvalconspub"
    },
    chainName: "axelartestnet",
    feeCurrencies: [
      {
        coinDenom: "axl",
        coinMinimalDenom: "uaxl",
        coinDecimals: 6,
        gasPriceStep: {
          low: 7e-3,
          average: 7e-3,
          high: 0.01
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "axl",
      coinMinimalDenom: "uaxl",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "bbn-test3",
    currencies: [
      {
        coinDenom: "bbn",
        coinMinimalDenom: "ubbn",
        coinDecimals: 6
      }
    ],
    rest: "lcd.testnet3.babylonchain.io:443",
    rpc: "rpc.testnet3.babylonchain.io:443",
    bech32Config: {
      bech32PrefixAccAddr: "bbn",
      bech32PrefixAccPub: "bbnpub",
      bech32PrefixValAddr: "bbnvaloper",
      bech32PrefixValPub: "bbnvaloperpub",
      bech32PrefixConsAddr: "bbnvalcons",
      bech32PrefixConsPub: "bbnvalconspub"
    },
    chainName: "babylontestnet",
    feeCurrencies: [
      {
        coinDenom: "bbn",
        coinMinimalDenom: "ubbn",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "bbn",
      coinMinimalDenom: "ubbn",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "bbn-test1",
    currencies: [
      {
        coinDenom: "bbn",
        coinMinimalDenom: "ubbn",
        coinDecimals: 6
      }
    ],
    rest: "rpc.testnet.babylonchain.io:1317",
    rpc: "rpc.testnet.babylonchain.io:26657",
    bech32Config: {
      bech32PrefixAccAddr: "bbn",
      bech32PrefixAccPub: "bbnpub",
      bech32PrefixValAddr: "bbnvaloper",
      bech32PrefixValPub: "bbnvaloperpub",
      bech32PrefixConsAddr: "bbnvalcons",
      bech32PrefixConsPub: "bbnvalconspub"
    },
    chainName: "babylontestnet1",
    feeCurrencies: [
      {
        coinDenom: "bbn",
        coinMinimalDenom: "ubbn",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "bbn",
      coinMinimalDenom: "ubbn",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "bitcanna-dev-1",
    currencies: [
      {
        coinDenom: "bcna",
        coinMinimalDenom: "ubcna",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd-testnet.bitcanna.io",
    rpc: "https://rpc-testnet.bitcanna.io",
    bech32Config: {
      bech32PrefixAccAddr: "bcna",
      bech32PrefixAccPub: "bcnapub",
      bech32PrefixValAddr: "bcnavaloper",
      bech32PrefixValPub: "bcnavaloperpub",
      bech32PrefixConsAddr: "bcnavalcons",
      bech32PrefixConsPub: "bcnavalconspub"
    },
    chainName: "bitcannadevnet",
    feeCurrencies: [
      {
        coinDenom: "bcna",
        coinMinimalDenom: "ubcna",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "bcna",
      coinMinimalDenom: "ubcna",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "cascadia_6102-1",
    currencies: [
      {
        coinDenom: "tCC",
        coinMinimalDenom: "aCC",
        coinDecimals: 18
      }
    ],
    rest: "https://lcd.cascadia.foundation",
    rpc: "https://rpc.cascadia.foundation:443",
    bech32Config: {
      bech32PrefixAccAddr: "cascadia",
      bech32PrefixAccPub: "cascadiapub",
      bech32PrefixValAddr: "cascadiavaloper",
      bech32PrefixValPub: "cascadiavaloperpub",
      bech32PrefixConsAddr: "cascadiavalcons",
      bech32PrefixConsPub: "cascadiavalconspub"
    },
    chainName: "cascadiatestnet",
    feeCurrencies: [
      {
        coinDenom: "tCC",
        coinMinimalDenom: "aCC",
        coinDecimals: 18,
        gasPriceStep: {
          low: 7,
          average: 10,
          high: 15
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tCC",
      coinMinimalDenom: "aCC",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "blockspacerace-0",
    currencies: [
      {
        coinDenom: "tia",
        coinMinimalDenom: "utia",
        coinDecimals: 6
      }
    ],
    rest: "https://celestia-blockspacerace-rest.brocha.in",
    rpc: "https://rpc-blockspacerace.pops.one/",
    bech32Config: {
      bech32PrefixAccAddr: "celestia",
      bech32PrefixAccPub: "celestiapub",
      bech32PrefixValAddr: "celestiavaloper",
      bech32PrefixValPub: "celestiavaloperpub",
      bech32PrefixConsAddr: "celestiavalcons",
      bech32PrefixConsPub: "celestiavalconspub"
    },
    chainName: "celestiatestnet",
    feeCurrencies: [
      {
        coinDenom: "tia",
        coinMinimalDenom: "utia",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "tia",
      coinMinimalDenom: "utia",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "mocha-4",
    currencies: [
      {
        coinDenom: "tia",
        coinMinimalDenom: "utia",
        coinDecimals: 6
      }
    ],
    rest: "https://api-mocha.pops.one",
    rpc: "https://rpc-mocha.pops.one",
    bech32Config: {
      bech32PrefixAccAddr: "celestia",
      bech32PrefixAccPub: "celestiapub",
      bech32PrefixValAddr: "celestiavaloper",
      bech32PrefixValPub: "celestiavaloperpub",
      bech32PrefixConsAddr: "celestiavalcons",
      bech32PrefixConsPub: "celestiavalconspub"
    },
    chainName: "celestiatestnet3",
    feeCurrencies: [
      {
        coinDenom: "tia",
        coinMinimalDenom: "utia",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.02,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tia",
      coinMinimalDenom: "utia",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "babajaga-1",
    currencies: [
      {
        coinDenom: "c4e",
        coinMinimalDenom: "uc4e",
        coinDecimals: 6
      }
    ],
    rest: "https://c4e.api.t.stavr.tech",
    rpc: "https://rpc-testnet.c4e.io",
    bech32Config: {
      bech32PrefixAccAddr: "c4e",
      bech32PrefixAccPub: "c4epub",
      bech32PrefixValAddr: "c4evaloper",
      bech32PrefixValPub: "c4evaloperpub",
      bech32PrefixConsAddr: "c4evalcons",
      bech32PrefixConsPub: "c4evalconspub"
    },
    chainName: "chain4energytestnet",
    feeCurrencies: [
      {
        coinDenom: "c4e",
        coinMinimalDenom: "uc4e",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.02,
          average: 0.03,
          high: 0.06
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "c4e",
      coinMinimalDenom: "uc4e",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "cheqd-testnet-6",
    currencies: [
      {
        coinDenom: "cheq",
        coinMinimalDenom: "ncheq",
        coinDecimals: 9
      }
    ],
    rest: "https://api.cheqd.network",
    rpc: "https://rpc.cheqd.network",
    bech32Config: {
      bech32PrefixAccAddr: "cheqd",
      bech32PrefixAccPub: "cheqdpub",
      bech32PrefixValAddr: "cheqdvaloper",
      bech32PrefixValPub: "cheqdvaloperpub",
      bech32PrefixConsAddr: "cheqdvalcons",
      bech32PrefixConsPub: "cheqdvalconspub"
    },
    chainName: "cheqdtestnet",
    feeCurrencies: [
      {
        coinDenom: "cheq",
        coinMinimalDenom: "ncheq",
        coinDecimals: 9,
        gasPriceStep: {
          low: 50,
          average: 75,
          high: 100
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "cheq",
      coinMinimalDenom: "ncheq",
      coinDecimals: 9
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "chimba-testnet",
    currencies: [
      {
        coinDenom: "chimba",
        coinMinimalDenom: "ucmba",
        coinDecimals: 6
      }
    ],
    rest: "https://testnet.chimba.ooo",
    rpc: "https://rpc.testnet.chimba.ooo",
    bech32Config: {
      bech32PrefixAccAddr: "chimba",
      bech32PrefixAccPub: "chimbapub",
      bech32PrefixValAddr: "chimbavaloper",
      bech32PrefixValPub: "chimbavaloperpub",
      bech32PrefixConsAddr: "chimbavalcons",
      bech32PrefixConsPub: "chimbavalconspub"
    },
    chainName: "chimbatestnet",
    feeCurrencies: [
      {
        coinDenom: "chimba",
        coinMinimalDenom: "ucmba",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1,
          average: 5,
          high: 10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "chimba",
      coinMinimalDenom: "ucmba",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "banksy-testnet-3",
    currencies: [
      {
        coinDenom: "pica",
        coinMinimalDenom: "ppica",
        coinDecimals: 12
      }
    ],
    rest: "https://api.composable-t.indonode.net",
    rpc: "https://rpc.composable-t.indonode.net:443",
    bech32Config: {
      bech32PrefixAccAddr: "centauri",
      bech32PrefixAccPub: "centauripub",
      bech32PrefixValAddr: "centaurivaloper",
      bech32PrefixValPub: "centaurivaloperpub",
      bech32PrefixConsAddr: "centaurivalcons",
      bech32PrefixConsPub: "centaurivalconspub"
    },
    chainName: "composabletestnet",
    feeCurrencies: [
      {
        coinDenom: "pica",
        coinMinimalDenom: "ppica",
        coinDecimals: 12
      }
    ],
    stakeCurrency: {
      coinDenom: "pica",
      coinMinimalDenom: "ppica",
      coinDecimals: 12
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "kitten-04",
    currencies: [
      {
        coinDenom: "ccat",
        coinMinimalDenom: "uccat",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.coolcat.space",
    rpc: "https://rpc.coolcat.space",
    bech32Config: {
      bech32PrefixAccAddr: "ccat",
      bech32PrefixAccPub: "ccatpub",
      bech32PrefixValAddr: "ccatvaloper",
      bech32PrefixValPub: "ccatvaloperpub",
      bech32PrefixConsAddr: "ccatvalcons",
      bech32PrefixConsPub: "ccatvalconspub"
    },
    chainName: "coolcattestnet",
    feeCurrencies: [
      {
        coinDenom: "ccat",
        coinMinimalDenom: "uccat",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "ccat",
      coinMinimalDenom: "uccat",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "coreum-testnet-1",
    currencies: [
      {
        coinDenom: "testcore",
        coinMinimalDenom: "utestcore",
        coinDecimals: 6
      }
    ],
    rest: "https://full-node.testnet-1.coreum.dev:1317",
    rpc: "https://full-node.testnet-1.coreum.dev:26657",
    bech32Config: {
      bech32PrefixAccAddr: "testcore",
      bech32PrefixAccPub: "testcorepub",
      bech32PrefixValAddr: "testcorevaloper",
      bech32PrefixValPub: "testcorevaloperpub",
      bech32PrefixConsAddr: "testcorevalcons",
      bech32PrefixConsPub: "testcorevalconspub"
    },
    chainName: "coreumtestnet",
    feeCurrencies: [
      {
        coinDenom: "testcore",
        coinMinimalDenom: "utestcore",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.0625,
          average: 0.0625,
          high: 62.5
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "testcore",
      coinMinimalDenom: "utestcore",
      coinDecimals: 6
    },
    bip44: {
      coinType: 990
    }
  },
  {
    chainId: "theta-testnet-001",
    currencies: [
      {
        coinDenom: "atom",
        coinMinimalDenom: "uatom",
        coinDecimals: 6
      }
    ],
    rest: "https://cosmoshubt.lava.build",
    rpc: "https://cosmoshubt.tendermintrpc.lava.build:443",
    bech32Config: {
      bech32PrefixAccAddr: "cosmos",
      bech32PrefixAccPub: "cosmospub",
      bech32PrefixValAddr: "cosmosvaloper",
      bech32PrefixValPub: "cosmosvaloperpub",
      bech32PrefixConsAddr: "cosmosvalcons",
      bech32PrefixConsPub: "cosmosvalconspub"
    },
    chainName: "cosmoshubtestnet",
    feeCurrencies: [
      {
        coinDenom: "atom",
        coinMinimalDenom: "uatom",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "atom",
      coinMinimalDenom: "uatom",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "provider",
    currencies: [
      {
        coinDenom: "atom",
        coinMinimalDenom: "uatom",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.provider-sentry-01.rs-testnet.polypore.xyz",
    rpc: "https://rpc.provider-sentry-01.rs-testnet.polypore.xyz",
    bech32Config: {
      bech32PrefixAccAddr: "cosmos",
      bech32PrefixAccPub: "cosmospub",
      bech32PrefixValAddr: "cosmosvaloper",
      bech32PrefixValPub: "cosmosvaloperpub",
      bech32PrefixConsAddr: "cosmosvalcons",
      bech32PrefixConsPub: "cosmosvalconspub"
    },
    chainName: "cosmosicsprovidertestnet",
    feeCurrencies: [
      {
        coinDenom: "atom",
        coinMinimalDenom: "uatom",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "atom",
      coinMinimalDenom: "uatom",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "malaga-420",
    currencies: [
      {
        coinDenom: "MLG",
        coinMinimalDenom: "umlg",
        coinDecimals: 6
      },
      {
        coinDenom: "AND",
        coinMinimalDenom: "uand",
        coinDecimals: 6
      }
    ],
    rest: "https://api.malaga-420.cosmwasm.com",
    rpc: "https://rpc.malaga-420.cosmwasm.com:443",
    bech32Config: {
      bech32PrefixAccAddr: "wasm",
      bech32PrefixAccPub: "wasmpub",
      bech32PrefixValAddr: "wasmvaloper",
      bech32PrefixValPub: "wasmvaloperpub",
      bech32PrefixConsAddr: "wasmvalcons",
      bech32PrefixConsPub: "wasmvalconspub"
    },
    chainName: "cosmwasmtestnet",
    feeCurrencies: [
      {
        coinDenom: "MLG",
        coinMinimalDenom: "umlg",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.03,
          average: 0.04,
          high: 0.05
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "MLG",
      coinMinimalDenom: "umlg",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "coss-testnet-1",
    currencies: [
      {
        coinDenom: "cgas",
        coinMinimalDenom: "ucgas",
        coinDecimals: 6
      }
    ],
    rest: "https://coss-testnet-rest.coss.ink",
    rpc: "https://coss-testnet-rpc.coss.ink",
    bech32Config: {
      bech32PrefixAccAddr: "coss",
      bech32PrefixAccPub: "cosspub",
      bech32PrefixValAddr: "cossvaloper",
      bech32PrefixValPub: "cossvaloperpub",
      bech32PrefixConsAddr: "cossvalcons",
      bech32PrefixConsPub: "cossvalconspub"
    },
    chainName: "cosstestnet",
    feeCurrencies: [
      {
        coinDenom: "cgas",
        coinMinimalDenom: "ucgas",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "cgas",
      coinMinimalDenom: "ucgas",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "deardoge-testnet",
    currencies: [
      {
        coinDenom: "dear",
        coinMinimalDenom: "udear",
        coinDecimals: 6
      }
    ],
    rest: "https://testnet-rest.deardoge.org",
    rpc: "https://testnet-rpc.deardoge.org",
    bech32Config: {
      bech32PrefixAccAddr: "deardoge",
      bech32PrefixAccPub: "deardogepub",
      bech32PrefixValAddr: "deardogevaloper",
      bech32PrefixValPub: "deardogevaloperpub",
      bech32PrefixConsAddr: "deardogevalcons",
      bech32PrefixConsPub: "deardogevalconspub"
    },
    chainName: "deardogetestnet",
    feeCurrencies: [
      {
        coinDenom: "dear",
        coinMinimalDenom: "udear",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "dear",
      coinMinimalDenom: "udear",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "morpheus-apollo-3",
    currencies: [
      {
        coinDenom: "daric",
        coinMinimalDenom: "udaric",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.morpheus.desmos.network",
    rpc: "https://rpc.morpheus.desmos.network",
    bech32Config: {
      bech32PrefixAccAddr: "desmos",
      bech32PrefixAccPub: "desmospub",
      bech32PrefixValAddr: "desmosvaloper",
      bech32PrefixValPub: "desmosvaloperpub",
      bech32PrefixConsAddr: "desmosvalcons",
      bech32PrefixConsPub: "desmosvalconspub"
    },
    chainName: "desmostestnet",
    feeCurrencies: [
      {
        coinDenom: "daric",
        coinMinimalDenom: "udaric",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.03,
          high: 0.05
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "daric",
      coinMinimalDenom: "udaric",
      coinDecimals: 6
    },
    bip44: {
      coinType: 852
    }
  },
  {
    chainId: "dhealth-testnet-2",
    currencies: [
      {
        coinDenom: "tdhp",
        coinMinimalDenom: "utdhp",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd-testnet.dhealth.dev",
    rpc: "https://rpc-testnet.dhealth.dev",
    bech32Config: {
      bech32PrefixAccAddr: "tdh02",
      bech32PrefixAccPub: "tdh02pub",
      bech32PrefixValAddr: "tdh02valoper",
      bech32PrefixValPub: "tdh02valoperpub",
      bech32PrefixConsAddr: "tdh02valcons",
      bech32PrefixConsPub: "tdh02valconspub"
    },
    chainName: "dhealthtestnet",
    feeCurrencies: [
      {
        coinDenom: "tdhp",
        coinMinimalDenom: "utdhp",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.03,
          high: 0.035
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tdhp",
      coinMinimalDenom: "utdhp",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "vota-testnet",
    currencies: [
      {
        coinDenom: "DORA",
        coinMinimalDenom: "peaka",
        coinDecimals: 18
      }
    ],
    rest: "https://vota-testnet-rest.dorafactory.org",
    rpc: "https://vota-testnet-rpc.dorafactory.org/",
    bech32Config: {
      bech32PrefixAccAddr: "dora",
      bech32PrefixAccPub: "dorapub",
      bech32PrefixValAddr: "doravaloper",
      bech32PrefixValPub: "doravaloperpub",
      bech32PrefixConsAddr: "doravalcons",
      bech32PrefixConsPub: "doravalconspub"
    },
    chainName: "doravotatestnet",
    feeCurrencies: [
      {
        coinDenom: "DORA",
        coinMinimalDenom: "peaka",
        coinDecimals: 18
      }
    ],
    stakeCurrency: {
      coinDenom: "DORA",
      coinMinimalDenom: "peaka",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "vota-vk",
    currencies: [
      {
        coinDenom: "DORA",
        coinMinimalDenom: "peaka",
        coinDecimals: 18
      }
    ],
    rest: "https://vota-vk-rest.dorafactory.org",
    rpc: "https://vota-vk-rpc.dorafactory.org/",
    bech32Config: {
      bech32PrefixAccAddr: "dora",
      bech32PrefixAccPub: "dorapub",
      bech32PrefixValAddr: "doravaloper",
      bech32PrefixValPub: "doravaloperpub",
      bech32PrefixConsAddr: "doravalcons",
      bech32PrefixConsPub: "doravalconspub"
    },
    chainName: "doravotatestnet2",
    feeCurrencies: [
      {
        coinDenom: "DORA",
        coinMinimalDenom: "peaka",
        coinDecimals: 18
      }
    ],
    stakeCurrency: {
      coinDenom: "DORA",
      coinMinimalDenom: "peaka",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "dydx-testnet-4",
    currencies: [
      {
        coinDenom: "dv4tnt",
        coinMinimalDenom: "adv4tnt",
        coinDecimals: 18
      }
    ],
    rest: "https://dydx-lcd-testnet.enigma-validator.com",
    rpc: "https://dydx-rpc-testnet.enigma-validator.com",
    bech32Config: {
      bech32PrefixAccAddr: "dydx",
      bech32PrefixAccPub: "dydxpub",
      bech32PrefixValAddr: "dydxvaloper",
      bech32PrefixValPub: "dydxvaloperpub",
      bech32PrefixConsAddr: "dydxvalcons",
      bech32PrefixConsPub: "dydxvalconspub"
    },
    chainName: "dydxtestnet",
    feeCurrencies: [
      {
        coinDenom: "dv4tnt",
        coinMinimalDenom: "adv4tnt",
        coinDecimals: 18,
        gasPriceStep: {
          low: 125e8,
          average: 125e8,
          high: 2e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "dv4tnt",
      coinMinimalDenom: "adv4tnt",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "elystestnet-1",
    currencies: [
      {
        coinDenom: "elys",
        coinMinimalDenom: "uelys",
        coinDecimals: 6
      },
      {
        coinDenom: "eden",
        coinMinimalDenom: "ueden",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/2180E84E20F5679FCC760D8C165B60F42065DEF7F46A72B447CFF1B7DC6C0A65",
        coinDecimals: 6
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/E2D2F6ADCC68AA3384B2F5DFACCA437923D137C14E86FB8A10207CF3BED0C8D4",
        coinDecimals: 6
      }
    ],
    rest: "https://api.testnet.elys.network",
    rpc: "https://rpc.testnet.elys.network",
    bech32Config: {
      bech32PrefixAccAddr: "elys",
      bech32PrefixAccPub: "elyspub",
      bech32PrefixValAddr: "elysvaloper",
      bech32PrefixValPub: "elysvaloperpub",
      bech32PrefixConsAddr: "elysvalcons",
      bech32PrefixConsPub: "elysvalconspub"
    },
    chainName: "elystestnet",
    feeCurrencies: [
      {
        coinDenom: "elys",
        coinMinimalDenom: "uelys",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/2180E84E20F5679FCC760D8C165B60F42065DEF7F46A72B447CFF1B7DC6C0A65",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/E2D2F6ADCC68AA3384B2F5DFACCA437923D137C14E86FB8A10207CF3BED0C8D4",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "elys",
      coinMinimalDenom: "uelys",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "empe-testnet-2",
    currencies: [
      {
        coinDenom: "empe",
        coinMinimalDenom: "uempe",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd-testnet.empe.io/",
    rpc: "https://rpc-testnet.empe.io/",
    bech32Config: {
      bech32PrefixAccAddr: "empe",
      bech32PrefixAccPub: "empepub",
      bech32PrefixValAddr: "empevaloper",
      bech32PrefixValPub: "empevaloperpub",
      bech32PrefixConsAddr: "empevalcons",
      bech32PrefixConsPub: "empevalconspub"
    },
    chainName: "empetestnet",
    feeCurrencies: [
      {
        coinDenom: "empe",
        coinMinimalDenom: "uempe",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "empe",
      coinMinimalDenom: "uempe",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "circulus-1",
    currencies: [
      {
        coinDenom: "mpwr",
        coinMinimalDenom: "umpwr",
        coinDecimals: 6
      }
    ],
    rest: "https://empower-testnet-api.polkachu.com:443",
    rpc: "https://empower-testnet-rpc.polkachu.com:443",
    bech32Config: {
      bech32PrefixAccAddr: "empower",
      bech32PrefixAccPub: "empowerpub",
      bech32PrefixValAddr: "empowervaloper",
      bech32PrefixValPub: "empowervaloperpub",
      bech32PrefixConsAddr: "empowervalcons",
      bech32PrefixConsPub: "empowervalconspub"
    },
    chainName: "empowertestnet",
    feeCurrencies: [
      {
        coinDenom: "mpwr",
        coinMinimalDenom: "umpwr",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "mpwr",
      coinMinimalDenom: "umpwr",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "entrypoint-pubtest-2",
    currencies: [
      {
        coinDenom: "entry",
        coinMinimalDenom: "uentry",
        coinDecimals: 6
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/8A138BC76D0FB2665F8937EC2BF01B9F6A714F6127221A0E155106A45E09BCC5",
        coinDecimals: 6
      }
    ],
    rest: "https://entry.api.t.stavr.tech",
    rpc: "https://testnet-rpc.entrypoint.zone",
    bech32Config: {
      bech32PrefixAccAddr: "entrypoint",
      bech32PrefixAccPub: "entrypointpub",
      bech32PrefixValAddr: "entrypointvaloper",
      bech32PrefixValPub: "entrypointvaloperpub",
      bech32PrefixConsAddr: "entrypointvalcons",
      bech32PrefixConsPub: "entrypointvalconspub"
    },
    chainName: "entrypointtestnet",
    feeCurrencies: [
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/8A138BC76D0FB2665F8937EC2BF01B9F6A714F6127221A0E155106A45E09BCC5",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.01,
          high: 0.02
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "entry",
      coinMinimalDenom: "uentry",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "epix_4243-1",
    currencies: [
      {
        coinDenom: "epix",
        coinMinimalDenom: "aepix",
        coinDecimals: 18
      }
    ],
    rest: "https://api.testnet.epix.zone",
    rpc: "https://rpc.testnet.epix.zone",
    bech32Config: {
      bech32PrefixAccAddr: "epix",
      bech32PrefixAccPub: "epixpub",
      bech32PrefixValAddr: "epixvaloper",
      bech32PrefixValPub: "epixvaloperpub",
      bech32PrefixConsAddr: "epixvalcons",
      bech32PrefixConsPub: "epixvalconspub"
    },
    chainName: "epixtestnet",
    feeCurrencies: [
      {
        coinDenom: "epix",
        coinMinimalDenom: "aepix",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e10,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "epix",
      coinMinimalDenom: "aepix",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "evmos_9000-4",
    currencies: [
      {
        coinDenom: "tevmos",
        coinMinimalDenom: "atevmos",
        coinDecimals: 18
      }
    ],
    rest: "https://evmos.test.api.coldyvalidator.net",
    rpc: "https://evmos.test.rpc.coldyvalidator.net",
    bech32Config: {
      bech32PrefixAccAddr: "evmos",
      bech32PrefixAccPub: "evmospub",
      bech32PrefixValAddr: "evmosvaloper",
      bech32PrefixValPub: "evmosvaloperpub",
      bech32PrefixConsAddr: "evmosvalcons",
      bech32PrefixConsPub: "evmosvalconspub"
    },
    chainName: "evmostestnet",
    feeCurrencies: [
      {
        coinDenom: "tevmos",
        coinMinimalDenom: "atevmos",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e10,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tevmos",
      coinMinimalDenom: "atevmos",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "dorado-1",
    currencies: [
      {
        coinDenom: "testfet",
        coinMinimalDenom: "atestfet",
        coinDecimals: 18
      }
    ],
    rest: "https://rest-dorado.fetch.ai",
    rpc: "https://rpc-dorado.fetch.ai:443",
    bech32Config: {
      bech32PrefixAccAddr: "fetch",
      bech32PrefixAccPub: "fetchpub",
      bech32PrefixValAddr: "fetchvaloper",
      bech32PrefixValPub: "fetchvaloperpub",
      bech32PrefixConsAddr: "fetchvalcons",
      bech32PrefixConsPub: "fetchvalconspub"
    },
    chainName: "fetchhubtestnet",
    feeCurrencies: [
      {
        coinDenom: "testfet",
        coinMinimalDenom: "atestfet",
        coinDecimals: 18,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.035
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "testfet",
      coinMinimalDenom: "atestfet",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "fiamma-testnet-1",
    currencies: [
      {
        coinDenom: "fia",
        coinMinimalDenom: "ufia",
        coinDecimals: 6
      }
    ],
    rest: "https://testnet-api.fiammachain.io",
    rpc: "https://testnet-rpc.fiammachain.io",
    bech32Config: {
      bech32PrefixAccAddr: "fiamma",
      bech32PrefixAccPub: "fiammapub",
      bech32PrefixValAddr: "fiammavaloper",
      bech32PrefixValPub: "fiammavaloperpub",
      bech32PrefixConsAddr: "fiammavalcons",
      bech32PrefixConsPub: "fiammavalconspub"
    },
    chainName: "fiammatestnet",
    feeCurrencies: [
      {
        coinDenom: "fia",
        coinMinimalDenom: "ufia",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "fia",
      coinMinimalDenom: "ufia",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "ebony-2",
    currencies: [
      {
        coinDenom: "tfnsa",
        coinMinimalDenom: "tcony",
        coinDecimals: 6
      }
    ],
    rest: "https://ebony-api.finschia.io",
    rpc: "https://ebony-rpc.finschia.io",
    bech32Config: {
      bech32PrefixAccAddr: "tlink",
      bech32PrefixAccPub: "tlinkpub",
      bech32PrefixValAddr: "tlinkvaloper",
      bech32PrefixValPub: "tlinkvaloperpub",
      bech32PrefixConsAddr: "tlinkvalcons",
      bech32PrefixConsPub: "tlinkvalconspub"
    },
    chainName: "finschiatestnet",
    feeCurrencies: [
      {
        coinDenom: "tfnsa",
        coinMinimalDenom: "tcony",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.015,
          average: 0.015,
          high: 0.015
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tfnsa",
      coinMinimalDenom: "tcony",
      coinDecimals: 6
    },
    bip44: {
      coinType: 438
    }
  },
  {
    chainId: "galactica_9302-1",
    currencies: [
      {
        coinDenom: "gnet",
        coinMinimalDenom: "agnet",
        coinDecimals: 18
      }
    ],
    rest: "https://api.galactica.test.pfc.zone/",
    rpc: "https://rpc.galactica.test.pfc.zone/",
    bech32Config: {
      bech32PrefixAccAddr: "gala",
      bech32PrefixAccPub: "galapub",
      bech32PrefixValAddr: "galavaloper",
      bech32PrefixValPub: "galavaloperpub",
      bech32PrefixConsAddr: "galavalcons",
      bech32PrefixConsPub: "galavalconspub"
    },
    chainName: "galacticatestnet",
    feeCurrencies: [
      {
        coinDenom: "gnet",
        coinMinimalDenom: "agnet",
        coinDecimals: 18,
        gasPriceStep: {
          low: 10,
          average: 10,
          high: 20
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "gnet",
      coinMinimalDenom: "agnet",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "gitopia-janus-testnet-2",
    currencies: [
      {
        coinDenom: "tlore",
        coinMinimalDenom: "utlore",
        coinDecimals: 6
      }
    ],
    rest: "https://gitopia-testnet.nodejumper.io:1317",
    rpc: "https://gitopia-testnet.nodejumper.io",
    bech32Config: {
      bech32PrefixAccAddr: "gitopia",
      bech32PrefixAccPub: "gitopiapub",
      bech32PrefixValAddr: "gitopiavaloper",
      bech32PrefixValPub: "gitopiavaloperpub",
      bech32PrefixConsAddr: "gitopiavalcons",
      bech32PrefixConsPub: "gitopiavalconspub"
    },
    chainName: "gitopiatestnet",
    feeCurrencies: [
      {
        coinDenom: "tlore",
        coinMinimalDenom: "utlore",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "tlore",
      coinMinimalDenom: "utlore",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "berberis-1",
    currencies: [
      {
        coinDenom: "hedge",
        coinMinimalDenom: "uhedge",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd-berberis.hedgeblock.io",
    rpc: "https://rpc-berberis.hedgeblock.io",
    bech32Config: {
      bech32PrefixAccAddr: "hedge",
      bech32PrefixAccPub: "hedgepub",
      bech32PrefixValAddr: "hedgevaloper",
      bech32PrefixValPub: "hedgevaloperpub",
      bech32PrefixConsAddr: "hedgevalcons",
      bech32PrefixConsPub: "hedgevalconspub"
    },
    chainName: "hedgetestnet",
    feeCurrencies: [
      {
        coinDenom: "hedge",
        coinMinimalDenom: "uhedge",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "hedge",
      coinMinimalDenom: "uhedge",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "testnet-1",
    currencies: [
      {
        coinDenom: "heart",
        coinMinimalDenom: "uheart",
        coinDecimals: 6
      }
    ],
    rest: "https://humans-testnet.nodejumper.io:1317",
    rpc: "https://humans-testnet.nodejumper.io",
    bech32Config: {
      bech32PrefixAccAddr: "humans",
      bech32PrefixAccPub: "humanspub",
      bech32PrefixValAddr: "humansvaloper",
      bech32PrefixValPub: "humansvaloperpub",
      bech32PrefixConsAddr: "humansvalcons",
      bech32PrefixConsPub: "humansvalconspub"
    },
    chainName: "humanstestnet",
    feeCurrencies: [
      {
        coinDenom: "heart",
        coinMinimalDenom: "uheart",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "heart",
      coinMinimalDenom: "uheart",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "prajna-1",
    currencies: [
      {
        coinDenom: "hid",
        coinMinimalDenom: "uhid",
        coinDecimals: 6
      }
    ],
    rest: "https://api.prajna.hypersign.id",
    rpc: "https://rpc.prajna.hypersign.id",
    bech32Config: {
      bech32PrefixAccAddr: "hid",
      bech32PrefixAccPub: "hidpub",
      bech32PrefixValAddr: "hidvaloper",
      bech32PrefixValPub: "hidvaloperpub",
      bech32PrefixConsAddr: "hidvalcons",
      bech32PrefixConsPub: "hidvalconspub"
    },
    chainName: "hypersigntestnet",
    feeCurrencies: [
      {
        coinDenom: "hid",
        coinMinimalDenom: "uhid",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "hid",
      coinMinimalDenom: "uhid",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "pandora-8",
    currencies: [
      {
        coinDenom: "ixo",
        coinMinimalDenom: "uixo",
        coinDecimals: 6
      }
    ],
    rest: "https://testnet.ixo.earth/rest/",
    rpc: "https://rpc.testnet.ixo.earth/",
    bech32Config: {
      bech32PrefixAccAddr: "ixo",
      bech32PrefixAccPub: "ixopub",
      bech32PrefixValAddr: "ixovaloper",
      bech32PrefixValPub: "ixovaloperpub",
      bech32PrefixConsAddr: "ixovalcons",
      bech32PrefixConsPub: "ixovalconspub"
    },
    chainName: "impacthubtestnet",
    feeCurrencies: [
      {
        coinDenom: "ixo",
        coinMinimalDenom: "uixo",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.015,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ixo",
      coinMinimalDenom: "uixo",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "imversed-test-1",
    currencies: [
      {
        coinDenom: "imv",
        coinMinimalDenom: "nimv",
        coinDecimals: 6
      }
    ],
    rest: "https://query-endpoint-test.imversed.com/",
    rpc: "https://tx-endpoint-test.imversed.com/",
    bech32Config: {
      bech32PrefixAccAddr: "imv",
      bech32PrefixAccPub: "imvpub",
      bech32PrefixValAddr: "imvvaloper",
      bech32PrefixValPub: "imvvaloperpub",
      bech32PrefixConsAddr: "imvvalcons",
      bech32PrefixConsPub: "imvvalconspub"
    },
    chainName: "imversedtestnet",
    feeCurrencies: [
      {
        coinDenom: "imv",
        coinMinimalDenom: "nimv",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "imv",
      coinMinimalDenom: "nimv",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "injective-888",
    currencies: [
      {
        coinDenom: "INJ",
        coinMinimalDenom: "inj",
        coinDecimals: 18
      }
    ],
    rest: "https://injective-testnet-api.polkachu.com",
    rpc: "https://injective-testnet-rpc.polkachu.com",
    bech32Config: {
      bech32PrefixAccAddr: "inj",
      bech32PrefixAccPub: "injpub",
      bech32PrefixValAddr: "injvaloper",
      bech32PrefixValPub: "injvaloperpub",
      bech32PrefixConsAddr: "injvalcons",
      bech32PrefixConsPub: "injvalconspub"
    },
    chainName: "injectivetestnet",
    feeCurrencies: [
      {
        coinDenom: "INJ",
        coinMinimalDenom: "inj",
        coinDecimals: 18,
        gasPriceStep: {
          low: 5e8,
          average: 7e8,
          high: 9e8
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "INJ",
      coinMinimalDenom: "inj",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "canine-1",
    currencies: [
      {
        coinDenom: "jkl",
        coinMinimalDenom: "ujkl",
        coinDecimals: 6
      }
    ],
    rest: "https://jkl.api.t.stavr.tech",
    rpc: "http://jkl.rpc.t.stavr.tech:19127",
    bech32Config: {
      bech32PrefixAccAddr: "jkl",
      bech32PrefixAccPub: "jklpub",
      bech32PrefixValAddr: "jklvaloper",
      bech32PrefixValPub: "jklvaloperpub",
      bech32PrefixConsAddr: "jklvalcons",
      bech32PrefixConsPub: "jklvalconspub"
    },
    chainName: "jackaltestnet",
    feeCurrencies: [
      {
        coinDenom: "jkl",
        coinMinimalDenom: "ujkl",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "jkl",
      coinMinimalDenom: "ujkl",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "mesomelas-1",
    currencies: [
      {
        coinDenom: "jkl",
        coinMinimalDenom: "ujkl",
        coinDecimals: 6
      }
    ],
    rest: "https://jackal-testnet-v4-rest.brocha.in",
    rpc: "https://jackal-testnet-v4-rpc.brocha.in",
    bech32Config: {
      bech32PrefixAccAddr: "jkl",
      bech32PrefixAccPub: "jklpub",
      bech32PrefixValAddr: "jklvaloper",
      bech32PrefixValPub: "jklvaloperpub",
      bech32PrefixConsAddr: "jklvalcons",
      bech32PrefixConsPub: "jklvalconspub"
    },
    chainName: "jackaltestnet2",
    feeCurrencies: [
      {
        coinDenom: "jkl",
        coinMinimalDenom: "ujkl",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "jkl",
      coinMinimalDenom: "ujkl",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "uni-6",
    currencies: [
      {
        coinDenom: "junox",
        coinMinimalDenom: "ujunox",
        coinDecimals: 6
      },
      {
        coinDenom: "nexx",
        coinMinimalDenom: "factory/juno12klaltyqvg2j6v034jwdxrk5n4242ttse4sdpt/NEXX",
        coinDecimals: 6
      },
      {
        coinDenom: "arena",
        coinMinimalDenom: "factory/juno12dgadj3wwv5jn0ec7tw5cgvq526nn4gnt2tujlmd57p2ra6k87esl36r9k/ARENA",
        coinDecimals: 6
      }
    ],
    rest: "https://juno-testnet-api.polkachu.com",
    rpc: "https://juno-testnet-rpc.polkachu.com",
    bech32Config: {
      bech32PrefixAccAddr: "juno",
      bech32PrefixAccPub: "junopub",
      bech32PrefixValAddr: "junovaloper",
      bech32PrefixValPub: "junovaloperpub",
      bech32PrefixConsAddr: "junovalcons",
      bech32PrefixConsPub: "junovalconspub"
    },
    chainName: "junotestnet",
    feeCurrencies: [
      {
        coinDenom: "junox",
        coinMinimalDenom: "ujunox",
        coinDecimals: 6,
        gasPriceStep: {
          low: 3e-3,
          average: 45e-4,
          high: 6e-3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "junox",
      coinMinimalDenom: "ujunox",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "kichain-t-4",
    currencies: [
      {
        coinDenom: "tki",
        coinMinimalDenom: "utki",
        coinDecimals: 6
      }
    ],
    rest: "https://api-challenge.blockchain.ki/",
    rpc: "https://rpc-challenge.blockchain.ki/",
    bech32Config: {
      bech32PrefixAccAddr: "tki",
      bech32PrefixAccPub: "tkipub",
      bech32PrefixValAddr: "tkivaloper",
      bech32PrefixValPub: "tkivaloperpub",
      bech32PrefixConsAddr: "tkivalcons",
      bech32PrefixConsPub: "tkivalconspub"
    },
    chainName: "kichaintestnet",
    feeCurrencies: [
      {
        coinDenom: "tki",
        coinMinimalDenom: "utki",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "tki",
      coinMinimalDenom: "utki",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "kima_testnet",
    currencies: [
      {
        coinDenom: "KIMA",
        coinMinimalDenom: "uKIMA",
        coinDecimals: 6
      }
    ],
    rest: "https://api-testnet.kima.finance",
    rpc: "https://rpc-testnet.kima.finance/",
    bech32Config: {
      bech32PrefixAccAddr: "kima",
      bech32PrefixAccPub: "kimapub",
      bech32PrefixValAddr: "kimavaloper",
      bech32PrefixValPub: "kimavaloperpub",
      bech32PrefixConsAddr: "kimavalcons",
      bech32PrefixConsPub: "kimavalconspub"
    },
    chainName: "kimanetworktestnet",
    feeCurrencies: [
      {
        coinDenom: "KIMA",
        coinMinimalDenom: "uKIMA",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "KIMA",
      coinMinimalDenom: "uKIMA",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "harpoon-4",
    currencies: [
      {
        coinDenom: "kuji",
        coinMinimalDenom: "ukuji",
        coinDecimals: 6
      },
      {
        coinDenom: "fuzn",
        coinMinimalDenom: "factory/kujira16qpvzhmawvsm8mcj4hdvtz25dadatdhhgw79xa/FUZN",
        coinDecimals: 6
      }
    ],
    rest: "https://kujira-testnet-api.polkachu.com/",
    rpc: "https://kujira-testnet-rpc.polkachu.com",
    bech32Config: {
      bech32PrefixAccAddr: "kujira",
      bech32PrefixAccPub: "kujirapub",
      bech32PrefixValAddr: "kujiravaloper",
      bech32PrefixValPub: "kujiravaloperpub",
      bech32PrefixConsAddr: "kujiravalcons",
      bech32PrefixConsPub: "kujiravalconspub"
    },
    chainName: "kujiratestnet",
    feeCurrencies: [
      {
        coinDenom: "kuji",
        coinMinimalDenom: "ukuji",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "kuji",
      coinMinimalDenom: "ukuji",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "kaon-1",
    currencies: [
      {
        coinDenom: "kyve",
        coinMinimalDenom: "tkyve",
        coinDecimals: 6
      }
    ],
    rest: "https://api-eu-1.kaon.kyve.network",
    rpc: "https://rpc-eu-1.kaon.kyve.network",
    bech32Config: {
      bech32PrefixAccAddr: "kyve",
      bech32PrefixAccPub: "kyvepub",
      bech32PrefixValAddr: "kyvevaloper",
      bech32PrefixValPub: "kyvevaloperpub",
      bech32PrefixConsAddr: "kyvevalcons",
      bech32PrefixConsPub: "kyvevalconspub"
    },
    chainName: "kyvetestnet",
    feeCurrencies: [
      {
        coinDenom: "kyve",
        coinMinimalDenom: "tkyve",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.02,
          average: 0.03,
          high: 0.06
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "kyve",
      coinMinimalDenom: "tkyve",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "lava-testnet-2",
    currencies: [
      {
        coinDenom: "lava",
        coinMinimalDenom: "ulava",
        coinDecimals: 6
      }
    ],
    rest: "https://lav1.lava.build/",
    rpc: "https://lav1.tendermintrpc.lava.build:443",
    bech32Config: {
      bech32PrefixAccAddr: "lava@",
      bech32PrefixAccPub: "lava@pub",
      bech32PrefixValAddr: "lava@valoper",
      bech32PrefixValPub: "lava@valoperpub",
      bech32PrefixConsAddr: "lava@valcons",
      bech32PrefixConsPub: "lava@valconspub"
    },
    chainName: "lavatestnet",
    feeCurrencies: [
      {
        coinDenom: "lava",
        coinMinimalDenom: "ulava",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-6,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "lava",
      coinMinimalDenom: "ulava",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "lava-testnet-1",
    currencies: [
      {
        coinDenom: "lava",
        coinMinimalDenom: "ulava",
        coinDecimals: 6
      }
    ],
    rest: "https://public-rpc-testnet2.lavanet.xyz/rest/",
    rpc: "https://public-rpc-testnet2.lavanet.xyz/",
    bech32Config: {
      bech32PrefixAccAddr: "lava@",
      bech32PrefixAccPub: "lava@pub",
      bech32PrefixValAddr: "lava@valoper",
      bech32PrefixValPub: "lava@valoperpub",
      bech32PrefixConsAddr: "lava@valcons",
      bech32PrefixConsPub: "lava@valconspub"
    },
    chainName: "lavatestnet1",
    feeCurrencies: [
      {
        coinDenom: "lava",
        coinMinimalDenom: "ulava",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "lava",
      coinMinimalDenom: "ulava",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "likecoin-public-testnet-5",
    currencies: [
      {
        coinDenom: "ekil",
        coinMinimalDenom: "nanoekil",
        coinDecimals: 9
      }
    ],
    rest: "https://node.testnet.like.co/",
    rpc: "https://node.testnet.like.co/rpc/",
    bech32Config: {
      bech32PrefixAccAddr: "like",
      bech32PrefixAccPub: "likepub",
      bech32PrefixValAddr: "likevaloper",
      bech32PrefixValPub: "likevaloperpub",
      bech32PrefixConsAddr: "likevalcons",
      bech32PrefixConsPub: "likevalconspub"
    },
    chainName: "likecointestnet",
    feeCurrencies: [
      {
        coinDenom: "ekil",
        coinMinimalDenom: "nanoekil",
        coinDecimals: 9,
        gasPriceStep: {
          low: 1e3,
          average: 1e4,
          high: 1e6
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ekil",
      coinMinimalDenom: "nanoekil",
      coinDecimals: 9
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "lumenx-test",
    currencies: [
      {
        coinDenom: "lumen",
        coinMinimalDenom: "ulumen",
        coinDecimals: 6
      }
    ],
    rest: "https://testnet-api.lumenx.chaintools.tech/",
    rpc: "https://testnet-rpc.lumenx.chaintools.tech/",
    bech32Config: {
      bech32PrefixAccAddr: "lumen",
      bech32PrefixAccPub: "lumenpub",
      bech32PrefixValAddr: "lumenvaloper",
      bech32PrefixValPub: "lumenvaloperpub",
      bech32PrefixConsAddr: "lumenvalcons",
      bech32PrefixConsPub: "lumenvalconspub"
    },
    chainName: "lumenxtestnet",
    feeCurrencies: [
      {
        coinDenom: "lumen",
        coinMinimalDenom: "ulumen",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "lumen",
      coinMinimalDenom: "ulumen",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "manifest-ledger-beta",
    currencies: [
      {
        coinDenom: "mfx",
        coinMinimalDenom: "umfx",
        coinDecimals: 6
      },
      {
        coinDenom: "poa",
        coinMinimalDenom: "upoa",
        coinDecimals: 6
      }
    ],
    rest: "https://nodes.chandrastation.com/api/manifest/",
    rpc: "https://nodes.chandrastation.com/rpc/manifest/",
    bech32Config: {
      bech32PrefixAccAddr: "manifest",
      bech32PrefixAccPub: "manifestpub",
      bech32PrefixValAddr: "manifestvaloper",
      bech32PrefixValPub: "manifestvaloperpub",
      bech32PrefixConsAddr: "manifestvalcons",
      bech32PrefixConsPub: "manifestvalconspub"
    },
    chainName: "manifesttestnet",
    feeCurrencies: [
      {
        coinDenom: "mfx",
        coinMinimalDenom: "umfx",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 7e-3,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "mfx",
      coinMinimalDenom: "umfx",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "mantra-hongbai-1",
    currencies: [
      {
        coinDenom: "om",
        coinMinimalDenom: "uom",
        coinDecimals: 6
      }
    ],
    rest: "https://api.hongbai.mantrachain.io",
    rpc: "https://rpc.hongbai.mantrachain.io",
    bech32Config: {
      bech32PrefixAccAddr: "mantra",
      bech32PrefixAccPub: "mantrapub",
      bech32PrefixValAddr: "mantravaloper",
      bech32PrefixValPub: "mantravaloperpub",
      bech32PrefixConsAddr: "mantravalcons",
      bech32PrefixConsPub: "mantravalconspub"
    },
    chainName: "mantrachaintestnet",
    feeCurrencies: [
      {
        coinDenom: "om",
        coinMinimalDenom: "uom",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-3,
          average: 2e-3,
          high: 3e-3
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "om",
      coinMinimalDenom: "uom",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "mantra-dukong-1",
    currencies: [
      {
        coinDenom: "om",
        coinMinimalDenom: "uom",
        coinDecimals: 6
      }
    ],
    rest: "https://api.dukong.mantrachain.io",
    rpc: "https://rpc.dukong.mantrachain.io",
    bech32Config: {
      bech32PrefixAccAddr: "mantra",
      bech32PrefixAccPub: "mantrapub",
      bech32PrefixValAddr: "mantravaloper",
      bech32PrefixValPub: "mantravaloperpub",
      bech32PrefixConsAddr: "mantravalcons",
      bech32PrefixConsPub: "mantravalconspub"
    },
    chainName: "mantrachaintestnet2",
    feeCurrencies: [
      {
        coinDenom: "om",
        coinMinimalDenom: "uom",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.02,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "om",
      coinMinimalDenom: "uom",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "ares-1",
    currencies: [
      {
        coinDenom: "mars",
        coinMinimalDenom: "umars",
        coinDecimals: 6
      }
    ],
    rest: "https://testnet-rest.marsprotocol.io/",
    rpc: "https://testnet-rpc.marsprotocol.io/",
    bech32Config: {
      bech32PrefixAccAddr: "mars",
      bech32PrefixAccPub: "marspub",
      bech32PrefixValAddr: "marsvaloper",
      bech32PrefixValPub: "marsvaloperpub",
      bech32PrefixConsAddr: "marsvalcons",
      bech32PrefixConsPub: "marsvalconspub"
    },
    chainName: "marstestnet",
    feeCurrencies: [
      {
        coinDenom: "mars",
        coinMinimalDenom: "umars",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "mars",
      coinMinimalDenom: "umars",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "narwhal-2",
    currencies: [
      {
        coinDenom: "whale",
        coinMinimalDenom: "uwhale",
        coinDecimals: 6
      }
    ],
    rest: "https://migaloo-testnet-api.polkachu.com",
    rpc: "https://migaloo-testnet-rpc.polkachu.com",
    bech32Config: {
      bech32PrefixAccAddr: "migaloo",
      bech32PrefixAccPub: "migaloopub",
      bech32PrefixValAddr: "migaloovaloper",
      bech32PrefixValPub: "migaloovaloperpub",
      bech32PrefixConsAddr: "migaloovalcons",
      bech32PrefixConsPub: "migaloovalconspub"
    },
    chainName: "migalootestnet",
    feeCurrencies: [
      {
        coinDenom: "whale",
        coinMinimalDenom: "uwhale",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.25,
          average: 0.5,
          high: 0.75
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "whale",
      coinMinimalDenom: "uwhale",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "pion-1",
    currencies: [
      {
        coinDenom: "ntrn",
        coinMinimalDenom: "untrn",
        coinDecimals: 6
      },
      {
        coinDenom: "amATOM",
        coinMinimalDenom: "factory/neutron15lku24mqhvy4v4gryrqs4662n9v9q4ux9tayn89cmdzldjcgawushxvm76/amatom",
        coinDecimals: 6
      },
      {
        coinDenom: "arena",
        coinMinimalDenom: "factory/neutron1r3slyjlf7g76mz3na6gh7c8ek62rhssrzf60uh0emyw3x94rppyqfcs0pk/uarena",
        coinDecimals: 6
      }
    ],
    rest: "https://rest-falcron.pion-1.ntrn.tech",
    rpc: "https://rpc-falcron.pion-1.ntrn.tech",
    bech32Config: {
      bech32PrefixAccAddr: "neutron",
      bech32PrefixAccPub: "neutronpub",
      bech32PrefixValAddr: "neutronvaloper",
      bech32PrefixValPub: "neutronvaloperpub",
      bech32PrefixConsAddr: "neutronvalcons",
      bech32PrefixConsPub: "neutronvalconspub"
    },
    chainName: "neutrontestnet",
    feeCurrencies: [
      {
        coinDenom: "ntrn",
        coinMinimalDenom: "untrn",
        coinDecimals: 6,
        gasPriceStep: {
          low: 53e-4,
          average: 53e-4,
          high: 53e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ntrn",
      coinMinimalDenom: "untrn",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "nibiru-testnet-1",
    currencies: [
      {
        coinDenom: "attonibi",
        coinMinimalDenom: "unibi",
        coinDecimals: 18
      }
    ],
    rest: "https://lcd.testnet-1.nibiru.fi",
    rpc: "https://rpc.testnet-1.nibiru.fi",
    bech32Config: {
      bech32PrefixAccAddr: "nibi",
      bech32PrefixAccPub: "nibipub",
      bech32PrefixValAddr: "nibivaloper",
      bech32PrefixValPub: "nibivaloperpub",
      bech32PrefixConsAddr: "nibivalcons",
      bech32PrefixConsPub: "nibivalconspub"
    },
    chainName: "nibirutestnet",
    feeCurrencies: [
      {
        coinDenom: "attonibi",
        coinMinimalDenom: "unibi",
        coinDecimals: 18,
        gasPriceStep: {
          low: 0.025,
          average: 0.05,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "attonibi",
      coinMinimalDenom: "unibi",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "nibiru-testnet-2",
    currencies: [
      {
        coinDenom: "attonibi",
        coinMinimalDenom: "unibi",
        coinDecimals: 18
      }
    ],
    rest: "https://lcd.testnet-2.nibiru.fi",
    rpc: "https://rpc.testnet-2.nibiru.fi",
    bech32Config: {
      bech32PrefixAccAddr: "nibi",
      bech32PrefixAccPub: "nibipub",
      bech32PrefixValAddr: "nibivaloper",
      bech32PrefixValPub: "nibivaloperpub",
      bech32PrefixConsAddr: "nibivalcons",
      bech32PrefixConsPub: "nibivalconspub"
    },
    chainName: "nibirutestnet2",
    feeCurrencies: [
      {
        coinDenom: "attonibi",
        coinMinimalDenom: "unibi",
        coinDecimals: 18,
        gasPriceStep: {
          low: 0.025,
          average: 0.05,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "attonibi",
      coinMinimalDenom: "unibi",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "nibiru-testnet-3",
    currencies: [
      {
        coinDenom: "attonibi",
        coinMinimalDenom: "unibi",
        coinDecimals: 18
      }
    ],
    rest: "https://lcd.testnet-3.nibiru.fi",
    rpc: "https://rpc.testnet-3.nibiru.fi",
    bech32Config: {
      bech32PrefixAccAddr: "nibi",
      bech32PrefixAccPub: "nibipub",
      bech32PrefixValAddr: "nibivaloper",
      bech32PrefixValPub: "nibivaloperpub",
      bech32PrefixConsAddr: "nibivalcons",
      bech32PrefixConsPub: "nibivalconspub"
    },
    chainName: "nibirutestnet3",
    feeCurrencies: [
      {
        coinDenom: "attonibi",
        coinMinimalDenom: "unibi",
        coinDecimals: 18,
        gasPriceStep: {
          low: 0.025,
          average: 0.05,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "attonibi",
      coinMinimalDenom: "unibi",
      coinDecimals: 18
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "nillion-chain-testnet-1",
    currencies: [
      {
        coinDenom: "nil",
        coinMinimalDenom: "unil",
        coinDecimals: 6
      }
    ],
    rest: "https://nillion-testnet-api.polkachu.com/",
    rpc: "https://nillion-testnet-rpc.polkachu.com/",
    bech32Config: {
      bech32PrefixAccAddr: "nillion",
      bech32PrefixAccPub: "nillionpub",
      bech32PrefixValAddr: "nillionvaloper",
      bech32PrefixValPub: "nillionvaloperpub",
      bech32PrefixConsAddr: "nillionvalcons",
      bech32PrefixConsPub: "nillionvalconspub"
    },
    chainName: "nilliontestnet",
    feeCurrencies: [
      {
        coinDenom: "nil",
        coinMinimalDenom: "unil",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-4,
          average: 1e-4,
          high: 25e-5
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "nil",
      coinMinimalDenom: "unil",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "grand-1",
    currencies: [
      {
        coinDenom: "stake",
        coinMinimalDenom: "ustake",
        coinDecimals: 6
      },
      {
        coinDenom: "love",
        coinMinimalDenom: "ulove",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "uusdc",
        coinDecimals: 6
      },
      {
        coinDenom: "usdy",
        coinMinimalDenom: "ausdy",
        coinDecimals: 18
      }
    ],
    rest: "https://noble-testnet-api.polkachu.com",
    rpc: "https://noble-testnet-rpc.polkachu.com",
    bech32Config: {
      bech32PrefixAccAddr: "noble",
      bech32PrefixAccPub: "noblepub",
      bech32PrefixValAddr: "noblevaloper",
      bech32PrefixValPub: "noblevaloperpub",
      bech32PrefixConsAddr: "noblevalcons",
      bech32PrefixConsPub: "noblevalconspub"
    },
    chainName: "nobletestnet",
    feeCurrencies: [
      {
        coinDenom: "usdc",
        coinMinimalDenom: "uusdc",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "stake",
      coinMinimalDenom: "ustake",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "nois-testnet-005",
    currencies: [
      {
        coinDenom: "nois",
        coinMinimalDenom: "unois",
        coinDecimals: 6
      }
    ],
    rest: "https://api.nois.mcbnode.online",
    rpc: "https://nois-testnet-rpc.polkachu.com",
    bech32Config: {
      bech32PrefixAccAddr: "nois",
      bech32PrefixAccPub: "noispub",
      bech32PrefixValAddr: "noisvaloper",
      bech32PrefixValPub: "noisvaloperpub",
      bech32PrefixConsAddr: "noisvalcons",
      bech32PrefixConsPub: "noisvalconspub"
    },
    chainName: "noistestnet",
    feeCurrencies: [
      {
        coinDenom: "nois",
        coinMinimalDenom: "unois",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.05,
          average: 0.05,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "nois",
      coinMinimalDenom: "unois",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "rila-1",
    currencies: [
      {
        coinDenom: "nls",
        coinMinimalDenom: "unls",
        coinDecimals: 6
      }
    ],
    rest: "https://rila-cl.nolus.network:1317",
    rpc: "https://rila-cl.nolus.network:26657",
    bech32Config: {
      bech32PrefixAccAddr: "nolus",
      bech32PrefixAccPub: "noluspub",
      bech32PrefixValAddr: "nolusvaloper",
      bech32PrefixValPub: "nolusvaloperpub",
      bech32PrefixConsAddr: "nolusvalcons",
      bech32PrefixConsPub: "nolusvalconspub"
    },
    chainName: "nolustestnet",
    feeCurrencies: [
      {
        coinDenom: "nls",
        coinMinimalDenom: "unls",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.05
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "nls",
      coinMinimalDenom: "unls",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "nomic-testnet-6",
    currencies: [
      {
        coinDenom: "nom",
        coinMinimalDenom: "unom",
        coinDecimals: 6
      },
      {
        coinDenom: "nbtc",
        coinMinimalDenom: "usat",
        coinDecimals: 14
      }
    ],
    rest: "https://testnet-api.nomic.io:8443",
    rpc: "https://testnet-rpc.nomic.io:2096",
    bech32Config: {
      bech32PrefixAccAddr: "nomic",
      bech32PrefixAccPub: "nomicpub",
      bech32PrefixValAddr: "nomicvaloper",
      bech32PrefixValPub: "nomicvaloperpub",
      bech32PrefixConsAddr: "nomicvalcons",
      bech32PrefixConsPub: "nomicvalconspub"
    },
    chainName: "nomictestnet",
    feeCurrencies: [
      {
        coinDenom: "nom",
        coinMinimalDenom: "unom",
        coinDecimals: 6
      },
      {
        coinDenom: "nbtc",
        coinMinimalDenom: "usat",
        coinDecimals: 14
      }
    ],
    stakeCurrency: {
      coinDenom: "nom",
      coinMinimalDenom: "unom",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "sandbox",
    currencies: [
      {
        coinDenom: "nyx",
        coinMinimalDenom: "unyx",
        coinDecimals: 6
      },
      {
        coinDenom: "nym",
        coinMinimalDenom: "unym",
        coinDecimals: 6
      }
    ],
    rest: "https://api.sandbox.nymtech.net",
    rpc: "https://rpc.sandbox.nymtech.net",
    bech32Config: {
      bech32PrefixAccAddr: "n",
      bech32PrefixAccPub: "npub",
      bech32PrefixValAddr: "nvaloper",
      bech32PrefixValPub: "nvaloperpub",
      bech32PrefixConsAddr: "nvalcons",
      bech32PrefixConsPub: "nvalconspub"
    },
    chainName: "nyxtestnet",
    feeCurrencies: [
      {
        coinDenom: "nym",
        coinMinimalDenom: "unym",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.04
        }
      },
      {
        coinDenom: "nyx",
        coinMinimalDenom: "unyx",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.025,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "nyx",
      coinMinimalDenom: "unyx",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "okp4-nemeton-1",
    currencies: [
      {
        coinDenom: "know",
        coinMinimalDenom: "uknow",
        coinDecimals: 6
      }
    ],
    rest: "https://okptest-lcd.quickapi.com",
    rpc: "https://api.testnet.okp4.network/rpc",
    bech32Config: {
      bech32PrefixAccAddr: "okp4",
      bech32PrefixAccPub: "okp4pub",
      bech32PrefixValAddr: "okp4valoper",
      bech32PrefixValPub: "okp4valoperpub",
      bech32PrefixConsAddr: "okp4valcons",
      bech32PrefixConsPub: "okp4valconspub"
    },
    chainName: "okp4testnet",
    feeCurrencies: [
      {
        coinDenom: "know",
        coinMinimalDenom: "uknow",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "know",
      coinMinimalDenom: "uknow",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "osmo-test-5",
    currencies: [
      {
        coinDenom: "osmo",
        coinMinimalDenom: "uosmo",
        coinDecimals: 6
      },
      {
        coinDenom: "ion",
        coinMinimalDenom: "uion",
        coinDecimals: 6
      },
      {
        coinDenom: "atom",
        coinMinimalDenom: "ibc/9FF2B7A5F55038A7EE61F4FD6749D9A648B48E89830F2682B67B5DC158E2753C",
        coinDecimals: 6
      },
      {
        coinDenom: "ausdc",
        coinMinimalDenom: "ibc/2164BDB48DE5501430E71286448D87C6D2240EC0E078CF113CAB85E21A352BB0",
        coinDecimals: 6
      },
      {
        coinDenom: "weth",
        coinMinimalDenom: "ibc/1F42AC9631DBE03009219ECCFE151786F53A038DE9F7A07C709158514F1D5942",
        coinDecimals: 18
      },
      {
        coinDenom: "junox",
        coinMinimalDenom: "ibc/31D220286E6C224C0F72D890D0EB75A228D388089EF5C4D77212344F9EAF0183",
        coinDecimals: 6
      },
      {
        coinDenom: "mars",
        coinMinimalDenom: "ibc/66A7ADA623D33D0B66C6890FE3E1AF3D638D56CE2B56F8BDA210B2AA62016216",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/DE6792CF9E521F6AD6E9A4BDF6225C9571A3B74ACC0A529F92BC5122A39D2E58",
        coinDecimals: 6
      },
      {
        coinDenom: "akt",
        coinMinimalDenom: "ibc/AD59D59CFB0E628E73C798415F823AB5B6257C2FE4BF67DBB5D6A677B2686E82",
        coinDecimals: 6
      },
      {
        coinDenom: "kyve",
        coinMinimalDenom: "ibc/AB8AF05799E299FB5C5C80781DA35887F53E029745D20E5641233DB4E6B28515",
        coinDecimals: 6
      },
      {
        coinDenom: "qck",
        coinMinimalDenom: "ibc/F37CF69589DE12342758382F8770C0852CD8D2E4519F55166EBDAF472AD667C9",
        coinDecimals: 6
      },
      {
        coinDenom: "c4e",
        coinMinimalDenom: "ibc/E3D323CB6F427C49E56F913C853A416F6B71BAA9B0164625AD0203266F92B3ED",
        coinDecimals: 6
      },
      {
        coinDenom: "xprt",
        coinMinimalDenom: "ibc/754C8533F8A418B03AD5F2C6AA19D4703CF78BBAB9E2E4DDD6212AAC2E502CA6",
        coinDecimals: 6
      },
      {
        coinDenom: "XION",
        coinMinimalDenom: "ibc/3642669AD14386D3E38F43F30CFCA859B3E8A05BF6BD6A23DEBD2115AD1325E9",
        coinDecimals: 6
      },
      {
        coinDenom: "tsaga",
        coinMinimalDenom: "ibc/48384130079A5987378F5776775F8C29A02505273E777BBB99361F2BB5B577C9",
        coinDecimals: 6
      },
      {
        coinDenom: "ixo",
        coinMinimalDenom: "ibc/88C815D69587CF0F05E96E5E2731EA56194D73C9A02A500095294D3A5DE68F16",
        coinDecimals: 6
      },
      {
        coinDenom: "willyz",
        coinMinimalDenom: "factory/osmo1zlkzu72774ynac53necz46u4ycqtp36wedrar0/willyz",
        coinDecimals: 6
      },
      {
        coinDenom: "amATOM",
        coinMinimalDenom: "ibc/C86B92F7FCFC1993DAC4AB0D78D9BC080300354B823A57F12CD6E2FBB667214E",
        coinDecimals: 6
      },
      {
        coinDenom: "tkx",
        coinMinimalDenom: "ibc/28EEF762052DB8C3D27A7BF625E9F86A1B3B689CC8D80C818CEDF2EB6CBA02A6",
        coinDecimals: 18
      }
    ],
    rest: "https://lcd.osmotest5.osmosis.zone/",
    rpc: "https://rpc.osmotest5.osmosis.zone/",
    bech32Config: {
      bech32PrefixAccAddr: "osmo",
      bech32PrefixAccPub: "osmopub",
      bech32PrefixValAddr: "osmovaloper",
      bech32PrefixValPub: "osmovaloperpub",
      bech32PrefixConsAddr: "osmovalcons",
      bech32PrefixConsPub: "osmovalconspub"
    },
    chainName: "osmosistestnet",
    feeCurrencies: [
      {
        coinDenom: "osmo",
        coinMinimalDenom: "uosmo",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "osmo",
      coinMinimalDenom: "uosmo",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "osmo-test-4",
    currencies: [
      {
        coinDenom: "osmo",
        coinMinimalDenom: "uosmo",
        coinDecimals: 6
      },
      {
        coinDenom: "ion",
        coinMinimalDenom: "uion",
        coinDecimals: 6
      }
    ],
    rest: "https://osmosistest-lcd.quickapi.com/",
    rpc: "https://rpc.osmo-test.ccvalidators.com/",
    bech32Config: {
      bech32PrefixAccAddr: "osmo",
      bech32PrefixAccPub: "osmopub",
      bech32PrefixValAddr: "osmovaloper",
      bech32PrefixValPub: "osmovaloperpub",
      bech32PrefixConsAddr: "osmovalcons",
      bech32PrefixConsPub: "osmovalconspub"
    },
    chainName: "osmosistestnet4",
    feeCurrencies: [
      {
        coinDenom: "osmo",
        coinMinimalDenom: "uosmo",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "osmo",
      coinMinimalDenom: "uosmo",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "INVALID-ID-permtestnet-testnet-1",
    currencies: [
      {
        coinDenom: "perm",
        coinMinimalDenom: "uperm",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.3.finance/",
    rpc: "https://rpc.3.finance/",
    bech32Config: {
      bech32PrefixAccAddr: "perm",
      bech32PrefixAccPub: "permpub",
      bech32PrefixValAddr: "permvaloper",
      bech32PrefixValPub: "permvaloperpub",
      bech32PrefixConsAddr: "permvalcons",
      bech32PrefixConsPub: "permvalconspub"
    },
    chainName: "permtestnet",
    feeCurrencies: [
      {
        coinDenom: "perm",
        coinMinimalDenom: "uperm",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 25e-4,
          high: 24e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "perm",
      coinMinimalDenom: "uperm",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "test-core-1",
    currencies: [
      {
        coinDenom: "xprt",
        coinMinimalDenom: "uxprt",
        coinDecimals: 6
      },
      {
        coinDenom: "stkatom",
        coinMinimalDenom: "stk/uatom",
        coinDecimals: 6
      }
    ],
    rest: "https://rest-testnet-persistence.architectnodes.com/",
    rpc: "https://rpc-testnet-persistence.architectnodes.com/",
    bech32Config: {
      bech32PrefixAccAddr: "persistence",
      bech32PrefixAccPub: "persistencepub",
      bech32PrefixValAddr: "persistencevaloper",
      bech32PrefixValPub: "persistencevaloperpub",
      bech32PrefixConsAddr: "persistencevalcons",
      bech32PrefixConsPub: "persistencevalconspub"
    },
    chainName: "persistencetestnet",
    feeCurrencies: [
      {
        coinDenom: "xprt",
        coinMinimalDenom: "uxprt",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.05,
          average: 0.125,
          high: 0.2
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "xprt",
      coinMinimalDenom: "uxprt",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "test-core-2",
    currencies: [
      {
        coinDenom: "xprt",
        coinMinimalDenom: "uxprt",
        coinDecimals: 6
      },
      {
        coinDenom: "stkatom",
        coinMinimalDenom: "stk/uatom",
        coinDecimals: 6
      },
      {
        coinDenom: "stkosmo",
        coinMinimalDenom: "stk/uosmo",
        coinDecimals: 6
      },
      {
        coinDenom: "stkdv4tnt",
        coinMinimalDenom: "stk/adv4tnt",
        coinDecimals: 18
      }
    ],
    rest: "https://api-persistence-testnet-01.stakeflow.io/",
    rpc: "https://rpc-persistence-testnet-01.stakeflow.io/",
    bech32Config: {
      bech32PrefixAccAddr: "persistence",
      bech32PrefixAccPub: "persistencepub",
      bech32PrefixValAddr: "persistencevaloper",
      bech32PrefixValPub: "persistencevaloperpub",
      bech32PrefixConsAddr: "persistencevalcons",
      bech32PrefixConsPub: "persistencevalconspub"
    },
    chainName: "persistencetestnet2",
    feeCurrencies: [
      {
        coinDenom: "xprt",
        coinMinimalDenom: "uxprt",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.05,
          average: 0.125,
          high: 0.2
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "xprt",
      coinMinimalDenom: "uxprt",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "planq_7077-1",
    currencies: [
      {
        coinDenom: "tplanq",
        coinMinimalDenom: "atplanq",
        coinDecimals: 18
      }
    ],
    rest: "https://rest-atlas.planq.network",
    rpc: "https://rpc-atlas.planq.network",
    bech32Config: {
      bech32PrefixAccAddr: "plq",
      bech32PrefixAccPub: "plqpub",
      bech32PrefixValAddr: "plqvaloper",
      bech32PrefixValPub: "plqvaloperpub",
      bech32PrefixConsAddr: "plqvalcons",
      bech32PrefixConsPub: "plqvalconspub"
    },
    chainName: "planqtestnet",
    feeCurrencies: [
      {
        coinDenom: "tplanq",
        coinMinimalDenom: "atplanq",
        coinDecimals: 18,
        gasPriceStep: {
          low: 3e10,
          average: 35e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tplanq",
      coinMinimalDenom: "atplanq",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "indigo-1",
    currencies: [
      {
        coinDenom: "pryzm",
        coinMinimalDenom: "upryzm",
        coinDecimals: 6
      }
    ],
    rest: "https://testnet-api.pryzm.zone",
    rpc: "https://testnet-rpc.pryzm.zone",
    bech32Config: {
      bech32PrefixAccAddr: "pryzm",
      bech32PrefixAccPub: "pryzmpub",
      bech32PrefixValAddr: "pryzmvaloper",
      bech32PrefixValPub: "pryzmvaloperpub",
      bech32PrefixConsAddr: "pryzmvalcons",
      bech32PrefixConsPub: "pryzmvalconspub"
    },
    chainName: "pryzmtestnet",
    feeCurrencies: [
      {
        coinDenom: "pryzm",
        coinMinimalDenom: "upryzm",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.015,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "pryzm",
      coinMinimalDenom: "upryzm",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "quasar-test-1",
    currencies: [
      {
        coinDenom: "qsr",
        coinMinimalDenom: "uqsr",
        coinDecimals: 6
      },
      {
        coinDenom: "ayy",
        coinMinimalDenom: "uayy",
        coinDecimals: 6
      },
      {
        coinDenom: "oro",
        coinMinimalDenom: "uoro",
        coinDecimals: 6
      }
    ],
    rest: "https://quasar-testnet-api.polkachu.com/",
    rpc: "https://quasar-testnet-rpc.polkachu.com/",
    bech32Config: {
      bech32PrefixAccAddr: "quasar",
      bech32PrefixAccPub: "quasarpub",
      bech32PrefixValAddr: "quasarvaloper",
      bech32PrefixValPub: "quasarvaloperpub",
      bech32PrefixConsAddr: "quasarvalcons",
      bech32PrefixConsPub: "quasarvalconspub"
    },
    chainName: "quasartestnet",
    feeCurrencies: [
      {
        coinDenom: "qsr",
        coinMinimalDenom: "uqsr",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "qsr",
      coinMinimalDenom: "uqsr",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "rhye-2",
    currencies: [
      {
        coinDenom: "qck",
        coinMinimalDenom: "uqck",
        coinDecimals: 6
      }
    ],
    rest: "https://quick.api.t.stavr.tech",
    rpc: "http://quick.rpc.t.stavr.tech:20027",
    bech32Config: {
      bech32PrefixAccAddr: "quick",
      bech32PrefixAccPub: "quickpub",
      bech32PrefixValAddr: "quickvaloper",
      bech32PrefixValPub: "quickvaloperpub",
      bech32PrefixConsAddr: "quickvalcons",
      bech32PrefixConsPub: "quickvalconspub"
    },
    chainName: "quicksilvertestnet",
    feeCurrencies: [
      {
        coinDenom: "qck",
        coinMinimalDenom: "uqck",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1e-4,
          average: 1e-4,
          high: 25e-5
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "qck",
      coinMinimalDenom: "uqck",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "earendel-1",
    currencies: [
      {
        coinDenom: "qwoyn",
        coinMinimalDenom: "uqwoyn",
        coinDecimals: 6
      }
    ],
    rest: "https://testnet-api.qwoyn.studio",
    rpc: "https://testnet-rpc.qwoyn.studio",
    bech32Config: {
      bech32PrefixAccAddr: "qwoyn",
      bech32PrefixAccPub: "qwoynpub",
      bech32PrefixValAddr: "qwoynvaloper",
      bech32PrefixValPub: "qwoynvaloperpub",
      bech32PrefixConsAddr: "qwoynvalcons",
      bech32PrefixConsPub: "qwoynvalconspub"
    },
    chainName: "qwoyntestnet",
    feeCurrencies: [
      {
        coinDenom: "qwoyn",
        coinMinimalDenom: "uqwoyn",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "qwoyn",
      coinMinimalDenom: "uqwoyn",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "ssc-testnet-1",
    currencies: [
      {
        coinDenom: "tsaga",
        coinMinimalDenom: "utsaga",
        coinDecimals: 6
      }
    ],
    rest: "https://testnet-ssc-lcd.sagarpc.io/",
    rpc: "https://testnet-ssc.sagarpc.io/",
    bech32Config: {
      bech32PrefixAccAddr: "saga",
      bech32PrefixAccPub: "sagapub",
      bech32PrefixValAddr: "sagavaloper",
      bech32PrefixValPub: "sagavaloperpub",
      bech32PrefixConsAddr: "sagavalcons",
      bech32PrefixConsPub: "sagavalconspub"
    },
    chainName: "sagatestnet",
    feeCurrencies: [
      {
        coinDenom: "tsaga",
        coinMinimalDenom: "utsaga",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tsaga",
      coinMinimalDenom: "utsaga",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "pulsar-3",
    currencies: [
      {
        coinDenom: "scrt",
        coinMinimalDenom: "uscrt",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.testnet.secretsaturn.net",
    rpc: "https://rpc.testnet.secretsaturn.net",
    bech32Config: {
      bech32PrefixAccAddr: "secret",
      bech32PrefixAccPub: "secretpub",
      bech32PrefixValAddr: "secretvaloper",
      bech32PrefixValPub: "secretvaloperpub",
      bech32PrefixConsAddr: "secretvalcons",
      bech32PrefixConsPub: "secretvalconspub"
    },
    chainName: "secretnetworktestnet",
    feeCurrencies: [
      {
        coinDenom: "scrt",
        coinMinimalDenom: "uscrt",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "scrt",
      coinMinimalDenom: "uscrt",
      coinDecimals: 6
    },
    bip44: {
      coinType: 529
    }
  },
  {
    chainId: "pulsar-2",
    currencies: [
      {
        coinDenom: "scrt",
        coinMinimalDenom: "uscrt",
        coinDecimals: 6
      }
    ],
    rest: "http://testnet.securesecrets.org:1317",
    rpc: "https://rpc.testnet.secretsaturn.net",
    bech32Config: {
      bech32PrefixAccAddr: "secret",
      bech32PrefixAccPub: "secretpub",
      bech32PrefixValAddr: "secretvaloper",
      bech32PrefixValPub: "secretvaloperpub",
      bech32PrefixConsAddr: "secretvalcons",
      bech32PrefixConsPub: "secretvalconspub"
    },
    chainName: "secretnetworktestnet2",
    feeCurrencies: [
      {
        coinDenom: "scrt",
        coinMinimalDenom: "uscrt",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "scrt",
      coinMinimalDenom: "uscrt",
      coinDecimals: 6
    },
    bip44: {
      coinType: 529
    }
  },
  {
    chainId: "atlantic-1",
    currencies: [
      {
        coinDenom: "sei",
        coinMinimalDenom: "usei",
        coinDecimals: 6
      }
    ],
    rest: "https://sei-testnet-rest.brocha.in",
    rpc: "https://sei-testnet-rpc.brocha.in",
    bech32Config: {
      bech32PrefixAccAddr: "sei",
      bech32PrefixAccPub: "seipub",
      bech32PrefixValAddr: "seivaloper",
      bech32PrefixValPub: "seivaloperpub",
      bech32PrefixConsAddr: "seivalcons",
      bech32PrefixConsPub: "seivalconspub"
    },
    chainName: "seitestnet",
    feeCurrencies: [
      {
        coinDenom: "sei",
        coinMinimalDenom: "usei",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "sei",
      coinMinimalDenom: "usei",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "atlantic-2",
    currencies: [
      {
        coinDenom: "sei",
        coinMinimalDenom: "usei",
        coinDecimals: 6
      }
    ],
    rest: "https://sei-testnet-2-rest.brocha.in",
    rpc: "https://sei-testnet-2-rpc.brocha.in",
    bech32Config: {
      bech32PrefixAccAddr: "sei",
      bech32PrefixAccPub: "seipub",
      bech32PrefixValAddr: "seivaloper",
      bech32PrefixValPub: "seivaloperpub",
      bech32PrefixConsAddr: "seivalcons",
      bech32PrefixConsPub: "seivalconspub"
    },
    chainName: "seitestnet2",
    feeCurrencies: [
      {
        coinDenom: "sei",
        coinMinimalDenom: "usei",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "sei",
      coinMinimalDenom: "usei",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "self-dev-1",
    currencies: [
      {
        coinDenom: "self",
        coinMinimalDenom: "uself",
        coinDecimals: 6
      }
    ],
    rest: "https://api-devnet.selfchain.xyz/",
    rpc: "https://rpc-devnet.selfchain.xyz",
    bech32Config: {
      bech32PrefixAccAddr: "self",
      bech32PrefixAccPub: "selfpub",
      bech32PrefixValAddr: "selfvaloper",
      bech32PrefixValPub: "selfvaloperpub",
      bech32PrefixConsAddr: "selfvalcons",
      bech32PrefixConsPub: "selfvalconspub"
    },
    chainName: "selfchaindevnet",
    feeCurrencies: [
      {
        coinDenom: "self",
        coinMinimalDenom: "uself",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "self",
      coinMinimalDenom: "uself",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "sge-network-3",
    currencies: [
      {
        coinDenom: "sge",
        coinMinimalDenom: "usge",
        coinDecimals: 6
      }
    ],
    rest: "https://api.testnet.sgenetwork.io",
    rpc: "https://rpc.testnet.sgenetwork.io",
    bech32Config: {
      bech32PrefixAccAddr: "sge",
      bech32PrefixAccPub: "sgepub",
      bech32PrefixValAddr: "sgevaloper",
      bech32PrefixValPub: "sgevaloperpub",
      bech32PrefixConsAddr: "sgevalcons",
      bech32PrefixConsPub: "sgevalconspub"
    },
    chainName: "sgetestnet",
    feeCurrencies: [
      {
        coinDenom: "sge",
        coinMinimalDenom: "usge",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "sge",
      coinMinimalDenom: "usge",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "sge-network-4",
    currencies: [
      {
        coinDenom: "sge",
        coinMinimalDenom: "usge",
        coinDecimals: 6
      }
    ],
    rest: "https://api.testnet.sgenetwork.io",
    rpc: "https://rpc.testnet.sgenetwork.io",
    bech32Config: {
      bech32PrefixAccAddr: "sge",
      bech32PrefixAccPub: "sgepub",
      bech32PrefixValAddr: "sgevaloper",
      bech32PrefixValPub: "sgevaloperpub",
      bech32PrefixConsAddr: "sgevalcons",
      bech32PrefixConsPub: "sgevalconspub"
    },
    chainName: "sgetestnet4",
    feeCurrencies: [
      {
        coinDenom: "sge",
        coinMinimalDenom: "usge",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "sge",
      coinMinimalDenom: "usge",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "yulei-2.1",
    currencies: [
      {
        coinDenom: "ctk",
        coinMinimalDenom: "uctk",
        coinDecimals: 6
      }
    ],
    rest: "https://yulei-rest.shentu.org/",
    rpc: "https://yulei-rpc.shentu.org:443",
    bech32Config: {
      bech32PrefixAccAddr: "shentu",
      bech32PrefixAccPub: "shentupub",
      bech32PrefixValAddr: "shentuvaloper",
      bech32PrefixValPub: "shentuvaloperpub",
      bech32PrefixConsAddr: "shentuvalcons",
      bech32PrefixConsPub: "shentuvalconspub"
    },
    chainName: "shentutestnet",
    feeCurrencies: [
      {
        coinDenom: "ctk",
        coinMinimalDenom: "uctk",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ctk",
      coinMinimalDenom: "uctk",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "fivenet",
    currencies: [
      {
        coinDenom: "six",
        coinMinimalDenom: "usix",
        coinDecimals: 6
      }
    ],
    rest: "https://api1.fivenet.sixprotocol.net:443",
    rpc: "https://rpc1.fivenet.sixprotocol.net:443",
    bech32Config: {
      bech32PrefixAccAddr: "6x",
      bech32PrefixAccPub: "6xpub",
      bech32PrefixValAddr: "6xvaloper",
      bech32PrefixValPub: "6xvaloperpub",
      bech32PrefixConsAddr: "6xvalcons",
      bech32PrefixConsPub: "6xvalconspub"
    },
    chainName: "sixtestnet",
    feeCurrencies: [
      {
        coinDenom: "six",
        coinMinimalDenom: "usix",
        coinDecimals: 6,
        gasPriceStep: {
          low: 1.25,
          average: 1.5,
          high: 1.75
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "six",
      coinMinimalDenom: "usix",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "soarchaintestnet",
    currencies: [
      {
        coinDenom: "tsoar",
        coinMinimalDenom: "utsoar",
        coinDecimals: 6
      }
    ],
    rest: "https://api.testnet.soarchain.com/",
    rpc: "https://rpc1.testnet.soarchain.com",
    bech32Config: {
      bech32PrefixAccAddr: "soar",
      bech32PrefixAccPub: "soarpub",
      bech32PrefixValAddr: "soarvaloper",
      bech32PrefixValPub: "soarvaloperpub",
      bech32PrefixConsAddr: "soarvalcons",
      bech32PrefixConsPub: "soarvalconspub"
    },
    chainName: "soarchaintestnet",
    feeCurrencies: [
      {
        coinDenom: "tsoar",
        coinMinimalDenom: "utsoar",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.02,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tsoar",
      coinMinimalDenom: "utsoar",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "sourcetest-1",
    currencies: [
      {
        coinDenom: "source",
        coinMinimalDenom: "usource",
        coinDecimals: 6
      }
    ],
    rest: "https://source-testnet-api.itrocket.net/",
    rpc: "https://source-testnet-rpc.itrocket.net/",
    bech32Config: {
      bech32PrefixAccAddr: "source",
      bech32PrefixAccPub: "sourcepub",
      bech32PrefixValAddr: "sourcevaloper",
      bech32PrefixValPub: "sourcevaloperpub",
      bech32PrefixConsAddr: "sourcevalcons",
      bech32PrefixConsPub: "sourcevalconspub"
    },
    chainName: "sourcetestnet",
    feeCurrencies: [
      {
        coinDenom: "source",
        coinMinimalDenom: "usource",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.05,
          average: 0.075,
          high: 0.1
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "source",
      coinMinimalDenom: "usource",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "elgafar-1",
    currencies: [
      {
        coinDenom: "stars",
        coinMinimalDenom: "ustars",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.elgafar-1.stargaze-apis.com",
    rpc: "https://rpc.elgafar-1.stargaze-apis.com",
    bech32Config: {
      bech32PrefixAccAddr: "stars",
      bech32PrefixAccPub: "starspub",
      bech32PrefixValAddr: "starsvaloper",
      bech32PrefixValPub: "starsvaloperpub",
      bech32PrefixConsAddr: "starsvalcons",
      bech32PrefixConsPub: "starsvalconspub"
    },
    chainName: "stargazetestnet",
    feeCurrencies: [
      {
        coinDenom: "stars",
        coinMinimalDenom: "ustars",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.03,
          average: 0.04,
          high: 0.05
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "stars",
      coinMinimalDenom: "ustars",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "stateset-1-testnet",
    currencies: [
      {
        coinDenom: "state",
        coinMinimalDenom: "ustate",
        coinDecimals: 6
      }
    ],
    rest: "https://rest-api.stateset.zone",
    rpc: "https://rpc.stateset.zone/",
    bech32Config: {
      bech32PrefixAccAddr: "stateset",
      bech32PrefixAccPub: "statesetpub",
      bech32PrefixValAddr: "statesetvaloper",
      bech32PrefixValPub: "statesetvaloperpub",
      bech32PrefixConsAddr: "statesetvalcons",
      bech32PrefixConsPub: "statesetvalconspub"
    },
    chainName: "statesettestnet",
    feeCurrencies: [
      {
        coinDenom: "state",
        coinMinimalDenom: "ustate",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "state",
      coinMinimalDenom: "ustate",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "stride-internal-1",
    currencies: [
      {
        coinDenom: "strd",
        coinMinimalDenom: "ustrd",
        coinDecimals: 6
      },
      {
        coinDenom: "stTIA",
        coinMinimalDenom: "stutia",
        coinDecimals: 6
      },
      {
        coinDenom: "stDV4TNT",
        coinMinimalDenom: "stadv4tnt",
        coinDecimals: 18
      },
      {
        coinDenom: "TIA",
        coinMinimalDenom: "ibc/1A7653323C1A9E267FF7BEBF40B3EEA8065E8F069F47F2493ABC3E0B621BF793",
        coinDecimals: 6
      },
      {
        coinDenom: "DV4TNT",
        coinMinimalDenom: "ibc/DFA22C0A6DD15E64B6BD164A1C748EDA8E976F3BDAC9BA7B40AD887BBEC5D2BB",
        coinDecimals: 6
      }
    ],
    rest: "https://stride.testnet-1.stridenet.co/api",
    rpc: "https://stride.testnet-1.stridenet.co",
    bech32Config: {
      bech32PrefixAccAddr: "stride",
      bech32PrefixAccPub: "stridepub",
      bech32PrefixValAddr: "stridevaloper",
      bech32PrefixValPub: "stridevaloperpub",
      bech32PrefixConsAddr: "stridevalcons",
      bech32PrefixConsPub: "stridevalconspub"
    },
    chainName: "stridetestnet",
    feeCurrencies: [
      {
        coinDenom: "strd",
        coinMinimalDenom: "ustrd",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "strd",
      coinMinimalDenom: "ustrd",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "sunrise-test-0.1",
    currencies: [
      {
        coinDenom: "vrise",
        coinMinimalDenom: "uvrise",
        coinDecimals: 6
      },
      {
        coinDenom: "rise",
        coinMinimalDenom: "urise",
        coinDecimals: 6
      }
    ],
    rest: "https://a-node.sunrise-test-1.cauchye.net:1318",
    rpc: "https://a-node.sunrise-test-1.cauchye.net/",
    bech32Config: {
      bech32PrefixAccAddr: "sunrise",
      bech32PrefixAccPub: "sunrisepub",
      bech32PrefixValAddr: "sunrisevaloper",
      bech32PrefixValPub: "sunrisevaloperpub",
      bech32PrefixConsAddr: "sunrisevalcons",
      bech32PrefixConsPub: "sunrisevalconspub"
    },
    chainName: "sunrisetestnet",
    feeCurrencies: [
      {
        coinDenom: "rise",
        coinMinimalDenom: "urise",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "vrise",
      coinMinimalDenom: "uvrise",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "swisstronik_1291-1",
    currencies: [
      {
        coinDenom: "swtr",
        coinMinimalDenom: "aswtr",
        coinDecimals: 18
      }
    ],
    rest: "https://api.testnet.swisstronik.com",
    rpc: "https://rpc.testnet.swisstronik.com",
    bech32Config: {
      bech32PrefixAccAddr: "swtr",
      bech32PrefixAccPub: "swtrpub",
      bech32PrefixValAddr: "swtrvaloper",
      bech32PrefixValPub: "swtrvaloperpub",
      bech32PrefixConsAddr: "swtrvalcons",
      bech32PrefixConsPub: "swtrvalconspub"
    },
    chainName: "swisstroniktestnet",
    feeCurrencies: [
      {
        coinDenom: "swtr",
        coinMinimalDenom: "aswtr",
        coinDecimals: 18
      }
    ],
    stakeCurrency: {
      coinDenom: "swtr",
      coinMinimalDenom: "aswtr",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "symphony-testnet-3",
    currencies: [
      {
        coinDenom: "mld",
        coinMinimalDenom: "note",
        coinDecimals: 6
      },
      {
        coinDenom: "husd",
        coinMinimalDenom: "uusd",
        coinDecimals: 6
      },
      {
        coinDenom: "hkhd",
        coinMinimalDenom: "ukhd",
        coinDecimals: 6
      },
      {
        coinDenom: "hvnd",
        coinMinimalDenom: "uvnd",
        coinDecimals: 6
      }
    ],
    rest: "https://symphony.test.api.nodeshub.online/",
    rpc: "https://symphony.test.rpc.nodeshub.online/",
    bech32Config: {
      bech32PrefixAccAddr: "symphony",
      bech32PrefixAccPub: "symphonypub",
      bech32PrefixValAddr: "symphonyvaloper",
      bech32PrefixValPub: "symphonyvaloperpub",
      bech32PrefixConsAddr: "symphonyvalcons",
      bech32PrefixConsPub: "symphonyvalconspub"
    },
    chainName: "symphonytestnet",
    feeCurrencies: [
      {
        coinDenom: "mld",
        coinMinimalDenom: "note",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "mld",
      coinMinimalDenom: "note",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "amber-2",
    currencies: [
      {
        coinDenom: "AMBER",
        coinMinimalDenom: "uamber",
        coinDecimals: 6
      }
    ],
    rest: "https://api-testnet.synternet.com/",
    rpc: "https://rpc-testnet.synternet.com/",
    bech32Config: {
      bech32PrefixAccAddr: "amber",
      bech32PrefixAccPub: "amberpub",
      bech32PrefixValAddr: "ambervaloper",
      bech32PrefixValPub: "ambervaloperpub",
      bech32PrefixConsAddr: "ambervalcons",
      bech32PrefixConsPub: "ambervalconspub"
    },
    chainName: "synternettestnet",
    feeCurrencies: [
      {
        coinDenom: "AMBER",
        coinMinimalDenom: "uamber",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "AMBER",
      coinMinimalDenom: "uamber",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "temporal-test-2",
    currencies: [
      {
        coinDenom: "tprl",
        coinMinimalDenom: "utprl",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.yieldmos.com/temporal-test-2",
    rpc: "https://rpc.yieldmos.com/temporal-test-2",
    bech32Config: {
      bech32PrefixAccAddr: "temporal",
      bech32PrefixAccPub: "temporalpub",
      bech32PrefixValAddr: "temporalvaloper",
      bech32PrefixValPub: "temporalvaloperpub",
      bech32PrefixConsAddr: "temporalvalcons",
      bech32PrefixConsPub: "temporalvalconspub"
    },
    chainName: "temporaltestnet",
    feeCurrencies: [
      {
        coinDenom: "tprl",
        coinMinimalDenom: "utprl",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "tprl",
      coinMinimalDenom: "utprl",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "90u-4",
    currencies: [
      {
        coinDenom: "terpx",
        coinMinimalDenom: "uterpx",
        coinDecimals: 6
      },
      {
        coinDenom: "thiolx",
        coinMinimalDenom: "uthiolx",
        coinDecimals: 6
      }
    ],
    rest: "https://testnet-api.terp.network:443/",
    rpc: "https://testnet-rpc.terp.network:443/",
    bech32Config: {
      bech32PrefixAccAddr: "terp",
      bech32PrefixAccPub: "terppub",
      bech32PrefixValAddr: "terpvaloper",
      bech32PrefixValPub: "terpvaloperpub",
      bech32PrefixConsAddr: "terpvalcons",
      bech32PrefixConsPub: "terpvalconspub"
    },
    chainName: "terpnettestnet",
    feeCurrencies: [
      {
        coinDenom: "thiolx",
        coinMinimalDenom: "uthiolx",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.75,
          average: 1,
          high: 1.25
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "terpx",
      coinMinimalDenom: "uterpx",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "90u-2",
    currencies: [
      {
        coinDenom: "terpx",
        coinMinimalDenom: "uterpx",
        coinDecimals: 6
      },
      {
        coinDenom: "thiolx",
        coinMinimalDenom: "uthiolx",
        coinDecimals: 6
      }
    ],
    rest: "https://terp-testnet-api.itrocket.net:443/",
    rpc: "https://terp-testnet-rpc.itrocket.net:443/",
    bech32Config: {
      bech32PrefixAccAddr: "terp",
      bech32PrefixAccPub: "terppub",
      bech32PrefixValAddr: "terpvaloper",
      bech32PrefixValPub: "terpvaloperpub",
      bech32PrefixConsAddr: "terpvalcons",
      bech32PrefixConsPub: "terpvalconspub"
    },
    chainName: "terpnettestnet2",
    feeCurrencies: [
      {
        coinDenom: "thiolx",
        coinMinimalDenom: "uthiolx",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.75,
          average: 1,
          high: 1.25
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "terpx",
      coinMinimalDenom: "uterpx",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "pisco-1",
    currencies: [
      {
        coinDenom: "luna",
        coinMinimalDenom: "uluna",
        coinDecimals: 6
      }
    ],
    rest: "https://pisco-lcd.terra.dev:443",
    rpc: "https://pisco-rpc.terra.dev:443",
    bech32Config: {
      bech32PrefixAccAddr: "terra",
      bech32PrefixAccPub: "terrapub",
      bech32PrefixValAddr: "terravaloper",
      bech32PrefixValPub: "terravaloperpub",
      bech32PrefixConsAddr: "terravalcons",
      bech32PrefixConsPub: "terravalconspub"
    },
    chainName: "terra2testnet",
    feeCurrencies: [
      {
        coinDenom: "luna",
        coinMinimalDenom: "uluna",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.0125,
          average: 0.015,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "luna",
      coinMinimalDenom: "uluna",
      coinDecimals: 6
    },
    bip44: {
      coinType: 330
    }
  },
  {
    chainId: "titan_18889-1",
    currencies: [
      {
        coinDenom: "tkx",
        coinMinimalDenom: "atkx",
        coinDecimals: 18
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/7C0807A56073C4A27B0DE1C21BA3EB75DF75FD763F4AD37BC159917FC01145F0",
        coinDecimals: 6
      }
    ],
    rest: "https://titan-testnet-lcd.titanlab.io:443",
    rpc: "https://titan-testnet-rpc.titanlab.io:443",
    bech32Config: {
      bech32PrefixAccAddr: "titan",
      bech32PrefixAccPub: "titanpub",
      bech32PrefixValAddr: "titanvaloper",
      bech32PrefixValPub: "titanvaloperpub",
      bech32PrefixConsAddr: "titanvalcons",
      bech32PrefixConsPub: "titanvalconspub"
    },
    chainName: "titantestnet",
    feeCurrencies: [
      {
        coinDenom: "tkx",
        coinMinimalDenom: "atkx",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e11,
          average: 11e10,
          high: 2e11
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tkx",
      coinMinimalDenom: "atkx",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "tucana_712-1",
    currencies: [
      {
        coinDenom: "tuc",
        coinMinimalDenom: "atuc",
        coinDecimals: 18
      }
    ],
    rest: "https://lcd.birdee-2.tucana.zone/",
    rpc: "https://rpc.birdee-2.tucana.zone/",
    bech32Config: {
      bech32PrefixAccAddr: "tuc",
      bech32PrefixAccPub: "tucpub",
      bech32PrefixValAddr: "tucvaloper",
      bech32PrefixValPub: "tucvaloperpub",
      bech32PrefixConsAddr: "tucvalcons",
      bech32PrefixConsPub: "tucvalconspub"
    },
    chainName: "tucanatestnet",
    feeCurrencies: [
      {
        coinDenom: "tuc",
        coinMinimalDenom: "atuc",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e10,
          average: 25e9,
          high: 3e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tuc",
      coinMinimalDenom: "atuc",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "FUND-TestNet-2",
    currencies: [
      {
        coinDenom: "FUND",
        coinMinimalDenom: "nund",
        coinDecimals: 9
      }
    ],
    rest: "https://rest-testnet.unification.io",
    rpc: "https://rpc-testnet.unification.io:443",
    bech32Config: {
      bech32PrefixAccAddr: "und",
      bech32PrefixAccPub: "undpub",
      bech32PrefixValAddr: "undvaloper",
      bech32PrefixValPub: "undvaloperpub",
      bech32PrefixConsAddr: "undvalcons",
      bech32PrefixConsPub: "undvalconspub"
    },
    chainName: "unificationtestnet",
    feeCurrencies: [
      {
        coinDenom: "FUND",
        coinMinimalDenom: "nund",
        coinDecimals: 9,
        gasPriceStep: {
          low: 100,
          average: 200,
          high: 300
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "FUND",
      coinMinimalDenom: "nund",
      coinDecimals: 9
    },
    bip44: {
      coinType: 5555
    }
  },
  {
    chainId: "union-testnet-8",
    currencies: [
      {
        coinDenom: "uno",
        coinMinimalDenom: "muno",
        coinDecimals: 6
      }
    ],
    rest: "https://rest.testnet-8.union.build",
    rpc: "https://rpc.testnet-8.union.build",
    bech32Config: {
      bech32PrefixAccAddr: "union",
      bech32PrefixAccPub: "unionpub",
      bech32PrefixValAddr: "unionvaloper",
      bech32PrefixValPub: "unionvaloperpub",
      bech32PrefixConsAddr: "unionvalcons",
      bech32PrefixConsPub: "unionvalconspub"
    },
    chainName: "uniontestnet",
    feeCurrencies: [
      {
        coinDenom: "uno",
        coinMinimalDenom: "muno",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 0.025,
          high: 0.04
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "uno",
      coinMinimalDenom: "muno",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "uptick_7000-2",
    currencies: [
      {
        coinDenom: "uptick",
        coinMinimalDenom: "auptick",
        coinDecimals: 18
      }
    ],
    rest: "https://uptick-7000-2-rest.staketab.org",
    rpc: "https://uptick-7000-2-rpc.staketab.org:443",
    bech32Config: {
      bech32PrefixAccAddr: "uptick",
      bech32PrefixAccPub: "uptickpub",
      bech32PrefixValAddr: "uptickvaloper",
      bech32PrefixValPub: "uptickvaloperpub",
      bech32PrefixConsAddr: "uptickvalcons",
      bech32PrefixConsPub: "uptickvalconspub"
    },
    chainName: "upticktestnet",
    feeCurrencies: [
      {
        coinDenom: "uptick",
        coinMinimalDenom: "auptick",
        coinDecimals: 18
      }
    ],
    stakeCurrency: {
      coinDenom: "uptick",
      coinMinimalDenom: "auptick",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "vince_1903-1",
    currencies: [
      {
        coinDenom: "vce",
        coinMinimalDenom: "avce",
        coinDecimals: 18
      }
    ],
    rest: "http://lcd-testnet.vincechain.com/:1317/",
    rpc: "http://api-testnet.vincechain.com/:26657/",
    bech32Config: {
      bech32PrefixAccAddr: "vce",
      bech32PrefixAccPub: "vcepub",
      bech32PrefixValAddr: "vcevaloper",
      bech32PrefixValPub: "vcevaloperpub",
      bech32PrefixConsAddr: "vcevalcons",
      bech32PrefixConsPub: "vcevalconspub"
    },
    chainName: "vincechaintestnet",
    feeCurrencies: [
      {
        coinDenom: "vce",
        coinMinimalDenom: "avce",
        coinDecimals: 18,
        gasPriceStep: {
          low: 1e10,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "vce",
      coinMinimalDenom: "avce",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "buenavista-1",
    currencies: [
      {
        coinDenom: "ward",
        coinMinimalDenom: "uward",
        coinDecimals: 6
      }
    ],
    rest: "https://api.buenavista.wardenprotocol.org/",
    rpc: "https://rpc.buenavista.wardenprotocol.org/",
    bech32Config: {
      bech32PrefixAccAddr: "warden",
      bech32PrefixAccPub: "wardenpub",
      bech32PrefixValAddr: "wardenvaloper",
      bech32PrefixValPub: "wardenvaloperpub",
      bech32PrefixConsAddr: "wardenvalcons",
      bech32PrefixConsPub: "wardenvalconspub"
    },
    chainName: "wardenprotocoltestnet",
    feeCurrencies: [
      {
        coinDenom: "ward",
        coinMinimalDenom: "uward",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.01,
          average: 0.025,
          high: 0.03
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "ward",
      coinMinimalDenom: "uward",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "INVALID-ID-wavehashtestnet-testnet-1",
    currencies: [
      {
        coinDenom: "wahax",
        coinMinimalDenom: "uwahax",
        coinDecimals: 6
      }
    ],
    rest: "https://lcd.wavehash.online/",
    rpc: "https://rpc.wavehash.online/",
    bech32Config: {
      bech32PrefixAccAddr: "wavehash",
      bech32PrefixAccPub: "wavehashpub",
      bech32PrefixValAddr: "wavehashvaloper",
      bech32PrefixValPub: "wavehashvaloperpub",
      bech32PrefixConsAddr: "wavehashvalcons",
      bech32PrefixConsPub: "wavehashvalconspub"
    },
    chainName: "wavehashtestnet",
    feeCurrencies: [
      {
        coinDenom: "wahax",
        coinMinimalDenom: "uwahax",
        coinDecimals: 6,
        gasPriceStep: {
          low: 25e-4,
          average: 25e-4,
          high: 24e-4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "wahax",
      coinMinimalDenom: "uwahax",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "xion-testnet-1",
    currencies: [
      {
        coinDenom: "XION",
        coinMinimalDenom: "uxion",
        coinDecimals: 6
      },
      {
        coinDenom: "axl",
        coinMinimalDenom: "ibc/33517D439F5E545A1AAB148FAE43AAE17CF68FFB9BC97AE0048A3E3B64518C58",
        coinDecimals: 6
      },
      {
        coinDenom: "osmo",
        coinMinimalDenom: "ibc/484532EB74866F3FB8A71F909F7B1B470FE2E66313DA0A1F9EE5B7C5C046D195",
        coinDecimals: 6
      },
      {
        coinDenom: "usdc",
        coinMinimalDenom: "ibc/57097251ED81A232CE3C9D899E7C8096D6D87EF84BA203E12E424AA4C9B57A64",
        coinDecimals: 6
      },
      {
        coinDenom: "INJ",
        coinMinimalDenom: "ibc/05314A48723E06A1B1B666066B6BEC89F3708E8854DF2E5E9193387AA9653036",
        coinDecimals: 18
      }
    ],
    rest: "https://testnet-burnt-api.lavenderfive.com",
    rpc: "https://testnet-burnt-rpc.lavenderfive.com",
    bech32Config: {
      bech32PrefixAccAddr: "xion",
      bech32PrefixAccPub: "xionpub",
      bech32PrefixValAddr: "xionvaloper",
      bech32PrefixValPub: "xionvaloperpub",
      bech32PrefixConsAddr: "xionvalcons",
      bech32PrefixConsPub: "xionvalconspub"
    },
    chainName: "xiontestnet",
    feeCurrencies: [
      {
        coinDenom: "XION",
        coinMinimalDenom: "uxion",
        coinDecimals: 6
      }
    ],
    stakeCurrency: {
      coinDenom: "XION",
      coinMinimalDenom: "uxion",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "athens_7001-1",
    currencies: [
      {
        coinDenom: "tzeta",
        coinMinimalDenom: "azeta",
        coinDecimals: 18
      }
    ],
    rest: "https://zetachain-athens.blockpi.network/lcd/v1/public",
    rpc: "https://zetachain-athens.blockpi.network/rpc/v1/public",
    bech32Config: {
      bech32PrefixAccAddr: "zeta",
      bech32PrefixAccPub: "zetapub",
      bech32PrefixValAddr: "zetavaloper",
      bech32PrefixValPub: "zetavaloperpub",
      bech32PrefixConsAddr: "zetavalcons",
      bech32PrefixConsPub: "zetavalconspub"
    },
    chainName: "zetachaintestnet",
    feeCurrencies: [
      {
        coinDenom: "tzeta",
        coinMinimalDenom: "azeta",
        coinDecimals: 18,
        gasPriceStep: {
          low: 2e10,
          average: 25e9,
          high: 4e10
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "tzeta",
      coinMinimalDenom: "azeta",
      coinDecimals: 18
    },
    bip44: {
      coinType: 60
    }
  },
  {
    chainId: "landlord-2",
    currencies: [
      {
        coinDenom: "INIT",
        coinMinimalDenom: "l2/1666ede2bf1985307a86de36a6b78411cbf1edeffc2ac569e6a7b2f8753db4bb",
        coinDecimals: 6
      }
    ],
    rest: "https://maze-rest-sequencer-53ecf1d6-4fa1-4103-827f-a9430df97cef.ane1-prod-nocsm.newmetric.xyz",
    rpc: "https://maze-rpc-sequencer-53ecf1d6-4fa1-4103-827f-a9430df97cef.ane1-prod-nocsm.newmetric.xyz",
    bech32Config: {
      bech32PrefixAccAddr: "init",
      bech32PrefixAccPub: "initpub",
      bech32PrefixValAddr: "initvaloper",
      bech32PrefixValPub: "initvaloperpub",
      bech32PrefixConsAddr: "initvalcons",
      bech32PrefixConsPub: "initvalconspub"
    },
    chainName: "civitia",
    feeCurrencies: [
      {
        coinDenom: "INIT",
        coinMinimalDenom: "l2/1666ede2bf1985307a86de36a6b78411cbf1edeffc2ac569e6a7b2f8753db4bb",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.2,
          average: 0.3,
          high: 0.4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "INIT",
      coinMinimalDenom: "l2/1666ede2bf1985307a86de36a6b78411cbf1edeffc2ac569e6a7b2f8753db4bb",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "initiation-2",
    currencies: [
      {
        coinDenom: "INIT",
        coinMinimalDenom: "uinit",
        coinDecimals: 6
      },
      {
        coinDenom: "ETH",
        coinMinimalDenom: "ueth",
        coinDecimals: 6
      },
      {
        coinDenom: "USDC",
        coinMinimalDenom: "uusdc",
        coinDecimals: 6
      },
      {
        coinDenom: "TIA",
        coinMinimalDenom: "utia",
        coinDecimals: 6
      },
      {
        coinDenom: "USDC-INIT LP",
        coinMinimalDenom: "move/dbf06c48af3984ec6d9ae8a9aa7dbb0bb1e784aa9b8c4a5681af660cf8558d7d",
        coinDecimals: 6
      },
      {
        coinDenom: "ETH-INIT LP",
        coinMinimalDenom: "move/a2b0d3c8e53e379ede31f3a361ff02716d50ec53c6b65b8c48a81d5b06548200",
        coinDecimals: 6
      },
      {
        coinDenom: "TIA-INIT LP",
        coinMinimalDenom: "move/b134ae6786f10ef74294e627d2519b63b7c742a6735f98682929fea9a84744d2",
        coinDecimals: 6
      },
      {
        coinDenom: "oINIT",
        coinMinimalDenom: "uoinit",
        coinDecimals: 6
      },
      {
        coinDenom: "minimoveINIT",
        coinMinimalDenom: "ibc/9DD7B5DF63F03D505BE785C9B32095A33CBB9472503077D375E0A557BE5A2B87",
        coinDecimals: 6
      },
      {
        coinDenom: "minimoveINIT-INIT LP",
        coinMinimalDenom: "move/d460381fad32fa8a165f7b13ca4343f99ebd83580b1dc121049b8e695fb6c5b5",
        coinDecimals: 6
      },
      {
        coinDenom: "TEST LZ",
        coinMinimalDenom: "move/7dfcccb8d69af29d585165531eae5c558061d3e3bded2a121be3ef5e189e6b01",
        coinDecimals: 8
      }
    ],
    rest: "https://lcd.testnet.initia.xyz",
    rpc: "https://rpc.testnet.initia.xyz/",
    bech32Config: {
      bech32PrefixAccAddr: "init",
      bech32PrefixAccPub: "initpub",
      bech32PrefixValAddr: "initvaloper",
      bech32PrefixValPub: "initvaloperpub",
      bech32PrefixConsAddr: "initvalcons",
      bech32PrefixConsPub: "initvalconspub"
    },
    chainName: "initia",
    feeCurrencies: [
      {
        coinDenom: "INIT",
        coinMinimalDenom: "uinit",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.15,
          average: 0.15,
          high: 0.4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "INIT",
      coinMinimalDenom: "uinit",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  },
  {
    chainId: "glados-2.1",
    currencies: [
      {
        coinDenom: "MILK",
        coinMinimalDenom: "umilk",
        coinDecimals: 6
      },
      {
        coinDenom: "milkINIT",
        coinMinimalDenom: "milkuinit",
        coinDecimals: 6
      },
      {
        coinDenom: "INIT",
        coinMinimalDenom: "ibc/37A3FB4FED4CA04ED6D9E5DA36C6D27248645F0E22F585576A1488B8A89C5A50",
        coinDecimals: 6
      },
      {
        coinDenom: "TEST LZ",
        coinMinimalDenom: "ibc/665CCAFA2768242D74D8CB2E9F5167261B6B75646E2EF2546E0707C0BFC7CDAF",
        coinDecimals: 8
      }
    ],
    rest: "https://lcd.testnet.milkyway.zone",
    rpc: "https://rpc.testnet.milkyway.zone",
    bech32Config: {
      bech32PrefixAccAddr: "init",
      bech32PrefixAccPub: "initpub",
      bech32PrefixValAddr: "initvaloper",
      bech32PrefixValPub: "initvaloperpub",
      bech32PrefixConsAddr: "initvalcons",
      bech32PrefixConsPub: "initvalconspub"
    },
    chainName: "milkyway",
    feeCurrencies: [
      {
        coinDenom: "MILK",
        coinMinimalDenom: "umilk",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.2,
          average: 0.3,
          high: 0.4
        }
      },
      {
        coinDenom: "INIT",
        coinMinimalDenom: "ibc/37A3FB4FED4CA04ED6D9E5DA36C6D27248645F0E22F585576A1488B8A89C5A50",
        coinDecimals: 6,
        gasPriceStep: {
          low: 0.2,
          average: 0.3,
          high: 0.4
        }
      }
    ],
    stakeCurrency: {
      coinDenom: "MILK",
      coinMinimalDenom: "umilk",
      coinDecimals: 6
    },
    bip44: {
      coinType: 118
    }
  }
], Su = [
  {
    chainId: "eightball-1",
    explorers: [
      {
        url: "https://explorer.8ball.info/",
        tx_page: "https://explorer.8ball.info/8ball/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/8ball",
        tx_page: "https://ping.pub/8ball/tx/${txHash}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/8ball/",
        tx_page: "https://explorer.nodestake.top/8ball/tx/${txHash}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/8ball",
        tx_page: "https://explorer.tcnetwork.io/8ball/transaction/${txHash}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.co.id/8ball",
        tx_page: "https://explorer.co.id/8ball/tx/${txHash}"
      },
      {
        kind: "NODEXPLORER",
        url: "https://explorer.nodexcapital.com/8ball",
        tx_page: "https://explorer.nodexcapital.com/8ball/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "acre_9052-1",
    explorers: [
      {
        kind: "blockscout",
        url: "https://acrescout.mindheartsoul.org",
        tx_page: "https://acrescout.mindheartsoul.org/tx/${txHash}"
      },
      {
        kind: "blockscout",
        url: "https://acrescan.com",
        tx_page: "https://acrescan.com/tx/${txHash}"
      },
      {
        kind: "blockscout",
        url: "https://acreblockexplorer.jet-node.com",
        tx_page: "https://acreblockexplorer.jet-node.com/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.nodestake.top/acre",
        tx_page: "https://explorer.nodestake.top/acre/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://cosmosrun.info/acre-mainnet",
        tx_page: "https://cosmosrun.info/acre-mainnet/tx/${txHash}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/acre",
        tx_page: "https://explorer.tcnetwork.io/acre/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "agoric-3",
    explorers: [
      {
        kind: "explorers.guru",
        url: "https://agoric.explorers.guru",
        tx_page: "https://agoric.explorers.guru/transaction/${txHash}",
        account_page: "https://agoric.explorers.guru/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/agoric",
        tx_page: "https://staking-explorer.com/transaction.php?chain=agoric&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=agoric&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/agoric/",
        tx_page: "https://atomscan.com/agoric/transactions/${txHash}",
        account_page: "https://atomscan.com/agoric/accounts/${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/agoric",
        account_page: "https://stakeflow.io/agoric/accounts/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Agoric",
        tx_page: "https://explorer.stavr.tech/Agoric/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Agoric/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "aioz_168-1",
    explorers: [
      {
        kind: "aioz",
        url: "https://explorer.aioz.network",
        tx_page: "https://explorer.aioz.network/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "akashnet-2",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/akash",
        tx_page: "https://ezstaking.app/akash/txs/${txHash}",
        account_page: "https://ezstaking.app/akash/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/akash",
        tx_page: "https://www.mintscan.io/akash/transactions/${txHash}",
        account_page: "https://www.mintscan.io/akash/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/akash-network",
        tx_page: "https://ping.pub/akash-network/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/akash",
        tx_page: "https://staking-explorer.com/transaction.php?chain=akash&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=akash&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/akash",
        tx_page: "https://atomscan.com/akash/transactions/${txHash}",
        account_page: "https://atomscan.com/akash/accounts/${accountAddress}"
      },
      {
        kind: "cloudmos",
        url: "https://cloudmos.io/blocks",
        tx_page: "https://cloudmos.io/transactions/${txHash}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/akash",
        account_page: "https://stakeflow.io/akash/accounts/${accountAddress}"
      },
      {
        kind: "ValidatorNode",
        url: "https://explorer.validatornode.com/akash-network",
        tx_page: "https://explorer.validatornode.com/akash-network/tx/${txHash}"
      },
      {
        kind: "Decloud Nodes Lab",
        url: "https://explorer.declab.pro/Akash",
        tx_page: "https://explorer.declab.pro/Akash/tx/${txHash}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/akash",
        tx_page: "https://mainnet.whispernode.com/akash/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/akash/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "akiro-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/akiro",
        tx_page: "https://ping.pub/akiro/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "althea_258432-1",
    explorers: [
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/althea",
        tx_page: "https://staking-explorer.com/transaction.php?chain=althea&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=althea&addr=${accountAddress}"
      }
    ]
  },
  {
    chainId: "andromeda-1",
    explorers: [
      {
        kind: "🔥STAVR🔥 Explorer",
        url: "https://explorer.stavr.tech/Andromeda-Mainnet",
        tx_page: "https://explorer.stavr.tech/Andromeda-Mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Andromeda-Mainnet/account/${accountAddress}"
      },
      {
        kind: "exploreme.pro",
        url: "https://andromeda.exploreme.pro",
        tx_page: "https://andromeda.exploreme.pro/transaction/${txHash}",
        account_page: "https://andromeda.exploreme.pro/account/${accountAddress}"
      },
      {
        kind: "Cosmotracker",
        url: "https://cosmotracker.com/andromeda",
        tx_page: "https://cosmotracker.com/andromeda/tx/${txHash}",
        account_page: "https://cosmotracker.com/andromeda/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/andromeda",
        tx_page: "https://ping.pub/andromeda/tx/${txHash}"
      },
      {
        kind: "AviaOne Explorer 🟢",
        url: "https://mainnet.explorer.aviaone.com/andromeda",
        tx_page: "https://mainnet.explorer.aviaone.com/andromeda/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "andromeda-1",
    explorers: [
      {
        kind: "🔥STAVR🔥 Explorer",
        url: "https://explorer.stavr.tech/Andromeda-Mainnet",
        tx_page: "https://explorer.stavr.tech/Andromeda-Mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Andromeda-Mainnet/account/${accountAddress}"
      },
      {
        kind: "exploreme.pro",
        url: "https://andromeda.exploreme.pro",
        tx_page: "https://andromeda.exploreme.pro/transaction/${txHash}",
        account_page: "https://andromeda.exploreme.pro/account/${accountAddress}"
      },
      {
        kind: "Cosmotracker",
        url: "https://cosmotracker.com/andromeda",
        tx_page: "https://cosmotracker.com/andromeda/tx/${txHash}",
        account_page: "https://cosmotracker.com/andromeda/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/andromeda",
        tx_page: "https://ping.pub/andromeda/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "archway-1",
    explorers: [
      {
        kind: "Nodes Guru",
        url: "https://archway.explorers.guru/",
        tx_page: "https://archway.explorers.guru/transaction/${txHash}",
        account_page: "https://archway.explorers.guru/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/archway",
        tx_page: "https://staking-explorer.com/transaction.php?chain=archway&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=archway&addr=${accountAddress}"
      },
      {
        kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀",
        url: "https://exp.utsa.tech/archway",
        tx_page: "https://exp.utsa.tech/archway/tx/${txHash}",
        account_page: "https://exp.utsa.tech/archway/account/${accountAddress}"
      },
      {
        kind: "Mintscan",
        url: "https://mintscan.io/archway/",
        tx_page: "https://mintscan.io/archway/transactions/${txHash}",
        account_page: "https://mintscan.io/archway/accounts/${accountAddress}"
      },
      {
        kind: "Silk Nodes",
        url: "https://explorer.silknodes.io/archway",
        tx_page: "https://explorer.silknodes.io/archway/tx/${txHash}",
        account_page: "https://explorer.silknodes.io/archway/account/${accountAddress}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/archway/",
        tx_page: "https://explorer.nodestake.top/archway/txs/${txHash}",
        account_page: "https://explorer.nodestake.top/archway/account/${accountAddress}"
      },
      {
        kind: "Exploreme",
        url: "https://archway.exploreme.pro/",
        tx_page: "https://archway.exploreme.pro/transaction/${txHash}",
        account_page: "https://archway.exploreme.pro/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/archway",
        tx_page: "https://ping.pub/archway/tx/${txHash}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/archway",
        tx_page: "https://ezstaking.app/archway/txs/${txHash}",
        account_page: "https://ezstaking.app/archway/account/${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/archway",
        tx_page: "https://mainnet.whispernode.com/archway/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/archway/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "arkh",
    explorers: [
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/arkh",
        tx_page: "https://explorer.nodestake.top/arkh/tx/${txHash}"
      },
      {
        kind: "Kynraze Explorer",
        url: "https://explorer.kynraze.com/arkhadian",
        tx_page: "https://explorer.kynraze.com/arkhadian/tx/${txHash}"
      },
      {
        kind: "NODEXPLORER",
        url: "https://explorer.nodexcapital.com/arkhadian",
        tx_page: "https://explorer.nodexcapital.com/arkhadian/tx/${txHash}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/arkhadian",
        tx_page: "https://explorer.whenmoonwhenlambo.money/arkhadian/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/arkhadian/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "mantle-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/assetmantle",
        tx_page: "https://ezstaking.app/assetmantle/txs/${txHash}",
        account_page: "https://ezstaking.app/assetmantle/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/asset-mantle",
        tx_page: "https://www.mintscan.io/asset-mantle/transactions/${txHash}",
        account_page: "https://www.mintscan.io/asset-mantle/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.postcapitalist.io/AssetMantle",
        tx_page: "https://explorer.postcapitalist.io/AssetMantle/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/assetmantle",
        tx_page: "https://staking-explorer.com/transaction.php?chain=assetmantle&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=assetmantle&addr=${accountAddress}"
      },
      {
        kind: "other",
        url: "https://explorer.assetmantle.one",
        tx_page: "https://explorer.assetmantle.one/transactions/${txHash}"
      },
      {
        kind: "explorers.guru",
        url: "https://assetmantle.explorers.guru",
        tx_page: "https://assetmantle.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/assetmantle",
        tx_page: "https://atomscan.com/assetmantle/transactions/${txHash}",
        account_page: "https://atomscan.com/assetmantle/accounts/${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/assetmantle",
        tx_page: "https://mainnet.whispernode.com/assetmantle/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/assetmantle/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "atomone-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer.allinbits.com/atomone",
        tx_page: "https://explorer.allinbits.com/atomone/tx/${txHash}",
        account_page: "https://explorer.allinbits.com/atomone/account/${accountAddress}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️",
        url: "https://explorer.nodeshub.online/atomone/",
        tx_page: "https://explorer.nodeshub.online/atomone/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/atomone/accounts/${accountAddress}"
      },
      {
        kind: "Nodeist Explorer",
        url: "https://explorer.ist/atomone",
        tx_page: "https://explorer.ist/atomone/tx/${txHash}",
        account_page: "https://explorer.ist/atomone/account/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/atomone",
        tx_page: "https://explorer.whenmoonwhenlambo.money/atomone/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/atomone/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "aura_6322-2",
    explorers: [
      {
        kind: "aurascan",
        url: "https://aurascan.io",
        tx_page: "https://aurascan.io/tx/${txHash}",
        account_page: "https://aurascan.io/address/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/aura",
        tx_page: "https://staking-explorer.com/transaction.php?chain=aura&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=aura&addr=${accountAddress}"
      },
      {
        kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀 Explorer",
        url: "https://exp.utsa.tech/aura",
        tx_page: "https://exp.utsa.tech/aura/tx/${txHash}",
        account_page: "https://exp.utsa.tech/aura/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥 Explorer",
        url: "https://explorer.stavr.tech/Aura-Mainnet",
        tx_page: "https://explorer.stavr.tech/aura-mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/aura-mainnet/account/${accountAddress}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/aura",
        tx_page: "https://explorer.nodestake.top/aura/tx/${txHash}",
        account_page: "https://explorer.nodestake.top/aura/account/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/aura",
        tx_page: "https://explorer.tcnetwork.io/aura/transaction/${txHash}",
        account_page: "https://explorer.tcnetwork.io/aura/account/${accountAddress}"
      },
      {
        kind: "Stake-Take",
        url: "https://explorer.stake-take.com/aura",
        tx_page: "https://explorer.stake-take.com/aura/tx/${txHash}",
        account_page: "https://explorer.stake-take.com/aura/account/${accountAddress}"
      },
      {
        kind: "Safe Block",
        url: "https://explorer.safeblock.space/aura",
        tx_page: "https://explorer.safeblock.space/aura/tx/${txHash}",
        account_page: "https://explorer.safeblock.space/aura/account/${accountAddress}"
      },
      {
        kind: "STAKR.space explorer",
        url: "https://explorer.stakr.space/aura/",
        tx_page: "https://explorer.stakr.space/aura/tx/${txHash}",
        account_page: "https://explorer.stakr.space/aura/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "xstaxy-1",
    explorers: [
      {
        kind: "aurascan",
        url: "https://aurascan.io",
        tx_page: "https://aurascan.io/transaction/${txHash}",
        account_page: "https://aurascan.io/account/${accountAddress}"
      },
      {
        kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀 Explorer",
        url: "https://exp.utsa.tech/aura",
        tx_page: "https://exp.utsa.tech/aura/tx/${txHash}",
        account_page: "https://exp.utsa.tech/aura/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥 Explorer",
        url: "https://explorer.stavr.tech/Aura-Mainnet",
        tx_page: "https://explorer.stavr.tech/aura-mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/aura-mainnet/account/${accountAddress}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/aura",
        tx_page: "https://explorer.nodestake.top/aura/tx/${txHash}",
        account_page: "https://explorer.nodestake.top/aura/account/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/aura",
        tx_page: "https://explorer.tcnetwork.io/aura/transaction/${txHash}",
        account_page: "https://explorer.tcnetwork.io/aura/account/${accountAddress}"
      },
      {
        kind: "Stake-Take",
        url: "https://explorer.stake-take.com/aura",
        tx_page: "https://explorer.stake-take.com/aura/tx/${txHash}",
        account_page: "https://explorer.stake-take.com/aura/account/${accountAddress}"
      },
      {
        kind: "Safe Block",
        url: "https://explorer.safeblock.space/aura",
        tx_page: "https://explorer.safeblock.space/aura/tx/${txHash}",
        account_page: "https://explorer.safeblock.space/aura/account/${accountAddress}"
      },
      {
        kind: "STAKR.space explorer",
        url: "https://explorer.stakr.space/aura/",
        tx_page: "https://explorer.stakr.space/aura/tx/${txHash}",
        account_page: "https://explorer.stakr.space/aura/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "axelar-dojo-1",
    explorers: [
      {
        kind: "axelarscan",
        url: "https://axelarscan.io",
        tx_page: "https://axelarscan.io/tx/${txHash}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/axelar",
        tx_page: "https://www.mintscan.io/axelar/transactions/${txHash}",
        account_page: "https://www.mintscan.io/axelar/accounts/${accountAddress}"
      },
      {
        kind: "explorers.guru",
        url: "https://axelar.explorers.guru",
        tx_page: "https://axelar.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/axelar",
        tx_page: "https://staking-explorer.com/transaction.php?chain=axelar&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=axelar&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/axelar",
        tx_page: "https://atomscan.com/axelar/transactions/${txHash}",
        account_page: "https://atomscan.com/axelar/accounts/${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/axelar",
        account_page: "https://stakeflow.io/axelar/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/axelar",
        tx_page: "https://ezstaking.app/axelar/txs/${txHash}",
        account_page: "https://ezstaking.app/axelar/account/${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/axelar",
        tx_page: "https://mainnet.whispernode.com/axelar/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/axelar/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "laozi-mainnet",
    explorers: [
      {
        kind: "cosmoscan",
        url: "https://cosmoscan.io",
        tx_page: "https://cosmoscan.io/tx/${txHash}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/band",
        tx_page: "https://www.mintscan.io/band/transactions/${txHash}",
        account_page: "https://www.mintscan.io/band/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/band-protocol",
        tx_page: "https://ping.pub/band-protocol/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/bandchain",
        tx_page: "https://staking-explorer.com/transaction.php?chain=bandchain&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=bandchain&addr=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Band-Mainnet",
        tx_page: "https://explorer.stavr.tech/Band-Mainnet/tx/${txHash}"
      },
      {
        kind: "Nodeist Explorer",
        url: "https://exp.nodeist.net/band",
        tx_page: "https://exp.nodeist.net/band/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/band-protocol",
        tx_page: "https://atomscan.com/band-protocol/transactions/${txHash}",
        account_page: "https://atomscan.com/band-protocol/accounts/${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/band-protocol",
        account_page: "https://stakeflow.io/band-protocol/accounts/${accountAddress}"
      },
      {
        kind: "Roomit Explorer",
        url: "https://explorer.tendermint.roomit.xyz/band-mainnet",
        account_page: "https://explorer.tendermint.roomit.xyz/band-mainnet/accounts/${accountAddress}"
      },
      {
        kind: "kjnodes Explorer",
        url: "https://explorer.kjnodes.com/band",
        tx_page: "https://explorer.kjnodes.com/band/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "beezee-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/beezee",
        tx_page: "https://ping.pub/beezee/tx/${txHash}",
        account_page: "https://ping.pub/beezee/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/beezee",
        tx_page: "https://staking-explorer.com/transaction.php?chain=beezee&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=beezee&addr=${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.getbze.com/beezee",
        tx_page: "https://explorer.getbze.com/beezee/tx/${txHash}",
        account_page: "https://explorer.getbze.com/beezee/account/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/beezee",
        tx_page: "https://atomscan.com/beezee/transactions/${txHash}",
        account_page: "https://atomscan.com/beezee/accounts/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/beezee",
        tx_page: "https://explorer.whenmoonwhenlambo.money/beezee/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/beezee/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "bitbadges-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/bitbadges",
        tx_page: "https://www.mintscan.io/bitbadges/transactions/${txHash}",
        account_page: "https://www.mintscan.io/bitbadges/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.bitbadges.io/BitBadges%20Mainnet",
        tx_page: "https://explorer.bitbadges.io/BitBadges%20Mainnet/txs/${txHash}",
        account_page: "https://explorer.bitbadges.io/BitBadBitBadges%20Mainnetges/account/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/bitbadges",
        tx_page: "https://explorer.whenmoonwhenlambo.money/bitbadges/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/bitbadges/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "bitcanna-1",
    explorers: [
      {
        kind: "EZStaking Tools",
        url: "https://app.ezstaking.io/bitcanna",
        tx_page: "https://ezstaking.tools/bitcanna/txs/${txHash}",
        account_page: "https://ezstaking.tools/bitcanna/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/bitcanna",
        tx_page: "https://staking-explorer.com/transaction.php?chain=bitcanna&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=bitcanna&addr=${accountAddress}"
      },
      {
        kind: "forbole",
        url: "https://explorer.bitcanna.io",
        tx_page: "https://explorer.bitcanna.io/transactions/${txHash}",
        account_page: "https://explorer.bitcanna.io/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/bitcanna",
        tx_page: "https://ping.pub/bitcanna/tx/${txHash}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/bitcanna/",
        tx_page: "https://www.mintscan.io/bitcanna/txs/${txHash}",
        account_page: "https://www.mintscan.io/bitcanna/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥 Explorer",
        url: "https://explorer.stavr.tech/Bitcanna",
        tx_page: "https://explorer.stavr.tech/Bitcanna/txs/${txHash}",
        account_page: "https://explorer.stavr.tech/Bitcanna/account/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/bitcanna",
        tx_page: "https://atomscan.com/bitcanna/transactions/${txHash}"
      },
      {
        kind: "ValidatorNode Explorer",
        url: "https://explorer.validatornode.com/bitcanna",
        tx_page: "https://explorer.validatornode.com/bitcanna/tx/${txHash}"
      },
      {
        kind: "Safe Block Explorer Pruned",
        url: "https://explorer.safeblock.space/bitcanna",
        tx_page: "https://explorer.safeblock.space/bitcanna/tx/${txHash}"
      },
      {
        kind: "AlxVoy ⚡ ANODE.TEAM",
        url: "https://main.anode.team/bitcanna",
        tx_page: "https://main.anode.team/bitcanna/tx/${txHash}"
      },
      {
        kind: "kjnodes",
        url: "https://explorer.kjnodes.com/bitcanna",
        tx_page: "https://explorer.kjnodes.com/bitcanna/tx/${txHash}"
      },
      {
        kind: "L0vd.com ❤️",
        url: "https://explorers.l0vd.com/bitcanna-mainnet",
        tx_page: "https://explorers.l0vd.com/bitcanna-mainnet/tx/${txHash}"
      },
      {
        kind: "NODEXPLORER",
        url: "https://explorer.nodex.one/bitcanna",
        tx_page: "https://explorer.nodex.one/bitcanna/tx/${txHash}"
      },
      {
        kind: "Moonbys Dashboard",
        url: "https://explorer.moonbys.com",
        tx_page: "https://explorer.moonbys.com/${txHash}"
      },
      {
        kind: "BlockHunters 🎯",
        url: "https://scan.bh.rocks/bitcanna",
        tx_page: "https://scan.bh.rocks/bitcanna/tx/${txHash}"
      },
      {
        kind: "Indonode",
        url: "https://explorer.indonode.net/bitcanna",
        tx_page: "https://explorer.indonode.net/bitcanna/tx/${txHash}"
      },
      {
        kind: "CrypTech Explorer",
        url: "https://explorers.cryptech.com.ua/bitcanna",
        tx_page: "https://explorers.cryptech.com.ua/bitcanna/txs/${txHash}"
      },
      {
        kind: "Kalia Network",
        url: "https://explorer.kalia.network/bitcanna",
        tx_page: "https://explorer.kalia.network/bitcanna/tx/${txHash}",
        account_page: "https://explorer.kalia.network/bitcanna/account/${accountAddress}"
      },
      {
        kind: "AviaOne Explorer 🟢",
        url: "https://mainnet.explorer.aviaone.com/bitcanna",
        tx_page: "https://mainnet.explorer.aviaone.com/bitcanna/tx/${txHash}",
        account_page: "https://mainnet.explorer.aviaone.com/bitcanna/account/${accountAddress}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️",
        url: "https://explorer.nodeshub.online/bitcanna/",
        tx_page: "https://explorer.nodeshub.online/bitcanna/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/bitcanna/accounts/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/bitcanna",
        tx_page: "https://explorer.whenmoonwhenlambo.money/bitcanna/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/bitcanna/account/${accountAddress}"
      },
      {
        kind: "AviaOne Explorer 🟢",
        url: "https://mainnet.explorer.aviaone.com/bitcanna",
        tx_page: "https://mainnet.explorer.aviaone.com/bitcanna/tx/${txHash}",
        account_page: "https://mainnet.explorer.aviaone.com/bitcanna/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "bitsong-2b",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/bitsong",
        tx_page: "https://ezstaking.app/bitsong/txs/${txHash}",
        account_page: "https://ezstaking.app/bitsong/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/bitsong",
        tx_page: "https://ping.pub/bitsong/tx/${txHash}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/bitsong",
        tx_page: "https://www.mintscan.io/bitsong/transactions/${txHash}",
        account_page: "https://www.mintscan.io/bitsong/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/bitsong",
        tx_page: "https://staking-explorer.com/transaction.php?chain=bitsong&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=bitsong&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/bitsong",
        tx_page: "https://atomscan.com/bitsong/transactions/${txHash}",
        account_page: "https://atomscan.com/bitsong/accounts/${accountAddress}"
      },
      {
        kind: "Safe Block",
        url: "https://explorer.safeblok.space/bitsong",
        tx_page: "https://explorer.safeblock.space/bitsong/tx/${txHash}",
        account_page: "https://explorer.safeblock.space/bitsong/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Bitsong",
        tx_page: "https://explorer.stavr.tech/Bitsong/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Bitsong/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "blockx_19191-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/blockx",
        tx_page: "https://ping.pub/blockx/tx/${txHash}"
      },
      {
        kind: "Nodeist Explorer",
        url: "https://explorer.ist/blockx/",
        tx_page: "https://explorer.ist/blockx/tx/${txHash}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/blockx",
        tx_page: "https://explorer.whenmoonwhenlambo.money/blockx/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/blockx/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "bluechip-2"
  },
  {
    chainId: "bluzelle-9",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.explorer.net.bluzelle.com/bluzelle",
        tx_page: "https://ping.explorer.net.bluzelle.com/bluzelle/tx/${txHash}",
        account_page: "https://ping.explorer.net.bluzelle.com/bluzelle/account/${accountAddress}"
      },
      {
        kind: "big dipper",
        url: "https://bd.explorer.net.bluzelle.com",
        tx_page: "https://bd.explorer.net.bluzelle.com/transactions/${txHash}",
        account_page: "https://bd.explorer.net.bluzelle.com/accounts/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/bluzelle",
        tx_page: "https://explorer.tcnetwork.io/bluzelle/transaction/${txHash}"
      },
      {
        kind: "Nodine.ID",
        url: "https://explorer.co.id/bluzelle",
        tx_page: "https://explorer.co.id/bluzelle/transaction/${txHash}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/bluzelle",
        tx_page: "https://explorer.whenmoonwhenlambo.money/bluzelle/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/bluzelle/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "bostrom",
    explorers: [
      {
        kind: "cyb",
        url: "https://cyb.ai/",
        tx_page: "https://cyb.ai/network/bostrom/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/bostrom",
        tx_page: "https://ping.pub/bostrom/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/bostrom",
        tx_page: "https://staking-explorer.com/transaction.php?chain=bostrom&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=bostrom&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/bostrom",
        tx_page: "https://atomscan.com/bostrom/transactions/${txHash}",
        account_page: "https://atomscan.com/bostrom/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "bouachain",
    explorers: [
      {
        kind: "bouachain",
        url: "https://bouascan.com",
        tx_page: "https://bouascan.com/bouachain/tx/${txHash}",
        account_page: "https://bouascan.com/bouachain/${accountAddress}"
      }
    ]
  },
  {
    chainId: "canto_7700-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://cosmos-explorers.neobase.one/canto",
        tx_page: "https://cosmos-explorers.neobase.one/canto/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/canto",
        tx_page: "https://staking-explorer.com/transaction.php?chain=canto&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=canto&addr=${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/canto",
        tx_page: "https://explorer.tcnetwork.io/canto/transaction/${txHash}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/canto",
        tx_page: "https://ezstaking.app/canto/txs/${txHash}",
        account_page: "https://ezstaking.app/canto/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Canto-Mainnet",
        tx_page: "https://explorer.stavr.tech/Canto-Mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Canto-Mainnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "carbon-1",
    explorers: [
      {
        kind: "carbonscan",
        url: "https://scan.carbon.network",
        tx_page: "https://scan.carbon.network/transaction/${txHash}?net=main"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/carbon",
        tx_page: "https://ping.pub/carbon/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/carbon",
        tx_page: "https://staking-explorer.com/transaction.php?chain=carbon&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=carbon&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/carbon",
        tx_page: "https://atomscan.com/carbon/transactions/${txHash}",
        account_page: "https://atomscan.com/carbon/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "celestia",
    explorers: [
      {
        kind: "Mintscan",
        url: "https://mintscan.io/celestia",
        tx_page: "https://mintscan.io/celestia/txs/${txHash}",
        account_page: "https://mintscan.io/celestia/address/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/celestia",
        tx_page: "https://staking-explorer.com/transaction.php?chain=celestia&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=celestia&addr=${accountAddress}"
      },
      {
        kind: "NodeStake",
        url: "https://explorer.nodestake.top/celestia/",
        tx_page: "https://explorer.nodestake.top/celestia/txs/${txHash}",
        account_page: "https://explorer.nodestake.top/celestia/account/${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/celestia",
        tx_page: "https://stakeflow.io/celestia/transactions/${txHash}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/celestia",
        tx_page: "https://explorer.tcnetwork.io/celestia/transaction/${txHash}",
        account_page: "https://explorer.tcnetwork.io/celestia/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Celestia-Mainnet",
        tx_page: "https://explorer.stavr.tech/Celestia-Mainnet/transaction/${txHash}",
        account_page: "https://explorer.stavr.tech/Celestia-Mainnet/account/${accountAddress}"
      },
      {
        kind: "AM Solutions",
        url: "https://explorer.theamsolutions.info/celestia-main",
        tx_page: "https://explorer.theamsolutions.info/celestia-main/transaction/${txHash}",
        account_page: "https://explorer.theamsolutions.info/celestia-main/account/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/celestia",
        tx_page: "https://ezstaking.app/celestia/txs/${txHash}",
        account_page: "https://ezstaking.app/celestia/account/${accountAddress}"
      },
      {
        kind: "🚀 itrocket 🚀",
        url: "https://mainnet.itrocket.net/celestia",
        tx_page: "https://mainnet.itrocket.net/celestia/transaction/${txHash}",
        account_page: "https://mainnet.itrocket.net/celestia/account/${accountAddress}"
      },
      {
        kind: "DTEAM | Explorer",
        url: "https://explorer.mainnet.dteam.tech/celestia",
        tx_page: "https://explorer.mainnet.dteam.tech/celestia/transaction/${txHash}",
        account_page: "https://explorer.mainnet.dteam.tech/celestia/account/${accountAddress}"
      },
      {
        kind: "Relaxed Explorer 🦥",
        url: "https://explorer.stakeandrelax.net/celestia",
        tx_page: "https://explorer.stakeandrelax.net/celestia/transaction/${txHash}",
        account_page: "https://explorer.stakeandrelax.net/celestia/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "cerberus-chain-1",
    explorers: [
      {
        kind: "skynetexplorers",
        url: "https://skynetexplorers.com/cerberus",
        tx_page: "https://skynetexplorers.com/cerberus/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/cerberus",
        tx_page: "https://ping.pub/cerberus/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/cerberus",
        tx_page: "https://atomscan.com/cerberus/transactions/${txHash}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/cerberus",
        tx_page: "https://explorer.tcnetwork.io/cerberus/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "perun-1",
    explorers: [
      {
        kind: "explorer",
        url: "https://explorer.apeironnodes.com/chain4energy",
        tx_page: "https://explorer.apeironnodes.com/chain4energy/transactions/${txHash}"
      },
      {
        kind: "DTEAM | Explorer",
        url: "https://explorer.mainnet.dteam.tech/chain4energy",
        tx_page: "https://explorer.mainnet.dteam.tech/chain4energytransactions/${txHash}"
      },
      {
        kind: "explorer",
        url: "https://explorer.ppnv.space/c4e",
        tx_page: "https://explorer.ppnv.space/c4e/transactions/${txHash}"
      },
      {
        kind: "explorer",
        url: "https://explorer.c4e.io/",
        tx_page: "https://explorer.c4e.io/transactions/${txHash}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/chain4energy",
        tx_page: "https://explorer.nodestake.top/chain4energy/transactions/${txHash}"
      },
      {
        kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀 Explorer",
        url: "https://exp.utsa.tech/c4e",
        tx_page: "https://exp.utsa.tech/c4e/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥 Explorer",
        url: "https://explorer.stavr.tech/c4e",
        tx_page: "https://explorer.stavr.tech/c4e/tx/${txHash}"
      },
      {
        kind: "BccNodes Explorer",
        url: "https://explorer.bccnodes.com/chain4energy",
        tx_page: "https://explorer.bccnodes.com/chain4energy/transactions/${txHash}"
      },
      {
        kind: "NODEXPLORER",
        url: "https://explorer.nodexcapital.com/c4e",
        tx_page: "https://explorer.nodexcapital.com/c4e/transactions/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/chain4energy",
        tx_page: "https://atomscan.com/chain4energy/transactions/${txHash}",
        account_page: "https://atomscan.com/chain4energy/accounts/${accountAddress}"
      },
      {
        kind: "AM Solutions Explorer",
        url: "https://explorer.theamsolutions.info/c4e-main/staking",
        tx_page: "https://explorer.theamsolutions.info/c4e-main/transactions/${txHash}"
      },
      {
        kind: "AlxVoy ⚡ ANODE.TEAM Explorer",
        url: "https://main.anode.team/c4e",
        tx_page: "https://main.anode.team/c4e/tx/${txHash}"
      },
      {
        kind: "ScanRun",
        url: "https://scanrun.io/c4e",
        tx_page: "https://scanrun.io/c4e/transactions/${txHash}"
      },
      {
        kind: "Cryptech",
        url: "https://explorers.cryptech.com.ua/chain4energy",
        tx_page: "https://explorers.cryptech.com.ua/chain4energy/tx/${txHash}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/chain4energy",
        tx_page: "https://explorer.whenmoonwhenlambo.money/chain4energy/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/chain4energy/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "cheqd-mainnet-1",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://explorer.cheqd.io",
        tx_page: "https://explorer.cheqd.io/transactions/${txHash}",
        account_page: "https://explorer.cheqd.io/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/cheqd",
        tx_page: "https://ping.pub/cheqd/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/cheqd",
        tx_page: "https://staking-explorer.com/transaction.php?chain=cheqd&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=cheqd&addr=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Cheqd-Mainnet",
        tx_page: "https://explorer.stavr.tech/Cheqd-Mainnet/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/cheqd",
        tx_page: "https://atomscan.com/cheqd/transactions/${txHash}",
        account_page: "https://atomscan.com/cheqd/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/cheqd",
        tx_page: "https://ezstaking.app/cheqd/txs/${txHash}",
        account_page: "https://ezstaking.app/cheqd/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://look.chillvalidation.com/cheqd",
        tx_page: "https://look.chillvalidation.com/cheqd/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.wildsage.io/cheqd",
        tx_page: "https://ping.wildsage.io/cheqd/tx/${txHash}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/cheqd",
        tx_page: "https://mainnet.whispernode.com/cheqd/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/cheqd/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "chihuahua-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/chihuahua",
        tx_page: "https://ping.pub/chihuahua/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Chihua-Mainnet",
        tx_page: "https://explorer.stavr.tech/Chihua-Mainnet/tx/${txHash}"
      },
      {
        kind: "mintscan",
        url: "https://mintscan.io/chihuahua",
        tx_page: "https://mintscan.io/chihuahua/transactions/${txHash}",
        account_page: "https://www.mintscan.io/chihuahua/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/chihuahua",
        tx_page: "https://staking-explorer.com/transaction.php?chain=chihuahua&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=chihuahua&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/chihuahua",
        tx_page: "https://atomscan.com/chihuahua/transactions/${txHash}",
        account_page: "https://atomscan.com/chihuahua/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/chihuahua",
        tx_page: "https://ezstaking.app/chihuahua/txs/${txHash}",
        account_page: "https://ezstaking.app/chihuahua/account/${accountAddress}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
        url: "https://explorer.nodeshub.online/chihuahua/",
        tx_page: "https://explorer.nodeshub.online/chihuahua/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/chihuahua/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "chimba",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://explorer.chimba.ooo/",
        tx_page: "https://explorer.chimba.ooo/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "morocco-1",
    explorers: [
      {
        kind: "skynetexplorers",
        url: "https://www.skynetexplorers.com/chronic-token"
      },
      {
        kind: "Zenscan.io",
        url: "https://www.chronic.zenscan.io"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/chronicnetwork",
        tx_page: "https://atomscan.com/chronicnetwork/transactions/${txHash}",
        account_page: "https://atomscan.com/chronicnetwork/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "cifer-2",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://explorer.cifer.ai/",
        tx_page: "https://explorer.cifer.ai/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "cifer-1",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://explorer.cifer.ai/",
        tx_page: "https://explorer.cifer.ai/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "cnho_stables-1",
    explorers: [
      {
        url: "https://explorer.cnho.io",
        tx_page: "https://explorer.cnho.io/transaction/${txHash}",
        account_page: "https://explorer.cnho.io/account/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/cnhostables",
        tx_page: "https://explorer.whenmoonwhenlambo.money/cnhostables/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/cnhostables/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "comdex-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/comdex",
        tx_page: "https://ezstaking.app/comdex/txs/${txHash}",
        account_page: "https://ezstaking.app/comdex/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/comdex",
        tx_page: "https://www.mintscan.io/comdex/transactions/${txHash}",
        account_page: "https://www.mintscan.io/comdex/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/comdex",
        tx_page: "https://staking-explorer.com/transaction.php?chain=comdex&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=comdex&addr=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Comdex-Mainnet",
        tx_page: "https://explorer.stavr.tech/Comdex-Mainnet/txs/${txHash}",
        account_page: "https://explorer.stavr.tech/Comdex-Mainnet/accounts/${accountAddress}"
      },
      {
        kind: "aneka",
        url: "https://comdex.aneka.io/",
        tx_page: "https://comdex.aneka.io/txs/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/comdex",
        tx_page: "https://ping.pub/comdex/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/comdex",
        tx_page: "https://atomscan.com/comdex/transactions/${txHash}",
        account_page: "https://atomscan.com/comdex/accounts/${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/comdex",
        account_page: "https://stakeflow.io/comdex/accounts/${accountAddress}"
      },
      {
        kind: "ValidatorNode",
        url: "https://explorer.validatornode.com/comdex",
        tx_page: "https://explorer.validatornode.com/comdex/tx/${txHash}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/comdex",
        tx_page: "https://mainnet.whispernode.com/comdex/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/comdex/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "commercio-3",
    explorers: [
      {
        kind: "almerico",
        url: "https://mainnet.commercio.network",
        tx_page: "https://mainnet.commercio.network/transactions/detail/${txHash}"
      }
    ]
  },
  {
    chainId: "centauri-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/composable",
        tx_page: "https://ping.pub/composable/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/composable",
        tx_page: "https://staking-explorer.com/transaction.php?chain=composable&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=composable&addr=${accountAddress}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/composable",
        tx_page: "https://explorer.nodestake.top/composable/tx/${txHash}"
      },
      {
        kind: "Stake Village",
        url: "https://exp.stakevillage.net/composable",
        tx_page: "https://exp.stakevillage.net/composable/tx/${txHash}",
        account_page: "https://exp.stakevillage.net/composable/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Composable-Mainnet",
        tx_page: "https://explorer.stavr.tech/Composable-Mainnet/tx/${txHash}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/picasso",
        tx_page: "https://mainnet.whispernode.com/picasso/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/picasso/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "cvn_2032-1",
    explorers: [
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/conscious",
        tx_page: "https://staking-explorer.com/transaction.php?chain=conscious&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=conscious&addr=${accountAddress}"
      },
      {
        kind: "blockscout",
        url: "https://explore.consciousdao.com/",
        tx_page: "https://explore.consciousdao.com/tx/${txHash}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/conscious",
        tx_page: "https://explorer.whenmoonwhenlambo.money/conscious/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/conscious/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "coreum-mainnet-1",
    explorers: [
      {
        kind: "Coreum",
        url: "https://explorer.coreum.com/coreum",
        tx_page: "https://explorer.coreum.com/coreum/transactions/${txHash}",
        account_page: "https://explorer.coreum.com/coreum/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/coreum",
        tx_page: "https://www.mintscan.io/coreum/transactions/${txHash}",
        account_page: "https://www.mintscan.io/coreum/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/coreum",
        tx_page: "https://staking-explorer.com/transaction.php?chain=coreum&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=coreum&addr=${accountAddress}"
      },
      {
        kind: "NODEXPLORER",
        url: "https://explorer.nodexcapital.com/coreum",
        tx_page: "https://explorer.nodexcapital.com/coreum/txs/${txHash}",
        account_page: "https://explorer.nodexcapital.com/coreum/account/${accountAddress}"
      },
      {
        kind: "Silk Nodes",
        url: "https://explorer.silknodes.io/coreum",
        tx_page: "https://explorer.silknodes.io/coreum/tx/${txHash}",
        account_page: "https://explorer.silknodes.io/coreum/account/${accountAddress}"
      },
      {
        kind: "#SoloNation",
        url: "https://explorer.solonation.io/core-main",
        tx_page: "https://explorer.solonation.io/core-main/tx/${txHash}",
        account_page: "https://explorer.solonation.io/core-main/account/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/coreum",
        tx_page: "https://explorer.tcnetwork.io/coreum/transaction/${txHash}",
        account_page: "https://explorer.tcnetwork.io/coreum/account/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/coreum",
        tx_page: "https://ezstaking.app/coreum/txs/${txHash}",
        account_page: "https://ezstaking.app/coreum/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "cosmoshub-4",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/cosmos",
        tx_page: "https://www.mintscan.io/cosmos/transactions/${txHash}",
        account_page: "https://www.mintscan.io/cosmos/accounts/${accountAddress}",
        validator_page: "https://www.mintscan.io/cosmos/validators/${validatorAddress}",
        proposal_page: "https://www.mintscan.io/cosmos/proposals/${proposalId}",
        block_page: "https://www.mintscan.io/cosmos/blocks/${blockHeight}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/cosmoshub",
        tx_page: "https://ezstaking.app/cosmoshub/txs/${txHash}",
        account_page: "https://ezstaking.app/cosmoshub/account/${accountAddress}",
        validator_page: "https://ezstaking.app/cosmoshub/validators/${validatorAddress}",
        proposal_page: "https://ezstaking.app/cosmoshub/proposals/${proposalId}",
        block_page: "https://ezstaking.app/cosmoshub/blocks/${blockHeight}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/cosmos",
        tx_page: "https://ping.pub/cosmos/tx/${txHash}",
        account_page: "https://ping.pub/cosmos/account/${accountAddress}",
        validator_page: "https://ping.pub/cosmos/staking/${validatorAddress}",
        proposal_page: "https://ping.pub/cosmos/gov/${proposalId}",
        block_page: "https://ping.pub/cosmos/block/${blockHeight}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/cosmoshub",
        tx_page: "https://staking-explorer.com/transaction.php?chain=cosmoshub&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=cosmoshub&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com",
        tx_page: "https://atomscan.com/transactions/${txHash}",
        account_page: "https://atomscan.com/accounts/${accountAddress}",
        validator_page: "https://atomscan.com/validators/${validatorAddress}",
        proposal_page: "https://atomscan.com/votes/${proposalId}",
        block_page: "https://atomscan.com/blocks/${blockHeight}"
      },
      {
        kind: "unichain",
        url: "https://unicha.in/cosmos",
        tx_page: "https://unicha.in/cosmos/transaction/${txHash}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/cosmoshub",
        tx_page: "https://explorer.tcnetwork.io/cosmoshub/transaction/${txHash}",
        account_page: "https://explorer.tcnetwork.io/cosmoshub/account/${accountAddress}",
        validator_page: "https://explorer.tcnetwork.io/cosmoshub/validator/${validatorAddress}",
        proposal_page: "https://explorer.tcnetwork.io/cosmoshub/proposal/${proposalId}",
        block_page: "https://explorer.tcnetwork.io/cosmoshub/block/${blockHeight}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/cosmos",
        account_page: "https://stakeflow.io/cosmos/accounts/${accountAddress}",
        validator_page: "https://stakeflow.io/cosmos/validators/${validatorAddress}"
      },
      {
        kind: "Nodeist Explorer",
        url: "https://exp.nodeist.net/cosmos"
      },
      {
        kind: "Inbloc",
        url: "https://inbloc.org",
        tx_page: "https://inbloc.org/transactions/${txHash}",
        account_page: "https://inbloc.org/account/${accountAddress}",
        validator_page: "https://inbloc.org/cosmos/validator/${validatorAddress}",
        proposal_page: "https://inbloc.org/cosmos/proposal/${proposalId}",
        block_page: "https://inbloc.org/cosmos/blocks/${blockHeight}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/cosmos",
        tx_page: "https://mainnet.whispernode.com/cosmos/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/cosmos/account/${accountAddress}",
        validator_page: "https://mainnet.whispernode.com/cosmos/staking/${validatorAddress}",
        proposal_page: "https://mainnet.whispernode.com/cosmos/gov/${proposalId}",
        block_page: "https://mainnet.whispernode.com/cosmos/block/${blockHeight}"
      }
    ]
  },
  {
    chainId: "coss-1"
  },
  {
    chainId: "crescent-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/crescent",
        tx_page: "https://ezstaking.app/crescent/txs/${txHash}",
        account_page: "https://ezstaking.app/crescent/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/crescent",
        tx_page: "https://ping.pub/crescent/tx/${txHash}"
      },
      {
        kind: "explorers.guru",
        url: "https://crescent.explorers.guru",
        tx_page: "https://crescent.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/crescent",
        tx_page: "https://staking-explorer.com/transaction.php?chain=crescent&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=crescent&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/crescent",
        tx_page: "https://atomscan.com/crescent/transactions/${txHash}",
        account_page: "https://atomscan.com/crescent/accounts/${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/crescent",
        account_page: "https://stakeflow.io/crescent/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "cronosmainnet_25-1",
    explorers: [
      {
        kind: "cronoscan",
        url: "https://cronoscan.com",
        tx_page: "https://cronoscan.com/tx/${txHash}"
      },
      {
        kind: "crypto.org",
        url: "https://cronos.org/explorer",
        tx_page: "https://cronos.org/explorer/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/cronos",
        tx_page: "https://ping.pub/cronos/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "crypto-org-chain-mainnet-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/crypto-org",
        tx_page: "https://www.mintscan.io/crypto-org/transactions/${txHash}",
        account_page: "https://www.mintscan.io/crypto-org/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/cryptoorgchain",
        tx_page: "https://staking-explorer.com/transaction.php?chain=cryptoorgchain&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=cryptoorgchain&addr=${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/crypto-org",
        tx_page: "https://ezstaking.app/crypto-org/txs/${txHash}",
        account_page: "https://ezstaking.app/crypto-org/account/${accountAddress}"
      },
      {
        kind: "cronos.org",
        url: "https://cronos-pos.org/explorer",
        tx_page: "https://cronos-pos.org/explorer/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/crypto-com-chain",
        tx_page: "https://ping.pub/crypto-com-chain/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "cudos-1",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://explorer.cudos.org/",
        tx_page: "https://explorer.cudos.org/transactions/${txHash}",
        account_page: "https://explorer.cudos.org/accounts/${accountAddress}"
      },
      {
        kind: "cudos-dashboard",
        url: "https://dashboard.cudos.org/",
        tx_page: "https://explorer.cudos.org/transactions/${txHash}",
        account_page: "https://explorer.cudos.org/accounts/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/cudos",
        tx_page: "https://www.mintscan.io/cudos/transactions/${txHash}",
        account_page: "https://www.mintscan.io/cudos/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/cudos",
        tx_page: "https://staking-explorer.com/transaction.php?chain=cudos&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=cudos&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/cudos",
        tx_page: "https://atomscan.com/cudos/transactions/${txHash}",
        account_page: "https://atomscan.com/cudos/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/cudos",
        tx_page: "https://ezstaking.app/cudos/txs/${txHash}",
        account_page: "https://ezstaking.app/cudos/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "mainnet-3",
    explorers: [
      {
        kind: "decentr.net",
        url: "https://explorer.decentr.net",
        tx_page: "https://explorer.decentr.net/transactions/${txHash}?networkId=mainnet"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/decentr/",
        tx_page: "https://ping.pub/decentr/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/decentr",
        tx_page: "https://staking-explorer.com/transaction.php?chain=decentr&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=decentr&addr=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Decentr-Mainnet",
        tx_page: "https://explorer.stavr.tech/Decentr-Mainnet/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/decentr",
        tx_page: "https://atomscan.com/decentr/transactions/${txHash}",
        account_page: "https://atomscan.com/decentr/accounts/${accountAddress}"
      },
      {
        kind: "Nodine.ID",
        url: "https://explorer.co.id/decentr",
        tx_page: "https://explorer.co.id/decentr/tx/${txHash}"
      },
      {
        kind: "THE EXPLORER",
        url: "https://explorer.sxlzptprjkt.xyz/decentr",
        tx_page: "https://explorer.sxlzptprjkt.xyz/decentr/tx/${txHash}"
      },
      {
        kind: "hexskrt EXPLORER",
        url: "https://explorer.hexskrt.net/decentr",
        tx_page: "https://explorer.hexskrt.net/decentr/tx/${txHash}"
      },
      {
        kind: "NODEXPLORER",
        url: "https://explorer.nodexcapital.com/decentr",
        tx_page: "https://explorer.nodexcapital.com/decentr/tx/${txHash}"
      },
      {
        kind: "Explorer ComunityNode",
        url: "https://explorer.comunitynode.my.id/decentr",
        tx_page: "https://explorer.comunitynode.my.id/decentr/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "desmos-mainnet",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/desmos",
        tx_page: "https://ezstaking.app/desmos/txs/${txHash}",
        account_page: "https://ezstaking.app/desmos/account/${accountAddress}"
      },
      {
        kind: "bigdipper",
        url: "https://bigdipper.live/desmos",
        tx_page: "https://bigdipper.live/desmos/transactions/${txHash}",
        account_page: "https://bigdipper.live/desmos/accounts/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/desmos",
        tx_page: "https://www.mintscan.io/desmos/transactions/${txHash}",
        account_page: "https://www.mintscan.io/desmos/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/desmos",
        tx_page: "https://ping.pub/desmos/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/desmos",
        tx_page: "https://atomscan.com/desmos/transactions/${txHash}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/desmos",
        tx_page: "https://explorer.tcnetwork.io/desmos/transaction/${txHash}"
      },
      {
        kind: "Decloud Nodes Lab",
        url: "https://explorer.declab.pro/Desmos",
        tx_page: "https://explorer.declab.pro/Desmos/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "dhealth",
    explorers: [
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/dhealth",
        tx_page: "https://staking-explorer.com/transaction.php?chain=dhealth&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=dhealth&addr=${accountAddress}"
      },
      {
        kind: "nodestake",
        url: "https://explorer.nodestake.org/dhealth",
        tx_page: "https://explorer.nodestake.org/dhealth/tx/${txHash}",
        account_page: "https://explorer.nodestake.org/dhealth/account/${accountAddress}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️",
        url: "https://explorer.nodeshub.online/dhealth/",
        tx_page: "https://explorer.nodeshub.online/dhealth/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/dhealth/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "dig-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/dig",
        tx_page: "https://ping.pub/dig/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/dig",
        tx_page: "https://atomscan.com/dig/transactions/${txHash}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/dig",
        tx_page: "https://explorer.tcnetwork.io/dig/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "vota-ash",
    explorers: [
      {
        kind: "Dora Vota Ping Pub",
        url: "https://vota-explorer.dorafactory.org",
        tx_page: "https://vota-explorer.dorafactory.org/doravota/tx/${txHash}"
      },
      {
        kind: "lesnik | UTSA Ping Pub",
        url: "https://exp.utsa.tech/dora/staking",
        tx_page: "https://exp.utsa.tech/dora/tx/${txHash}"
      },
      {
        kind: "ITRocket Ping Pub",
        url: "https://mainnet.itrocket.net/doravota/staking",
        tx_page: "https://mainnet.itrocket.net/doravota/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/doravota",
        tx_page: "https://staking-explorer.com/transaction.php?chain=doravota&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=doravota&addr=${accountAddress}"
      },
      {
        kind: "Explorers",
        url: "https://dora.explorers.guru",
        tx_page: "https://dora.explorers.guru/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "dungeon-1"
  },
  {
    chainId: "dydx-mainnet-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/dydx",
        tx_page: "https://www.mintscan.io/dydx/txs/${txHash}",
        account_page: "https://www.mintscan.io/dydx/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/dydx",
        tx_page: "https://staking-explorer.com/transaction.php?chain=dydx&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=dydx&addr=${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/dydx",
        tx_page: "https://ezstaking.app/dydx/txs/${txHash}",
        account_page: "https://ezstaking.app/dydx/account/${accountAddress}"
      },
      {
        kind: "NodeStake",
        url: "https://explorer.nodestake.top/dydx/",
        tx_page: "https://explorer.nodestake.top/dydx/txs/${txHash}",
        account_page: "https://explorer.nodestake.top/dydx/account/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/dydx",
        tx_page: "https://explorer.tcnetwork.io/dydx/transaction/${txHash}",
        account_page: "https://explorer.tcnetwork.io/dydx/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "dymension_1100-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/dymension",
        tx_page: "https://www.mintscan.io/dymension/tx/${txHash}",
        account_page: "https://www.mintscan.io/dymension/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/dymension",
        tx_page: "https://staking-explorer.com/transaction.php?chain=dymension&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=dymension&addr=${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/dymension",
        tx_page: "https://ezstaking.app/dymension/txs/${txHash}",
        account_page: "https://ezstaking.app/dymension/account/${accountAddress}"
      },
      {
        kind: "NodeStake",
        url: "https://explorer.nodestake.org/dymension",
        tx_page: "https://explorer.nodestake.org/dymension/tx/${txHash}",
        account_page: "https://explorer.nodestake.org/dymension/account/${accountAddress}"
      },
      {
        kind: "Kynraze",
        url: "https://explorer.kynraze.com/dymension",
        tx_page: "https://explorer.kynraze.com/dymension/tx/${txHash}",
        account_page: "https://explorer.kynraze.com/dymension/account/${accountAddress}"
      },
      {
        kind: "Nodeist Explorer",
        url: "https://explorer.ist/dymension",
        tx_page: "https://explorer.ist/dymension/tx/${txHash}",
        account_page: "https://explorer.ist/dymension/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Dymension-Mainnet",
        tx_page: "https://explorer.stavr.tech/Dymension-Mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Dymension-Mainnet/account/${accountAddress}"
      },
      {
        kind: "HoodScan",
        url: "https://hoodscan.io/dymension",
        tx_page: "https://hoodscan.io/dymension/transactions/${txHash}",
        account_page: "https://hoodscan.io/dymension/accounts/${accountAddress}"
      },
      {
        kind: "posthuman",
        url: "https://explorer.posthuman.digital/dymension",
        tx_page: "https://explorer.posthuman.digital/dymension/tx/${txHash}",
        account_page: "https://explorer.posthuman.digital/dymension/account/${accountAddress}"
      },
      {
        kind: "AVIAONE 🟢",
        url: "https://mainnet.explorer.aviaone.com/dymension",
        tx_page: "https://mainnet.explorer.aviaone.com/dymension/tx/${txHash}",
        account_page: "https://mainnet.explorer.aviaone.com/dymension/account/${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/dymension",
        tx_page: "https://mainnet.whispernode.com/dymension/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/dymension/account/${accountAddress}"
      },
      {
        kind: "DTEAM | Explorer",
        url: "https://explorer.mainnet.dteam.tech/dymension",
        tx_page: "https://explorer.mainnet.dteam.tech/dymension/tx/${txHash}",
        account_page: "https://explorer.mainnet.dteam.tech/dymension/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "dyson-mainnet-01",
    explorers: [
      {
        kind: "dysonprotocol",
        url: "https://explorer.dys.dysonprotocol.com/dyson/",
        tx_page: "https://explorer.dys.dysonprotocol.com/dyson/tx/${txHash}",
        account_page: "https://explorer.dys.dysonprotocol.com/dyson/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "echelon_3000-3",
    explorers: [
      {
        kind: "echelon",
        url: "https://app.ech.network/explorer",
        tx_page: "https://app.ech.network/explorer/tx/${txHash}"
      },
      {
        kind: "blockscout",
        url: "https://scout.ech.network",
        tx_page: "https://scout.ech.network/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/echelon",
        tx_page: "https://ping.pub/echelon/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/echelon",
        tx_page: "https://atomscan.com/echelon/transactions/${txHash}",
        account_page: "https://atomscan.com/echelon/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "emoney-3",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/emoney",
        tx_page: "https://ezstaking.app/emoney/txs/${txHash}",
        account_page: "https://ezstaking.app/emoney/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/e-money",
        tx_page: "https://ping.pub/e-money/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/emoney",
        tx_page: "https://atomscan.com/emoney/transactions/${txHash}",
        account_page: "https://atomscan.com/emoney/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "empowerchain-1",
    explorers: [
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/empowerchain",
        tx_page: "https://staking-explorer.com/transaction.php?chain=empowerchain&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=empowerchain&addr=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Empower-Mainnet",
        tx_page: "https://explorer.stavr.tech/Empower-Mainnet/txs/${txHash}",
        account_page: "https://explorer.stavr.tech/Empower-Mainnet/account/${accountAddress}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/empower",
        tx_page: "https://explorer.nodestake.top/empower/tx/${txHash}",
        account_page: "https://explorer.nodestake.top/empower/account/{$accountAddress}"
      },
      {
        kind: "Stake Village",
        url: "https://exp.stakevillage.net/empower",
        tx_page: "https://exp.stakevillage.net/empower/tx/${txHash}",
        account_page: "https://exp.stakevillage.net/empower/account/${accountAddress}"
      },
      {
        kind: "Decloud Nodes Lab",
        url: "https://explorer.declab.pro/Empower",
        tx_page: "https://explorer.declab.pro/Empower/tx/${txHash}",
        account_page: "https://explorer.declab.pro/Empower/account/{$accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/empowerchain",
        tx_page: "https://mainnet.whispernode.com/empowerchain/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/empowerchain/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "epix_4242-1",
    explorers: [
      {
        kind: "Silk Nodes Explorer",
        url: "https://explorer.silknodes.io/epix",
        tx_page: "https://explorer.silknodes.io/osmosis/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "1",
    explorers: [
      {
        kind: "Etherscan",
        url: "https://etherscan.io/",
        tx_page: "https://etherscan.io/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "ethos_7003-1",
    explorers: []
  },
  {
    chainId: "evmos_9001-2",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/evmos",
        tx_page: "https://ezstaking.app/evmos/txs/${txHash}",
        account_page: "https://ezstaking.app/evmos/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/evmos",
        tx_page: "https://www.mintscan.io/evmos/transactions/${txHash}",
        account_page: "https://www.mintscan.io/evmos/accounts/${accountAddress}"
      },
      {
        kind: "blockscout",
        url: "https://evm.evmos.org",
        tx_page: "https://evm.evmos.org/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/evmos",
        tx_page: "https://ping.pub/evmos/tx/${txHash}"
      },
      {
        kind: "explorers.guru",
        url: "https://evmos.explorers.guru",
        tx_page: "https://evmos.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/evmos",
        tx_page: "https://staking-explorer.com/transaction.php?chain=evmos&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=evmos&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/evmos",
        tx_page: "https://atomscan.com/evmos/transactions/${txHash}",
        account_page: "https://atomscan.com/evmos/accounts/${accountAddress}"
      },
      {
        kind: "tcnetwork",
        url: "https://evmos.tcnetwork.io",
        tx_page: "https://evmos.tcnetwork.io/transaction/${txHash}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/evmos",
        account_page: "https://stakeflow.io/evmos/accounts/${accountAddress}"
      },
      {
        kind: "Stake Village",
        url: "https://exp.stakevillage.net/evmos",
        tx_page: "https://exp.stakevillage.net/evmos/tx/${txHash}",
        account_page: "https://exp.stakevillage.net/evmos/accounts/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/evmos",
        tx_page: "https://explorer.stavr.tech/evmos/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/evmos/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "fetchhub-4",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/fetchai",
        tx_page: "https://www.mintscan.io/fetchai/transactions/${txHash}",
        account_page: "https://www.mintscan.io/fetchai/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/fetchhub",
        tx_page: "https://ezstaking.app/fetchhub/txs/${txHash}",
        account_page: "https://ezstaking.app/fetchhub/account/${accountAddress}"
      },
      {
        kind: "bigdipper",
        url: "https://explore-fetchhub.fetch.ai",
        tx_page: "https://explore-fetchhub.fetch.ai/transactions/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/fetchhub",
        tx_page: "https://ping.pub/fetchhub/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/fetchai",
        tx_page: "https://atomscan.com/fetchai/transactions/${txHash}",
        account_page: "https://atomscan.com/fetchai/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/fetchhub",
        tx_page: "https://staking-explorer.com/transaction.php?chain=fetchhub&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=fetchhub&addr=${accountAddress}"
      },
      {
        kind: "bigdipper",
        url: "https://fetch-explorer.teasel.org",
        tx_page: "https://fetch-explorer.teasel.org/transactions/${txHash}"
      },
      {
        kind: "azoyalabs",
        url: "https://fetchstation.azoyalabs.com/mainnet",
        tx_page: "https://fetchstation.azoyalabs.com/mainnet/explorer/transactions/${txHash}",
        account_page: "https://fetchstation.azoyalabs.com/mainnet/explorer/address/${accountAddress}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
        url: "https://explorer.nodeshub.online/fetchhub/",
        tx_page: "https://explorer.nodeshub.online/fetchhub/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/fetchhub/accounts/${accountAddress}"
      },
      {
        kind: "Blockchain Explorer by AVIAONE 🟢",
        url: "https://mainnet.explorer.aviaone.com/fetchhub",
        tx_page: "https://mainnet.explorer.aviaone.com/fetchhub/tx/${txHash}",
        account_page: "https://mainnet.explorer.aviaone.com/fetchhub/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "finschia-2",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/finschia",
        tx_page: "https://www.mintscan.io/finschia/tx/${txHash}",
        account_page: "https://www.mintscan.io/finschia/address/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/finschia",
        tx_page: "https://ezstaking.app/finschia/txs/${txHash}",
        account_page: "https://ezstaking.app/finschia/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "colosseum-1",
    explorers: [
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/firmachain",
        tx_page: "https://staking-explorer.com/transaction.php?chain=firmachain&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=firmachain&addr=${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/firmachain",
        tx_page: "https://ezstaking.app/firmachain/txs/${txHash}",
        account_page: "https://ezstaking.app/firmachain/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Firmachain-M",
        tx_page: "https://explorer.stavr.tech/Firmachain-M/txs/${txHash}",
        account_page: "https://explorer.stavr.tech/Firmachain-M/account/${accountAddress}"
      },
      {
        kind: "bigdipper",
        url: "https://explorer.firmachain.dev",
        tx_page: "https://explorer.firmachain.dev/transactions/${txHash}"
      },
      {
        kind: "explorer.ChainTools",
        url: "https://explorer.chaintools.tech/firmachain",
        tx_page: "https://explorer.chaintools.tech/firmachain/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/firmachain",
        tx_page: "https://atomscan.com/firmachain/transactions/${txHash}",
        account_page: "https://atomscan.com/firmachain/accounts/${accountAddress}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
        url: "https://explorer.nodeshub.online/firmachain/",
        tx_page: "https://explorer.nodeshub.online/firmachain/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/firmachain/accounts/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/firmachain",
        tx_page: "https://explorer.whenmoonwhenlambo.money/firmachain/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/firmachain/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "furya-1",
    explorers: [
      {
        kind: "Furya Explorer",
        url: "https://explorer.furya.network/furya-1/",
        tx_page: "https://explorer.furya.network/furya-1/tx/${txHash}",
        account_page: "https://explorer.furya.network/furya-1/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/furya",
        tx_page: "https://staking-explorer.com/transaction.php?chain=furya&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=furya&addr=${accountAddress}"
      },
      {
        kind: "Nodeshub Explorer",
        url: "https://explorer.nodeshub.online/furya",
        tx_page: "https://explorer.nodeshub.online/furya/txs/${txHash}",
        account_page: "https://explorer.nodeshub.online/furya/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "fxcore",
    explorers: [
      {
        kind: "starscan",
        url: "https://starscan.io",
        tx_page: "https://starscan.io/fxcore/tx/${txHash}",
        account_page: "https://starscan.io/fxcore/address/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/fx",
        tx_page: "https://explorer.tcnetwork.io/fx/transaction/${txHash}",
        account_page: "https://explorer.tcnetwork.io/fx/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/fxcore",
        tx_page: "https://ping.pub/fxcore/tx/${txHash}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
        url: "https://explorer.nodeshub.online/fxcore/",
        tx_page: "https://explorer.nodeshub.online/fxcore/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/fxcore/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "galaxy-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer.postcapitalist.io/Galaxy",
        tx_page: "https://explorer.postcapitalist.io/Galaxy/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "wormchain",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://bigdipper.live/wormhole",
        tx_page: "https://bigdipper.live/wormhole/transactions/${txHash}",
        account_page: "https://bigdipper.live/wormhole/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "genesis_29-2",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/genesisL1",
        tx_page: "https://ping.pub/genesisL1/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://exp.utsa.tech/genesis",
        tx_page: "https://exp.utsa.tech/genesis/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Genesisl1",
        tx_page: "https://explorer.stavr.tech/Genesisl1/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Genesisl1/accounts/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/genesisl1",
        tx_page: "https://atomscan.com/genesisl1/transactions/${txHash}",
        account_page: "https://atomscan.com/genesisl1/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "gitopia",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/gitopia",
        tx_page: "https://ping.pub/gitopia/tx/${txHash}",
        account_page: "https://ping.pub/gitopia/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/gitopia",
        tx_page: "https://staking-explorer.com/transaction.php?chain=gitopia&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=gitopia&addr=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Gitopia-M",
        tx_page: "https://explorer.stavr.tech/Gitopia-M/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Gitopia-M/account/${accountAddress}"
      },
      {
        kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀",
        url: "https://exp.utsa.tech/gitopia",
        tx_page: "https://exp.utsa.tech/gitopia/tx/${txHash}",
        account_page: "https://exp.utsa.tech/gitopia/account/${accountAddress}"
      },
      {
        kind: "Nodeist",
        url: "https://exp.nodeist.net/gitopia",
        tx_page: "https://exp.nodeist.net/gitopia/tx/${txHash}",
        account_page: "https://exp.nodeist.net/gitopia/account/${accountAddress}"
      },
      {
        kind: "Stake-Take",
        url: "https://explorer.stake-take.com/gitopia",
        tx_page: "https://explorer.stake-take.com/gitopia/tx/${txHash}",
        account_page: "https://explorer.stake-take.com/gitopia/account/${accountAddress}"
      },
      {
        kind: "NODEXPLORER",
        url: "https://explorer.nodexcapital.com/gitopia",
        tx_page: "https://explorer.nodexcapital.com/gitopia/tx/${txHash}",
        account_page: "https://explorer.nodexcapital.com/gitopia/account/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/gitopia",
        tx_page: "https://explorer.tcnetwork.io/gitopia/transaction/${txHash}",
        account_page: "https://explorer.tcnetwork.io/gitopia/account/${accountAddress}"
      },
      {
        kind: "NodeStake",
        url: "https://explorer.nodestake.top/gitopia",
        tx_page: "https://explorer.nodestake.top/gitopia/tx/${txHash}",
        account_page: "https://explorer.nodestake.top/gitopia/account/${accountAddress}"
      },
      {
        kind: "Roomit",
        url: "https://explorer.tendermint.roomit.xyz/gitopia-mainnet",
        tx_page: "https://explorer.tendermint.roomit.xyz/gitopia-mainnet/transaction/${txHash}",
        account_page: "https://explorer.tendermint.roomit.xyz/gitopia-mainnet/account/${accountAddress}"
      },
      {
        kind: "Moonbridge",
        url: "https://explorer.moonbridge.team/gitopia",
        tx_page: "https://explorer.moonbridge.team/gitopia/tx/${txHash}",
        account_page: "https://explorer.moonbridge.team/gitopia/account/${accountAddress}"
      },
      {
        kind: "KonsorTech",
        url: "https://explorer.konsortech.xyz/gitopia",
        tx_page: "https://explorer.konsortech.xyz/gitopia/tx/${txHash}",
        account_page: "https://explorer.konsortech.xyz/gitopia/account/${accountAddress}"
      },
      {
        kind: "Stake Village",
        url: "https://exp.stakevillage.net/gitopia",
        tx_page: "https://exp.stakevillage.net/gitopia/tx/${txHash}",
        account_page: "https://exp.stakevillage.net/gitopia/account/${accountAddress}"
      },
      {
        kind: "AlxVoy ⚡ ANODE.TEAM",
        url: "https://main.anode.team/gitopia",
        tx_page: "https://main.anode.team/gitopia/tx/${txHash}",
        account_page: "https://main.anode.team/gitopia/account/${accountAddress}"
      },
      {
        kind: "L0vd.com ❤️",
        url: "https://chain-services.l0vd.com/mainnets/gitopia",
        tx_page: "https://chain-services.l0vd.com/mainnets/gitopia/tx/${txHash}",
        account_page: "https://chain-services.l0vd.com/mainnets/gitopia/account/${accountAddress}"
      },
      {
        kind: "ToTheMars",
        url: "https://explorer.tothemars.network/gitopia",
        tx_page: "https://explorer.tothemars.network/gitopia/tx/${txHash}",
        account_page: "https://explorer.tothemars.network/gitopia/account/${accountAddress}"
      },
      {
        kind: "Decloud Nodes Lab",
        url: "https://explorer.declab.pro/Gitopia",
        tx_page: "https://explorer.declab.pro/Gitopia/tx/${txHash}",
        account_page: "https://explorer.declab.pro/Gitopia/account/${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/gitopia",
        tx_page: "https://mainnet.whispernode.com/gitopia/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/gitopia/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "govgen-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer.govgen.io/",
        tx_page: "https://explorer.govgen.io/govgen/tx/${txHash}",
        account_page: "https://explorer.govgen.io/govgen/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/govgen",
        tx_page: "https://staking-explorer.com/transaction.php?chain=govgen&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=govgen&addr=${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.nodeshub.online/govgen",
        tx_page: "https://explorer.nodeshub.online/govgen/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/govgen/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.equinoxdao.xyz/govgen",
        tx_page: "https://explorer.equinoxdao.xyz/govgen/tx/${txHash}",
        account_page: "https://explorer.equinoxdao.xyz/govgen/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://test.explorer.ist/govgen",
        tx_page: "https://test.explorer.ist/govgen/tx/${txHash}",
        account_page: "https://test.explorer.ist/govgen/account/${accountAddress}"
      },
      {
        kind: "posthuman",
        url: "https://explorer.posthuman.digital/govgen",
        tx_page: "https://explorer.posthuman.digital/govgen/tx/${txHash}",
        account_page: "https://explorer.posthuman.digital/govgen/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "gravity-bridge-3",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/gravitybridge",
        tx_page: "https://ezstaking.app/gravitybridge/txs/${txHash}",
        account_page: "https://ezstaking.app/gravitybridge/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/gravity-bridge",
        tx_page: "https://www.mintscan.io/gravity-bridge/transactions/${txHash}",
        account_page: "https://www.mintscan.io/gravity-bridge/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/gravity-bridge",
        tx_page: "https://ping.pub/gravity-bridge/tx/${txHash}"
      },
      {
        kind: "explorers.guru",
        url: "https://gravity.explorers.guru",
        tx_page: "https://gravity.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/gravity-bridge",
        tx_page: "https://atomscan.com/gravity-bridge/transactions/${txHash}",
        account_page: "https://atomscan.com/gravity-bridge/accounts/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/gravitybridge",
        tx_page: "https://explorer.tcnetwork.io/gravitybridge/transaction/${txHash}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/gravity-bridge",
        account_page: "https://stakeflow.io/gravity-bridge/accounts/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/GravityBridge",
        tx_page: "https://explorer.stavr.tech/GravityBridge/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/GravityBridge/accounts/${accountAddress}"
      },
      {
        kind: "AviaOne 🟢",
        url: "https://mainnet.explorer.aviaone.com/gravity-bridge",
        tx_page: "https://mainnet.explorer.aviaone.com/gravity-bridge/tx/${txHash}",
        account_page: "https://mainnet.explorer.aviaone.com/gravity-bridge/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "haqq_11235-1",
    explorers: [
      {
        kind: "blockscout",
        url: "https://explorer.haqq.network",
        tx_page: "https://explorer.haqq.network/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/haqq",
        tx_page: "https://ping.pub/haqq/tx/${txHash}"
      },
      {
        kind: "explorers.guru",
        url: "https://haqq.explorers.guru",
        tx_page: "https://haqq.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/haqq",
        tx_page: "https://staking-explorer.com/transaction.php?chain=haqq&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=haqq&addr=${accountAddress}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/haqq",
        tx_page: "https://explorer.nodestake.top/haqq/tx/${txHash}"
      },
      {
        kind: "KonsorTech Explorer",
        url: "https://explorer.konsortech.xyz/haqq",
        tx_page: "https://explorer.konsortech.xyz/haqq/tx/${txHash}"
      },
      {
        kind: "Palamar Explorer",
        url: "https://explorer.palamar.io/haqq",
        tx_page: "https://explorer.palamar.io/haqq/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "helichain",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer.helichain.com/Helichain",
        tx_page: "https://explorer.helichain.com/Helichain/tx/${txHash}",
        account_page: "https://explorer.helichain.com/Helichain/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/heli",
        tx_page: "https://staking-explorer.com/transaction.php?chain=heli&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=heli&addr=${accountAddress}"
      }
    ]
  },
  {
    chainId: "highbury_710-1",
    explorers: [
      {
        kind: "pingpub",
        url: "https://explorer.furya.wtf/",
        tx_page: "https://www.explorer.furya.wtf//txs/${txHash}",
        account_page: "https://explorer.furya.wtf//account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "humans_1089-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://mintscan.io/humans",
        tx_page: "https://www.mintscan.io/humans/tx/${txHash}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/humans",
        tx_page: "https://ezstaking.app/humans/txs/${txHash}",
        account_page: "https://ezstaking.app/humans/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/humans",
        tx_page: "https://ping.pub/humans/tx/${txHash}"
      },
      {
        kind: "explorers.guru",
        url: "https://humans.explorers.guru",
        tx_page: "https://humans.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/humans",
        tx_page: "https://staking-explorer.com/transaction.php?chain=humans&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=humans&addr=${accountAddress}"
      },
      {
        kind: "exploreme",
        url: "https://humansai.exploreme.pro/",
        tx_page: "https://humans.exploreme.pro/transaction/${txHash}"
      },
      {
        kind: "itrocket",
        url: "https://mainnet.itrocket.net/humans/staking",
        tx_page: "https://mainnet.itrocket.net/humans/tx/${txHash}",
        account_page: "https://mainnet.itrocket.net/humans/account/${accountAddress}"
      },
      {
        kind: "posthuman",
        url: "https://explorer.posthuman.digital/humans",
        tx_page: "https://explorer.posthuman.digital/humans/tx/${txHash}",
        account_page: "https://explorer.posthuman.digital/humans/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "Antora",
    explorers: [
      {
        kind: "chadscan",
        url: "https://chadscan.com",
        tx_page: "https://chadscan.com/transactions/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/idep",
        tx_page: "https://atomscan.com/idep/transactions/${txHash}",
        account_page: "https://atomscan.com/idep/accounts/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/idep",
        tx_page: "https://explorer.tcnetwork.io/idep/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "ixo-5",
    explorers: [
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/impacthub",
        tx_page: "https://staking-explorer.com/transaction.php?chain=impacthub&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=impacthub&addr=${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/ixo",
        tx_page: "https://ezstaking.app/ixo/txs/${txHash}",
        account_page: "https://ezstaking.app/ixo/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/IXO-Mainnet",
        tx_page: "https://explorer.stavr.tech/IXO-Mainnet/txs/${txHash}",
        account_page: "https://explorer.stavr.tech/IXO-Mainnet/account/${accountAddress}"
      },
      {
        kind: "bigdipper",
        url: "https://blockscan.ixo.world",
        tx_page: "https://blockscan.ixo.world/transactions/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/ixo",
        tx_page: "https://ping.pub/ixo/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/ixo",
        tx_page: "https://atomscan.com/ixo/transactions/${txHash}",
        account_page: "https://atomscan.com/ixo/accounts/${accountAddress}"
      },
      {
        kind: "Mintscan",
        url: "https://www.mintscan.io/ixo",
        tx_page: "https://www.mintscan.io/ixo/transactions/${txHash}",
        account_page: "https://www.mintscan.io/ixo/accounts/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/ixo",
        tx_page: "https://explorer.whenmoonwhenlambo.money/ixo/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/ixo/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "imversed_5555555-1",
    explorers: [
      {
        kind: "blockscout",
        url: "https://txe.imversed.network/",
        tx_page: "https://txe.imversed.network/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "injective-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/injective",
        tx_page: "https://ezstaking.app/injective/txs/${txHash}",
        account_page: "https://ezstaking.app/injective/account/${accountAddress}"
      },
      {
        kind: "injectiveprotocol",
        url: "https://explorer.injective.network/",
        tx_page: "https://explorer.injective.network/transaction/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/injective",
        tx_page: "https://ping.pub/injective/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/injective",
        tx_page: "https://atomscan.com/injective/transactions/${txHash}",
        account_page: "https://atomscan.com/injective/accounts/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/injective",
        tx_page: "https://www.mintscan.io/injective/transactions/${txHash}",
        account_page: "https://www.mintscan.io/injective/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/injective",
        tx_page: "https://staking-explorer.com/transaction.php?chain=injective&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=injective&addr=${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/injective",
        account_page: "https://stakeflow.io/injective/accounts/${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/injective",
        tx_page: "https://mainnet.whispernode.com/injective/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/injective/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "int3face-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer.int3face.zone",
        tx_page: "https://explorer.int3face.zone/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "irishub-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/irisnet",
        tx_page: "https://ezstaking.app/irisnet/txs/${txHash}",
        account_page: "https://ezstaking.app/irisnet/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/iris",
        tx_page: "https://www.mintscan.io/iris/transactions/${txHash}",
        account_page: "https://www.mintscan.io/iris/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/iris-network",
        tx_page: "https://ping.pub/iris-network/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/irisnet",
        tx_page: "https://staking-explorer.com/transaction.php?chain=irisnet&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=irisnet&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/iris-network",
        tx_page: "https://atomscan.com/iris-network/transactions/${txHash}",
        account_page: "https://atomscan.com/iris-network/accounts/${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/irisnet",
        account_page: "https://stakeflow.io/irisnet/accounts/${accountAddress}"
      },
      {
        kind: "Nodeist Explorer",
        url: "https://exp.nodeist.net/iris",
        tx_page: "https://exp.nodeist.net/iris/tx/${txHash}"
      },
      {
        kind: "L0vd.com ❤️",
        url: "https://explorers.l0vd.com/iris-mainnet",
        tx_page: "https://explorers.l0vd.com/iris-mainnet/tx/${txHash}"
      },
      {
        kind: "KonsorTech",
        url: "https://explorer.konsortech.xyz/iris",
        tx_page: "https://explorer.konsortech.xyz/iris/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "jackal-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/jackal",
        tx_page: "https://ping.pub/jackal/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/jackal",
        tx_page: "https://staking-explorer.com/transaction.php?chain=jackal&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=jackal&addr=${accountAddress}"
      },
      {
        kind: "NodeStake",
        url: "https://explorer.nodestake.top/jackal",
        tx_page: "https://explorer.nodestake.top/jackal/tx/${txHash}"
      },
      {
        kind: "BccNodes",
        url: "https://explorer.bccnodes.com/jackal",
        tx_page: "https://explorer.bccnodes.com/jackal/tx/${txHash}"
      },
      {
        kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀",
        url: "https://exp.utsa.tech/jackal",
        tx_page: "https://exp.utsa.tech/jackal/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/jackal",
        tx_page: "https://explorer.stavr.tech/jackal/tx/${txHash}"
      },
      {
        kind: "Nodeist Explorer",
        url: "https://exp.nodeist.net/jackal",
        tx_page: "https://exp.nodeist.net/jackal/tx/${txHash}"
      },
      {
        kind: "Big Dipper",
        url: "https://bigdipper.live/jackal",
        tx_page: "https://bigdipper.live/jackal/transactions/${txHash}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/jackal",
        tx_page: "https://mainnet.whispernode.com/jackal/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/jackal/account/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/jackal",
        tx_page: "https://explorer.whenmoonwhenlambo.money/jackal/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/jackal/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "joltify_1729-1",
    explorers: [
      {
        kind: "big dipper",
        url: "https://explorer.joltify.io/joltify",
        tx_page: "https://explorer.joltify.io/joltify/transactions/${txHash}",
        account_page: "https://explorer.joltify.io/joltify/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/joltify",
        tx_page: "https://staking-explorer.com/transaction.php?chain=joltify&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=joltify&addr=${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/joltify",
        tx_page: "https://explorer.whenmoonwhenlambo.money/joltify/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/joltify/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "juno-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/juno",
        tx_page: "https://ezstaking.app/juno/txs/${txHash}",
        account_page: "https://ezstaking.app/juno/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/juno",
        tx_page: "https://ping.pub/juno/tx/${txHash}"
      },
      {
        kind: "explorers.guru",
        url: "https://juno.explorers.guru",
        tx_page: "https://juno.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/juno",
        tx_page: "https://www.mintscan.io/juno/transactions/${txHash}",
        account_page: "https://www.mintscan.io/juno/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/juno",
        tx_page: "https://staking-explorer.com/transaction.php?chain=juno&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=juno&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/juno",
        tx_page: "https://atomscan.com/juno/transactions/${txHash}",
        account_page: "https://atomscan.com/juno/accounts/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/juno",
        tx_page: "https://explorer.stavr.tech/juno/transactions/${txHash}",
        account_page: "https://explorer.stavr.tech/juno/accounts/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/juno",
        tx_page: "https://explorer.tcnetwork.io/juno/transaction/${txHash}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/juno",
        account_page: "https://stakeflow.io/juno/accounts/${accountAddress}"
      },
      {
        kind: "Decloud Nodes Lab",
        url: "https://explorer.declab.pro/Juno",
        tx_page: "https://explorer.declab.pro/Juno/tx/${txHash}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
        url: "https://explorer.nodeshub.online/juno/",
        tx_page: "https://explorer.nodeshub.online/juno/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/juno/accounts/${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/juno",
        tx_page: "https://mainnet.whispernode.com/juno/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/juno/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "kava_2222-10",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/kava",
        tx_page: "https://www.mintscan.io/kava/transactions/${txHash}",
        account_page: "https://www.mintscan.io/kava/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/kava",
        tx_page: "https://staking-explorer.com/transaction.php?chain=kava&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=kava&addr=${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/kava",
        tx_page: "https://ezstaking.app/kava/txs/${txHash}",
        account_page: "https://ezstaking.app/kava/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/kava",
        tx_page: "https://ping.pub/kava/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/kava",
        tx_page: "https://atomscan.com/kava/transactions/${txHash}",
        account_page: "https://atomscan.com/kava/accounts/${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/kava",
        account_page: "https://stakeflow.io/kava/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "kichain-2",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/kichain",
        tx_page: "https://ezstaking.app/kichain/txs/${txHash}",
        account_page: "https://ezstaking.app/kichain/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/ki-chain",
        tx_page: "https://www.mintscan.io/ki-chain/txs/${txHash}",
        account_page: "https://www.mintscan.io/ki-chain/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Kichain-Mainnet",
        tx_page: "https://explorer.stavr.tech/Kichain-Mainnet/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/kichain",
        tx_page: "https://ping.pub/kichain/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/kichain",
        tx_page: "https://staking-explorer.com/transaction.php?chain=kichain&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=kichain&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/ki-chain",
        tx_page: "https://atomscan.com/ki-chain/transactions/${txHash}",
        account_page: "https://atomscan.com/ki-chain/accounts/${accountAddress}"
      },
      {
        kind: "AVIAONE Explorer 🟢",
        url: "https://mainnet.explorer.aviaone.com/kichain",
        tx_page: "https://mainnet.explorer.aviaone.com/kichain/transactions/${txHash}",
        account_page: "https://mainnet.explorer.aviaone.com/kichain/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "kima_network",
    explorers: [
      {
        kind: "Kima Network Explorer",
        url: "https://explorer.kima.network/",
        tx_page: "https://explorer.kima.network/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "darchub",
    explorers: [
      {
        kind: "konstellation",
        url: "https://explorer.konstellation.tech/",
        tx_page: "https://explorer.konstellation.tech/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/konstellation",
        tx_page: "https://staking-explorer.com/transaction.php?chain=konstellation&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=konstellation&addr=${accountAddress}"
      },
      {
        kind: "cosmotracker",
        url: "https://cosmotracker.com/konstellation",
        tx_page: "https://cosmotracker.com/konstellation/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "kaiyo-1",
    explorers: [
      {
        kind: "kujira",
        url: "https://finder.kujira.app",
        tx_page: "https://finder.kujira.app/kaiyo-1/tx/${txHash}"
      },
      {
        kind: "explorers.guru",
        url: "https://kujira.explorers.guru",
        tx_page: "https://kujira.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/kujira",
        tx_page: "https://staking-explorer.com/transaction.php?chain=kujira&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=kujira&addr=${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/kujira",
        tx_page: "https://ezstaking.app/kujira/txs/${txHash}",
        account_page: "https://ezstaking.app/kujira/account/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/kujira",
        tx_page: "https://atomscan.com/kujira/transactions/${txHash}",
        account_page: "https://atomscan.com/kujira/accounts/${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/kujira",
        tx_page: "https://mainnet.whispernode.com/kujira/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/kujira/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "kyve-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/kyve",
        tx_page: "https://ezstaking.app/kyve/txs/${txHash}",
        account_page: "https://ezstaking.app/kyve/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/kyve",
        tx_page: "https://www.mintscan.io/kyve/txs/${txHash}",
        account_page: "https://www.mintscan.io/kyve/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/kyve",
        tx_page: "https://staking-explorer.com/transaction.php?chain=kyve&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=kyve&addr=${accountAddress}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/kyve",
        tx_page: "https://explorer.nodestake.top/kyve/txs/${txHash}",
        account_page: "https://explorer.nodestake.top/kyve/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Kyve",
        tx_page: "https://explorer.stavr.tech/Kyve/txs/${txHash}",
        account_page: "https://explorer.stavr.tech/Kyve/account/${accountAddress}"
      },
      {
        kind: "Stake-Take",
        url: "https://explorer.stake-take.com/kyve",
        tx_page: "https://explorer.stake-take.com/kyve/txs/${txHash}",
        account_page: "https://explorer.stake-take.com/kyve/account/${accountAddress}"
      },
      {
        kind: "Decloud Nodes Lab",
        url: "https://explorer.declab.pro/Kyve",
        tx_page: "https://explorer.declab.pro/Kyve/txs/${txHash}",
        account_page: "https://explorer.declab.pro/Kyve/account/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/kyve",
        tx_page: "https://explorer.whenmoonwhenlambo.money/kyve/txs/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/kyve/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "lambda_92000-1",
    explorers: [
      {
        kind: "blockscout",
        url: "https://explorer.lambda.im/",
        tx_page: "https://explorer.lambda.im/tx/${txHash}"
      },
      {
        kind: "NodeStake",
        url: "https://explorer.nodestake.top/lambda",
        tx_page: "https://explorer.nodestake.top/lambda/txs/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/lambda",
        tx_page: "https://explorer.stavr.tech/lambda/txs/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/lambda",
        tx_page: "https://atomscan.com/lambda/transactions/${txHash}",
        account_page: "https://atomscan.com/lambda/accounts/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/lambda",
        tx_page: "https://explorer.whenmoonwhenlambo.money/lambda/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/lambda/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "lava-mainnet-1",
    explorers: [
      {
        kind: "finteh",
        url: "https://explorer.finteh.org/lava",
        tx_page: "https://explorer.finteh.org/lava/tx/${txHash}",
        account_page: "https://explorer.finteh.org/lava/account/${accountAddress}"
      },
      {
        kind: "guru",
        url: "https://lava.explorers.guru/",
        tx_page: "https://lava.explorers.guru/transaction/${txHash}",
        account_page: "https://lava.explorers.guru/account/${accountAddress}"
      },
      {
        kind: "w3coins",
        url: "https://lava-explorer.w3coins.io/Lava",
        tx_page: "https://lava-explorer.w3coins.io/Lava/tx/${txHash}",
        account_page: "https://lava-explorer.w3coins.io/Lava/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/lava",
        tx_page: "https://staking-explorer.com/transaction.php?chain=lava&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=lava&addr=${accountAddress}"
      },
      {
        kind: "Stake Village",
        url: "https://exp.stakevillage.net/lava-mainnet",
        tx_page: "https://exp.stakevillage.net/lava-mainnet/tx/${txHash}",
        account_page: "https://exp.stakevillage.net/lava-mainnet/account/${accountAddress}"
      },
      {
        kind: "AVIAONE 🟢",
        url: "https://mainnet.explorer.aviaone.com/lava/",
        tx_page: "https://mainnet.explorer.aviaone.com/lava/tx/${txHash}",
        account_page: "https://mainnet.explorer.aviaone.com/lava/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Lava-Mainnet",
        tx_page: "https://explorer.stavr.tech/Lava-Mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Lava-Mainnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "likecoin-mainnet-2",
    explorers: [
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/likecoin",
        tx_page: "https://staking-explorer.com/transaction.php?chain=likecoin&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=likecoin&addr=${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/likecoin",
        tx_page: "https://ezstaking.app/likecoin/txs/${txHash}",
        account_page: "https://ezstaking.app/likecoin/account/${accountAddress}"
      },
      {
        kind: "lunie-ng",
        url: "https://stake.like.co/"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Likecoin-M",
        tx_page: "https://explorer.stavr.tech/Likecoin-M/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/likecoin",
        tx_page: "https://ping.pub/likecoin/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/likecoin",
        tx_page: "https://atomscan.com/likecoin/transactions/${txHash}",
        account_page: "https://atomscan.com/likecoin/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "logos_7002-1",
    explorers: []
  },
  {
    chainId: "loop-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pfc.zone/loop",
        tx_page: "https://ping.pfc.zone/loop/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "lorenzo_8329-1",
    explorers: [
      {
        kind: "blockscout",
        url: "https://scan.lorenzo-protocol.xyz/",
        tx_page: "https://scan.lorenzo-protocol.xyz/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "loyal-main-02",
    explorers: [
      {
        kind: "Loyal explorer",
        url: "https://pingpub.joinloyal.io/loyal",
        tx_page: "https://pingpub.joinloyal.io/loyal/tx/${txHash}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/loyal",
        tx_page: "https://explorer.tcnetwork.io/loyal/transaction/${txHash}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/loyal",
        tx_page: "https://explorer.nodestake.top/loyal/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "LumenX",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer.chaintools.tech/lumenx",
        tx_page: "https://explorer.chaintools.tech/lumenx/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.cryptonet.pl/lumenx",
        tx_page: "https://explorer.cryptonet.pl/lumenx/tx/${txHash}"
      },
      {
        kind: "Kynraze",
        url: "https://explorer.kynraze.com/lumenx",
        tx_page: "https://explorer.kynraze.com/lumenx/tx/${txHash}"
      },
      {
        kind: "ComunityNode",
        url: "https://explorer.comunitynode.my.id/lumenx",
        tx_page: "https://explorer.comunitynode.my.id/lumenx/tx/${txHash}"
      },
      {
        kind: "Nodine.ID",
        url: "https://explorer.co.id/lumenx",
        tx_page: "https://explorer.co.id/lumenx/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/lumenx",
        tx_page: "https://atomscan.com/lumenx/transactions/${txHash}",
        account_page: "https://atomscan.com/lumenx/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "lum-network-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/lumnetwork",
        tx_page: "https://ezstaking.app/lumnetwork/txs/${txHash}",
        account_page: "https://ezstaking.app/lumnetwork/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/lum",
        tx_page: "https://www.mintscan.io/lum/transactions/${txHash}",
        account_page: "https://www.mintscan.io/lum/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/lumnetwork",
        tx_page: "https://staking-explorer.com/transaction.php?chain=lumnetwork&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=lumnetwork&addr=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/LumNetwork-Mainnet",
        tx_page: "https://explorer.stavr.tech/LumNetwork-Mainnet/tx/${txHash}"
      },
      {
        kind: "lum-network",
        url: "https://explorer.lum.network",
        tx_page: "https://explorer.lum.network/txs/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/lum-network",
        tx_page: "https://ping.pub/lum-network/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/lum-network",
        tx_page: "https://atomscan.com/lum-network/transactions/${txHash}",
        account_page: "https://atomscan.com/lum-network/accounts/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/lum-network",
        tx_page: "https://explorer.whenmoonwhenlambo.money/lum-network/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/lum-network/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "mande_18071918-1",
    explorers: [
      {
        kind: "FYI",
        url: "https://dym.fyi/r/mande",
        tx_page: "https://dym.fyi/r/mande/tx/${txHash}",
        account_page: "https://dym.fyi/r/mande/address/${accountAddress}"
      }
    ]
  },
  {
    chainId: "mantra-1",
    explorers: []
  },
  {
    chainId: "mars-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/mars-protocol",
        tx_page: "https://ezstaking.app/mars-protocol/txs/${txHash}",
        account_page: "https://ezstaking.app/mars-protocol/account/${accountAddress}"
      },
      {
        kind: "BigDipper",
        url: "https://explorer.marsprotocol.io",
        tx_page: "https://explorer.marsprotocol.io/transactions/${txHash}",
        account_page: "https://explorer.marsprotocol.io/accounts/${accountAddress}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/mars",
        tx_page: "https://explorer.nodestake.top/mars/transactions/${txHash}",
        account_page: "https://explorer.nodestake.top/mars/account/${accountAddress}"
      },
      {
        kind: "Nodes.Guru",
        url: "https://mars.explorers.guru/",
        tx_page: "https://mars.explorers.guru/transaction/${txHash}",
        account_page: "https://mars.explorers.guru/account/${accountAddress}"
      },
      {
        kind: "MintScan",
        url: "https://www.mintscan.io/mars-protocol",
        tx_page: "https://www.mintscan.io/mars-protocol/transactions/${txHash}",
        account_page: "https://www.mintscan.io/mars-protocol/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/mars",
        tx_page: "https://ping.pub/mars/tx/${txHash}",
        account_page: "https://ping.pub/mars/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "mayachain-mainnet-v1",
    explorers: [
      {
        kind: "Maya Protocol explorer",
        url: "https://www.explorer.mayachain.info",
        tx_page: "https://www.explorer.mayachain.info/#/txs/${txHash}"
      }
    ]
  },
  {
    chainId: "medasdigital-1",
    explorers: [
      {
        kind: "BigDipper",
        url: "https://explorer.medas-digital.io:3100/medasdigital",
        tx_page: "https://explorer.medas-digital.io:3100/medasdigital/transactions/${txHash}",
        account_page: "explorer.medas-digital.io:3100/medasdigital/accounts/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/frontier/medasdigital",
        tx_page: "https://atomscan.com/frontier/medasdigital/transactions/${txHash}",
        account_page: "https://atomscan.com/frontier/medasdigital/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "meme-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/meme",
        tx_page: "https://ping.pub/meme/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/meme",
        tx_page: "https://atomscan.com/meme/transactions/${txHash}",
        account_page: "https://atomscan.com/meme/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/meme",
        tx_page: "https://staking-explorer.com/transaction.php?chain=meme&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=meme&addr=${accountAddress}"
      },
      {
        kind: "MEME Explorer",
        url: "https://explorer.meme.sx/meme",
        tx_page: "https://explorer.meme.sx/meme/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/meme",
        tx_page: "https://atomscan.com/meme/transactions/${txHash}",
        account_page: "https://atomscan.com/meme/accounts/${accountAddress}"
      },
      {
        kind: "Brochain",
        url: "https://explorer.brocha.in/meme",
        tx_page: "https://explorer.brocha.in/meme/tx/${txHash}"
      },
      {
        kind: "Stake-Take",
        url: "https://explorer.stake-take.com/meme",
        tx_page: "https://explorer.stake-take.com/meme/tx/${txHash}",
        account_page: "https://explorer.stake-take.com/meme/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Meme",
        tx_page: "https://explorer.stavr.tech/Meme/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Meme/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "microtick-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/microtick",
        tx_page: "https://ping.pub/microtick/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "migaloo-1",
    explorers: [
      {
        kind: "Migaloo Explorers Guru",
        url: "https://migaloo.explorers.guru",
        tx_page: "https://migaloo.explorers.guru/transaction/${txHash}",
        account_page: "https://migaloo.explorers.guru/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/migaloo",
        tx_page: "https://ping.pub/migaloo/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/migaloo",
        tx_page: "https://staking-explorer.com/transaction.php?chain=migaloo&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=migaloo&addr=${accountAddress}"
      },
      {
        kind: "Silk Nodes",
        url: "https://explorer.silknodes.io/migaloo",
        tx_page: "https://explorer.silknodes.io/migaloo/tx/${txHash}",
        account_page: "https://explorer.silknodes.io/migaloo/account/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/migaloo",
        tx_page: "https://atomscan.com/migaloo/transactions/${txHash}",
        account_page: "https://atomscan.com/migaloo/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "mainnet",
    explorers: [
      {
        kind: "Mises-GW Explorer",
        url: "https://gw.mises.site",
        tx_page: "https://gw.mises.site/tx/${txHash}"
      },
      {
        kind: "Jambulmerah ping.pub based",
        url: "https://explorer.jambulmerah.dev/mises",
        tx_page: "https://explorer.jambulmerah.dev/mises/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "mtgbp-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://blockexplorer.mtgbp.com/mtgbp",
        tx_page: "https://blockexplorer.mtgbp.com/mtgbp/tx/${txHash}",
        account_page: "https://blockexplorer.mtgbp.com/mtgbp/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "mun-1",
    explorers: [
      {
        url: "https://explorer.mun.money/mun",
        tx_page: "https://explorer.mun.money/mun/${txHash}"
      },
      {
        url: "https://explorer.indonode.net/mun/staking",
        tx_page: "https://explorer.indonode.net/mun/${txHash}"
      },
      {
        url: "https://explorer.konsortech.xyz/mun/staking",
        tx_page: "https://explorer.konsortech.xyz/mun/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/mun",
        tx_page: "https://ping.pub/mun/${txHash}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/mun",
        tx_page: "https://explorer.tcnetwork.io/mun/transaction/${txHash}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/mun",
        tx_page: "https://explorer.whenmoonwhenlambo.money/mun/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/mun/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "mythos_7001-1",
    explorers: []
  },
  {
    chainId: "neura_266-1"
  },
  {
    chainId: "Neutaro-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer.neutaro.tech/Neutaro",
        tx_page: "https://explorer.neutaro.tech/Neutaro/tx/${txHash}",
        account_page: "https://explorer.neutaro.tech/Neutaro/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "neutron-1",
    explorers: [
      {
        kind: "Mintscan",
        url: "https://www.mintscan.io/neutron",
        tx_page: "https://www.mintscan.io/neutron/transactions/${txHash}",
        account_page: "https://www.mintscan.io/neutron/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/neutron",
        tx_page: "https://ezstaking.app/neutron/txs/${txHash}",
        account_page: "https://ezstaking.app/neutron/account/${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/neutron",
        tx_page: "https://mainnet.whispernode.com/neutron/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/neutron/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "cataclysm-1",
    explorers: [
      {
        kind: "Nodes Guru",
        url: "https://nibiru.explorers.guru/",
        tx_page: "https://nibiru.explorers.guru/transaction/${txHash}",
        account_page: "https://nibiru.explorers.guru/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/nibiru",
        tx_page: "https://staking-explorer.com/transaction.php?chain=nibiru&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=nibiru&addr=${accountAddress}"
      },
      {
        kind: "NodeStake",
        url: "https://explorer.nodestake.org/nibiru",
        tx_page: "https://explorer.nodestake.org/nibiru/tx/${txHash}",
        account_page: "https://explorer.nodestake.org/nibiru/account/${accountAddress}"
      },
      {
        kind: "LiveRaveN",
        url: "https://mainnet.explorer.liveraven.net/nibiru",
        tx_page: "https://mainnet.explorer.liveraven.net/nibiru/tx/${txHash}",
        account_page: "https://mainnet.explorer.liveraven.net/nibiru/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Nibiru-Mainnet",
        tx_page: "https://explorer.stavr.tech/Nibiru-Mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Nibiru-Mainnet/account/${accountAddress}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
        url: "https://explorer.nodeshub.online/nibiru/",
        tx_page: "https://explorer.nodeshub.online/nibiru/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/nibiru/accounts/${accountAddress}"
      },
      {
        kind: "Stake Village",
        url: "https://exp.stakevillage.net/nibiru-mainnet",
        tx_page: "https://exp.stakevillage.net/nibiru-mainnet/tx/${txHash}",
        account_page: "https://exp.stakevillage.net/nibiru-mainnet/accounts/${accountAddress}"
      },
      {
        kind: "Roomit",
        url: "https://explorer.tendermint.roomit.xyz/nibiru-mainnet",
        tx_page: "https://explorer.tendermint.roomit.xyz/nibiru-mainnet/tx/${txHash}",
        account_page: "https://explorer.tendermint.roomit.xyz/nibiru-mainnet/accounts/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/nibiru",
        tx_page: "https://explorer.whenmoonwhenlambo.money/nibiru/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/nibiru/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "nim_1122-1",
    explorers: [
      {
        kind: "FYI",
        url: "https://dym.fyi/r/nim",
        tx_page: "https://dym.fyi/r/nim/tx/${txHash}",
        account_page: "https://dym.fyi/r/nim/address/${accountAddress}"
      }
    ]
  },
  {
    chainId: "noble-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/noble",
        tx_page: "https://www.mintscan.io/noble/txs/${txHash}",
        account_page: "https://www.mintscan.io/noble/account/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/noble",
        tx_page: "https://ezstaking.app/noble/txs/${txHash}",
        account_page: "https://ezstaking.app/noble/account/${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/noble",
        account_page: "https://stakeflow.io/noble/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "nois-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/nois",
        tx_page: "https://ezstaking.app/nois/txs/${txHash}",
        account_page: "https://ezstaking.app/nois/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/nois",
        tx_page: "https://staking-explorer.com/transaction.php?chain=nois&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=nois&addr=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/nois-mainnet",
        tx_page: "https://explorer.stavr.tech/nois-mainnet/txs/${txHash}",
        account_page: "https://explorer.stavr.tech/nois-mainnet/account/${accountAddress}"
      },
      {
        kind: "BccNodes",
        url: "https://explorer.stavr.tech/nois-mainnet",
        tx_page: "https://explorer.bccnodes.com/nois-M/txs/${txHash}",
        account_page: "https://explorer.bccnodes.com/nois-M/account/${accountAddress}"
      },
      {
        kind: "explorers.guru",
        url: "https://nois.explorers.guru",
        tx_page: "https://nois.explorers.guru/transaction/${txHash}",
        account_page: "https://nois.explorers.guru/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "pirin-1",
    explorers: [
      {
        kind: "Nolus Explorer",
        url: "https://explorer.nolus.io/pirin-1",
        tx_page: "https://explorer.nolus.io/pirin-1/tx/${txHash}",
        account_page: "https://explorer.nolus.io/pirin-1/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/nolus",
        tx_page: "https://ping.pub/nolus/tx/${txHash}",
        account_page: "https://ping.pub/nolus/account/${accountAddress}"
      },
      {
        kind: "NODEXPLORER",
        url: "https://explorer.nodexcapital.com/nolus",
        tx_page: "https://explorer.nodexcapital.com/nolus/tx/${txHash}",
        account_page: "https://explorer.nodexcapital.com/nolus/account/${accountAddress}"
      },
      {
        kind: "Nodes Guru Explorer",
        url: "https://nolus.explorers.guru",
        tx_page: "https://nolus.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/nolus",
        tx_page: "https://staking-explorer.com/transaction.php?chain=nolus&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=nolus&addr=${accountAddress}"
      },
      {
        kind: "KJ Nodes Explorer",
        url: "https://explorer.kjnodes.com/nolus",
        tx_page: "https://explorer.kjnodes.com/nolus/tx/${txHash}",
        account_page: "https://explorer.kjnodes.com/nolus/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "nomic-stakenet-3",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://bigdipper.live/nomic",
        account_page: "https://bigdipper.live/nomic/accounts/${accountAddress}",
        tx_page: "https://bigdipper.live/nomic/transactions/${txHash}"
      },
      {
        kind: "Zenscan.io",
        url: "https://nomic.zenscan.io/index.php",
        account_page: "https://nomic.zenscan.io/address.php?address=${accountAddress}",
        tx_page: "https://nomic.zenscan.io/transaction.php?hash=${txHash}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/nomic",
        tx_page: "https://mainnet.whispernode.com/nomic/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/nomic/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "nyx",
    explorers: [
      {
        kind: "Nodes Guru explorer",
        url: "https://nym.explorers.guru/",
        tx_page: "https://nym.explorers.guru/transaction/${txHash}",
        account_page: "https://nym.explorers.guru/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/nyx",
        tx_page: "https://staking-explorer.com/transaction.php?chain=nyx&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=nyx&addr=${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/nyx",
        tx_page: "https://ezstaking.app/nyx/txs/${txHash}",
        account_page: "https://ezstaking.app/nyx/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/nyx",
        tx_page: "https://www.mintscan.io/nyx/transactions/${txHash}",
        account_page: "https://www.mintscan.io/nyx/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/nyx",
        tx_page: "https://ping.pub/nyx/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "octa",
    explorers: [
      {
        kind: "Octa explorer",
        url: "http://explorer.octa-coin.com/",
        tx_page: "http://explorer.octa-coin.com/txs/${txHash}"
      }
    ]
  },
  {
    chainId: "odin-mainnet-freya",
    explorers: [
      {
        kind: "odin web",
        url: "https://mainnet.odinprotocol.io/",
        tx_page: "https://mainnet.odinprotocol.io/transactions/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/odin",
        tx_page: "https://ping.pub/odin/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "exchain-66",
    explorers: [
      {
        kind: "OKLink",
        url: "https://www.oklink.com/en/okc",
        tx_page: "https://www.oklink.com/en/okc/tx/${txHash}",
        account_page: "https://www.oklink.com/en/okc/address/${accountAddress}"
      }
    ]
  },
  {
    chainId: "omniflixhub-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/omniflix",
        tx_page: "https://www.mintscan.io/omniflix/transactions/${txHash}",
        account_page: "https://www.mintscan.io/omniflix/accounts/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/omniflixhub",
        tx_page: "https://atomscan.com/omniflixhub/transactions/${txHash}",
        account_page: "https://atomscan.com/omniflixhub/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/omniflixhub",
        tx_page: "https://staking-explorer.com/transaction.php?chain=omniflixhub&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=omniflixhub&addr=${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/omniflixhub",
        tx_page: "https://ezstaking.app/omniflixhub/txs/${txHash}",
        account_page: "https://ezstaking.app/omniflixhub/account/${accountAddress}"
      },
      {
        kind: "STAKR.space explorer",
        url: "https://explorer.stakr.space/omniflix/",
        tx_page: "https://explorer.stakr.space/omniflix/tx/${txHash}",
        account_page: "https://explorer.stakr.space/omniflix/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "onex-mainnet-1",
    explorers: [
      {
        kind: "Dexplorer - must enter rpc link provided above",
        url: "https://dexplorer.cakralabs.site",
        tx_page: "https://dexplorer.cakralabs.site/txs/${txHash}",
        account_page: "https://dexplorer.cakralabs.site/${accountAddress}"
      }
    ]
  },
  {
    chainId: "onomy-mainnet-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/onomy-protocol",
        tx_page: "https://www.mintscan.io/onomy-protocol/transactions/${txHash}",
        account_page: "https://www.mintscan.io/onomy-protocol/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/onomy",
        tx_page: "https://staking-explorer.com/transaction.php?chain=onomy&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=onomy&addr=${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/onomy",
        tx_page: "https://ezstaking.app/onomy/txs/${txHash}",
        account_page: "https://ezstaking.app/onomy/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "Oraichain",
    explorers: [
      {
        kind: "oraiscan",
        url: "https://scan.orai.io",
        tx_page: "https://scan.orai.io/txs/${txHash}"
      },
      {
        kind: "Nodine Explorer",
        url: "https://explorer.co.id/orai",
        tx_page: "https://explorer.co.id/orai/tx/${txHash}"
      },
      {
        kind: "Blockval Explorer",
        url: "https://explorer.blockval.io/oraichain",
        tx_page: "https://explorer.blockval.io/oraichain/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/orai",
        tx_page: "https://atomscan.com/orai/transactions/${txHash}",
        account_page: "https://atomscan.com/orai/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/oraichain",
        tx_page: "https://staking-explorer.com/transaction.php?chain=oraichain&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=oraichain&addr=${accountAddress}"
      },
      {
        kind: "KonsorTech Explorer",
        url: "https://explorer.konsortech.xyz/oraichain",
        tx_page: "https://explorer.konsortech.xyz/oraichain/transactions/${txHash}",
        account_page: "https://explorer.konsortech.xyz/oraichain/accounts/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥 Explorer",
        url: "https://explorer.stavr.tech/Orai-Mainnet",
        tx_page: "https://explorer.stavr.tech/Orai-Mainnet/transactions/${txHash}",
        account_page: "https://explorer.stavr.tech/Orai-Mainnet/accounts/${accountAddress}"
      },
      {
        kind: "imORAI ORAIchain Explorer",
        url: "https://explorer.imdev.app/oraichain",
        tx_page: "https://explorer.imdev.app/oraichain/tx/${txHash}",
        account_page: "https://explorer.imdev.app/oraichain/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "osmosis-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/osmosis",
        tx_page: "https://ezstaking.app/osmosis/txs/${txHash}",
        account_page: "https://ezstaking.app/osmosis/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/osmosis",
        tx_page: "https://www.mintscan.io/osmosis/transactions/${txHash}",
        account_page: "https://www.mintscan.io/osmosis/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/osmosis",
        tx_page: "https://ping.pub/osmosis/tx/${txHash}"
      },
      {
        kind: "explorers.guru",
        url: "https://osmosis.explorers.guru",
        tx_page: "https://osmosis.explorers.guru/transaction/${txHash}",
        account_page: "https://osmosis.explorers.guru/account/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/osmosis",
        tx_page: "https://atomscan.com/osmosis/transactions/${txHash}",
        account_page: "https://atomscan.com/osmosis/accounts/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/osmosis",
        tx_page: "https://explorer.tcnetwork.io/osmosis/transaction/${txHash}",
        account_page: "https://explorer.tcnetwork.io/osmosis/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/osmosis",
        tx_page: "https://staking-explorer.com/transaction.php?chain=osmosis&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=osmosis&addr=${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/osmosis",
        account_page: "https://stakeflow.io/osmosis/accounts/${accountAddress}"
      },
      {
        kind: "Nodeist Explorer",
        url: "https://exp.nodeist.net/osmosis",
        tx_page: "https://exp.nodeist.net/osmosis/tx/${txHash}"
      },
      {
        kind: "L0vd.com ❤️",
        url: "https://explorers.l0vd.com/osmosis-mainnet",
        tx_page: "https://explorers.l0vd.com/osmosis-mainnet/tx/${txHash}"
      },
      {
        kind: "Chainscope",
        url: "https://chainsco.pe/osmosis",
        tx_page: "https://chainsco.pe/osmosis/tx/${txHash}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/osmosis",
        tx_page: "https://mainnet.whispernode.com/osmosis/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/osmosis/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "tumbler",
    explorers: [
      {
        kind: "explorers.guru",
        url: "https://paloma.explorers.guru/",
        tx_page: "https://paloma.explorers.guru/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "panacea-3",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/medibloc",
        tx_page: "https://www.mintscan.io/medibloc/transactions/${txHash}",
        account_page: "https://www.mintscan.io/medibloc/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/panacea",
        tx_page: "https://staking-explorer.com/transaction.php?chain=panacea&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=panacea&addr=${accountAddress}"
      },
      {
        kind: "bigdipper",
        url: "https://explorer.gopanacea.org",
        tx_page: "https://explorer.gopanacea.org/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "passage-2",
    explorers: [
      {
        kind: "aneka",
        url: "https://passage.aneka.io",
        tx_page: "https://passage.aneka.io/txs/${txHash}",
        account_page: "https://passage.aneka.io/accounts/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/passage",
        tx_page: "https://www.mintscan.io/passage/transactions/${txHash}",
        account_page: "https://www.mintscan.io/passage/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/passage",
        tx_page: "https://ezstaking.app/passage/txs/${txHash}",
        account_page: "https://ezstaking.app/passage/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/passage",
        tx_page: "https://staking-explorer.com/transaction.php?chain=passage&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=passage&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/passage",
        tx_page: "https://atomscan.com/passage/transactions/${txHash}",
        account_page: "https://atomscan.com/passage/accounts/${accountAddress}"
      },
      {
        kind: "cosmotracker",
        url: "https://cosmotracker.com/passage",
        tx_page: "https://cosmotracker.com/passage/tx/${txHash}",
        account_page: "https://cosmotracker.com/passage/account/${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/passage",
        tx_page: "https://mainnet.whispernode.com/passage/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/passage/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "passage-1",
    explorers: [
      {
        kind: "aneka",
        url: "https://passage.aneka.io",
        tx_page: "https://passage.aneka.io/txs/${txHash}",
        account_page: "https://passage.aneka.io/accounts/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/passage",
        tx_page: "https://www.mintscan.io/passage/txs/${txHash}",
        account_page: "https://www.mintscan.io/passage/account/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/passage",
        tx_page: "https://ezstaking.app/passage/txs/${txHash}",
        account_page: "https://ezstaking.app/passage/account/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/passage",
        tx_page: "https://atomscan.com/passage/transactions/${txHash}",
        account_page: "https://atomscan.com/passage/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "core-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/persistence",
        tx_page: "https://www.mintscan.io/persistence/transactions/${txHash}",
        account_page: "https://www.mintscan.io/persistence/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/persistence",
        tx_page: "https://ezstaking.app/persistence/txs/${txHash}",
        account_page: "https://ezstaking.app/persistence/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/persistence",
        tx_page: "https://ping.pub/persistence/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Persistence-Mainnet",
        tx_page: "https://explorer.stavr.tech/Persistence-Mainnet/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/persistence",
        tx_page: "https://staking-explorer.com/transaction.php?chain=persistence&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=persistence&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/persistence",
        tx_page: "https://atomscan.com/persistence/transactions/${txHash}",
        account_page: "https://atomscan.com/persistence/accounts/${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/persistence",
        account_page: "https://stakeflow.io/persistence/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "planq_7070-2",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://explorer.planq.network",
        tx_page: "https://explorer.planq.network/transactions/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Planq-Mainnet",
        tx_page: "https://explorer.stavr.tech/Planq-Mainnet/tx/${txHash}"
      },
      {
        kind: "blockscout",
        url: "https://evm.planq.network",
        tx_page: "https://evm.planq.network/tx/${txHash}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/planq",
        tx_page: "https://explorer.nodestake.top/planq/tx/${txHash}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/planq",
        tx_page: "https://explorer.tcnetwork.io/planq/transaction/${txHash}"
      },
      {
        kind: "Roomit",
        url: "https://explorer.tendermint.roomit.xyz/planq-mainnet",
        tx_page: "https://explorer.tendermint.roomit.xyz/planq-mainnet/transaction/${txHash}"
      },
      {
        kind: "Kynraze",
        url: "https://explorer.kynraze.com/planq",
        tx_page: "https://explorer.kynraze.com/planq/tx/${txHash}"
      },
      {
        kind: "THE EXPLORER",
        url: "https://explorer.sxlzptprjkt.xyz/planq",
        tx_page: "https://explorer.sxlzptprjkt.xyz/planq/tx/${txHash}"
      },
      {
        kind: "NODEXPLORER",
        url: "https://explorer.nodexcapital.com/planq",
        tx_page: "https://explorer.nodexcapital.com/planq/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/planq",
        tx_page: "https://atomscan.com/planq/transactions/${txHash}",
        account_page: "https://atomscan.com/planq/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/planq",
        tx_page: "https://staking-explorer.com/transaction.php?chain=planq&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=planq&addr=${accountAddress}"
      },
      {
        kind: "Indonode",
        url: "https://explorer.indonode.net/planq",
        tx_page: "https://explorer.indonode.net/planq/tx/${txHash}"
      },
      {
        kind: "Safe Block",
        url: "https://explorer.safeblock.space/planq",
        tx_page: "https://explorer.safeblock.space/planq/tx/${txHash}"
      },
      {
        kind: "KonsorTech",
        url: "https://explorer.konsortech.xyz/planq",
        tx_page: "https://explorer.konsortech.xyz/planq/tx/${txHash}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/planq",
        tx_page: "https://explorer.whenmoonwhenlambo.money/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "point_10687-1",
    explorers: [
      {
        kind: "blockscout",
        url: "https://explorer.pointnetwork.io/",
        tx_page: "https://explorer.pointnetwork.io/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Point-Mainnet",
        tx_page: "https://explorer.stavr.tech/Point-Mainnet/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://cosmos.pointnetwork.io/",
        tx_page: "https://cosmos.pointnetwork.io/point/tx/${txHash}"
      },
      {
        kind: "NODEXPLORER",
        url: "https://explorer.nodexcapital.com/point",
        tx_page: "https://explorer.nodexcapital.com/point/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/point",
        tx_page: "https://atomscan.com/point/transactions/${txHash}",
        account_page: "https://atomscan.com/point/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "pio-mainnet-1",
    explorers: [
      {
        kind: "Provenance",
        url: "https://explorer.provenance.io",
        tx_page: "https://explorer.provenance.io/tx/${txHash}"
      },
      {
        kind: "hubble",
        url: "https://hubble.figment.io/provenance/chains/pio-mainnet-1",
        tx_page: "https://hubble.figment.io/provenance/chains/pio-mainnet-1/${block}/transactions/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/provenance",
        tx_page: "https://ping.pub/provenance/tx/${txHash}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/provenance",
        tx_page: "https://www.mintscan.io/provenance/transactions/${txHash}",
        account_page: "https://www.mintscan.io/provenance/accounts/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Provenance",
        tx_page: "https://explorer.stavr.tech/Provenance/txs/${txHash}",
        account_page: "https://explorer.stavr.tech/Provenance/account/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/provenance",
        tx_page: "https://ezstaking.app/provenance/txs/${txHash}",
        account_page: "https://ezstaking.app/provenance/account/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/provenance",
        tx_page: "https://atomscan.com/provenance/transactions/${txHash}",
        account_page: "https://atomscan.com/provenance/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/provenance",
        tx_page: "https://staking-explorer.com/transaction.php?chain=provenance&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=provenance&addr=${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/provenance",
        tx_page: "https://explorer.whenmoonwhenlambo.money/provenance/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/provenance/account/${accountAddress}"
      },
      {
        kind: "AVIAONE 🟢",
        url: "https://mainnet.explorer.aviaone.com/provenance",
        tx_page: "https://mainnet.explorer.aviaone.com/provenance/tx/${txHash}",
        account_page: "https://mainnet.explorer.aviaone.com/provenance/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "pryzm-1",
    explorers: [
      {
        kind: "Chainscope",
        url: "https://chainsco.pe/pryzm",
        tx_page: "https://chainsco.pe/pryzm/tx/${txHash}",
        account_page: "https://chainsco.pe/pryzm/address/${accountAddress}",
        block_page: "https://chainsco.pe/pryzm/block/${blockHeight}",
        proposal_page: "https://chainsco.pe/pryzm/governance/proposal/${proposalId}",
        validator_page: "https://chainsco.pe/pryzm/validator/${validatorAddress}"
      },
      {
        kind: "PingPub",
        url: "https://cosmosrun.info/pryzm",
        tx_page: "https://cosmosrun.info/pryzm/tx/${txHash}",
        account_page: "https://cosmosrun.info/pryzm/account/${accountAddress}",
        block_page: "https://cosmosrun.info/pryzm/blocks/${blockHeight}",
        proposal_page: "https://cosmosrun.info/pryzm/gov/${proposalId}",
        validator_page: "https://cosmosrun.info/pryzm/staking/${validatorAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/pryzm",
        tx_page: "https://staking-explorer.com/transaction.php?chain=pryzm&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=pryzm&addr=${accountAddress}"
      }
    ]
  },
  {
    chainId: "PUNDIX",
    explorers: [
      {
        kind: "starscan",
        url: "https://starscan.io",
        tx_page: "https://starscan.io/pundix/tx/${txHash}",
        account_page: "https://starscan.io/pundix/address/${accountAddress}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
        url: "https://explorer.nodeshub.online/pundix/",
        tx_page: "https://explorer.nodeshub.online/pundix/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/pundix/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "pylons-mainnet-1",
    explorers: [
      {
        kind: "Nodes.guru",
        url: "https://pylons.explorers.guru/",
        tx_page: "https://pylons.explorers.guru/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "qfs-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://blockexplorer.qfsone.com/qfs",
        tx_page: "https://blockexplorer.qfsone.com/qfs/tx/${txHash}",
        account_page: "https://blockexplorer.qfsone.com/qfs/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "quasar-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/quasar",
        tx_page: "https://www.mintscan.io/quasar/transactions/${txHash}",
        account_page: "https://www.mintscan.io/quasar/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/quasar",
        tx_page: "https://ezstaking.app/quasar/txs/${txHash}",
        account_page: "https://ezstaking.app/quasar/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/quasar",
        tx_page: "https://staking-explorer.com/transaction.php?chain=quasar&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=quasar&addr=${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/quasar",
        tx_page: "https://mainnet.whispernode.com/quasar/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/quasar/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "quicksilver-2",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/quicksilver",
        tx_page: "https://www.mintscan.io/quicksilver/transactions/${txHash}",
        account_page: "https://www.mintscan.io/quicksilver/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/quicksilver",
        tx_page: "https://ezstaking.app/quicksilver/txs/${txHash}",
        account_page: "https://ezstaking.app/quicksilver/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/quicksilver",
        tx_page: "https://staking-explorer.com/transaction.php?chain=quicksilver&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=quicksilver&addr=${accountAddress}"
      },
      {
        kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀 explorer",
        url: "https://exp.utsa.tech/quicksilver",
        tx_page: "https://exp.utsa.tech/quicksilver/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥 explorer",
        url: "https://explorer.stavr.tech/quicksilver-mainnet",
        tx_page: "https://explorer.stavr.tech/quicksilver-mainnet/tx/${txHash}"
      },
      {
        kind: "Stake-Take",
        url: "https://explorer.stake-take.com/quicksilver",
        tx_page: "https://explorer.stake-take.com/quicksilver/tx/${txHash}"
      },
      {
        kind: "AM Solutions Explorers",
        url: "https://explorer.theamsolutions.info/quicksilver-main/staking",
        tx_page: "https://explorer.theamsolutions.info/quicksilver-main/tx/${txHash}"
      },
      {
        kind: "KonsorTech",
        url: "https://explorer.konsortech.xyz/quicksilver/staking",
        tx_page: "https://explorer.konsortech.xyz/quicksilver/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "qwoyn-1",
    explorers: [
      {
        kind: "ping",
        url: "https://explorer.theamsolutions.info/qwoyn-main/",
        tx_page: "https://explorer.theamsolutions.info/qwoyn-main/blocks",
        account_page: "https://explorer.theamsolutions.info/qwoyn-main/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/qwoyn",
        tx_page: "https://staking-explorer.com/transaction.php?chain=qwoyn&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=qwoyn&addr=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Qwoyn-Mainnet",
        tx_page: "https://explorer.stavr.tech/Qwoyn-Mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Qwoyn-Mainnet/account/${accountAddress}"
      },
      {
        kind: "ping",
        url: "https://explorer.theamsolutions.info/QWOYN-MAIN",
        tx_page: "https://explorer.theamsolutions.info/QWOYN-MAIN/tx/${txHash}",
        account_page: "https://explorer.theamsolutions.info/QWOYN-MAIN/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "realionetwork_3301-1",
    explorers: [
      {
        kind: "🔥STAVR🔥 Explorer",
        url: "https://explorer.stavr.tech/realio-mainnet",
        tx_page: "https://explorer.stavr.tech/realio-mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/realio-mainnet/account/{$accountAddress}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/realio",
        tx_page: "https://explorer.nodestake.top/realio/tx/${txHash}",
        account_page: "https://explorer.nodestake.top/realio/account/{$accountAddress}"
      },
      {
        kind: "Sr20de Explorer",
        url: "https://explorer.sr20de.xyz/Realio",
        tx_page: "https://explorer.sr20de.xyz/Realio/tx/${txHash}",
        account_page: "https://explorer.sr20de.xyz/Realio/account/{$accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/realio",
        tx_page: "https://explorer.tcnetwork.io/realio/transaction/${txHash}",
        account_page: "https://explorer.tcnetwork.io/realio/account/${accountAddress}"
      },
      {
        kind: "Safe Block",
        url: "https://explorer.safeblock.space/realio",
        tx_page: "https://explorer.safeblock.space/realio/tx/${txHash}",
        account_page: "https://explorer.safeblock.space/realio/account/${accountAddress}"
      },
      {
        kind: "Decloud Nodes Lab",
        url: "https://explorer.declab.pro/realio",
        tx_page: "https://explorer.declab.pro/realio/tx/${txHash}",
        account_page: "https://explorer.declab.pro/realio/account/{$accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/realio",
        tx_page: "https://explorer.whenmoonwhenlambo.money/realio/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/realio/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "reb_1111-1",
    explorers: [
      {
        kind: "explorers.guru",
        url: "https://rebus.explorers.guru",
        tx_page: "https://rebus.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "NodeStake",
        url: "https://explorer.nodestake.top/rebus",
        tx_page: "https://explorer.nodestake.top/rebus/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/rebus",
        tx_page: "https://staking-explorer.com/transaction.php?chain=rebus&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=rebus&addr=${accountAddress}"
      },
      {
        kind: "BccNodes",
        url: "https://explorer.bccnodes.com/rebus-M",
        tx_page: "https://explorer.bccnodes.com/rebus-M/tx/${txHash}"
      },
      {
        kind: "Brochain",
        url: "https://explorer.brocha.in/rebus",
        tx_page: "https://explorer.brocha.in/rebus/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥 Explorer",
        url: "https://explorer.stavr.tech/rebus",
        tx_page: "https://explorer.stavr.tech/rebus/tx/${txHash}"
      },
      {
        kind: "tcnetwork",
        url: "https://rebus.tcnetwork.io",
        tx_page: "https://rebus.tcnetwork.io/transaction/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/rebus",
        tx_page: "https://atomscan.com/rebus/transactions/${txHash}",
        account_page: "https://atomscan.com/rebus/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "regen-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/regen",
        tx_page: "https://ezstaking.app/regen/txs/${txHash}",
        account_page: "https://ezstaking.app/regen/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/regen",
        tx_page: "https://staking-explorer.com/transaction.php?chain=regen&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=regen&addr=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Regen-Mainnet",
        tx_page: "https://explorer.stavr.tech/Regen-Mainnet/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/regen",
        tx_page: "https://ping.pub/regen/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/regen-network",
        tx_page: "https://atomscan.com/regen-network/transactions/${txHash}",
        account_page: "https://atomscan.com/regen-network/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "titan-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/rizon",
        tx_page: "https://ezstaking.app/rizon/txs/${txHash}",
        account_page: "https://ezstaking.app/rizon/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/rizon",
        tx_page: "https://www.mintscan.io/rizon/transactions/${txHash}",
        account_page: "https://www.mintscan.io/rizon/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/rizon",
        tx_page: "https://ping.pub/rizon/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/rizon",
        tx_page: "https://staking-explorer.com/transaction.php?chain=rizon&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=rizon&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/rizon",
        tx_page: "https://atomscan.com/rizon/transactions/${txHash}",
        account_page: "https://atomscan.com/rizon/accounts/${accountAddress}"
      },
      {
        kind: "bigdipper",
        url: "https://bigdipper.live/rizon",
        tx_page: "https://bigdipper.live/rizon/transactions/${txHash}",
        account_page: "https://bigdipper.live/rizon/accounts/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Rizon",
        tx_page: "https://explorer.stavr.tech/Rizon/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Rizon/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "30",
    explorers: [
      {
        kind: "Rootstock Explorer",
        url: "https://explorer.rootstock.io/",
        tx_page: "https://explorer.rootstock.io/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "router_9600-1",
    explorers: [
      {
        kind: "Routerscan",
        url: "https://routerscan.io/",
        tx_page: "https://routerscan.io/transactions/${txHash}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.org/router",
        tx_page: "https://explorer.nodestake.org/router/tx/${txHash}"
      },
      {
        kind: "Router Explorer",
        url: "https://router.explorers.guru/",
        tx_page: "https://router.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/routerchain",
        tx_page: "https://staking-explorer.com/transaction.php?chain=routerchain&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=routerchain&addr=${accountAddress}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️",
        url: "https://explorer.nodeshub.online/router/",
        tx_page: "https://explorer.nodeshub.online/router/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/router/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "ssc-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/saga",
        tx_page: "https://www.mintscan.io/saga/transactions/${txHash}",
        account_page: "https://www.mintscan.io/saga/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/saga",
        tx_page: "https://staking-explorer.com/transaction.php?chain=saga&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=saga&addr=${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/saga",
        tx_page: "https://ezstaking.app/saga/txs/${txHash}",
        account_page: "https://ezstaking.app/saga/account/${accountAddress}"
      },
      {
        kind: "NodeStake",
        url: "https://explorer.nodestake.org/saga",
        tx_page: "https://explorer.nodestake.org/saga/tx/${txHash}",
        account_page: "https://explorer.nodestake.org/saga/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "scorum-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/scorum",
        tx_page: "https://ezstaking.app/scorum/txs/${txHash}",
        account_page: "https://ezstaking.app/scorum/account/${accountAddress}"
      },
      {
        kind: "bigdipper",
        url: "https://cosmos.scorum.com/scorum",
        tx_page: "https://cosmos.scorum.com/scorum/transactions/${txHash}",
        account_page: "https://cosmos.scorum.com/scorum/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "secret-4",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/secretnetwork",
        tx_page: "https://ezstaking.app/secretnetwork/txs/${txHash}",
        account_page: "https://ezstaking.app/secretnetwork/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/secret",
        tx_page: "https://ping.pub/secret/tx/${txHash}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/secret",
        tx_page: "https://www.mintscan.io/secret/transactions/${txHash}",
        account_page: "https://www.mintscan.io/secret/accounts/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/secret-network",
        tx_page: "https://atomscan.com/secret-network/transactions/${txHash}",
        account_page: "https://atomscan.com/secret-network/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/secretnetwork",
        tx_page: "https://staking-explorer.com/transaction.php?chain=secretnetwork&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=secretnetwork&addr=${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/secret",
        tx_page: "https://mainnet.whispernode.com/secret/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/secret/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "seda-1",
    explorers: [
      {
        kind: "sedaexplorer",
        url: "https://explorer.seda.xyz/",
        tx_page: "https://explorer.seda.xyz/txs/${txHash}",
        account_page: "https://explorer.seda.xyz/account/${accountAddress}"
      },
      {
        kind: "explorers.guru",
        url: "https://seda.explorers.guru",
        tx_page: "https://seda.explorers.guru/transaction/${txHash}",
        account_page: "https://seda.explorers.guru/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/seda",
        tx_page: "https://staking-explorer.com/transaction.php?chain=seda&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=seda&addr=${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/seda",
        tx_page: "https://mainnet.whispernode.com/seda/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/seda/account/${accountAddress}"
      },
      {
        kind: "Apple juice 🧃",
        url: "https://explorer.256x25.tech/seda-mainnet",
        tx_page: "https://explorer.256x25.tech/seda-mainnet/tx/${txHash}",
        account_page: "https://explorer.256x25.tech/seda-mainnet/account/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/seda",
        tx_page: "https://explorer.whenmoonwhenlambo.money/seda/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/seda/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "pacific-1",
    explorers: [
      {
        kind: "blockscout",
        url: "https://seitrace.com",
        tx_page: "https://seitrace.com/tx/${txHash}?chain=pacific-1",
        account_page: "https://seitrace.com/address/${accountAddress}?chain=pacific-1"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/sei",
        tx_page: "https://www.mintscan.io/sei/transactions/${txHash}",
        account_page: "https://www.mintscan.io/sei/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/sei",
        tx_page: "https://ezstaking.app/sei/txs/${txHash}",
        account_page: "https://ezstaking.app/sei/account/${accountAddress}"
      },
      {
        kind: "celatone",
        url: "https://www.seiscan.app/pacific-1",
        tx_page: "https://www.seiscan.app/pacific-1/txs/${txHash}",
        account_page: "https://www.seiscan.app/pacific-1/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/sei",
        tx_page: "https://staking-explorer.com/transaction.php?chain=sei&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=sei&addr=${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/sei",
        tx_page: "https://mainnet.whispernode.com/sei/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/sei/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "self-1",
    explorers: [
      {
        kind: "Self Chain",
        url: "https://explorer.selfchain.xyz/selfchain",
        tx_page: "https://explorer.selfchain.xyz/selfchain/tx/${txHash}",
        account_page: "https://explorer.selfchain.xyz/selfchain/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/self",
        tx_page: "https://staking-explorer.com/transaction.php?chain=self&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=self&addr=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Selfchain-Mainnet",
        tx_page: "https://explorer.stavr.tech/Selfchain-Mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Selfchain-Mainnet/account/${accountAddress}"
      },
      {
        kind: "Roomit",
        url: "https://explorer.tendermint.roomit.xyz/selfchain-mainnet",
        tx_page: "https://explorer.tendermint.roomit.xyz/selfchain-mainnet/tx/${txHash}",
        account_page: "https://explorer.tendermint.roomit.xyz/selfchain-mainnet/account/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/self",
        tx_page: "https://explorer.whenmoonwhenlambo.money/self/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/self/account/${accountAddress}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️",
        url: "https://explorer.nodeshub.online/selfchain/",
        tx_page: "https://explorer.nodeshub.online/selfchain/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/selfchain/accounts/${accountAddress}"
      },
      {
        kind: "Stake Village",
        url: "https://exp.stakevillage.net/selfchain-mainnet",
        tx_page: "https://exp.stakevillage.net/selfchain-mainnet/tx/${txHash}",
        account_page: "https://exp.stakevillage.net/selfchain-mainnet/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "sentinelhub-2",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/sentinel",
        tx_page: "https://www.mintscan.io/sentinel/transactions/${txHash}",
        account_page: "https://www.mintscan.io/sentinel/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/sentinel",
        tx_page: "https://ezstaking.app/sentinel/txs/${txHash}",
        account_page: "https://ezstaking.app/sentinel/account/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/sentinel",
        tx_page: "https://atomscan.com/sentinel/transactions/${txHash}",
        account_page: "https://atomscan.com/sentinel/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/sentinel",
        tx_page: "https://staking-explorer.com/transaction.php?chain=sentinel&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=sentinel&addr=${accountAddress}"
      },
      {
        kind: "Roomit",
        url: "https://explorer.tendermint.roomit.xyz/sentinel-mainnet",
        tx_page: "https://explorer.tendermint.roomit.xyz/sentinel-mainnet/transactions/${txHash}",
        account_page: "https://explorer.tendermint.roomit.xyz/sentinel-mainnet/accounts/${accountAddress}"
      },
      {
        kind: "ValidatorNode",
        url: "https://explorer.validatornode.com/sentinel",
        tx_page: "https://explorer.validatornode.com/sentinel/tx/${txHash}"
      },
      {
        kind: "Decloud Nodes Lab",
        url: "https://explorer.declab.pro/Sentinel",
        tx_page: "https://explorer.declab.pro/Sentinel/tx/${txHash}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
        url: "https://explorer.nodeshub.online/sentinel/",
        tx_page: "https://explorer.nodeshub.online/sentinel/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/sentinel/accounts/${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/sentinel",
        tx_page: "https://mainnet.whispernode.com/sentinel/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/sentinel/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "sgenet-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://blockexplorer.sgenetwork.io/sge",
        tx_page: "https://blockexplorer.sgenetwork.io/sge/tx/${txHash}"
      },
      {
        kind: "nodestake.top",
        url: "https://explorer.nodestake.top/sge",
        tx_page: "https://explorer.nodestake.top/sge/tx/${txHash}"
      },
      {
        kind: "stakerhouse",
        url: "https://cosmotracker.com/sge",
        tx_page: "https://cosmotracker.com/sge/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Sge-Mainnet",
        tx_page: "https://explorer.stavr.tech/Sge-Mainnet/transaction/${txHash}",
        account_page: "https://explorer.stavr.tech/Sge-Mainnet/account/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/sge",
        tx_page: "https://explorer.tcnetwork.io/sge/transaction/${txHash}",
        account_page: "https://explorer.tcnetwork.io/sge/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/sge",
        tx_page: "https://staking-explorer.com/transaction.php?chain=sge&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=sge&addr=${accountAddress}"
      },
      {
        kind: "Safe Block",
        url: "https://explorer.safeblock.space/sge",
        tx_page: "https://explorer.safeblock.space/sge/tx/${txHash}",
        account_page: "https://explorer.safeblock.space/sge/account/${accountAddress}"
      },
      {
        kind: "KonsorTech",
        url: "https://explorer.konsortech.xyz/sge",
        tx_page: "https://explorer.konsortech.xyz/sge/tx/${txHash}",
        account_page: "https://explorer.konsortech.xyz/sge/account/${accountAddress}"
      },
      {
        kind: "Roomit",
        url: "https://explorer.tendermint.roomit.xyz/sge-mainnet",
        tx_page: "https://explorer.tendermint.roomit.xyz/sge-mainnet/tx/${txHash}",
        account_page: "https://explorer.tendermint.roomit.xyz/sge-mainnet/account/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/sge",
        tx_page: "https://explorer.whenmoonwhenlambo.money/sge/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/sge/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "ShareRing-VoyagerNet",
    explorers: [
      {
        kind: "big dipper",
        url: "https://explorer.shareri.ng",
        tx_page: "https://explorer.shareri.ng/transactions/${txHash}",
        account_page: "https://explorer.shareri.ng/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/shareledger",
        tx_page: "https://staking-explorer.com/transaction.php?chain=shareledger&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=shareledger&addr=${accountAddress}"
      }
    ]
  },
  {
    chainId: "shentu-2.2",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/shentu",
        tx_page: "https://ezstaking.app/shentu/txs/${txHash}",
        account_page: "https://ezstaking.app/shentu/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Shentu-Mainnet",
        tx_page: "https://explorer.stavr.tech/Shentu-Mainnet/txs/${txHash}",
        account_page: "https://explorer.stavr.tech/Shentu-Mainnet/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/shentu",
        tx_page: "https://www.mintscan.io/shentu/transactions/${txHash}",
        account_page: "https://www.mintscan.io/shentu/accounts/${accountAddress}"
      },
      {
        kind: "Shentu Explorer",
        url: "https://explorer.shentu.org/?chain=shentu-2.2",
        tx_page: "https://explorer.shentu.org/transactions/${txHash}?chain=shentu-2.2"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/shentu",
        tx_page: "https://ping.pub/shentu/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/shentu",
        tx_page: "https://atomscan.com/shentu/transactions/${txHash}",
        account_page: "https://atomscan.com/shentu/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/shentu",
        tx_page: "https://staking-explorer.com/transaction.php?chain=shentu&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=shentu&addr=${accountAddress}"
      },
      {
        kind: "bigdipper",
        url: "https://bigdipper.live/shentu",
        tx_page: "https://bigdipper.live/shentu/transactions/${txHash}",
        account_page: "https://bigdipper.live/shentu/accounts/${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/shentu",
        account_page: "https://stakeflow.io/shentu/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "shido_9008-1",
    explorers: [
      {
        kind: "shido",
        url: "https://shidoscan.com",
        tx_page: "https://shidoscan.com/tx/${txHash}",
        account_page: "https://shidoscan.com/address/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/shido",
        tx_page: "https://explorer.whenmoonwhenlambo.money/shido/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/shido/account/${accountAddress}"
      },
      {
        kind: "256x25",
        url: "https://explorer.256x25.tech/shido",
        tx_page: "https://explorer.256x25.tech/shido/tx/${txHash}",
        account_page: "https://explorer.256x25.tech//shido/account/${accountAddress}"
      },
      {
        kind: "MavNode",
        url: "https://explorer.mavnode.io/shido",
        tx_page: "https://explorer.mavnode.io/shido/tx/${txHash}",
        account_page: "https://explorer.mavnode.io/shido/account/${accountAddress}"
      },
      {
        kind: "Indonode",
        url: "https://explorer.indonode.net/shido",
        tx_page: "https://explorer.indonode.net/shido/tx/${txHash}",
        account_page: "https://explorer.indonode.net/shido/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "sifchain-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/sifchain",
        tx_page: "https://ping.pub/sifchain/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/sifchain",
        tx_page: "https://atomscan.com/sifchain/transactions/${txHash}",
        account_page: "https://atomscan.com/sifchain/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/sifchain",
        tx_page: "https://staking-explorer.com/transaction.php?chain=sifchain&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=sifchain&addr=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Sifchain",
        tx_page: "https://explorer.stavr.tech/Sifchain/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Sifchain/accounts/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/sifchain",
        tx_page: "https://explorer.whenmoonwhenlambo.money/sifchain/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/sifchain/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "sixnet",
    explorers: [
      {
        kind: "sixscan",
        url: "https://sixscan.io/sixnet",
        tx_page: "https://sixscan.io/sixnet/tx/${txHash}"
      }
    ]
  },
  {
    explorers: [
      {
        kind: "Solana Explorer",
        url: "https://explorer.solana.com/",
        tx_page: "https://explorer.solana.com/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "sommelier-3",
    explorers: [
      {
        kind: "sommscan",
        url: "https://sommscan.io",
        tx_page: "https://sommscan.io"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/sommelier",
        tx_page: "https://www.mintscan.io/sommelier/transactions/${txHash}",
        account_page: "https://www.mintscan.io/sommelier/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/sommelier",
        tx_page: "https://ezstaking.app/sommelier/txs/${txHash}",
        account_page: "https://ezstaking.app/sommelier/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/sommelier",
        tx_page: "https://staking-explorer.com/transaction.php?chain=sommelier&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=sommelier&addr=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Sommelier-Mainnet",
        tx_page: "https://explorer.stavr.tech/Sommelier-Mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Sommelier-Mainnet/account/${accountAddress}"
      },
      {
        kind: "NODEXPLORER",
        url: "https://explorer.nodexcapital.com/sommelier",
        tx_page: "https://explorer.nodexcapital.com/sommelier/tx/${txHash}",
        account_page: "https://explorer.nodexcapital.com/sommelier/account/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/sommelier",
        tx_page: "https://atomscan.com/sommelier/transactions/${txHash}",
        account_page: "https://atomscan.com/sommelier/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "source-1",
    explorers: [
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Source-Mainnet/",
        tx_page: "https://explorer.stavr.tech/Source-Mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Source-Mainnet/accounts/${accountAddress}"
      },
      {
        kind: "Nodeist",
        url: "https://exp.nodeist.net/source/",
        tx_page: "https://exp.nodeist.net/source/tx/${txHash}",
        account_page: "https://exp.nodeist.net/source/accounts/${accountAddress}"
      },
      {
        kind: "MoonBridge",
        url: "https://explorer.moonbridge.team/source",
        tx_page: "https://explorer.moonbridge.team/source/tx/${txHash}",
        account_page: "https://explorer.moonbridge.team/source/accounts/${accountAddress}"
      },
      {
        kind: "NodeStake",
        url: "https://explorer.nodestake.top/source",
        tx_page: "https://explorer.nodestake.top/source/tx/${txHash}",
        account_page: "https://explorer.nodestake.top/source/accounts/${accountAddress}"
      },
      {
        kind: "Sr20de",
        url: "https://explorer.sr20de.xyz/Source-mainnet",
        tx_page: "https://explorer.sr20de.xyz/Source-mainnet/tx/${txHash}",
        account_page: "https://explorer.sr20de.xyz/Source-mainnet/accounts/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/source",
        tx_page: "https://explorer.tcnetwork.io/source/transaction/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/source",
        tx_page: "https://staking-explorer.com/transaction.php?chain=source&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=source&addr=${accountAddress}"
      },
      {
        kind: "Indonode",
        url: "https://explorer.indonode.net/source",
        tx_page: "https://explorer.indonode.net/source/tx/${txHash}"
      },
      {
        kind: "Roomit",
        url: "https://explorer.tendermint.roomit.xyz/source-mainnet/",
        tx_page: "https://explorer.tendermint.roomit.xyz/source-mainnet/tx/${txHash}"
      },
      {
        kind: "posthuman",
        url: "https://explorer.posthuman.digital/source",
        tx_page: "https://explorer.posthuman.digital/source/tx/${txHash}",
        account_page: "https://explorer.posthuman.digital/source/account/${accountAddress}"
      },
      {
        kind: "Decloud Nodes Lab",
        url: "https://explorer.declab.pro/Source",
        tx_page: "https://explorer.declab.pro/Source/tx/${txHash}",
        account_page: "https://explorer.declab.pro/Source/account/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/source",
        tx_page: "https://explorer.whenmoonwhenlambo.money/source/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/source/account/${accountAddress}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
        url: "https://explorer.nodeshub.online/source/",
        tx_page: "https://explorer.nodeshub.online/source/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/source/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "stafihub-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/stafi",
        tx_page: "https://www.mintscan.io/stafi/transactions/${txHash}",
        account_page: "https://www.mintscan.io/stafi/accounts/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/stafihub",
        tx_page: "https://ezstaking.app/stafihub/txs/${txHash}",
        account_page: "https://ezstaking.app/stafihub/account/${accountAddress}"
      },
      {
        kind: "ping-pub",
        url: "https://ping.pub/stafihub",
        tx_page: "https://ping.pub/stafihub/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/stafihub",
        tx_page: "https://staking-explorer.com/transaction.php?chain=stafihub&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=stafihub&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/stafihub",
        tx_page: "https://atomscan.com/stafihub/transactions/${txHash}",
        account_page: "https://atomscan.com/stafihub/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "stargaze-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/stargaze",
        tx_page: "https://ezstaking.app/stargaze/txs/${txHash}",
        account_page: "https://ezstaking.app/stargaze/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/stargaze/",
        tx_page: "https://www.mintscan.io/stargaze/transactions/${txHash}",
        account_page: "https://www.mintscan.io/stargaze/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/stargaze",
        tx_page: "https://ping.pub/stargaze/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/stargaze",
        tx_page: "https://staking-explorer.com/transaction.php?chain=stargaze&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=stargaze&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/stargaze",
        tx_page: "https://atomscan.com/stargaze/transactions/${txHash}",
        account_page: "https://atomscan.com/stargaze/accounts/${accountAddress}"
      },
      {
        kind: "Starscan",
        url: "https://starscan.net/",
        tx_page: "https://starscan.net/stargaze-1/tx/${txHash}",
        account_page: "https://starscan.net/stargaze-1/address/${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/stargaze",
        tx_page: "https://mainnet.whispernode.com/stargaze/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/stargaze/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "iov-mainnet-ibc",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/starname",
        tx_page: "https://ping.pub/starname/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/starname",
        tx_page: "https://atomscan.com/starname/transactions/${txHash}",
        account_page: "https://atomscan.com/starname/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "stratos-1",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://explorer.thestratos.org",
        tx_page: "https://explorer.thestratos.org/transactions/${txHash}",
        account_page: "https://explorer.thestratos.org/accounts/${accountAddress}"
      },
      {
        kind: "blockscout",
        url: "https://web3-explorer.thestratos.org",
        tx_page: "https://web3-explorer.thestratos.org/tx/${txHash}",
        account_page: "https://web3-explorer.thestratos.org/address/${accountAddress}"
      },
      {
        kind: "NodeStake",
        url: "https://explorer.nodestake.top/stratos",
        tx_page: "https://explorer.nodestake.top/stratos/tx/${txHash}",
        account_page: "https://explorer.nodestake.top/stratos/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/stratos",
        tx_page: "https://staking-explorer.com/transaction.php?chain=stratos&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=stratos&addr=${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/stratos",
        tx_page: "https://explorer.tcnetwork.io/stratos/transaction/${txHash}",
        account_page: "https://explorer.tcnetwork.io/stratos/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "stride-1",
    explorers: [
      {
        kind: "BccNodes",
        url: "https://explorer.bccnodes.com/stride-M",
        tx_page: "https://explorer.bccnodes.com/stride-M/tx/${txHash}",
        account_page: "https://explorer.bccnodes.com/stride-M/account/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/stride",
        tx_page: "https://ezstaking.app/stride/txs/${txHash}",
        account_page: "https://ezstaking.app/stride/account/${accountAddress}"
      },
      {
        kind: "Apollo",
        url: "https://apollo.chandrastation.com/stride",
        tx_page: "https://apollo.chandrastation.com/stride/tx/${txHash}",
        account_page: "https://apollo.chandrastation.com/stride/account/${accountAddress}"
      },
      {
        kind: "Stride Ping Pub",
        url: "https://explorer.stride.zone/stride",
        tx_page: "https://explorer.stride.zone/stride/tx/${txHash}",
        account_page: "https://explorer.stride.zone/stride/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥 Explorer",
        url: "https://explorer.stavr.tech/stride",
        tx_page: "https://explorer.stavr.tech/stride/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/stride/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/stride",
        tx_page: "https://www.mintscan.io/stride/transactions/${txHash}",
        account_page: "https://www.mintscan.io/stride/accounts/${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/stride",
        tx_page: "https://atomscan.com/stride/transactions/${txHash}",
        account_page: "https://atomscan.com/stride/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/stride",
        tx_page: "https://staking-explorer.com/transaction.php?chain=stride&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=stride&addr=${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/stride",
        account_page: "https://stakeflow.io/stride/accounts/${accountAddress}"
      },
      {
        kind: "Stake-Take",
        url: "https://explorer.stake-take.com/stride",
        tx_page: "https://explorer.stake-take.com/stride/tx/${txHash}",
        account_page: "https://explorer.stake-take.com/stride/account/${accountAddress}"
      },
      {
        kind: "WhisperNode 🤐",
        url: "https://mainnet.whispernode.com/stride",
        tx_page: "https://mainnet.whispernode.com/stride/tx/${txHash}",
        account_page: "https://mainnet.whispernode.com/stride/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "sunrise-1",
    explorers: []
  },
  {
    chainId: "synternet-1",
    explorers: [
      {
        kind: "Big Dipper",
        url: "https://explorer.synternet.com/",
        tx_page: "https://explorer.synternet.com/transactions/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/synternet",
        tx_page: "https://staking-explorer.com/transaction.php?chain=synternet&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=synternet&addr=${accountAddress}"
      }
    ]
  },
  {
    chainId: "taketitan-12",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://scan.taketitan.com/taketitan",
        tx_page: "https://scan.taketitan.com/taketitan/tx/${txHash}",
        account_page: "https://scan.taketitan.com/taketitan/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "tenet_1559-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/tenet",
        tx_page: "https://ping.pub/tenet/tx/${txHash}"
      },
      {
        kind: "Nodeist Explorer",
        url: "https://exp.nodeist.net/Tenet",
        tx_page: "https://exp.nodeist.net/Tenet/tx/${txHash}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/tenet",
        tx_page: "https://explorer.tcnetwork.io/tenet/transaction/${txHash}",
        account_page: "https://explorer.tcnetwork.io/tenet/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/tenet",
        tx_page: "https://staking-explorer.com/transaction.php?chain=tenet&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=tenet&addr=${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/tenet",
        tx_page: "https://explorer.whenmoonwhenlambo.money/tenet/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/tenet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "teritori-1",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/teritori",
        tx_page: "https://ezstaking.app/teritori/txs/${txHash}",
        account_page: "https://ezstaking.app/teritori/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.teritori.com/teritori",
        tx_page: "https://explorer.teritori.com/teritori/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥 Explorer",
        url: "https://explorer.stavr.tech/teritori-main",
        tx_page: "https://explorer.stavr.tech/teritori-main/tx/${txHash}"
      },
      {
        kind: "guru",
        url: "https://teritori.explorers.guru/",
        tx_page: "https://teritori.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "Brochain",
        url: "https://explorer.brocha.in/teritori",
        tx_page: "https://explorer.brocha.in/teritori/tx/${txHash}"
      },
      {
        kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀",
        url: "https://exp.utsa.tech/teritori",
        tx_page: "https://exp.utsa.tech/teritori/tx/${txHash}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/teritori",
        tx_page: "https://www.mintscan.io/teritori/transactions/${txHash}",
        account_page: "https://www.mintscan.io/teritori/accounts/${accountAddress}"
      },
      {
        kind: "TC Network",
        url: "https://explorer.tcnetwork.io/teritori",
        tx_page: "https://explorer.tcnetwork.io/teritori/transaction/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/teritori",
        tx_page: "https://staking-explorer.com/transaction.php?chain=teritori&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=teritori&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/teritori",
        tx_page: "https://atomscan.com/teritori/transactions/${txHash}",
        account_page: "https://atomscan.com/teritori/accounts/${accountAddress}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/teritori",
        tx_page: "https://explorer.whenmoonwhenlambo.money/teritori/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/teritori/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "morocco-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pub/terp",
        tx_page: "https://ping.pub/terp/tx/${txHash}",
        account_page: "https://ping.pub/terp/account/{$accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.nodestake.top",
        tx_page: "https://explorer.nodestake.top/terp/tx/${txHash}",
        account_page: "https://explorer.nodestake.top/terp/account/{$accountAddress}"
      },
      {
        kind: "ZenChainLabs",
        url: "https://terp.zenscan.io/",
        tx_page: "https://terp.zenscan.io/transaction.php?hash=${txHash}",
        account_page: "https://terp.zenscan.io/address.php?address=${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Terp-Mainnet",
        tx_page: "https://explorer.stavr.tech/Terp-Mainnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Terp-Mainnet/account/{$accountAddress}"
      }
    ]
  },
  {
    chainId: "columbus-5",
    explorers: [
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/terra",
        tx_page: "https://ezstaking.app/terra/txs/${txHash}",
        account_page: "https://ezstaking.app/terra/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/terra-luna",
        tx_page: "https://ping.pub/terra-luna/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/terra",
        tx_page: "https://atomscan.com/terra/transactions/${txHash}",
        account_page: "https://atomscan.com/terra/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/terra",
        tx_page: "https://staking-explorer.com/transaction.php?chain=terra&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=terra&addr=${accountAddress}"
      },
      {
        kind: "finder",
        url: "https://finder.terra.money/classic",
        tx_page: "https://finder.terra.money/classic/tx/${txHash}",
        account_page: "https://finder.terra.money/classic/address/${accountAddress}"
      },
      {
        kind: "finder",
        url: "https://finder.terrarebels.net/classic",
        tx_page: "https://finder.terrarebels.net/classic/tx/${txHash}",
        account_page: "https://finder.terrarebels.net/classic/address/${accountAddress}"
      }
    ]
  },
  {
    chainId: "phoenix-1",
    explorers: [
      {
        kind: "atomscan",
        url: "https://atomscan.com/terra2",
        tx_page: "https://atomscan.com/terra2/transactions/${txHash}",
        account_page: "https://atomscan.com/terra2/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/terra2",
        tx_page: "https://staking-explorer.com/transaction.php?chain=terra2&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=terra2&addr=${accountAddress}"
      },
      {
        kind: "finder",
        url: "http://finder.terra.money/",
        tx_page: "https://finder.terra.money/mainnet/tx/${txHash}",
        account_page: "https://finder.terra.money/mainnet/address/${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/terra",
        account_page: "https://stakeflow.io/terra/accounts/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/terra",
        tx_page: "https://www.mintscan.io/terra/transactions/${txHash}",
        account_page: "https://www.mintscan.io/terra/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "tgrade-mainnet-1",
    explorers: [
      {
        kind: "aneka",
        url: "https://tgrade.aneka.io",
        tx_page: "https://tgrade.aneka.io/txs/${txHash}",
        account_page: "https://tgrade.aneka.io/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "thorchain-1",
    explorers: [
      {
        kind: "THORChain explorer",
        url: "https://thorchain.net",
        tx_page: "https://thorchain.net/#/txs/${txHash}"
      },
      {
        kind: "viewblock",
        url: "https://viewblock.io/thorchain",
        tx_page: "https://viewblock.io/thorchain/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "titan_18888-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://tkxscan.io",
        tx_page: "https://tkxscan.io/Titan/tx/${txHash}",
        account_page: "https://tkxscan.io/Titan/account/${accountAddress}"
      }
    ]
  },
  {
    explorers: [
      {
        kind: "Tonscan",
        url: "https://tonscan.org/",
        tx_page: "https://tonscan.org/tx/${txHash}"
      }
    ]
  },
  {
    explorers: [
      {
        kind: "TRONSCAN",
        url: "https://tronscan.org/",
        tx_page: "https://tronscan.org/#/transaction//${txHash}"
      }
    ]
  },
  {
    chainId: "umee-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/umee/",
        tx_page: "https://www.mintscan.io/umee/transactions/${txHash}",
        account_page: "https://www.mintscan.io/umee/accounts/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/umee",
        tx_page: "https://ping.pub/umee/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥 Explorer",
        url: "https://explorer.stavr.tech/umee",
        tx_page: "https://explorer.stavr.tech/umee/tx/${txHash}"
      },
      {
        kind: "explorers.guru",
        url: "https://umee.explorers.guru",
        tx_page: "https://umee.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/umee",
        tx_page: "https://atomscan.com/umee/transactions/${txHash}",
        account_page: "https://atomscan.com/umee/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/umee",
        tx_page: "https://staking-explorer.com/transaction.php?chain=umee&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=umee&addr=${accountAddress}"
      },
      {
        kind: "Stakeflow",
        url: "https://stakeflow.io/umee",
        account_page: "https://stakeflow.io/umee/accounts/${accountAddress}"
      },
      {
        kind: "Stake-Take",
        url: "https://explorer.stake-take.com/umee",
        tx_page: "https://explorer.stake-take.com/umee/transactions/${txHash}",
        account_page: "https://explorer.stake-take.com/umee/account/${accountAddress}"
      },
      {
        kind: "Stake Village",
        url: "https://exp.stakevillage.net/umee",
        tx_page: "https://exp.stakevillage.net/umee/tx/${txHash}",
        account_page: "https://exp.stakevillage.net/umee/account/${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/umee",
        tx_page: "https://ezstaking.app/umee/txs/${txHash}",
        account_page: "https://ezstaking.app/umee/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "unicorn-420"
  },
  {
    chainId: "FUND-MainNet-2",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer.unification.io/u",
        tx_page: "https://explorer.unification.io/u/tx/${txHash}",
        account_page: "https://explorer.unification.io/u/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.unification.chainmasters.ninja/unification",
        tx_page: "https://explorer.unification.chainmasters.ninja/unification/tx/${txHash}",
        account_page: "https://explorer.unification.chainmasters.ninja/Unification/account/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/unification",
        tx_page: "https://staking-explorer.com/transaction.php?chain=unification&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=unification&addr=${accountAddress}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/unification",
        tx_page: "https://atomscan.com/unification/transactions/${txHash}",
        account_page: "https://atomscan.com/unification/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "ununifi-beta-v1",
    explorers: [
      {
        kind: "UnUniFi Explorer",
        url: "https://ununifi.io/explorer",
        tx_page: "https://ununifi.io/explorer/txs/${txHash}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/ununifi",
        tx_page: "https://explorer.nodestake.top/ununifi/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/ununifi",
        tx_page: "https://staking-explorer.com/transaction.php?chain=ununifi&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=ununifi&addr=${accountAddress}"
      },
      {
        kind: "Nodeist Explorer",
        url: "https://exp.nodeist.net/Ununifi",
        tx_page: "https://exp.nodeist.net/Ununifi/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "uptick_117-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorers.brocha.in/uptick",
        tx_page: "https://explorers.brocha.in/uptick/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/uptick",
        tx_page: "https://staking-explorer.com/transaction.php?chain=uptick&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=uptick&addr=${accountAddress}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.top/uptick",
        tx_page: "https://explorer.nodestake.top/uptick/tx/${txHash}"
      },
      {
        kind: "BccNodes Explorer",
        url: "https://explorer.bccnodes.com/uptick-M",
        tx_page: "https://explorer.bccnodes.com/uptick-M/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥 Explorer",
        url: "https://explorer.stavr.tech/uptick-mainnet",
        tx_page: "https://explorer.stavr.tech/uptick-mainnet/tx/${txHash}"
      },
      {
        kind: "𝐥𝐞𝐬𝐧𝐢𝐤 | 𝐔𝐓𝐒𝐀 Explorer",
        url: "https://exp.utsa.tech/uptick",
        tx_page: "https://exp.utsa.tech/uptick/tx/${txHash}"
      },
      {
        kind: "cosmotracker",
        url: "https://cosmotracker.com/uptick",
        tx_page: "https://cosmotracker.com/uptick/tx/${txHash}"
      },
      {
        kind: "Upscan",
        url: "https://upscan.xyz/",
        tx_page: "https://upscan.xyz/uptick_117-1/tx/${txHash}"
      },
      {
        kind: "Sr20de",
        url: "https://explorer.sr20de.xyz/uptick",
        tx_page: "https://explorer.sr20de.xyz/uptick/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "vidulum-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorers.vidulum.app/vidulum",
        tx_page: "https://explorers.vidulum.app/vidulum/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://ping.pub/vidulum",
        tx_page: "https://ping.pub/vidulum/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Vidulum-Mainnet",
        tx_page: "https://explorer.stavr.tech/Vidulum-Mainnet/tx/${txHash}"
      },
      {
        kind: "atomscan",
        url: "https://atomscan.com/vidulum",
        tx_page: "https://atomscan.com/vidulum/transactions/${txHash}",
        account_page: "https://atomscan.com/vidulum/accounts/${accountAddress}"
      },
      {
        kind: "Nodine Explorer",
        url: "https://explorer.co.id/vidulum",
        tx_page: "https://explorer.co.id/vidulum/tx/${txHash}"
      },
      {
        kind: "Decloud Nodes Lab",
        url: "https://explorer.declab.pro/Vidulum",
        tx_page: "https://explorer.declab.pro/Vidulum/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "dimension_37-1",
    explorers: [
      {
        kind: "explorer.xpla",
        url: "https://explorer.xpla.io",
        tx_page: "https://explorer.xpla.io/mainnet/tx/${txHash}"
      },
      {
        kind: "finder",
        url: "https://finder.xpla.io",
        tx_page: "https://finder.xpla.io/mainnet/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Xpla-Mainnet",
        tx_page: "https://explorer.stavr.tech/Xpla-Mainnet/tx/${txHash}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/xpla",
        tx_page: "https://www.mintscan.io/xpla/transactions/${txHash}",
        account_page: "https://www.mintscan.io/xpla/accounts/${accountAddress}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/xpla",
        tx_page: "https://staking-explorer.com/transaction.php?chain=xpla&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=xpla&addr=${accountAddress}"
      },
      {
        kind: "ezstaking",
        url: "https://ezstaking.app/xpla",
        tx_page: "https://ezstaking.app/xpla/txs/${txHash}",
        account_page: "https://ezstaking.app/xpla/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "zetachain_7000-1",
    explorers: [
      {
        kind: "ZetaScan",
        url: "https://explorer.zetachain.com/",
        tx_page: "https://explorer.zetachain.com/cc/tx/${txHash}"
      },
      {
        kind: "BlockScout",
        url: "https://zetachain.blockscout.com/",
        tx_page: "https://zetachain.blockscout.com/tx/${txHash}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.org/zetachain",
        tx_page: "https://explorer.nodestake.org/zetachain/tx/${txHash}"
      },
      {
        kind: "staking-explorer.com",
        url: "https://staking-explorer.com/explorer/zetachain",
        tx_page: "https://staking-explorer.com/transaction.php?chain=zetachain&tx=${txHash}",
        account_page: "https://staking-explorer.com/account.php?chain=zetachain&addr=${accountAddress}"
      },
      {
        kind: "Nodes Hub 🛡️ 100% Slash Protected 🛡️ | Restake ✅",
        url: "https://explorer.nodeshub.online/zetachain/",
        tx_page: "https://explorer.nodeshub.online/zetachain/tx/${txHash}",
        account_page: "https://explorer.nodeshub.online/zetachain/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "junction",
    explorers: [
      {
        kind: "Airchains",
        url: "https://testnet.airchains.io",
        tx_page: "https://testnet.airchains.io/transaction/${txHash}",
        account_page: "https://testnet.airchains.io/address/${accountAddress}"
      },
      {
        kind: "NodesGuru",
        url: "https://testnet.junction.explorers.guru/",
        tx_page: "https://testnet.junction.explorers.guru/transaction/${txHash}",
        account_page: "https://testnet.junction.explorers.guru/account/${accountAddress}"
      },
      {
        kind: "Nodejumper",
        url: "https://app.nodejumper.io/airchains-testnet/"
      },
      {
        kind: "UTSA",
        url: "https://exp.utsa.tech/airchains-test/",
        tx_page: "https://exp.utsa.tech/airchains-test/tx/${txHash}",
        account_page: "https://exp.utsa.tech/airchains-test/account/${accountAddress}"
      },
      {
        kind: "Stavr Tech",
        url: "https://explorer.stavr.tech/Airchains-Testnet",
        tx_page: "https://explorer.stavr.tech/Airchains-Testnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Airchains-Testnet/${accountAddress}"
      },
      {
        kind: "CoinHunters",
        url: "https://explorer.coinhunterstr.com/Airchains",
        tx_page: "https://explorer.coinhunterstr.com/Airchains/tx/${txHash}",
        account_page: "https://explorer.coinhunterstr.com/Airchains/account/${accountAddress}"
      },
      {
        kind: "KZVN",
        url: "https://explorer.kzvn.xyz/airchains",
        tx_page: "https://explorer.kzvn.xyz/airchains/tx/${txHash}",
        account_page: "https://explorer.kzvn.xyz/airchains/account/${accountAddress}"
      },
      {
        kind: "Elessar Nodes",
        url: "https://explorer.elessarnodes.xyz/Airchains",
        tx_page: "https://explorer.elessarnodes.xyz/Airchains/tx/${txHash}",
        account_page: "https://explorer.elessarnodes.xyz/Airchains/account/${accountAddress}"
      },
      {
        kind: "Apollo Sync",
        url: "https://explorer.apollo-sync.com/",
        tx_page: "https://explorer.apollo-sync.com/tx/${txHash}",
        account_page: "https://explorer.apollo-sync.com/account/${accountAddress}"
      },
      {
        kind: "Stakeme",
        url: "https://airchains.exploreme.pro/",
        tx_page: "https://airchains.exploreme.pro/transaction/${txHash}"
      },
      {
        kind: "StakerHouse",
        url: "https://cosmotracker.com/airchains",
        tx_page: "https://cosmotracker.com/airchains/tx/${txHash}",
        account_page: "https://cosmotracker.com/airchains/account/${accountAddress}"
      },
      {
        kind: "IT Rocket",
        url: "https://testnet.itrocket.net/airchains/",
        tx_page: "https://testnet.itrocket.net/airchains//tx/${txHash}",
        account_page: "https://testnet.itrocket.net/airchains/account/${accountAddress}"
      },
      {
        kind: "Validator VN ",
        url: "https://explorer.validatorvn.com/Airchains-Testnet",
        tx_page: "https://explorer.validatorvn.com/Airchains-Testnet/tx/${txHash}",
        account_page: "https://explorer.validatorvn.com/Airchains-Testnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "sandbox-01",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer.sandbox-01.aksh.pw/akash",
        tx_page: "https://explorer.sandbox-01.aksh.pw/akash/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "constantine-3",
    explorers: [
      {
        kind: "archwayscan",
        url: "https://testnet.archway.explorers.guru",
        tx_page: "https://testnet.archway.explorers.guru/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "arkeo",
    explorers: [
      {
        url: "https://explorer.nodexcapital.com/arkeo",
        tx_page: "https://explorer.nodexcapital.com/arkeo/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "artela_11820-1",
    explorers: [
      {
        kind: "Artela Network",
        url: "https://testnet-scan.artela.network",
        tx_page: "https://testnet-scan.artela.network/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "aura_6321-3",
    explorers: [
      {
        kind: "aurascan",
        url: "https://euphoria.aurascan.io",
        tx_page: "https://euphoria.aurascan.io/tx/${txHash}",
        account_page: "https://euphoria.aurascan.io/address/${accountAddress}"
      }
    ]
  },
  {
    chainId: "axelar-testnet-lisbon-3",
    explorers: [
      {
        kind: "axelarscan",
        url: "https://testnet.axelarscan.io",
        tx_page: "https://testnet.axelarscan.io/tx/${txHash}"
      },
      {
        kind: "mintscan",
        url: "https://mintscan.io/axelar-testnet",
        tx_page: "https://mintscan.io/axelar-testnet/txs/${txHash}",
        account_page: "https://mintscan.io/axelar-testnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "bbn-test3",
    explorers: [
      {
        kind: "babylonscan",
        url: "https://babylonscan.io"
      },
      {
        kind: "explorers.guru",
        url: "https://testnet.babylon.explorers.guru",
        tx_page: "https://testnet.babylon.explorers.guru/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "bbn-test1",
    explorers: [
      {
        kind: "babylonscan",
        url: "https://babylonscan.io"
      },
      {
        kind: "explorers.guru",
        url: "https://babylon.explorers.guru",
        tx_page: "https://babylon.explorers.guru/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "bitcanna-dev-1",
    explorers: [
      {
        url: "https://explorer.thesilverfox.pro/bitcanna",
        tx_page: "https://explorer.thesilverfox.pro/bitcanna/tx/${txHash}"
      },
      {
        url: "https://testnets-cosmos.mintthemoon.xyz/bitcanna",
        tx_page: "https://testnets-cosmos.mintthemoon.xyz/bitcanna/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Bitcanna-DEV",
        tx_page: "https://explorer.stavr.tech/Bitcanna-DEV/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Bitcanna-DEV/account/${accountAddress}"
      },
      {
        url: "https://explorer.kjnodes.com/bitcanna-testnet",
        tx_page: "https://explorer.kjnodes.com/bitcanna-testnet/tx/${txHash}"
      },
      {
        url: "https://explorer.stavr.tech/bitcanna-dev",
        tx_page: "https://explorer.stavr.tech/bitcanna-dev/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "blockx_19077-1"
  },
  {
    chainId: "cascadia_6102-1",
    explorers: [
      {
        kind: "validator_explorer",
        url: "https://validator.cascadia.foundation/",
        tx_page: "https://validator.cascadia.foundation/transactions/${txHash}",
        account_page: "https://validator.cascadia.foundation/accounts/${accountAddress}"
      },
      {
        kind: "block_explorer",
        url: "https://explorer.cascadia.foundation/",
        tx_page: "https://explorer.cascadia.foundation/tx/${txHash}",
        account_page: "https://explorer.cascadia.foundation/address/${accountAddress}"
      }
    ]
  },
  {
    chainId: "blockspacerace-0",
    explorers: [
      {
        kind: "Mintscan",
        url: "https://mintscan.io/celestia-incentivized-testnet",
        tx_page: "https://mintscan.io/celestia-incentivized-testnet/txs/${txHash}"
      }
    ]
  },
  {
    chainId: "mocha-4",
    explorers: [
      {
        kind: "Mintscan",
        url: "https://mintscan.io/celestia-testnet",
        tx_page: "https://mintscan.io/celestia-testnet/txs/${txHash}"
      },
      {
        kind: "🚀ITRocket🚀",
        url: "https://testnet.itrocket.net/celestia",
        tx_page: "https://testnet.itrocket.net/celestia/tx/${txHash}",
        account_page: "https://testnet.itrocket.net/celestia/account/${accountAddress}"
      },
      {
        kind: "CrypTech",
        url: "https://explorers.cryptech.com.ua/Celestia-Testnet",
        tx_page: "https://explorers.cryptech.com.ua/Celestia-Testnet/tx/${txHash}",
        account_page: "https://explorers.cryptech.com.ua/Celestia-Testnet/account/${accountAddress}"
      },
      {
        kind: "DTEAM | Explorer",
        url: "https://explorer.testnet.dteam.tech/celestia",
        tx_page: "https://explorer.testnet.dteam.tech/celestia/tx/${txHash}",
        account_page: "https://explorer.testnet.dteam.tech/celestia/account/${accountAddress}"
      },
      {
        kind: "Relaxed Explorer 🦥",
        url: "https://testnet.explorer.stakeandrelax.net/celestia",
        tx_page: "https://testnet.explorer.stakeandrelax.net/celestia/transaction/${txHash}",
        account_page: "https://testnet.explorer.stakeandrelax.net/celestia/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "babajaga-1",
    explorers: [
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/C4E-Testnet",
        tx_page: "https://explorer.stavr.tech/C4E-Testnet/transactions/${txHash}"
      },
      {
        kind: "explorer",
        url: "https://explorer-testnet.c4e.io/",
        tx_page: "https://explorer-testnet.c4e.io/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "cheqd-testnet-6",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://testnet-explorer.cheqd.io/",
        tx_page: "https://testnet-explorer.cheqd.io/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "chimba-testnet",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://explorer.testnet.chimba.ooo/",
        tx_page: "https://explorer.testnet.chimba.ooo/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "banksy-testnet-3",
    explorers: [
      {
        url: "https://explorer.nodexcapital.com/composable-3",
        tx_page: "https://explorer.nodexcapital.com/composable-3/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Composable-Testnet4",
        tx_page: "https://explorer.stavr.tech/Composable-Testnet4/tx/${txHash}"
      },
      {
        url: "https://explorer.indonode.net/composable-testnet-3",
        tx_page: "https://explorer.indonode.net/composable-testnet-3/tx/${txHash}"
      },
      {
        url: "https://explorer.sr20de.xyz/Composible-3",
        tx_page: "https://explorer.sr20de.xyz/Composible-3/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "kitten-04",
    explorers: []
  },
  {
    chainId: "coreum-testnet-1",
    explorers: [
      {
        kind: "Coreum",
        url: "https://explorer.testnet-1.coreum.dev/coreum",
        tx_page: "https://explorer.testnet-1.coreum.dev/coreum/transactions/${txHash}",
        account_page: "https://explorer.testnet-1.coreum.dev/coreum/account/${accountAddress}"
      },
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/coreum-testnet",
        tx_page: "https://www.mintscan.io/coreum-testnet/transactions/${txHash}",
        account_page: "https://www.mintscan.io/coreum-testnet/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "theta-testnet-001",
    explorers: [
      {
        kind: "Mintscan",
        url: "https://mintscan.io/cosmoshub-testnet",
        tx_page: "https://mintscan.io/cosmoshub-testnet/txs/${txHash}"
      },
      {
        kind: "Big Dipper",
        url: "https://explorer.theta-testnet.polypore.xyz/",
        tx_page: "https://explorer.theta-testnet.polypore.xyz/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "provider",
    explorers: [
      {
        kind: "Mintscan",
        url: "https://mintscan.io/ics-testnet-provider",
        tx_page: "https://mintscan.io/ics-testnet-provider/tx/${txHash}"
      },
      {
        kind: "Ping.pub",
        url: "https://explorer.rs-testnet.polypore.xyz/provider",
        tx_page: "https://explorer.rs-testnet.polypore.xyz/provider/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "malaga-420",
    explorers: [
      {
        kind: "BIG DIPPER",
        url: "https://block-explorer.malaga-420.cosmwasm.com/",
        tx_page: "https://block-explorer.malaga-420.cosmwasm.com/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "coss-testnet-1"
  },
  {
    chainId: "cudos-testnet-public-3",
    explorers: [
      {
        kind: "bigdipper-testnet",
        url: "https://explorer.testnet.cudos.org/",
        tx_page: "https://explorer.testnet.cudos.org/transactions/${txHash}",
        account_page: "https://explorer.testnet.cudos.org/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "deardoge-testnet",
    explorers: [
      {
        kind: "Dear Doge Ping Pub",
        url: "https://testnet-explorer.deardoge.org/deardoge",
        tx_page: "https://testnet-explorer.deardoge.org/deardoge/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "morpheus-apollo-3",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://testnet.bigdipper.live/desmos",
        tx_page: "https://testnet.live/desmos/transactions/${txHash}",
        account_page: "https://testnet.bigdipper.live/desmos/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "dhealth-testnet-2",
    explorers: []
  },
  {
    chainId: "vota-testnet",
    explorers: [
      {
        kind: "Dora Vota Ping Pub",
        url: "https://maci-explorer-test.dorafactory.org",
        tx_page: "https://maci-explorer-test.dorafactory.org/dora/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "vota-vk",
    explorers: [
      {
        kind: "Dora Vota Ping Pub",
        url: "https://vota-vk-explorer.dorafactory.org",
        tx_page: "https://vota-vk-explorer.dorafactory.org/doravotaincentive/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "dydx-testnet-4",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/dydx-testnet",
        tx_page: "https://www.mintscan.io/dydx-testnet/txs/${txHash}",
        account_page: "https://www.mintscan.io/dydx-testnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "elystestnet-1",
    explorers: [
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Elys-Testnet",
        tx_page: "https://explorer.stavr.tech/Elys-Testnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Elys-Testnet/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://testnet.elys.network/elys",
        tx_page: "https://testnet.elys.network/elys/tx/${txHash}"
      },
      {
        kind: "itrocket",
        url: "https://testnet.itrocket.net/elys",
        tx_page: "https://testnet.itrocket.net/elys/staking/tx/${txHash}",
        account_page: "https://testnet.itrocket.net/elys/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "empe-testnet-2",
    explorers: [
      {
        kind: "empe",
        url: "https://explorer-testnet.empe.io",
        tx_page: "https://explorer-testnet.empe.io/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "circulus-1",
    explorers: [
      {
        kind: "exploreme",
        url: "https://empowerchain.exploreme.pro",
        tx_page: "https://empowerchain.exploreme.pro/transaction/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://exp.nodeist.net/Empower",
        tx_page: "https://exp.nodeist.net/Empower/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Empower",
        tx_page: "https://explorer.stavr.tech/Empower/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.nodestake.top/empower-testnet",
        tx_page: "https://explorer.nodestake.top/empower-testnet/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://testnet.itrocket.net/empower/staking",
        tx_page: "https://testnet.itrocket.net/empower/staking/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.stavr.tech/empower",
        tx_page: "https://explorer.stavr.tech/empower/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "entrypoint-pubtest-2",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer.entrypoint.zone/entrypoint",
        tx_page: "https://explorer.entrypoint.zone/entrypoint/tx/${txHash}",
        account_page: "https://explorer.entrypoint.zone/entrypoint/account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Entrypoint-Testnet",
        tx_page: "https://explorer.stavr.tech/Entrypoint-Testnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Entrypoint-Testnet/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://testnet.ping.pub/entrypoint",
        tx_page: "https://testnet.ping.pub/entrypoint/tx/${txHash}",
        account_page: "https://testnet.ping.pub/entrypoint/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "epix_4243-1",
    explorers: [
      {
        kind: "Epix Explorer",
        url: "https://testnet.epix.zone/epix",
        tx_page: "https://testnet.epix.zone/epix/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "evmos_9000-4",
    explorers: [
      {
        kind: "Mintscan",
        url: "https://mintscan.io/evmos-testnet",
        tx_page: "https://mintscan.io/evmos-testnet/txs/${txHash}"
      },
      {
        kind: "NodesGuru",
        url: "https://testnet.evmos.explorers.guru/",
        tx_page: "https://testnet.evmos.explorers.guru/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "dorado-1",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://explore-dorado.fetch.ai",
        tx_page: "https://explore-dorado.fetch.ai/transactions/${txHash}"
      },
      {
        kind: "azoyalabs",
        url: "https://fetchstation.azoyalabs.com/testnet",
        tx_page: "https://fetchstation.azoyalabs.com/testnet/explorer/transactions/${txHash}",
        account_page: "https://fetchstation.azoyalabs.com/testnet/explorer/address/${accountAddress}"
      }
    ]
  },
  {
    chainId: "fiamma-testnet-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://testnet-explorer.fiammachain.io/"
      }
    ]
  },
  {
    chainId: "ebony-2",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/finschia-testnet",
        tx_page: "https://www.mintscan.io/finschia-testnet/tx/${txHash}",
        account_page: "https://www.mintscan.io/finschia-testnet/address/${accountAddress}"
      }
    ]
  },
  {
    chainId: "galactica_9302-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pfc.zone/galactica-testnet",
        tx_page: "https://ping.pfc.zone/galactica-testnet/tx/${txHash}",
        account_page: "https://ping.pfc.zone/galactica-testnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "gitopia-janus-testnet-2",
    explorers: [
      {
        kind: "explorer.humans.zone",
        url: "https://gitopia.explorers.guru/",
        tx_page: "https://gitopia.explorers.guru/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "berberis-1",
    explorers: [
      {
        kind: "hedgescan",
        url: "https://berberis.hedgescan.io",
        tx_page: "https://berberis.hedgescan.io/txs/${txHash}"
      }
    ]
  },
  {
    chainId: "testnet-1",
    explorers: [
      {
        kind: "explorer.humans.zone",
        url: "https://explorer.humans.zone/",
        tx_page: "https://explorer.humans.zone/humans-testnet/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "prajna-1",
    explorers: [
      {
        kind: "Hypersign",
        url: "https://explorer.hypersign.id/hypersign-prajna-testnet",
        tx_page: "https://explorer.hypersign.id/hypersign-prajna-testnet/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "pandora-8",
    explorers: [
      {
        kind: "ixoworld",
        url: "https://blockscan.testnet.ixo.earth/ixo",
        tx_page: "https://blockscan.testnet.ixo.earth/ixo/transactions/${txHash}",
        account_page: "https://blockscan.testnet.ixo.earth/ixo/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "imversed-test-1",
    explorers: [
      {
        kind: "Big Dipper",
        url: "https://tex-s.imversed.com",
        tx_page: "https://tex-s.imversed.com/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "injective-888",
    explorers: [
      {
        kind: "injectiveprotocol",
        url: "https://testnet.explorer.injective.network/",
        tx_page: "https://testnet.explorer.injective.network/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "canine-1",
    explorers: [
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Jackal-Testnet",
        tx_page: "https://explorer.stavr.tech/Jackal-Testnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Jackal-Testnet/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://testnet.ping.pub/jackal",
        tx_page: "https://testnet.ping.pub/jackal/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "mesomelas-1",
    explorers: [
      {
        kind: "PingPub",
        url: "https://testnet-explorer.brocha.in/Jackal%20v4",
        tx_page: "https://testnet-explorer.brocha.in/Jackal%20v4/tx/${txHash}",
        account_page: "https://testnet-explorer.brocha.in/Jackal%20v4/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "uni-6",
    explorers: [
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Juno-Testnet",
        tx_page: "https://explorer.stavr.tech/Juno-Testnet/txs/${txHash}",
        account_page: "https://explorer.stavr.tech/Juno-Testnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "kichain-t-4",
    explorers: [
      {
        kind: "kifoundation",
        url: "https://kichain-t-4.blockchain.ki/",
        tx_page: "https://kichain-t-4.blockchain.ki/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "kima_testnet",
    explorers: [
      {
        kind: "Kima Network",
        url: "https://explorer-testnet.kima.finance/",
        tx_page: "https://explorer-testnet.kima.finance/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "harpoon-4",
    explorers: [
      {
        kind: "explorers.guru",
        url: "https://kujira.explorers.guru",
        tx_page: "https://kujira.explorers.guru/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "kaon-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://mintscan.io/kyve-testnet",
        tx_page: "https://mintscan.io/kyve-testnet/txs/${txHash}",
        account_page: "https://mintscan.io/kyve-testnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "lava-testnet-2",
    explorers: [
      {
        kind: "explorers.guru",
        url: "https://lava.explorers.guru/",
        tx_page: "https://lava.explorers.guru//transaction/${txHash}",
        account_page: "https://lava.explorers.guru//account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Lava-Testnet",
        tx_page: "https://explorer.stavr.tech/Lava-Testnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Lava-Testnet/account/${accountAddress}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.org/lava-testnet",
        tx_page: "https://explorer.nodestake.org/lava-testnet/tx/${txHash}",
        account_page: "https://explorer.nodestake.org/lava-testnet/account/${accountAddress}"
      },
      {
        kind: "🚀ITRocket🚀",
        url: "https://testnet.itrocket.net/lava",
        tx_page: "https://testnet.itrocket.net/lava/tx/${txHash}",
        account_page: "https://testnet.itrocket.net/lava/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "lava-testnet-1",
    explorers: [
      {
        kind: "explorers.guru",
        url: "https://lava.explorers.guru/",
        tx_page: "https://lava.explorers.guru//transaction/${txHash}",
        account_page: "https://lava.explorers.guru//account/${accountAddress}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Lava-Testnet",
        tx_page: "https://explorer.stavr.tech/Lava-Testnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Lava-Testnet/account/${accountAddress}"
      },
      {
        kind: "NodeStake Explorer",
        url: "https://explorer.nodestake.org/lava-testnet",
        tx_page: "https://explorer.nodestake.org/lava-testnet/tx/${txHash}",
        account_page: "https://explorer.nodestake.org/lava-testnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "likecoin-public-testnet-5",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://testnet.bigdipper.live/likecoin",
        tx_page: "https://testnet.bigdipper.live/likecoin/transactions/${txHash}",
        account_page: "https://testnet.bigdipper.live/likecoin/accounts/${accountAddress}"
      },
      {
        kind: "lunie-ng",
        url: "https://likecoin-public-testnet-5.netlify.app/"
      }
    ]
  },
  {
    chainId: "lumenx-test",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://testnet.explorer.chaintools.tech/lumenx",
        tx_page: "https://testnet.explorer.chaintools.tech/lumenx/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "manifest-ledger-beta",
    explorers: [
      {
        kind: "Default Explorer",
        url: "https://manifest-explorer.vercel.app/",
        tx_page: "https://manifest-explorer.vercel.app/manifest/tx"
      }
    ]
  },
  {
    chainId: "mantra-hongbai-1"
  },
  {
    chainId: "mantra-dukong-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://www.mintscan.io/mantra-testnet",
        tx_page: "https://mintscan.io/mantra-testnet/txs/${txHash}",
        account_page: "https://mintscan.io/mantra-testnet/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.mantrachain.io",
        tx_page: "https://explorer.mantrachain.io/MANTRA-Dukong/tx/${txHash}",
        account_page: "https://explorer.mantrachain.io/MANTRA-Dukong/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "ares-1",
    explorers: [
      {
        kind: "Mars Protocol",
        url: "https://testnet-explorer.marsprotocol.io",
        tx_page: "https://testnet-explorer.marsprotocol.io/transactions/${txHash}"
      },
      {
        kind: "Nodeist Explorer",
        url: "https://exp.nodeist.net/t-mars/",
        tx_page: "https://exp.nodeist.net/t-mars/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "mnova_10096-1"
  },
  {
    chainId: "narwhal-2",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://ping.pfc.zone/narwhal-testnet",
        tx_page: "https://ping.pfc.zone/narwhal-testnet/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "neura_267-1",
    explorers: [
      {
        kind: "ankrscan-neura",
        url: "https://testnet.explorer.neuraprotocol.io",
        tx_page: "https://testnet.explorer.neuraprotocol.io/tx/${txHash}"
      },
      {
        kind: "blockscout",
        url: "https://explorer.neura-testnet.ankr.com",
        tx_page: "https://explorer.neura-testnet.ankr.com/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "pion-1",
    explorers: [
      {
        kind: "Ping.pub Explorer from Hypha",
        url: "https://explorer.rs-testnet.polypore.xyz/pion-1",
        tx_page: "https://explorer.rs-testnet.polypore.xyz/pion-1/tx/${txHash}",
        account_page: "https://explorer.rs-testnet.polypore.xyz/baryon-1/account/${accountAddress}"
      },
      {
        kind: "Mintscan",
        url: "https://mintscan.io/neutron-testnet",
        tx_page: "https://mintscan.io/neutron-testnet/txs/${txHash}",
        account_page: "https://mintscan.io/neutron-testnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "nibiru-testnet-1",
    explorers: [
      {
        kind: "Nibiru Foundation",
        url: "https://explorer.nibiru.fi/nibiru-testnet-1",
        tx_page: "https://explorer.nibiru.fi/nibiru-tesnet-1/tx/${txHash}",
        account_page: "https://explorer.nibiru.fi/nibiru-testnet-1/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "nibiru-testnet-2",
    explorers: [
      {
        kind: "Nibiru Foundation",
        url: "https://explorer.nibiru.fi/nibiru-testnet-2",
        tx_page: "https://explorer.nibiru.fi/nibiru-tesnet-2/tx/${txHash}",
        account_page: "https://explorer.nibiru.fi/nibiru-testnet-2/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "nibiru-testnet-3",
    explorers: [
      {
        kind: "Nibiru Foundation",
        url: "https://explorer.nibiru.fi/nibiru-testnet-3",
        tx_page: "https://explorer.nibiru.fi/nibiru-tesnet-3/tx/${txHash}",
        account_page: "https://explorer.nibiru.fi/nibiru-testnet-3/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "nillion-chain-testnet-1",
    explorers: [
      {
        url: "https://testnet.nillion.explorers.guru",
        tx_page: "https://testnet.nillion.explorers.guru/transaction/${txHash}",
        account_page: "https://testnet.nillion.explorers.guru/account/${accountAddress}"
      },
      {
        url: "https://testnet.ping.pub/nillion",
        tx_page: "https://testnet.ping.pub/nillion/tx/${txHash}",
        account_page: "https://testnet.ping.pub/nillion/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "grand-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://mintscan.io/noble-testnet",
        tx_page: "https://mintscan.io/noble-testnet/txs/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://explore.strange.love/grand-1",
        tx_page: "https://explore.strange.love/grand-1/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "nois-testnet-005",
    explorers: [
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Nois-Testnet",
        tx_page: "https://explorer.stavr.tech/Nois-Testnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Nois-Testnet/account/${accountAddress}"
      },
      {
        kind: "explorers.guru",
        url: "https://testnet.nois.explorers.guru",
        tx_page: "https://testnet.nois.explorers.guru/transaction/${txHash}",
        account_page: "https://testnet.nois.explorers.guru/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "rila-1",
    explorers: [
      {
        kind: "Nolus Explorer",
        url: "https://explorer-rila.nolus.io/rila-1/",
        tx_page: "https://explorer-rila.nolus.io/rila-1/tx/${txHash}",
        account_page: "https://explorer-rila.nolus.io/rila-1/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "nomic-testnet-6",
    explorers: []
  },
  {
    chainId: "sandbox",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://sandbox-blocks.nymtech.net/sandbox",
        tx_page: "https://sandbox-blocks.nymtech.net/sandbox/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "okp4-nemeton-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://testnet.ping.pub/OKP4%20testnet",
        tx_page: "https://testnet.ping.pub/OKP4%20testnet/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/OKP4-Testnet",
        tx_page: "https://explorer.stavr.tech/OKP4-Testnet/tx/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://explore.okp4.network/OKP4%20testnet",
        tx_page: "https://explore.okp4.network/OKP4%20testnet/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "osmo-test-5",
    explorers: [
      {
        kind: "mintscan",
        url: "https://mintscan.io/osmosis-testnet",
        tx_page: "https://mintscan.io/osmosis-testnet/txs/${txHash}",
        account_page: "https://mintscan.io/osmosis-testnet/account/${accountAddress}"
      },
      {
        kind: "ping.pub",
        url: "https://explorer.osmotest5.osmosis.zone",
        tx_page: "https://explorer.osmotest5.osmosis.zone/osmo-test-5/tx/${txHash}",
        account_page: "https://explorer.osmotest5.osmosis.zone/osmo-test-5/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "osmo-test-4"
  },
  {
    chainId: "INVALID-ID-permtestnet-testnet-1",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://explorer.testnet.perm.ooo/",
        tx_page: "https://explorer.testnet.perm.ooo/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "test-core-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://testnet.ping.pub/test-core-1/",
        tx_page: "https://testnet.ping.pub/test-core-1/tx/${txHash}"
      },
      {
        kind: "mintscan",
        url: "https://mintscan.io/persistence-testnet",
        tx_page: "https://mintscan.io/persistence-testnet/txs/${txHash}",
        account_page: "https://mintscan.io/persistence-testnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "test-core-2",
    explorers: [
      {
        kind: "mintscan",
        url: "https://mintscan.io/persistence-testnet",
        tx_page: "https://mintscan.io/persistence-testnet/txs/${txHash}",
        account_page: "https://mintscan.io/persistence-testnet/account/${accountAddress}"
      },
      {
        kind: "StakeFlow",
        url: "https://stakeflow.io/persistence-testnet",
        tx_page: "https://stakeflow.io/persistence-testnet/transactions/${txHash}",
        account_page: "https://stakeflow.io/persistence-testnet/accounts/${accountAddress}"
      },
      {
        kind: "baryon",
        url: "https://testnet-explorer.baryon.dev/test-core-2",
        tx_page: "https://testnet-explorer.baryon.dev/test-core-2/tx/{txHash}",
        account_page: "https://testnet-explorer.baryon.dev/test-core-2/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "planq_7077-1",
    explorers: [
      {
        kind: "EVM",
        url: "https://evm-atlas.planq.network",
        tx_page: "https://evm-atlas.planq.network/tx/${txHash}"
      },
      {
        kind: "Konsortech",
        url: "https://testnet-explorer.konsortech.xyz/planq",
        tx_page: "https://testnet-explorer.konsortech.xyz/planq/tx/${txHash}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/planq-testnet",
        tx_page: "https://explorer.whenmoonwhenlambo.money/planq-testnet/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "indigo-1",
    explorers: [
      {
        kind: "PingPub",
        url: "https://testnets.cosmosrun.info/pryzm-indigo-1",
        tx_page: "https://testnets.cosmosrun.info/pryzm-indigo-1/tx/${txHash}",
        account_page: "https://testnets.cosmosrun.info/pryzm-indigo-1/account/${accountAddress}"
      },
      {
        kind: "ITRocket",
        url: "https://testnet.itrocket.net/pryzm",
        tx_page: "https://testnet.itrocket.net/pryzm/tx/${txHash}",
        account_page: "https://testnet.itrocket.net/pryzm/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "quasar-test-1"
  },
  {
    chainId: "rhye-2",
    explorers: [
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Quicksilver",
        tx_page: "https://explorer.stavr.tech/Quicksilver/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Quicksilver/account/${accountAddress}"
      },
      {
        url: "https://testnet.quicksilver.explorers.guru",
        tx_page: "https://testnet.quicksilver.explorers.guru/transaction/${txHash}",
        account_page: "https://testnet.quicksilver.explorers.guru/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "earendel-1",
    explorers: [
      {
        kind: "pingfork",
        url: "https://explorer.theamsolutions.info/qwoyn-testnet/",
        tx_page: "https://explorer.theamsolutions.info/qwoyn-testnet/tx/${txHash}",
        account_page: "https://explorer.theamsolutions.info/qwoyn-testnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "ssc-testnet-1",
    explorers: [
      {
        kind: "mintscan",
        url: "https://mintscan.io/saga-testnet",
        tx_page: "https://www.mintscan.io/saga-testnet/tx/${txHash}",
        account_page: "https://mintscan.io/saga-testnet/address/${accountAddress}"
      }
    ]
  },
  {
    chainId: "pulsar-3",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://testnet.ping.pub/secret",
        tx_page: "https://testnet.ping.pub/secret/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "pulsar-2",
    explorers: [
      {
        kind: "secret nodes",
        url: "https://secretnodes.com/secret/chains/pulsar-2",
        tx_page: "https://secretnodes.com/secret/chains/pulsar-2/transactions/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://testnet.ping.pub/secret",
        tx_page: "https://testnet.ping.pub/secret/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "atlantic-1",
    explorers: [
      {
        kind: "explorers.guru",
        url: "https://sei.explorers.guru",
        tx_page: "https://sei.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "Brochain",
        url: "https://testnet-explorer.brocha.in/sei",
        tx_page: "https://testnet-explorer.brocha.in/sei/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "atlantic-2",
    explorers: [
      {
        kind: "blockscout",
        url: "https://seitrace.com/?chain=atlantic-2",
        tx_page: "https://seitrace.com/tx/${txHash}?chain=atlantic-2"
      },
      {
        kind: "celatone",
        url: "https://www.seiscan.app/atlantic-2",
        tx_page: "https://www.seiscan.app/atlantic-2/txs/${txHash}"
      },
      {
        kind: "explorers.guru",
        url: "https://testnet.sei.explorers.guru",
        tx_page: "https://testnet.sei.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "Brochain",
        url: "https://testnet-explorer.brocha.in/sei%20atlantic%202",
        tx_page: "https://testnet-explorer.brocha.in/sei%20atlantic%202/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "self-dev-1",
    explorers: [
      {
        kind: "Selfchain",
        url: "https://explorer-devnet.selfchain.xyz",
        tx_page: "https://explorer-devnet.selfchain.xyz/self/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "sge-network-3",
    explorers: [
      {
        kind: "Sge BlockExplorer",
        url: "https://blockexplorer.testnet.sgenetwork.io/",
        tx_page: "https://blockexplorer.testnet.sgenetwork.io/sge-network/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Sge-Testnet",
        tx_page: "https://explorer.stavr.tech/Sge-Testnet/tx/${txHash}",
        account_page: "https://explorer.stavr.tech/Sge-Testnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "sge-network-4",
    explorers: [
      {
        kind: "Sge BlockExplorer",
        url: "https://blockexplorer.testnet.sgenetwork.io/",
        tx_page: "https://blockexplorer.testnet.sgenetwork.io/sge-network/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "yulei-2.1",
    explorers: [
      {
        kind: "Shentu Explorer",
        url: "https://explorer.shentu.org/?chain=yulei-2.1",
        tx_page: "https://explorer.shentu.org/transactions/${txHash}?chain=yulei-2.1"
      }
    ]
  },
  {
    chainId: "fivenet",
    explorers: [
      {
        kind: "sixscan",
        url: "https://sixscan.io/fivenet",
        tx_page: "https://sixscan.io/fivenet/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "soarchaintestnet",
    explorers: [
      {
        kind: "Soarchain Explorer",
        url: "https://explorer.soarchain.com/soarchain",
        tx_page: "https://explorer.soarchain.com/soarchain/tx/${txHash}"
      },
      {
        kind: "Kjnodes Explorer",
        url: "https://explorer.kjnodes.com/soarchain-testnet",
        tx_page: "https://explorer.kjnodes.com/soarchain-testnet/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "sourcetest-1",
    explorers: [
      {
        kind: "Nodestake",
        url: "https://explorer.nodestake.top/source-testnet",
        tx_page: "https://explorer.nodestake.top/source-testnet/tx/${txHash}"
      },
      {
        kind: "🔥STAVR🔥",
        url: "https://explorer.stavr.tech/Source",
        tx_page: "https://explorer.stavr.tech/Source/tx/${txHash}"
      },
      {
        kind: "SR20DE",
        url: "https://explorer.sr20de.xyz/Source-testnet",
        tx_page: "https://explorer.sr20de.xyz/Source-testnet/txs/${txHash}"
      },
      {
        kind: "🚀 WHEN MOON 🌕 WHEN LAMBO 🔥",
        url: "https://explorer.whenmoonwhenlambo.money/source-testnet",
        tx_page: "https://explorer.whenmoonwhenlambo.money/source-testnet/tx/${txHash}",
        account_page: "https://explorer.whenmoonwhenlambo.money/source-testnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "elgafar-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://testnet-explorer.publicawesome.dev/stargaze",
        tx_page: "https://testnet-explorer.publicawesome.dev/stargaze/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "stateset-1-testnet",
    explorers: [
      {
        kind: "bigdipper",
        url: "https://explore.stateset.zone",
        tx_page: "https://explore.stateset.zone/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "stride-internal-1",
    explorers: [
      {
        kind: "PingPub",
        url: "https://testnet.ping.pub/stride",
        tx_page: "https://testnet.ping.pub/stride/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "sunrise-test-0.1",
    explorers: []
  },
  {
    chainId: "swisstronik_1291-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer-cosmos.testnet.swisstronik.com/swisstronik",
        tx_page: "https://explorer-cosmos.testnet.swisstronik.com/swisstronik/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "symphony-testnet-3"
  },
  {
    chainId: "amber-2",
    explorers: [
      {
        kind: "Big Dipper",
        url: "https://explorer-testnet.synternet.com/",
        tx_page: "https://explorer-testnet.synternet.com/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "temporal-test-2",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://testnet.explorer.thesilverfox.pro/temporal",
        tx_page: "https://testnet.explorer.thesilverfox.pro/temporal/tx/${txHash}"
      },
      {
        kind: "Nodes.Guru",
        url: "https://testnet.temporal.explorers.guru",
        tx_page: "https://testnet.temporal.explorers.guru/transaction/${txHash}"
      },
      {
        kind: "ping.pub",
        url: "https://testnet.ping.pub/temporal",
        tx_page: "https://testnet.ping.pub/temporal/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "90u-4",
    explorers: [
      {
        kind: "Ping Pub",
        url: "https://explorer.nodestake.top/terp-testnet",
        tx_page: "https://explorer.nodestake.top/terp-testnet/tx/${txHash}"
      },
      {
        kind: "NODEXPLORER",
        url: "https://explorer.nodexcapital.com",
        tx_page: "https://explorer.nodexcapital.com/terp/tx/${txHash}",
        account_page: "https://explorer.nodexcapital.com/terp/account/{$accountAddress}"
      }
    ]
  },
  {
    chainId: "90u-2",
    explorers: [
      {
        kind: "Ping Pub",
        url: "https://explorer.nodestake.top/terp-testnet",
        tx_page: "https://explorer.nodestake.top/terp-testnet/tx/${txHash}"
      },
      {
        kind: "NODEXPLORER",
        url: "https://explorer.nodexcapital.com",
        tx_page: "https://explorer.nodexcapital.com/terp/tx/${txHash}",
        account_page: "https://explorer.nodexcapital.com/terp/account/{$accountAddress}"
      }
    ]
  },
  {
    chainId: "pisco-1",
    explorers: [
      {
        kind: "finder",
        url: "http://finder.terra.money/testnet/",
        tx_page: "https://finder.terra.money/testnet/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "titan_18889-1",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://titan-testnet-explorer-light.titanlab.io",
        tx_page: "https://titan-testnet-explorer-light.titanlab.io/Titan%20Testnet/tx/${txHash}",
        account_page: "https://titan-testnet-explorer-light.titanlab.io/Titan%20Testnet/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "tucana_712-1",
    explorers: [
      {
        kind: "Blockscout",
        url: "https://explorer.birdee-2.tucana.zone/",
        tx_page: "https://explorer.birdee-2.tucana.zone/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "ulas",
    explorers: [
      {
        kind: "ulas-scan",
        url: "https://testnet-explorer.ulas.network",
        tx_page: "https://testnet-explorer.ulas.network/ulas/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "FUND-TestNet-2",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer-testnet.unification.io/u",
        tx_page: "https://explorer-testnet.unification.io/u/tx/${txHash}",
        account_page: "https://explorer-testnet.unification.io/u/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "union-testnet-8",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer.testnet-8.union.build/union",
        tx_page: "https://explorer.testnet-8.union.build/union/tx/${txHash}",
        account_page: "https://explorer.testnet-8.union.build/union/account/${accountAddress}"
      },
      {
        kind: "explorers.guru",
        url: "https://testnet.union.explorers.guru",
        tx_page: "https://testnet.union.explorers.guru/transaction/${txHash}",
        account_page: "https://testnet.union.explorers.guru/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "uptick_7000-2",
    explorers: [
      {
        kind: "ping.pub",
        url: "https://explorer.testnet.uptick.network/uptick-network-testnet",
        tx_page: "https://explorer.testnet.uptick.network/uptick-network-testnet/tx/${txHash}"
      },
      {
        kind: "Nodes.Guru",
        url: "https://uptick.explorers.guru/",
        tx_page: "https://uptick.explorers.guru/transaction/${txHash}"
      }
    ]
  },
  {
    chainId: "vince_1903-1",
    explorers: [
      {
        kind: "blockscout",
        url: "https://scan-testnet.vincechain.com",
        tx_page: "https://scan-testnet.vincechain.com/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "buenavista-1",
    explorers: []
  },
  {
    chainId: "INVALID-ID-wavehashtestnet-testnet-1",
    explorers: [
      {
        kind: "atomscan",
        url: "https://atomscan.com/directory/testnet/wavehashtestnet",
        tx_page: "https://atomscan.com/directory/testnet/wavehashtestnet/transactions/${txHash}"
      }
    ]
  },
  {
    chainId: "xion-testnet-1",
    explorers: [
      {
        url: "https://explorer.burnt.com/xion-testnet-1",
        tx_page: "https://explorer.burnt.com/xion-testnet-1/tx/${txHash}",
        account_page: "https://explorer.burnt.com/xion-testnet-1/account/${accountAddress}"
      },
      {
        url: "https://testnet.xion.explorers.guru",
        tx_page: "https://testnet.xion.explorers.guru/transaction/${txHash}",
        account_page: "https://testnet.xion.explorers.guru/account/${accountAddress}"
      },
      {
        kind: "ITRocket",
        url: "https://testnet.itrocket.net/burnt",
        tx_page: "https://testnet.itrocket.net/burnt/tx/${txHash}",
        account_page: "https://testnet.itrocket.net/burnt/account/${accountAddress}"
      }
    ]
  },
  {
    chainId: "athens_7001-1",
    explorers: [
      {
        kind: "ZetaScan",
        url: "https://athens.explorer.zetachain.com/",
        tx_page: "https://athens.explorer.zetachain.com/cc/tx/${txHash}"
      },
      {
        kind: "BlockScout",
        url: "https://zetachain-athens-3.blockscout.com/",
        tx_page: "https://zetachain-athens-3.blockscout.com/tx/${txHash}"
      }
    ]
  },
  {
    chainId: "landlord-2",
    explorers: [
      {
        kind: "initia scan",
        url: "https://scan.testnet.initia.xyz/landlord-2",
        tx_page: "https://scan.testnet.initia.xyz/landlord-2/txs/${txHash}",
        account_page: "https://scan.testnet.initia.xyz/landlord-2/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "initiation-2",
    explorers: [
      {
        kind: "initia scan",
        url: "https://scan.testnet.initia.xyz/initiation-2",
        tx_page: "https://scan.testnet.initia.xyz/initiation-2/txs/${txHash}",
        account_page: "https://scan.testnet.initia.xyz/initiation-2/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "glados-2.1",
    explorers: [
      {
        kind: "initia scan",
        url: "https://scan.testnet.initia.xyz/glados-2.1",
        tx_page: "https://scan.testnet.initia.xyz/glados-2.1/txs/${txHash}",
        account_page: "https://scan.testnet.initia.xyz/glados-2.1/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "minievm-2",
    explorers: [
      {
        kind: "initia scan",
        url: "https://scan.testnet.initia.xyz/minievm-2",
        tx_page: "https://scan.testnet.initia.xyz/minievm-2/txs/${txHash}",
        account_page: "https://scan.testnet.initia.xyz/minievm-2/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "minimove-2",
    explorers: [
      {
        kind: "initia scan",
        url: "https://scan.testnet.initia.xyz/minimove-2",
        tx_page: "https://scan.testnet.initia.xyz/minimove-2/txs/${txHash}",
        account_page: "https://scan.testnet.initia.xyz/minimove-2/accounts/${accountAddress}"
      }
    ]
  },
  {
    chainId: "miniwasm-2",
    explorers: [
      {
        kind: "initia scan",
        url: "https://scan.testnet.initia.xyz/miniwasm-2",
        tx_page: "https://scan.testnet.initia.xyz/miniwasm-2/txs/${txHash}",
        account_page: "https://scan.testnet.initia.xyz/miniwasm-2/accounts/${accountAddress}"
      }
    ]
  }
], Ic = qu, js = Iu, Hu = [...Ic, ...js], Tu = Su, Ua = (e) => {
  const n = Hu.find((i) => i.chainId === e);
  if (n)
    return n;
}, dc = "https://go.skip.build", Nu = {
  getRpcEndpointForChain: async (e) => `${dc}/api/rpc/${e}`,
  getRestEndpointForChain: async (e) => `${dc}/api/rest/${e}`
}, Vu = `${dc}/api/widget/skip`, Sc = ee(), Hc = ee(), Tc = ee(), Nc = ee((e) => ({
  evm: e(Sc),
  cosmos: e(Hc),
  svm: e(Tc)
})), Ru = "2.16.4", Lu = () => `viem@${Ru}`;
let De = class xc extends Error {
  constructor(n, i = {}) {
    var c;
    super(), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ViemError"
    }), Object.defineProperty(this, "version", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: Lu()
    });
    const o = i.cause instanceof xc ? i.cause.details : (c = i.cause) != null && c.message ? i.cause.message : i.details, t = i.cause instanceof xc && i.cause.docsPath || i.docsPath;
    this.message = [
      n || "An error occurred.",
      "",
      ...i.metaMessages ? [...i.metaMessages, ""] : [],
      ...t ? [
        `Docs: ${i.docsBaseUrl ?? "https://viem.sh"}${t}${i.docsSlug ? `#${i.docsSlug}` : ""}`
      ] : [],
      ...o ? [`Details: ${o}`] : [],
      `Version: ${this.version}`
    ].join(`
`), i.cause && (this.cause = i.cause), this.details = o, this.docsPath = t, this.metaMessages = i.metaMessages, this.shortMessage = n;
  }
  walk(n) {
    return zs(this, n);
  }
};
function zs(e, n) {
  return n != null && n(e) ? e : e && typeof e == "object" && "cause" in e ? zs(e.cause, n) : n ? null : e;
}
class Ou extends De {
  constructor({ max: n, min: i, signed: o, size: t, value: c }) {
    super(`Number "${c}" is not in safe ${t ? `${t * 8}-bit ${o ? "signed" : "unsigned"} ` : ""}integer range ${n ? `(${i} to ${n})` : `(above ${i})`}`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "IntegerOutOfRangeError"
    });
  }
}
class Uu extends De {
  constructor({ givenSize: n, maxSize: i }) {
    super(`Size cannot exceed ${i} bytes. Given size: ${n} bytes.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeOverflowError"
    });
  }
}
class Wu extends De {
  constructor({ offset: n, position: i, size: o }) {
    super(`Slice ${i === "start" ? "starting" : "ending"} at offset "${n}" is out-of-bounds (size: ${o}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SliceOffsetOutOfBoundsError"
    });
  }
}
class qs extends De {
  constructor({ size: n, targetSize: i, type: o }) {
    super(`${o.charAt(0).toUpperCase()}${o.slice(1).toLowerCase()} size (${n}) exceeds padding size (${i}).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "SizeExceedsPaddingSizeError"
    });
  }
}
function Li(e, { dir: n, size: i = 32 } = {}) {
  return typeof e == "string" ? Gu(e, { dir: n, size: i }) : Ju(e, { dir: n, size: i });
}
function Gu(e, { dir: n, size: i = 32 } = {}) {
  if (i === null)
    return e;
  const o = e.replace("0x", "");
  if (o.length > i * 2)
    throw new qs({
      size: Math.ceil(o.length / 2),
      targetSize: i,
      type: "hex"
    });
  return `0x${o[n === "right" ? "padEnd" : "padStart"](i * 2, "0")}`;
}
function Ju(e, { dir: n, size: i = 32 } = {}) {
  if (i === null)
    return e;
  if (e.length > i)
    throw new qs({
      size: e.length,
      targetSize: i,
      type: "bytes"
    });
  const o = new Uint8Array(i);
  for (let t = 0; t < i; t++) {
    const c = n === "right";
    o[c ? t : i - t - 1] = e[c ? t : e.length - t - 1];
  }
  return o;
}
function Do(e, { strict: n = !0 } = {}) {
  return !e || typeof e != "string" ? !1 : n ? /^0x[0-9a-fA-F]*$/.test(e) : e.startsWith("0x");
}
function Mi(e) {
  return Do(e, { strict: !1 }) ? Math.ceil((e.length - 2) / 2) : e.length;
}
function _o(e, { dir: n = "left" } = {}) {
  let i = typeof e == "string" ? e.replace("0x", "") : e, o = 0;
  for (let t = 0; t < i.length - 1 && i[n === "left" ? t : i.length - t - 1].toString() === "0"; t++)
    o++;
  return i = n === "left" ? i.slice(o) : i.slice(0, i.length - o), typeof e == "string" ? (i.length === 1 && n === "right" && (i = `${i}0`), `0x${i.length % 2 === 1 ? `0${i}` : i}`) : i;
}
const Ku = /* @__PURE__ */ new TextEncoder();
function Is(e, n = {}) {
  return typeof e == "number" || typeof e == "bigint" ? Zu(e, n) : typeof e == "boolean" ? Xu(e, n) : Do(e) ? ri(e, n) : Ss(e, n);
}
function Xu(e, n = {}) {
  const i = new Uint8Array(1);
  return i[0] = Number(e), typeof n.size == "number" ? (Oi(i, { size: n.size }), Li(i, { size: n.size })) : i;
}
const Pn = {
  zero: 48,
  nine: 57,
  A: 65,
  F: 70,
  a: 97,
  f: 102
};
function Wa(e) {
  if (e >= Pn.zero && e <= Pn.nine)
    return e - Pn.zero;
  if (e >= Pn.A && e <= Pn.F)
    return e - (Pn.A - 10);
  if (e >= Pn.a && e <= Pn.f)
    return e - (Pn.a - 10);
}
function ri(e, n = {}) {
  let i = e;
  n.size && (Oi(i, { size: n.size }), i = Li(i, { dir: "right", size: n.size }));
  let o = i.slice(2);
  o.length % 2 && (o = `0${o}`);
  const t = o.length / 2, c = new Uint8Array(t);
  for (let a = 0, s = 0; a < t; a++) {
    const l = Wa(o.charCodeAt(s++)), m = Wa(o.charCodeAt(s++));
    if (l === void 0 || m === void 0)
      throw new De(`Invalid byte sequence ("${o[s - 2]}${o[s - 1]}" in "${o}").`);
    c[a] = l * 16 + m;
  }
  return c;
}
function Zu(e, n) {
  const i = Mn(e, n);
  return ri(i);
}
function Ss(e, n = {}) {
  const i = Ku.encode(e);
  return typeof n.size == "number" ? (Oi(i, { size: n.size }), Li(i, { dir: "right", size: n.size })) : i;
}
function Oi(e, { size: n }) {
  if (Mi(e) > n)
    throw new Uu({
      givenSize: Mi(e),
      maxSize: n
    });
}
function On(e, n = {}) {
  const { signed: i } = n;
  n.size && Oi(e, { size: n.size });
  const o = BigInt(e);
  if (!i)
    return o;
  const t = (e.length - 2) / 2, c = (1n << BigInt(t) * 8n - 1n) - 1n;
  return o <= c ? o : o - BigInt(`0x${"f".padStart(t * 2, "f")}`) - 1n;
}
function $o(e, n = {}) {
  return Number(On(e, n));
}
const Yu = /* @__PURE__ */ Array.from({ length: 256 }, (e, n) => n.toString(16).padStart(2, "0"));
function te(e, n = {}) {
  return typeof e == "number" || typeof e == "bigint" ? Mn(e, n) : typeof e == "string" ? $u(e, n) : typeof e == "boolean" ? Qu(e, n) : In(e, n);
}
function Qu(e, n = {}) {
  const i = `0x${Number(e)}`;
  return typeof n.size == "number" ? (Oi(i, { size: n.size }), Li(i, { size: n.size })) : i;
}
function In(e, n = {}) {
  let i = "";
  for (let t = 0; t < e.length; t++)
    i += Yu[e[t]];
  const o = `0x${i}`;
  return typeof n.size == "number" ? (Oi(o, { size: n.size }), Li(o, { dir: "right", size: n.size })) : o;
}
function Mn(e, n = {}) {
  const { signed: i, size: o } = n, t = BigInt(e);
  let c;
  o ? i ? c = (1n << BigInt(o) * 8n - 1n) - 1n : c = 2n ** (BigInt(o) * 8n) - 1n : typeof e == "number" && (c = BigInt(Number.MAX_SAFE_INTEGER));
  const a = typeof c == "bigint" && i ? -c - 1n : 0;
  if (c && t > c || t < a) {
    const l = typeof e == "bigint" ? "n" : "";
    throw new Ou({
      max: c ? `${c}${l}` : void 0,
      min: `${a}${l}`,
      signed: i,
      size: o,
      value: `${e}${l}`
    });
  }
  const s = `0x${(i && t < 0 ? (1n << BigInt(o * 8)) + BigInt(t) : t).toString(16)}`;
  return o ? Li(s, { size: o }) : s;
}
const _u = /* @__PURE__ */ new TextEncoder();
function $u(e, n = {}) {
  const i = _u.encode(e);
  return In(i, n);
}
function go(e) {
  return `0x${e.reduce((n, i) => n + i.replace("0x", ""), "")}`;
}
class Gn extends De {
  constructor({ address: n }) {
    super(`Address "${n}" is invalid.`, {
      metaMessages: [
        "- Address must be a hex value of 20 bytes (40 hex characters).",
        "- Address must match its checksum counterpart."
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidAddressError"
    });
  }
}
class Hs extends Map {
  constructor(n) {
    super(), Object.defineProperty(this, "maxSize", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.maxSize = n;
  }
  set(n, i) {
    return super.set(n, i), this.maxSize && this.size > this.maxSize && this.delete(this.keys().next().value), this;
  }
}
function Ga(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`positive integer expected, not ${e}`);
}
function eh(e) {
  return e instanceof Uint8Array || e != null && typeof e == "object" && e.constructor.name === "Uint8Array";
}
function Vc(e, ...n) {
  if (!eh(e))
    throw new Error("Uint8Array expected");
  if (n.length > 0 && !n.includes(e.length))
    throw new Error(`Uint8Array expected of length ${n}, not of length=${e.length}`);
}
function et(e, n = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (n && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function Ts(e, n) {
  Vc(e);
  const i = n.outputLen;
  if (e.length < i)
    throw new Error(`digestInto() expects output buffer of length at least ${i}`);
}
const Mo = /* @__PURE__ */ BigInt(2 ** 32 - 1), Ja = /* @__PURE__ */ BigInt(32);
function nh(e, n = !1) {
  return n ? { h: Number(e & Mo), l: Number(e >> Ja & Mo) } : { h: Number(e >> Ja & Mo) | 0, l: Number(e & Mo) | 0 };
}
function ih(e, n = !1) {
  let i = new Uint32Array(e.length), o = new Uint32Array(e.length);
  for (let t = 0; t < e.length; t++) {
    const { h: c, l: a } = nh(e[t], n);
    [i[t], o[t]] = [c, a];
  }
  return [i, o];
}
const oh = (e, n, i) => e << i | n >>> 32 - i, th = (e, n, i) => n << i | e >>> 32 - i, ch = (e, n, i) => n << i - 32 | e >>> 64 - i, ah = (e, n, i) => e << i - 32 | n >>> 64 - i;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const rh = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), Vt = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), gn = (e, n) => e << 32 - n | e >>> n, Ka = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, sh = (e) => e << 24 & 4278190080 | e << 8 & 16711680 | e >>> 8 & 65280 | e >>> 24 & 255;
function Xa(e) {
  for (let n = 0; n < e.length; n++)
    e[n] = sh(e[n]);
}
function lh(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new Uint8Array(new TextEncoder().encode(e));
}
function Rc(e) {
  return typeof e == "string" && (e = lh(e)), Vc(e), e;
}
class Ns {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
}
function Vs(e) {
  const n = (o) => e().update(Rc(o)).digest(), i = e();
  return n.outputLen = i.outputLen, n.blockLen = i.blockLen, n.create = () => e(), n;
}
const Rs = [], Ls = [], Os = [], mh = /* @__PURE__ */ BigInt(0), Qi = /* @__PURE__ */ BigInt(1), ph = /* @__PURE__ */ BigInt(2), uh = /* @__PURE__ */ BigInt(7), hh = /* @__PURE__ */ BigInt(256), dh = /* @__PURE__ */ BigInt(113);
for (let e = 0, n = Qi, i = 1, o = 0; e < 24; e++) {
  [i, o] = [o, (2 * i + 3 * o) % 5], Rs.push(2 * (5 * o + i)), Ls.push((e + 1) * (e + 2) / 2 % 64);
  let t = mh;
  for (let c = 0; c < 7; c++)
    n = (n << Qi ^ (n >> uh) * dh) % hh, n & ph && (t ^= Qi << (Qi << /* @__PURE__ */ BigInt(c)) - Qi);
  Os.push(t);
}
const [xh, Dh] = /* @__PURE__ */ ih(Os, !0), Za = (e, n, i) => i > 32 ? ch(e, n, i) : oh(e, n, i), Ya = (e, n, i) => i > 32 ? ah(e, n, i) : th(e, n, i);
function gh(e, n = 24) {
  const i = new Uint32Array(10);
  for (let o = 24 - n; o < 24; o++) {
    for (let a = 0; a < 10; a++)
      i[a] = e[a] ^ e[a + 10] ^ e[a + 20] ^ e[a + 30] ^ e[a + 40];
    for (let a = 0; a < 10; a += 2) {
      const s = (a + 8) % 10, l = (a + 2) % 10, m = i[l], h = i[l + 1], u = Za(m, h, 1) ^ i[s], D = Ya(m, h, 1) ^ i[s + 1];
      for (let b = 0; b < 50; b += 10)
        e[a + b] ^= u, e[a + b + 1] ^= D;
    }
    let t = e[2], c = e[3];
    for (let a = 0; a < 24; a++) {
      const s = Ls[a], l = Za(t, c, s), m = Ya(t, c, s), h = Rs[a];
      t = e[h], c = e[h + 1], e[h] = l, e[h + 1] = m;
    }
    for (let a = 0; a < 50; a += 10) {
      for (let s = 0; s < 10; s++)
        i[s] = e[a + s];
      for (let s = 0; s < 10; s++)
        e[a + s] ^= ~i[(s + 2) % 10] & i[(s + 4) % 10];
    }
    e[0] ^= xh[o], e[1] ^= Dh[o];
  }
  i.fill(0);
}
class Lc extends Ns {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(n, i, o, t = !1, c = 24) {
    if (super(), this.blockLen = n, this.suffix = i, this.outputLen = o, this.enableXOF = t, this.rounds = c, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, Ga(o), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = rh(this.state);
  }
  keccak() {
    Ka || Xa(this.state32), gh(this.state32, this.rounds), Ka || Xa(this.state32), this.posOut = 0, this.pos = 0;
  }
  update(n) {
    et(this);
    const { blockLen: i, state: o } = this;
    n = Rc(n);
    const t = n.length;
    for (let c = 0; c < t; ) {
      const a = Math.min(i - this.pos, t - c);
      for (let s = 0; s < a; s++)
        o[this.pos++] ^= n[c++];
      this.pos === i && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: n, suffix: i, pos: o, blockLen: t } = this;
    n[o] ^= i, i & 128 && o === t - 1 && this.keccak(), n[t - 1] ^= 128, this.keccak();
  }
  writeInto(n) {
    et(this, !1), Vc(n), this.finish();
    const i = this.state, { blockLen: o } = this;
    for (let t = 0, c = n.length; t < c; ) {
      this.posOut >= o && this.keccak();
      const a = Math.min(o - this.posOut, c - t);
      n.set(i.subarray(this.posOut, this.posOut + a), t), this.posOut += a, t += a;
    }
    return n;
  }
  xofInto(n) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(n);
  }
  xof(n) {
    return Ga(n), this.xofInto(new Uint8Array(n));
  }
  digestInto(n) {
    if (Ts(n, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(n), this.destroy(), n;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(n) {
    const { blockLen: i, suffix: o, outputLen: t, rounds: c, enableXOF: a } = this;
    return n || (n = new Lc(i, o, t, a, c)), n.state32.set(this.state32), n.pos = this.pos, n.posOut = this.posOut, n.finished = this.finished, n.rounds = c, n.suffix = o, n.outputLen = t, n.enableXOF = a, n.destroyed = this.destroyed, n;
  }
}
const fh = (e, n, i) => Vs(() => new Lc(n, e, i)), bh = /* @__PURE__ */ fh(1, 136, 256 / 8);
function Ah(e, n) {
  return bh(Do(e, { strict: !1 }) ? Is(e) : e);
}
const Rt = /* @__PURE__ */ new Hs(8192);
function Us(e, n) {
  if (Rt.has(`${e}.${n}`))
    return Rt.get(`${e}.${n}`);
  const i = e.substring(2).toLowerCase(), o = Ah(Ss(i)), t = i.split("");
  for (let a = 0; a < 40; a += 2)
    o[a >> 1] >> 4 >= 8 && t[a] && (t[a] = t[a].toUpperCase()), (o[a >> 1] & 15) >= 8 && t[a + 1] && (t[a + 1] = t[a + 1].toUpperCase());
  const c = `0x${t.join("")}`;
  return Rt.set(`${e}.${n}`, c), c;
}
function Ch(e, n) {
  if (!zn(e, { strict: !1 }))
    throw new Gn({ address: e });
  return Us(e, n);
}
const kh = /^0x[a-fA-F0-9]{40}$/, Lt = /* @__PURE__ */ new Hs(8192);
function zn(e, n) {
  const { strict: i = !0 } = n ?? {}, o = `${e}.${i}`;
  if (Lt.has(o))
    return Lt.get(o);
  const t = kh.test(e) ? e.toLowerCase() === e ? !0 : i ? Us(e) === e : !0 : !1;
  return Lt.set(o, t), t;
}
function vh(e, n, i, { strict: o } = {}) {
  return Do(e, { strict: !1 }) ? yh(e, n, i, {
    strict: o
  }) : wh(e, n, i, {
    strict: o
  });
}
function Ws(e, n, i) {
  if (Mi(e) !== i - n)
    throw new Wu({
      offset: i,
      position: "end",
      size: Mi(e)
    });
}
function wh(e, n, i, { strict: o } = {}) {
  const t = e.slice(n, i);
  return o && Ws(t, n, i), t;
}
function yh(e, n, i, { strict: o } = {}) {
  const t = `0x${e.replace("0x", "").slice(n * 2, i * 2)}`;
  return o && Ws(t, n, i), t;
}
function Eh(e) {
  return typeof e == "string" ? { address: e, type: "json-rpc" } : e;
}
class ft extends De {
  constructor({ chainId: n }) {
    super(typeof n == "number" ? `Chain ID "${n}" is invalid.` : "Chain ID is invalid."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidChainIdError"
    });
  }
}
const Ph = {
  ether: -9,
  wei: 9
};
function Fh(e, n) {
  let i = e.toString();
  const o = i.startsWith("-");
  o && (i = i.slice(1)), i = i.padStart(n, "0");
  let [t, c] = [
    i.slice(0, i.length - n),
    i.slice(i.length - n)
  ];
  return c = c.replace(/(0+)$/, ""), `${o ? "-" : ""}${t || "0"}${c ? `.${c}` : ""}`;
}
function Dc(e, n = "wei") {
  return Fh(e, Ph[n]);
}
class fo extends De {
  constructor({ cause: n, maxFeePerGas: i } = {}) {
    super(`The fee cap (\`maxFeePerGas\`${i ? ` = ${Dc(i)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
      cause: n
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "FeeCapTooHigh"
    });
  }
}
Object.defineProperty(fo, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class Oc extends De {
  constructor({ cause: n, maxPriorityFeePerGas: i, maxFeePerGas: o } = {}) {
    super([
      `The provided tip (\`maxPriorityFeePerGas\`${i ? ` = ${Dc(i)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${o ? ` = ${Dc(o)} gwei` : ""}).`
    ].join(`
`), {
      cause: n
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "TipAboveFeeCapError"
    });
  }
}
Object.defineProperty(Oc, "nodeMessage", {
  enumerable: !0,
  configurable: !0,
  writable: !0,
  value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
function Bh(e) {
  const n = Object.entries(e).map(([o, t]) => t === void 0 || t === !1 ? null : [o, t]).filter(Boolean), i = n.reduce((o, [t]) => Math.max(o, t.length), 0);
  return n.map(([o, t]) => `  ${`${o}:`.padEnd(i + 1)}  ${t}`).join(`
`);
}
class Mh extends De {
  constructor({ v: n }) {
    super(`Invalid \`v\` value "${n}". Expected 27 or 28.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidLegacyVError"
    });
  }
}
class jh extends De {
  constructor({ transaction: n }) {
    super("Cannot infer a transaction type from provided transaction.", {
      metaMessages: [
        "Provided Transaction:",
        "{",
        Bh(n),
        "}",
        "",
        "To infer the type, either provide:",
        "- a `type` to the Transaction, or",
        "- an EIP-1559 Transaction with `maxFeePerGas`, or",
        "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
        "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
        "- a Legacy Transaction with `gasPrice`"
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidSerializableTransactionError"
    });
  }
}
class zh extends De {
  constructor({ storageKey: n }) {
    super(`Size for storage key "${n}" is invalid. Expected 32 bytes. Got ${Math.floor((n.length - 2) / 2)} bytes.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidStorageKeySizeError"
    });
  }
}
function bt(e, n) {
  return ({ exclude: i, format: o }) => ({
    exclude: i,
    format: (t) => {
      const c = n(t);
      if (i)
        for (const a of i)
          delete c[a];
      return {
        ...c,
        ...o(t)
      };
    },
    type: e
  });
}
const qh = {
  legacy: "0x0",
  eip2930: "0x1",
  eip1559: "0x2",
  eip4844: "0x3"
};
function Ih(e) {
  const n = {};
  return typeof e.accessList < "u" && (n.accessList = e.accessList), typeof e.blobVersionedHashes < "u" && (n.blobVersionedHashes = e.blobVersionedHashes), typeof e.blobs < "u" && (typeof e.blobs[0] != "string" ? n.blobs = e.blobs.map((i) => In(i)) : n.blobs = e.blobs), typeof e.data < "u" && (n.data = e.data), typeof e.from < "u" && (n.from = e.from), typeof e.gas < "u" && (n.gas = Mn(e.gas)), typeof e.gasPrice < "u" && (n.gasPrice = Mn(e.gasPrice)), typeof e.maxFeePerBlobGas < "u" && (n.maxFeePerBlobGas = Mn(e.maxFeePerBlobGas)), typeof e.maxFeePerGas < "u" && (n.maxFeePerGas = Mn(e.maxFeePerGas)), typeof e.maxPriorityFeePerGas < "u" && (n.maxPriorityFeePerGas = Mn(e.maxPriorityFeePerGas)), typeof e.nonce < "u" && (n.nonce = Mn(e.nonce)), typeof e.to < "u" && (n.to = e.to), typeof e.type < "u" && (n.type = qh[e.type]), typeof e.value < "u" && (n.value = Mn(e.value)), n;
}
const Sh = /* @__PURE__ */ bt("transactionRequest", Ih), Gs = {
  "0x0": "legacy",
  "0x1": "eip2930",
  "0x2": "eip1559",
  "0x3": "eip4844"
};
function At(e) {
  const n = {
    ...e,
    blockHash: e.blockHash ? e.blockHash : null,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    chainId: e.chainId ? $o(e.chainId) : void 0,
    gas: e.gas ? BigInt(e.gas) : void 0,
    gasPrice: e.gasPrice ? BigInt(e.gasPrice) : void 0,
    maxFeePerBlobGas: e.maxFeePerBlobGas ? BigInt(e.maxFeePerBlobGas) : void 0,
    maxFeePerGas: e.maxFeePerGas ? BigInt(e.maxFeePerGas) : void 0,
    maxPriorityFeePerGas: e.maxPriorityFeePerGas ? BigInt(e.maxPriorityFeePerGas) : void 0,
    nonce: e.nonce ? $o(e.nonce) : void 0,
    to: e.to ? e.to : null,
    transactionIndex: e.transactionIndex ? Number(e.transactionIndex) : null,
    type: e.type ? Gs[e.type] : void 0,
    typeHex: e.type ? e.type : void 0,
    value: e.value ? BigInt(e.value) : void 0,
    v: e.v ? BigInt(e.v) : void 0
  };
  return n.yParity = (() => {
    if (e.yParity)
      return Number(e.yParity);
    if (typeof n.v == "bigint") {
      if (n.v === 0n || n.v === 27n)
        return 0;
      if (n.v === 1n || n.v === 28n)
        return 1;
      if (n.v >= 35n)
        return n.v % 2n === 0n ? 1 : 0;
    }
  })(), n.type === "legacy" && (delete n.accessList, delete n.maxFeePerBlobGas, delete n.maxFeePerGas, delete n.maxPriorityFeePerGas, delete n.yParity), n.type === "eip2930" && (delete n.maxFeePerBlobGas, delete n.maxFeePerGas, delete n.maxPriorityFeePerGas), n.type === "eip1559" && delete n.maxFeePerBlobGas, n;
}
const Js = /* @__PURE__ */ bt("transaction", At);
function Hh(e) {
  var i;
  const n = (i = e.transactions) == null ? void 0 : i.map((o) => typeof o == "string" ? o : At(o));
  return {
    ...e,
    baseFeePerGas: e.baseFeePerGas ? BigInt(e.baseFeePerGas) : null,
    blobGasUsed: e.blobGasUsed ? BigInt(e.blobGasUsed) : void 0,
    difficulty: e.difficulty ? BigInt(e.difficulty) : void 0,
    excessBlobGas: e.excessBlobGas ? BigInt(e.excessBlobGas) : void 0,
    gasLimit: e.gasLimit ? BigInt(e.gasLimit) : void 0,
    gasUsed: e.gasUsed ? BigInt(e.gasUsed) : void 0,
    hash: e.hash ? e.hash : null,
    logsBloom: e.logsBloom ? e.logsBloom : null,
    nonce: e.nonce ? e.nonce : null,
    number: e.number ? BigInt(e.number) : null,
    size: e.size ? BigInt(e.size) : void 0,
    timestamp: e.timestamp ? BigInt(e.timestamp) : void 0,
    transactions: n,
    totalDifficulty: e.totalDifficulty ? BigInt(e.totalDifficulty) : null
  };
}
const Ks = /* @__PURE__ */ bt("block", Hh);
function Xs(e) {
  const { kzg: n } = e, i = e.to ?? (typeof e.blobs[0] == "string" ? "hex" : "bytes"), o = typeof e.blobs[0] == "string" ? e.blobs.map((c) => ri(c)) : e.blobs, t = [];
  for (const c of o)
    t.push(Uint8Array.from(n.blobToKzgCommitment(c)));
  return i === "bytes" ? t : t.map((c) => In(c));
}
function Zs(e) {
  const { kzg: n } = e, i = e.to ?? (typeof e.blobs[0] == "string" ? "hex" : "bytes"), o = typeof e.blobs[0] == "string" ? e.blobs.map((a) => ri(a)) : e.blobs, t = typeof e.commitments[0] == "string" ? e.commitments.map((a) => ri(a)) : e.commitments, c = [];
  for (let a = 0; a < o.length; a++) {
    const s = o[a], l = t[a];
    c.push(Uint8Array.from(n.computeBlobKzgProof(s, l)));
  }
  return i === "bytes" ? c : c.map((a) => In(a));
}
function Th(e, n, i, o) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(n, i, o);
  const t = BigInt(32), c = BigInt(4294967295), a = Number(i >> t & c), s = Number(i & c), l = o ? 4 : 0, m = o ? 0 : 4;
  e.setUint32(n + l, a, o), e.setUint32(n + m, s, o);
}
const Nh = (e, n, i) => e & n ^ ~e & i, Vh = (e, n, i) => e & n ^ e & i ^ n & i;
class Rh extends Ns {
  constructor(n, i, o, t) {
    super(), this.blockLen = n, this.outputLen = i, this.padOffset = o, this.isLE = t, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(n), this.view = Vt(this.buffer);
  }
  update(n) {
    et(this);
    const { view: i, buffer: o, blockLen: t } = this;
    n = Rc(n);
    const c = n.length;
    for (let a = 0; a < c; ) {
      const s = Math.min(t - this.pos, c - a);
      if (s === t) {
        const l = Vt(n);
        for (; t <= c - a; a += t)
          this.process(l, a);
        continue;
      }
      o.set(n.subarray(a, a + s), this.pos), this.pos += s, a += s, this.pos === t && (this.process(i, 0), this.pos = 0);
    }
    return this.length += n.length, this.roundClean(), this;
  }
  digestInto(n) {
    et(this), Ts(n, this), this.finished = !0;
    const { buffer: i, view: o, blockLen: t, isLE: c } = this;
    let { pos: a } = this;
    i[a++] = 128, this.buffer.subarray(a).fill(0), this.padOffset > t - a && (this.process(o, 0), a = 0);
    for (let u = a; u < t; u++)
      i[u] = 0;
    Th(o, t - 8, BigInt(this.length * 8), c), this.process(o, 0);
    const s = Vt(n), l = this.outputLen;
    if (l % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const m = l / 4, h = this.get();
    if (m > h.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let u = 0; u < m; u++)
      s.setUint32(4 * u, h[u], c);
  }
  digest() {
    const { buffer: n, outputLen: i } = this;
    this.digestInto(n);
    const o = n.slice(0, i);
    return this.destroy(), o;
  }
  _cloneInto(n) {
    n || (n = new this.constructor()), n.set(...this.get());
    const { blockLen: i, buffer: o, length: t, finished: c, destroyed: a, pos: s } = this;
    return n.length = t, n.pos = s, n.finished = c, n.destroyed = a, t % i && n.buffer.set(o), n;
  }
}
const Lh = /* @__PURE__ */ new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Nn = /* @__PURE__ */ new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), Vn = /* @__PURE__ */ new Uint32Array(64);
class Oh extends Rh {
  constructor() {
    super(64, 32, 8, !1), this.A = Nn[0] | 0, this.B = Nn[1] | 0, this.C = Nn[2] | 0, this.D = Nn[3] | 0, this.E = Nn[4] | 0, this.F = Nn[5] | 0, this.G = Nn[6] | 0, this.H = Nn[7] | 0;
  }
  get() {
    const { A: n, B: i, C: o, D: t, E: c, F: a, G: s, H: l } = this;
    return [n, i, o, t, c, a, s, l];
  }
  // prettier-ignore
  set(n, i, o, t, c, a, s, l) {
    this.A = n | 0, this.B = i | 0, this.C = o | 0, this.D = t | 0, this.E = c | 0, this.F = a | 0, this.G = s | 0, this.H = l | 0;
  }
  process(n, i) {
    for (let u = 0; u < 16; u++, i += 4)
      Vn[u] = n.getUint32(i, !1);
    for (let u = 16; u < 64; u++) {
      const D = Vn[u - 15], b = Vn[u - 2], C = gn(D, 7) ^ gn(D, 18) ^ D >>> 3, k = gn(b, 17) ^ gn(b, 19) ^ b >>> 10;
      Vn[u] = k + Vn[u - 7] + C + Vn[u - 16] | 0;
    }
    let { A: o, B: t, C: c, D: a, E: s, F: l, G: m, H: h } = this;
    for (let u = 0; u < 64; u++) {
      const D = gn(s, 6) ^ gn(s, 11) ^ gn(s, 25), b = h + D + Nh(s, l, m) + Lh[u] + Vn[u] | 0, k = (gn(o, 2) ^ gn(o, 13) ^ gn(o, 22)) + Vh(o, t, c) | 0;
      h = m, m = l, l = s, s = a + b | 0, a = c, c = t, t = o, o = b + k | 0;
    }
    o = o + this.A | 0, t = t + this.B | 0, c = c + this.C | 0, a = a + this.D | 0, s = s + this.E | 0, l = l + this.F | 0, m = m + this.G | 0, h = h + this.H | 0, this.set(o, t, c, a, s, l, m, h);
  }
  roundClean() {
    Vn.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
const Uh = /* @__PURE__ */ Vs(() => new Oh());
function Wh(e, n) {
  return Uh(Do(e, { strict: !1 }) ? Is(e) : e);
}
function Gh(e) {
  const { commitment: n, version: i = 1 } = e, o = e.to ?? (typeof n == "string" ? "hex" : "bytes"), t = Wh(n);
  return t.set([i], 0), o === "bytes" ? t : In(t);
}
function Jh(e) {
  const { commitments: n, version: i } = e, o = e.to ?? (typeof n[0] == "string" ? "hex" : "bytes"), t = [];
  for (const c of n)
    t.push(Gh({
      commitment: c,
      to: o,
      version: i
    }));
  return t;
}
const Qa = 6, Ys = 32, Uc = 4096, Qs = Ys * Uc, _a = Qs * Qa - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * Uc * Qa, _s = 1;
class Kh extends De {
  constructor({ maxSize: n, size: i }) {
    super("Blob size is too large.", {
      metaMessages: [`Max: ${n} bytes`, `Given: ${i} bytes`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "BlobSizeTooLargeError"
    });
  }
}
class $s extends De {
  constructor() {
    super("Blob data must not be empty."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "EmptyBlobError"
    });
  }
}
class Xh extends De {
  constructor({ hash: n, size: i }) {
    super(`Versioned hash "${n}" size is invalid.`, {
      metaMessages: ["Expected: 32", `Received: ${i}`]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidVersionedHashSizeError"
    });
  }
}
class Zh extends De {
  constructor({ hash: n, version: i }) {
    super(`Versioned hash "${n}" version is invalid.`, {
      metaMessages: [
        `Expected: ${_s}`,
        `Received: ${i}`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "InvalidVersionedHashVersionError"
    });
  }
}
class $a extends De {
  constructor({ offset: n }) {
    super(`Offset \`${n}\` cannot be negative.`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "NegativeOffsetError"
    });
  }
}
class Yh extends De {
  constructor({ length: n, position: i }) {
    super(`Position \`${i}\` is out of bounds (\`0 < position < ${n}\`).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "PositionOutOfBoundsError"
    });
  }
}
class Qh extends De {
  constructor({ count: n, limit: i }) {
    super(`Recursive read limit of \`${i}\` exceeded (recursive read count: \`${n}\`).`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "RecursiveReadLimitExceededError"
    });
  }
}
const _h = {
  bytes: new Uint8Array(),
  dataView: new DataView(new ArrayBuffer(0)),
  position: 0,
  positionReadCount: /* @__PURE__ */ new Map(),
  recursiveReadCount: 0,
  recursiveReadLimit: Number.POSITIVE_INFINITY,
  assertReadLimit() {
    if (this.recursiveReadCount >= this.recursiveReadLimit)
      throw new Qh({
        count: this.recursiveReadCount + 1,
        limit: this.recursiveReadLimit
      });
  },
  assertPosition(e) {
    if (e < 0 || e > this.bytes.length - 1)
      throw new Yh({
        length: this.bytes.length,
        position: e
      });
  },
  decrementPosition(e) {
    if (e < 0)
      throw new $a({ offset: e });
    const n = this.position - e;
    this.assertPosition(n), this.position = n;
  },
  getReadCount(e) {
    return this.positionReadCount.get(e || this.position) || 0;
  },
  incrementPosition(e) {
    if (e < 0)
      throw new $a({ offset: e });
    const n = this.position + e;
    this.assertPosition(n), this.position = n;
  },
  inspectByte(e) {
    const n = e ?? this.position;
    return this.assertPosition(n), this.bytes[n];
  },
  inspectBytes(e, n) {
    const i = n ?? this.position;
    return this.assertPosition(i + e - 1), this.bytes.subarray(i, i + e);
  },
  inspectUint8(e) {
    const n = e ?? this.position;
    return this.assertPosition(n), this.bytes[n];
  },
  inspectUint16(e) {
    const n = e ?? this.position;
    return this.assertPosition(n + 1), this.dataView.getUint16(n);
  },
  inspectUint24(e) {
    const n = e ?? this.position;
    return this.assertPosition(n + 2), (this.dataView.getUint16(n) << 8) + this.dataView.getUint8(n + 2);
  },
  inspectUint32(e) {
    const n = e ?? this.position;
    return this.assertPosition(n + 3), this.dataView.getUint32(n);
  },
  pushByte(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushBytes(e) {
    this.assertPosition(this.position + e.length - 1), this.bytes.set(e, this.position), this.position += e.length;
  },
  pushUint8(e) {
    this.assertPosition(this.position), this.bytes[this.position] = e, this.position++;
  },
  pushUint16(e) {
    this.assertPosition(this.position + 1), this.dataView.setUint16(this.position, e), this.position += 2;
  },
  pushUint24(e) {
    this.assertPosition(this.position + 2), this.dataView.setUint16(this.position, e >> 8), this.dataView.setUint8(this.position + 2, e & 255), this.position += 3;
  },
  pushUint32(e) {
    this.assertPosition(this.position + 3), this.dataView.setUint32(this.position, e), this.position += 4;
  },
  readByte() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectByte();
    return this.position++, e;
  },
  readBytes(e, n) {
    this.assertReadLimit(), this._touch();
    const i = this.inspectBytes(e);
    return this.position += n ?? e, i;
  },
  readUint8() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint8();
    return this.position += 1, e;
  },
  readUint16() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint16();
    return this.position += 2, e;
  },
  readUint24() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint24();
    return this.position += 3, e;
  },
  readUint32() {
    this.assertReadLimit(), this._touch();
    const e = this.inspectUint32();
    return this.position += 4, e;
  },
  get remaining() {
    return this.bytes.length - this.position;
  },
  setPosition(e) {
    const n = this.position;
    return this.assertPosition(e), this.position = e, () => this.position = n;
  },
  _touch() {
    if (this.recursiveReadLimit === Number.POSITIVE_INFINITY)
      return;
    const e = this.getReadCount();
    this.positionReadCount.set(this.position, e + 1), e > 0 && this.recursiveReadCount++;
  }
};
function el(e, { recursiveReadLimit: n = 8192 } = {}) {
  const i = Object.create(_h);
  return i.bytes = e, i.dataView = new DataView(e.buffer, e.byteOffset, e.byteLength), i.positionReadCount = /* @__PURE__ */ new Map(), i.recursiveReadLimit = n, i;
}
function $h(e) {
  const n = e.to ?? (typeof e.data == "string" ? "hex" : "bytes"), i = typeof e.data == "string" ? ri(e.data) : e.data, o = Mi(i);
  if (!o)
    throw new $s();
  if (o > _a)
    throw new Kh({
      maxSize: _a,
      size: o
    });
  const t = [];
  let c = !0, a = 0;
  for (; c; ) {
    const s = el(new Uint8Array(Qs));
    let l = 0;
    for (; l < Uc; ) {
      const m = i.slice(a, a + (Ys - 1));
      if (s.pushByte(0), s.pushBytes(m), m.length < 31) {
        s.pushByte(128), c = !1;
        break;
      }
      l++, a += 31;
    }
    t.push(s);
  }
  return n === "bytes" ? t.map((s) => s.bytes) : t.map((s) => In(s.bytes));
}
function ed(e) {
  const { data: n, kzg: i, to: o } = e, t = e.blobs ?? $h({ data: n, to: o }), c = e.commitments ?? Xs({ blobs: t, kzg: i, to: o }), a = e.proofs ?? Zs({ blobs: t, commitments: c, kzg: i, to: o }), s = [];
  for (let l = 0; l < t.length; l++)
    s.push({
      blob: t[l],
      commitment: c[l],
      proof: a[l]
    });
  return s;
}
function nd(e) {
  if (e.type)
    return e.type;
  if (typeof e.blobs < "u" || typeof e.blobVersionedHashes < "u" || typeof e.maxFeePerBlobGas < "u" || typeof e.sidecars < "u")
    return "eip4844";
  if (typeof e.maxFeePerGas < "u" || typeof e.maxPriorityFeePerGas < "u")
    return "eip1559";
  if (typeof e.gasPrice < "u")
    return typeof e.accessList < "u" ? "eip2930" : "legacy";
  throw new jh({ transaction: e });
}
function id(e, { args: n, eventName: i } = {}) {
  return {
    ...e,
    blockHash: e.blockHash ? e.blockHash : null,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    logIndex: e.logIndex ? Number(e.logIndex) : null,
    transactionHash: e.transactionHash ? e.transactionHash : null,
    transactionIndex: e.transactionIndex ? Number(e.transactionIndex) : null,
    ...i ? { args: n, eventName: i } : {}
  };
}
const od = {
  "0x0": "reverted",
  "0x1": "success"
};
function td(e) {
  const n = {
    ...e,
    blockNumber: e.blockNumber ? BigInt(e.blockNumber) : null,
    contractAddress: e.contractAddress ? e.contractAddress : null,
    cumulativeGasUsed: e.cumulativeGasUsed ? BigInt(e.cumulativeGasUsed) : null,
    effectiveGasPrice: e.effectiveGasPrice ? BigInt(e.effectiveGasPrice) : null,
    gasUsed: e.gasUsed ? BigInt(e.gasUsed) : null,
    logs: e.logs ? e.logs.map((i) => id(i)) : null,
    to: e.to ? e.to : null,
    transactionIndex: e.transactionIndex ? $o(e.transactionIndex) : null,
    status: e.status ? od[e.status] : null,
    type: e.type ? Gs[e.type] || e.type : null
  };
  return e.blobGasPrice && (n.blobGasPrice = BigInt(e.blobGasPrice)), e.blobGasUsed && (n.blobGasUsed = BigInt(e.blobGasUsed)), n;
}
const cd = /* @__PURE__ */ bt("transactionReceipt", td);
function ve(e) {
  return {
    formatters: void 0,
    fees: void 0,
    serializers: void 0,
    ...e
  };
}
function si(e, n = "hex") {
  const i = nl(e), o = el(new Uint8Array(i.length));
  return i.encode(o), n === "hex" ? In(o.bytes) : o.bytes;
}
function nl(e) {
  return Array.isArray(e) ? ad(e.map((n) => nl(n))) : rd(e);
}
function ad(e) {
  const n = e.reduce((t, c) => t + c.length, 0), i = il(n);
  return {
    length: n <= 55 ? 1 + n : 1 + i + n,
    encode(t) {
      n <= 55 ? t.pushByte(192 + n) : (t.pushByte(247 + i), i === 1 ? t.pushUint8(n) : i === 2 ? t.pushUint16(n) : i === 3 ? t.pushUint24(n) : t.pushUint32(n));
      for (const { encode: c } of e)
        c(t);
    }
  };
}
function rd(e) {
  const n = typeof e == "string" ? ri(e) : e, i = il(n.length);
  return {
    length: n.length === 1 && n[0] < 128 ? 1 : n.length <= 55 ? 1 + n.length : 1 + i + n.length,
    encode(t) {
      n.length === 1 && n[0] < 128 ? t.pushBytes(n) : n.length <= 55 ? (t.pushByte(128 + n.length), t.pushBytes(n)) : (t.pushByte(183 + i), i === 1 ? t.pushUint8(n.length) : i === 2 ? t.pushUint16(n.length) : i === 3 ? t.pushUint24(n.length) : t.pushUint32(n.length), t.pushBytes(n));
    }
  };
}
function il(e) {
  if (e < 2 ** 8)
    return 1;
  if (e < 2 ** 16)
    return 2;
  if (e < 2 ** 24)
    return 3;
  if (e < 2 ** 32)
    return 4;
  throw new De("Length is too large.");
}
function sd(e) {
  const { blobVersionedHashes: n } = e;
  if (n) {
    if (n.length === 0)
      throw new $s();
    for (const i of n) {
      const o = Mi(i), t = $o(vh(i, 0, 1));
      if (o !== 32)
        throw new Xh({ hash: i, size: o });
      if (t !== _s)
        throw new Zh({
          hash: i,
          version: t
        });
    }
  }
  ol(e);
}
function ol(e) {
  const { chainId: n, maxPriorityFeePerGas: i, maxFeePerGas: o, to: t } = e;
  if (n <= 0)
    throw new ft({ chainId: n });
  if (t && !zn(t))
    throw new Gn({ address: t });
  if (o && o > 2n ** 256n - 1n)
    throw new fo({ maxFeePerGas: o });
  if (i && o && i > o)
    throw new Oc({ maxFeePerGas: o, maxPriorityFeePerGas: i });
}
function ld(e) {
  const { chainId: n, maxPriorityFeePerGas: i, gasPrice: o, maxFeePerGas: t, to: c } = e;
  if (n <= 0)
    throw new ft({ chainId: n });
  if (c && !zn(c))
    throw new Gn({ address: c });
  if (i || t)
    throw new De("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid EIP-2930 Transaction attribute.");
  if (o && o > 2n ** 256n - 1n)
    throw new fo({ maxFeePerGas: o });
}
function md(e) {
  const { chainId: n, maxPriorityFeePerGas: i, gasPrice: o, maxFeePerGas: t, to: c, accessList: a } = e;
  if (c && !zn(c))
    throw new Gn({ address: c });
  if (typeof n < "u" && n <= 0)
    throw new ft({ chainId: n });
  if (i || t)
    throw new De("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid Legacy Transaction attribute.");
  if (o && o > 2n ** 256n - 1n)
    throw new fo({ maxFeePerGas: o });
  if (a)
    throw new De("`accessList` is not a valid Legacy Transaction attribute.");
}
function Ct(e) {
  if (!e || e.length === 0)
    return [];
  const n = [];
  for (let i = 0; i < e.length; i++) {
    const { address: o, storageKeys: t } = e[i];
    for (let c = 0; c < t.length; c++)
      if (t[c].length - 2 !== 64)
        throw new zh({ storageKey: t[c] });
    if (!zn(o, { strict: !1 }))
      throw new Gn({ address: o });
    n.push([o, t]);
  }
  return n;
}
function tl(e, n) {
  const i = nd(e);
  return i === "eip1559" ? ud(e, n) : i === "eip2930" ? hd(e, n) : i === "eip4844" ? pd(e, n) : dd(e, n);
}
function pd(e, n) {
  const { chainId: i, gas: o, nonce: t, to: c, value: a, maxFeePerBlobGas: s, maxFeePerGas: l, maxPriorityFeePerGas: m, accessList: h, data: u } = e;
  sd(e);
  let D = e.blobVersionedHashes, b = e.sidecars;
  if (e.blobs && (typeof D > "u" || typeof b > "u")) {
    const g = typeof e.blobs[0] == "string" ? e.blobs : e.blobs.map((P) => In(P)), M = e.kzg, H = Xs({
      blobs: g,
      kzg: M
    });
    if (typeof D > "u" && (D = Jh({
      commitments: H
    })), typeof b > "u") {
      const P = Zs({ blobs: g, commitments: H, kzg: M });
      b = ed({ blobs: g, commitments: H, proofs: P });
    }
  }
  const C = Ct(h), k = [
    te(i),
    t ? te(t) : "0x",
    m ? te(m) : "0x",
    l ? te(l) : "0x",
    o ? te(o) : "0x",
    c ?? "0x",
    a ? te(a) : "0x",
    u ?? "0x",
    C,
    s ? te(s) : "0x",
    D ?? [],
    ...kt(e, n)
  ], q = [], E = [], x = [];
  if (b)
    for (let g = 0; g < b.length; g++) {
      const { blob: M, commitment: H, proof: P } = b[g];
      q.push(M), E.push(H), x.push(P);
    }
  return go([
    "0x03",
    // If sidecars are enabled, envelope turns into a "wrapper":
    si(b ? [k, q, E, x] : k)
  ]);
}
function ud(e, n) {
  const { chainId: i, gas: o, nonce: t, to: c, value: a, maxFeePerGas: s, maxPriorityFeePerGas: l, accessList: m, data: h } = e;
  ol(e);
  const u = Ct(m), D = [
    te(i),
    t ? te(t) : "0x",
    l ? te(l) : "0x",
    s ? te(s) : "0x",
    o ? te(o) : "0x",
    c ?? "0x",
    a ? te(a) : "0x",
    h ?? "0x",
    u,
    ...kt(e, n)
  ];
  return go([
    "0x02",
    si(D)
  ]);
}
function hd(e, n) {
  const { chainId: i, gas: o, data: t, nonce: c, to: a, value: s, accessList: l, gasPrice: m } = e;
  ld(e);
  const h = Ct(l), u = [
    te(i),
    c ? te(c) : "0x",
    m ? te(m) : "0x",
    o ? te(o) : "0x",
    a ?? "0x",
    s ? te(s) : "0x",
    t ?? "0x",
    h,
    ...kt(e, n)
  ];
  return go([
    "0x01",
    si(u)
  ]);
}
function dd(e, n) {
  const { chainId: i = 0, gas: o, data: t, nonce: c, to: a, value: s, gasPrice: l } = e;
  md(e);
  let m = [
    c ? te(c) : "0x",
    l ? te(l) : "0x",
    o ? te(o) : "0x",
    a ?? "0x",
    s ? te(s) : "0x",
    t ?? "0x"
  ];
  if (n) {
    const h = (() => {
      if (n.v >= 35n)
        return (n.v - 35n) / 2n > 0 ? n.v : 27n + (n.v === 35n ? 0n : 1n);
      if (i > 0)
        return BigInt(i * 2) + BigInt(35n + n.v - 27n);
      const u = 27n + (n.v === 27n ? 0n : 1n);
      if (n.v !== u)
        throw new Mh({ v: n.v });
      return u;
    })();
    m = [
      ...m,
      te(h),
      n.r,
      n.s
    ];
  } else i > 0 && (m = [
    ...m,
    te(i),
    "0x",
    "0x"
  ]);
  return si(m);
}
function kt(e, n) {
  const i = n ?? e, { v: o, yParity: t } = i;
  if (typeof i.r > "u")
    return [];
  if (typeof i.s > "u")
    return [];
  if (typeof o > "u" && typeof t > "u")
    return [];
  const c = _o(i.r), a = _o(i.s);
  return [typeof t == "number" ? t ? te(1) : "0x" : o === 0n ? "0x" : o === 1n ? te(1) : o === 27n ? "0x" : te(1), c === "0x00" ? "0x" : c, a === "0x00" ? "0x" : a];
}
const xd = "2.11.5", Dd = () => `@wagmi/core@${xd}`;
var cl = function(e, n, i, o) {
  if (i === "a" && !o) throw new TypeError("Private accessor was defined without a getter");
  if (typeof n == "function" ? e !== n || !o : !n.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return i === "m" ? o : i === "a" ? o.call(e) : o ? o.value : n.get(e);
}, nt, al;
class ji extends Error {
  get docsBaseUrl() {
    return "https://wagmi.sh/core";
  }
  get version() {
    return Dd();
  }
  constructor(n, i = {}) {
    var c;
    super(), nt.add(this), Object.defineProperty(this, "details", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "docsPath", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "metaMessages", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "shortMessage", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "WagmiCoreError"
    });
    const o = i.cause instanceof ji ? i.cause.details : (c = i.cause) != null && c.message ? i.cause.message : i.details, t = i.cause instanceof ji && i.cause.docsPath || i.docsPath;
    this.message = [
      n || "An error occurred.",
      "",
      ...i.metaMessages ? [...i.metaMessages, ""] : [],
      ...t ? [
        `Docs: ${this.docsBaseUrl}${t}.html${i.docsSlug ? `#${i.docsSlug}` : ""}`
      ] : [],
      ...o ? [`Details: ${o}`] : [],
      `Version: ${this.version}`
    ].join(`
`), i.cause && (this.cause = i.cause), this.details = o, this.docsPath = t, this.metaMessages = i.metaMessages, this.shortMessage = n;
  }
  walk(n) {
    return cl(this, nt, "m", al).call(this, this, n);
  }
}
nt = /* @__PURE__ */ new WeakSet(), al = function e(n, i) {
  return i != null && i(n) ? n : n.cause ? cl(this, nt, "m", e).call(this, n.cause, i) : n;
};
class gd extends ji {
  constructor() {
    super("Connector not connected."), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorNotConnectedError"
    });
  }
}
class fd extends ji {
  constructor({ address: n, connector: i }) {
    super(`Account "${n}" not found for connector "${i.name}".`), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorAccountNotFoundError"
    });
  }
}
class bd extends ji {
  constructor({ connectionChainId: n, connectorChainId: i }) {
    super(`The current chain of the connector (id: ${i}) does not match the connection's chain (id: ${n}).`, {
      metaMessages: [
        `Current Chain ID:  ${i}`,
        `Expected Chain ID: ${n}`
      ]
    }), Object.defineProperty(this, "name", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: "ConnectorChainMismatchError"
    });
  }
}
async function Ad(e, n = {}) {
  let i;
  if (n.connector) {
    const { connector: m } = n, [h, u] = await Promise.all([
      m.getAccounts(),
      m.getChainId()
    ]);
    i = {
      accounts: h,
      chainId: u,
      connector: m
    };
  } else
    i = e.state.connections.get(e.state.current);
  if (!i)
    throw new gd();
  const o = n.chainId ?? i.chainId, t = await i.connector.getChainId();
  if (t !== i.chainId)
    throw new bd({
      connectionChainId: i.chainId,
      connectorChainId: t
    });
  const c = i.connector;
  if (c.getClient)
    return c.getClient({ chainId: o });
  const a = Eh(n.account ?? i.accounts[0]);
  a.address = Ch(a.address);
  const s = e.chains.find((m) => m.id === o), l = await i.connector.getProvider({ chainId: o });
  if (n.account && !i.accounts.some((m) => m.toLowerCase() === a.address.toLowerCase()))
    throw new fd({
      address: a.address,
      connector: c
    });
  return ep({
    account: a,
    chain: s,
    name: "Connector Client",
    transport: (m) => np(l)({ ...m, retryCount: 0 })
  });
}
async function Cd(e, n = {}) {
  const i = await Ad(e, n);
  return i.extend(wa), i.extend(wa);
}
const kd = {
  gasPriceOracle: { address: "0x420000000000000000000000000000000000000F" },
  l1Block: { address: "0x4200000000000000000000000000000000000015" },
  l2CrossDomainMessenger: {
    address: "0x4200000000000000000000000000000000000007"
  },
  l2Erc721Bridge: { address: "0x4200000000000000000000000000000000000014" },
  l2StandardBridge: { address: "0x4200000000000000000000000000000000000010" },
  l2ToL1MessagePasser: {
    address: "0x4200000000000000000000000000000000000016"
  }
}, vd = {
  block: /* @__PURE__ */ Ks({
    format(e) {
      var i;
      return {
        transactions: (i = e.transactions) == null ? void 0 : i.map((o) => {
          if (typeof o == "string")
            return o;
          const t = At(o);
          return t.typeHex === "0x7e" && (t.isSystemTx = o.isSystemTx, t.mint = o.mint ? On(o.mint) : void 0, t.sourceHash = o.sourceHash, t.type = "deposit"), t;
        }),
        stateRoot: e.stateRoot
      };
    }
  }),
  transaction: /* @__PURE__ */ Js({
    format(e) {
      const n = {};
      return e.type === "0x7e" && (n.isSystemTx = e.isSystemTx, n.mint = e.mint ? On(e.mint) : void 0, n.sourceHash = e.sourceHash, n.type = "deposit"), n;
    }
  }),
  transactionReceipt: /* @__PURE__ */ cd({
    format(e) {
      return {
        l1GasPrice: e.l1GasPrice ? On(e.l1GasPrice) : null,
        l1GasUsed: e.l1GasUsed ? On(e.l1GasUsed) : null,
        l1Fee: e.l1Fee ? On(e.l1Fee) : null,
        l1FeeScalar: e.l1FeeScalar ? Number(e.l1FeeScalar) : null
      };
    }
  })
};
function wd(e, n) {
  return Pd(e) ? Ed(e) : tl(e, n);
}
const yd = {
  transaction: wd
};
function Ed(e) {
  Fd(e);
  const { sourceHash: n, data: i, from: o, gas: t, isSystemTx: c, mint: a, to: s, value: l } = e, m = [
    n,
    o,
    s ?? "0x",
    a ? te(a) : "0x",
    l ? te(l) : "0x",
    t ? te(t) : "0x",
    c ? "0x1" : "0x",
    i ?? "0x"
  ];
  return go([
    "0x7e",
    si(m)
  ]);
}
function Pd(e) {
  return e.type === "deposit" || typeof e.sourceHash < "u";
}
function Fd(e) {
  const { from: n, to: i } = e;
  if (n && !zn(n))
    throw new Gn({ address: n });
  if (i && !zn(i))
    throw new Gn({ address: i });
}
const Jn = {
  contracts: kd,
  formatters: vd,
  serializers: yd
}, er = /* @__PURE__ */ ve({
  id: 42161,
  name: "Arbitrum One",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://arb1.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arbiscan",
      url: "https://arbiscan.io",
      apiUrl: "https://api.arbiscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7654707
    }
  }
}), nr = /* @__PURE__ */ ve({
  id: 421614,
  name: "Arbitrum Sepolia",
  nativeCurrency: {
    name: "Arbitrum Sepolia Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia-rollup.arbitrum.io/rpc"]
    }
  },
  blockExplorers: {
    default: {
      name: "Arbiscan",
      url: "https://sepolia.arbiscan.io",
      apiUrl: "https://api-sepolia.arbiscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 81930
    }
  },
  testnet: !0
}), ir = /* @__PURE__ */ ve({
  id: 43114,
  name: "Avalanche",
  nativeCurrency: {
    decimals: 18,
    name: "Avalanche",
    symbol: "AVAX"
  },
  rpcUrls: {
    default: { http: ["https://api.avax.network/ext/bc/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "SnowTrace",
      url: "https://snowtrace.io",
      apiUrl: "https://api.snowtrace.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 11907934
    }
  }
}), or = /* @__PURE__ */ ve({
  id: 43113,
  name: "Avalanche Fuji",
  nativeCurrency: {
    decimals: 18,
    name: "Avalanche Fuji",
    symbol: "AVAX"
  },
  rpcUrls: {
    default: { http: ["https://api.avax-test.network/ext/bc/C/rpc"] }
  },
  blockExplorers: {
    default: {
      name: "SnowTrace",
      url: "https://testnet.snowtrace.io",
      apiUrl: "https://api-testnet.snowtrace.io"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 7096959
    }
  },
  testnet: !0
}), jo = 1, tr = /* @__PURE__ */ ve({
  ...Jn,
  id: 8453,
  name: "Base",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.base.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Basescan",
      url: "https://basescan.org",
      apiUrl: "https://api.basescan.org/api"
    }
  },
  contracts: {
    ...Jn.contracts,
    l2OutputOracle: {
      [jo]: {
        address: "0x56315b90c40730925ec5485cf004d835058518A0"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 5022
    },
    portal: {
      [jo]: {
        address: "0x49048044D57e1C92A77f79988d21Fa8fAF74E97e",
        blockCreated: 17482143
      }
    },
    l1StandardBridge: {
      [jo]: {
        address: "0x3154Cf16ccdb4C6d922629664174b904d80F2C35",
        blockCreated: 17482143
      }
    }
  },
  sourceId: jo
}), zo = 11155111, cr = /* @__PURE__ */ ve({
  ...Jn,
  id: 84532,
  network: "base-sepolia",
  name: "Base Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.base.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Basescan",
      url: "https://sepolia.basescan.org",
      apiUrl: "https://api-sepolia.basescan.org/api"
    }
  },
  contracts: {
    ...Jn.contracts,
    l2OutputOracle: {
      [zo]: {
        address: "0x84457ca9D0163FbC4bbfe4Dfbb20ba46e48DF254"
      }
    },
    portal: {
      [zo]: {
        address: "0x49f53e41452c74589e85ca1677426ba426459e85",
        blockCreated: 4446677
      }
    },
    l1StandardBridge: {
      [zo]: {
        address: "0xfd0Bf71F60660E2f608ed56e1659C450eB113120",
        blockCreated: 4446677
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1059647
    }
  },
  testnet: !0,
  sourceId: zo
}), Bd = 1, ar = /* @__PURE__ */ ve({
  id: 81457,
  name: "Blast",
  nativeCurrency: {
    decimals: 18,
    name: "Ether",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://rpc.blast.io"] }
  },
  blockExplorers: {
    default: {
      name: "Blastscan",
      url: "https://blastscan.io",
      apiUrl: "https://api.blastscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 212929
    }
  },
  sourceId: Bd
}), Md = 11155111, rr = /* @__PURE__ */ ve({
  id: 168587773,
  name: "Blast Sepolia",
  nativeCurrency: {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://sepolia.blast.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blastscan",
      url: "https://sepolia.blastscan.io",
      apiUrl: "https://api-sepolia.blastscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 756690
    }
  },
  testnet: !0,
  sourceId: Md
}), sr = /* @__PURE__ */ ve({
  id: 56,
  name: "BNB Smart Chain",
  nativeCurrency: {
    decimals: 18,
    name: "BNB",
    symbol: "BNB"
  },
  rpcUrls: {
    default: { http: ["https://rpc.ankr.com/bsc"] }
  },
  blockExplorers: {
    default: {
      name: "BscScan",
      url: "https://bscscan.com",
      apiUrl: "https://api.bscscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 15921452
    }
  }
}), jd = {
  /*
     * Estimates the fees per gas for a transaction.
  
     * If the transaction is to be paid in a token (feeCurrency is present) then the fees
     * are estimated in the value of the token. Otherwise falls back to the default
     * estimation by returning null.
     *
     * @param params fee estimation function parameters
     */
  estimateFeesPerGas: async (e) => {
    var o;
    if (!((o = e.request) != null && o.feeCurrency))
      return null;
    const [n, i] = await Promise.all([
      zd(e.client, e.request.feeCurrency),
      qd(e.client, e.request.feeCurrency)
    ]);
    return {
      maxFeePerGas: n,
      maxPriorityFeePerGas: i
    };
  }
};
async function zd(e, n) {
  const i = await e.request({
    method: "eth_gasPrice",
    params: [n]
  });
  return BigInt(i);
}
async function qd(e, n) {
  const i = await e.request({
    method: "eth_maxPriorityFeePerGas",
    params: [n]
  });
  return BigInt(i);
}
function rl(e) {
  return e === 0 || e === 0n || e === void 0 || e === null || e === "0" || e === "" || typeof e == "string" && (_o(e).toLowerCase() === "0x" || _o(e).toLowerCase() === "0x00");
}
function co(e) {
  return !rl(e);
}
function Id(e) {
  return typeof e.maxFeePerGas < "u" && typeof e.maxPriorityFeePerGas < "u";
}
function sl(e) {
  return e.type === "cip64" ? !0 : Id(e) && co(e.feeCurrency);
}
const Sd = {
  block: /* @__PURE__ */ Ks({
    exclude: ["difficulty", "gasLimit", "mixHash", "nonce", "uncles"],
    format(e) {
      var i;
      const n = (i = e.transactions) == null ? void 0 : i.map((o) => typeof o == "string" ? o : {
        ...At(o),
        feeCurrency: o.feeCurrency,
        ...o.type !== "0x7b" ? {
          gatewayFee: o.gatewayFee ? On(o.gatewayFee) : null,
          gatewayFeeRecipient: o.gatewayFeeRecipient || null
        } : {}
      });
      return {
        randomness: e.randomness,
        transactions: n
      };
    }
  }),
  transaction: /* @__PURE__ */ Js({
    format(e) {
      const n = { feeCurrency: e.feeCurrency };
      return e.type === "0x7b" ? n.type = "cip64" : (e.type === "0x7c" && (n.type = "cip42"), n.gatewayFee = e.gatewayFee ? On(e.gatewayFee) : null, n.gatewayFeeRecipient = e.gatewayFeeRecipient), n;
    }
  }),
  transactionRequest: /* @__PURE__ */ Sh({
    format(e) {
      const n = {
        feeCurrency: e.feeCurrency
      };
      return sl(e) && (n.type = "0x7b"), n;
    }
  })
};
function Hd(e, n) {
  return sl(e) ? Nd(e, n) : tl(e, n);
}
const Td = {
  transaction: Hd
};
function Nd(e, n) {
  Rd(e);
  const { chainId: i, gas: o, nonce: t, to: c, value: a, maxFeePerGas: s, maxPriorityFeePerGas: l, accessList: m, feeCurrency: h, data: u } = e, D = [
    te(i),
    t ? te(t) : "0x",
    l ? te(l) : "0x",
    s ? te(s) : "0x",
    o ? te(o) : "0x",
    c ?? "0x",
    a ? te(a) : "0x",
    u ?? "0x",
    Ct(m),
    h,
    ...kt(e, n)
  ];
  return go([
    "0x7b",
    si(D)
  ]);
}
const Vd = 2n ** 256n - 1n;
function Rd(e) {
  const { chainId: n, maxPriorityFeePerGas: i, gasPrice: o, maxFeePerGas: t, to: c, feeCurrency: a } = e;
  if (n <= 0)
    throw new ft({ chainId: n });
  if (c && !zn(c))
    throw new Gn({ address: c });
  if (o)
    throw new De("`gasPrice` is not a valid CIP-64 Transaction attribute.");
  if (co(t) && t > Vd)
    throw new fo({ maxFeePerGas: t });
  if (co(i) && co(t) && i > t)
    throw new Oc({ maxFeePerGas: t, maxPriorityFeePerGas: i });
  if (co(a) && !zn(a))
    throw new De("`feeCurrency` MUST be a token address for CIP-64 transactions.");
  if (rl(a))
    throw new De("`feeCurrency` must be provided for CIP-64 transactions.");
}
const Ld = {
  formatters: Sd,
  serializers: Td,
  fees: jd
}, lr = /* @__PURE__ */ ve({
  ...Ld,
  id: 42220,
  name: "Celo",
  nativeCurrency: {
    decimals: 18,
    name: "CELO",
    symbol: "CELO"
  },
  rpcUrls: {
    default: { http: ["https://forno.celo.org"] }
  },
  blockExplorers: {
    default: {
      name: "Celo Explorer",
      url: "https://celoscan.io",
      apiUrl: "https://api.celoscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 13112599
    }
  },
  testnet: !1
}), mr = /* @__PURE__ */ ve({
  id: 250,
  name: "Fantom",
  nativeCurrency: {
    decimals: 18,
    name: "Fantom",
    symbol: "FTM"
  },
  rpcUrls: {
    default: { http: ["https://rpc.ankr.com/fantom"] }
  },
  blockExplorers: {
    default: {
      name: "FTMScan",
      url: "https://ftmscan.com",
      apiUrl: "https://api.ftmscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 33001987
    }
  }
}), pr = /* @__PURE__ */ ve({
  id: 314,
  name: "Filecoin Mainnet",
  nativeCurrency: {
    decimals: 18,
    name: "filecoin",
    symbol: "FIL"
  },
  rpcUrls: {
    default: { http: ["https://api.node.glif.io/rpc/v1"] }
  },
  blockExplorers: {
    default: {
      name: "Filfox",
      url: "https://filfox.info/en"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 3328594
    }
  }
}), ur = /* @__PURE__ */ ve({
  id: 2222,
  name: "Kava EVM",
  network: "kava-mainnet",
  nativeCurrency: {
    name: "Kava",
    symbol: "KAVA",
    decimals: 18
  },
  rpcUrls: {
    default: { http: ["https://evm.kava.io"] }
  },
  blockExplorers: {
    default: {
      name: "Kava EVM Explorer",
      url: "https://kavascan.com",
      apiUrl: "https://kavascan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 3661165
    }
  },
  testnet: !1
}), hr = /* @__PURE__ */ ve({
  id: 59144,
  name: "Linea Mainnet",
  nativeCurrency: { name: "Linea Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.linea.build"],
      webSocket: ["wss://rpc.linea.build"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://lineascan.build",
      apiUrl: "https://api.lineascan.build/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 42
    }
  },
  testnet: !1
}), dr = /* @__PURE__ */ ve({
  id: 1,
  name: "Ethereum",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://cloudflare-eth.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://etherscan.io",
      apiUrl: "https://api.etherscan.io/api"
    }
  },
  contracts: {
    ensRegistry: {
      address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    ensUniversalResolver: {
      address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
      blockCreated: 19258213
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 14353601
    }
  }
}), xr = /* @__PURE__ */ ve({
  id: 169,
  name: "Manta Pacific Mainnet",
  network: "manta",
  nativeCurrency: {
    decimals: 18,
    name: "ETH",
    symbol: "ETH"
  },
  rpcUrls: {
    default: { http: ["https://pacific-rpc.manta.network/http"] }
  },
  blockExplorers: {
    default: {
      name: "Manta Explorer",
      url: "https://pacific-explorer.manta.network",
      apiUrl: "https://pacific-explorer.manta.network/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 332890
    }
  }
}), Dr = /* @__PURE__ */ ve({
  id: 1284,
  name: "Moonbeam",
  nativeCurrency: {
    decimals: 18,
    name: "GLMR",
    symbol: "GLMR"
  },
  rpcUrls: {
    default: {
      http: ["https://moonbeam.public.blastapi.io"],
      webSocket: ["wss://moonbeam.public.blastapi.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Moonscan",
      url: "https://moonscan.io",
      apiUrl: "https://api-moonbeam.moonscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11",
      blockCreated: 609002
    }
  },
  testnet: !1
}), _i = 1, gr = /* @__PURE__ */ ve({
  ...Jn,
  id: 10,
  name: "OP Mainnet",
  nativeCurrency: { name: "Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://mainnet.optimism.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Optimism Explorer",
      url: "https://optimistic.etherscan.io",
      apiUrl: "https://api-optimistic.etherscan.io/api"
    }
  },
  contracts: {
    ...Jn.contracts,
    disputeGameFactory: {
      [_i]: {
        address: "0xe5965Ab5962eDc7477C8520243A95517CD252fA9"
      }
    },
    l2OutputOracle: {
      [_i]: {
        address: "0xdfe97868233d1aa22e815a266982f2cf17685a27"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 4286263
    },
    portal: {
      [_i]: {
        address: "0xbEb5Fc579115071764c7423A4f12eDde41f106Ed"
      }
    },
    l1StandardBridge: {
      [_i]: {
        address: "0x99C9fc46f92E8a1c0deC1b1747d010903E884bE1"
      }
    }
  },
  sourceId: _i
}), $i = 11155111, fr = /* @__PURE__ */ ve({
  ...Jn,
  id: 11155420,
  name: "OP Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://sepolia.optimism.io"]
    }
  },
  blockExplorers: {
    default: {
      name: "Blockscout",
      url: "https://optimism-sepolia.blockscout.com",
      apiUrl: "https://optimism-sepolia.blockscout.com/api"
    }
  },
  contracts: {
    ...Jn.contracts,
    disputeGameFactory: {
      [$i]: {
        address: "0x05F9613aDB30026FFd634f38e5C4dFd30a197Fa1"
      }
    },
    l2OutputOracle: {
      [$i]: {
        address: "0x90E9c4f8a994a250F6aEfd61CAFb4F2e895D458F"
      }
    },
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 1620204
    },
    portal: {
      [$i]: {
        address: "0x16Fc5058F25648194471939df75CF27A2fdC48BC"
      }
    },
    l1StandardBridge: {
      [$i]: {
        address: "0xFBb0621E0B23b5478B630BD55a5f21f67730B0F1"
      }
    }
  },
  testnet: !0,
  sourceId: $i
}), br = /* @__PURE__ */ ve({
  id: 137,
  name: "Polygon",
  nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://polygon-rpc.com"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://polygonscan.com",
      apiUrl: "https://api.polygonscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 25770160
    }
  }
}), Ar = /* @__PURE__ */ ve({
  id: 80001,
  name: "Polygon Mumbai",
  nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.ankr.com/polygon_mumbai"]
    }
  },
  blockExplorers: {
    default: {
      name: "PolygonScan",
      url: "https://mumbai.polygonscan.com",
      apiUrl: "https://api-testnet.polygonscan.com/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 25770160
    }
  },
  testnet: !0
}), it = /* @__PURE__ */ ve({
  id: 1329,
  name: "Sei Network",
  nativeCurrency: { name: "Sei", symbol: "SEI", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://evm-rpc.sei-apis.com/"],
      webSocket: ["wss://evm-ws.sei-apis.com/"]
    }
  },
  blockExplorers: {
    default: {
      name: "Seitrace",
      url: "https://seitrace.com",
      apiUrl: "https://seitrace.com/pacific-1/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xcA11bde05977b3631167028862bE2a173976CA11"
    }
  }
}), Cr = /* @__PURE__ */ ve({
  id: 11155111,
  name: "Sepolia",
  nativeCurrency: { name: "Sepolia Ether", symbol: "ETH", decimals: 18 },
  rpcUrls: {
    default: {
      http: ["https://rpc.sepolia.org"]
    }
  },
  blockExplorers: {
    default: {
      name: "Etherscan",
      url: "https://sepolia.etherscan.io",
      apiUrl: "https://api-sepolia.etherscan.io/api"
    }
  },
  contracts: {
    multicall3: {
      address: "0xca11bde05977b3631167028862be2a173976ca11",
      blockCreated: 751532
    },
    ensRegistry: { address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e" },
    ensUniversalResolver: {
      address: "0xc8Af999e38273D658BE1b921b88A9Ddf005769cC",
      blockCreated: 5317080
    }
  },
  testnet: !0
}), kr = Qr({
  id: 984122,
  name: "Forma",
  nativeCurrency: {
    name: "TIA",
    symbol: "TIA",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.forma.art"]
    }
  },
  blockExplorers: {
    default: {
      name: "Forma Explorer",
      url: "https://explorer.forma.art"
    }
  },
  contracts: {
    multicall3: {
      address: "0xd53C6FFB123F7349A32980F87faeD8FfDc9ef079",
      blockCreated: 252705
    }
  },
  testnet: !1
}), vr = Qr({
  id: 984123,
  name: "Forma Testnet",
  nativeCurrency: {
    name: "TIA",
    symbol: "TIA",
    decimals: 18
  },
  rpcUrls: {
    default: {
      http: ["https://rpc.sketchpad-1.forma.art"]
    }
  },
  blockExplorers: {
    default: {
      name: "Forma Explorer",
      url: "https://explorer.sketchpad-1.forma.art"
    }
  },
  testnet: !0
}), Wc = tp({
  chains: [
    er,
    ir,
    tr,
    sr,
    lr,
    mr,
    pr,
    ur,
    hr,
    dr,
    xr,
    Dr,
    gr,
    br,
    Ar,
    Cr,
    or,
    cr,
    fr,
    nr,
    ar,
    rr,
    kr,
    vr,
    it
  ],
  transports: {
    [er.id]: xe(),
    [ir.id]: xe(),
    [tr.id]: xe(),
    [sr.id]: xe(),
    [lr.id]: xe(),
    [mr.id]: xe(),
    [pr.id]: xe(),
    [ur.id]: xe(),
    [hr.id]: xe(),
    [dr.id]: xe(),
    [xr.id]: xe(),
    [Dr.id]: xe(),
    [gr.id]: xe(),
    [br.id]: xe(),
    [Ar.id]: xe(),
    [Cr.id]: xe(),
    [or.id]: xe(),
    [cr.id]: xe(),
    [fr.id]: xe(),
    [nr.id]: xe(),
    [ar.id]: xe(),
    [rr.id]: xe(),
    [kr.id]: xe(),
    [vr.id]: xe(),
    [it.id]: xe()
  },
  ssr: !1
}), Gc = [
  new mp(),
  new rp(),
  new pp(),
  new sp(),
  new up(),
  new lp()
], ll = {
  apiURL: Vu,
  endpointOptions: Nu
}, ml = ee(ll), pl = ee(Qo), Sn = ee((e) => {
  const n = e(ml), i = e(Nc);
  return new Zm({
    ...n,
    getCosmosSigner: async (o) => {
      if (!i.cosmos)
        throw new Error("getCosmosSigner error: no cosmos wallet");
      const t = Ai(i.cosmos.walletName);
      if (!t)
        throw new Error("getCosmosSigner error: wallet not found");
      return (await t.getKey(o)).isNanoLedger ? t.getOfflineSignerOnlyAmino(o) : t.getOfflineSigner(o);
    },
    getEVMSigner: async (o) => await Cd(Wc, {
      chainId: parseInt(o)
    }),
    getSVMSigner: async () => {
      var c;
      const o = (c = i.svm) == null ? void 0 : c.walletName;
      if (!o) throw new Error("getSVMSigner error: no svm wallet");
      const t = Gc.find((a) => a.name === o);
      if (!t)
        throw new Error("getSVMSigner error: wallet not found");
      return t;
    }
  });
}), Od = (e, n) => {
  const i = [];
  for (const o in e)
    e[o].forEach((t) => {
      const c = n == null ? void 0 : n.find((a) => a.chainID === t.chainID);
      i.push({
        ...t,
        chain_key: o,
        chainName: (c == null ? void 0 : c.prettyName) ?? (c == null ? void 0 : c.chainName) ?? t.chainID ?? "--"
      });
    });
  return i;
}, bo = ee(void 0), Hn = pi((e) => {
  const n = e(Sn), i = e(Te), o = e(bo);
  return {
    queryKey: ["skipAssets"],
    queryFn: async () => n.assets({
      includeEvmAssets: !0,
      includeCW20Assets: !0,
      includeSvmAssets: !0,
      onlyTestnets: o
    }).then((t) => Od(t, i.data))
  };
}), Te = pi((e) => {
  const n = e(Sn), i = e(bo);
  return {
    queryKey: ["skipChains"],
    queryFn: async () => n.chains({
      includeEVM: !0,
      includeSVM: !0,
      onlyTestnets: i
    })
  };
}), Ud = pi((e) => {
  const n = e(Sn);
  return {
    queryKey: ["skipBridges"],
    queryFn: async () => n.bridges()
  };
}), Wd = pi((e) => {
  const n = e(Sn), i = e(bo);
  return {
    queryKey: ["skipSwapVenue"],
    queryFn: async () => n.venues(i)
  };
}), Gd = ({
  children: e
}) => {
  const n = X(bo);
  return /* @__PURE__ */ r.jsx(Qm, { grazOptions: {
    // @ts-expect-error mismatch keplr types version
    chains: n ? js : Ic,
    autoReconnect: !1,
    walletDefaultOptions: {
      sign: {
        preferNoSetFee: !0
      }
    }
  }, children: e });
}, Jd = ({
  children: e,
  wagmiConfig: n
}) => /* @__PURE__ */ r.jsx(
  cp,
  {
    config: n || Wc,
    reconnectOnMount: !0,
    children: e
  },
  "skip-widget-wagmi-provider"
), Kd = ({ children: e }) => /* @__PURE__ */ r.jsx(Gd, { children: /* @__PURE__ */ r.jsx(Jd, { children: e }) }), Xd = "data:font/woff2;base64,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", Zd = "data:font/woff2;base64,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", Yd = "data:font/woff2;base64,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", Qd = "data:font/woff2;base64,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", _d = `
  @font-face {
    font-family: ABCDiatype-regular;
    font-weight: 400;
    src: url(${Xd}) format(woff2);
  }
  @font-face {
    font-family: ABCDiatype-medium;
    font-weight: 500;
    src: url(${Zd}) format(woff2);
  }
  @font-face {
    font-family: ABCDiatype-bold;
    font-weight: 700;
    src: url(${Yd}) format(woff2);
  }
  @font-face {
    font-family: ABCDiatype-mono;
    font-weight: 500;
    src: url(${Qd}) format(woff2);
  }
`, $d = () => {
  Xe(() => {
    const e = document.createElement("style");
    return e.textContent = _d, document.head.contains(e) || document.head.appendChild(e), () => {
      document.head.removeChild(e);
    };
  }, []);
}, e0 = `
  * {
    font-style: unset;
    font-weight: unset;
    text-align: revert;
    text-decoration: unset;
    text-indent: unset;
    text-transform: unset;
    line-height: unset;
    letter-spacing: unset;
    white-space: unset;
    box-sizing: border-box;
    margin: unset;
    padding: unset;
    visibility: unset;
    float: unset;
    clear: unset;
    background-color: unset;
    word-spacing: unset;
    font-family: 'ABCDiatype', sans-serif;
  }
  div {
    box-sizing: border-box;
  }
`, n0 = new Jm();
function i0(e, n) {
  return typeof n == "string" ? as(e) : !0;
}
const ul = ({
  children: e,
  theme: n
}) => {
  $d();
  const [i, o] = be(!1), [, t] = be(), [c, a] = be(), s = ze((h) => {
    t(h);
  }, []), l = ze(
    (h) => {
      a(h);
    },
    []
  );
  Xe(() => {
    o(!0);
  }, []);
  const m = K(() => ({
    ...Qo,
    ...n
  }), [n]);
  return i ? /* @__PURE__ */ r.jsxs(Gm, { ref: s, stylesheet: e0, children: [
    /* @__PURE__ */ r.jsx("div", { ref: l }),
    /* @__PURE__ */ r.jsx(
      yu,
      {
        shouldForwardProp: i0,
        target: c,
        children: /* @__PURE__ */ r.jsx(Mu, { theme: m, children: /* @__PURE__ */ r.jsx(Kd, { children: /* @__PURE__ */ r.jsx(Km, { client: n0, children: e }, "skip-widget") }) })
      }
    )
  ] }) : null;
}, hn = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 };
let o0 = 0;
function gc(e, n) {
  const i = `atom${++o0}`, o = {
    toString() {
      return (hn ? "production" : void 0) !== "production" && this.debugLabel ? i + ":" + this.debugLabel : i;
    }
  };
  return typeof e == "function" ? o.read = e : (o.init = e, o.read = t0, o.write = c0), n && (o.write = n), o;
}
function t0(e) {
  return e(this);
}
function c0(e, n, i) {
  return n(
    this,
    typeof i == "function" ? i(e(this)) : i
  );
}
const wr = (e, n) => e.unstable_is ? e.unstable_is(n) : n === e, Ot = (e) => "init" in e, Ut = (e) => !!e.write, ot = /* @__PURE__ */ new WeakMap(), fc = (e) => {
  var n;
  return bc(e) && !((n = ot.get(e)) != null && n[1]);
}, a0 = (e, n) => {
  const i = ot.get(e);
  if (i)
    i[1] = !0, i[0].forEach((o) => o(n));
  else if ((hn ? "production" : void 0) !== "production")
    throw new Error("[Bug] cancelable promise not found");
}, r0 = (e) => {
  if (ot.has(e))
    return;
  const n = [/* @__PURE__ */ new Set(), !1];
  ot.set(e, n);
  const i = () => {
    n[1] = !0;
  };
  e.then(i, i), e.onCancel = (o) => {
    n[0].add(o);
  };
}, bc = (e) => typeof (e == null ? void 0 : e.then) == "function", yr = (e) => "v" in e || "e" in e, qo = (e) => {
  if ("e" in e)
    throw e.e;
  if ((hn ? "production" : void 0) !== "production" && !("v" in e))
    throw new Error("[Bug] atom state is not initialized");
  return e.v;
}, hl = (e, n, i) => {
  i.p.has(e) || (i.p.add(e), n.then(
    () => {
      i.p.delete(e);
    },
    () => {
      i.p.delete(e);
    }
  ));
}, Er = (e, n, i, o, t) => {
  var c;
  if ((hn ? "production" : void 0) !== "production" && o === n)
    throw new Error("[Bug] atom cannot depend on itself");
  i.d.set(o, t.n), fc(i.v) && hl(n, i.v, t), (c = t.m) == null || c.t.add(n), e && s0(e, o, n);
}, gi = () => [/* @__PURE__ */ new Map(), /* @__PURE__ */ new Map(), /* @__PURE__ */ new Set()], Wt = (e, n, i) => {
  e[0].has(n) || e[0].set(n, /* @__PURE__ */ new Set()), e[1].set(n, i);
}, s0 = (e, n, i) => {
  const o = e[0].get(n);
  o && o.add(i);
}, l0 = (e, n) => e[0].get(n), Pr = (e, n) => {
  e[2].add(n);
}, Qn = (e) => {
  for (; e[1].size || e[2].size; ) {
    e[0].clear();
    const n = new Set(e[1].values());
    e[1].clear();
    const i = new Set(e[2]);
    e[2].clear(), n.forEach((o) => {
      var t;
      return (t = o.m) == null ? void 0 : t.l.forEach((c) => c());
    }), i.forEach((o) => o());
  }
}, dl = (e) => {
  let n;
  (hn ? "production" : void 0) !== "production" && (n = /* @__PURE__ */ new Set());
  const i = (k, q, E) => {
    const x = "v" in q, g = q.v, M = fc(q.v) ? q.v : null;
    if (bc(E)) {
      r0(E);
      for (const H of q.d.keys())
        hl(
          k,
          E,
          e(H, q)
        );
      q.v = E, delete q.e;
    } else
      q.v = E, delete q.e;
    (!x || !Object.is(g, q.v)) && (++q.n, M && a0(M, E));
  }, o = (k, q, E, x) => {
    var g;
    if (yr(E) && (E.m && !(x != null && x.has(q)) || Array.from(E.d).every(
      ([d, f]) => (
        // Recursively, read the atom state of the dependency, and
        // check if the atom epoch number is unchanged
        o(k, d, e(d, E), x).n === f
      )
    )))
      return E;
    E.d.clear();
    let M = !0;
    const H = (d) => {
      if (wr(q, d)) {
        const w = e(d, E);
        if (!yr(w))
          if (Ot(d))
            i(d, w, d.init);
          else
            throw new Error("no atom init");
        return qo(w);
      }
      const f = o(
        k,
        d,
        e(d, E),
        x
      );
      if (M)
        Er(k, q, E, d, f);
      else {
        const w = gi();
        Er(w, q, E, d, f), m(w, q, E), Qn(w);
      }
      return qo(f);
    };
    let P, S;
    const p = {
      get signal() {
        return P || (P = new AbortController()), P.signal;
      },
      get setSelf() {
        return (hn ? "production" : void 0) !== "production" && !Ut(q) && console.warn("setSelf function cannot be used with read-only atom"), !S && Ut(q) && (S = (...d) => {
          if ((hn ? "production" : void 0) !== "production" && M && console.warn("setSelf function cannot be called in sync"), !M)
            return l(q, ...d);
        }), S;
      }
    };
    try {
      const d = q.read(H, p);
      if (i(q, E, d), bc(d)) {
        (g = d.onCancel) == null || g.call(d, () => P == null ? void 0 : P.abort());
        const f = () => {
          if (E.m) {
            const w = gi();
            m(w, q, E), Qn(w);
          }
        };
        d.then(f, f);
      }
      return E;
    } catch (d) {
      return delete E.v, E.e = d, ++E.n, E;
    } finally {
      M = !1;
    }
  }, t = (k) => qo(o(void 0, k, e(k))), c = (k, q, E) => {
    var x, g;
    const M = /* @__PURE__ */ new Map();
    for (const H of ((x = E.m) == null ? void 0 : x.t) || [])
      M.set(H, e(H, E));
    for (const H of E.p)
      M.set(
        H,
        e(H, E)
      );
    return (g = l0(k, q)) == null || g.forEach((H) => {
      M.set(H, e(H, E));
    }), M;
  }, a = (k, q, E) => {
    const x = [], g = /* @__PURE__ */ new Set(), M = (P, S) => {
      if (!g.has(P)) {
        g.add(P);
        for (const [p, d] of c(k, P, S))
          P !== p && M(p, d);
        x.push([P, S, S.n]);
      }
    };
    M(q, E);
    const H = /* @__PURE__ */ new Set([q]);
    for (let P = x.length - 1; P >= 0; --P) {
      const [S, p, d] = x[P];
      let f = !1;
      for (const w of p.d.keys())
        if (w !== S && H.has(w)) {
          f = !0;
          break;
        }
      f && (o(k, S, p, g), m(k, S, p), d !== p.n && (Wt(k, S, p), H.add(S))), g.delete(S);
    }
  }, s = (k, q, E, ...x) => {
    const g = (P) => qo(o(k, P, e(P, E))), M = (P, ...S) => {
      const p = e(P, E);
      let d;
      if (wr(q, P)) {
        if (!Ot(P))
          throw new Error("atom not writable");
        const f = "v" in p, w = p.v, y = S[0];
        i(P, p, y), m(k, P, p), (!f || !Object.is(w, p.v)) && (Wt(k, P, p), a(k, P, p));
      } else
        d = s(k, P, p, ...S);
      return Qn(k), d;
    };
    return q.write(g, M, ...x);
  }, l = (k, ...q) => {
    const E = gi(), x = s(E, k, e(k), ...q);
    return Qn(E), x;
  }, m = (k, q, E) => {
    if (E.m && !fc(E.v)) {
      for (const x of E.d.keys())
        E.m.d.has(x) || (h(k, x, e(x, E)).t.add(q), E.m.d.add(x));
      for (const x of E.m.d || [])
        if (!E.d.has(x)) {
          E.m.d.delete(x);
          const g = u(k, x, e(x, E));
          g == null || g.t.delete(q);
        }
    }
  }, h = (k, q, E) => {
    if (!E.m) {
      o(k, q, E);
      for (const x of E.d.keys())
        h(k, x, e(x, E)).t.add(q);
      if (E.m = {
        l: /* @__PURE__ */ new Set(),
        d: new Set(E.d.keys()),
        t: /* @__PURE__ */ new Set()
      }, (hn ? "production" : void 0) !== "production" && n.add(q), Ut(q) && q.onMount) {
        const x = E.m, { onMount: g } = q;
        Pr(k, () => {
          const M = g(
            (...H) => s(k, q, E, ...H)
          );
          M && (x.u = M);
        });
      }
    }
    return E.m;
  }, u = (k, q, E) => {
    if (E.m && !E.m.l.size && !Array.from(E.m.t).some(
      (x) => {
        var g;
        return (g = e(x, E).m) == null ? void 0 : g.d.has(q);
      }
    )) {
      const x = E.m.u;
      x && Pr(k, x), delete E.m, (hn ? "production" : void 0) !== "production" && n.delete(q);
      for (const g of E.d.keys()) {
        const M = u(k, g, e(g, E));
        M == null || M.t.delete(q);
      }
      return;
    }
    return E.m;
  }, C = {
    get: t,
    set: l,
    sub: (k, q) => {
      const E = gi(), x = e(k), g = h(E, k, x);
      Qn(E);
      const M = g.l;
      return M.add(q), () => {
        M.delete(q);
        const H = gi();
        u(H, k, x), Qn(H);
      };
    },
    unstable_derive: (k) => dl(...k(e))
  };
  return (hn ? "production" : void 0) !== "production" && Object.assign(C, {
    // store dev methods (these are tentative and subject to change without notice)
    dev4_get_internal_weak_map: () => ({
      get: (q) => {
        const E = e(q);
        if (E.n !== 0)
          return E;
      }
    }),
    dev4_get_mounted_atoms: () => n,
    dev4_restore_atoms: (q) => {
      const E = gi();
      for (const [x, g] of q)
        if (Ot(x)) {
          const M = e(x), H = "v" in M, P = M.v;
          i(x, M, g), m(E, x, M), (!H || !Object.is(P, M.v)) && (Wt(E, x, M), a(E, x, M));
        }
      Qn(E);
    }
  }), C;
}, m0 = () => {
  const e = /* @__PURE__ */ new WeakMap();
  return dl((i) => {
    let o = e.get(i);
    return o || (o = { d: /* @__PURE__ */ new Map(), p: /* @__PURE__ */ new Set(), n: 0 }, e.set(i, o)), o;
  });
};
let eo;
const p0 = () => (eo || (eo = m0(), (hn ? "production" : void 0) !== "production" && (globalThis.__JOTAI_DEFAULT_STORE__ || (globalThis.__JOTAI_DEFAULT_STORE__ = eo), globalThis.__JOTAI_DEFAULT_STORE__ !== eo && console.warn(
  "Detected multiple Jotai instances. It may cause unexpected behavior with the default store. https://github.com/pmndrs/jotai/discussions/2044"
))), eo), Jc = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, Kc = Symbol(
  (Jc ? "production" : void 0) !== "production" ? "RESET" : ""
);
function xl(e) {
  const n = gc(
    e,
    (i, o, t) => {
      const c = typeof t == "function" ? t(i(n)) : t;
      o(n, c === Kc ? e : c);
    }
  );
  return n;
}
const u0 = (e) => typeof (e == null ? void 0 : e.then) == "function";
function h0(e = () => {
  try {
    return window.localStorage;
  } catch (i) {
    (Jc ? "production" : void 0) !== "production" && typeof window < "u" && console.warn(i);
    return;
  }
}, n) {
  var i;
  let o, t;
  const c = {
    getItem: (l, m) => {
      var h, u;
      const D = (C) => {
        if (C = C || "", o !== C) {
          try {
            t = JSON.parse(C, n == null ? void 0 : n.reviver);
          } catch {
            return m;
          }
          o = C;
        }
        return t;
      }, b = (u = (h = e()) == null ? void 0 : h.getItem(l)) != null ? u : null;
      return u0(b) ? b.then(D) : D(b);
    },
    setItem: (l, m) => {
      var h;
      return (h = e()) == null ? void 0 : h.setItem(
        l,
        JSON.stringify(m, void 0)
      );
    },
    removeItem: (l) => {
      var m;
      return (m = e()) == null ? void 0 : m.removeItem(l);
    }
  }, a = (l) => (m, h, u) => l(m, (D) => {
    let b;
    try {
      b = JSON.parse(D || "");
    } catch {
      b = u;
    }
    h(b);
  });
  let s;
  try {
    s = (i = e()) == null ? void 0 : i.subscribe;
  } catch {
  }
  return !s && typeof window < "u" && typeof window.addEventListener == "function" && window.Storage && (s = (l, m) => {
    if (!(e() instanceof window.Storage))
      return () => {
      };
    const h = (u) => {
      u.storageArea === e() && u.key === l && m(u.newValue);
    };
    return window.addEventListener("storage", h), () => {
      window.removeEventListener("storage", h);
    };
  }), s && (c.subscribe = a(s)), c;
}
const d0 = h0();
function Dl(e, n, i = d0, o) {
  const t = gc(
    n
  );
  return (Jc ? "production" : void 0) !== "production" && (t.debugPrivate = !0), t.onMount = (a) => {
    a(i.getItem(e, n));
    let s;
    return i.subscribe && (s = i.subscribe(e, a, n)), s;
  }, gc(
    (a) => a(t),
    (a, s, l) => {
      const m = typeof l == "function" ? l(a(t)) : l;
      return m === Kc ? (s(t, n), i.removeItem(e)) : m instanceof Promise ? m.then((h) => (s(t, h), i.setItem(e, h))) : (s(t, m), i.setItem(e, m));
    }
  );
}
const x0 = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, D0 = Om(
  void 0
), g0 = (e) => wc(D0) || p0(), f0 = (e) => {
  e.status = "pending", e.then(
    (n) => {
      e.status = "fulfilled", e.value = n;
    },
    (n) => {
      e.status = "rejected", e.reason = n;
    }
  );
};
$e.use;
function b0(e, n) {
  const i = g0();
  return ze(
    (...t) => {
      if ((x0 ? "production" : void 0) !== "production" && !("write" in e))
        throw new Error("not writable atom");
      return i.set(e, ...t);
    },
    [i, e]
  );
}
function A0(e, n) {
  const i = b0(e);
  return ze(() => i(Kc), [i]);
}
const _e = xl(
  void 0
);
var Le = /* @__PURE__ */ ((e) => (e[e.AuthFailed = 0] = "AuthFailed", e[e.Timeout = 1] = "Timeout", e[e.AdditionalSigningRequired = 2] = "AdditionalSigningRequired", e[e.TradeWarning = 3] = "TradeWarning", e[e.TransactionFailed = 4] = "TransactionFailed", e[e.TransactionReverted = 5] = "TransactionReverted", e[e.Unexpected = 6] = "Unexpected", e))(Le || {});
const gl = xl(0), C0 = ({
  children: e,
  drawer: n,
  container: i,
  onOpenChange: o,
  stackedModal: t,
  theme: c
}) => {
  const a = Je();
  Xe(() => (o == null || o(!0), () => {
    o == null || o(!1);
  }), [o]);
  const s = async (h) => new Promise((u) => setTimeout(u, h)), [l, m] = be(!0);
  return /* @__PURE__ */ r.jsx(
    Ko.Root,
    {
      open: a.visible,
      onOpenChange: () => {
        m(!1), s(75).then(() => a.remove());
      },
      children: /* @__PURE__ */ r.jsx(Ko.Portal, { container: i, children: /* @__PURE__ */ r.jsx(ul, { theme: c, children: /* @__PURE__ */ r.jsx(E0, { drawer: n, open: l, invisible: t, children: /* @__PURE__ */ r.jsx(P0, { drawer: n, open: l, children: e }) }) }) })
    }
  );
}, Ui = (e) => {
  const n = e, i = (o) => {
    const [, t] = ue(_e);
    return /* @__PURE__ */ r.jsx(C0, { ...o, children: /* @__PURE__ */ r.jsx(
      Ro,
      {
        fallback: null,
        onError: (c) => t({ errorType: Le.Unexpected, error: c }),
        children: /* @__PURE__ */ r.jsx(n, { ...o })
      }
    ) });
  };
  return $r.create(i);
}, Je = (e, n) => {
  const [i] = ue(pl), [o, t] = ue(
    gl
  ), c = hp(e, n);
  return K(
    () => ({
      ...c,
      show: (a) => {
        c.show({
          ...a,
          theme: i
        }), t((s) => s + 1);
      },
      remove: () => {
        t((a) => Math.max(0, a - 1)), c.remove();
      },
      hide: () => {
        t((a) => Math.max(0, a - 1)), c.hide();
      }
    }),
    [c, i, t]
  );
}, Fr = Ri`
  from {
      opacity: 0;
    }
    to {
    opacity: 1;
    }
`, Br = Ri`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`, k0 = Ri`
  from {
      opacity: 0;
    transform: translateY(100%);
    }
    to {
    opacity: 1;
    transform: translateY(0);
    }
`, v0 = Ri`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(100%);
  }
`, w0 = Ri`
  from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
`, y0 = Ri`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0);
  }
`, E0 = V(Ko.Overlay)`
  ${({ invisible: e }) => e ? "" : "background: rgba(0 0 0 / 0.5);"}
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  place-items: center;
  overflow-y: auto;
  z-index: 10;
  animation: ${({ open: e }) => e ? Fr : Br} 150ms ease-in-out;
  /* For Chrome */
  &::-webkit-scrollbar {
    display: none;
  }
  /* For Firefox */
  scrollbar-width: none;
  /* For Internet Explorer and Edge */
  -ms-overflow-style: none;

  ${(e) => e.drawer && He`
      align-items: flex-end;
      position: absolute;
      background: rgba(255, 255, 255, 0);
      animation: ${e.open ? Fr : Br} 150ms ease-in-out;
      /* For Chrome */
      &::-webkit-scrollbar {
        display: none;
      }
      /* For Firefox */
      scrollbar-width: none;
      /* For Internet Explorer and Edge */
      -ms-overflow-style: none;
    `};
`, P0 = V(Ko.Content)`
  min-width: 300px;
  border-radius: 4px;
  z-index: 100;
  animation: ${({ drawer: e, open: n }) => n ? e ? k0 : w0 : e ? v0 : y0}
    150ms ease-in-out;
`, Xc = He`
  display: flex;
  ${({ align: e }) => e && `align-items: ${e}`};
  ${({ justify: e }) => e && `justify-content: ${e}`};
  ${({ gap: e }) => e && `gap: ${e}px`};
  ${({ padding: e }) => e && `padding: ${e}px`};
  ${({ borderRadius: e }) => e && `border-radius: ${e}px`};
`, U = V.div`
  ${Xc};
  flex-direction: row;
`, re = V(U)`
  flex-direction: column;
`, fl = V.div`
  ${({ width: e }) => e && `width: ${e}px`};
  ${({ height: e }) => e && `height: ${e}px`};
  flex-shrink: 0;
  flex-grow: 0;
`, bl = (e, n) => (i) => {
  const o = {
    ...n,
    ...i
  };
  return /* @__PURE__ */ r.jsx(e, { ...o });
}, vt = (e) => {
  e && navigator.clipboard.writeText(e);
};
function Ao(e, n) {
  return Dl(
    e,
    n,
    {
      getItem: (o) => {
        const t = localStorage.getItem(o);
        if (!t) return n;
        try {
          return JSON.parse(t);
        } catch {
          return n;
        }
      },
      setItem: (o, t) => {
        localStorage.setItem(o, JSON.stringify(t));
      },
      removeItem: (o) => {
        localStorage.delete(o);
      }
    }
  );
}
const Al = ({
  color: e = "currentColor",
  backgroundColor: n = "transparent",
  direction: i = "right",
  className: o
}) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    className: o,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: i === "down" ? "rotate(90)" : i === "left" ? "rotate(180)" : i === "up" ? "rotate(-90)" : "",
    children: [
      /* @__PURE__ */ r.jsx("rect", { width: "40", height: "40", rx: "10", fill: n }),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M20.1203 18.2749L9.84088 18.2749L9.84088 21.7251L20.1203 21.7251C21.3854 21.7251 22.0202 23.2548 21.1255 24.1496L17.206 28.0691L19.6465 30.5096L30.1582 19.9977L19.6511 9.49043L17.2106 11.9309L21.1278 15.8459C22.0225 16.7406 21.39 18.2726 20.1226 18.2726",
          fill: e
        }
      )
    ]
  }
), Zc = bl(Al, { direction: "right" }), Yc = bl(Al, { direction: "left" }), F0 = ({
  color: e = "currentColor",
  backgroundColor: n = "transparent"
}) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r.jsx("rect", { width: "40", height: "40", rx: "10", fill: n }),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M13.4052 17.915L11.8286 16.3384L8.58887 19.5182L17.5889 28.5164L19.7233 26.3819C19.725 26.3802 19.7267 26.3786 19.7283 26.377L31.4111 14.6941L29.8138 13.0968C29.8112 13.0941 29.8086 13.0916 29.806 13.0889C29.8034 13.0864 29.8008 13.0838 29.7982 13.0812L28.2006 11.4836L19.7285 19.9582C18.5469 21.1402 16.6307 21.1403 15.449 19.9585L13.4185 17.9281C13.4141 17.9237 13.4097 17.9194 13.4052 17.915Z",
          fill: e
        }
      )
    ]
  }
), B0 = ({
  color: e = "currentColor",
  backgroundColor: n = "transparent"
}) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r.jsx("rect", { width: "40", height: "40", rx: "10", fill: n }),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M18.4577 6.76448L18.3922 6.76448L18.3922 15.1648C18.3922 16.9436 16.9495 18.3863 15.1707 18.3863L6.76448 18.3863L6.76448 21.5423L6.76597 21.6093L15.1663 21.6093C16.9451 21.6093 18.3878 23.0519 18.3878 24.8308L18.3878 33.237L21.5438 33.237L21.6078 33.2355L21.6078 24.8352C21.6078 23.0564 23.0505 21.6137 24.8293 21.6137L33.2355 21.6137V18.4577L33.234 18.3907L24.8337 18.3907C23.0549 18.3907 21.6122 16.948 21.6122 15.1692L21.6122 6.763L18.4562 6.76299L18.4577 6.76448Z",
          fill: e
        }
      )
    ]
  }
), Qc = ({
  backgroundColor: e = "currentColor",
  className: n,
  ...i
}) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...i,
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M8.186 8.078c-.426.04-.66.274-.7.701a21.73 21.73 0 01-.854 6.46c-.06.183-.04.377.061.58.102.223.315.345.64.365.346-.02.58-.193.701-.518.203-.751.406-1.706.61-2.864.182-1.138.274-2.469.274-3.992-.04-.447-.285-.691-.732-.732zm-.03-2.499c-.955.02-1.717.325-2.286.914a3.065 3.065 0 00-.853 2.164 20.712 20.712 0 01-.396 4.358.76.76 0 00.091.548.667.667 0 00.457.305c.204.04.386.01.549-.091a.78.78 0 00.335-.457c.305-1.544.447-3.088.427-4.632 0-.427.142-.803.426-1.128.285-.325.701-.498 1.25-.518.488.02.894.193 1.219.518.325.325.498.721.518 1.189a26.355 26.355 0 01-.305 4.357.66.66 0 00.122.549.667.667 0 00.457.305c.305.02.518-.051.64-.214.142-.162.213-.294.213-.396.244-1.524.356-3.057.336-4.601-.04-.894-.356-1.636-.945-2.225-.61-.59-1.361-.904-2.255-.945zM4.804 5c-.386-.264-.732-.233-1.036.092a5.33 5.33 0 00-1.189 3.413 17.334 17.334 0 01-.274 3.413c-.04.183 0 .366.122.548a.667.667 0 00.457.305c.305.02.518-.05.64-.213.142-.163.203-.285.183-.366.223-1.24.325-2.478.304-3.718.02-.914.305-1.737.854-2.468.284-.366.264-.701-.061-1.006zm3.291-1.92c-.447 0-.904.051-1.371.153-.427.122-.61.416-.549.883.142.427.427.61.853.549a4.911 4.911 0 011.067-.122c1.178.04 2.174.447 2.986 1.22.793.771 1.21 1.736 1.25 2.894.02 1.138-.03 2.286-.152 3.444-.02.447.193.721.64.823.243 0 .436-.072.579-.214.142-.142.213-.284.213-.426.142-1.22.203-2.438.183-3.657-.061-1.544-.63-2.834-1.707-3.87C11.031 3.7 9.7 3.14 8.095 3.08zm7.71 3.718c-.142-.426-.437-.62-.884-.579a.779.779 0 00-.426.335c-.122.163-.163.346-.122.549.081.325.122.63.122.914.02.285.03.6.03.945.04.447.284.7.732.762.446-.04.69-.285.73-.732v-.03c.042-.63-.02-1.351-.182-2.164zm-1.25-2.773a7.78 7.78 0 00-2.833-2.499A7.896 7.896 0 008.065.581c-2.195 0-4.043.742-5.547 2.225C1.076 4.27.354 6.036.354 8.11v.64c.061.447.305.7.732.761h.03a.671.671 0 00.488-.213.61.61 0 00.213-.487v-.732c.02-1.645.6-3.057 1.737-4.236 1.24-1.198 2.743-1.798 4.51-1.798a6.515 6.515 0 012.987.762 6.656 6.656 0 012.347 2.042c.284.345.62.406 1.005.183.325-.285.376-.62.153-1.006z",
        fill: e
      }
    )
  }
), M0 = ({
  color: e = "currentColor",
  backgroundColor: n = "transparent"
}) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r.jsx("rect", { width: "40", height: "40", rx: "10", fill: n }),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M22.959 27.9526H17.5572C16.3875 27.9526 15.8005 26.5389 16.6294 25.71L21.5607 20.7787L19.2281 18.446L14.2967 23.3774C13.4701 24.204 12.0542 23.6192 12.0542 22.4496V17.0411H8.75635V31.2482H22.959V27.9504V27.9526Z",
          fill: e
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M23.3702 14.2922L18.2146 19.4478L20.5472 21.7805L25.7028 16.6249C26.5295 15.7982 27.9454 16.383 27.9454 17.5526V22.9611H31.2432V8.75183H17.0405V12.0497H22.4424C23.612 12.0497 24.199 13.4633 23.3702 14.2922Z",
          fill: e
        }
      )
    ]
  }
), j0 = ({
  color: e = "currentColor",
  backgroundColor: n = "transparent"
}) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    width: "40",
    height: "41",
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r.jsx("rect", { y: "0.480713", width: "40", height: "40", rx: "10", fill: n }),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M18.9042 24.141L17.4816 16.1506V11.6555C17.4816 10.5509 18.3771 9.65552 19.4816 9.65552H20.5182C21.6228 9.65552 22.5182 10.5509 22.5182 11.6555V16.1506L21.0957 24.141H18.9042ZM19.0972 31.3059C17.9926 31.3059 17.0972 30.4105 17.0972 29.3059V28.6975C17.0972 27.5929 17.9926 26.6975 19.0972 26.6975H20.9027C22.0073 26.6975 22.9027 27.5929 22.9027 28.6975V29.3059C22.9027 30.4105 22.0073 31.3059 20.9027 31.3059H19.0972Z",
          fill: e
        }
      )
    ]
  }
), z0 = ({ backgroundColor: e }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: "47",
    height: "41",
    viewBox: "0 0 47 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5686 1.76471C24.7988 0.431378 22.8743 0.431374 22.1045 1.76471L1.18402 38C0.414219 39.3333 1.37647 41 2.91607 41H44.757C46.2966 41 47.2588 39.3333 46.489 38L25.5686 1.76471ZM22.7622 27.766C22.8336 28.3044 23.2927 28.7066 23.8358 28.7066C24.3788 28.7066 24.8379 28.3044 24.9093 27.766L26.0164 19.418V14.6072C26.0164 13.4028 25.0401 12.4265 23.8358 12.4265C22.6314 12.4265 21.6551 13.4028 21.6551 14.6072V19.418L22.7622 27.766ZM21.3222 33.52C21.3222 34.7413 22.3122 35.7314 23.5335 35.7314H24.138C25.3593 35.7314 26.3494 34.7413 26.3494 33.52V32.9821C26.3494 31.7608 25.3593 30.7708 24.138 30.7708H23.5335C22.3122 30.7708 21.3222 31.7608 21.3222 32.9821V33.52Z",
        fill: e
      }
    )
  }
), _c = ({ color: e = "currentColor" }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "11",
    height: "13",
    viewBox: "0 0 11 12",
    fill: "none",
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M1.07754 9.22755H3.07909C3.14933 9.22755 3.21175 9.21584 3.26638 9.19243C3.321 9.16902 3.37562 9.13391 3.43025 9.08709L8.9199 3.58572C9.02135 3.48428 9.07207 3.36723 9.07207 3.23457C9.07207 3.10191 9.02135 2.98487 8.9199 2.88342L6.91834 0.893567C6.8169 0.792123 6.69985 0.741402 6.56719 0.741402C6.43454 0.741402 6.31749 0.792123 6.21604 0.893567L0.726384 6.38322C0.679564 6.43785 0.642498 6.49052 0.615186 6.54124C0.587875 6.59196 0.574219 6.65634 0.574219 6.73438V8.73594C0.574219 8.8842 0.621038 9.0032 0.714679 9.09294C0.80832 9.18268 0.929271 9.22755 1.07754 9.22755ZM1.58085 6.93336L6.56719 1.93531L7.86645 3.23457L2.88011 8.23262H1.58085V6.93336ZM10.067 10.7258H1.07754C0.929271 10.7258 0.80832 10.7726 0.714679 10.8663C0.621038 10.9599 0.574219 11.0808 0.574219 11.2291C0.574219 11.3774 0.621038 11.4983 0.714679 11.592C0.80832 11.6856 0.929271 11.7324 1.07754 11.7324H10.067C10.2153 11.7324 10.3362 11.6856 10.4299 11.592C10.5235 11.4983 10.5703 11.3774 10.5703 11.2291C10.5703 11.0808 10.5235 10.9599 10.4299 10.8663C10.3362 10.7726 10.2153 10.7258 10.067 10.7258Z",
        fill: e
      }
    )
  }
), Cl = ({
  color: e = "currentColor",
  ...n
}) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    width: "14",
    height: "12",
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M8.10134 0.511659C5.13657 0.540327 2.7685 3.00041 2.7685 5.96584V8.51992C2.7685 8.90927 2.29781 9.10394 2.02247 8.8286L0.92977 7.73589L0.222412 8.44325L3.26918 11.4893L6.31461 8.44392L5.60726 7.73656L4.51455 8.82926C4.23921 9.10461 3.76853 8.90927 3.76853 8.52059V5.96317C3.76853 3.55642 5.67992 1.54836 8.086 1.51169C10.5354 1.47436 12.5395 3.45575 12.5395 5.8965C12.5395 8.33725 10.5721 10.282 8.154 10.282V11.282C11.1234 11.282 13.5395 8.86593 13.5395 5.8965C13.5395 2.92707 11.0948 0.482324 8.10067 0.510992",
          fill: e
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M9.46906 8.01673L7.62567 6.17334V2.53589H8.6257V3.56659C8.6257 4.97063 9.18305 6.31668 10.1758 7.30938L9.4684 8.01673H9.46906Z",
          fill: e
        }
      )
    ]
  }
), q0 = ({
  color: e = "currentColor",
  direction: n = "left"
}) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "13",
    viewBox: "0 0 12 12",
    fill: "none",
    transform: n === "right" ? "rotate(180)" : "",
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M1 5.99999L6.02752 0.972473M1 5.99999L6.02752 11.0275M1 5.99999L11.0469 5.99999",
        stroke: e
      }
    )
  }
), I0 = ({ color: e = "currentColor" }) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "11",
    viewBox: "0 0 10 10",
    fill: "none",
    children: [
      /* @__PURE__ */ r.jsx("line", { x1: "10", y1: "1.25903", x2: "-4.37114e-08", y2: "1.25903", stroke: e }),
      /* @__PURE__ */ r.jsx("line", { x1: "10", y1: "5.09158", x2: "-3.30781e-08", y2: "5.09158", stroke: e }),
      /* @__PURE__ */ r.jsx("line", { x1: "10", y1: "8.92412", x2: "-3.30781e-08", y2: "8.92412", stroke: e })
    ]
  }
), S0 = ({ color: e = "currentColor" }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "2",
    viewBox: "0 0 10 2",
    fill: "none",
    children: /* @__PURE__ */ r.jsx("line", { x1: "10", y1: "1.09157", x2: "-3.30781e-08", y2: "1.09157", stroke: e })
  }
);
var Q = /* @__PURE__ */ ((e) => (e[e.none = 0] = "none", e[e.plus = 1] = "plus", e[e.checkmark = 2] = "checkmark", e[e.rightArrow = 3] = "rightArrow", e[e.leftArrow = 4] = "leftArrow", e[e.swap = 5] = "swap", e[e.warning = 6] = "warning", e[e.triangleWarning = 7] = "triangleWarning", e[e.signature = 8] = "signature", e[e.pen = 9] = "pen", e[e.history = 10] = "history", e[e.thinArrow = 11] = "thinArrow", e[e.hamburger = 12] = "hamburger", e[e.horizontalLine = 13] = "horizontalLine", e))(Q || {});
const mo = {
  0: () => null,
  1: B0,
  2: F0,
  3: Zc,
  4: Yc,
  5: M0,
  6: j0,
  7: z0,
  8: Qc,
  9: _c,
  10: Cl,
  11: q0,
  12: I0,
  13: S0
}, Co = He`
  background: none;
  border: none;
  padding: 0;
  outline: inherit;
`, kl = He`
  font-family: 'ABCDiatype-regular', sans-serif;
  ${({ fontSize: e }) => e && `font-size: ${e}px`};
  ${({ fontWeight: e }) => e && `font-weight: ${e}`};
  ${({ fontWeight: e }) => {
  switch (e) {
    case "400":
    case "normal":
      return "font-family: 'ABCDiatype-regular', sans-serif;";
    case "500":
    case "medium":
      return "font-family: 'ABCDiatype-medium', sans-serif;";
    case "700":
    case "bold":
      return "font-family: 'ABCDiatype-bold', sans-serif;";
  }
}};
  ${({ textAlign: e }) => e && `text-align: ${e}`};
  ${({ normalTextColor: e, theme: n }) => e && `color: ${n.primary.text.normal}`};
  ${({ color: e }) => e && `color: ${e}`};
  ${({ opacity: e }) => e && `opacity: ${e}`};
  ${({ lineHeight: e }) => e && `line-height: ${e}`};
  ${({ textWrap: e }) => e && `text-wrap: ${e}`};
  ${({ monospace: e }) => e && "font-family: 'ABCDiatype-mono', monospace;"};
  ${({ mainButtonColor: e }) => e && `color: ${xo(e)}`};
  ${({ capitalize: e }) => e && He`
      &::first-letter {
        text-transform: capitalize;
      }
    `};
`, G = V.p`
  color: ${({ theme: e }) => e.primary.text.lowContrast};
  margin: 0;
  font-size: 13px;
  ${kl}
`, ko = V(G).attrs({ as: "button" })`
  line-height: 15px;
  ${Co}
  cursor: pointer;
`, Pe = V(G)`
  color: ${(e) => e.theme.primary.text.normal};
  font-size: 20px;
  font-weight: 500;
  ${kl}
`, Mr = V(Pe).attrs({ as: "button" })`
  ${Co}
  cursor: pointer;
`, ui = ({
  title: e,
  description: n,
  textColor: i,
  backgroundColor: o,
  icon: t = Q.none
}) => {
  const c = ke();
  i ?? (i = c.primary.text.normal), o ?? (o = c.primary.background.normal);
  const a = mo[t];
  return /* @__PURE__ */ r.jsxs(
    H0,
    {
      align: "center",
      justify: "center",
      backgroundColor: o,
      gap: 12,
      padding: 16,
      children: [
        /* @__PURE__ */ r.jsx(a, { backgroundColor: i, color: o, height: 40, width: 40 }),
        typeof e == "string" ? /* @__PURE__ */ r.jsx(Pe, { fontSize: 20, color: i, children: e }) : e,
        typeof n == "string" ? /* @__PURE__ */ r.jsx(T0, { children: /* @__PURE__ */ r.jsx(G, { color: i, textAlign: "center", style: {
          wordWrap: "break-word"
        }, children: n }) }) : n
      ]
    }
  );
}, H0 = V(re)`
  width: 480px;
  height: 225px;
  border-radius: 25px;
  ${({ backgroundColor: e }) => e && `background-color: ${e}`};
`, T0 = V(re)`
  padding: 8px;
  max-height: 100px;
  overflow-y: auto;
  width: 100%;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: ${({ theme: e }) => e.primary.text.ultraLowContrast};
    border-radius: 16px;
  }
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 16px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`, Ce = ({
  label: e,
  icon: n = Q.none,
  leftIcon: i = Q.none,
  backgroundColor: o,
  disabled: t,
  loading: c,
  loadingTimeString: a,
  onClick: s
}) => {
  const l = ke();
  o ?? (o = t ? l.secondary.background.normal : l.brandColor);
  const m = xo(o), h = mo[n], u = mo[i];
  return c ? /* @__PURE__ */ r.jsx(
    N0,
    {
      label: e,
      backgroundColor: l.primary.background.normal,
      loadingTimeString: a
    }
  ) : /* @__PURE__ */ r.jsx(V0, { children: /* @__PURE__ */ r.jsxs(
    vl,
    {
      align: "center",
      justify: "space-between",
      padding: 20,
      backgroundColor: o,
      disabled: t,
      onClick: s,
      children: [
        i ? /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 10, children: [
          /* @__PURE__ */ r.jsx(u, { backgroundColor: m, color: o }),
          /* @__PURE__ */ r.jsx(
            Pe,
            {
              fontWeight: "bold",
              fontSize: 24,
              color: m,
              mainButtonColor: o,
              capitalize: !0,
              children: e
            }
          )
        ] }) : /* @__PURE__ */ r.jsx(Pe, { fontWeight: "bold", capitalize: !0, fontSize: 24, color: m, mainButtonColor: o, children: e }),
        /* @__PURE__ */ r.jsx(h, { backgroundColor: m, color: o })
      ]
    }
  ) });
}, N0 = ({
  label: e,
  backgroundColor: n,
  loadingTimeString: i
}) => /* @__PURE__ */ r.jsx(
  R0,
  {
    align: "center",
    justify: "center",
    backgroundColor: n,
    children: /* @__PURE__ */ r.jsxs(
      O0,
      {
        className: "overlay",
        justify: "space-between",
        align: "center",
        padding: 20,
        backgroundColor: n,
        children: [
          /* @__PURE__ */ r.jsx(Pe, { fontWeight: "bold", fontSize: 24, style: { opacity: 0.5 }, children: e }),
          i && /* @__PURE__ */ r.jsx(L0, { align: "center", justify: "center", children: /* @__PURE__ */ r.jsxs(G, { children: [
            i,
            "."
          ] }) })
        ]
      }
    )
  }
), V0 = V.div`
  position: relative;
  overflow: hidden;
  &:hover::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 25px;
    background-color: rgba(255, 255, 255, 0.1);
    pointer-events: none;
  }
`, vl = V(U).attrs({
  as: "button"
})`
  position: relative;
  border: none;
  background-color: ${({ theme: e, backgroundColor: n }) => n ?? e.brandColor};
  height: 70px;
  width: 480px;
  border-radius: 25px;
  overflow: hidden;

  &:hover {
    cursor: pointer;
  }

  ${(e) => e.disabled && `
      opacity: 0.5;
      background-color: ${e.theme.secondary.background.normal};
      &:hover {
        cursor: not-allowed;
      }
    `};
`, R0 = V(vl)`
  background-color: ${(e) => e.theme.secondary.background.normal};
  &:hover {
    cursor: not-allowed;
  }

  &:before {
    content: '';
    position: absolute;
    height: 500px;
    width: 500px;
    opacity: 0.5;
    background-image: conic-gradient(
      transparent,
      transparent,
      transparent,
      ${(e) => e.theme.primary.text.normal}
    );
    animation: rotate 4s linear infinite;
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, L0 = V(U)`
  background-color: ${(e) => e.theme.secondary.background.normal};
  padding: 16px;
  border-radius: 10px;
  height: 40px;
`, O0 = V(U)`
  position: absolute;
  height: 66px;
  width: 476px;
  border-radius: 24px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
`, jr = [0.5, 3, 5, 10], po = 6;
var U0 = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, Gt = Math.ceil, tn = Math.floor, Qe = "[BigNumber Error] ", zr = Qe + "Number primitive has more than 15 significant digits: ", un = 1e14, $ = 14, Jt = 9007199254740991, Kt = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], Rn = 1e7, Ie = 1e9;
function wl(e) {
  var n, i, o, t = x.prototype = { constructor: x, toString: null, valueOf: null }, c = new x(1), a = 20, s = 4, l = -7, m = 21, h = -1e7, u = 1e7, D = !1, b = 1, C = 0, k = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, q = "0123456789abcdefghijklmnopqrstuvwxyz", E = !0;
  function x(p, d) {
    var f, w, y, F, I, v, B, z, j = this;
    if (!(j instanceof x)) return new x(p, d);
    if (d == null) {
      if (p && p._isBigNumber === !0) {
        j.s = p.s, !p.c || p.e > u ? j.c = j.e = null : p.e < h ? j.c = [j.e = 0] : (j.e = p.e, j.c = p.c.slice());
        return;
      }
      if ((v = typeof p == "number") && p * 0 == 0) {
        if (j.s = 1 / p < 0 ? (p = -p, -1) : 1, p === ~~p) {
          for (F = 0, I = p; I >= 10; I /= 10, F++) ;
          F > u ? j.c = j.e = null : (j.e = F, j.c = [p]);
          return;
        }
        z = String(p);
      } else {
        if (!U0.test(z = String(p))) return o(j, z, v);
        j.s = z.charCodeAt(0) == 45 ? (z = z.slice(1), -1) : 1;
      }
      (F = z.indexOf(".")) > -1 && (z = z.replace(".", "")), (I = z.search(/e/i)) > 0 ? (F < 0 && (F = I), F += +z.slice(I + 1), z = z.substring(0, I)) : F < 0 && (F = z.length);
    } else {
      if (Ae(d, 2, q.length, "Base"), d == 10 && E)
        return j = new x(p), P(j, a + j.e + 1, s);
      if (z = String(p), v = typeof p == "number") {
        if (p * 0 != 0) return o(j, z, v, d);
        if (j.s = 1 / p < 0 ? (z = z.slice(1), -1) : 1, x.DEBUG && z.replace(/^0\.0*|\./, "").length > 15)
          throw Error(zr + p);
      } else
        j.s = z.charCodeAt(0) === 45 ? (z = z.slice(1), -1) : 1;
      for (f = q.slice(0, d), F = I = 0, B = z.length; I < B; I++)
        if (f.indexOf(w = z.charAt(I)) < 0) {
          if (w == ".") {
            if (I > F) {
              F = B;
              continue;
            }
          } else if (!y && (z == z.toUpperCase() && (z = z.toLowerCase()) || z == z.toLowerCase() && (z = z.toUpperCase()))) {
            y = !0, I = -1, F = 0;
            continue;
          }
          return o(j, String(p), v, d);
        }
      v = !1, z = i(z, d, 10, j.s), (F = z.indexOf(".")) > -1 ? z = z.replace(".", "") : F = z.length;
    }
    for (I = 0; z.charCodeAt(I) === 48; I++) ;
    for (B = z.length; z.charCodeAt(--B) === 48; ) ;
    if (z = z.slice(I, ++B)) {
      if (B -= I, v && x.DEBUG && B > 15 && (p > Jt || p !== tn(p)))
        throw Error(zr + j.s * p);
      if ((F = F - I - 1) > u)
        j.c = j.e = null;
      else if (F < h)
        j.c = [j.e = 0];
      else {
        if (j.e = F, j.c = [], I = (F + 1) % $, F < 0 && (I += $), I < B) {
          for (I && j.c.push(+z.slice(0, I)), B -= $; I < B; )
            j.c.push(+z.slice(I, I += $));
          I = $ - (z = z.slice(I)).length;
        } else
          I -= B;
        for (; I--; z += "0") ;
        j.c.push(+z);
      }
    } else
      j.c = [j.e = 0];
  }
  x.clone = wl, x.ROUND_UP = 0, x.ROUND_DOWN = 1, x.ROUND_CEIL = 2, x.ROUND_FLOOR = 3, x.ROUND_HALF_UP = 4, x.ROUND_HALF_DOWN = 5, x.ROUND_HALF_EVEN = 6, x.ROUND_HALF_CEIL = 7, x.ROUND_HALF_FLOOR = 8, x.EUCLID = 9, x.config = x.set = function(p) {
    var d, f;
    if (p != null)
      if (typeof p == "object") {
        if (p.hasOwnProperty(d = "DECIMAL_PLACES") && (f = p[d], Ae(f, 0, Ie, d), a = f), p.hasOwnProperty(d = "ROUNDING_MODE") && (f = p[d], Ae(f, 0, 8, d), s = f), p.hasOwnProperty(d = "EXPONENTIAL_AT") && (f = p[d], f && f.pop ? (Ae(f[0], -Ie, 0, d), Ae(f[1], 0, Ie, d), l = f[0], m = f[1]) : (Ae(f, -Ie, Ie, d), l = -(m = f < 0 ? -f : f))), p.hasOwnProperty(d = "RANGE"))
          if (f = p[d], f && f.pop)
            Ae(f[0], -Ie, -1, d), Ae(f[1], 1, Ie, d), h = f[0], u = f[1];
          else if (Ae(f, -Ie, Ie, d), f)
            h = -(u = f < 0 ? -f : f);
          else
            throw Error(Qe + d + " cannot be zero: " + f);
        if (p.hasOwnProperty(d = "CRYPTO"))
          if (f = p[d], f === !!f)
            if (f)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                D = f;
              else
                throw D = !f, Error(Qe + "crypto unavailable");
            else
              D = f;
          else
            throw Error(Qe + d + " not true or false: " + f);
        if (p.hasOwnProperty(d = "MODULO_MODE") && (f = p[d], Ae(f, 0, 9, d), b = f), p.hasOwnProperty(d = "POW_PRECISION") && (f = p[d], Ae(f, 0, Ie, d), C = f), p.hasOwnProperty(d = "FORMAT"))
          if (f = p[d], typeof f == "object") k = f;
          else throw Error(Qe + d + " not an object: " + f);
        if (p.hasOwnProperty(d = "ALPHABET"))
          if (f = p[d], typeof f == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(f))
            E = f.slice(0, 10) == "0123456789", q = f;
          else
            throw Error(Qe + d + " invalid: " + f);
      } else
        throw Error(Qe + "Object expected: " + p);
    return {
      DECIMAL_PLACES: a,
      ROUNDING_MODE: s,
      EXPONENTIAL_AT: [l, m],
      RANGE: [h, u],
      CRYPTO: D,
      MODULO_MODE: b,
      POW_PRECISION: C,
      FORMAT: k,
      ALPHABET: q
    };
  }, x.isBigNumber = function(p) {
    if (!p || p._isBigNumber !== !0) return !1;
    if (!x.DEBUG) return !0;
    var d, f, w = p.c, y = p.e, F = p.s;
    e: if ({}.toString.call(w) == "[object Array]") {
      if ((F === 1 || F === -1) && y >= -Ie && y <= Ie && y === tn(y)) {
        if (w[0] === 0) {
          if (y === 0 && w.length === 1) return !0;
          break e;
        }
        if (d = (y + 1) % $, d < 1 && (d += $), String(w[0]).length == d) {
          for (d = 0; d < w.length; d++)
            if (f = w[d], f < 0 || f >= un || f !== tn(f)) break e;
          if (f !== 0) return !0;
        }
      }
    } else if (w === null && y === null && (F === null || F === 1 || F === -1))
      return !0;
    throw Error(Qe + "Invalid BigNumber: " + p);
  }, x.maximum = x.max = function() {
    return M(arguments, -1);
  }, x.minimum = x.min = function() {
    return M(arguments, 1);
  }, x.random = function() {
    var p = 9007199254740992, d = Math.random() * p & 2097151 ? function() {
      return tn(Math.random() * p);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(f) {
      var w, y, F, I, v, B = 0, z = [], j = new x(c);
      if (f == null ? f = a : Ae(f, 0, Ie), I = Gt(f / $), D)
        if (crypto.getRandomValues) {
          for (w = crypto.getRandomValues(new Uint32Array(I *= 2)); B < I; )
            v = w[B] * 131072 + (w[B + 1] >>> 11), v >= 9e15 ? (y = crypto.getRandomValues(new Uint32Array(2)), w[B] = y[0], w[B + 1] = y[1]) : (z.push(v % 1e14), B += 2);
          B = I / 2;
        } else if (crypto.randomBytes) {
          for (w = crypto.randomBytes(I *= 7); B < I; )
            v = (w[B] & 31) * 281474976710656 + w[B + 1] * 1099511627776 + w[B + 2] * 4294967296 + w[B + 3] * 16777216 + (w[B + 4] << 16) + (w[B + 5] << 8) + w[B + 6], v >= 9e15 ? crypto.randomBytes(7).copy(w, B) : (z.push(v % 1e14), B += 7);
          B = I / 7;
        } else
          throw D = !1, Error(Qe + "crypto unavailable");
      if (!D)
        for (; B < I; )
          v = d(), v < 9e15 && (z[B++] = v % 1e14);
      for (I = z[--B], f %= $, I && f && (v = Kt[$ - f], z[B] = tn(I / v) * v); z[B] === 0; z.pop(), B--) ;
      if (B < 0)
        z = [F = 0];
      else {
        for (F = -1; z[0] === 0; z.splice(0, 1), F -= $) ;
        for (B = 1, v = z[0]; v >= 10; v /= 10, B++) ;
        B < $ && (F -= $ - B);
      }
      return j.e = F, j.c = z, j;
    };
  }(), x.sum = function() {
    for (var p = 1, d = arguments, f = new x(d[0]); p < d.length; ) f = f.plus(d[p++]);
    return f;
  }, i = /* @__PURE__ */ function() {
    var p = "0123456789";
    function d(f, w, y, F) {
      for (var I, v = [0], B, z = 0, j = f.length; z < j; ) {
        for (B = v.length; B--; v[B] *= w) ;
        for (v[0] += F.indexOf(f.charAt(z++)), I = 0; I < v.length; I++)
          v[I] > y - 1 && (v[I + 1] == null && (v[I + 1] = 0), v[I + 1] += v[I] / y | 0, v[I] %= y);
      }
      return v.reverse();
    }
    return function(f, w, y, F, I) {
      var v, B, z, j, T, L, W, J, se = f.indexOf("."), pe = a, _ = s;
      for (se >= 0 && (j = C, C = 0, f = f.replace(".", ""), J = new x(w), L = J.pow(f.length - se), C = j, J.c = d(
        Fn(on(L.c), L.e, "0"),
        10,
        y,
        p
      ), J.e = J.c.length), W = d(f, w, y, I ? (v = q, p) : (v = p, q)), z = j = W.length; W[--j] == 0; W.pop()) ;
      if (!W[0]) return v.charAt(0);
      if (se < 0 ? --z : (L.c = W, L.e = z, L.s = F, L = n(L, J, pe, _, y), W = L.c, T = L.r, z = L.e), B = z + pe + 1, se = W[B], j = y / 2, T = T || B < 0 || W[B + 1] != null, T = _ < 4 ? (se != null || T) && (_ == 0 || _ == (L.s < 0 ? 3 : 2)) : se > j || se == j && (_ == 4 || T || _ == 6 && W[B - 1] & 1 || _ == (L.s < 0 ? 8 : 7)), B < 1 || !W[0])
        f = T ? Fn(v.charAt(1), -pe, v.charAt(0)) : v.charAt(0);
      else {
        if (W.length = B, T)
          for (--y; ++W[--B] > y; )
            W[B] = 0, B || (++z, W = [1].concat(W));
        for (j = W.length; !W[--j]; ) ;
        for (se = 0, f = ""; se <= j; f += v.charAt(W[se++])) ;
        f = Fn(f, z, v.charAt(0));
      }
      return f;
    };
  }(), n = /* @__PURE__ */ function() {
    function p(w, y, F) {
      var I, v, B, z, j = 0, T = w.length, L = y % Rn, W = y / Rn | 0;
      for (w = w.slice(); T--; )
        B = w[T] % Rn, z = w[T] / Rn | 0, I = W * B + z * L, v = L * B + I % Rn * Rn + j, j = (v / F | 0) + (I / Rn | 0) + W * z, w[T] = v % F;
      return j && (w = [j].concat(w)), w;
    }
    function d(w, y, F, I) {
      var v, B;
      if (F != I)
        B = F > I ? 1 : -1;
      else
        for (v = B = 0; v < F; v++)
          if (w[v] != y[v]) {
            B = w[v] > y[v] ? 1 : -1;
            break;
          }
      return B;
    }
    function f(w, y, F, I) {
      for (var v = 0; F--; )
        w[F] -= v, v = w[F] < y[F] ? 1 : 0, w[F] = v * I + w[F] - y[F];
      for (; !w[0] && w.length > 1; w.splice(0, 1)) ;
    }
    return function(w, y, F, I, v) {
      var B, z, j, T, L, W, J, se, pe, _, O, ce, ge, ye, Be, Ne, Ve, Ze = w.s == y.s ? 1 : -1, Re = w.c, he = y.c;
      if (!Re || !Re[0] || !he || !he[0])
        return new x(
          // Return NaN if either NaN, or both Infinity or 0.
          !w.s || !y.s || (Re ? he && Re[0] == he[0] : !he) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            Re && Re[0] == 0 || !he ? Ze * 0 : Ze / 0
          )
        );
      for (se = new x(Ze), pe = se.c = [], z = w.e - y.e, Ze = F + z + 1, v || (v = un, z = cn(w.e / $) - cn(y.e / $), Ze = Ze / $ | 0), j = 0; he[j] == (Re[j] || 0); j++) ;
      if (he[j] > (Re[j] || 0) && z--, Ze < 0)
        pe.push(1), T = !0;
      else {
        for (ye = Re.length, Ne = he.length, j = 0, Ze += 2, L = tn(v / (he[0] + 1)), L > 1 && (he = p(he, L, v), Re = p(Re, L, v), Ne = he.length, ye = Re.length), ge = Ne, _ = Re.slice(0, Ne), O = _.length; O < Ne; _[O++] = 0) ;
        Ve = he.slice(), Ve = [0].concat(Ve), Be = he[0], he[1] >= v / 2 && Be++;
        do {
          if (L = 0, B = d(he, _, Ne, O), B < 0) {
            if (ce = _[0], Ne != O && (ce = ce * v + (_[1] || 0)), L = tn(ce / Be), L > 1)
              for (L >= v && (L = v - 1), W = p(he, L, v), J = W.length, O = _.length; d(W, _, J, O) == 1; )
                L--, f(W, Ne < J ? Ve : he, J, v), J = W.length, B = 1;
            else
              L == 0 && (B = L = 1), W = he.slice(), J = W.length;
            if (J < O && (W = [0].concat(W)), f(_, W, O, v), O = _.length, B == -1)
              for (; d(he, _, Ne, O) < 1; )
                L++, f(_, Ne < O ? Ve : he, O, v), O = _.length;
          } else B === 0 && (L++, _ = [0]);
          pe[j++] = L, _[0] ? _[O++] = Re[ge] || 0 : (_ = [Re[ge]], O = 1);
        } while ((ge++ < ye || _[0] != null) && Ze--);
        T = _[0] != null, pe[0] || pe.splice(0, 1);
      }
      if (v == un) {
        for (j = 1, Ze = pe[0]; Ze >= 10; Ze /= 10, j++) ;
        P(se, F + (se.e = j + z * $ - 1) + 1, I, T);
      } else
        se.e = z, se.r = +T;
      return se;
    };
  }();
  function g(p, d, f, w) {
    var y, F, I, v, B;
    if (f == null ? f = s : Ae(f, 0, 8), !p.c) return p.toString();
    if (y = p.c[0], I = p.e, d == null)
      B = on(p.c), B = w == 1 || w == 2 && (I <= l || I >= m) ? So(B, I) : Fn(B, I, "0");
    else if (p = P(new x(p), d, f), F = p.e, B = on(p.c), v = B.length, w == 1 || w == 2 && (d <= F || F <= l)) {
      for (; v < d; B += "0", v++) ;
      B = So(B, F);
    } else if (d -= I, B = Fn(B, F, "0"), F + 1 > v) {
      if (--d > 0) for (B += "."; d--; B += "0") ;
    } else if (d += F - v, d > 0)
      for (F + 1 == v && (B += "."); d--; B += "0") ;
    return p.s < 0 && y ? "-" + B : B;
  }
  function M(p, d) {
    for (var f, w, y = 1, F = new x(p[0]); y < p.length; y++)
      w = new x(p[y]), (!w.s || (f = _n(F, w)) === d || f === 0 && F.s === d) && (F = w);
    return F;
  }
  function H(p, d, f) {
    for (var w = 1, y = d.length; !d[--y]; d.pop()) ;
    for (y = d[0]; y >= 10; y /= 10, w++) ;
    return (f = w + f * $ - 1) > u ? p.c = p.e = null : f < h ? p.c = [p.e = 0] : (p.e = f, p.c = d), p;
  }
  o = /* @__PURE__ */ function() {
    var p = /^(-?)0([xbo])(?=\w[\w.]*$)/i, d = /^([^.]+)\.$/, f = /^\.([^.]+)$/, w = /^-?(Infinity|NaN)$/, y = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(F, I, v, B) {
      var z, j = v ? I : I.replace(y, "");
      if (w.test(j))
        F.s = isNaN(j) ? null : j < 0 ? -1 : 1;
      else {
        if (!v && (j = j.replace(p, function(T, L, W) {
          return z = (W = W.toLowerCase()) == "x" ? 16 : W == "b" ? 2 : 8, !B || B == z ? L : T;
        }), B && (z = B, j = j.replace(d, "$1").replace(f, "0.$1")), I != j))
          return new x(j, z);
        if (x.DEBUG)
          throw Error(Qe + "Not a" + (B ? " base " + B : "") + " number: " + I);
        F.s = null;
      }
      F.c = F.e = null;
    };
  }();
  function P(p, d, f, w) {
    var y, F, I, v, B, z, j, T = p.c, L = Kt;
    if (T) {
      e: {
        for (y = 1, v = T[0]; v >= 10; v /= 10, y++) ;
        if (F = d - y, F < 0)
          F += $, I = d, B = T[z = 0], j = tn(B / L[y - I - 1] % 10);
        else if (z = Gt((F + 1) / $), z >= T.length)
          if (w) {
            for (; T.length <= z; T.push(0)) ;
            B = j = 0, y = 1, F %= $, I = F - $ + 1;
          } else
            break e;
        else {
          for (B = v = T[z], y = 1; v >= 10; v /= 10, y++) ;
          F %= $, I = F - $ + y, j = I < 0 ? 0 : tn(B / L[y - I - 1] % 10);
        }
        if (w = w || d < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        T[z + 1] != null || (I < 0 ? B : B % L[y - I - 1]), w = f < 4 ? (j || w) && (f == 0 || f == (p.s < 0 ? 3 : 2)) : j > 5 || j == 5 && (f == 4 || w || f == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (F > 0 ? I > 0 ? B / L[y - I] : 0 : T[z - 1]) % 10 & 1 || f == (p.s < 0 ? 8 : 7)), d < 1 || !T[0])
          return T.length = 0, w ? (d -= p.e + 1, T[0] = L[($ - d % $) % $], p.e = -d || 0) : T[0] = p.e = 0, p;
        if (F == 0 ? (T.length = z, v = 1, z--) : (T.length = z + 1, v = L[$ - F], T[z] = I > 0 ? tn(B / L[y - I] % L[I]) * v : 0), w)
          for (; ; )
            if (z == 0) {
              for (F = 1, I = T[0]; I >= 10; I /= 10, F++) ;
              for (I = T[0] += v, v = 1; I >= 10; I /= 10, v++) ;
              F != v && (p.e++, T[0] == un && (T[0] = 1));
              break;
            } else {
              if (T[z] += v, T[z] != un) break;
              T[z--] = 0, v = 1;
            }
        for (F = T.length; T[--F] === 0; T.pop()) ;
      }
      p.e > u ? p.c = p.e = null : p.e < h && (p.c = [p.e = 0]);
    }
    return p;
  }
  function S(p) {
    var d, f = p.e;
    return f === null ? p.toString() : (d = on(p.c), d = f <= l || f >= m ? So(d, f) : Fn(d, f, "0"), p.s < 0 ? "-" + d : d);
  }
  return t.absoluteValue = t.abs = function() {
    var p = new x(this);
    return p.s < 0 && (p.s = 1), p;
  }, t.comparedTo = function(p, d) {
    return _n(this, new x(p, d));
  }, t.decimalPlaces = t.dp = function(p, d) {
    var f, w, y, F = this;
    if (p != null)
      return Ae(p, 0, Ie), d == null ? d = s : Ae(d, 0, 8), P(new x(F), p + F.e + 1, d);
    if (!(f = F.c)) return null;
    if (w = ((y = f.length - 1) - cn(this.e / $)) * $, y = f[y]) for (; y % 10 == 0; y /= 10, w--) ;
    return w < 0 && (w = 0), w;
  }, t.dividedBy = t.div = function(p, d) {
    return n(this, new x(p, d), a, s);
  }, t.dividedToIntegerBy = t.idiv = function(p, d) {
    return n(this, new x(p, d), 0, 1);
  }, t.exponentiatedBy = t.pow = function(p, d) {
    var f, w, y, F, I, v, B, z, j, T = this;
    if (p = new x(p), p.c && !p.isInteger())
      throw Error(Qe + "Exponent not an integer: " + S(p));
    if (d != null && (d = new x(d)), v = p.e > 14, !T.c || !T.c[0] || T.c[0] == 1 && !T.e && T.c.length == 1 || !p.c || !p.c[0])
      return j = new x(Math.pow(+S(T), v ? p.s * (2 - Io(p)) : +S(p))), d ? j.mod(d) : j;
    if (B = p.s < 0, d) {
      if (d.c ? !d.c[0] : !d.s) return new x(NaN);
      w = !B && T.isInteger() && d.isInteger(), w && (T = T.mod(d));
    } else {
      if (p.e > 9 && (T.e > 0 || T.e < -1 || (T.e == 0 ? T.c[0] > 1 || v && T.c[1] >= 24e7 : T.c[0] < 8e13 || v && T.c[0] <= 9999975e7)))
        return F = T.s < 0 && Io(p) ? -0 : 0, T.e > -1 && (F = 1 / F), new x(B ? 1 / F : F);
      C && (F = Gt(C / $ + 2));
    }
    for (v ? (f = new x(0.5), B && (p.s = 1), z = Io(p)) : (y = Math.abs(+S(p)), z = y % 2), j = new x(c); ; ) {
      if (z) {
        if (j = j.times(T), !j.c) break;
        F ? j.c.length > F && (j.c.length = F) : w && (j = j.mod(d));
      }
      if (y) {
        if (y = tn(y / 2), y === 0) break;
        z = y % 2;
      } else if (p = p.times(f), P(p, p.e + 1, 1), p.e > 14)
        z = Io(p);
      else {
        if (y = +S(p), y === 0) break;
        z = y % 2;
      }
      T = T.times(T), F ? T.c && T.c.length > F && (T.c.length = F) : w && (T = T.mod(d));
    }
    return w ? j : (B && (j = c.div(j)), d ? j.mod(d) : F ? P(j, C, s, I) : j);
  }, t.integerValue = function(p) {
    var d = new x(this);
    return p == null ? p = s : Ae(p, 0, 8), P(d, d.e + 1, p);
  }, t.isEqualTo = t.eq = function(p, d) {
    return _n(this, new x(p, d)) === 0;
  }, t.isFinite = function() {
    return !!this.c;
  }, t.isGreaterThan = t.gt = function(p, d) {
    return _n(this, new x(p, d)) > 0;
  }, t.isGreaterThanOrEqualTo = t.gte = function(p, d) {
    return (d = _n(this, new x(p, d))) === 1 || d === 0;
  }, t.isInteger = function() {
    return !!this.c && cn(this.e / $) > this.c.length - 2;
  }, t.isLessThan = t.lt = function(p, d) {
    return _n(this, new x(p, d)) < 0;
  }, t.isLessThanOrEqualTo = t.lte = function(p, d) {
    return (d = _n(this, new x(p, d))) === -1 || d === 0;
  }, t.isNaN = function() {
    return !this.s;
  }, t.isNegative = function() {
    return this.s < 0;
  }, t.isPositive = function() {
    return this.s > 0;
  }, t.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, t.minus = function(p, d) {
    var f, w, y, F, I = this, v = I.s;
    if (p = new x(p, d), d = p.s, !v || !d) return new x(NaN);
    if (v != d)
      return p.s = -d, I.plus(p);
    var B = I.e / $, z = p.e / $, j = I.c, T = p.c;
    if (!B || !z) {
      if (!j || !T) return j ? (p.s = -d, p) : new x(T ? I : NaN);
      if (!j[0] || !T[0])
        return T[0] ? (p.s = -d, p) : new x(j[0] ? I : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          s == 3 ? -0 : 0
        ));
    }
    if (B = cn(B), z = cn(z), j = j.slice(), v = B - z) {
      for ((F = v < 0) ? (v = -v, y = j) : (z = B, y = T), y.reverse(), d = v; d--; y.push(0)) ;
      y.reverse();
    } else
      for (w = (F = (v = j.length) < (d = T.length)) ? v : d, v = d = 0; d < w; d++)
        if (j[d] != T[d]) {
          F = j[d] < T[d];
          break;
        }
    if (F && (y = j, j = T, T = y, p.s = -p.s), d = (w = T.length) - (f = j.length), d > 0) for (; d--; j[f++] = 0) ;
    for (d = un - 1; w > v; ) {
      if (j[--w] < T[w]) {
        for (f = w; f && !j[--f]; j[f] = d) ;
        --j[f], j[w] += un;
      }
      j[w] -= T[w];
    }
    for (; j[0] == 0; j.splice(0, 1), --z) ;
    return j[0] ? H(p, j, z) : (p.s = s == 3 ? -1 : 1, p.c = [p.e = 0], p);
  }, t.modulo = t.mod = function(p, d) {
    var f, w, y = this;
    return p = new x(p, d), !y.c || !p.s || p.c && !p.c[0] ? new x(NaN) : !p.c || y.c && !y.c[0] ? new x(y) : (b == 9 ? (w = p.s, p.s = 1, f = n(y, p, 0, 3), p.s = w, f.s *= w) : f = n(y, p, 0, b), p = y.minus(f.times(p)), !p.c[0] && b == 1 && (p.s = y.s), p);
  }, t.multipliedBy = t.times = function(p, d) {
    var f, w, y, F, I, v, B, z, j, T, L, W, J, se, pe, _ = this, O = _.c, ce = (p = new x(p, d)).c;
    if (!O || !ce || !O[0] || !ce[0])
      return !_.s || !p.s || O && !O[0] && !ce || ce && !ce[0] && !O ? p.c = p.e = p.s = null : (p.s *= _.s, !O || !ce ? p.c = p.e = null : (p.c = [0], p.e = 0)), p;
    for (w = cn(_.e / $) + cn(p.e / $), p.s *= _.s, B = O.length, T = ce.length, B < T && (J = O, O = ce, ce = J, y = B, B = T, T = y), y = B + T, J = []; y--; J.push(0)) ;
    for (se = un, pe = Rn, y = T; --y >= 0; ) {
      for (f = 0, L = ce[y] % pe, W = ce[y] / pe | 0, I = B, F = y + I; F > y; )
        z = O[--I] % pe, j = O[I] / pe | 0, v = W * z + j * L, z = L * z + v % pe * pe + J[F] + f, f = (z / se | 0) + (v / pe | 0) + W * j, J[F--] = z % se;
      J[F] = f;
    }
    return f ? ++w : J.splice(0, 1), H(p, J, w);
  }, t.negated = function() {
    var p = new x(this);
    return p.s = -p.s || null, p;
  }, t.plus = function(p, d) {
    var f, w = this, y = w.s;
    if (p = new x(p, d), d = p.s, !y || !d) return new x(NaN);
    if (y != d)
      return p.s = -d, w.minus(p);
    var F = w.e / $, I = p.e / $, v = w.c, B = p.c;
    if (!F || !I) {
      if (!v || !B) return new x(y / 0);
      if (!v[0] || !B[0]) return B[0] ? p : new x(v[0] ? w : y * 0);
    }
    if (F = cn(F), I = cn(I), v = v.slice(), y = F - I) {
      for (y > 0 ? (I = F, f = B) : (y = -y, f = v), f.reverse(); y--; f.push(0)) ;
      f.reverse();
    }
    for (y = v.length, d = B.length, y - d < 0 && (f = B, B = v, v = f, d = y), y = 0; d; )
      y = (v[--d] = v[d] + B[d] + y) / un | 0, v[d] = un === v[d] ? 0 : v[d] % un;
    return y && (v = [y].concat(v), ++I), H(p, v, I);
  }, t.precision = t.sd = function(p, d) {
    var f, w, y, F = this;
    if (p != null && p !== !!p)
      return Ae(p, 1, Ie), d == null ? d = s : Ae(d, 0, 8), P(new x(F), p, d);
    if (!(f = F.c)) return null;
    if (y = f.length - 1, w = y * $ + 1, y = f[y]) {
      for (; y % 10 == 0; y /= 10, w--) ;
      for (y = f[0]; y >= 10; y /= 10, w++) ;
    }
    return p && F.e + 1 > w && (w = F.e + 1), w;
  }, t.shiftedBy = function(p) {
    return Ae(p, -Jt, Jt), this.times("1e" + p);
  }, t.squareRoot = t.sqrt = function() {
    var p, d, f, w, y, F = this, I = F.c, v = F.s, B = F.e, z = a + 4, j = new x("0.5");
    if (v !== 1 || !I || !I[0])
      return new x(!v || v < 0 && (!I || I[0]) ? NaN : I ? F : 1 / 0);
    if (v = Math.sqrt(+S(F)), v == 0 || v == 1 / 0 ? (d = on(I), (d.length + B) % 2 == 0 && (d += "0"), v = Math.sqrt(+d), B = cn((B + 1) / 2) - (B < 0 || B % 2), v == 1 / 0 ? d = "5e" + B : (d = v.toExponential(), d = d.slice(0, d.indexOf("e") + 1) + B), f = new x(d)) : f = new x(v + ""), f.c[0]) {
      for (B = f.e, v = B + z, v < 3 && (v = 0); ; )
        if (y = f, f = j.times(y.plus(n(F, y, z, 1))), on(y.c).slice(0, v) === (d = on(f.c)).slice(0, v))
          if (f.e < B && --v, d = d.slice(v - 3, v + 1), d == "9999" || !w && d == "4999") {
            if (!w && (P(y, y.e + a + 2, 0), y.times(y).eq(F))) {
              f = y;
              break;
            }
            z += 4, v += 4, w = 1;
          } else {
            (!+d || !+d.slice(1) && d.charAt(0) == "5") && (P(f, f.e + a + 2, 1), p = !f.times(f).eq(F));
            break;
          }
    }
    return P(f, f.e + a + 1, s, p);
  }, t.toExponential = function(p, d) {
    return p != null && (Ae(p, 0, Ie), p++), g(this, p, d, 1);
  }, t.toFixed = function(p, d) {
    return p != null && (Ae(p, 0, Ie), p = p + this.e + 1), g(this, p, d);
  }, t.toFormat = function(p, d, f) {
    var w, y = this;
    if (f == null)
      p != null && d && typeof d == "object" ? (f = d, d = null) : p && typeof p == "object" ? (f = p, p = d = null) : f = k;
    else if (typeof f != "object")
      throw Error(Qe + "Argument not an object: " + f);
    if (w = y.toFixed(p, d), y.c) {
      var F, I = w.split("."), v = +f.groupSize, B = +f.secondaryGroupSize, z = f.groupSeparator || "", j = I[0], T = I[1], L = y.s < 0, W = L ? j.slice(1) : j, J = W.length;
      if (B && (F = v, v = B, B = F, J -= F), v > 0 && J > 0) {
        for (F = J % v || v, j = W.substr(0, F); F < J; F += v) j += z + W.substr(F, v);
        B > 0 && (j += z + W.slice(F)), L && (j = "-" + j);
      }
      w = T ? j + (f.decimalSeparator || "") + ((B = +f.fractionGroupSize) ? T.replace(
        new RegExp("\\d{" + B + "}\\B", "g"),
        "$&" + (f.fractionGroupSeparator || "")
      ) : T) : j;
    }
    return (f.prefix || "") + w + (f.suffix || "");
  }, t.toFraction = function(p) {
    var d, f, w, y, F, I, v, B, z, j, T, L, W = this, J = W.c;
    if (p != null && (v = new x(p), !v.isInteger() && (v.c || v.s !== 1) || v.lt(c)))
      throw Error(Qe + "Argument " + (v.isInteger() ? "out of range: " : "not an integer: ") + S(v));
    if (!J) return new x(W);
    for (d = new x(c), z = f = new x(c), w = B = new x(c), L = on(J), F = d.e = L.length - W.e - 1, d.c[0] = Kt[(I = F % $) < 0 ? $ + I : I], p = !p || v.comparedTo(d) > 0 ? F > 0 ? d : z : v, I = u, u = 1 / 0, v = new x(L), B.c[0] = 0; j = n(v, d, 0, 1), y = f.plus(j.times(w)), y.comparedTo(p) != 1; )
      f = w, w = y, z = B.plus(j.times(y = z)), B = y, d = v.minus(j.times(y = d)), v = y;
    return y = n(p.minus(f), w, 0, 1), B = B.plus(y.times(z)), f = f.plus(y.times(w)), B.s = z.s = W.s, F = F * 2, T = n(z, w, F, s).minus(W).abs().comparedTo(
      n(B, f, F, s).minus(W).abs()
    ) < 1 ? [z, w] : [B, f], u = I, T;
  }, t.toNumber = function() {
    return +S(this);
  }, t.toPrecision = function(p, d) {
    return p != null && Ae(p, 1, Ie), g(this, p, d, 2);
  }, t.toString = function(p) {
    var d, f = this, w = f.s, y = f.e;
    return y === null ? w ? (d = "Infinity", w < 0 && (d = "-" + d)) : d = "NaN" : (p == null ? d = y <= l || y >= m ? So(on(f.c), y) : Fn(on(f.c), y, "0") : p === 10 && E ? (f = P(new x(f), a + y + 1, s), d = Fn(on(f.c), f.e, "0")) : (Ae(p, 2, q.length, "Base"), d = i(Fn(on(f.c), y, "0"), 10, p, w, !0)), w < 0 && f.c[0] && (d = "-" + d)), d;
  }, t.valueOf = t.toJSON = function() {
    return S(this);
  }, t._isBigNumber = !0, t[Symbol.toStringTag] = "BigNumber", t[Symbol.for("nodejs.util.inspect.custom")] = t.valueOf, e != null && x.set(e), x;
}
function cn(e) {
  var n = e | 0;
  return e > 0 || e === n ? n : n - 1;
}
function on(e) {
  for (var n, i, o = 1, t = e.length, c = e[0] + ""; o < t; ) {
    for (n = e[o++] + "", i = $ - n.length; i--; n = "0" + n) ;
    c += n;
  }
  for (t = c.length; c.charCodeAt(--t) === 48; ) ;
  return c.slice(0, t + 1 || 1);
}
function _n(e, n) {
  var i, o, t = e.c, c = n.c, a = e.s, s = n.s, l = e.e, m = n.e;
  if (!a || !s) return null;
  if (i = t && !t[0], o = c && !c[0], i || o) return i ? o ? 0 : -s : a;
  if (a != s) return a;
  if (i = a < 0, o = l == m, !t || !c) return o ? 0 : !t ^ i ? 1 : -1;
  if (!o) return l > m ^ i ? 1 : -1;
  for (s = (l = t.length) < (m = c.length) ? l : m, a = 0; a < s; a++) if (t[a] != c[a]) return t[a] > c[a] ^ i ? 1 : -1;
  return l == m ? 0 : l > m ^ i ? 1 : -1;
}
function Ae(e, n, i, o) {
  if (e < n || e > i || e !== tn(e))
    throw Error(Qe + (o || "Argument") + (typeof e == "number" ? e < n || e > i ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
}
function Io(e) {
  var n = e.c.length - 1;
  return cn(e.e / $) == n && e.c[n] % 2 != 0;
}
function So(e, n) {
  return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (n < 0 ? "e" : "e+") + n;
}
function Fn(e, n, i) {
  var o, t;
  if (n < 0) {
    for (t = i + "."; ++n; t += i) ;
    e = t + e;
  } else if (o = e.length, ++n > o) {
    for (t = i, n -= o; --n; t += i) ;
    e += t;
  } else n < o && (e = e.slice(0, n) + "." + e.slice(n));
  return e;
}
var Ke = wl();
const Un = (e, n = po) => (typeof e == "string" && (e = parseFloat(e)), new Ke(e).shiftedBy(n).toFixed(0)), wn = (e, n = po) => e === "" ? "" : (typeof e == "string" && (e = parseFloat(e)), new Ke(e).shiftedBy(-n).toFixed(n).replace(/(\.\d*?[1-9])(?:0+|\.0*)$/, "$1")), zi = (e) => e ? `${e.slice(
  0,
  9
)}…${e.slice(-5)}` : "", qr = (e, n, i) => {
  const o = new Ke(e).decimalPlaces(i, Ke.ROUND_DOWN), t = new Ke(n).decimalPlaces(i, Ke.ROUND_DOWN);
  return !o.eq(t);
}, en = ({
  assetDenom: e,
  amount: n,
  tokenAmount: i,
  chainId: o
}) => {
  const [{ data: t }] = ue(Hn), [{ data: c }] = ue(Te), a = t == null ? void 0 : t.find((b) => o ? b.denom === e && b.chainID === o : b.denom === e);
  !n && i ? n = wn(i, a == null ? void 0 : a.decimals) : !i && n && (i = Un(n, a == null ? void 0 : a.decimals));
  const s = a == null ? void 0 : a.logoURI, l = (a == null ? void 0 : a.recommendedSymbol) ?? (a == null ? void 0 : a.symbol), m = c == null ? void 0 : c.find((b) => o ? b.chainID === o : b.chainID === (a == null ? void 0 : a.chainID)), h = (m == null ? void 0 : m.prettyName) ?? (m == null ? void 0 : m.chainName), u = m == null ? void 0 : m.logoURI, D = a == null ? void 0 : a.decimals;
  return o ? {
    asset: a,
    chain: m,
    assetImage: s,
    chainName: h,
    chainImage: u,
    symbol: l,
    amount: n,
    tokenAmount: i,
    decimals: D
  } : {
    asset: void 0,
    chain: void 0,
    assetImage: void 0,
    chainName: void 0,
    chainImage: void 0,
    symbol: void 0,
    amount: void 0,
    tokenAmount: void 0
  };
};
function W0(e) {
  const n = e.toString().split(".");
  return n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), n.join(".");
}
function Xt(e) {
  return e.toString().replace(/,/g, "");
}
const G0 = (e) => e == null ? void 0 : e.replace(/0+$/, "").replace(/\.$/, "");
function uo(e, n = po) {
  if (e === void 0) return "";
  if (typeof e == "string") {
    const [t, c] = e.split(".");
    return c === void 0 || c.length <= n ? e : t + "." + c.slice(0, n);
  }
  if (isNaN(e)) return "";
  const i = Math.pow(10, n);
  return (Math.floor(e * i) / i).toString();
}
function yl(e, n, i) {
  const o = Ke(e), c = Ke(n).minus(o).dividedBy(o).multipliedBy(100);
  return i ? c.absoluteValue().toFixed(0) : c.toFixed(0);
}
const El = (e) => {
  if (e)
    return e < 60 ? `${e} ${ao("sec", e)}` : e < 3600 ? `${Math.round(e / 60)} ${ao(
      "min",
      Math.round(e / 60)
    )}` : `${Math.round(e / 3600)} ${ao(
      "hr",
      Math.round(e / 3600)
    )}`;
}, li = V(G).attrs({
  as: "button"
})`
  ${Co};
  line-height: 13px;
  height: 30px;

  ${({ alwaysShowBackground: e, theme: n, secondary: i }) => {
  if (e)
    return He`
        background-color: ${i ? n.secondary.background.normal : n.primary.ghostButtonHover};
      `;
}}

  ${({ onClick: e, disabled: n, secondary: i, theme: o }) => {
  if (e && !n)
    return He`
          &:hover {
            background-color: ${i ? o.secondary.background.normal : o.primary.ghostButtonHover};
            color: ${o.primary.text.normal};
            cursor: pointer;
          }
        `;
}}
 
  padding: 8px 16px;
  border-radius: 90px;
  ${Xc};
`, xn = V.button`
  ${Co}
  line - height: initial;
  ${({ disabled: e }) => e ? He`
          &:hover {
            cursor: not-allowed;
          }
        ` : He`
          &:hover {
            cursor: pointer;
          }
        `}

  ${Xc};
`, tt = V(xn).attrs({
  as: "a"
})`
  text-decoration: none;
`, yn = ({
  leftButton: e,
  rightButton: n,
  rightContent: i
}) => {
  const o = mo[(e == null ? void 0 : e.icon) || Q.none], t = mo[(n == null ? void 0 : n.icon) || Q.none];
  return /* @__PURE__ */ r.jsxs(J0, { justify: "space-between", children: [
    /* @__PURE__ */ r.jsx(U, { align: "center", gap: 10, children: e && /* @__PURE__ */ r.jsxs(li, { gap: 5, align: "center", onClick: e.onClick, children: [
      /* @__PURE__ */ r.jsx(o, {}),
      e.label
    ] }) }),
    /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 10, children: [
      i,
      n && /* @__PURE__ */ r.jsxs(li, { gap: 5, align: "center", onClick: n.onClick, children: [
        n.label,
        /* @__PURE__ */ r.jsx(t, {})
      ] })
    ] })
  ] });
}, J0 = V(U)`
  height: 30px;
`, K0 = ({
  onClickContinue: e,
  onClickBack: n,
  route: i
}) => {
  const o = ke(), {
    amountIn: t,
    amountOut: c,
    usdAmountIn: a,
    usdAmountOut: s,
    sourceAssetDenom: l,
    sourceAssetChainID: m,
    destAssetDenom: h,
    destAssetChainID: u
  } = i, D = `${yl(
    a ?? 0,
    s ?? 0,
    !0
  )}%`, b = en({
    assetDenom: l,
    chainId: m,
    tokenAmount: t
  }), C = en({
    assetDenom: h,
    chainId: u,
    tokenAmount: c
  });
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      yn,
      {
        leftButton: {
          label: "Back",
          icon: Q.thinArrow,
          onClick: n
        }
      }
    ),
    /* @__PURE__ */ r.jsx(
      ui,
      {
        title: `Warning: Bad trade (-${D})`,
        description: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsxs(G, { color: o.error.text, textAlign: "center", textWrap: "balance", children: [
            "You will lose ~",
            D,
            " of your input value with this trade",
            /* @__PURE__ */ r.jsx("br", {}),
            "Input: ",
            b == null ? void 0 : b.amount,
            " ",
            b == null ? void 0 : b.symbol,
            " (",
            a,
            ")",
            /* @__PURE__ */ r.jsx("br", {}),
            "Estimated output: ~",
            C == null ? void 0 : C.amount,
            " ",
            C == null ? void 0 : C.symbol,
            " (",
            s,
            ")"
          ] }),
          /* @__PURE__ */ r.jsx(
            ko,
            {
              onClick: e,
              color: o.primary.text.lowContrast,
              children: "I know the risk, continue anyway"
            }
          )
        ] }),
        icon: Q.triangleWarning,
        backgroundColor: o.error.background,
        textColor: o.error.text
      }
    ),
    /* @__PURE__ */ r.jsx(
      Ce,
      {
        label: "Back",
        icon: Q.leftArrow,
        onClick: n,
        backgroundColor: o.error.text
      }
    )
  ] });
}, X0 = ({
  onClickBack: e
}) => {
  const n = Z(_e), i = ke(), o = () => {
    n(void 0), e && e();
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      yn,
      {
        leftButton: {
          label: "Back",
          icon: Q.thinArrow,
          onClick: o
        }
      }
    ),
    /* @__PURE__ */ r.jsx(
      ui,
      {
        title: "Transaction failed",
        description: "User rejected authentication request",
        icon: Q.triangleWarning,
        backgroundColor: i.error.background,
        textColor: i.error.text
      }
    ),
    /* @__PURE__ */ r.jsx(
      Ce,
      {
        label: "Back",
        icon: Q.leftArrow,
        onClick: o,
        backgroundColor: i.error.text
      }
    )
  ] });
}, mi = ({
  color: e = "currentColor",
  ...n
}) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M3.28732 11.1042C3.1309 11.2606 2.93332 11.273 2.69458 11.1413C2.45584 11.0095 2.25826 10.8655 2.10184 10.7091C1.94542 10.5526 1.80136 10.3551 1.66963 10.1163C1.53791 9.87758 1.55026 9.68 1.70668 9.52359L5.36191 5.75722C5.09023 5.68313 4.79592 5.64814 4.47897 5.65226C4.16202 5.65637 3.89652 5.76134 3.68248 5.96715L0.916362 8.73327C0.603525 9.0461 0.459458 9.46596 0.484156 9.99284C0.508854 10.5197 0.677618 10.9396 0.990454 11.2524L1.5585 11.8081C1.87133 12.1209 2.29118 12.2918 2.81807 12.3206C3.34495 12.3494 3.7648 12.2074 4.07764 11.8945L6.84375 9.12843C7.0578 8.92261 7.16276 8.65712 7.15865 8.33193C7.15453 8.00675 7.11954 7.71244 7.05368 7.449L3.28732 11.1042ZM12.2895 1.07705L11.7339 0.509009C11.421 0.196173 11.0012 0.0274085 10.4743 0.00271077C9.9474 -0.0219869 9.52755 0.12208 9.21471 0.434916L6.4486 3.20103C6.24278 3.41508 6.13782 3.68057 6.1337 3.99753C6.12959 4.31448 6.16457 4.60467 6.23867 4.86811L10.005 1.22524C10.1614 1.06882 10.359 1.05647 10.5978 1.18819C10.8365 1.31991 11.0341 1.46398 11.1905 1.6204C11.3469 1.77681 11.491 1.97439 11.6227 2.21313C11.7544 2.45188 11.7421 2.64946 11.5857 2.80587L7.93044 6.57224C8.19388 6.6381 8.48819 6.67309 8.81338 6.6772C9.13856 6.68132 9.40406 6.57635 9.60987 6.36231L12.376 3.59619C12.6888 3.28336 12.8308 2.8635 12.802 2.33662C12.7732 1.80974 12.6024 1.38989 12.2895 1.07705ZM7.91809 4.89281C7.83577 4.81872 7.73904 4.78167 7.6279 4.78167C7.51676 4.78167 7.42415 4.81872 7.35005 4.89281L5.37425 6.86861C5.29193 6.95093 5.25077 7.04766 5.25077 7.1588C5.25077 7.26994 5.29193 7.36256 5.37425 7.43665C5.44835 7.51897 5.54096 7.56014 5.6521 7.56014C5.76324 7.56014 5.85585 7.51897 5.92995 7.43665L7.91809 5.46085C7.99219 5.38676 8.02923 5.29414 8.02923 5.18301C8.02923 5.07187 7.99219 4.97513 7.91809 4.89281Z",
        fill: e
      }
    )
  }
);
var Ue = /* @__PURE__ */ ((e) => (e[e.SwapPage = 0] = "SwapPage", e[e.SwapExecutionPage = 1] = "SwapExecutionPage", e[e.TransactionHistoryPage = 2] = "TransactionHistoryPage", e))(Ue || {});
const Tn = ee(
  0
  /* SwapPage */
), Z0 = ({
  transactionHash: e,
  explorerLink: n,
  onClickContactSupport: i,
  onClickBack: o
}) => {
  const t = ke(), c = Z(_e), a = Z(Tn);
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      yn,
      {
        leftButton: {
          label: "Back",
          icon: Q.thinArrow,
          onClick: () => {
            c(void 0), o && o(), a(Ue.SwapPage);
          }
        }
      }
    ),
    /* @__PURE__ */ r.jsx(
      ui,
      {
        title: "Transaction failed",
        description: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsx(G, { color: t.error.text, textAlign: "center", textWrap: "balance", children: "Please contact our support team below." }),
          /* @__PURE__ */ r.jsxs(
            U,
            {
              as: ko,
              gap: 5,
              onClick: () => window.open(n, "_blank"),
              color: t.primary.text.lowContrast,
              children: [
                "Transaction: ",
                /* @__PURE__ */ r.jsx("u", { children: zi(e) }),
                /* @__PURE__ */ r.jsx(mi, { color: t.primary.text.lowContrast })
              ]
            }
          )
        ] }),
        icon: Q.triangleWarning,
        backgroundColor: t.error.background,
        textColor: t.error.text
      }
    ),
    /* @__PURE__ */ r.jsx(
      Ce,
      {
        label: "Contact support",
        icon: Q.rightArrow,
        onClick: i,
        backgroundColor: t.error.text
      }
    )
  ] });
}, Y0 = ({ error: e, onClickBack: n }) => {
  const i = ke(), o = Z(_e), t = Z(Tn), c = () => {
    o(void 0), t(Ue.SwapPage);
  };
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      yn,
      {
        leftButton: {
          label: "Back",
          icon: Q.thinArrow,
          onClick: () => {
            o(void 0), n && n(), t(Ue.SwapPage);
          }
        }
      }
    ),
    /* @__PURE__ */ r.jsx(
      ui,
      {
        title: "An unexpected error has occurred",
        description: e == null ? void 0 : e.message,
        icon: Q.triangleWarning,
        backgroundColor: i.error.background,
        textColor: i.error.text
      }
    ),
    /* @__PURE__ */ r.jsx(
      Ce,
      {
        label: "Retry",
        icon: Q.rightArrow,
        onClick: c,
        backgroundColor: i.error.text
      }
    )
  ] });
}, Q0 = ({
  txHash: e,
  explorerLink: n,
  onClickBack: i
}) => {
  const o = ke(), t = Z(_e), c = Z(Tn);
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      yn,
      {
        leftButton: {
          label: "Back",
          icon: Q.thinArrow,
          onClick: () => {
            t(void 0), i && i(), c(Ue.SwapPage);
          }
        }
      }
    ),
    /* @__PURE__ */ r.jsx(
      ui,
      {
        title: "Sorry, your transaction is taking longer than usual.",
        description: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsxs(G, { color: o.warning.text, textAlign: "center", textWrap: "balance", children: [
            "Your funds are secure.",
            /* @__PURE__ */ r.jsx("br", {}),
            "You can close this window safely while you wait.",
            /* @__PURE__ */ r.jsx("br", {}),
            "Check the history page for status updates."
          ] }),
          /* @__PURE__ */ r.jsxs(
            U,
            {
              gap: 5,
              align: "center",
              as: ko,
              onClick: () => n && window.open(n, "_blank"),
              color: o.primary.text.lowContrast,
              children: [
                /* @__PURE__ */ r.jsx(mi, { color: o.primary.text.lowContrast }),
                n ? "View on explorer" : `Tx hash: ${e}`
              ]
            }
          )
        ] }),
        icon: Q.warning,
        backgroundColor: o.warning.background,
        textColor: o.warning.text
      }
    ),
    /* @__PURE__ */ r.jsx(Ce, { label: "Swap in progress...", loading: !0 })
  ] });
}, _0 = ({
  onClickSign: e,
  route: n,
  onClickBack: i
}) => {
  const { amountIn: o, amountOut: t, sourceAssetDenom: c, destAssetDenom: a } = n, s = en({
    assetDenom: c,
    tokenAmount: o
  }), l = en({
    assetDenom: a,
    tokenAmount: t
  });
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      yn,
      {
        leftButton: {
          label: "Back",
          icon: Q.thinArrow,
          onClick: i
        }
      }
    ),
    /* @__PURE__ */ r.jsx(
      ui,
      {
        title: /* @__PURE__ */ r.jsxs(Pe, { children: [
          "Transaction requires an",
          /* @__PURE__ */ r.jsx("br", {}),
          "additional signing step"
        ] }),
        description: /* @__PURE__ */ r.jsxs(G, { textWrap: "balance", children: [
          s.amount,
          " ",
          s.symbol,
          " ",
          " -> ",
          l.amount,
          " ",
          l.symbol
        ] }),
        icon: Q.signature
      }
    ),
    /* @__PURE__ */ r.jsx(
      Ce,
      {
        label: "Authorize in wallet",
        icon: Q.rightArrow,
        onClick: e
      }
    )
  ] });
}, $0 = ({
  explorerUrl: e,
  revertedOperation: n,
  recoveryAddress: i,
  onClickContinueTransaction: o,
  onClickBack: t
}) => {
  const c = Z(_e), a = Z(Tn), s = ke(), l = n.denomIn ?? n.denom, m = en({
    assetDenom: l,
    tokenAmount: n.amountIn,
    chainId: (n == null ? void 0 : n.fromChainID) ?? n.chainID
  });
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsx(
      yn,
      {
        leftButton: {
          label: "Back",
          icon: Q.thinArrow,
          onClick: () => {
            c(void 0), t && t(), a(Ue.SwapPage);
          }
        }
      }
    ),
    /* @__PURE__ */ r.jsx(
      ui,
      {
        title: "Action Required",
        description: /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
          /* @__PURE__ */ r.jsxs(G, { color: s.warning.text, textAlign: "center", textWrap: "balance", children: [
            "This transaction reverted while trying to execute.",
            /* @__PURE__ */ r.jsx("br", {}),
            "You can continue executing this transaction now."
          ] }),
          /* @__PURE__ */ r.jsxs(
            G,
            {
              color: s.primary.text.lowContrast,
              textAlign: "center",
              textWrap: "balance",
              children: [
                "Current asset location: ",
                m == null ? void 0 : m.amount,
                " ",
                m == null ? void 0 : m.symbol,
                " on ",
                m == null ? void 0 : m.chainName,
                " (",
                i,
                ")"
              ]
            }
          ),
          /* @__PURE__ */ r.jsx(U, { gap: 25, justify: "center", children: /* @__PURE__ */ r.jsxs(
            U,
            {
              gap: 5,
              align: "center",
              as: ko,
              onClick: () => window.open(e, "_blank"),
              color: s.primary.text.lowContrast,
              children: [
                /* @__PURE__ */ r.jsx(mi, { color: s.primary.text.lowContrast }),
                "View on explorer"
              ]
            }
          ) })
        ] }),
        icon: Q.warning,
        backgroundColor: s.warning.background,
        textColor: s.warning.text
      }
    ),
    /* @__PURE__ */ r.jsx(
      Ce,
      {
        label: "Continue transaction",
        backgroundColor: s.warning.text,
        icon: Q.rightArrow,
        onClick: o
      }
    )
  ] });
}, ex = () => {
  const [e] = ue(_e), n = K(() => {
    switch (e == null ? void 0 : e.errorType) {
      case Le.AuthFailed:
        return /* @__PURE__ */ r.jsx(X0, { ...e });
      case Le.Timeout:
        return /* @__PURE__ */ r.jsx(Q0, { ...e });
      case Le.AdditionalSigningRequired:
        return /* @__PURE__ */ r.jsx(_0, { ...e });
      case Le.TradeWarning:
        return /* @__PURE__ */ r.jsx(K0, { ...e });
      case Le.TransactionFailed:
        return /* @__PURE__ */ r.jsx(Z0, { ...e });
      case Le.TransactionReverted:
        return /* @__PURE__ */ r.jsx($0, { ...e });
      case Le.Unexpected:
        return /* @__PURE__ */ r.jsx(Y0, { error: e.error });
      default:
        return;
    }
  }, [e]);
  if ((e == null ? void 0 : e.errorType) !== void 0)
    return /* @__PURE__ */ r.jsx(re, { gap: 5, children: n });
}, Pl = ({ color: e = "currentColor" }) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "16",
    viewBox: "0 0 50 16",
    fill: "none",
    children: [
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M45.6038 9.5579C46.3169 9.5579 46.855 9.01981 46.855 8.30673C46.855 7.59365 46.3169 7.05556 45.6038 7.05556C44.8907 7.05556 44.3526 7.59365 44.3526 8.30673C44.3526 9.01981 44.8907 9.5579 45.6038 9.5579ZM41.4609 8.30673L42.7524 4.51297H48.4561L49.7344 8.30673L48.4561 12.1005H42.7524L41.4609 8.30673Z",
          fill: e
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M37.7754 8.52196C37.1699 8.52196 36.7263 8.07837 36.7263 7.4729C36.7263 6.86744 37.1699 6.43697 37.7754 6.43697C38.3809 6.43697 38.8253 6.88057 38.8253 7.4729C38.8253 8.06524 38.3817 8.52196 37.7754 8.52196ZM36.82 4.52696C34.9765 4.52696 33.874 5.77814 33.874 7.44666C33.874 9.11518 34.9773 10.3795 36.82 10.3795H38.1788C38.569 10.3795 38.8376 10.635 38.8376 10.9981V11.1477C38.8376 11.5108 38.569 11.7803 38.1788 11.7803H34.1164V14H41.1256V4.52784H36.8208L36.82 4.52696Z",
          fill: e
        }
      ),
      /* @__PURE__ */ r.jsx("path", { d: "M18.6979 4.51384H15.5498V12.1022H18.6979V4.51384Z", fill: e }),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M7.50488 2.61609H10.5864V5.67052C10.5864 6.07387 10.8288 6.33023 11.219 6.33023C11.6093 6.33023 11.8516 6.07475 11.8516 5.67052V4.51385H14.9323V7.6759H10.4517C10.0615 7.6759 9.79199 7.93138 9.79199 8.29449C9.79199 8.65759 10.0615 8.91307 10.4517 8.91307H14.9323V12.1022H11.8516V10.9184C11.8516 10.5151 11.6093 10.2587 11.219 10.2587C10.8288 10.2587 10.5864 10.5142 10.5864 10.9184V12.1022H7.50488V2.61696V2.61609Z",
          fill: e
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M0.00976562 11.4627H4.20775C4.59798 11.4627 4.86659 11.2072 4.86659 10.8441C4.86659 10.481 4.59798 10.2115 4.20775 10.2115L0.00976562 10.1844V4.51297H6.88509V7.04244H2.6871C2.29687 7.04244 2.02739 7.29792 2.02739 7.66102C2.02739 8.02412 2.29687 8.29361 2.6871 8.29361H6.88509V13.9983H0.00976562V11.4627Z",
          fill: e
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M23.0044 9.51853C23.6904 9.51853 24.2153 8.99356 24.2153 8.3076C24.2153 7.62165 23.6904 7.09668 23.0044 7.09668C22.3184 7.09668 21.7935 7.62165 21.7935 8.3076C21.7935 8.99356 22.3184 9.51853 23.0044 9.51853ZM23.1383 4.51384C25.4525 4.51384 27.0396 6.06074 27.0396 8.30848C27.0396 10.5562 25.4516 12.1031 23.1383 12.1031H22.3447V14H19.3174V4.51471H23.1383V4.51384Z",
          fill: e
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M20.9686 1.95988C20.9686 3.04218 20.091 3.91976 19.0087 3.91976C17.9264 3.91976 17.0488 3.04218 17.0488 1.95988C17.0488 0.87757 17.9264 0 19.0087 0C20.091 0 20.9686 0.87757 20.9686 1.95988Z",
          fill: e
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M33.2752 6.27073C33.2752 7.35304 32.3977 8.23061 31.3153 8.23061C30.233 8.23061 29.3555 7.35304 29.3555 6.27073C29.3555 5.18842 30.233 4.31085 31.3153 4.31085C32.3977 4.31085 33.2752 5.18842 33.2752 6.27073Z",
          fill: e
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M31.3905 10.3427C31.3905 11.425 30.5129 12.3026 29.4306 12.3026C28.3483 12.3026 27.4707 11.425 27.4707 10.3427C27.4707 9.26042 28.3483 8.38284 29.4306 8.38284C30.5129 8.38284 31.3905 9.26042 31.3905 10.3427Z",
          fill: e
        }
      )
    ]
  }
), nx = ({ color: e = "currentColor" }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M2.85078 14.7961V13.0889H11.9561V14.7961H2.85078ZM8.2215 8.21613C8.00809 8.42953 7.73541 8.53624 7.40344 8.53624C7.07148 8.53624 6.79879 8.42953 6.58539 8.21613C6.37198 8.00272 6.26528 7.73004 6.26528 7.39807C6.26528 7.2558 6.27713 7.1491 6.30085 7.07796L4.55803 4.69493L4.7003 4.55266L7.08333 6.29547C7.15447 6.27176 7.26117 6.25991 7.40344 6.25991C7.73541 6.25991 8.00809 6.36661 8.2215 6.58002C8.43491 6.79342 8.54161 7.0661 8.54161 7.39807C8.54161 7.73004 8.43491 8.00272 8.2215 8.21613ZM2.175 2.16963C3.62142 0.723202 5.36422 0 7.40344 0C9.44266 0 11.1855 0.723202 12.6319 2.16963C14.0783 3.61605 14.8015 5.35885 14.8015 7.39807C14.8015 9.12904 14.2799 10.6466 13.2365 11.9507H11.138L10.9958 11.8085L10.2133 11.026L11.0313 10.2079L11.8138 10.9904C12.5252 10.1368 12.9401 9.12904 13.0587 7.96715H11.9561V6.82899H13.0587C12.9401 5.66711 12.5252 4.65937 11.8138 3.80574L11.0313 4.58823L10.2133 3.77017L10.9958 2.98768C10.1421 2.27633 9.13441 1.86137 7.97252 1.74281V2.84541H6.83436V1.74281C5.67248 1.86137 4.66474 2.27633 3.81111 2.98768L4.5936 3.77017L3.77554 4.58823L2.99305 3.80574C2.2817 4.65937 1.86675 5.66711 1.74819 6.82899H2.85078V7.96715H1.74819C1.86675 9.12904 2.2817 10.1368 2.99305 10.9904L3.77554 10.2079L4.5936 11.026L3.81111 11.8085L3.66884 11.9507H1.57035C0.527025 10.6466 0.00537109 9.12904 0.00537109 7.39807C0.00537109 5.35885 0.728573 3.61605 2.175 2.16963Z",
        fill: e
      }
    )
  }
);
function Fl(e = 500) {
  const n = ee(
    void 0
  ), i = ee(), o = ee(!1), t = ee(!1), c = ee(
    void 0,
    (s, l, m, h, u) => {
      clearTimeout(s(n));
      const D = s(i), b = typeof m == "function" ? m(D) : m, C = () => {
        l(i, b), l(o, !0), l(t, !0);
      }, k = () => {
        l(c, b), l(o, !1), h == null || h();
      };
      u ? k() : C();
      const q = setTimeout(() => {
        k();
      }, e);
      q && l(n, q);
    }
  ), a = ee(null, (s, l, m) => {
    clearTimeout(s(n)), l(o, !1);
  });
  return {
    currentValueAtom: ee((s) => s(i)),
    isDebouncingAtom: o,
    clearTimeoutAtom: a,
    debouncedValueAtom: c,
    valueInitialized: t
  };
}
const {
  debouncedValueAtom: Wi,
  valueInitialized: ix,
  clearTimeoutAtom: ox
} = Fl(), {
  debouncedValueAtom: Gi,
  valueInitialized: tx,
  clearTimeoutAtom: cx
} = Fl(), qe = Ao(
  "sourceAsset",
  void 0
), vo = ee(
  (e) => {
    var n;
    return ((n = e(qe)) == null ? void 0 : n.amount) ?? "";
  },
  (e, n, i) => {
    n(qe, (o) => ({ ...o, amount: i })), n(Wi, i), n(Kn, "swap-in"), i === "" && (n(Dn, (o) => ({ ...o, amount: i })), n(Gi, i, void 0, !0));
  }
), Dn = Ao(
  "destinationAsset",
  void 0
), wt = ee(
  (e) => {
    var n;
    return ((n = e(Dn)) == null ? void 0 : n.amount) ?? "";
  },
  (e, n, i, o) => {
    n(Dn, (t) => ({ ...t, amount: i })), n(Gi, i, o), n(Kn, "swap-out"), i === "" && (n(qe, (t) => ({ ...t, amount: i })), n(Wi, i, void 0, !0));
  }
), Bl = ee(null, (e, n) => {
  n(qe, (i) => ({ ...i, amount: "" })), n(Wi, "", void 0, !0), n(Dn, (i) => ({ ...i, amount: "" })), n(Gi, "", void 0, !0);
}), ax = ee((e) => {
  const n = e(vo), i = e(wt), o = e(Wi), t = e(Gi), { isLoading: c } = e(Ji), a = e(Kn), s = n !== o, l = i !== t;
  if (a === "swap-in")
    return s || c;
  if (a === "swap-out")
    return l || c;
}), Kn = Ao(
  "swapDirection",
  "swap-in"
), ct = ee(!1), rx = ee(null, (e, n) => {
  const i = e(qe), o = e(Dn), t = e(Kn);
  n(ct, !0), n(qe, { ...o }), o != null && o.amount && n(vo, o == null ? void 0 : o.amount), n(Dn, { ...i }), i != null && i.amount && n(wt, i == null ? void 0 : i.amount, () => {
    n(Kn, t === "swap-in" ? "swap-out" : "swap-in"), n(ct, !1);
  });
}), $c = ee(), at = {
  slippage: 3,
  customGasAmount: 2e5
}, vi = Ao("swapSettingsAtom", at), sx = ee(
  (e) => e(vi).slippage,
  (e, n, i) => {
    const o = e(vi);
    n(vi, { ...o, slippage: i });
  }
), lx = es((e, n) => {
  const i = e(qe), o = e(Dn), t = e(ix), c = e(tx);
  i != null && i.amount && !t && n(Wi, i.amount), o != null && o.amount && !c && n(Gi, o.amount);
}), mx = ee((e) => {
  const n = e(qe), i = e(Dn), o = e(Kn), t = e(Wi), c = e(Gi);
  return e(lx), !(n != null && n.chainID) || !n.denom || !(i != null && i.chainID) || !i.denom ? void 0 : {
    ...o === "swap-in" ? {
      amountIn: Un(
        t ?? "0",
        n.decimals
      )
    } : {
      amountOut: Un(
        c ?? "0",
        i.decimals
      )
    },
    sourceAssetChainID: n.chainID,
    sourceAssetDenom: n.denom,
    destAssetChainID: i.chainID,
    destAssetDenom: i.denom
  };
}), Ml = ee({
  experimentalFeatures: ["hyperlane"],
  allowMultiTx: !0,
  allowUnsafe: !0,
  smartSwapOptions: {
    splitRoutes: !0,
    evmSwaps: !0
  }
}), px = pi((e) => {
  const n = e(Sn), i = e(mx), o = e(Tn), t = e(ct), c = e(_e), a = e(Ml), s = i !== void 0 && (Number(i.amountIn) > 0 || Number(i.amountOut) > 0) && !t && o === Ue.SwapPage && c === void 0;
  return {
    queryKey: ["skipRoute", i],
    queryFn: async () => {
      if (!i)
        throw new Error("No route request provided");
      try {
        return await n.route({
          ...i,
          smartRelay: !0,
          ...a
        });
      } catch (l) {
        return {
          isError: !0,
          error: l
        };
      }
    },
    retry: 1,
    enabled: s,
    refetchInterval: 1e3 * 30
  };
}), Ji = ee((e) => {
  const { data: n, isError: i, error: o, isLoading: t } = e(px), c = n, a = n;
  return c != null && c.isError ? {
    data: void 0,
    isError: !0,
    error: c.error,
    isLoading: !1
  } : {
    data: a,
    isError: i,
    error: o,
    isLoading: t
  };
}), ux = ({ color: e = "currentColor", ...n }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ r.jsxs("g", { opacity: "0.5", children: [
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M4.96253 7.13619C3.78268 7.13619 2.82646 6.17997 2.82646 5.00012C2.82646 3.82027 3.78268 2.86405 4.96253 2.86405C6.14238 2.86405 7.0986 3.82027 7.0986 5.00012C7.0986 6.17997 6.14238 7.13619 4.96253 7.13619ZM7.67865 5.79097C7.74234 5.5703 7.97633 5.44639 8.19404 5.52044L8.91626 5.7653V4.23495L8.18811 4.48178C7.97189 4.55534 7.73789 4.4334 7.67322 4.21422C7.61448 4.01478 7.53401 3.82422 7.43429 3.64552C7.32223 3.44361 7.39924 3.18937 7.60608 3.08719L8.29869 2.74508L7.21659 1.66297L6.8725 2.36002C6.77081 2.56637 6.51756 2.64388 6.31615 2.5333C6.13744 2.43506 5.9464 2.35558 5.74696 2.29782C5.52679 2.23414 5.40386 1.99965 5.47742 1.78244L5.72721 1.0459H4.19686L4.44665 1.78244C4.52021 2.00015 4.3968 2.23365 4.17662 2.29782C3.98015 2.35509 3.79255 2.43259 3.61582 2.52886C3.41638 2.63746 3.16659 2.56242 3.06341 2.36002L2.70699 1.66297L1.62489 2.74508L2.31749 3.09903C2.52039 3.2027 2.59543 3.45348 2.48534 3.65292C2.38759 3.83064 2.30811 4.01971 2.24986 4.21767C2.18519 4.43834 1.94972 4.56077 1.73251 4.48573L1.00781 4.23495V5.7653L1.72708 5.51649C1.94528 5.44096 2.18174 5.56487 2.24542 5.78702C2.30367 5.99041 2.38364 6.18442 2.48336 6.36658C2.59444 6.56898 2.51545 6.82272 2.30811 6.92392L1.62489 7.25566L2.70699 8.33777L3.03676 7.65898C3.13796 7.45066 3.39318 7.37217 3.59608 7.48472C3.77774 7.58543 3.97175 7.66688 4.17514 7.72612C4.3963 7.7903 4.51823 8.02627 4.4432 8.24348L4.19686 8.95484H5.72721L5.48087 8.24348C5.40534 8.02577 5.52827 7.7903 5.74943 7.72612C5.95133 7.66737 6.14386 7.58641 6.32454 7.48669C6.52645 7.37513 6.7797 7.45263 6.88188 7.65898L7.21708 8.33777L8.29918 7.25566L7.61695 6.91898C7.41109 6.81729 7.33309 6.56503 7.44367 6.36312C7.54191 6.18343 7.62139 5.99238 7.67865 5.79146",
          fill: e
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M7.67865 5.79097C7.74234 5.5703 7.97633 5.44639 8.19404 5.52044L8.91626 5.7653V4.23495L8.18811 4.48178C7.97189 4.55534 7.73789 4.4334 7.67322 4.21422C7.61448 4.01478 7.53401 3.82422 7.43429 3.64552C7.32223 3.44361 7.39924 3.18938 7.60608 3.08719L8.29869 2.74508L7.21659 1.66297L6.8725 2.36002C6.77081 2.56637 6.51756 2.64388 6.31615 2.5333C6.13744 2.43506 5.9464 2.35558 5.74696 2.29782C5.52679 2.23414 5.40386 1.99965 5.47742 1.78244L5.72721 1.0459H4.19686L4.44665 1.78244C4.52021 2.00015 4.3968 2.23365 4.17662 2.29782C3.98015 2.35509 3.79255 2.43259 3.61582 2.52886C3.41638 2.63746 3.16659 2.56242 3.06341 2.36002L2.70699 1.66297L1.62489 2.74508L2.31749 3.09903C2.52039 3.2027 2.59543 3.45348 2.48534 3.65292C2.38759 3.83064 2.30811 4.01971 2.24986 4.21767C2.18519 4.43834 1.94972 4.56077 1.73251 4.48573L1.00781 4.23495V5.7653L1.72708 5.51649C1.94528 5.44096 2.18174 5.56487 2.24542 5.78702C2.30367 5.99041 2.38364 6.18442 2.48336 6.36658C2.59444 6.56898 2.51545 6.82272 2.30811 6.92392L1.62489 7.25566L2.70699 8.33777L3.03676 7.65898C3.13796 7.45066 3.39318 7.37217 3.59608 7.48472C3.77774 7.58543 3.97175 7.66688 4.17514 7.72612C4.3963 7.7903 4.51823 8.02627 4.4432 8.24348L4.19686 8.95484H5.72721L5.48087 8.24348C5.40534 8.02577 5.52827 7.7903 5.74943 7.72612C5.95133 7.66737 6.14386 7.58641 6.32454 7.48669C6.52645 7.37513 6.7797 7.45263 6.88188 7.65898L7.21708 8.33777L8.29918 7.25566L7.61695 6.91898C7.41109 6.81729 7.33309 6.56503 7.44367 6.36312C7.54191 6.18343 7.62139 5.99238 7.67865 5.79146M4.96253 7.13619C3.78268 7.13619 2.82646 6.17997 2.82646 5.00012C2.82646 3.82027 3.78268 2.86405 4.96253 2.86405C6.14238 2.86405 7.0986 3.82027 7.0986 5.00012C7.0986 6.17997 6.14238 7.13619 4.96253 7.13619Z",
          stroke: e,
          strokeWidth: "0.3"
        }
      )
    ] })
  }
), jl = ({
  rightContent: e = null,
  showRouteInfo: n,
  showEstimatedTime: i
}) => {
  const { data: o, isLoading: t } = X(Ji), c = X(vi), a = K(() => c.slippage !== at.slippage || c.customGasAmount !== at.customGasAmount, [c]), s = El(
    o == null ? void 0 : o.estimatedRouteDurationSeconds
  ), l = K(() => {
    if (e) return e;
    if (!t && n && o)
      return /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 8, children: [
        (o == null ? void 0 : o.txsRequired) > 1 && /* @__PURE__ */ r.jsx(U, { gap: 4, align: "center", children: /* @__PURE__ */ r.jsxs(zl, { gap: 5, align: "center", children: [
          /* @__PURE__ */ r.jsx(Qc, {}),
          o == null ? void 0 : o.txsRequired,
          " ",
          ao("Signature", o == null ? void 0 : o.txsRequired),
          " required"
        ] }) }),
        i && s && /* @__PURE__ */ r.jsxs(U, { gap: 6, align: "center", children: [
          /* @__PURE__ */ r.jsx(nx, {}),
          s,
          /* @__PURE__ */ r.jsxs(hx, { children: [
            /* @__PURE__ */ r.jsx(ux, { height: 13, width: 13 }),
            a && /* @__PURE__ */ r.jsx(dx, {})
          ] })
        ] })
      ] });
  }, [
    s,
    t,
    e,
    o,
    i,
    n,
    a
  ]);
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 5, children: [
      "Powered by ",
      /* @__PURE__ */ r.jsx(Pl, {})
    ] }),
    l
  ] });
}, ea = ({
  onClick: e,
  rightContent: n,
  showRouteInfo: i,
  showEstimatedTime: o,
  ...t
}) => /* @__PURE__ */ r.jsx(
  li,
  {
    gap: 5,
    justify: "space-between",
    onClick: e,
    ...t,
    children: /* @__PURE__ */ r.jsx(
      jl,
      {
        rightContent: n,
        showRouteInfo: i,
        showEstimatedTime: o
      }
    )
  }
), zl = V(U)`
  ${({ theme: e }) => `color: ${e.warning.text}`};
`, hx = V.div`
  position: relative;
  display: inline-block;
`, dx = V.div`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 4px;
  height: 4px;
  background-color: white;
  border-radius: 50%;
`, qi = ({
  leftContent: e,
  rightContent: n,
  onClick: i,
  style: o
}) => /* @__PURE__ */ r.jsxs(
  xx,
  {
    as: "button",
    align: "center",
    justify: "space-between",
    onClick: i,
    gap: 16,
    style: o,
    children: [
      typeof e == "string" ? /* @__PURE__ */ r.jsx(Pe, { fontSize: 20, children: e }) : e,
      typeof n == "string" ? /* @__PURE__ */ r.jsx(Pe, { fontSize: 20, children: n }) : n
    ]
  }
), xx = V(U)`
  ${Co};
  width: 100%;
  height: 60px;
  border-radius: 12px;
  padding: 12px 15px;
  ${({ theme: e }) => `background-color: ${e.secondary.background.normal}`};

  ${({ onClick: e, theme: n }) => e && He`
      &:hover, &:focus {
        background-color: ${n.secondary.background.hover};
        cursor: pointer;
      }
    `};
`, na = ({
  listItems: e,
  height: n,
  itemHeight: i,
  renderItem: o,
  itemKey: t,
  className: c,
  empty: a
}) => {
  const s = ke(), [l, m] = be(), h = yc(null);
  return Xe(() => {
    var C, k, q;
    const u = (q = (k = (C = h.current) == null ? void 0 : C.nativeElement) == null ? void 0 : k.getElementsByClassName("rc-virtual-list-holder-inner")) == null ? void 0 : q[0], D = u == null ? void 0 : u.firstChild, b = (E) => {
      if (E.key === "ArrowDown") {
        D && (D.focus(), m(D)), E.preventDefault();
        const x = l == null ? void 0 : l.nextElementSibling;
        x && (x.focus(), m(x));
      } else if (E.key === "ArrowUp") {
        E.preventDefault();
        const x = l == null ? void 0 : l.previousElementSibling;
        x && (m(x), x.focus());
      }
    };
    return document.addEventListener("keydown", b), () => {
      document.removeEventListener("keydown", b);
    };
  }, [l, e.length]), Xe(() => {
    setTimeout(() => {
      var u;
      (u = h.current) == null || u.scrollTo(0);
    }, 0);
  }, [e.length]), e.length === 0 ? /* @__PURE__ */ r.jsx(Dx, { align: "center", justify: "center", children: /* @__PURE__ */ r.jsxs(gx, { gap: 10, children: [
    a == null ? void 0 : a.icon,
    /* @__PURE__ */ r.jsx(G, { fontSize: 22, children: a == null ? void 0 : a.header }),
    /* @__PURE__ */ r.jsx(fx, { children: a == null ? void 0 : a.details })
  ] }) }) : /* @__PURE__ */ r.jsx(
    dp,
    {
      ref: h,
      data: e,
      height: n,
      itemHeight: i,
      itemKey: t,
      virtual: !0,
      className: c,
      styles: {
        verticalScrollBar: {
          backgroundColor: "transparent",
          visibility: "visible"
        },
        verticalScrollBarThumb: {
          backgroundColor: qc(s.primary.text.normal) + sn(50)
        }
      },
      children: (u, D) => o(u, D)
    }
  );
}, Dx = V(re)`
  height: 100%;
  width: 100%;
`, gx = V(re)`
  width: 50%;
  text-align: center;
  align-items: center;
  justify-content: center;
`, fx = V(G)`
  white-space: pre-line;
`, Xn = Dl(
  "transactionHistory",
  []
), ql = ee(
  null,
  (e, n, i, o) => {
    const t = e(Xn), c = (t == null ? void 0 : t[i]) ?? {}, a = t;
    a[i] = { ...c, ...o }, n(Xn, a);
  }
), bx = ee(
  null,
  (e, n, i) => {
    const o = e(Xn);
    if (!o || i < 0 || i >= o.length) return;
    const t = o.filter((c, a) => a !== i);
    n(Xn, t);
  }
);
pi((e) => {
  const n = e(Sn), i = e(Xn), o = i.find(
    (t) => t.status !== "completed" && t.status !== "failed"
  );
  return {
    queryKey: ["skipPendingTxHistoryStatus", i],
    queryFn: async () => i.map(
      async (c) => await Promise.all(
        c.transactionDetails.map(
          async (s) => c.status !== "completed" && c.status !== "failed" ? await n.transactionStatus({
            chainID: s.chainID,
            txHash: s.txHash
          }) : new Promise((l) => l(null))
        )
      )
    ),
    enabled: !!o,
    refetchInterval: 1e3 * 2,
    keepPreviousData: !0
  };
});
function Ax(e) {
  return !!(e instanceof Error && // keplr | metamask
  (e.message.toLowerCase().includes("rejected") || // leap
  e.message.toLowerCase().includes("declined") || e.message.toLowerCase().includes("denied") || // @ts-expect-error common user rejected request error code
  e.code === 4001));
}
const Cx = ({ chainID: e, txHash: n, chainType: i }) => {
  var o, t, c, a;
  if (i)
    switch (i) {
      case "cosmos": {
        const s = Tu.find((u) => u.chainId === e), m = ((o = s == null ? void 0 : s.explorers) == null ? void 0 : o.find((u) => u.kind === "mintscan")) || ((t = s == null ? void 0 : s.explorers) == null ? void 0 : t[0]);
        return (c = m == null ? void 0 : m.tx_page) == null ? void 0 : c.replace("${txHash}", n);
      }
      case "evm": {
        const s = Wc.chains.find((m) => m.id === Number(e)), l = (a = s == null ? void 0 : s.blockExplorers) == null ? void 0 : a.default.url;
        return l ? `${l}/tx/${n}` : void 0;
      }
      case "svm":
        return `https://solscan.io/tx/${n}`;
      default:
        return;
    }
}, En = ee({}), pn = Ao(
  "swapExecutionState",
  {
    route: void 0,
    userAddresses: [],
    transactionDetailsArray: [],
    transactionHistoryIndex: 0,
    overallStatus: "unconfirmed",
    isValidatingGasBalance: void 0
  }
), so = ee(null, (e, n, i) => {
  n(pn, (o) => ({ ...o, overallStatus: i }));
}), kx = ee(null, (e, n) => {
  const { data: i } = e(Ji), { data: o } = e(Te), c = e(Xn).length;
  i && (n(pn, {
    userAddresses: [],
    transactionDetailsArray: [],
    route: i,
    transactionHistoryIndex: c,
    overallStatus: "unconfirmed",
    isValidatingGasBalance: void 0
  }), n(Il, {
    onTransactionUpdated: (a) => {
      a.isTxCompleted || n(Ir, a, c);
    },
    onTransactionSigned: async (a) => {
      const s = o == null ? void 0 : o.find((m) => m.chainID === a.chainID), l = Cx({ chainID: a.chainID, chainType: s == null ? void 0 : s.chainType, txHash: a.txHash });
      n(Ir, { ...a, explorerLink: l, status: void 0 }, c);
    },
    onError: (a, s) => {
      const l = s == null ? void 0 : s[(s == null ? void 0 : s.length) - 1];
      Ax(a) ? n(_e, {
        errorType: Le.AuthFailed,
        onClickBack: () => {
          n(so, "unconfirmed");
        }
      }) : l != null && l.explorerLink ? n(_e, {
        errorType: Le.TransactionFailed,
        onClickBack: () => {
          n(so, "unconfirmed");
        },
        explorerLink: (l == null ? void 0 : l.explorerLink) ?? "",
        transactionHash: (l == null ? void 0 : l.txHash) ?? "",
        onClickContactSupport: () => {
          window.open("https://skip.build/discord", "_blank");
        }
      }) : n(_e, {
        errorType: Le.Unexpected,
        error: a,
        onClickBack: () => {
          n(so, "unconfirmed");
        }
      });
    },
    onValidateGasBalance: async (a) => {
      n(vx, a);
    }
  }));
}), vx = ee(null, (e, n, i) => {
  n(pn, (o) => ({ ...o, isValidatingGasBalance: i }));
}), Ir = ee(
  null,
  (e, n, i, o) => {
    const t = e(pn), { transactionDetailsArray: c, route: a } = t, s = c, l = s.findIndex(
      (m) => m.txHash.toLowerCase() === i.txHash.toLowerCase()
    );
    l !== -1 ? s[l] = {
      ...s[l],
      ...i
    } : s.push(i), n(pn, {
      ...t,
      transactionDetailsArray: s
    }), n(ql, o, {
      route: a,
      transactionDetails: s,
      timestamp: Date.now(),
      status: "unconfirmed"
    });
  }
), wx = es((e, n) => {
  const i = e(En);
  if (!Object.values(i).every(
    (t) => !!t.address
  ))
    return;
  const o = Object.values(i).map((t) => ({
    chainID: t.chainID,
    address: t.address
  }));
  n(pn, (t) => ({
    ...t,
    userAddresses: o
  }));
}), Il = ee(), Sl = Ym((e) => {
  const n = e(Sn), { route: i, userAddresses: o, transactionDetailsArray: t } = e(pn), c = e(Il), a = e(vi);
  return {
    gcTime: 1 / 0,
    mutationFn: async () => {
      var s;
      if (i && o.length) {
        try {
          await n.executeRoute({
            route: i,
            userAddresses: o,
            slippageTolerancePercent: a.slippage.toString(),
            validateGasBalance: i.sourceAssetChainID !== "984122",
            getFallbackGasAmount: async (l, m) => {
              if (m === "cosmos")
                return a.customGasAmount;
            },
            onValidateGasBalance: async (l) => {
              var m;
              (m = c == null ? void 0 : c.onValidateGasBalance) == null || m.call(
                c,
                l
              );
            },
            onTransactionSigned: async (l) => {
              var m;
              (m = c == null ? void 0 : c.onTransactionSigned) == null || m.call(
                c,
                l
              );
            },
            onTransactionCompleted: async (l, m, h) => {
              var u;
              (u = c == null ? void 0 : c.onTransactionUpdated) == null || u.call(c, {
                chainID: l,
                txHash: m,
                status: h,
                isTxCompleted: !0
              });
            }
          });
        } catch (l) {
          console.error(l), (s = c == null ? void 0 : c.onError) == null || s.call(c, l, t);
        }
        return null;
      }
    },
    onError: (s) => {
      var l;
      console.error(s), (l = c == null ? void 0 : c.onError) == null || l.call(c, s, t);
    }
  };
}), yx = [
  "90u-4",
  "FUND-MainNet-2",
  "HICKORY",
  "HoneyWood",
  "LumenX",
  "Neutaro-1",
  "ShareRing-VoyagerNet",
  "agoric-3",
  "aioz_168-1",
  "akashnet-2",
  "alfama",
  "arctic-1",
  "ares-1",
  "arkeo",
  "athens_7001-1",
  "atlantic-2",
  "axelar-dojo-1",
  "axelar-testnet-lisbon-3",
  "band-laozi-testnet6",
  "banksy-testnet-5",
  "bbn-dev-5",
  "bbn-test-3",
  "berberis-1",
  "birdee-1",
  "bitcanna-1",
  "blockx_100-1",
  "bluechip-2",
  "bluzelle-testnet-10",
  "bluzelle-9",
  "bostrom",
  "bouachain",
  "buenavista-1",
  "bzetestnet-2",
  "celestia",
  "chihuahua-1",
  "cifer-2",
  "cnho_stables-1",
  "colosseum-1",
  "columbus-5",
  "comdex-test-4",
  "constantine-3",
  "core-1",
  "coreum-testnet-1",
  "cosmoshub-4",
  "coss-1",
  "crossfi-evm-testnet-1",
  "crypto-org-chain-mainnet-1",
  "cudos-1",
  "cvm_323-1",
  "cvn_2032-1",
  "desmos-mainnet",
  "developer",
  "dimension_37-1",
  "dydx-mainnet-1",
  "dydx-testnet-4",
  "dymension_1100-1",
  "dyson-mainnet-01",
  "earendel-1",
  "ebony-2",
  "elgafar-1",
  "elystestnet-1",
  "emoney-3",
  "empe-testnet-2",
  "entrypoint-pubtest-2",
  "evmos_9001-2",
  "fairyring-testnet-1",
  "fiamma-testnet-1",
  "finschia-2",
  "fivenet",
  "froopyland_100-1",
  "furya-1",
  "fxcore",
  "galactica_9302-1",
  "govgen-1",
  "grand-1",
  "helichain",
  "iconlake-testnet-1",
  "iconlake-1",
  "indigo-1",
  "initiation-1",
  "injective-888",
  "injective-1",
  "inns-1",
  "iov-mainnet-ibc",
  "irishub-1",
  "ixo-5",
  "joltify_1729-1",
  "juno-1",
  "kaon-1",
  "kava_2222-10",
  "korellia-2",
  "kyve-1",
  "lambda_92000-1",
  "laozi-mainnet",
  "lava-mainnet-1",
  "lava-testnet-2",
  "likecoin-mainnet-2",
  "likecoin-public-testnet-5",
  "loop-1",
  "mainnet-tura",
  "mande_18071918-1",
  "mantra-hongbai-1",
  "mars-1",
  "medasdigital-1",
  "meme-1",
  "mineplex-mainnet-1",
  "mocha-4",
  "morocco-1",
  "mutelandia1",
  "neutron-1",
  "nibiru-devnet-1",
  "nibiru-testnet-1",
  "nillion-chain-testnet-1",
  "nim_1122-1",
  "noble-1",
  "nubit-alphatestnet-1",
  "omniflixhub-1",
  "osmo-test-5",
  "osmosis-1",
  "ovg",
  "panacea-3",
  "passage-2",
  "phoenix-1",
  "pio-testnet-1",
  "pion-1",
  "planq_7077-1",
  "poktroll",
  "provider",
  "pryzm-1",
  "pulsar-3",
  "quasar-1",
  "quicksilver-2",
  "qwoyn-1",
  "realionetwork_3300-3",
  "realionetwork_3301-1",
  "reapchain_221230-1",
  "regen-1",
  "router_9600-1",
  "scorum-1",
  "secret-4",
  "seda-1-testnet",
  "seda-1",
  "sentinelhub-2",
  "sge-network-4",
  "sgenet-1",
  "shido_9007-1",
  "sixnet",
  "soarchaintestnet",
  "sommelier-3",
  "sourcetest-1",
  "ssc-testnet-2",
  "ssc-1",
  "stafihub-1",
  "stargaze-1",
  "stratos-1",
  "stride-internal-1",
  "stride-1",
  "stwart_test_1",
  "stwart_testnet_1",
  "swisstronik_1291-1",
  "symphony-testnet-3",
  "synternet-1",
  "tenet_1559-1",
  "test-core-2",
  "tgrade-mainnet-1",
  "theta-testnet-001",
  "titan-test-3",
  "titan_18889-1",
  "tucana_712-1",
  "tumbler",
  "umee-1",
  "unicorn-420",
  "union-testnet-8",
  "uptick_117-1",
  "wormchain",
  "xion-testnet-1",
  "yulei-2.1",
  "zetachain_7000-1"
], Ex = [
  "cosmoshub-4",
  "injective-1",
  "pacific-1",
  "noble-1",
  "osmosis-1",
  "neutron-1",
  "pryzm-1",
  "axelar-dojo-1",
  "chihuahua-1"
], Px = {
  [we.KEPLR]: {
    name: "Keplr",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-keplr.png"
  },
  [we.LEAP]: {
    name: "Leap",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-leap.png"
  },
  [we.COSMOSTATION]: {
    name: "Cosmostation",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-cosmostation.png"
  },
  [we.VECTIS]: {
    name: "Vectis",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-vectis.svg"
  },
  [we.STATION]: {
    name: "Station",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-station.svg"
  },
  [we.XDEFI]: {
    name: "XDefi",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-xdefi.jpeg"
  },
  [we.METAMASK_SNAP_LEAP]: {
    name: "Metamask Snap Leap",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-metamask.png"
  },
  [we.METAMASK_SNAP_COSMOS]: {
    name: "Metamask Snap Cosmos",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-metamask.png"
  },
  [we.WALLETCONNECT]: {
    name: "WalletConnect",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-walletconnect.png"
  },
  [we.WC_KEPLR_MOBILE]: {
    name: "Keplr Mobile",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-keplr.png",
    mobile: !0
  },
  [we.WC_LEAP_MOBILE]: {
    name: "Leap Mobile",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-leap.png",
    mobile: !0
  },
  [we.WC_COSMOSTATION_MOBILE]: {
    name: "Cosmostation Mobile",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-cosmostation.png",
    mobile: !0
  },
  [we.CAPSULE]: {
    name: "Capsule",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-capsule.jpg"
  },
  [we.COSMIFRAME]: {
    name: "DAO DAO",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-daodao.png"
  },
  [we.COMPASS]: {
    name: "Compass",
    imgSrc: "https://raw.githubusercontent.com/graz-sh/graz/dev/example/starter/public/assets/wallet-icon-compass.png"
  }
}, Hl = (e) => Px[e], hi = () => {
  const e = X(Nc), [n, i] = ue(Sc), [o, t] = ue(Hc), [c, a] = ue(Tc), { data: s } = X(Te), { data: l, walletType: m } = Yr({
    multiChain: !0
  }), h = Gc.find(
    (C) => {
      var k;
      return C.name === ((k = e.svm) == null ? void 0 : k.walletName);
    }
  ), u = pt(), D = _r();
  return ze(
    // if checkChainType is true, it only check wallet connected no chainId is dependent
    (C, k) => {
      var g, M;
      const q = (g = s == null ? void 0 : s.find((H) => H.chainID === C)) == null ? void 0 : g.chainType;
      switch (q) {
        case "cosmos":
          m && o === void 0 && t({
            walletName: m,
            chainType: "cosmos"
          });
          break;
        case "svm":
          h && c === void 0 && a({
            walletName: h.name,
            chainType: "svm"
          });
          break;
        case "evm":
          u.connector && n === void 0 && i({
            walletName: u.connector.id,
            chainType: "evm"
          });
          break;
      }
      const x = (() => {
        if (!(!l || !C))
          return l[C];
      })();
      switch (q) {
        case "cosmos": {
          if (!x || !e.cosmos) return;
          const H = Hl(
            e.cosmos.walletName
          );
          return {
            address: x.bech32Address,
            chainType: q,
            wallet: {
              name: e.cosmos.walletName,
              prettyName: H.name,
              logo: H.imgSrc,
              isLedger: x.isNanoLedger
            }
          };
        }
        case "evm":
          return !e.evm || u.chainId !== Number(C) && !k || !u.address || !u.connector ? void 0 : {
            address: u.address,
            currentConnectedEVMChainId: String(u.chainId),
            chainType: q,
            wallet: {
              name: u.connector.id,
              prettyName: u.connector.name,
              logo: (M = D.find(
                (H) => {
                  var P;
                  return H.id === ((P = u.connector) == null ? void 0 : P.id);
                }
              )) == null ? void 0 : M.icon
            }
          };
        case "svm":
          return !e.svm || !(h != null && h.publicKey) ? void 0 : {
            address: h.publicKey.toBase58(),
            chainType: q,
            wallet: {
              name: h.name,
              prettyName: h.name,
              logo: h.icon
            }
          };
        default:
          return;
      }
    },
    [
      s,
      m,
      o,
      h,
      c,
      u.connector,
      u.chainId,
      u.address,
      n,
      t,
      a,
      i,
      l,
      e.evm,
      e.cosmos,
      e.svm,
      D
    ]
  );
}, Sr = ({
  denom: e,
  tokenAmount: n,
  chainId: i,
  status: o,
  onClickEditDestinationWallet: t,
  explorerLink: c,
  isSignRequired: a,
  index: s,
  context: l,
  ...m
}) => {
  var E;
  const h = ke(), u = en({
    assetDenom: e,
    chainId: i,
    tokenAmount: n
  }), D = X(En), C = hi()(i), k = K(() => {
    const x = Object.values(D);
    switch (l) {
      case "source":
        return {
          address: C == null ? void 0 : C.address,
          image: C == null ? void 0 : C.wallet.logo
        };
      case "intermediary": {
        const g = Object.values(D).find(
          (M) => M.chainID === i
        );
        return {
          address: g == null ? void 0 : g.address,
          image: (g == null ? void 0 : g.source) === "wallet" && g.wallet.walletInfo.logo || void 0
        };
      }
      case "destination": {
        const g = x[x.length - 1];
        return {
          address: g == null ? void 0 : g.address,
          image: (g == null ? void 0 : g.source) === "wallet" && g.wallet.walletInfo.logo || void 0
        };
      }
    }
  }, [
    C == null ? void 0 : C.address,
    C == null ? void 0 : C.wallet.logo,
    D,
    i,
    l
  ]), q = K(() => {
    const x = l === "destination" && t, g = x ? ({ children: M }) => /* @__PURE__ */ r.jsx(U, { gap: 5, children: M }) : $e.Fragment;
    if (k.address)
      return /* @__PURE__ */ r.jsxs(g, { children: [
        /* @__PURE__ */ r.jsxs(Bx, { onClick: () => vt(k.address), children: [
          k.image && /* @__PURE__ */ r.jsx(
            "img",
            {
              src: k.image,
              style: {
                height: "100%"
              }
            }
          ),
          /* @__PURE__ */ r.jsx(Fx, { title: k.address, monospace: !0, children: zi(k.address) })
        ] }),
        x && /* @__PURE__ */ r.jsx(xn, { align: "center", onClick: t, children: /* @__PURE__ */ r.jsx(_c, { color: h.primary.text.lowContrast }) })
      ] });
  }, [
    l,
    t,
    k.address,
    k.image,
    h.primary.text.lowContrast
  ]);
  return /* @__PURE__ */ r.jsxs(U, { gap: 15, align: "center", ...m, children: [
    (u == null ? void 0 : u.assetImage) && /* @__PURE__ */ r.jsx(
      yt,
      {
        width: 30,
        height: 30,
        backgroundColor: h.success.text,
        status: o,
        children: /* @__PURE__ */ r.jsx(
          jx,
          {
            height: 30,
            width: 30,
            src: u.assetImage,
            title: (E = u == null ? void 0 : u.asset) == null ? void 0 : E.name
          }
        )
      }
    ),
    /* @__PURE__ */ r.jsx(
      re,
      {
        style: {
          flex: 1
        },
        justify: "space-between",
        children: /* @__PURE__ */ r.jsxs(U, { align: "center", justify: "space-between", children: [
          /* @__PURE__ */ r.jsxs(re, { children: [
            /* @__PURE__ */ r.jsxs(U, { gap: 5, children: [
              /* @__PURE__ */ r.jsx(Ix, { normalTextColor: !0, title: u == null ? void 0 : u.amount, children: u == null ? void 0 : u.amount }),
              /* @__PURE__ */ r.jsx(Mx, { normalTextColor: !0, children: u == null ? void 0 : u.symbol }),
              /* @__PURE__ */ r.jsxs(Sx, { title: u == null ? void 0 : u.chainName, children: [
                " ",
                "on ",
                u == null ? void 0 : u.chainName
              ] }),
              c && /* @__PURE__ */ r.jsx(tt, { href: c, target: "_blank", children: /* @__PURE__ */ r.jsx(G, { children: /* @__PURE__ */ r.jsx(mi, {}) }) })
            ] }),
            " ",
            a && /* @__PURE__ */ r.jsx(G, { color: h.warning.text, children: "Signature required" })
          ] }),
          q
        ] })
      }
    )
  ] });
}, Fx = V(G)`
  text-transform: lowercase;
`, Bx = V(xn)`
  padding: 5px 8px;
  height: 28px;
  border-radius: 30px;
  box-sizing: border-box;
  background-color: ${({ theme: e }) => e.secondary.background.normal};
  gap: 4px;
  align-items: center;
`, Mx = V(G)`
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
`, jx = V.img`
  border-radius: 50%;
  box-sizing: content-box;
`, yt = ({
  backgroundColor: e,
  children: n,
  width: i,
  height: o,
  borderSize: t = 2,
  status: c
}) => /* @__PURE__ */ r.jsx(
  zx,
  {
    align: "center",
    justify: "center",
    width: i,
    height: o,
    borderSize: t,
    status: c,
    backgroundColor: e,
    children: /* @__PURE__ */ r.jsx(
      qx,
      {
        className: "overlay",
        justify: "space-between",
        width: i,
        height: o,
        backgroundColor: e,
        children: n
      }
    )
  }
), zx = V(U)`
  position: relative;
  overflow: hidden;
  height: ${({ height: e, borderSize: n }) => e + n * 2}px;
  width: ${({ width: e, borderSize: n }) => e + n * 2}px;
  ${({ status: e, borderSize: n, theme: i }) => {
  switch (e) {
    case "completed":
      return `border: ${n}px solid ${i.success.text}`;
    case "failed":
      return `border: ${n}px solid ${i.error.text}`;
    default:
      return "";
  }
}};
  border-radius: 50%;

  &:before {
    content: '';
    position: absolute;
    height: ${({ height: e }) => `${e + 20}px;`};
    width: ${({ width: e }) => `${e + 20}px;`};
    ${({ status: e, backgroundColor: n, theme: i }) => e === "pending" && He`
        background-image: conic-gradient(
          transparent,
          transparent,
          transparent,
          ${n ?? i.success.text}
        );
        animation: rotate 4s linear infinite;
      `};
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`, qx = V(U)`
  width: ${({ width: e }) => e}px;
  height: ${({ height: e }) => e}px;
  position: absolute;
  border-radius: 50%;
  background-color: ${({ theme: e }) => e.primary.background.normal};
`, Ix = V(G)`
  max-width: 90px;
  text-overflow: ellipsis;
  overflow: hidden;
`, Sx = V(G)`
  max-width: 95px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`, ia = ({
  title: e,
  onClickBackButton: n,
  rightContent: i
}) => {
  const o = ke();
  return /* @__PURE__ */ r.jsxs(Hx, { align: "center", justify: "space-between", children: [
    /* @__PURE__ */ r.jsx(xn, { onClick: () => n(), children: /* @__PURE__ */ r.jsx(
      Tx,
      {
        color: o == null ? void 0 : o.primary.background.normal,
        backgroundColor: o == null ? void 0 : o.primary.text.normal
      }
    ) }),
    /* @__PURE__ */ r.jsx(Nx, { textAlign: "center", children: e }),
    i == null ? void 0 : i()
  ] });
}, Tl = V(re)`
  position: relative;
  padding: 10px;
  gap: 10px;
  width: 580px;
  border-radius: 20px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
  overflow: hidden;
`, Nl = V(re)`
  height: ${({ height: e }) => e}px;
  width: 100%;
  align-items: center;
  justify-content: center;
`, Hx = V(U)`
  height: 40px;
  margin-top: 10px;
  padding: 0 12px;
`, Tx = V(Yc)`
  opacity: 0.2;
`, Nx = V(Pe)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
`, Vx = (e) => e.onSelect !== void 0, Ho = (e) => e.connect !== void 0, Hr = 60, To = 5, Vl = ({
  title: e,
  walletList: n,
  onClickBackButton: i,
  isDestinationAddress: o,
  chainId: t,
  chainType: c,
  isConnectEco: a,
  chainAddressIndex: s
}) => {
  var q, E;
  const l = ke(), m = Je(), h = Z(En), u = Z(Bl), D = Xm({
    mutationKey: ["connectWallet"],
    mutationFn: async (x) => {
      var g;
      if (o) {
        if (!t || !c) return;
        const M = await ((g = x.getAddress) == null ? void 0 : g.call(x, {}));
        return h((H) => {
          const P = s || Object.values(H).length - 1;
          return {
            ...H,
            [P]: {
              chainID: t,
              chainType: c,
              address: M,
              source: "wallet",
              wallet: {
                walletName: x.walletName,
                walletPrettyName: x.walletPrettyName,
                walletChainType: x.walletChainType,
                walletInfo: x.walletInfo
              }
            }
          };
        }), null;
      }
      return a ? await x.connectEco() : await x.connect();
    },
    onSuccess: () => {
      a && u(), m.remove();
    }
  }), b = ze(
    (x) => {
      const g = Ho(x) ? x.walletPrettyName ?? x.walletName : x.walletName, M = Ho(x) ? x.walletInfo.logo : void 0, H = Vx(x) ? x.rightContent : void 0, P = Ho(x) ? x.isAvailable : void 0, S = () => {
        Ho(x) ? D.mutate(x) : x.onSelect();
      };
      return x.walletName === "prax" ? /* @__PURE__ */ r.jsx(
        qi,
        {
          onClick: S,
          style: { marginTop: To },
          leftContent: /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 10, children: [
            M && /* @__PURE__ */ r.jsx(
              "img",
              {
                height: 35,
                width: 35,
                style: { objectFit: "cover" },
                src: M,
                alt: `${g} logo`
              }
            ),
            /* @__PURE__ */ r.jsx(Pe, { children: g })
          ] }),
          rightContent: H == null ? void 0 : H()
        },
        g
      ) : /* @__PURE__ */ r.jsx(
        qi,
        {
          onClick: S,
          style: { marginTop: To },
          leftContent: /* @__PURE__ */ r.jsxs(U, { style: { width: "100%" }, align: "center", justify: "space-between", children: [
            /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 10, children: [
              M && /* @__PURE__ */ r.jsx(
                "img",
                {
                  height: 35,
                  width: 35,
                  style: { objectFit: "cover" },
                  src: M,
                  alt: `${g} logo`
                }
              ),
              /* @__PURE__ */ r.jsx(Pe, { children: g })
            ] }),
            P !== void 0 && /* @__PURE__ */ r.jsx(G, { children: P ? "Installed" : "Not Installed" })
          ] }),
          rightContent: H == null ? void 0 : H()
        },
        g
      );
    },
    [D]
  ), C = K(() => Math.min(530, n.length * (Hr + To)), [n]), k = K(() => {
    var x, g, M;
    if (D.isError || D.isPending) {
      const H = D.isError ? "Failed to connect" : "Connecting to";
      return /* @__PURE__ */ r.jsx(Nl, { height: C, children: /* @__PURE__ */ r.jsxs(Rx, { children: [
        /* @__PURE__ */ r.jsx(
          yt,
          {
            width: 80,
            height: 80,
            backgroundColor: l.primary.text.normal,
            status: D.isError ? "failed" : "pending",
            borderSize: 8,
            children: /* @__PURE__ */ r.jsx(
              "img",
              {
                style: { objectFit: "cover" },
                src: (x = D.variables) == null ? void 0 : x.walletInfo.logo,
                alt: `${(g = D.variables) == null ? void 0 : g.walletPrettyName} logo`
              }
            )
          }
        ),
        /* @__PURE__ */ r.jsxs(Pe, { color: l.primary.text.lowContrast, children: [
          H,
          " ",
          (M = D.variables) == null ? void 0 : M.walletPrettyName
        ] }),
        D.error && /* @__PURE__ */ r.jsx(
          Pe,
          {
            textAlign: "center",
            fontSize: 14,
            color: l.primary.text.lowContrast,
            children: D.error.message
          }
        )
      ] }) });
    }
    return /* @__PURE__ */ r.jsx(
      na,
      {
        listItems: n,
        height: C,
        itemHeight: Hr + To,
        renderItem: b,
        itemKey: (H) => H.walletName,
        empty: {
          header: "No wallets available"
        }
      }
    );
  }, [
    D.error,
    D.isError,
    D.isPending,
    (q = D.variables) == null ? void 0 : q.walletInfo.logo,
    (E = D.variables) == null ? void 0 : E.walletPrettyName,
    C,
    b,
    l.primary.text.lowContrast,
    l.primary.text.normal,
    n
  ]);
  return /* @__PURE__ */ r.jsxs(Tl, { gap: 15, children: [
    /* @__PURE__ */ r.jsx(
      ia,
      {
        title: e,
        onClickBackButton: D.isPending || D.isError ? D.reset : i
      }
    ),
    k
  ] });
}, Rx = V(re)`
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding-bottom: 10px;
`;
var Rl = {}, Ii = {};
Object.defineProperty(Ii, "__esModule", { value: !0 });
Ii.fromAscii = Ii.toAscii = void 0;
function Lx(e) {
  const n = (i) => i.split("").map((o) => {
    const t = o.charCodeAt(0);
    if (t < 32 || t > 126)
      throw new Error("Cannot encode character that is out of printable ASCII range: " + t);
    return t;
  });
  return Uint8Array.from(n(e));
}
Ii.toAscii = Lx;
function Ox(e) {
  return ((i) => i.map((o) => {
    if (o < 32 || o > 126)
      throw new Error("Cannot decode character that is out of printable ASCII range: " + o);
    return String.fromCharCode(o);
  }))(Array.from(e)).join("");
}
Ii.fromAscii = Ox;
var Si = {}, Et = {};
Et.byteLength = Gx;
Et.toByteArray = Kx;
Et.fromByteArray = Yx;
var kn = [], an = [], Ux = typeof Uint8Array < "u" ? Uint8Array : Array, Zt = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var fi = 0, Wx = Zt.length; fi < Wx; ++fi)
  kn[fi] = Zt[fi], an[Zt.charCodeAt(fi)] = fi;
an[45] = 62;
an[95] = 63;
function Ll(e) {
  var n = e.length;
  if (n % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var i = e.indexOf("=");
  i === -1 && (i = n);
  var o = i === n ? 0 : 4 - i % 4;
  return [i, o];
}
function Gx(e) {
  var n = Ll(e), i = n[0], o = n[1];
  return (i + o) * 3 / 4 - o;
}
function Jx(e, n, i) {
  return (n + i) * 3 / 4 - i;
}
function Kx(e) {
  var n, i = Ll(e), o = i[0], t = i[1], c = new Ux(Jx(e, o, t)), a = 0, s = t > 0 ? o - 4 : o, l;
  for (l = 0; l < s; l += 4)
    n = an[e.charCodeAt(l)] << 18 | an[e.charCodeAt(l + 1)] << 12 | an[e.charCodeAt(l + 2)] << 6 | an[e.charCodeAt(l + 3)], c[a++] = n >> 16 & 255, c[a++] = n >> 8 & 255, c[a++] = n & 255;
  return t === 2 && (n = an[e.charCodeAt(l)] << 2 | an[e.charCodeAt(l + 1)] >> 4, c[a++] = n & 255), t === 1 && (n = an[e.charCodeAt(l)] << 10 | an[e.charCodeAt(l + 1)] << 4 | an[e.charCodeAt(l + 2)] >> 2, c[a++] = n >> 8 & 255, c[a++] = n & 255), c;
}
function Xx(e) {
  return kn[e >> 18 & 63] + kn[e >> 12 & 63] + kn[e >> 6 & 63] + kn[e & 63];
}
function Zx(e, n, i) {
  for (var o, t = [], c = n; c < i; c += 3)
    o = (e[c] << 16 & 16711680) + (e[c + 1] << 8 & 65280) + (e[c + 2] & 255), t.push(Xx(o));
  return t.join("");
}
function Yx(e) {
  for (var n, i = e.length, o = i % 3, t = [], c = 16383, a = 0, s = i - o; a < s; a += c)
    t.push(Zx(e, a, a + c > s ? s : a + c));
  return o === 1 ? (n = e[i - 1], t.push(
    kn[n >> 2] + kn[n << 4 & 63] + "=="
  )) : o === 2 && (n = (e[i - 2] << 8) + e[i - 1], t.push(
    kn[n >> 10] + kn[n >> 4 & 63] + kn[n << 2 & 63] + "="
  )), t.join("");
}
var Qx = ln && ln.__createBinding || (Object.create ? function(e, n, i, o) {
  o === void 0 && (o = i);
  var t = Object.getOwnPropertyDescriptor(n, i);
  (!t || ("get" in t ? !n.__esModule : t.writable || t.configurable)) && (t = { enumerable: !0, get: function() {
    return n[i];
  } }), Object.defineProperty(e, o, t);
} : function(e, n, i, o) {
  o === void 0 && (o = i), e[o] = n[i];
}), _x = ln && ln.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), $x = ln && ln.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var n = {};
  if (e != null) for (var i in e) i !== "default" && Object.prototype.hasOwnProperty.call(e, i) && Qx(n, e, i);
  return _x(n, e), n;
};
Object.defineProperty(Si, "__esModule", { value: !0 });
Si.fromBase64 = Si.toBase64 = void 0;
const Ol = $x(Et);
function eD(e) {
  return Ol.fromByteArray(e);
}
Si.toBase64 = eD;
function nD(e) {
  if (!e.match(/^[a-zA-Z0-9+/]*={0,2}$/))
    throw new Error("Invalid base64 string format");
  return Ol.toByteArray(e);
}
Si.fromBase64 = nD;
var Wn = {}, rt = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", Ac = {};
for (var No = 0; No < rt.length; No++) {
  var Yt = rt.charAt(No);
  if (Ac[Yt] !== void 0) throw new TypeError(Yt + " is ambiguous");
  Ac[Yt] = No;
}
function wi(e) {
  var n = e >> 25;
  return (e & 33554431) << 5 ^ -(n >> 0 & 1) & 996825010 ^ -(n >> 1 & 1) & 642813549 ^ -(n >> 2 & 1) & 513874426 ^ -(n >> 3 & 1) & 1027748829 ^ -(n >> 4 & 1) & 705979059;
}
function Ul(e) {
  for (var n = 1, i = 0; i < e.length; ++i) {
    var o = e.charCodeAt(i);
    if (o < 33 || o > 126) return "Invalid prefix (" + e + ")";
    n = wi(n) ^ o >> 5;
  }
  for (n = wi(n), i = 0; i < e.length; ++i) {
    var t = e.charCodeAt(i);
    n = wi(n) ^ t & 31;
  }
  return n;
}
function iD(e, n, i) {
  if (i = i || 90, e.length + 7 + n.length > i) throw new TypeError("Exceeds length limit");
  e = e.toLowerCase();
  var o = Ul(e);
  if (typeof o == "string") throw new Error(o);
  for (var t = e + "1", c = 0; c < n.length; ++c) {
    var a = n[c];
    if (a >> 5) throw new Error("Non 5-bit word");
    o = wi(o) ^ a, t += rt.charAt(a);
  }
  for (c = 0; c < 6; ++c)
    o = wi(o);
  for (o ^= 1, c = 0; c < 6; ++c) {
    var s = o >> (5 - c) * 5 & 31;
    t += rt.charAt(s);
  }
  return t;
}
function Wl(e, n) {
  if (n = n || 90, e.length < 8) return e + " too short";
  if (e.length > n) return "Exceeds length limit";
  var i = e.toLowerCase(), o = e.toUpperCase();
  if (e !== i && e !== o) return "Mixed-case string " + e;
  e = i;
  var t = e.lastIndexOf("1");
  if (t === -1) return "No separator character for " + e;
  if (t === 0) return "Missing prefix for " + e;
  var c = e.slice(0, t), a = e.slice(t + 1);
  if (a.length < 6) return "Data too short";
  var s = Ul(c);
  if (typeof s == "string") return s;
  for (var l = [], m = 0; m < a.length; ++m) {
    var h = a.charAt(m), u = Ac[h];
    if (u === void 0) return "Unknown character " + h;
    s = wi(s) ^ u, !(m + 6 >= a.length) && l.push(u);
  }
  return s !== 1 ? "Invalid checksum for " + e : { prefix: c, words: l };
}
function oD() {
  var e = Wl.apply(null, arguments);
  if (typeof e == "object") return e;
}
function tD(e) {
  var n = Wl.apply(null, arguments);
  if (typeof n == "object") return n;
  throw new Error(n);
}
function Pt(e, n, i, o) {
  for (var t = 0, c = 0, a = (1 << i) - 1, s = [], l = 0; l < e.length; ++l)
    for (t = t << n | e[l], c += n; c >= i; )
      c -= i, s.push(t >> c & a);
  if (o)
    c > 0 && s.push(t << i - c & a);
  else {
    if (c >= n) return "Excess padding";
    if (t << i - c & a) return "Non-zero padding";
  }
  return s;
}
function cD(e) {
  var n = Pt(e, 8, 5, !0);
  if (Array.isArray(n)) return n;
}
function aD(e) {
  var n = Pt(e, 8, 5, !0);
  if (Array.isArray(n)) return n;
  throw new Error(n);
}
function rD(e) {
  var n = Pt(e, 5, 8, !1);
  if (Array.isArray(n)) return n;
}
function sD(e) {
  var n = Pt(e, 5, 8, !1);
  if (Array.isArray(n)) return n;
  throw new Error(n);
}
var lD = {
  decodeUnsafe: oD,
  decode: tD,
  encode: iD,
  toWordsUnsafe: cD,
  toWords: aD,
  fromWordsUnsafe: rD,
  fromWords: sD
}, mD = ln && ln.__createBinding || (Object.create ? function(e, n, i, o) {
  o === void 0 && (o = i);
  var t = Object.getOwnPropertyDescriptor(n, i);
  (!t || ("get" in t ? !n.__esModule : t.writable || t.configurable)) && (t = { enumerable: !0, get: function() {
    return n[i];
  } }), Object.defineProperty(e, o, t);
} : function(e, n, i, o) {
  o === void 0 && (o = i), e[o] = n[i];
}), pD = ln && ln.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), uD = ln && ln.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var n = {};
  if (e != null) for (var i in e) i !== "default" && Object.prototype.hasOwnProperty.call(e, i) && mD(n, e, i);
  return pD(n, e), n;
};
Object.defineProperty(Wn, "__esModule", { value: !0 });
Wn.normalizeBech32 = Wn.fromBech32 = Wn.toBech32 = void 0;
const st = uD(lD);
function Gl(e, n, i) {
  return st.encode(e, st.toWords(n), i);
}
Wn.toBech32 = Gl;
function Jl(e, n = 1 / 0) {
  const i = st.decode(e, n);
  return {
    prefix: i.prefix,
    data: new Uint8Array(st.fromWords(i.words))
  };
}
Wn.fromBech32 = Jl;
function hD(e) {
  const { prefix: n, data: i } = Jl(e);
  return Gl(n, i);
}
Wn.normalizeBech32 = hD;
var Hi = {};
Object.defineProperty(Hi, "__esModule", { value: !0 });
Hi.fromHex = Hi.toHex = void 0;
function dD(e) {
  let n = "";
  for (const i of e)
    n += ("0" + i.toString(16)).slice(-2);
  return n;
}
Hi.toHex = dD;
function xD(e) {
  if (e.length % 2 !== 0)
    throw new Error("hex string length must be a multiple of 2");
  const n = new Uint8Array(e.length / 2);
  for (let i = 0; i < n.length; i++) {
    const o = 2 * i, t = e.slice(o, o + 2);
    if (!t.match(/[0-9a-f]{2}/i))
      throw new Error("hex string contains invalid characters");
    n[i] = parseInt(t, 16);
  }
  return n;
}
Hi.fromHex = xD;
var Ti = {};
Object.defineProperty(Ti, "__esModule", { value: !0 });
Ti.toRfc3339 = Ti.fromRfc3339 = void 0;
const DD = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function bi(e, n = 2) {
  return e.toString().padStart(n, "0");
}
function gD(e) {
  const n = DD.exec(e);
  if (!n)
    throw new Error("Date string is not in RFC3339 format");
  const i = +n[1], o = +n[2], t = +n[3], c = +n[4], a = +n[5], s = +n[6], l = n[7] ? Math.floor(+n[7] * 1e3) : 0;
  let m, h, u;
  n[8] === "Z" ? (m = 1, h = 0, u = 0) : (m = n[8].substring(0, 1) === "-" ? -1 : 1, h = +n[8].substring(1, 3), u = +n[8].substring(4, 6));
  const D = m * (h * 60 + u) * 60, b = Date.UTC(i, o - 1, t, c, a, s, l) - D * 1e3;
  return new Date(b);
}
Ti.fromRfc3339 = gD;
function fD(e) {
  const n = e.getUTCFullYear(), i = bi(e.getUTCMonth() + 1), o = bi(e.getUTCDate()), t = bi(e.getUTCHours()), c = bi(e.getUTCMinutes()), a = bi(e.getUTCSeconds()), s = bi(e.getUTCMilliseconds(), 3);
  return `${n}-${i}-${o}T${t}:${c}:${a}.${s}Z`;
}
Ti.toRfc3339 = fD;
var Ni = {};
Object.defineProperty(Ni, "__esModule", { value: !0 });
Ni.fromUtf8 = Ni.toUtf8 = void 0;
function bD(e) {
  return new TextEncoder().encode(e);
}
Ni.toUtf8 = bD;
function AD(e, n = !1) {
  const i = !n;
  return new TextDecoder("utf-8", { fatal: i }).decode(e);
}
Ni.fromUtf8 = AD;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.toUtf8 = e.fromUtf8 = e.toRfc3339 = e.fromRfc3339 = e.toHex = e.fromHex = e.toBech32 = e.normalizeBech32 = e.fromBech32 = e.toBase64 = e.fromBase64 = e.toAscii = e.fromAscii = void 0;
  var n = Ii;
  Object.defineProperty(e, "fromAscii", { enumerable: !0, get: function() {
    return n.fromAscii;
  } }), Object.defineProperty(e, "toAscii", { enumerable: !0, get: function() {
    return n.toAscii;
  } });
  var i = Si;
  Object.defineProperty(e, "fromBase64", { enumerable: !0, get: function() {
    return i.fromBase64;
  } }), Object.defineProperty(e, "toBase64", { enumerable: !0, get: function() {
    return i.toBase64;
  } });
  var o = Wn;
  Object.defineProperty(e, "fromBech32", { enumerable: !0, get: function() {
    return o.fromBech32;
  } }), Object.defineProperty(e, "normalizeBech32", { enumerable: !0, get: function() {
    return o.normalizeBech32;
  } }), Object.defineProperty(e, "toBech32", { enumerable: !0, get: function() {
    return o.toBech32;
  } });
  var t = Hi;
  Object.defineProperty(e, "fromHex", { enumerable: !0, get: function() {
    return t.fromHex;
  } }), Object.defineProperty(e, "toHex", { enumerable: !0, get: function() {
    return t.toHex;
  } });
  var c = Ti;
  Object.defineProperty(e, "fromRfc3339", { enumerable: !0, get: function() {
    return c.fromRfc3339;
  } }), Object.defineProperty(e, "toRfc3339", { enumerable: !0, get: function() {
    return c.toRfc3339;
  } });
  var a = Ni;
  Object.defineProperty(e, "fromUtf8", { enumerable: !0, get: function() {
    return a.fromUtf8;
  } }), Object.defineProperty(e, "toUtf8", { enumerable: !0, get: function() {
    return a.toUtf8;
  } });
})(Rl);
const CD = ({
  address: e,
  chainType: n,
  bech32Prefix: i
}) => {
  switch (n) {
    case "cosmos":
      try {
        const { prefix: o } = Rl.fromBech32(e);
        return i === o;
      } catch {
        return !1;
      }
    case "evm":
      try {
        return ip(e);
      } catch {
        return !1;
      }
    case "svm":
      try {
        const o = new ya(e);
        return ya.isOnCurve(o);
      } catch {
        return !1;
      }
    default:
      return !1;
  }
};
var ho = {};
Object.defineProperty(ho, "__esModule", { value: !0 });
var Kl = ho.bech32m = Yl = ho.bech32 = void 0;
const lt = "qpzry9x8gf2tvdw0s3jn54khce6mua7l", Xl = {};
for (let e = 0; e < lt.length; e++) {
  const n = lt.charAt(e);
  Xl[n] = e;
}
function yi(e) {
  const n = e >> 25;
  return (e & 33554431) << 5 ^ -(n >> 0 & 1) & 996825010 ^ -(n >> 1 & 1) & 642813549 ^ -(n >> 2 & 1) & 513874426 ^ -(n >> 3 & 1) & 1027748829 ^ -(n >> 4 & 1) & 705979059;
}
function Tr(e) {
  let n = 1;
  for (let i = 0; i < e.length; ++i) {
    const o = e.charCodeAt(i);
    if (o < 33 || o > 126)
      return "Invalid prefix (" + e + ")";
    n = yi(n) ^ o >> 5;
  }
  n = yi(n);
  for (let i = 0; i < e.length; ++i) {
    const o = e.charCodeAt(i);
    n = yi(n) ^ o & 31;
  }
  return n;
}
function oa(e, n, i, o) {
  let t = 0, c = 0;
  const a = (1 << i) - 1, s = [];
  for (let l = 0; l < e.length; ++l)
    for (t = t << n | e[l], c += n; c >= i; )
      c -= i, s.push(t >> c & a);
  if (o)
    c > 0 && s.push(t << i - c & a);
  else {
    if (c >= n)
      return "Excess padding";
    if (t << i - c & a)
      return "Non-zero padding";
  }
  return s;
}
function kD(e) {
  return oa(e, 8, 5, !0);
}
function vD(e) {
  const n = oa(e, 5, 8, !1);
  if (Array.isArray(n))
    return n;
}
function wD(e) {
  const n = oa(e, 5, 8, !1);
  if (Array.isArray(n))
    return n;
  throw new Error(n);
}
function Zl(e) {
  let n;
  e === "bech32" ? n = 1 : n = 734539939;
  function i(a, s, l) {
    if (l = l || 90, a.length + 7 + s.length > l)
      throw new TypeError("Exceeds length limit");
    a = a.toLowerCase();
    let m = Tr(a);
    if (typeof m == "string")
      throw new Error(m);
    let h = a + "1";
    for (let u = 0; u < s.length; ++u) {
      const D = s[u];
      if (D >> 5)
        throw new Error("Non 5-bit word");
      m = yi(m) ^ D, h += lt.charAt(D);
    }
    for (let u = 0; u < 6; ++u)
      m = yi(m);
    m ^= n;
    for (let u = 0; u < 6; ++u) {
      const D = m >> (5 - u) * 5 & 31;
      h += lt.charAt(D);
    }
    return h;
  }
  function o(a, s) {
    if (s = s || 90, a.length < 8)
      return a + " too short";
    if (a.length > s)
      return "Exceeds length limit";
    const l = a.toLowerCase(), m = a.toUpperCase();
    if (a !== l && a !== m)
      return "Mixed-case string " + a;
    a = l;
    const h = a.lastIndexOf("1");
    if (h === -1)
      return "No separator character for " + a;
    if (h === 0)
      return "Missing prefix for " + a;
    const u = a.slice(0, h), D = a.slice(h + 1);
    if (D.length < 6)
      return "Data too short";
    let b = Tr(u);
    if (typeof b == "string")
      return b;
    const C = [];
    for (let k = 0; k < D.length; ++k) {
      const q = D.charAt(k), E = Xl[q];
      if (E === void 0)
        return "Unknown character " + q;
      b = yi(b) ^ E, !(k + 6 >= D.length) && C.push(E);
    }
    return b !== n ? "Invalid checksum for " + a : { prefix: u, words: C };
  }
  function t(a, s) {
    const l = o(a, s);
    if (typeof l == "object")
      return l;
  }
  function c(a, s) {
    const l = o(a, s);
    if (typeof l == "object")
      return l;
    throw new Error(l);
  }
  return {
    decodeUnsafe: t,
    decode: c,
    encode: i,
    toWords: kD,
    fromWordsUnsafe: vD,
    fromWords: wD
  };
}
var Yl = ho.bech32 = Zl("bech32");
Kl = ho.bech32m = Zl("bech32m");
const Ql = {
  passet: 65,
  pauctid: 66,
  penumbra: 143,
  penumbracompat1: 150,
  penumbrafullviewingkey: 132,
  penumbragovern: 73,
  penumbraspendkey: 75,
  penumbravalid: 72,
  penumbrawalletid: 75,
  plpid: 64
}, _l = {
  passet: 32,
  pauctid: 32,
  penumbra: 80,
  penumbracompat1: 80,
  penumbrafullviewingkey: 64,
  penumbragovern: 32,
  penumbraspendkey: 32,
  penumbravalid: 32,
  penumbrawalletid: 32,
  plpid: 32
}, yD = (e, n) => $l({
  bechLib: Kl,
  bData: e,
  prefix: n,
  expectLength: Ql[n],
  expectBytes: _l[n]
}), ED = (e, n) => $l({
  bechLib: Yl,
  bData: e,
  prefix: n,
  expectLength: Ql[n],
  expectBytes: _l[n]
}), $l = ({ bechLib: e, bData: n, prefix: i, expectLength: o, expectBytes: t }) => {
  if (n.length !== t)
    throw new TypeError(`Invalid data length: expected ${t}, got ${n.length}`);
  const c = e.encode(i, e.toWords(n), o);
  if (c.length !== o)
    throw new TypeError("Unexpected string length");
  return c;
}, em = {
  passet: "inner",
  pauctid: "inner",
  penumbra: "inner",
  penumbracompat1: "inner",
  penumbrafullviewingkey: "inner",
  penumbragovern: "gk",
  penumbraspendkey: "inner",
  penumbravalid: "ik",
  penumbrawalletid: "inner",
  plpid: "inner"
}, nm = {
  passet: "passet",
  pauctid: "pauctid",
  penumbra: "penumbra",
  penumbracompat1: "penumbracompat1",
  penumbrafullviewingkey: "penumbrafullviewingkey",
  penumbragovern: "penumbragovern",
  penumbraspendkey: "penumbraspendkey",
  penumbravalid: "penumbravalid",
  penumbrawalletid: "penumbrawalletid",
  plpid: "plpid"
}, PD = em.penumbra, FD = nm.penumbra, Nr = ({ [PD]: e }) => yD(e, FD), BD = em.penumbracompat1, MD = nm.penumbracompat1, jD = ({ [BD]: e }) => ED(e, MD), im = () => {
  const { data: e } = X(Te), { data: n } = X(Hn), i = Z(Hc), o = Z(qe), { walletType: t } = _m(), { data: c, isConnected: a } = Yr({
    multiChain: !0
  }), { disconnectAsync: s } = $m();
  return { createCosmosWallets: ze(
    (m) => {
      const h = [we.KEPLR, we.LEAP, we.COSMOSTATION, we.XDEFI, we.STATION, we.VECTIS];
      if (m == null ? void 0 : m.includes("penumbra"))
        return [{
          walletName: "prax",
          walletPrettyName: "Prax Wallet",
          walletChainType: "cosmos",
          walletInfo: {
            logo: "https://raw.githubusercontent.com/prax-wallet/web/e8b18f9b997708eab04f57e7a6c44f18b3cf13a8/apps/extension/public/prax-white-vertical.svg"
          },
          connectEco: async () => {
            console.error("Prax wallet is not supported for connectEco");
          },
          connect: async () => {
            console.error("Prax wallet is not supported for connect");
          },
          getAddress: async ({ praxWallet: C }) => {
            const k = C == null ? void 0 : C.index, q = C == null ? void 0 : C.sourceChainID, g = xp("chrome-extension://lkpmkhpnhknhmibgnmmhdhgdilepfghe");
            try {
              await g.connect();
              const H = await g.service(Dp).ephemeralAddress({
                addressIndex: {
                  account: k || 0
                }
              });
              if (!H.address) throw new Error("No address found");
              return qD({
                address: H.address,
                chainID: q
              });
            } catch (M) {
              throw console.error(M), M;
            }
          },
          disconnect: async () => {
            console.error("Prax wallet is not supported");
          },
          isWalletConnected: !1
        }];
      const D = [];
      for (const b of h) {
        const C = Hl(b), k = (b === we.KEPLR ? yx : Ex).filter(
          (g) => (e == null ? void 0 : e.filter((M) => M.chainType === "cosmos").map((M) => M.chainID).includes(g)) && Ic.map((M) => M.chainId).includes(g)
        ), q = async () => {
          const g = k.map(
            async (M) => await yo({
              chainId: M,
              walletType: b
            })
          );
          return await Promise.all(g), Promise.resolve();
        }, E = async ({
          signRequired: g
        }) => {
          var S;
          if (!m) throw new Error("Chain ID is required");
          const M = Ua(m), H = (S = c == null ? void 0 : c[m]) == null ? void 0 : S.bech32Address;
          if (b !== t && !H) {
            if (!M)
              throw new Error(
                `getAddress: Chain info not found for chainID: ${m}`
              );
            await Ai(b).experimentalSuggestChain(M), k.includes(m) ? await q() : await yo({
              chainId: m,
              walletType: b
            }), i({ walletName: b, chainType: "cosmos" });
          } else H && a && g && i({ walletName: b, chainType: "cosmos" });
          return H || (await Ai(b).experimentalSuggestChain(M), k.includes(m) ? await q() : await yo({
            chainId: m,
            walletType: b
          }), i({ walletName: b, chainType: "cosmos" })), (await Ai(b).getKey(m)).bech32Address;
        }, x = {
          walletName: b,
          walletPrettyName: C == null ? void 0 : C.name,
          walletChainType: "cosmos",
          walletInfo: {
            logo: C == null ? void 0 : C.imgSrc
          },
          connectEco: async () => {
            await q(), i({ walletName: b, chainType: "cosmos" });
            const g = e == null ? void 0 : e.find((H) => H.chainID === "cosmoshub-4"), M = n == null ? void 0 : n.find((H) => H.denom === "uatom");
            return o({
              chainID: g == null ? void 0 : g.chainID,
              chainName: g == null ? void 0 : g.chainName,
              ...M
            }), Promise.resolve();
          },
          connect: async () => {
            try {
              if (!m) throw new Error("Chain ID is required");
              const g = Ua(m);
              if (!g)
                throw new Error(
                  `connect: Chain info not found for chainID: ${m}`
                );
              await Ai(b).experimentalSuggestChain(g), k.includes(m) ? await q() : await yo({
                chainId: m,
                walletType: b
              }), i({ walletName: b, chainType: "cosmos" }), q();
            } catch (g) {
              throw console.error(g), g;
            }
          },
          getAddress: E,
          disconnect: async () => {
            await s(), i(void 0);
          },
          isWalletConnected: t === b,
          isAvailable: (() => {
            try {
              return !!Ai(b);
            } catch {
              return !1;
            }
          })()
        };
        D.push(x);
      }
      return D;
    },
    [c, n, e, t, s, a, i, o]
  ) };
}, zD = ["noble-1", "grand-1"], qD = ({
  chainID: e,
  address: n
}) => e && zD.includes(e) ? jD(n) : Nr(n), ID = [
  {
    inputs: [
      { internalType: "string", name: "v", type: "string" },
      { internalType: "string", name: "r", type: "string" },
      { internalType: "string", name: "s", type: "string" },
      { internalType: "string", name: "customMessage", type: "string" }
    ],
    name: "associate",
    outputs: [
      { internalType: "string", name: "seiAddr", type: "string" },
      { internalType: "address", name: "evmAddr", type: "address" }
    ],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [{ internalType: "address", name: "addr", type: "address" }],
    name: "getSeiAddr",
    outputs: [{ internalType: "string", name: "response", type: "string" }],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [{ internalType: "string", name: "addr", type: "string" }],
    name: "getEvmAddr",
    outputs: [{ internalType: "address", name: "response", type: "address" }],
    stateMutability: "view",
    type: "function"
  }
], om = () => {
  const { data: e } = X(Te), { data: n } = X(Hn), i = Z(qe), o = Z(Sc), {
    connector: t,
    address: c,
    isConnected: a,
    chainId: s
  } = pt(), { connectAsync: l } = ap(), m = _r(), h = m.find(
    (D) => D.id === (t == null ? void 0 : t.id)
  );
  return { createEvmWallets: ze(
    (D) => {
      const b = D === "pacific-1";
      b && (D = it.id.toString());
      const C = [];
      for (const k of m) {
        if (C.findIndex((g) => g.walletName === k.id) !== -1)
          continue;
        const E = async ({
          signRequired: g
        }) => {
          var M;
          if (g && a && s !== Number(D) && k.id === (t == null ? void 0 : t.id))
            return await ((M = k == null ? void 0 : k.switchChain) == null ? void 0 : M.call(k, {
              chainId: Number(D)
            })), c;
          if (k.id !== (t == null ? void 0 : t.id) || !a) {
            const H = await l({
              connector: k,
              chainId: Number(D)
            });
            return o({ walletName: k.id, chainType: "evm" }), H.accounts[0];
          } else c && a && g && o({ walletName: k.id, chainType: "evm" });
          return c;
        }, x = {
          walletName: k.id,
          walletPrettyName: k.name,
          walletChainType: "evm",
          walletInfo: {
            logo: k.icon
          },
          connectEco: async () => {
            var g;
            if (a && s !== 1 && k.id === (t == null ? void 0 : t.id)) {
              await ((g = k == null ? void 0 : k.switchChain) == null ? void 0 : g.call(k, {
                chainId: 1
              }));
              return;
            }
            a && k.id !== (t == null ? void 0 : t.id) && await (h == null ? void 0 : h.disconnect());
            try {
              await l({ connector: k, chainId: 1 }), o({ walletName: k.id, chainType: "evm" });
              const M = e == null ? void 0 : e.find((P) => P.chainID === "1"), H = n == null ? void 0 : n.find((P) => P.denom === "ethereum-native");
              i({
                chainID: M == null ? void 0 : M.chainID,
                chainName: M == null ? void 0 : M.chainName,
                ...H
              });
            } catch (M) {
              throw console.error(M), M;
            }
          },
          connect: async () => {
            var g;
            if (a && s !== Number(D) && k.id === (t == null ? void 0 : t.id)) {
              await ((g = k == null ? void 0 : k.switchChain) == null ? void 0 : g.call(k, {
                chainId: Number(D)
              }));
              return;
            }
            a && k.id !== (t == null ? void 0 : t.id) && await (h == null ? void 0 : h.disconnect());
            try {
              await l({ connector: k, chainId: Number(D) }), o({ walletName: k.id, chainType: "evm" });
            } catch (M) {
              throw console.error(M), M;
            }
          },
          getAddress: async ({ signRequired: g, context: M }) => {
            try {
              return await E({ signRequired: g, context: M });
            } catch (H) {
              throw console.error(H), H;
            }
          },
          disconnect: async () => {
            await (h == null ? void 0 : h.disconnect()), o(void 0);
          },
          isWalletConnected: k.id === (t == null ? void 0 : t.id)
        };
        if (b) {
          const g = k.name.toLowerCase().includes("keplr") || k.name.toLowerCase().includes("leap") || k.name.toLowerCase().includes("cosmostation");
          x.walletPrettyName = `${k.name} ${g ? "(EVM)" : ""}`, x.getAddress = async ({ signRequired: M, context: H }) => {
            const P = await E({ signRequired: M, context: H }), S = op({
              chain: it,
              transport: xe()
            });
            try {
              return await S.readContract({
                args: [P],
                address: "0x0000000000000000000000000000000000001004",
                abi: ID,
                functionName: "getSeiAddr"
              });
            } catch (p) {
              throw console.error(p), new Error(`Your EVM address (0x) has not been associated on chain yet. Please visit https://app.sei.io/ to associate your SEI address.
`);
            }
          };
        }
        C.push(x);
      }
      return C;
    },
    [
      n,
      s,
      e,
      l,
      m,
      h,
      t == null ? void 0 : t.id,
      c,
      a,
      o,
      i
    ]
  ) };
}, tm = () => {
  const { data: e } = X(Te), { data: n } = X(Hn), i = Z(qe), o = Z(Tc);
  return { createSolanaWallets: ze(() => {
    const c = [];
    for (const a of Gc) {
      const s = {
        walletName: a.name,
        walletPrettyName: a.name,
        walletChainType: "svm",
        walletInfo: {
          logo: a.icon
        },
        connect: async () => {
          try {
            await a.connect(), o({ walletName: a.name, chainType: "svm" });
          } catch (l) {
            throw console.error(l), l;
          }
        },
        connectEco: async () => {
          try {
            await a.connect(), o({ walletName: a.name, chainType: "svm" });
            const l = e == null ? void 0 : e.find((h) => h.chainID === "solana"), m = n == null ? void 0 : n.find((h) => h.denom.toLowerCase() === "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v".toLowerCase());
            i({
              chainID: l == null ? void 0 : l.chainID,
              chainName: l == null ? void 0 : l.chainName,
              ...m
            });
          } catch (l) {
            throw console.error(l), l;
          }
        },
        getAddress: async ({ signRequired: l }) => {
          try {
            a.connected || (await a.connect(), o({ walletName: a.name, chainType: "svm" }));
            const h = a.publicKey;
            if (!h) throw new Error("No address found");
            return l && o({ walletName: a.name, chainType: "svm" }), h.toBase58();
          } catch (m) {
            console.error(m);
          }
        },
        disconnect: async () => {
          await a.disconnect(), o(void 0);
        },
        isWalletConnected: a.connected,
        isAvailable: a.readyState === "Installed"
      };
      c.push(s);
    }
    return c;
  }, [n, e, i, o]) };
}, ta = ({ chainID: e, destinationWalletList: n, chainType: i }) => {
  var h;
  const { createCosmosWallets: o } = im(), { createEvmWallets: t } = om(), { createSolanaWallets: c } = tm(), { data: a } = X(Te), s = e ? (h = a == null ? void 0 : a.find((u) => u.chainID === e)) == null ? void 0 : h.chainType : i, l = n && e === "pacific-1" ? "sei" : s;
  return K(() => {
    switch (l) {
      case "sei": {
        const u = o(e), D = t(e);
        return [...u, ...D];
      }
      case "cosmos":
        return o(e);
      case "evm":
        return t(e);
      case "svm":
        return c();
      default:
        return [];
    }
  }, [e, o, t, c, l]);
}, cm = Ui((e) => {
  var H;
  const { theme: n, signRequired: i, chainId: o, chainAddressIndex: t } = e, c = Je(), { data: a } = X(Te), s = a == null ? void 0 : a.find((P) => P.chainID === o), l = s == null ? void 0 : s.prettyName, m = s == null ? void 0 : s.logoURI, [h, u] = be(!1), [D, b] = be(""), C = ta({ chainID: o, destinationWalletList: !0 }), k = Z(En), q = [
    ...C,
    {
      onSelect: () => u(!0),
      walletName: "Enter address manually",
      rightContent: () => {
        var P, S;
        return /* @__PURE__ */ r.jsx(
          Zc,
          {
            color: (P = n == null ? void 0 : n.primary) == null ? void 0 : P.background.normal,
            backgroundColor: (S = n == null ? void 0 : n.primary) == null ? void 0 : S.text.normal
          }
        );
      }
    }
  ], E = ze(
    (P) => {
      b(P.target.value);
    },
    []
  ), x = K(() => {
    if (!s || D.length === 0) return;
    const { chainType: P, bech32Prefix: S } = s;
    return CD({
      address: D,
      bech32Prefix: S,
      chainType: P
    });
  }, [s, D]), g = K(() => {
    if (!s) return "Enter address...";
    const { chainType: P, bech32Prefix: S } = s;
    switch (P) {
      case "cosmos":
        return `${S}1...`;
      case "evm":
        return "0x...";
      case "svm":
        return "Enter solana address...";
      default:
        return "Enter address...";
    }
  }, [s]), M = () => {
    const P = s == null ? void 0 : s.chainType;
    !o || !P || (k((S) => {
      const p = t || Object.values(S).length - 1;
      return {
        ...S,
        [p]: {
          chainID: o,
          chainType: P,
          address: D,
          source: "input"
        }
      };
    }), c.remove());
  };
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: h ? /* @__PURE__ */ r.jsxs(SD, { gap: 15, children: [
    /* @__PURE__ */ r.jsx(
      ia,
      {
        title: `Enter a ${l} address`,
        onClickBackButton: () => u(!1),
        rightContent: () => /* @__PURE__ */ r.jsx(TD, { align: "center", justify: "center", children: /* @__PURE__ */ r.jsx("img", { width: "25px", height: "25px", src: m }) })
      }
    ),
    /* @__PURE__ */ r.jsxs(HD, { children: [
      /* @__PURE__ */ r.jsx(
        VD,
        {
          placeholder: g,
          value: D,
          onChange: E,
          validAddress: x
        }
      ),
      /* @__PURE__ */ r.jsx(ND, { validAddress: x })
    ] }),
    x === !1 && /* @__PURE__ */ r.jsxs(G, { color: (H = n == null ? void 0 : n.error) == null ? void 0 : H.text, textAlign: "center", children: [
      "Please enter a valid wallet address for ",
      l
    ] }),
    /* @__PURE__ */ r.jsx(
      RD,
      {
        align: "center",
        justify: "center",
        disabled: !x,
        onClick: M,
        children: /* @__PURE__ */ r.jsx(
          Pe,
          {
            mainButtonColor: x === !0 ? n == null ? void 0 : n.brandColor : void 0,
            opacity: x ? 1 : 0.5,
            fontSize: 24,
            children: "Confirm"
          }
        )
      }
    )
  ] }) : /* @__PURE__ */ r.jsx(
    Vl,
    {
      title: "Destination wallet",
      walletList: i ? C : q,
      onClickBackButton: () => c.remove(),
      chainId: o,
      chainType: s == null ? void 0 : s.chainType,
      isDestinationAddress: !0,
      chainAddressIndex: t
    }
  ) });
}), SD = V(re)`
  position: relative;
  padding: 10px;
  gap: 15px;
  width: 580px;
  border-radius: 20px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
  overflow: hidden;
`, HD = V.div`
  position: relative;
`, TD = V(U)`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: ${({ theme: e }) => e.secondary.background.normal};
`, ND = V.div`
  position: absolute;
  height: 11px;
  width: 11px;
  border-radius: 50%;
  background-color: ${({ theme: e }) => e.primary.text.lowContrast};

  ${({ validAddress: e, theme: n }) => e === !0 ? `background-color: ${n.success.text}` : e === !1 ? `background-color: ${n.error.text}` : ""};

  top: calc(50% - 11px / 2);
  right: 20px;
`, VD = V.input`
  height: 60px;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  padding: 8px 40px 8px 15px;
  border: 1px solid ${({ theme: e }) => e.primary.text.ultraLowContrast};
  background-color: ${({ theme: e }) => e.secondary.background.normal};
  color: ${({ theme: e }) => e.primary.text.normal};
  border-radius: 12px;

  ${({ validAddress: e, theme: n }) => e === !1 && He`
      border-color: ${n.error.text};
      background-color: ${n.error.background};
    `}
`, RD = V(xn)`
  background-color: ${({ theme: e }) => e.brandColor};
  height: 60px;
  border-radius: 12px;
  ${({ disabled: e, theme: n }) => e && `background-color: ${n.secondary.background.normal}`};
`;
function Zn(e) {
  const n = typeof e == "string" ? parseFloat(e) : e;
  return LD.format(n);
}
const LD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2
}), Vr = ({
  denom: e,
  tokenAmount: n,
  usdValue: i,
  chainId: o,
  status: t,
  onClickEditDestinationWallet: c,
  explorerLink: a,
  context: s
}) => {
  var k;
  const l = ke(), m = en({
    assetDenom: e,
    chainId: o,
    tokenAmount: n
  }), h = X(En), D = hi()(o), b = K(() => {
    const q = Object.values(h);
    switch (s) {
      case "source":
        return {
          address: D == null ? void 0 : D.address,
          image: D == null ? void 0 : D.wallet.logo
        };
      case "destination": {
        const E = q[q.length - 1];
        return {
          address: E == null ? void 0 : E.address,
          image: (E == null ? void 0 : E.source) === "wallet" && E.wallet.walletInfo.logo || void 0
        };
      }
    }
  }, [D == null ? void 0 : D.address, D == null ? void 0 : D.wallet.logo, h, s]), C = K(
    () => G0(uo(m.amount)),
    [m.amount]
  );
  return /* @__PURE__ */ r.jsxs(U, { gap: 25, align: "center", children: [
    m.assetImage && /* @__PURE__ */ r.jsx(
      yt,
      {
        width: 50,
        height: 50,
        backgroundColor: l.success.text,
        status: t,
        children: /* @__PURE__ */ r.jsx(
          "img",
          {
            height: 50,
            width: 50,
            style: { borderRadius: 50 },
            src: m.assetImage,
            title: (k = m == null ? void 0 : m.asset) == null ? void 0 : k.name
          }
        )
      }
    ),
    /* @__PURE__ */ r.jsxs(re, { gap: 5, children: [
      /* @__PURE__ */ r.jsxs(OD, { children: [
        C,
        " ",
        m == null ? void 0 : m.symbol
      ] }),
      i && /* @__PURE__ */ r.jsx(G, { children: Zn(i) }),
      /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 5, children: [
        /* @__PURE__ */ r.jsxs(G, { normalTextColor: !0, children: [
          "on ",
          m.chainName
        ] }),
        /* @__PURE__ */ r.jsxs(
          xn,
          {
            align: "center",
            gap: 3,
            onClick: () => vt(b.address),
            children: [
              b.image && /* @__PURE__ */ r.jsx("img", { height: 10, width: 10, src: b.image }),
              b.address && /* @__PURE__ */ r.jsx(G, { monospace: !0, title: b.address, children: zi(b.address) })
            ]
          }
        ),
        a ? /* @__PURE__ */ r.jsx(tt, { href: a, target: "_blank", children: /* @__PURE__ */ r.jsx(G, { children: /* @__PURE__ */ r.jsx(mi, {}) }) }) : c ? /* @__PURE__ */ r.jsx(xn, { align: "center", onClick: c, children: /* @__PURE__ */ r.jsx(
          _c,
          {
            color: l.primary.text.lowContrast
          }
        ) }) : null
      ] })
    ] })
  ] });
}, OD = V(Pe)`
  font-size: 24px;
  max-width: 325px;
  overflow: hidden;
  text-overflow: ellipsis;
`, am = ({
  color: e = "currentColor",
  className: n
}) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: "13",
    height: "13",
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: n,
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M7.48395 6.5705L7.48395 0.568512H5.46938L5.46938 6.5705C5.46938 7.30917 4.57625 7.67985 4.05381 7.15741L1.76526 4.86889L0.34029 6.29384L6.478 12.4315L12.613 6.29653L11.1881 4.87157L8.9022 7.15875C8.37976 7.68119 7.48528 7.31186 7.48528 6.57185",
        fill: e
      }
    )
  }
), UD = ({
  operations: e,
  statusData: n,
  onClickEditDestinationWallet: i,
  swapExecutionState: o
}) => {
  var M, H, P, S;
  const t = ke(), { route: c } = X(pn), a = X(En), s = e[0], l = e[e.length - 1], m = n == null ? void 0 : n.transferEvents, h = o === Ge.confirmed ? "completed" : (M = m == null ? void 0 : m[s.transferIndex]) == null ? void 0 : M.status, u = o === Ge.confirmed ? "completed" : (H = m == null ? void 0 : m[l.transferIndex]) == null ? void 0 : H.status, D = s.denomIn, b = l.denomOut, C = {
    denom: D,
    tokenAmount: s.amountIn,
    chainId: s.fromChainID ?? s.chainID,
    usdValue: c == null ? void 0 : c.usdAmountIn
  }, k = {
    denom: b,
    tokenAmount: l.amountOut,
    chainId: l.toChainID ?? l.chainID,
    usdValue: c == null ? void 0 : c.usdAmountOut
  }, q = l.signRequired, E = (P = m == null ? void 0 : m[s.transferIndex]) == null ? void 0 : P.fromExplorerLink, x = (S = m == null ? void 0 : m[l.transferIndex]) == null ? void 0 : S.toExplorerLink, g = K(() => {
    var f;
    if (q) return;
    const p = a ? Object.keys(a).length - 1 : 0;
    if (!(!((f = a == null ? void 0 : a[p]) != null && f.address) || o === Ge.pending || o === Ge.waitingForSigning || o === Ge.validatingGasBalance || o === Ge.confirmed))
      return i;
  }, [q, a, o, i]);
  return /* @__PURE__ */ r.jsxs(GD, { justify: "space-between", children: [
    /* @__PURE__ */ r.jsx(
      Vr,
      {
        ...C,
        status: h,
        context: "source",
        explorerLink: E
      }
    ),
    /* @__PURE__ */ r.jsx(WD, { color: t.primary.text.normal }),
    /* @__PURE__ */ r.jsx(
      Vr,
      {
        ...k,
        icon: Q.pen,
        status: u,
        onClickEditDestinationWallet: g,
        explorerLink: x,
        context: "destination"
      }
    )
  ] });
}, WD = V(am)`
  height: 18px;
  width: 54px;
`, GD = V(re)`
  padding: 35px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
  border-radius: 25px;
  min-height: 225px;
`, no = ({
  color: e = "currentColor",
  ...n
}) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "9",
    height: "10",
    viewBox: "0 0 9 10",
    fill: "none",
    ...n,
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M4.14243 9.26414L0.0367859 5.19958L3.11603 5.19958L3.11603 0.644653L5.12779 0.644653L5.12779 5.19958L8.20703 5.19958L4.14243 9.26414Z",
        fill: e
      }
    )
  }
), JD = ({
  color: e = "currentColor",
  ...n
}) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "9",
    height: "11",
    viewBox: "0 0 9 11",
    fill: "none",
    ...n,
    children: [
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M4.36704 7.83984L0.261395 3.77528L3.34064 3.77528L3.34064 0.4544L5.3524 0.4544L5.3524 1.49781L5.3524 3.77528L8.43164 3.77528L4.36704 7.83984Z",
          fill: e
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.43164 8.83984V8.97095V10.5L6.77148 10.5L1.91992 10.5L0.259766 10.5V8.97095H0.261475L0.261475 8.83984H8.43164Z",
          fill: e
        }
      )
    ]
  }
), Rr = ({
  color: e = "currentColor",
  ...n
}) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "30",
    height: "15",
    viewBox: "0 0 9 15",
    fill: "none",
    ...n,
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M8.20703 4.86573L5.12779 4.86573L5.12779 7.94459L3.11602 7.94459L3.11602 4.86573L0.0367735 4.86573L4.10137 0.801147L8.20703 4.86573ZM4.14243 14.2781L0.0367857 10.2135L3.11603 10.2135L3.11603 5.65862L5.12779 5.65862L5.12779 10.2135L8.20703 10.2135L4.14243 14.2781Z",
        fill: e
      }
    )
  }
);
var rn = /* @__PURE__ */ ((e) => (e.swap = "swap", e.evmSwap = "evmSwap", e.transfer = "transfer", e.axelarTransfer = "axelarTransfer", e.cctpTransfer = "cctpTransfer", e.hyperlaneTransfer = "hyperlaneTransfer", e.opInitTransfer = "opInitTransfer", e.bankSend = "bankSend", e))(rn || {});
function KD(e) {
  const n = e;
  let i = {
    details: {},
    type: void 0
  };
  return Object.values(rn).find((o) => {
    const t = n == null ? void 0 : n[o];
    if (t) {
      switch (o) {
        case "swap":
        case "evmSwap":
          t.toChainID = t.fromChainID;
          break;
        case "bankSend":
          t.denomIn = t.denom, t.denomOut = t.denom, t.fromChainID = t.chainID, t.toChainID = t.chainID;
          break;
      }
      i = {
        details: t,
        type: o
      };
    }
  }), i;
}
function XD(e) {
  const { details: n, type: i } = KD(e);
  return {
    type: i,
    ...n,
    txIndex: e.txIndex,
    amountIn: e.amountIn,
    amountOut: e.amountOut,
    swapVenues: [
      ...n.swapVenues ?? [],
      ...n != null && n.swapIn ? [n == null ? void 0 : n.swapIn.swapVenue] : [],
      ...n != null && n.swapOut ? [n == null ? void 0 : n.swapOut.swapVenue] : []
    ]
  };
}
function Ft(e) {
  let n = 0;
  return e.map((i, o, t) => {
    const c = t[o - 1], a = o === 0 ? !1 : i.txIndex > c.txIndex, s = XD(i), l = s.type === "swap" || s.type === "evmSwap", m = {
      ...s,
      transferIndex: n,
      signRequired: a,
      isSwap: l
    };
    return l || n++, m;
  });
}
function ZD(e) {
  const n = e, i = n == null ? void 0 : n.axelarTransfer, o = n == null ? void 0 : n.ibcTransfer, t = n == null ? void 0 : n.cctpTransfer, c = n == null ? void 0 : n.hyperlaneTransfer, a = n == null ? void 0 : n.opInitTransfer;
  let s = "";
  i ? s = "axelarTransfer" : o ? s = "ibcTransfer" : t ? s = "cctpTransfer" : c ? s = "hyperlaneTransfer" : a && (s = "opInitTransfer");
  const l = (D) => {
    var b, C, k, q, E, x;
    switch (s) {
      case "ibcTransfer":
        return D === "send" ? (b = o.packetTXs.sendTx) == null ? void 0 : b.explorerLink : (C = o.packetTXs.receiveTx) == null ? void 0 : C.explorerLink;
      case "axelarTransfer":
        return i.axelarScanLink;
      default:
        return D === "send" ? (q = (k = n[s]) == null ? void 0 : k.txs.sendTx) == null ? void 0 : q.explorerLink : (x = (E = n[s]) == null ? void 0 : E.txs.receiveTx) == null ? void 0 : x.explorerLink;
    }
  }, m = {
    ...o,
    ...i,
    ...t,
    ...c,
    ...a,
    fromExplorerLink: l("send"),
    toExplorerLink: l("receive")
  }, h = _D(m.state);
  return {
    ...m,
    status: h
  };
}
function YD(e) {
  return e ? e == null ? void 0 : e.flatMap((n) => n.transferSequence.map((i) => ZD(i))) : [];
}
function QD(e) {
  switch (e) {
    case "STATE_SUBMITTED":
    case "STATE_PENDING":
      return "pending";
    case "STATE_COMPLETED_SUCCESS":
      return "success";
    case "STATE_COMPLETED_ERROR":
    case "STATE_PENDING_ERROR":
    default:
      return "failed";
  }
}
function _D(e) {
  switch (e) {
    case "TRANSFER_PENDING":
    case "TRANSFER_RECEIVED":
    case "AXELAR_TRANSFER_PENDING_CONFIRMATION":
    case "AXELAR_TRANSFER_PENDING_RECEIPT":
    case "CCTP_TRANSFER_SENT":
    case "CCTP_TRANSFER_PENDING_CONFIRMATION":
    case "CCTP_TRANSFER_CONFIRMED":
    case "HYPERLANE_TRANSFER_SENT":
    case "OPINIT_TRANSFER_SENT":
      return "pending";
    case "TRANSFER_SUCCESS":
    case "AXELAR_TRANSFER_SUCCESS":
    case "CCTP_TRANSFER_RECEIVED":
    case "HYPERLANE_TRANSFER_RECEIVED":
    case "OPINIT_TRANSFER_RECEIVED":
      return "completed";
    default:
      return "failed";
  }
}
const $D = {
  // swap icon
  [rn.swap]: /* @__PURE__ */ r.jsx(Rr, { width: 34 }),
  [rn.evmSwap]: /* @__PURE__ */ r.jsx(Rr, { width: 34 }),
  // bridge icon
  [rn.transfer]: /* @__PURE__ */ r.jsx(no, { width: 34 }),
  [rn.axelarTransfer]: /* @__PURE__ */ r.jsx(no, { width: 34 }),
  [rn.cctpTransfer]: /* @__PURE__ */ r.jsx(no, { width: 34 }),
  [rn.hyperlaneTransfer]: /* @__PURE__ */ r.jsx(no, { width: 34 }),
  [rn.opInitTransfer]: /* @__PURE__ */ r.jsx(no, { width: 34 }),
  // send icon
  [rn.bankSend]: /* @__PURE__ */ r.jsx(JD, { width: 34 })
}, e2 = {
  swap: "Swapped",
  evmSwap: "Swapped",
  transfer: "Bridged",
  axelarTransfer: "Bridged",
  cctpTransfer: "Bridged",
  hyperlaneTransfer: "Bridged",
  opInitTransfer: "Bridged",
  bankSend: "Sent"
}, n2 = ({
  operations: e,
  statusData: n,
  onClickEditDestinationWallet: i,
  swapExecutionState: o
}) => {
  var E, x;
  const { data: t } = X(Wd), { data: c } = X(Ud), a = X(En), [s, l] = be({}), m = (g) => {
    l((M) => ({
      ...M,
      [g]: !0
    }));
  }, h = (g) => {
    l((M) => ({
      ...M,
      [g]: !1
    }));
  }, u = e[0], b = e[e.length - 1].signRequired, C = n == null ? void 0 : n.transferEvents, k = o === Ge.confirmed ? "completed" : (E = C == null ? void 0 : C[0]) == null ? void 0 : E.status, q = K(() => {
    var H;
    if (b) return;
    const g = a ? Object.keys(a).length - 1 : 0;
    if (!(!((H = a == null ? void 0 : a[g]) != null && H.address) || o === Ge.pending || o === Ge.waitingForSigning || o === Ge.validatingGasBalance || o === Ge.confirmed))
      return i;
  }, [b, a, o, i]);
  return /* @__PURE__ */ r.jsx(t2, { children: /* @__PURE__ */ r.jsxs(re, { children: [
    /* @__PURE__ */ r.jsx(
      Sr,
      {
        tokenAmount: u.amountIn,
        denom: u.denomIn,
        chainId: u.fromChainID,
        explorerLink: (x = C == null ? void 0 : C[0]) == null ? void 0 : x.fromExplorerLink,
        status: k,
        context: "source",
        index: 0
      }
    ),
    e.map((g, M) => {
      var y, F, I;
      const H = e2[g.type], S = (() => {
        var L, W;
        const v = (W = (L = g.swapVenues) == null ? void 0 : L[0]) == null ? void 0 : W.chainID, B = g.bridgeID, z = c == null ? void 0 : c.find((J) => J.id === B), j = t == null ? void 0 : t.find((J) => J.chainID === v);
        return {
          name: (z == null ? void 0 : z.name) ?? (j == null ? void 0 : j.name),
          image: (z == null ? void 0 : z.logoURI) ?? (j == null ? void 0 : j.logoUri)
        };
      })(), p = e[M + 1], d = {
        tokenAmount: g.amountOut,
        denom: g.denomOut,
        chainId: g.toChainID ?? g.chainID
      }, f = g.isSwap ? (y = C == null ? void 0 : C[g.transferIndex]) == null ? void 0 : y.fromExplorerLink : (F = C == null ? void 0 : C[g.transferIndex]) == null ? void 0 : F.toExplorerLink, w = o === Ge.confirmed ? "completed" : (I = C == null ? void 0 : C[g.transferIndex]) == null ? void 0 : I.status;
      return /* @__PURE__ */ r.jsxs($e.Fragment, { children: [
        /* @__PURE__ */ r.jsxs(a2, { style: { height: "25px", position: "relative" }, align: "center", children: [
          /* @__PURE__ */ r.jsx(
            o2,
            {
              onMouseEnter: () => m(M),
              onMouseLeave: () => h(M),
              justify: "center",
              children: $D[g.type]
            }
          ),
          (s == null ? void 0 : s[M]) && /* @__PURE__ */ r.jsxs(i2, { children: [
            H,
            " with ",
            S.name,
            /* @__PURE__ */ r.jsx(c2, { width: "10", height: "10", src: S.image })
          ] })
        ] }),
        /* @__PURE__ */ r.jsx(
          Sr,
          {
            ...d,
            index: M,
            onClickEditDestinationWallet: q,
            context: M === e.length - 1 ? "destination" : "intermediary",
            isSignRequired: p == null ? void 0 : p.signRequired,
            status: w,
            explorerLink: f
          }
        )
      ] }, `row-${g.fromChain}-${g.toChainID}-${M}`);
    })
  ] }) });
}, i2 = V(G).attrs({
  normalTextColor: !0
})`
  position: absolute;
  left: 30px;
  padding: 10px;
  border-radius: 13px;
  border: 1px solid ${({ theme: e }) => e.primary.text.ultraLowContrast};
  background-color: ${({ theme: e }) => e.secondary.background.normal};
  box-sizing: border-box;
  z-index: 1;
`, o2 = V(re).attrs({
  as: re
})`
  color: ${({ theme: e }) => e.primary.text.lowContrast};
  &:hover {
    color: ${({ theme: e }) => e.primary.text.normal};
  }
`, t2 = V(re)`
  padding: 25px;
  gap: 20px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
  border-radius: 25px;
  min-height: 225px;
`, c2 = V.img`
  margin-left: 5px;
  object-fit: contain;
  width: 10px;
  height: 10px;
`, a2 = V(U)`
  position: relative;
  height: 25px;
`, r2 = () => {
  const [e, n] = ue(En), { route: i } = X(pn), o = i == null ? void 0 : i.requiredChainAddresses, { data: t } = X(Te), c = X(Nc);
  ue(wx);
  const { createCosmosWallets: a } = im(), { createEvmWallets: s } = om(), { createSolanaWallets: l } = tm(), m = Je(cm), h = K(() => i != null && i.operations ? Ft(i.operations).filter((C) => C.signRequired).map((C) => C.fromChainID) : void 0, [i == null ? void 0 : i.operations]);
  Xe(() => {
    var b;
    const D = {};
    i != null && i.operations && ((b = i == null ? void 0 : i.requiredChainAddresses) == null || b.forEach((C, k) => {
      D[k] = {
        chainID: C
      };
    }), n(D));
  }, []);
  const u = async (D) => {
    o && o.forEach(async (b, C) => {
      var x, g, M;
      const k = t == null ? void 0 : t.find((H) => H.chainID === b);
      if (!k)
        return;
      const q = h == null ? void 0 : h.includes(b);
      switch (k.chainType) {
        case "cosmos": {
          const P = a(b).find((S) => {
            var p;
            return S.walletName === ((p = c.cosmos) == null ? void 0 : p.walletName);
          });
          if (!P) {
            if (!D || e[C].address) return;
            m.show({
              signRequired: q,
              chainId: b,
              chainAddressIndex: C
            });
            return;
          }
          try {
            const S = await ((x = P == null ? void 0 : P.getAddress) == null ? void 0 : x.call(P, {
              signRequired: q
            }));
            if (!S)
              return;
            n((p) => ({
              ...p,
              [C]: {
                chainID: b,
                address: S,
                chainType: "cosmos",
                source: "wallet",
                wallet: {
                  walletName: P == null ? void 0 : P.walletName,
                  walletPrettyName: P == null ? void 0 : P.walletPrettyName,
                  walletChainType: P == null ? void 0 : P.walletChainType,
                  walletInfo: P == null ? void 0 : P.walletInfo
                }
              }
            }));
          } catch {
            return;
          }
          break;
        }
        case "svm": {
          const P = l().find((S) => {
            var p;
            return S.walletName === ((p = c.svm) == null ? void 0 : p.walletName);
          });
          if (!P) {
            if (!D) return;
            m.show({
              signRequired: q,
              chainId: b
            });
            return;
          }
          try {
            const S = await ((g = P == null ? void 0 : P.getAddress) == null ? void 0 : g.call(P, {
              signRequired: q
            }));
            if (!S)
              return;
            n((p) => ({
              ...p,
              [C]: {
                chainID: b,
                address: S,
                chainType: "svm",
                source: "wallet",
                wallet: {
                  walletName: P == null ? void 0 : P.walletName,
                  walletPrettyName: P == null ? void 0 : P.walletPrettyName,
                  walletChainType: P == null ? void 0 : P.walletChainType,
                  walletInfo: P == null ? void 0 : P.walletInfo
                }
              }
            }));
          } catch {
            return;
          }
          break;
        }
        case "evm": {
          const P = s(b).find((S) => {
            var p;
            return S.walletName === ((p = c.evm) == null ? void 0 : p.walletName);
          });
          if (!P) {
            if (!D) return;
            m.show({
              signRequired: q,
              chainId: b
            });
            return;
          }
          try {
            const S = await ((M = P == null ? void 0 : P.getAddress) == null ? void 0 : M.call(P, {
              signRequired: q
            }));
            if (!S)
              return;
            n((p) => ({
              ...p,
              [C]: {
                chainID: b,
                address: S,
                chainType: "evm",
                source: "wallet",
                wallet: {
                  walletName: P == null ? void 0 : P.walletName,
                  walletPrettyName: P == null ? void 0 : P.walletPrettyName,
                  walletChainType: P == null ? void 0 : P.walletChainType,
                  walletInfo: P == null ? void 0 : P.walletInfo
                }
              }
            }));
          } catch {
            return;
          }
          break;
        }
      }
    });
  };
  return Ec({
    queryKey: ["auto-set-address", { requiredChainAddresses: o, chains: t, sourceWallet: c, signRequiredChains: h }],
    enabled: !!o && !!t && (!!c.cosmos || !!c.evm || !!c.svm),
    queryFn: async () => {
      if (o)
        return await u(), null;
    },
    refetchOnWindowFocus: !1,
    refetchOnReconnect: !1
  }), { connectRequiredChains: u };
}, rm = ({
  txs: e,
  txsRequired: n,
  enabled: i
}) => {
  const o = X(Sn), [t, c] = be(!1), [a, s] = be(void 0), l = K(
    () => ["txs-status", n, e],
    [e, n]
  );
  return Ec({
    queryKey: l,
    queryFn: async ({ queryKey: [, m, h] }) => {
      if (!h) return;
      const u = await Promise.all(
        h.map(async (x) => await o.transactionStatus({
          chainID: x.chainID,
          txHash: x.txHash
        }))
      ), D = YD(u), b = u.every((x) => x.state === "STATE_COMPLETED_SUCCESS" || x.state === "STATE_COMPLETED_ERROR" || x.state === "STATE_ABANDONED"), C = D.every((x) => x.status === "completed"), k = m === u.length && b;
      k && c(!0);
      const q = u.length > 0 ? QD(u[u.length - 1].state) : void 0, E = {
        isSuccess: q === "success" && k || C && k,
        lastTxStatus: q,
        isSettled: k,
        transferEvents: D
      };
      return s(E), E;
    },
    enabled: !t && (e && e.length > 0 && i !== void 0 ? i : !0),
    refetchInterval: 500,
    // to make the data persist when query key changed
    initialData: a
  });
}, s2 = (e) => {
  const { route: n, transactionDetailsArray: i } = X(
    pn
  ), o = Z(_e), t = Z(so), [c, a] = be();
  Xe(() => {
    if (!(!(n != null && n.estimatedRouteDurationSeconds) || !(n != null && n.txsRequired))) {
      if (e === Ge.pending && c === void 0 && n.txsRequired === i.length) {
        const s = i[i.length - 1], l = setTimeout(() => {
          o({
            errorType: Le.Timeout,
            onClickBack: () => {
              t("unconfirmed");
            },
            explorerLink: (s == null ? void 0 : s.explorerLink) ?? "",
            txHash: s == null ? void 0 : s.txHash
          });
        }, n.estimatedRouteDurationSeconds * 1e3 * 2);
        a(l);
      }
      return e === Ge.confirmed && c !== void 0 && clearTimeout(c), () => {
        clearTimeout(c);
      };
    }
  }, [
    n,
    o,
    t,
    e,
    i,
    c
  ]);
}, sm = ({
  statusData: e,
  historyIndex: n
}) => {
  const i = e == null ? void 0 : e.transferEvents, o = Z(so), {
    route: t,
    transactionDetailsArray: c,
    overallStatus: a,
    transactionHistoryIndex: s
  } = X(pn), l = Z(ql), { isPending: m } = X(Sl), h = K(() => t != null && t.operations ? Ft(t.operations) : [], [t == null ? void 0 : t.operations]), u = K(() => {
    if (!(!(t != null && t.operations) || !(t != null && t.txsRequired))) {
      if ((e == null ? void 0 : e.lastTxStatus) === "pending")
        return m && o("pending"), "pending";
      if ((i == null ? void 0 : i.length) === 0 && !(e != null && e.isSettled)) {
        m && o("signing");
        return;
      }
      if (i) {
        if (e.isSuccess)
          return "completed";
        if (!e.isSuccess && e.isSettled)
          return "failed";
        if (i != null && i.find(({ status: D }) => D === "pending"))
          return "pending";
        if (i != null && i.every(
          ({ status: D }) => D === "unconfirmed"
        ))
          return "unconfirmed";
      }
    }
  }, [m, t == null ? void 0 : t.operations, t == null ? void 0 : t.txsRequired, o, e == null ? void 0 : e.isSettled, e == null ? void 0 : e.isSuccess, e == null ? void 0 : e.lastTxStatus, i]);
  Xe(() => {
    u && (l(n ?? s, {
      status: u
    }), n || o(u));
  }, [h, a, u, o, c.length, l, s, n]);
};
var Ge = /* @__PURE__ */ ((e) => (e[e.recoveryAddressUnset = 0] = "recoveryAddressUnset", e[e.destinationAddressUnset = 1] = "destinationAddressUnset", e[e.ready = 2] = "ready", e[e.pending = 3] = "pending", e[e.waitingForSigning = 4] = "waitingForSigning", e[e.confirmed = 5] = "confirmed", e[e.validatingGasBalance = 6] = "validatingGasBalance", e))(Ge || {});
const l2 = () => {
  const e = ke(), n = Z(Tn), {
    route: i,
    overallStatus: o,
    transactionDetailsArray: t,
    isValidatingGasBalance: c
  } = X(pn), a = X(En), { connectRequiredChains: s } = r2(), [l, m] = be(!0), h = Je(cm), u = Z(Bl), { mutate: D } = X(Sl), { data: b } = rm({
    txsRequired: i == null ? void 0 : i.txsRequired,
    txs: t
  });
  sm({
    statusData: b
  });
  const C = K(() => i != null && i.operations ? Ft(i.operations) : [], [i == null ? void 0 : i.operations]), k = C[C.length - 1], q = K(() => {
    var S;
    if (!a) return;
    const M = i == null ? void 0 : i.requiredChainAddresses;
    if (!M) return;
    const H = M.every(
      (p, d) => {
        var f;
        return (f = a[d]) == null ? void 0 : f.address;
      }
    ), P = (S = a[M.length - 1]) == null ? void 0 : S.address;
    return o === "completed" ? 5 : o === "pending" ? 3 : (c == null ? void 0 : c.status) !== "completed" && c ? 6 : o === "signing" ? 4 : P ? H ? 2 : 0 : 1;
  }, [
    a,
    c,
    o,
    i == null ? void 0 : i.requiredChainAddresses
  ]);
  s2(q);
  const E = K(() => {
    const M = ((i == null ? void 0 : i.txsRequired) ?? 0) - (t == null ? void 0 : t.length);
    if (M > 1)
      return /* @__PURE__ */ r.jsxs(zl, { gap: 5, align: "center", children: [
        /* @__PURE__ */ r.jsx(Qc, {}),
        M,
        " ",
        ao("Signature", M),
        " ",
        "still required"
      ] });
  }, [i == null ? void 0 : i.txsRequired, t == null ? void 0 : t.length]), x = K(() => {
    switch (q) {
      case 0:
        return /* @__PURE__ */ r.jsx(
          Ce,
          {
            label: "Set recovery address",
            icon: Q.rightArrow,
            onClick: () => {
              s(!0);
            }
          }
        );
      case 1:
        return /* @__PURE__ */ r.jsx(
          Ce,
          {
            label: "Set destination address",
            icon: Q.rightArrow,
            onClick: () => {
              const M = i == null ? void 0 : i.destAssetChainID;
              M && h.show({
                signRequired: k.signRequired,
                chainId: M
              });
            }
          }
        );
      case 2:
        return /* @__PURE__ */ r.jsx(
          Ce,
          {
            label: "Confirm swap",
            icon: Q.rightArrow,
            onClick: D
          }
        );
      case 6:
        return /* @__PURE__ */ r.jsx(
          Ce,
          {
            label: "Validating gas and balance",
            icon: Q.rightArrow,
            loading: !0
          }
        );
      case 4:
        return /* @__PURE__ */ r.jsx(Ce, { label: "Confirm swap", icon: Q.rightArrow, loading: !0 });
      case 3:
        return /* @__PURE__ */ r.jsx(
          Ce,
          {
            label: "Swap in progress",
            loading: !0,
            loadingTimeString: El(
              i == null ? void 0 : i.estimatedRouteDurationSeconds
            )
          }
        );
      case 5:
        return /* @__PURE__ */ r.jsx(
          Ce,
          {
            label: "Swap again",
            icon: Q.checkmark,
            backgroundColor: e.success.text,
            onClick: () => {
              u(), n(Ue.SwapPage);
            }
          }
        );
    }
  }, [
    u,
    s,
    k.signRequired,
    D,
    i == null ? void 0 : i.destAssetChainID,
    i == null ? void 0 : i.estimatedRouteDurationSeconds,
    n,
    h,
    q,
    e.success.text
  ]), g = l ? UD : n2;
  return /* @__PURE__ */ r.jsxs(re, { gap: 5, children: [
    /* @__PURE__ */ r.jsx(
      yn,
      {
        leftButton: l ? {
          label: "Back",
          icon: Q.thinArrow,
          onClick: () => n(Ue.SwapPage)
        } : void 0,
        rightButton: {
          label: l ? "Details" : "Hide details",
          icon: l ? Q.hamburger : Q.horizontalLine,
          onClick: () => m(!l)
        }
      }
    ),
    /* @__PURE__ */ r.jsx(
      g,
      {
        onClickEditDestinationWallet: () => h.show({
          chainId: i == null ? void 0 : i.destAssetChainID,
          signRequired: k.signRequired
        }),
        operations: C,
        statusData: b,
        swapExecutionState: q
      }
    ),
    x,
    /* @__PURE__ */ r.jsx(
      ea,
      {
        showRouteInfo: o === void 0,
        rightContent: E
      }
    )
  ] });
}, Cc = V.div`
  ${({ width: e, height: n, theme: i }) => He`
      width: ${e}px;
      height: ${n}px;
      background-color: ${qc(i.primary.text.normal ?? "") + sn(10)};
    `};
`, m2 = V(Cc)`
  border-radius: 50%;
`;
function p2(e, n = 500, i = !1) {
  const o = ee(
    void 0
  ), t = ee(e), c = ee(!1), a = ee(
    e,
    (l, m, h) => {
      clearTimeout(l(o));
      const u = l(t), D = typeof h == "function" ? h(u) : h, b = () => {
        m(t, D), m(c, !0);
      }, C = () => {
        m(a, D), m(c, !1);
      };
      if (b(), !i && D === e) {
        C();
        return;
      }
      const k = setTimeout(() => {
        C();
      }, n);
      m(o, k);
    }
  ), s = ee(null, (l, m, h) => {
    clearTimeout(l(o)), m(c, !1);
  });
  return {
    currentValueAtom: ee((l) => l(t)),
    isDebouncingAtom: c,
    clearTimeoutAtom: s,
    debouncedValueAtom: a
  };
}
const lm = p2(void 0), ca = pi((e) => {
  const n = e(Sn), i = e(lm.debouncedValueAtom), o = e(ct), t = Object.values(i ?? {}).length > 0 && !o;
  return {
    queryKey: ["skipBalances", i],
    queryFn: async () => {
      if (!i)
        throw new Error("No balance request provided");
      return n.balances(i);
    },
    enabled: t,
    refetchInterval: 1e3 * 60,
    retry: 1,
    gcTime: 0
  };
}), aa = () => {
  const { data: e } = X(ca);
  return ze((i, o) => {
    var t, c, a;
    return (a = (c = (t = e == null ? void 0 : e.chains) == null ? void 0 : t[i]) == null ? void 0 : c.denoms) == null ? void 0 : a[o];
  }, [e]);
}, mm = ({
  selectedGroup: e,
  searchQuery: n = "",
  context: i
}) => {
  const { data: o } = X(Te), t = X($c), c = aa();
  return K(() => {
    if (!e || !o) return;
    const s = e.assets.map((l) => {
      const m = o.find((h) => h.chainID === l.chainID);
      return m ? { ...m, asset: l } : null;
    }).filter((l) => {
      if (!l) return !1;
      const m = !(t != null && t[i]) || Object.keys(t[i]).includes(l.chainID), h = i !== "source" || !l.chainID.includes("penumbra");
      return m && h;
    });
    return ns(s, n, {
      keys: ["prettyName", "chainName", "chainID"]
    }).sort((l, m) => {
      var C, k;
      const h = Number(((C = c(l.chainID, l.asset.denom)) == null ? void 0 : C.valueUSD) ?? 0), u = Number(((k = c(m.chainID, m.asset.denom)) == null ? void 0 : k.valueUSD) ?? 0);
      if (u !== h)
        return u - h;
      const D = l.asset.originChainID === l.chainID;
      return m.asset.originChainID === m.chainID ? 1 : D ? -1 : 0;
    });
  }, [t, o, i, c, n, e]);
}, kc = (e) => e.chains !== void 0, u2 = ({
  item: e,
  index: n,
  skeleton: i,
  onSelect: o,
  context: t
}) => {
  const { isLoading: c } = X(Te), a = aa();
  if (!e || c) return i;
  if (kc(e))
    return /* @__PURE__ */ r.jsx(
      qi,
      {
        onClick: () => o(e),
        style: { margin: "5px 0" },
        leftContent: /* @__PURE__ */ r.jsx(h2, { item: e, context: t }),
        rightContent: Number(e.totalAmount) > 0 && /* @__PURE__ */ r.jsxs(re, { align: "flex-end", children: [
          /* @__PURE__ */ r.jsx(G, { normalTextColor: !0, children: parseFloat(e.totalAmount.toFixed(8)) }),
          Number(e.totalUsd) > 0 && /* @__PURE__ */ r.jsx(G, { children: Zn(e.totalUsd) })
        ] })
      },
      `${n}${e.id}`
    );
  const s = a(e.asset.chainID, e.asset.denom);
  return /* @__PURE__ */ r.jsx(
    qi,
    {
      onClick: () => o(e.asset),
      style: { margin: "5px 0" },
      leftContent: /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 8, children: [
        /* @__PURE__ */ r.jsx(
          pm,
          {
            height: 35,
            width: 35,
            src: e == null ? void 0 : e.logoURI,
            alt: `${e.chainID} logo`
          }
        ),
        /* @__PURE__ */ r.jsxs(U, { align: "end", gap: 8, children: [
          /* @__PURE__ */ r.jsx(Pe, { children: e.prettyName }),
          /* @__PURE__ */ r.jsx(G, { children: e.chainID })
        ] })
      ] }),
      rightContent: s && Number(s.amount) > 0 && /* @__PURE__ */ r.jsxs(re, { align: "flex-end", children: [
        /* @__PURE__ */ r.jsx(G, { normalTextColor: !0, children: wn(
          s.amount,
          s.decimals
        ) }),
        s.valueUSD && /* @__PURE__ */ r.jsx(G, { children: Zn(s.valueUSD) })
      ] })
    },
    e.chainID
  );
}, h2 = ({
  item: e,
  context: n
}) => {
  var t;
  const i = mm({ selectedGroup: e, context: n }) ?? [], o = ((t = e.assets.find((c) => {
    var a;
    return (a = c.logoURI) == null ? void 0 : a.includes("raw.githubusercontent");
  })) == null ? void 0 : t.logoURI) ?? e.assets[0].logoURI;
  return /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 8, children: [
    /* @__PURE__ */ r.jsx(
      pm,
      {
        height: 35,
        width: 35,
        src: o,
        alt: `${e.assets[0].recommendedSymbol} logo`
      }
    ),
    /* @__PURE__ */ r.jsxs(U, { align: "end", gap: 8, children: [
      /* @__PURE__ */ r.jsx(Pe, { children: e.assets[0].recommendedSymbol }),
      i.length > 1 ? /* @__PURE__ */ r.jsx(G, { children: `${i.length} networks` }) : i.map((c, a) => /* @__PURE__ */ r.jsx(U, { align: "center", gap: 6, children: /* @__PURE__ */ r.jsx(G, { children: c.chainName }) }, a))
    ] })
  ] });
}, pm = V.img`
  border-radius: 50%;
  object-fit: cover;
  ${({ theme: e }) => `background-color: ${e.secondary.background.hover};`};
`, Lr = () => /* @__PURE__ */ r.jsx(
  qi,
  {
    style: { margin: "5px 0" },
    leftContent: /* @__PURE__ */ r.jsxs(d2, { align: "center", gap: 10, children: [
      /* @__PURE__ */ r.jsx(m2, { width: 35, height: 35 }),
      /* @__PURE__ */ r.jsx(Cc, { width: 80, height: 20 }),
      /* @__PURE__ */ r.jsx(Cc, { width: 60, height: 16 })
    ] })
  }
), d2 = V(U)`
  filter: blur(4px);
`, x2 = ({
  color: e = "currentColor",
  className: n
}) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: "21",
    height: "20",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: n,
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M15.347 9.01315C15.347 10.6201 14.7218 12.132 13.5847 13.2673C12.4475 14.4045 10.9374 15.0297 9.33047 15.0297C7.7235 15.0297 6.21159 14.4045 5.07629 13.2673C3.93916 12.1302 3.31392 10.6201 3.31392 9.01315C3.31392 7.40618 3.93916 5.89427 5.07629 4.75897C6.21342 3.62184 7.7235 2.9966 9.33047 2.9966C10.9374 2.9966 12.4494 3.62184 13.5847 4.75897C14.7218 5.8961 15.347 7.40618 15.347 9.01315ZM15.5244 2.81927C13.7912 1.08615 11.4585 0.168405 8.99408 0.259814C4.50407 0.426178 0.820279 4.04964 0.584443 8.536C0.430876 11.441 1.67953 14.1741 4.01412 15.9767C5.14759 16.8524 6.49313 17.4338 7.90997 17.6586C9.69976 17.942 11.4091 17.6787 12.8991 17.0096C13.9448 16.5398 15.177 16.7957 15.9869 17.6056L18.1277 19.7464L20.0674 17.8067L17.901 15.6403C17.0948 14.8341 16.8681 13.6147 17.3324 12.5745C17.8206 11.4849 18.0911 10.2801 18.0911 9.01132C18.0911 6.67125 17.1807 4.47195 15.5262 2.81744",
        fill: e
      }
    )
  }
), D2 = ({
  color: e = "currentColor",
  backgroundColor: n = "transparent"
}) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ r.jsx("rect", { width: "40", height: "40", rx: "10", fill: n }),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M11.9383 15.031L9.5 17.4693L17.0773 25.0449C17.0785 25.0461 17.0798 25.0474 17.081 25.0486L20.0023 27.9692L29.281 18.6907C29.2832 18.6884 29.2855 18.6861 29.2878 18.6838L30.5 17.4716L28.0617 15.0333L22.9273 20.1692C22.9246 20.1719 22.922 20.1745 22.9193 20.1771C21.3072 21.7811 18.7025 21.7826 17.0887 20.1813C17.0847 20.1774 17.0808 20.1736 17.0769 20.1696L11.9383 15.031Z",
          fill: e
        }
      )
    ]
  }
), g2 = ({
  color: e = "currentColor",
  direction: n,
  ...i
}) => /* @__PURE__ */ r.jsx("svg", { width: "9", height: "7", viewBox: "0 0 9 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", transform: n === "up" ? "rotate(180)" : "", ...i, children: /* @__PURE__ */ r.jsx("path", { d: "M4.44881 6.98877L0.420326 0.0112305L8.47729 0.0112305L4.44881 6.98877Z", fill: e }) }), Or = ({
  value: e,
  usdValue: n,
  onChangeValue: i,
  selectedAsset: o,
  handleChangeAsset: t,
  handleChangeChain: c,
  priceChangePercentage: a,
  isWaitingToUpdateInputValue: s,
  badPriceWarning: l
}) => {
  const m = ke(), [h, u] = be(!1), D = h || l, b = en({
    assetDenom: o == null ? void 0 : o.denom,
    amount: e,
    chainId: o == null ? void 0 : o.chainID
  }), C = (x) => {
    if (!i) return;
    let g = x.target.value;
    g.match(/^[.,]/) && (g = `0.${g}`), g = g.replace(/^[0]{2,}/, "0"), g = g.replace(/[^\d.,]/g, ""), g = g.replace(/[.]{2,}/g, "."), g = g.replace(/[,]{2,}/g, ",");
    const M = Xt(g);
    i == null || i(uo(M, b == null ? void 0 : b.decimals));
  }, k = (x) => {
    if (!i) return;
    let g;
    switch (x.key) {
      case "Escape":
        x.currentTarget.selectionStart === x.currentTarget.selectionEnd && x.currentTarget.select();
        return;
      case "ArrowUp":
        x.preventDefault(), g = new Ke(Xt(x.currentTarget.value) || "0"), x.shiftKey ? g = g.plus(10) : x.altKey || x.ctrlKey || x.metaKey ? g = g.plus(0.1) : g = g.plus(1), g.isNegative() && (g = new Ke(0)), i(g.toString());
        break;
      case "ArrowDown":
        x.preventDefault(), g = new Ke(Xt(x.currentTarget.value) || "0"), x.shiftKey ? g = g.minus(10) : x.altKey || x.ctrlKey || x.metaKey ? g = g.minus(0.1) : g = g.minus(1), g.isNegative() && (g = new Ke(0)), i(g.toString());
        break;
      default:
        return;
    }
  }, q = K(() => a ? a > 0 ? m.success.text : m.error.text : m.primary.text.normal, [
    a,
    m.error.text,
    m.primary.text.normal,
    m.success.text
  ]), E = W0(e || "");
  return /* @__PURE__ */ r.jsxs(f2, { justify: "space-between", padding: 20, borderRadius: 25, children: [
    /* @__PURE__ */ r.jsxs(U, { justify: "space-between", children: [
      /* @__PURE__ */ r.jsx(
        b2,
        {
          type: "text",
          value: E,
          placeholder: "0",
          inputMode: "numeric",
          onChange: C,
          onKeyDown: k,
          isWaitingToUpdateInputValue: s,
          valueLength: E.length
        }
      ),
      /* @__PURE__ */ r.jsxs(xn, { onClick: t, gap: 5, children: [
        b != null && b.assetImage && b.symbol ? /* @__PURE__ */ r.jsxs(ra, { align: "center", justify: "center", gap: 7, children: [
          /* @__PURE__ */ r.jsx(C2, { src: b.assetImage }),
          /* @__PURE__ */ r.jsx(Pe, { children: b.symbol })
        ] }) : /* @__PURE__ */ r.jsx(A2, { children: /* @__PURE__ */ r.jsx(Pe, { mainButtonColor: m.brandColor, children: "Select asset" }) }),
        /* @__PURE__ */ r.jsx(
          D2,
          {
            color: m.primary.background.normal,
            backgroundColor: m.primary.text.normal
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs(U, { justify: "space-between", align: "center", children: [
      a ? /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 6, children: [
        /* @__PURE__ */ r.jsx(
          ko,
          {
            color: l ? m.error.text : void 0,
            onMouseEnter: () => u(!0),
            onMouseLeave: () => u(!1),
            children: n && Zn(n)
          }
        ),
        /* @__PURE__ */ r.jsx(
          g2,
          {
            color: q,
            direction: (a ?? 0) > 0 ? "up" : "down",
            style: { scale: D ? "1" : "0.7" }
          }
        ),
        D && /* @__PURE__ */ r.jsxs(G, { color: q, children: [
          a,
          "%"
        ] })
      ] }) : /* @__PURE__ */ r.jsx(G, { children: n && Zn(n) }),
      b != null && b.chainName ? /* @__PURE__ */ r.jsx(li, { onClick: c, align: "center", secondary: !0, gap: 4, children: /* @__PURE__ */ r.jsxs(G, { children: [
        "on ",
        b == null ? void 0 : b.chainName
      ] }) }) : /* @__PURE__ */ r.jsx(fl, {})
    ] })
  ] });
}, f2 = V(re)`
  height: 110px;
  width: 480px;
  background-color: ${(e) => e.theme.primary.background.normal};
`, b2 = V.input`
  all: unset;
  font-size: ${({ valueLength: e }) => `${e > 15 ? 28 : e > 10 ? 32 : 38}px`};
  font-weight: 300;
  width: 100%;
  color: ${(e) => e.theme.primary.text.normal};
  background-color: ${(e) => e.theme.primary.background.normal};
  height: 50px;

  ${(e) => e.isWaitingToUpdateInputValue && "animation: pulse 2s cubic-bezier(.4,0,.6,1) infinite;"}
  @keyframes pulse {
    0% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.5;
    }
  }
`, ra = V(U).attrs({
  padding: 8
})`
  height: 40px;
  border-radius: 10px;
  white-space: nowrap;
  color: ${(e) => e.theme.primary.text.normal};
  background-color: ${(e) => e.theme.secondary.background.normal};
`, A2 = V(ra)`
  background-color: ${(e) => e.theme.brandColor};
`, C2 = V.img`
  border-radius: 50%;
  width: 23px;
  height: 23px;
  object-fit: cover;
`, k2 = ({
  asset: e,
  onSearch: n,
  onClickBack: i,
  searchTerm: o,
  setSearchTerm: t,
  onKeyDown: c
}) => {
  const a = ke(), s = yc(null), l = ze(
    (m) => {
      const h = m.target.value;
      t(h), n(h);
    },
    [n, t]
  );
  return Xe(() => {
    setTimeout(() => {
      var m;
      (m = s.current) == null || m.focus();
    }, 0);
  }, [e]), /* @__PURE__ */ r.jsxs(E2, { align: "center", gap: 5, children: [
    e ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
      /* @__PURE__ */ r.jsx(xn, { onClick: i, children: /* @__PURE__ */ r.jsx(v2, { color: a.primary.text.normal }) }),
      /* @__PURE__ */ r.jsxs(w2, { gap: 5, align: "center", justify: "center", children: [
        /* @__PURE__ */ r.jsx("img", { src: e.logoURI, width: 20, height: 20 }),
        /* @__PURE__ */ r.jsx(Pe, { children: e == null ? void 0 : e.symbol })
      ] })
    ] }) : /* @__PURE__ */ r.jsx(y2, { color: a.primary.text.normal }),
    /* @__PURE__ */ r.jsx(
      P2,
      {
        ref: s,
        style: { paddingLeft: e ? void 0 : 30 },
        type: "text",
        placeholder: e ? "Search network" : "Search asset",
        value: o,
        onChange: l,
        onKeyDown: c
      }
    ),
    /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 5, children: [
      /* @__PURE__ */ r.jsx(G, { style: { textWrap: "nowrap" }, children: " Powered by " }),
      /* @__PURE__ */ r.jsx(Pl, { color: a.primary.text.lowContrast })
    ] })
  ] });
}, v2 = V(Yc)`
  width: 25px;
  opacity: 0.5;
`, w2 = V(ra)`
  height: auto;
`, y2 = V(x2)`
  position: absolute;
  width: 20px;
  height: 20px;
`, E2 = V(U)`
  padding: 6px 10px;
  height: 50px;
  position: relative;
`, P2 = V.input`
  height: 40px;
  box-sizing: border-box;
  width: 100%;
  border: none;
  outline: none;
  color: ${({ theme: e }) => e.primary.text.normal};
  background-color: ${({ theme: e }) => e.primary.background.normal};
`, Ur = ["ATOM", "USDC", "USDT", "ETH", "TIA", "OSMO", "NTRN", "INJ"], F2 = ({
  groupedAssetsByRecommendedSymbol: e,
  searchQuery: n
}) => K(() => {
  if (e)
    return ns(e, n, {
      keys: ["id"]
    }).sort((o, t) => {
      if (o.totalUsd === 0 && t.totalUsd === 0) {
        const a = Ur.indexOf(o.id), s = Ur.indexOf(t.id);
        if (a !== -1 && s !== -1)
          return a - s;
        if (s !== -1) return 1;
        if (a !== -1) return -1;
      }
      return t.totalUsd - o.totalUsd;
    });
}, [e, n]), B2 = ({ context: e }) => {
  const { data: n } = X(Hn), i = aa(), o = X($c), t = K(() => {
    if (!o || !o[e]) return n;
    const a = Object.entries(o[e]);
    return a ? n == null ? void 0 : n.filter((s) => a.some((l) => {
      const [m, h] = l;
      if (h)
        return h.includes(s.denom) && m === s.chainID;
      if (m)
        return m === s.chainID;
    })) : n;
  }, [n, o, e]);
  return K(() => {
    if (!t) return;
    const a = [], s = (l) => l.reduce(
      (m, h) => {
        const u = i(h.chainID, h.denom);
        return u && (m.totalAmount += Number(
          wn(
            u.amount,
            u.decimals
          )
        ), Number(u.valueUSD) && (m.totalUsd += Number(u.valueUSD))), m;
      },
      { totalAmount: 0, totalUsd: 0 }
    );
    return t.forEach((l) => {
      const m = a.find(
        (h) => h.id === l.recommendedSymbol
      );
      m ? (m.assets.push(l), m.chains.push({
        chainID: l.chainID,
        chainName: l.chainName,
        originChainID: l.originChainID
      })) : a.push({
        id: l.recommendedSymbol || l.symbol || l.denom,
        chains: [
          {
            chainID: l.chainID,
            chainName: l.chainName,
            originChainID: l.originChainID
          }
        ],
        assets: [l],
        totalAmount: 0,
        totalUsd: 0
      });
    }), a.forEach((l) => {
      const m = s(l.assets);
      l.totalAmount = m.totalAmount, l.totalUsd = m.totalUsd;
    }), a;
  }, [t, i]);
}, M2 = Ui(
  (e) => {
    const n = Je(), { onSelect: i, selectedAsset: o, selectChain: t, context: c } = e, { data: a, isLoading: s } = X(Hn), { isLoading: l } = X(Te), m = s || l, [h, u] = be(!0), [D, b] = be(""), [C, k] = be(null), q = () => {
      b("");
    }, E = ze(
      (w) => {
        if (w) {
          if (kc(w)) {
            w.assets.length === 1 ? i(w.assets[0]) : k(w), q();
            return;
          }
          i(w), q();
        }
      },
      [i]
    ), x = B2({ context: c }), g = K(() => {
      const w = (C == null ? void 0 : C.assets[0]) || o;
      if (w)
        return x == null ? void 0 : x.find(
          (y) => y.id === w.recommendedSymbol
        );
    }, [
      C == null ? void 0 : C.assets,
      o,
      x
    ]), M = F2({ groupedAssetsByRecommendedSymbol: x, searchQuery: D }), H = mm({ selectedGroup: g, searchQuery: D, context: c });
    Xe(() => {
      if (!m && a) {
        const w = setTimeout(() => {
          u(!1);
        }, 100);
        return () => clearTimeout(w);
      }
    }, [m, a]), Xe(() => {
      b("");
    }, [n.visible]);
    const P = (w) => {
      b(w);
    }, S = ze(
      (w, y) => /* @__PURE__ */ r.jsx(
        u2,
        {
          item: w,
          index: y,
          onSelect: E,
          skeleton: /* @__PURE__ */ r.jsx(Lr, {}),
          context: c
        }
      ),
      [c, E]
    ), p = K(() => t || C ? H : M, [M, H, C, t]), d = () => {
      C === null ? n.remove() : k(null);
    }, f = (w) => {
      w.key === "Backspace" && C !== null && D === "" && k(null);
    };
    return /* @__PURE__ */ r.jsxs(j2, { children: [
      /* @__PURE__ */ r.jsx(
        k2,
        {
          onSearch: P,
          onClickBack: d,
          asset: (C == null ? void 0 : C.assets[0]) || o,
          searchTerm: D,
          setSearchTerm: b,
          onKeyDown: f
        }
      ),
      h || !M && !H ? /* @__PURE__ */ r.jsx(re, { children: Array.from({ length: 10 }, (w, y) => /* @__PURE__ */ r.jsx(Lr, {}, y)) }) : /* @__PURE__ */ r.jsx(
        na,
        {
          listItems: p ?? [],
          height: 530,
          itemHeight: 70,
          itemKey: (w) => kc(w) ? w.id : `${w.chainID}-${w.asset.denom}`,
          renderItem: S,
          empty: {
            header: g ? "No networks found" : "No assets found",
            details: g ? `Looking for an asset? 
 Select back to return to asset selection.` : `Looking for a network? 
 Select an asset first, then move to network selection.`
          }
        }
      )
    ] });
  }
), j2 = V(re)`
  padding: 10px;
  gap: 10px;
  width: 580px;
  height: 600px;
  border-radius: 20px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
  overflow: hidden;
`, z2 = ({ color: e = "currentColor" }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: "9",
    height: "11",
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M2.8108 1.87099L4.62035 3.73224C5.01216 4.13524 4.73524 4.82459 4.17993 4.82459L0.876057 4.82459L0.876056 6.43207L4.18067 6.43282C4.7345 6.43282 5.01289 7.12217 4.62108 7.52518L2.80933 9.3887L3.91406 10.525L8.67323 5.62984L3.91553 0.736215L2.8108 1.87251L2.8108 1.87099Z",
        fill: e
      }
    )
  }
), q2 = (e) => {
  var n;
  return !!((n = e == null ? void 0 : e.estimatedFees) != null && n.some(
    (i) => i.feeType === "SMART_RELAY"
  ));
}, I2 = (e, n) => {
  if (!e || !n) return;
  const i = n.filter(
    (l) => l.feeType === "SMART_RELAY"
    /* SMART_RELAY */
  );
  if (!i.every(
    (l, m, h) => l.originAsset.symbol === h[0].originAsset.symbol
  )) return;
  const t = i.reduce(
    (l, m) => l + Number(m.amount),
    0
  ), c = i.reduce(
    (l, m) => l + Number(m.usdAmount),
    0
  );
  if (!t || !c) return;
  const a = i[0].originAsset.decimals ?? 6, s = wn(t, a);
  return {
    assetAmount: Number(s),
    formattedAssetAmount: `${s} ${i[0].originAsset.symbol}`,
    formattedUsdAmount: `${Zn(c)}`
  };
}, S2 = ({ color: e = "currentColor", ...n }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.06616 14.199C10.9322 14.199 14.0662 11.065 14.0662 7.19897C14.0662 3.33298 10.9322 0.198975 7.06616 0.198975C3.20017 0.198975 0.0661621 3.33298 0.0661621 7.19897C0.0661621 11.065 3.20017 14.199 7.06616 14.199ZM7.22184 6.66477C6.5255 7.20041 6.2791 7.66107 6.2791 8.71094H7.54323C7.54323 8.07887 7.6825 7.78962 8.15387 7.42538L8.56096 7.12542C9.02162 6.78261 9.5037 6.11841 9.5037 5.34707C9.5037 4.07224 8.49668 3.27948 7.15757 3.27948C5.53991 3.27948 4.51147 4.26507 4.51147 5.83987H5.93629C5.93629 4.88642 6.38623 4.42576 7.13614 4.42576C7.75749 4.42576 8.14316 4.79 8.14316 5.38993C8.14316 5.74345 7.98246 6.07555 7.5968 6.37552L7.22184 6.66477ZM6.1077 9.37514V10.9714H7.72535V9.37514H6.1077Z",
        fill: e
      }
    )
  }
), H2 = () => {
  const [e, n] = be(!1), [i, o] = be(!1), [t, c] = be(""), [a, s] = ue(sx), l = !!(a && !jr.includes(a));
  return Xe(() => {
    l && c(a == null ? void 0 : a.toString());
  }, [a, l]), /* @__PURE__ */ r.jsxs(T2, { children: [
    /* @__PURE__ */ r.jsxs(V2, { children: [
      "Max Slippage",
      /* @__PURE__ */ r.jsx(fl, { width: 5 }),
      /* @__PURE__ */ r.jsx(
        S2,
        {
          onMouseEnter: () => n(!0),
          onMouseLeave: () => n(!1)
        }
      ),
      e && /* @__PURE__ */ r.jsx(R2, { children: "If price changes unfavorably during the transaction by more than this amount, the transaction will revert." })
    ] }),
    /* @__PURE__ */ r.jsxs(U, { gap: 4, children: [
      jr.map((m) => /* @__PURE__ */ r.jsxs(
        Wr,
        {
          monospace: !0,
          selected: m === a && !i,
          onClick: () => s(m),
          children: [
            m,
            "%"
          ]
        },
        m
      )),
      /* @__PURE__ */ r.jsx(N2, { children: l || i ? /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
        /* @__PURE__ */ r.jsx(
          L2,
          {
            type: "number",
            value: t,
            selected: !i,
            onChange: (m) => c(m.target.value),
            onFocus: () => o(!0),
            onBlur: () => {
              const m = parseFloat(t);
              !isNaN(m) && m >= 0 && m <= 100 && s(m), o(!1);
            },
            autoFocus: !0
          }
        ),
        /* @__PURE__ */ r.jsx(O2, { selected: !i, children: "%" })
      ] }) : /* @__PURE__ */ r.jsx(
        Wr,
        {
          monospace: !0,
          selected: l && !i,
          onClick: () => o(!0),
          children: "Custom"
        }
      ) })
    ] })
  ] });
}, T2 = V(U)`
  max-height: 25px;
  justify-content: space-between;
`, N2 = V.div`
  position: relative;
  width: 60px;
`, V2 = V(U).attrs({
  as: G,
  normalTextColor: !0
})`
  position: relative;
  letter-spacing: 0.26px;
`, R2 = V(G).attrs({
  normalTextColor: !0
})`
  position: absolute;
  padding: 13px;
  border-radius: 13px;
  border: 1px solid ${({ theme: e }) => e.primary.text.ultraLowContrast};
  background-color: ${({ theme: e }) => e.secondary.background.normal};
  top: -30px;
  left: 110px;
  width: 250px;
  z-index: 1;
`, Wr = V(G)`
  border-radius: 7px;
  padding: 4px 7px;
  white-space: nowrap;
  color: ${({ selected: e, theme: n }) => e ? xo(n.brandColor) : n.primary.text.normal};
  &:hover {
    box-shadow: inset 0px 0px 0px 1px ${({ theme: e }) => e.brandColor};
    opacity: 1;
    cursor: pointer;
  }
  ${({ selected: e, theme: n }) => e && He`
      background-color: ${n.brandColor};
      opacity: 1;
    `}
`, L2 = V(G).attrs({
  as: "input"
})`
  outline: none;
  background-color: ${({ theme: e }) => e.primary.background.normal};
  border: 1px solid ${({ theme: e }) => e.primary.text.normal};
  border-radius: 7px;
  color: ${({ theme: e }) => e.primary.text.normal};
  width: 100%;
  padding: 4px 5px;
  padding-right: 20px;
  box-sizing: border-box;
  text-align: center;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  ${({ selected: e, theme: n }) => e && He`
      color: ${xo(n.brandColor)};
      background-color: ${n.brandColor};
    `}
`, O2 = V(G)`
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  ${({ selected: e, theme: n }) => e && He`
      color: ${xo(n.brandColor)};
    `}
`, U2 = Ui((e) => {
  const { data: n } = X(Ji), { data: i } = X(Te), o = K(() => n == null ? void 0 : n.chainIDs.map(
    (u) => i == null ? void 0 : i.find((D) => D.chainID === u)
  ), [n, i]), t = n && Ft(n.operations), c = K(() => {
    if (t)
      return t == null ? void 0 : t.find(
        (u) => u.type === rn.axelarTransfer
      );
  }, [t]), a = K(() => {
    if (t)
      return t == null ? void 0 : t.find(
        (u) => u.type === rn.hyperlaneTransfer
      );
  }, [t]), s = K(() => {
    if (c) {
      const { feeAmount: u, feeAsset: D, usdFeeAmount: b } = c;
      if (!u || !D || !D.decimals) return;
      const C = wn(
        u,
        D.decimals
      );
      return {
        assetAmount: Number(C),
        formattedAssetAmount: `${C} ${D.symbol}`,
        formattedUsdAmount: b ? `${Zn(b)}` : void 0
      };
    }
  }, [c]), l = K(() => {
    if (a) {
      const { feeAmount: u, feeAsset: D, usdFeeAmount: b } = a;
      if (!u || !D || !D.decimals) return;
      const C = wn(
        u,
        D.decimals
      );
      return {
        assetAmount: Number(C),
        formattedAssetAmount: `${C} ${D.symbol}`,
        formattedUsdAmount: b ? `${Zn(b)}` : void 0
      };
    }
  }, [a]), m = q2(n), h = K(() => I2(m, n == null ? void 0 : n.estimatedFees), [m, n == null ? void 0 : n.estimatedFees]);
  return /* @__PURE__ */ r.jsxs(W2, { gap: 20, children: [
    /* @__PURE__ */ r.jsxs(re, { gap: 10, children: [
      /* @__PURE__ */ r.jsxs(U, { justify: "space-between", children: [
        /* @__PURE__ */ r.jsx(fn, { children: "Route" }),
        /* @__PURE__ */ r.jsx(U, { align: "center", gap: 5, children: o == null ? void 0 : o.map((u, D) => {
          var b, C;
          return /* @__PURE__ */ r.jsxs(Um, { children: [
            /* @__PURE__ */ r.jsx(
              "img",
              {
                width: "20",
                height: "20",
                src: u == null ? void 0 : u.logoURI,
                alt: u == null ? void 0 : u.prettyName,
                title: u == null ? void 0 : u.prettyName
              }
            ),
            D !== o.length - 1 && /* @__PURE__ */ r.jsx(z2, { color: (C = (b = e.theme) == null ? void 0 : b.primary) == null ? void 0 : C.text.normal })
          ] }, D);
        }) })
      ] }),
      !!(n != null && n.swapPriceImpactPercent) && /* @__PURE__ */ r.jsxs(U, { justify: "space-between", children: [
        /* @__PURE__ */ r.jsx(fn, { children: "Price Impact" }),
        /* @__PURE__ */ r.jsx(U, { align: "center", gap: 5, children: /* @__PURE__ */ r.jsxs(fn, { monospace: !0, children: [
          n == null ? void 0 : n.swapPriceImpactPercent,
          "%"
        ] }) })
      ] }),
      /* @__PURE__ */ r.jsx(
        H2,
        {}
      )
    ] }),
    (s || l || h) && /* @__PURE__ */ r.jsxs(re, { gap: 10, children: [
      s && /* @__PURE__ */ r.jsxs(U, { justify: "space-between", children: [
        /* @__PURE__ */ r.jsx(fn, { children: "Axelar Bridging Fee" }),
        /* @__PURE__ */ r.jsxs(fn, { monospace: !0, children: [
          s.formattedAssetAmount,
          " (",
          s.formattedUsdAmount,
          ")"
        ] })
      ] }),
      l && /* @__PURE__ */ r.jsxs(U, { justify: "space-between", children: [
        /* @__PURE__ */ r.jsx(fn, { children: "Hyperlane Bridging Fee" }),
        /* @__PURE__ */ r.jsxs(fn, { monospace: !0, children: [
          l.formattedAssetAmount,
          " (",
          l.formattedUsdAmount,
          ")"
        ] })
      ] }),
      h && /* @__PURE__ */ r.jsxs(U, { justify: "space-between", children: [
        /* @__PURE__ */ r.jsx(fn, { children: "Relayer Fee" }),
        /* @__PURE__ */ r.jsxs(fn, { monospace: !0, children: [
          h.formattedAssetAmount,
          " (",
          h.formattedUsdAmount,
          ")"
        ] })
      ] })
    ] }),
    /* @__PURE__ */ r.jsx(fn, { justify: "space-between", children: /* @__PURE__ */ r.jsx(jl, { showRouteInfo: !0 }) })
  ] });
}), W2 = V(re)`
  width: 480px;
  padding: 20px;
  border-radius: 20px;
  background-color: ${(e) => e.theme.primary.background.normal};
`, fn = V(U).attrs({
  as: G,
  normalTextColor: !0
})`
  position: relative;
  letter-spacing: 0.26px;
`, G2 = ({ color: e = "currentColor" }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: "47",
    height: "7",
    viewBox: "0 0 47 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: { display: "flex", alignItems: "center", justifyContent: "center" },
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.477783 0.000183105H46.4778V1.00416C45.1089 1.01674 44.0032 2.13029 44.0032 3.5021C44.0032 4.87391 45.1089 5.98746 46.4778 6.00004V7.00018H0.477783V5.99322C1.76984 5.89734 2.78833 4.81866 2.78833 3.5021C2.78833 2.18554 1.76984 1.10686 0.477783 1.01098V0.000183105Z",
        fill: e
      }
    )
  }
), J2 = () => {
  const e = ke(), [n, i] = be(!1), o = Z(rx), t = () => {
    o();
    let c;
    clearTimeout(c), i(!0), c = setTimeout(() => i(!1), 500);
  };
  return /* @__PURE__ */ r.jsxs(
    xn,
    {
      style: { position: "relative", cursor: "pointer", height: 5 },
      align: "center",
      onClick: t,
      disabled: n,
      children: [
        /* @__PURE__ */ r.jsx(G2, { color: e.primary.background.normal }),
        /* @__PURE__ */ r.jsx(K2, { spin: n, color: e.primary.text.normal })
      ]
    }
  );
}, K2 = V(am)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  @keyframes spin {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }

  ${({ spin: e }) => e && "animation: spin 0.5s cubic-bezier(.18,.89,.32,1.27);"};
`, um = Ui(
  (e) => {
    const { chainId: n, chainType: i, connectEco: o } = e, t = Je(), c = ta({ chainID: n, chainType: i });
    return /* @__PURE__ */ r.jsx(
      Vl,
      {
        title: "Connect wallet",
        walletList: c,
        onClickBackButton: () => t.remove(),
        isConnectEco: o
      }
    );
  }
), hm = () => {
  const [e] = ue(qe), i = hi()(e == null ? void 0 : e.chainID), { data: o, isLoading: t, refetch: c } = X(ca);
  return {
    data: K(() => {
      var u, D, b, C, k, q, E, x;
      if (!e || !i || !o) return;
      const { chainID: s, denom: l } = e;
      if (!l || !s) return;
      const m = !!((D = (u = o == null ? void 0 : o.chains) == null ? void 0 : u[s]) != null && D.denoms), h = (k = (C = (b = o == null ? void 0 : o.chains) == null ? void 0 : b[s]) == null ? void 0 : C.denoms) == null ? void 0 : k[l];
      return m && h === void 0 ? {
        amount: 0,
        formattedAmount: "0",
        error: void 0,
        decimals: void 0
      } : (x = (E = (q = o == null ? void 0 : o.chains) == null ? void 0 : q[s]) == null ? void 0 : E.denoms) == null ? void 0 : x[l];
    }, [e, i, o]),
    isLoading: t,
    refetch: c
  };
}, X2 = 2e6, Z2 = () => {
  var c, a, s, l, m, h, u, D, b, C;
  const [e] = ue(qe), [{ data: n }] = ue(Te), i = en({
    assetDenom: e == null ? void 0 : e.denom,
    amount: e == null ? void 0 : e.amount,
    chainId: e == null ? void 0 : e.chainID
  }), o = (a = (c = n == null ? void 0 : n.find((k) => k.chainID === (e == null ? void 0 : e.chainID))) == null ? void 0 : c.feeAssets) == null ? void 0 : a[0];
  switch ((s = i == null ? void 0 : i.chain) == null ? void 0 : s.chainType) {
    case "evm": {
      if (((l = e == null ? void 0 : e.denom) == null ? void 0 : l.includes("-native")) && (e == null ? void 0 : e.originChainID) === (e == null ? void 0 : e.chainID))
        switch (e == null ? void 0 : e.chainID) {
          case "1":
            return Number(Un(0.015, (m = i.asset) == null ? void 0 : m.decimals));
          case "137":
            return Number(Un(0.06, (h = i.asset) == null ? void 0 : h.decimals));
          case "43114":
            return Number(Un(0.02, (u = i.asset) == null ? void 0 : u.decimals));
          case "42220":
            return Number(Un(0.01, (D = i.asset) == null ? void 0 : D.decimals));
          default:
            return Number(Un(8e-4, (b = i.asset) == null ? void 0 : b.decimals));
        }
      return 0;
    }
    case "cosmos":
      return !((C = o == null ? void 0 : o.gasPrice) != null && C.average) || o.denom !== (e == null ? void 0 : e.denom) ? 0 : Number(o.gasPrice.average) * X2;
    case "svm":
    default:
      return 0;
  }
}, sa = () => {
  const { data: e } = hm(), n = Z2(), i = e == null ? void 0 : e.amount;
  if (n && i) {
    const o = Ke(i).minus(n).toString(), t = wn(o, e == null ? void 0 : e.decimals);
    return Number(t) > 0 ? t : "0";
  }
  return i && wn(String(i), e == null ? void 0 : e.decimals);
}, Y2 = () => {
  const e = sa(), n = Z(vo);
  return () => {
    e && n(e);
  };
}, Q2 = () => {
  const e = sa(), [n] = ue(qe);
  return n != null && n.amount ? e ? !Ke(e).isGreaterThanOrEqualTo(Ke(n == null ? void 0 : n.amount)) : !0 : !1;
}, _2 = 60, dm = 5, xm = Ui((e) => {
  const n = Je(), i = X(qe), { chainImage: o, chainName: t } = en({
    assetDenom: i == null ? void 0 : i.denom,
    chainId: i == null ? void 0 : i.chainID
  });
  return /* @__PURE__ */ r.jsxs(Tl, { gap: 15, children: [
    /* @__PURE__ */ r.jsx(
      ia,
      {
        title: "Wallets",
        onClickBackButton: n.remove,
        rightContent: () => i != null && i.chainID ? /* @__PURE__ */ r.jsx("img", { src: o, height: 36, width: 36, title: t }) : null
      }
    ),
    /* @__PURE__ */ r.jsxs(Nl, { height: (_2 + dm) * 3, children: [
      /* @__PURE__ */ r.jsx(Qt, { chainID: "cosmoshub-4", chainType: "cosmos" }, "cosmos"),
      /* @__PURE__ */ r.jsx(Qt, { chainID: "1", chainType: "evm" }, "evm"),
      /* @__PURE__ */ r.jsx(Qt, { chainID: "solana", chainType: "svm" }, "svm")
    ] })
  ] });
}), Qt = ({
  chainType: e,
  chainID: n
}) => {
  var u;
  const i = ke(), o = hi(), t = X(qe), { chain: c } = en({
    assetDenom: t == null ? void 0 : t.denom,
    chainId: t == null ? void 0 : t.chainID
  }), a = K(() => {
    const D = e === "cosmos" && (c == null ? void 0 : c.chainType) === "cosmos" || e === "evm" && (c == null ? void 0 : c.chainType) === "evm" || e === "svm" && (c == null ? void 0 : c.chainType) === "svm" ? t == null ? void 0 : t.chainID : n;
    return o(D, !0);
  }, [c == null ? void 0 : c.chainType, n, e, o, t == null ? void 0 : t.chainID]), s = zi(a == null ? void 0 : a.address), m = ta({ chainType: e }).find(
    (D) => D.walletName === (a == null ? void 0 : a.wallet.name)
  ), h = Je(um);
  return /* @__PURE__ */ r.jsx(
    qi,
    {
      style: { marginTop: dm },
      onClick: () => {
        h.show({
          chainType: e,
          connectEco: !0
        });
      },
      leftContent: a ? /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 10, children: [
        /* @__PURE__ */ r.jsx(
          "img",
          {
            height: 35,
            width: 35,
            style: { objectFit: "cover" },
            src: a == null ? void 0 : a.wallet.logo,
            alt: `${a == null ? void 0 : a.wallet.prettyName} logo`,
            title: a == null ? void 0 : a.wallet.prettyName
          }
        ),
        /* @__PURE__ */ r.jsxs(U, { align: "end", gap: 8, children: [
          /* @__PURE__ */ r.jsx(
            Mr,
            {
              title: a == null ? void 0 : a.address,
              onClick: (D) => {
                D.stopPropagation(), vt(a == null ? void 0 : a.address);
              },
              children: s
            }
          ),
          e === "evm" && /* @__PURE__ */ r.jsx($2, { chainId: a == null ? void 0 : a.currentConnectedEVMChainId })
        ] })
      ] }) : /* @__PURE__ */ r.jsxs(Mr, { children: [
        "Connect to",
        " ",
        e === "cosmos" ? "Cosmos" : e === "evm" ? "Ethereum" : "Solana"
      ] }),
      rightContent: a ? /* @__PURE__ */ r.jsx(
        li,
        {
          onClick: (D) => {
            D.stopPropagation(), m == null || m.disconnect();
          },
          children: "Disconnect"
        }
      ) : /* @__PURE__ */ r.jsx(
        Zc,
        {
          color: (u = i == null ? void 0 : i.primary) == null ? void 0 : u.background.normal,
          backgroundColor: i.primary.text.normal
        }
      )
    }
  );
}, $2 = ({ chainId: e }) => {
  const n = ke(), { data: i } = X(Te), o = i == null ? void 0 : i.find((t) => t.chainID === e);
  return /* @__PURE__ */ r.jsx(Pe, { fontSize: 12, color: n.primary.text.lowContrast, children: o == null ? void 0 : o.prettyName });
}, e1 = (e) => /* @__PURE__ */ r.jsxs(
  "svg",
  {
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ r.jsx(
        "circle",
        {
          cx: "12",
          cy: "12",
          opacity: ".25",
          r: "10",
          stroke: "currentColor",
          strokeWidth: "4"
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z",
          fill: "currentColor",
          opacity: ".75"
        }
      )
    ]
  }
), n1 = () => {
  const e = X(qe), i = hi()(e == null ? void 0 : e.chainID), o = en({
    assetDenom: e == null ? void 0 : e.denom,
    amount: e == null ? void 0 : e.amount,
    chainId: e == null ? void 0 : e.chainID
  }), { data: t, isLoading: c } = hm(), a = Y2(), s = sa(), l = Je(xm), m = K(() => {
    var b;
    const h = o != null && o.symbol ? ` ${o == null ? void 0 : o.symbol}` : "";
    if ((b = t == null ? void 0 : t.error) != null && b.message) return "--";
    if (t === void 0) return;
    const u = t == null ? void 0 : t.amount;
    let D = t == null ? void 0 : t.formattedAmount;
    return u === "0" && (D = u), `${uo(D)}${h}`;
  }, [t, o == null ? void 0 : o.symbol]);
  return i ? /* @__PURE__ */ r.jsxs(
    U,
    {
      gap: 6,
      style: {
        paddingRight: 13
      },
      children: [
        /* @__PURE__ */ r.jsxs(
          li,
          {
            onClick: () => {
              l.show();
            },
            align: "center",
            gap: 8,
            children: [
              i && /* @__PURE__ */ r.jsx(
                "img",
                {
                  style: { objectFit: "cover" },
                  src: i == null ? void 0 : i.wallet.logo,
                  height: 16,
                  width: 16
                }
              ),
              c ? /* @__PURE__ */ r.jsx(
                "div",
                {
                  style: {
                    marginLeft: "8px",
                    marginRight: "8px",
                    position: "relative"
                  },
                  children: /* @__PURE__ */ r.jsx(
                    e1,
                    {
                      style: {
                        animation: "spin 1s linear infinite",
                        position: "absolute",
                        height: 14,
                        width: 14
                      }
                    }
                  )
                }
              ) : m
            ]
          }
        ),
        /* @__PURE__ */ r.jsx(
          li,
          {
            disabled: !t || (t == null ? void 0 : t.amount) === "0" || s === "0",
            onClick: a,
            align: "center",
            children: "Max"
          }
        )
      ]
    }
  ) : null;
}, i1 = () => {
  const e = hi(), { data: n } = X(Hn), i = Z(lm.debouncedValueAtom), { data: o } = X(Te), { chainId: t } = pt(), c = K(() => n == null ? void 0 : n.reduce((a, s) => {
    var D, b;
    const l = (D = e(s.chainID)) == null ? void 0 : D.address, m = o == null ? void 0 : o.find((C) => C.chainID === s.chainID), h = (m == null ? void 0 : m.chainType) === "evm", u = h && t ? (b = e(String(t))) == null ? void 0 : b.address : void 0;
    return h && u ? a[s.chainID] || (a[s.chainID] = {
      address: u
    }) : l && (a[s.chainID] || (a[s.chainID] = {
      address: l
    })), a;
  }, {}), [n, e, o, t]);
  Ec({
    queryKey: ["all-balances-request", c],
    queryFn: () => (c && i({
      chains: c || {}
    }), null)
  });
}, o1 = () => {
  const e = Z(
    ox
  ), n = Z(
    cx
  );
  Xe(() => () => {
    e(void 0), n(void 0);
  }, [
    n,
    e
  ]);
}, t1 = () => {
  const [e] = ue(Ji), [n] = ue(Kn), [i, o] = ue(qe), [t, c] = ue(Dn);
  Xe(() => {
    if (!e.data || !i || !t || (i == null ? void 0 : i.amount) === "" && n === "swap-in" || (t == null ? void 0 : t.amount) === "" && n === "swap-out") return;
    const a = wn(
      e.data.amountOut,
      t.decimals
    ), s = wn(
      e.data.amountIn,
      i.decimals
    ), l = qr(
      a,
      (t == null ? void 0 : t.amount) ?? "",
      po
    ), m = qr(
      s,
      (i == null ? void 0 : i.amount) ?? "",
      po
    );
    n === "swap-in" && l ? c((h) => ({
      ...h,
      amount: uo(a)
    })) : n === "swap-out" && m && o((h) => ({
      ...h,
      amount: uo(s)
    }));
  }, [
    e.data,
    i,
    t,
    n,
    o,
    c
  ]);
}, c1 = () => {
  var pe, _;
  const [e, n] = be(), [i, o] = be(!1), { data: t } = X(Te), [c, a] = ue(qe), s = Z(vo), l = Z(wt), [m] = ue(ax), [h, u] = ue(Dn), [D] = ue(Kn), [{ data: b }] = ue(Hn), C = Z(Tn), k = Q2(), q = Z(kx), E = Z(_e), { isLoading: x } = X(ca), {
    data: g,
    isError: M,
    error: H
  } = X(Ji), P = Je(U2), S = Je(M2), p = Je(um), d = Je(xm), f = Z(En);
  i1(), o1(), t1();
  const w = hi(), y = w(c == null ? void 0 : c.chainID), F = X(Xn), { chainId: I, connector: v } = pt(), B = I ? (pe = w(String(I))) == null ? void 0 : pe.address : void 0, z = ze(
    (O, ce) => {
      if (!(!O || !ce) && b)
        return b.find((ge) => ge.denom === O && ge.chainID === ce);
    },
    [b]
  ), j = ze(() => {
    S.show({
      context: "source",
      onSelect: (O) => {
        var ge, ye;
        ((ge = t == null ? void 0 : t.find((Be) => Be.chainID === (O == null ? void 0 : O.chainID))) == null ? void 0 : ge.chainType) === "evm" && B && O && O.chainID !== String(I) && v && ((ye = v.switchChain) == null || ye.call(v, {
          chainId: Number(O.chainID)
        })), a((Be) => ({
          ...Be,
          ...O
        })), s(""), l(""), S.hide();
      }
    });
  }, [
    t,
    v,
    B,
    I,
    l,
    a,
    s,
    S
  ]), T = ze(() => {
    S.show({
      context: "source",
      onSelect: (O) => {
        var ge, ye;
        ((ge = t == null ? void 0 : t.find((Be) => Be.chainID === (O == null ? void 0 : O.chainID))) == null ? void 0 : ge.chainType) === "evm" && B && O && O.chainID !== String(I) && v && ((ye = v.switchChain) == null || ye.call(v, {
          chainId: Number(O.chainID)
        })), a((Be) => ({
          ...Be,
          ...O
        })), S.hide();
      },
      selectedAsset: z(c == null ? void 0 : c.denom, c == null ? void 0 : c.chainID),
      selectChain: !0
    });
  }, [
    t,
    v,
    B,
    I,
    z,
    a,
    c == null ? void 0 : c.chainID,
    c == null ? void 0 : c.denom,
    S
  ]), L = ze(() => {
    S.show({
      context: "destination",
      onSelect: (O) => {
        u((ce) => ({
          ...ce,
          ...O
        })), S.hide();
      }
    });
  }, [u, S]), W = ze(() => {
    S.show({
      context: "destination",
      onSelect: (O) => {
        u((ce) => ({
          ...ce,
          ...O
        })), S.hide();
      },
      selectedAsset: z(
        h == null ? void 0 : h.denom,
        h == null ? void 0 : h.chainID
      ),
      selectChain: !0
    });
  }, [
    h == null ? void 0 : h.chainID,
    h == null ? void 0 : h.denom,
    z,
    u,
    S
  ]), J = K(() => y != null && y.address ? c != null && c.chainID ? h != null && h.chainID ? !(c != null && c.amount) && !(h != null && h.amount) ? /* @__PURE__ */ r.jsx(
    Ce,
    {
      label: "Please enter a valid amount",
      icon: Q.swap,
      disabled: !0
    }
  ) : m ? /* @__PURE__ */ r.jsx(Ce, { label: "Finding best route...", loading: !0 }) : M ? /* @__PURE__ */ r.jsx(Ce, { label: (H == null ? void 0 : H.message) ?? "No routes found", disabled: !0 }) : x ? /* @__PURE__ */ r.jsx(Ce, { label: "Fetching balances", loading: !0, icon: Q.swap }) : k ? /* @__PURE__ */ r.jsx(Ce, { label: "Insufficient balance", disabled: !0, icon: Q.swap }) : /* @__PURE__ */ r.jsx(
    Ce,
    {
      label: "Swap",
      icon: Q.swap,
      disabled: !g,
      onClick: () => {
        var O;
        if (((O = g == null ? void 0 : g.warning) == null ? void 0 : O.type) === "BAD_PRICE_WARNING") {
          E({
            errorType: Le.TradeWarning,
            onClickContinue: () => {
              E(void 0), f({}), C(Ue.SwapExecutionPage), q();
            },
            onClickBack: () => {
              E(void 0);
            },
            route: { ...g }
          });
          return;
        }
        f({}), C(Ue.SwapExecutionPage), q();
      }
    }
  ) : /* @__PURE__ */ r.jsx(
    Ce,
    {
      label: "Please select a destination asset",
      icon: Q.swap,
      disabled: !0
    }
  ) : /* @__PURE__ */ r.jsx(
    Ce,
    {
      label: "Please select a source asset",
      icon: Q.swap,
      disabled: !0
    }
  ) : /* @__PURE__ */ r.jsx(
    Ce,
    {
      label: "Connect Wallet",
      icon: Q.plus,
      onClick: () => {
        c != null && c.chainID ? p.show({
          chainId: c == null ? void 0 : c.chainID
        }) : d.show();
      }
    }
  ), [
    c == null ? void 0 : c.chainID,
    c == null ? void 0 : c.amount,
    h == null ? void 0 : h.chainID,
    h == null ? void 0 : h.amount,
    m,
    y == null ? void 0 : y.address,
    M,
    x,
    k,
    g,
    d,
    p,
    H == null ? void 0 : H.message,
    f,
    C,
    q,
    E
  ]), se = K(() => {
    if (!(!(g != null && g.usdAmountIn) || !(g != null && g.usdAmountOut) || m))
      return yl(g.usdAmountIn, g.usdAmountOut);
  }, [m, g == null ? void 0 : g.usdAmountIn, g == null ? void 0 : g.usdAmountOut]);
  return /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
    /* @__PURE__ */ r.jsxs(
      re,
      {
        gap: 5,
        style: {
          opacity: i ? 0.3 : 1
        },
        children: [
          /* @__PURE__ */ r.jsx(
            yn,
            {
              leftButton: F.length === 0 ? void 0 : {
                label: "History",
                icon: Q.history,
                onClick: () => C(Ue.TransactionHistoryPage)
              },
              rightContent: /* @__PURE__ */ r.jsx(n1, {})
            }
          ),
          /* @__PURE__ */ r.jsxs(re, { align: "center", children: [
            /* @__PURE__ */ r.jsx(
              Or,
              {
                selectedAsset: c,
                handleChangeAsset: j,
                handleChangeChain: T,
                isWaitingToUpdateInputValue: D === "swap-out" && m,
                value: c == null ? void 0 : c.amount,
                usdValue: g == null ? void 0 : g.usdAmountIn,
                onChangeValue: s
              }
            ),
            /* @__PURE__ */ r.jsx(J2, {}),
            /* @__PURE__ */ r.jsx(
              Or,
              {
                selectedAsset: h,
                handleChangeAsset: L,
                handleChangeChain: W,
                isWaitingToUpdateInputValue: D === "swap-in" && m,
                usdValue: g == null ? void 0 : g.usdAmountOut,
                value: h == null ? void 0 : h.amount,
                priceChangePercentage: Number(se),
                badPriceWarning: ((_ = g == null ? void 0 : g.warning) == null ? void 0 : _.type) === "BAD_PRICE_WARNING",
                onChangeValue: l
              }
            )
          ] }),
          J,
          /* @__PURE__ */ r.jsx(
            ea,
            {
              showRouteInfo: !0,
              disabled: M || m,
              showEstimatedTime: !0,
              onClick: () => P.show({
                drawer: !0,
                container: e,
                onOpenChange: (O) => o(!!O)
              })
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ r.jsx(
      "div",
      {
        id: "swap-flow-settings-container",
        ref: (O) => {
          O && e === void 0 && n(O);
        }
      }
    )
  ] });
}, a1 = ({ color: e = "currentColor" }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M8.29234 0.740229L8.27336 0.721238L5.83563 3.15897C5.31942 3.67517 4.4821 3.67517 3.96589 3.15897L1.52643 0.719513L0.61056 1.63539L0.591572 1.65524L3.0293 4.09297C3.54551 4.60918 3.54551 5.4465 3.0293 5.9627L0.589844 8.40216L1.50572 9.31804L1.52471 9.33616L3.96244 6.89843C4.47865 6.38223 5.31597 6.38223 5.83217 6.89843L8.27163 9.33789L9.1875 8.42201L9.20649 8.40216L6.76877 5.96443C6.25256 5.44823 6.25256 4.6109 6.76877 4.0947L9.20822 1.65524L8.29234 0.739367V0.740229Z",
        fill: e
      }
    )
  }
), r1 = ({ color: e = "currentColor" }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        opacity: "0.8",
        d: "M4.7998 9.59766V4.18359C4.7998 4.11182 4.77673 4.05286 4.73059 4.00671C4.68445 3.96057 4.62549 3.9375 4.55371 3.9375H4.06152C3.98975 3.9375 3.93079 3.96057 3.88464 4.00671C3.8385 4.05286 3.81543 4.11182 3.81543 4.18359V9.59766C3.81543 9.66943 3.8385 9.72839 3.88464 9.77454C3.93079 9.82068 3.98975 9.84375 4.06152 9.84375H4.55371C4.62549 9.84375 4.68445 9.82068 4.73059 9.77454C4.77673 9.72839 4.7998 9.66943 4.7998 9.59766ZM6.76855 9.59766V4.18359C6.76855 4.11182 6.74548 4.05286 6.69934 4.00671C6.6532 3.96057 6.59424 3.9375 6.52246 3.9375H6.03027C5.9585 3.9375 5.89954 3.96057 5.85339 4.00671C5.80725 4.05286 5.78418 4.11182 5.78418 4.18359V9.59766C5.78418 9.66943 5.80725 9.72839 5.85339 9.77454C5.89954 9.82068 5.9585 9.84375 6.03027 9.84375H6.52246C6.59424 9.84375 6.6532 9.82068 6.69934 9.77454C6.74548 9.72839 6.76855 9.66943 6.76855 9.59766ZM8.7373 9.59766V4.18359C8.7373 4.11182 8.71423 4.05286 8.66809 4.00671C8.62195 3.96057 8.56299 3.9375 8.49121 3.9375H7.99902C7.92725 3.9375 7.86829 3.96057 7.82214 4.00671C7.776 4.05286 7.75293 4.11182 7.75293 4.18359V9.59766C7.75293 9.66943 7.776 9.72839 7.82214 9.77454C7.86829 9.82068 7.92725 9.84375 7.99902 9.84375H8.49121C8.56299 9.84375 8.62195 9.82068 8.66809 9.77454C8.71423 9.72839 8.7373 9.66943 8.7373 9.59766ZM4.55371 1.96875H7.99902L7.62988 1.06897C7.59399 1.02283 7.55042 0.994629 7.49915 0.984375H5.06128C5.01001 0.994629 4.96643 1.02283 4.93054 1.06897L4.55371 1.96875ZM11.6904 2.21484V2.70703C11.6904 2.77881 11.6674 2.83777 11.6212 2.88391C11.5751 2.93005 11.5161 2.95312 11.4443 2.95312H10.7061V10.2437C10.7061 10.6692 10.5856 11.037 10.3446 11.3472C10.1036 11.6574 9.81397 11.8125 9.47559 11.8125H3.07715C2.73877 11.8125 2.4491 11.6625 2.20813 11.3626C1.96716 11.0627 1.84668 10.7 1.84668 10.2744V2.95312H1.1084C1.03662 2.95312 0.977661 2.93005 0.931518 2.88391C0.885376 2.83777 0.862305 2.77881 0.862305 2.70703V2.21484C0.862305 2.14307 0.885376 2.08411 0.931518 2.03796C0.977661 1.99182 1.03662 1.96875 1.1084 1.96875H3.48474L4.02307 0.684448C4.09998 0.49475 4.2384 0.333253 4.43835 0.199951C4.63831 0.0666497 4.84082 0 5.0459 0H7.50684C7.71192 0 7.91443 0.0666497 8.11438 0.199951C8.31433 0.333253 8.45276 0.49475 8.52966 0.684448L9.06799 1.96875H11.4443C11.5161 1.96875 11.5751 1.99182 11.6212 2.03796C11.6674 2.08411 11.6904 2.14307 11.6904 2.21484Z",
        fill: e
      }
    )
  }
), Dm = ({ color: e = "currentColor" }) => /* @__PURE__ */ r.jsx(
  "svg",
  {
    width: "10",
    height: "9",
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ r.jsx(
      "path",
      {
        d: "M3.99905 8.941L7.36606 5.574H0.463055V4.196H7.36606L3.99905 0.828999H5.72806L9.78406 4.885L5.72806 8.941H3.99905Z",
        fill: e
      }
    )
  }
), s1 = {
  unconfirmed: "Unconfirmed",
  signing: "In Progress",
  broadcasted: "In Progress",
  pending: "In Progress",
  completed: "Completed",
  failed: "Failed"
}, l1 = ({
  status: e,
  sourceChainName: n,
  destinationChainName: i,
  absoluteTimeString: o,
  transactionDetails: t,
  onClickDelete: c
}) => {
  var m, h, u;
  const a = ke(), s = K(() => {
    if (e === "failed")
      return a.error.text;
    if (e === "completed")
      return a.success.text;
  }, [e, a]), l = (D, b) => {
    b || vt(D);
  };
  return /* @__PURE__ */ r.jsxs(re, { padding: 10, gap: 10, children: [
    /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 10, children: [
      /* @__PURE__ */ r.jsx(Vo, { children: "Status" }),
      /* @__PURE__ */ r.jsxs(U, { gap: 5, align: "center", children: [
        /* @__PURE__ */ r.jsx(G, { normalTextColor: !0, color: s, children: s1[e] }),
        /* @__PURE__ */ r.jsxs(G, { children: [
          "at ",
          o
        ] })
      ] })
    ] }),
    /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 10, children: [
      /* @__PURE__ */ r.jsx(Vo, { children: "Chain route" }),
      /* @__PURE__ */ r.jsxs(U, { gap: 5, align: "center", children: [
        /* @__PURE__ */ r.jsx(G, { normalTextColor: !0, children: n }),
        /* @__PURE__ */ r.jsx(Dm, { color: a.primary.text.normal }),
        /* @__PURE__ */ r.jsx(G, { normalTextColor: !0, children: i })
      ] })
    ] }),
    t.length === 1 ? /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 10, children: [
      /* @__PURE__ */ r.jsx(Vo, { children: "Transaction ID" }),
      /* @__PURE__ */ r.jsxs(
        tt,
        {
          onClick: () => {
            var D, b;
            return l((D = t == null ? void 0 : t[0]) == null ? void 0 : D.txHash, (b = t == null ? void 0 : t[0]) == null ? void 0 : b.explorerLink);
          },
          href: (m = t == null ? void 0 : t[0]) == null ? void 0 : m.explorerLink,
          title: (h = t == null ? void 0 : t[0]) == null ? void 0 : h.txHash,
          target: "_blank",
          gap: 5,
          children: [
            /* @__PURE__ */ r.jsx(G, { normalTextColor: !0, children: zi((u = t == null ? void 0 : t[0]) == null ? void 0 : u.txHash) }),
            /* @__PURE__ */ r.jsx(G, { children: /* @__PURE__ */ r.jsx(mi, {}) })
          ]
        }
      )
    ] }) : t.map((D, b) => {
      const C = () => b === 0 ? "Initial transaction" : b === t.length - 1 ? "Final transaction" : "Transaction";
      return /* @__PURE__ */ r.jsxs(
        U,
        {
          align: "center",
          gap: 10,
          children: [
            /* @__PURE__ */ r.jsx(Vo, { children: C() }, `${b}-${D.txHash}`),
            /* @__PURE__ */ r.jsxs(
              tt,
              {
                onClick: () => l(D.txHash, D.explorerLink),
                href: D.explorerLink,
                title: D == null ? void 0 : D.txHash,
                target: "_blank",
                gap: 5,
                children: [
                  /* @__PURE__ */ r.jsx(G, { normalTextColor: !0, children: zi(D.txHash) }),
                  /* @__PURE__ */ r.jsx(G, { children: /* @__PURE__ */ r.jsx(mi, {}) })
                ]
              },
              `${b}-${D.txHash}`
            )
          ]
        },
        `${b}-${D.txHash}`
      );
    }),
    /* @__PURE__ */ r.jsx(U, { align: "center", style: { marginTop: 10 }, children: /* @__PURE__ */ r.jsxs(xn, { onClick: c, gap: 5, align: "center", children: [
      /* @__PURE__ */ r.jsx(G, { color: a.error.text, children: "Delete" }),
      /* @__PURE__ */ r.jsx(r1, { color: a.error.text })
    ] }) })
  ] });
}, Vo = V(G)`
  width: 100px;
`;
function vc(e) {
  "@babel/helpers - typeof";
  return vc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, vc(e);
}
function la(e, n) {
  if (n.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + n.length + " present");
}
function Ci(e) {
  la(1, arguments);
  var n = Object.prototype.toString.call(e);
  return e instanceof Date || vc(e) === "object" && n === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || n === "[object Number]" ? new Date(e) : ((typeof e == "string" || n === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
var m1 = {};
function p1() {
  return m1;
}
function Gr(e) {
  var n = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return n.setUTCFullYear(e.getFullYear()), e.getTime() - n.getTime();
}
function u1(e, n) {
  la(2, arguments);
  var i = Ci(e), o = Ci(n), t = i.getTime() - o.getTime();
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
var h1 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, d1 = function(n, i, o) {
  var t, c = h1[n];
  return typeof c == "string" ? t = c : i === 1 ? t = c.one : t = c.other.replace("{{count}}", i.toString()), o != null && o.addSuffix ? o.comparison && o.comparison > 0 ? "in " + t : t + " ago" : t;
};
function _t(e) {
  return function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = n.width ? String(n.width) : e.defaultWidth, o = e.formats[i] || e.formats[e.defaultWidth];
    return o;
  };
}
var x1 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, D1 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, g1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, f1 = {
  date: _t({
    formats: x1,
    defaultWidth: "full"
  }),
  time: _t({
    formats: D1,
    defaultWidth: "full"
  }),
  dateTime: _t({
    formats: g1,
    defaultWidth: "full"
  })
}, b1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, A1 = function(n, i, o, t) {
  return b1[n];
};
function io(e) {
  return function(n, i) {
    var o = i != null && i.context ? String(i.context) : "standalone", t;
    if (o === "formatting" && e.formattingValues) {
      var c = e.defaultFormattingWidth || e.defaultWidth, a = i != null && i.width ? String(i.width) : c;
      t = e.formattingValues[a] || e.formattingValues[c];
    } else {
      var s = e.defaultWidth, l = i != null && i.width ? String(i.width) : e.defaultWidth;
      t = e.values[l] || e.values[s];
    }
    var m = e.argumentCallback ? e.argumentCallback(n) : n;
    return t[m];
  };
}
var C1 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, k1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, v1 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, w1 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, y1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, E1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, P1 = function(n, i) {
  var o = Number(n), t = o % 100;
  if (t > 20 || t < 10)
    switch (t % 10) {
      case 1:
        return o + "st";
      case 2:
        return o + "nd";
      case 3:
        return o + "rd";
    }
  return o + "th";
}, F1 = {
  ordinalNumber: P1,
  era: io({
    values: C1,
    defaultWidth: "wide"
  }),
  quarter: io({
    values: k1,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: io({
    values: v1,
    defaultWidth: "wide"
  }),
  day: io({
    values: w1,
    defaultWidth: "wide"
  }),
  dayPeriod: io({
    values: y1,
    defaultWidth: "wide",
    formattingValues: E1,
    defaultFormattingWidth: "wide"
  })
};
function oo(e) {
  return function(n) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = i.width, t = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], c = n.match(t);
    if (!c)
      return null;
    var a = c[0], s = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? M1(s, function(u) {
      return u.test(a);
    }) : B1(s, function(u) {
      return u.test(a);
    }), m;
    m = e.valueCallback ? e.valueCallback(l) : l, m = i.valueCallback ? i.valueCallback(m) : m;
    var h = n.slice(a.length);
    return {
      value: m,
      rest: h
    };
  };
}
function B1(e, n) {
  for (var i in e)
    if (e.hasOwnProperty(i) && n(e[i]))
      return i;
}
function M1(e, n) {
  for (var i = 0; i < e.length; i++)
    if (n(e[i]))
      return i;
}
function j1(e) {
  return function(n) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.match(e.matchPattern);
    if (!o) return null;
    var t = o[0], c = n.match(e.parsePattern);
    if (!c) return null;
    var a = e.valueCallback ? e.valueCallback(c[0]) : c[0];
    a = i.valueCallback ? i.valueCallback(a) : a;
    var s = n.slice(t.length);
    return {
      value: a,
      rest: s
    };
  };
}
var z1 = /^(\d+)(th|st|nd|rd)?/i, q1 = /\d+/i, I1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, S1 = {
  any: [/^b/i, /^(a|c)/i]
}, H1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, T1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, N1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, V1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, R1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, L1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, O1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, U1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, W1 = {
  ordinalNumber: j1({
    matchPattern: z1,
    parsePattern: q1,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: oo({
    matchPatterns: I1,
    defaultMatchWidth: "wide",
    parsePatterns: S1,
    defaultParseWidth: "any"
  }),
  quarter: oo({
    matchPatterns: H1,
    defaultMatchWidth: "wide",
    parsePatterns: T1,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: oo({
    matchPatterns: N1,
    defaultMatchWidth: "wide",
    parsePatterns: V1,
    defaultParseWidth: "any"
  }),
  day: oo({
    matchPatterns: R1,
    defaultMatchWidth: "wide",
    parsePatterns: L1,
    defaultParseWidth: "any"
  }),
  dayPeriod: oo({
    matchPatterns: O1,
    defaultMatchWidth: "any",
    parsePatterns: U1,
    defaultParseWidth: "any"
  })
}, G1 = {
  code: "en-US",
  formatDistance: d1,
  formatLong: f1,
  formatRelative: A1,
  localize: F1,
  match: W1,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function gm(e, n) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var i in n)
    Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
  return e;
}
function J1(e) {
  return gm({}, e);
}
var Jr = 1e3 * 60, mt = 60 * 24, Kr = mt * 30, Xr = mt * 365;
function K1(e, n, i) {
  var o, t, c;
  la(2, arguments);
  var a = p1(), s = (o = (t = i == null ? void 0 : i.locale) !== null && t !== void 0 ? t : a.locale) !== null && o !== void 0 ? o : G1;
  if (!s.formatDistance)
    throw new RangeError("locale must contain localize.formatDistance property");
  var l = u1(e, n);
  if (isNaN(l))
    throw new RangeError("Invalid time value");
  var m = gm(J1(i), {
    addSuffix: !!(i != null && i.addSuffix),
    comparison: l
  }), h, u;
  l > 0 ? (h = Ci(n), u = Ci(e)) : (h = Ci(e), u = Ci(n));
  var D = String((c = i == null ? void 0 : i.roundingMethod) !== null && c !== void 0 ? c : "round"), b;
  if (D === "floor")
    b = Math.floor;
  else if (D === "ceil")
    b = Math.ceil;
  else if (D === "round")
    b = Math.round;
  else
    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
  var C = u.getTime() - h.getTime(), k = C / Jr, q = Gr(u) - Gr(h), E = (C - q) / Jr, x = i == null ? void 0 : i.unit, g;
  if (x ? g = String(x) : k < 1 ? g = "second" : k < 60 ? g = "minute" : k < mt ? g = "hour" : E < Kr ? g = "day" : E < Xr ? g = "month" : g = "year", g === "second") {
    var M = b(C / 1e3);
    return s.formatDistance("xSeconds", M, m);
  } else if (g === "minute") {
    var H = b(k);
    return s.formatDistance("xMinutes", H, m);
  } else if (g === "hour") {
    var P = b(k / 60);
    return s.formatDistance("xHours", P, m);
  } else if (g === "day") {
    var S = b(E / mt);
    return s.formatDistance("xDays", S, m);
  } else if (g === "month") {
    var p = b(E / Kr);
    return p === 12 && x !== "month" ? s.formatDistance("xYears", 1, m) : s.formatDistance("xMonths", p, m);
  } else if (g === "year") {
    var d = b(E / Xr);
    return s.formatDistance("xYears", d, m);
  }
  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}
const X1 = ({
  index: e,
  txHistoryItem: n,
  showDetails: i,
  onClickRow: o
}) => {
  const t = ke(), { data: c } = rm({
    txsRequired: n == null ? void 0 : n.route.txsRequired,
    txs: n.transactionDetails.map((S) => ({
      chainID: S.chainID,
      txHash: S.txHash
    }))
  });
  sm({
    statusData: c,
    historyIndex: e
  });
  const a = Z(bx), {
    route: {
      amountIn: s,
      amountOut: l,
      sourceAssetDenom: m,
      sourceAssetChainID: h,
      destAssetDenom: u,
      destAssetChainID: D
    },
    timestamp: b,
    status: C,
    transactionDetails: k
  } = n, q = en({
    assetDenom: m,
    chainId: h,
    tokenAmount: s
  }), E = en({
    assetDenom: u,
    chainId: D,
    tokenAmount: l
  }), x = {
    amount: q.amount,
    asset: q.asset,
    assetImage: q.assetImage ?? ""
  }, g = {
    amount: E.amount,
    asset: E.asset,
    assetImage: E.assetImage ?? ""
  }, M = K(() => {
    switch (C) {
      case "unconfirmed":
      case "pending":
        return /* @__PURE__ */ r.jsx(
          yt,
          {
            width: 10,
            height: 10,
            backgroundColor: t.primary.text.normal,
            status: "pending"
          }
        );
      case "completed":
        return /* @__PURE__ */ r.jsx(Q1, {});
      case "failed":
        return /* @__PURE__ */ r.jsx(a1, { color: t.error.text });
    }
  }, [C, t.error.text, t.primary.text.normal]), H = K(() => new Date(b).toLocaleString(), [b]), P = K(() => C === "pending" ? "In Progress" : K1(new Date(b), /* @__PURE__ */ new Date(), { addSuffix: !0 }).replace("minutes", "mins").replace("minute", "min").replace("hours", "hrs").replace("hour", "hr").replace("seconds", "secs").replace("second", "sec"), [C, b]);
  return /* @__PURE__ */ r.jsxs(Z1, { showDetails: i, children: [
    /* @__PURE__ */ r.jsxs(
      Y1,
      {
        align: "center",
        justify: "space-between",
        onClick: o,
        children: [
          /* @__PURE__ */ r.jsxs(U, { gap: 5, align: "center", children: [
            /* @__PURE__ */ r.jsx(Zr, { ...x }),
            /* @__PURE__ */ r.jsx(Dm, { color: t.primary.text.lowContrast }),
            /* @__PURE__ */ r.jsx(Zr, { ...g }),
            /* @__PURE__ */ r.jsxs(eg, { normalTextColor: !0, title: E.chainName, children: [
              "on ",
              E.chainName
            ] })
          ] }),
          /* @__PURE__ */ r.jsxs(U, { align: "center", gap: 10, children: [
            /* @__PURE__ */ r.jsx(G, { children: P }),
            M
          ] })
        ]
      }
    ),
    i && /* @__PURE__ */ r.jsx(
      l1,
      {
        status: C,
        sourceChainName: q.chainName ?? "--",
        destinationChainName: E.chainName ?? "--",
        absoluteTimeString: H,
        transactionDetails: k,
        onClickDelete: () => a(e)
      }
    )
  ] });
}, Zr = ({
  amount: e,
  asset: n,
  assetImage: i
}) => /* @__PURE__ */ r.jsxs(r.Fragment, { children: [
  /* @__PURE__ */ r.jsx("img", { height: 20, width: 20, src: i }),
  /* @__PURE__ */ r.jsx(_1, { normalTextColor: !0, title: e, children: e }),
  /* @__PURE__ */ r.jsx($1, { normalTextColor: !0, children: (n == null ? void 0 : n.recommendedSymbol) ?? (n == null ? void 0 : n.symbol) })
] }), Z1 = V(re)`
  background-color: ${({ theme: e, showDetails: n }) => n && e.secondary.background.normal};
  &:hover {
    background-color: ${({ theme: e }) => e.secondary.background.normal};
  }
  border-radius: 6px;
`, Y1 = V(U)`
  padding: 0 10px;
  height: 40px;
  &:hover {
    cursor: pointer;
  }
`, Q1 = V.div`
  width: 10px;
  height: 10px;
  background-color: ${({ theme: e }) => e.success.text};
  border-radius: 50%;
`, _1 = V(G)`
  max-width: 60px;
  text-overflow: ellipsis;
  overflow: hidden;
`, $1 = V(G)`
  max-width: 40px;
  text-overflow: ellipsis;
  overflow: hidden;
`, eg = V(G)`
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 40px;
  white-space: nowrap;
`, ng = () => {
  var a;
  const e = ke(), n = Z(Tn), [i, o] = be(void 0), t = X(Xn), c = K(
    () => t.sort((s, l) => l.timestamp - s.timestamp),
    [t]
  );
  return /* @__PURE__ */ r.jsxs(re, { gap: 5, children: [
    /* @__PURE__ */ r.jsx(
      yn,
      {
        leftButton: {
          label: "Back",
          icon: Q.thinArrow,
          onClick: () => n(Ue.SwapPage)
        }
      }
    ),
    /* @__PURE__ */ r.jsx(ig, { gap: 5, justify: "center", children: /* @__PURE__ */ r.jsx(
      na,
      {
        listItems: c,
        height: 262,
        empty: {
          details: "No transactions yet",
          icon: /* @__PURE__ */ r.jsx(
            Cl,
            {
              width: 30,
              height: 30,
              color: (a = e == null ? void 0 : e.primary) == null ? void 0 : a.text.lowContrast
            }
          )
        },
        itemHeight: 1,
        renderItem: (s, l) => /* @__PURE__ */ r.jsx(
          X1,
          {
            index: l,
            txHistoryItem: s,
            showDetails: l === i,
            onClickRow: () => o(
              (m) => m === l ? void 0 : l
            )
          }
        ),
        itemKey: (s) => s.transactionDetails[0].txHash
      },
      t.length
    ) }),
    /* @__PURE__ */ r.jsx(ea, {})
  ] });
}, ig = V(re)`
  position: relative;
  padding: 20px;
  width: 480px;
  min-height: 302px;
  border-radius: 25px;
  background-color: ${({ theme: e }) => e.primary.background.normal};
`, og = () => {
  const [e] = ue(Tn), [n, i] = ue(_e);
  if (n)
    return /* @__PURE__ */ r.jsx(ex, {});
  switch (e) {
    case Ue.SwapPage:
      return /* @__PURE__ */ r.jsx(
        Ro,
        {
          fallback: null,
          onError: (o) => i({ errorType: Le.Unexpected, error: o }),
          children: /* @__PURE__ */ r.jsx(c1, {})
        }
      );
    case Ue.SwapExecutionPage:
      return /* @__PURE__ */ r.jsx(
        Ro,
        {
          fallback: null,
          onError: (o) => i({ errorType: Le.Unexpected, error: o }),
          children: /* @__PURE__ */ r.jsx(l2, {})
        }
      );
    case Ue.TransactionHistoryPage:
      return /* @__PURE__ */ r.jsx(
        Ro,
        {
          fallback: null,
          onError: (o) => i({ errorType: Le.Unexpected, error: o }),
          children: /* @__PURE__ */ r.jsx(ng, {})
        }
      );
  }
}, tg = (e) => {
  const n = Z(qe), i = Z(Dn), o = Z(vo), t = Z(wt), [{ data: c }] = ue(Hn), a = ze(
    (s, l) => {
      if (!(!s || !l) && c)
        return c.find((m) => m.denom === s && m.chainID === l);
    },
    [c]
  );
  $t(() => {
    if (e && e && c) {
      const {
        srcAssetDenom: s,
        srcChainId: l,
        destAssetDenom: m,
        destChainId: h,
        amountIn: u,
        amountOut: D
      } = e, b = a(s, l), C = a(m, h);
      i({
        ...C,
        amount: D == null ? void 0 : D.toString()
      }), n({
        ...b,
        amount: u == null ? void 0 : u.toString()
      }), u ? o(u == null ? void 0 : u.toString()) : D && t(D == null ? void 0 : D.toString());
    }
  }, [c, e, a, i, t, n, o]);
}, Mg = (e) => /* @__PURE__ */ r.jsx($r.Provider, { children: /* @__PURE__ */ r.jsx(fm, { ...e }) }), fm = (e) => {
  var m;
  tg(e.defaultRoute);
  const n = Z(ml), i = Z(pl), o = Z(vi), t = Z(Ml), c = Z($c), a = Z(bo), s = K(() => {
    const { theme: h, apiUrl: u, chainIdsToAffiliates: D, ...b } = e;
    return {
      ...ll,
      ...b,
      apiURL: u,
      chainIDsToAffiliates: D
    };
  }, [e]), l = K(() => {
    let h;
    return typeof e.theme == "string" ? h = e.theme === "light" ? zu : Qo : h = { ...Qo, ...e.theme }, e.brandColor && (h.brandColor = e.brandColor), h;
  }, [e.brandColor, e.theme]);
  return $t(() => {
    n(s), i(l);
  }, [n, s, i, l]), $t(() => {
    if (e.settings && o({
      ...at,
      ...e.settings
    }), e.routeConfig) {
      const h = e.routeConfig;
      h.swapVenues && (h.swapVenues = h.swapVenues.map((u) => ({
        name: u.name,
        chainID: u.chainId
      }))), t(h);
    }
    e.filter && c(e.filter), e.onlyTestnet && a(e.onlyTestnet);
  }, [
    e.filter,
    e.onlyTestnet,
    e.routeConfig,
    e.settings,
    (m = e.settings) == null ? void 0 : m.slippage,
    c,
    a,
    t,
    o
  ]), /* @__PURE__ */ r.jsx(ul, { theme: l, children: /* @__PURE__ */ r.jsx(cg, { children: /* @__PURE__ */ r.jsx(og, {}) }) });
}, jg = ({
  button: e = /* @__PURE__ */ r.jsx("button", { children: "show widget" }),
  ...n
}) => {
  const i = Je(
    Ui(() => /* @__PURE__ */ r.jsx(fm, { ...n }))
  ), o = A0(gl), c = Wm(e, { onClick: () => {
    o(), i.show({
      stackedModal: !1
    });
  } });
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: c });
}, cg = V.div`
  width: 480px;
  position: relative;
`;
export {
  jg as ShowWidget,
  Mg as Widget,
  Qo as defaultTheme,
  zu as lightTheme
};
